/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/mlearning/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(98);
	module.exports = __webpack_require__(105);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(10);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 4 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMProperty = __webpack_require__(19);
	var ReactDOMComponentFlags = __webpack_require__(72);
	
	var invariant = __webpack_require__(1);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(21);


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(143)();
	}


/***/ },
/* 8 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(221);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(222);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(223);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(92);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(56);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(224);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(225);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(57);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(226);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(70);
	var PooledClass = __webpack_require__(15);
	var ReactFeatureFlags = __webpack_require__(75);
	var ReactReconciler = __webpack_require__(20);
	var Transaction = __webpack_require__(34);
	
	var invariant = __webpack_require__(1);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(15);
	
	var emptyFunction = __webpack_require__(10);
	var warning = __webpack_require__(2);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 15 */
[244, 3],
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(41);
	var setInnerHTML = __webpack_require__(36);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(49);
	var setTextContent = __webpack_require__(88);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(182);
	var ReactInstrumentation = __webpack_require__(11);
	
	var warning = __webpack_require__(2);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactBaseClasses = __webpack_require__(93);
	var ReactChildren = __webpack_require__(229);
	var ReactDOMFactories = __webpack_require__(230);
	var ReactElement = __webpack_require__(22);
	var ReactPropTypes = __webpack_require__(231);
	var ReactVersion = __webpack_require__(232);
	
	var createReactClass = __webpack_require__(233);
	var onlyChild = __webpack_require__(237);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(14);
	
	var warning = __webpack_require__(2);
	var canDefineProperty = __webpack_require__(97);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(95);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org Version 4.10.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var version = "4.10.0";
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var sequence = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse = stop < start,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  if (reverse) n = start, start = stop, stop = n;
	
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = sequence(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var threshold = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (threshold(values, 0.75) - threshold(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return threshold(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	var slice$1 = Array.prototype.slice;
	
	var identity$1 = function(x) {
	  return x;
	};
	
	var top = 1;
	var right = 2;
	var bottom = 3;
	var left = 4;
	var epsilon = 1e-6;
	
	function translateX(x) {
	  return "translate(" + (x + 0.5) + ",0)";
	}
	
	function translateY(y) {
	  return "translate(0," + (y + 0.5) + ")";
	}
	
	function number$1(scale) {
	  return function(d) {
	    return +scale(d);
	  };
	}
	
	function center(scale) {
	  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
	  if (scale.round()) offset = Math.round(offset);
	  return function(d) {
	    return +scale(d) + offset;
	  };
	}
	
	function entering() {
	  return !this.__axis;
	}
	
	function axis(orient, scale) {
	  var tickArguments = [],
	      tickValues = null,
	      tickFormat = null,
	      tickSizeInner = 6,
	      tickSizeOuter = 6,
	      tickPadding = 3,
	      k = orient === top || orient === left ? -1 : 1,
	      x = orient === left || orient === right ? "x" : "y",
	      transform = orient === top || orient === bottom ? translateX : translateY;
	
	  function axis(context) {
	    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$1) : tickFormat,
	        spacing = Math.max(tickSizeInner, 0) + tickPadding,
	        range = scale.range(),
	        range0 = +range[0] + 0.5,
	        range1 = +range[range.length - 1] + 0.5,
	        position = (scale.bandwidth ? center : number$1)(scale.copy()),
	        selection = context.selection ? context.selection() : context,
	        path = selection.selectAll(".domain").data([null]),
	        tick = selection.selectAll(".tick").data(values, scale).order(),
	        tickExit = tick.exit(),
	        tickEnter = tick.enter().append("g").attr("class", "tick"),
	        line = tick.select("line"),
	        text = tick.select("text");
	
	    path = path.merge(path.enter().insert("path", ".tick")
	        .attr("class", "domain")
	        .attr("stroke", "#000"));
	
	    tick = tick.merge(tickEnter);
	
	    line = line.merge(tickEnter.append("line")
	        .attr("stroke", "#000")
	        .attr(x + "2", k * tickSizeInner));
	
	    text = text.merge(tickEnter.append("text")
	        .attr("fill", "#000")
	        .attr(x, k * spacing)
	        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	    if (context !== selection) {
	      path = path.transition(context);
	      tick = tick.transition(context);
	      line = line.transition(context);
	      text = text.transition(context);
	
	      tickExit = tickExit.transition(context)
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });
	
	      tickEnter
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
	    }
	
	    tickExit.remove();
	
	    path
	        .attr("d", orient === left || orient == right
	            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
	            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	    tick
	        .attr("opacity", 1)
	        .attr("transform", function(d) { return transform(position(d)); });
	
	    line
	        .attr(x + "2", k * tickSizeInner);
	
	    text
	        .attr(x, k * spacing)
	        .text(format);
	
	    selection.filter(entering)
	        .attr("fill", "none")
	        .attr("font-size", 10)
	        .attr("font-family", "sans-serif")
	        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	    selection
	        .each(function() { this.__axis = position; });
	  }
	
	  axis.scale = function(_) {
	    return arguments.length ? (scale = _, axis) : scale;
	  };
	
	  axis.ticks = function() {
	    return tickArguments = slice$1.call(arguments), axis;
	  };
	
	  axis.tickArguments = function(_) {
	    return arguments.length ? (tickArguments = _ == null ? [] : slice$1.call(_), axis) : tickArguments.slice();
	  };
	
	  axis.tickValues = function(_) {
	    return arguments.length ? (tickValues = _ == null ? null : slice$1.call(_), axis) : tickValues && tickValues.slice();
	  };
	
	  axis.tickFormat = function(_) {
	    return arguments.length ? (tickFormat = _, axis) : tickFormat;
	  };
	
	  axis.tickSize = function(_) {
	    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeInner = function(_) {
	    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeOuter = function(_) {
	    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	  };
	
	  axis.tickPadding = function(_) {
	    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	  };
	
	  return axis;
	}
	
	function axisTop(scale) {
	  return axis(top, scale);
	}
	
	function axisRight(scale) {
	  return axis(right, scale);
	}
	
	function axisBottom(scale) {
	  return axis(bottom, scale);
	}
	
	function axisLeft(scale) {
	  return axis(left, scale);
	}
	
	var noop = {value: function() {}};
	
	function dispatch() {
	  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	    _[t] = [];
	  }
	  return new Dispatch(_);
	}
	
	function Dispatch(_) {
	  this._ = _;
	}
	
	function parseTypenames(typenames, types) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	    return {type: t, name: name};
	  });
	}
	
	Dispatch.prototype = dispatch.prototype = {
	  constructor: Dispatch,
	  on: function(typename, callback) {
	    var _ = this._,
	        T = parseTypenames(typename + "", _),
	        t,
	        i = -1,
	        n = T.length;
	
	    // If no callback was specified, return the callback of the given type and name.
	    if (arguments.length < 2) {
	      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	      return;
	    }
	
	    // If a type was specified, set the callback for the given type and name.
	    // Otherwise, if a null callback was specified, remove callbacks of the given name.
	    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    while (++i < n) {
	      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
	      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
	    }
	
	    return this;
	  },
	  copy: function() {
	    var copy = {}, _ = this._;
	    for (var t in _) copy[t] = _[t].slice();
	    return new Dispatch(copy);
	  },
	  call: function(type, that) {
	    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  },
	  apply: function(type, that, args) {
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  }
	};
	
	function get(type, name) {
	  for (var i = 0, n = type.length, c; i < n; ++i) {
	    if ((c = type[i]).name === name) {
	      return c.value;
	    }
	  }
	}
	
	function set(type, name, callback) {
	  for (var i = 0, n = type.length; i < n; ++i) {
	    if (type[i].name === name) {
	      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	      break;
	    }
	  }
	  if (callback != null) type.push({name: name, value: callback});
	  return type;
	}
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	var namespace = function(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	};
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	var creator = function(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	};
	
	var nextId = 0;
	
	function local$1() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local$1.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	var matcher = function(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector
	        || element.msMatchesSelector
	        || element.mozMatchesSelector
	        || element.oMatchesSelector;
	    matcher = function(selector) {
	      return function() {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	var matcher$1 = matcher;
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element$1 = document.documentElement;
	  if (!("onmouseenter" in element$1)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames$1(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	var selection_on = function(typename, value, capture) {
	  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	};
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	var sourceEvent = function() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	};
	
	var point = function(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	};
	
	var mouse = function(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point(node, event);
	};
	
	function none() {}
	
	var selector = function(selector) {
	  return selector == null ? none : function() {
	    return this.querySelector(selector);
	  };
	};
	
	var selection_select = function(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	function empty$1() {
	  return [];
	}
	
	var selectorAll = function(selector) {
	  return selector == null ? empty$1 : function() {
	    return this.querySelectorAll(selector);
	  };
	};
	
	var selection_selectAll = function(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	};
	
	var selection_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	var sparse = function(update) {
	  return new Array(update.length);
	};
	
	var selection_enter = function() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	};
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	var constant$1 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	var selection_data = function(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant$1(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	};
	
	var selection_exit = function() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	};
	
	var selection_merge = function(selection$$1) {
	
	  for (var groups0 = this._groups, groups1 = selection$$1._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	};
	
	var selection_order = function() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	};
	
	var selection_sort = function(compare) {
	  if (!compare) compare = ascending$1;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	};
	
	function ascending$1(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	var selection_call = function() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	};
	
	var selection_nodes = function() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	};
	
	var selection_node = function() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	};
	
	var selection_size = function() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	};
	
	var selection_empty = function() {
	  return !this.node();
	};
	
	var selection_each = function(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	};
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	var selection_attr = function(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	};
	
	var defaultView = function(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	};
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	var selection_style = function(name, value, priority) {
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : styleValue(this.node(), name);
	};
	
	function styleValue(node, name) {
	  return node.style.getPropertyValue(name)
	      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
	}
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	var selection_property = function(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	};
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	var selection_classed = function(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	};
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	var selection_text = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	};
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	var selection_html = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	};
	
	function raise() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	var selection_raise = function() {
	  return this.each(raise);
	};
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	var selection_lower = function() {
	  return this.each(lower);
	};
	
	var selection_append = function(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	};
	
	function constantNull() {
	  return null;
	}
	
	var selection_insert = function(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	};
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	var selection_remove = function() {
	  return this.each(remove);
	};
	
	var selection_datum = function(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	};
	
	function dispatchEvent(node, type, params) {
	  var window = defaultView(node),
	      event = window.CustomEvent;
	
	  if (typeof event === "function") {
	    event = new event(type, params);
	  } else {
	    event = window.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	var selection_dispatch = function(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	};
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	var select = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	};
	
	var selectAll = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	};
	
	var touch = function(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point(node, touch);
	    }
	  }
	
	  return null;
	};
	
	var touches = function(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point(node, touches[i]);
	  }
	
	  return points;
	};
	
	function nopropagation() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	};
	
	var dragDisable = function(view) {
	  var root = view.document.documentElement,
	      selection$$1 = select(view).on("dragstart.drag", noevent, true);
	  if ("onselectstart" in root) {
	    selection$$1.on("selectstart.drag", noevent, true);
	  } else {
	    root.__noselect = root.style.MozUserSelect;
	    root.style.MozUserSelect = "none";
	  }
	};
	
	function yesdrag(view, noclick) {
	  var root = view.document.documentElement,
	      selection$$1 = select(view).on("dragstart.drag", null);
	  if (noclick) {
	    selection$$1.on("click.drag", noevent, true);
	    setTimeout(function() { selection$$1.on("click.drag", null); }, 0);
	  }
	  if ("onselectstart" in root) {
	    selection$$1.on("selectstart.drag", null);
	  } else {
	    root.style.MozUserSelect = root.__noselect;
	    delete root.__noselect;
	  }
	}
	
	var constant$2 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
	  this.target = target;
	  this.type = type;
	  this.subject = subject;
	  this.identifier = id;
	  this.active = active;
	  this.x = x;
	  this.y = y;
	  this.dx = dx;
	  this.dy = dy;
	  this._ = dispatch;
	}
	
	DragEvent.prototype.on = function() {
	  var value = this._.on.apply(this._, arguments);
	  return value === this._ ? this : value;
	};
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter$1() {
	  return !exports.event.button;
	}
	
	function defaultContainer() {
	  return this.parentNode;
	}
	
	function defaultSubject(d) {
	  return d == null ? {x: exports.event.x, y: exports.event.y} : d;
	}
	
	function touchable() {
	  return "ontouchstart" in this;
	}
	
	var drag = function() {
	  var filter = defaultFilter$1,
	      container = defaultContainer,
	      subject = defaultSubject,
	      gestures = {},
	      listeners = dispatch("start", "drag", "end"),
	      active = 0,
	      mousedownx,
	      mousedowny,
	      mousemoving,
	      touchending,
	      clickDistance2 = 0;
	
	  function drag(selection) {
	    selection
	        .on("mousedown.drag", mousedowned)
	      .filter(touchable)
	        .on("touchstart.drag", touchstarted)
	        .on("touchmove.drag", touchmoved)
	        .on("touchend.drag touchcancel.drag", touchended)
	        .style("touch-action", "none")
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var gesture = beforestart("mouse", container.apply(this, arguments), mouse, this, arguments);
	    if (!gesture) return;
	    select(exports.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
	    dragDisable(exports.event.view);
	    nopropagation();
	    mousemoving = false;
	    mousedownx = exports.event.clientX;
	    mousedowny = exports.event.clientY;
	    gesture("start");
	  }
	
	  function mousemoved() {
	    noevent();
	    if (!mousemoving) {
	      var dx = exports.event.clientX - mousedownx, dy = exports.event.clientY - mousedowny;
	      mousemoving = dx * dx + dy * dy > clickDistance2;
	    }
	    gestures.mouse("drag");
	  }
	
	  function mouseupped() {
	    select(exports.event.view).on("mousemove.drag mouseup.drag", null);
	    yesdrag(exports.event.view, mousemoving);
	    noevent();
	    gestures.mouse("end");
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var touches$$1 = exports.event.changedTouches,
	        c = container.apply(this, arguments),
	        n = touches$$1.length, i, gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = beforestart(touches$$1[i].identifier, c, touch, this, arguments)) {
	        nopropagation();
	        gesture("start");
	      }
	    }
	  }
	
	  function touchmoved() {
	    var touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches$$1[i].identifier]) {
	        noevent();
	        gesture("drag");
	      }
	    }
	  }
	
	  function touchended() {
	    var touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, gesture;
	
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches$$1[i].identifier]) {
	        nopropagation();
	        gesture("end");
	      }
	    }
	  }
	
	  function beforestart(id, container, point, that, args) {
	    var p = point(container, id), s, dx, dy,
	        sublisteners = listeners.copy();
	
	    if (!customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
	      if ((exports.event.subject = s = subject.apply(that, args)) == null) return false;
	      dx = s.x - p[0] || 0;
	      dy = s.y - p[1] || 0;
	      return true;
	    })) return;
	
	    return function gesture(type) {
	      var p0 = p, n;
	      switch (type) {
	        case "start": gestures[id] = gesture, n = active++; break;
	        case "end": delete gestures[id], --active; // nobreak
	        case "drag": p = point(container, id), n = active; break;
	      }
	      customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
	    };
	  }
	
	  drag.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$2(!!_), drag) : filter;
	  };
	
	  drag.container = function(_) {
	    return arguments.length ? (container = typeof _ === "function" ? _ : constant$2(_), drag) : container;
	  };
	
	  drag.subject = function(_) {
	    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$2(_), drag) : subject;
	  };
	
	  drag.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? drag : value;
	  };
	
	  drag.clickDistance = function(_) {
	    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
	  };
	
	  return drag;
	};
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant$3 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$3(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant$3(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant$3(isNaN(a) ? b : a);
	}
	
	var interpolateRgb = (function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = rgb(start)).r, (end = rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array$1 = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = interpolateValue(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var reinterpolate = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = interpolateValue(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var interpolateString = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: reinterpolate(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var interpolateValue = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant$3(b)
	      : (t === "number" ? reinterpolate
	      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
	      : b instanceof color ? interpolateRgb
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array$1
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : reinterpolate)(a, b);
	};
	
	var interpolateRound = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity$2 = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity$2;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity$2;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: reinterpolate(xa, xb)}, {i: i - 2, x: reinterpolate(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: reinterpolate(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: reinterpolate(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: reinterpolate(xa, xb)}, {i: i - 2, x: reinterpolate(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var interpolateZoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = hsl(start)).h, (end = hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = hcl(start)).h, (end = hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = cubehelix(start)).h, (end = cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	var frame = 0;
	var timeout = 0;
	var interval = 0;
	var pokeDelay = 1000;
	var taskHead;
	var taskTail;
	var clockLast = 0;
	var clockNow = 0;
	var clockSkew = 0;
	var clock = typeof performance === "object" && performance.now ? performance : Date;
	var setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow;
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, delay);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clockNow, interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	var timeout$1 = function(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	};
	
	var interval$1 = function(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	};
	
	var emptyOn = dispatch("start", "end", "interrupt");
	var emptyTween = [];
	
	var CREATED = 0;
	var SCHEDULED = 1;
	var STARTING = 2;
	var STARTED = 3;
	var RUNNING = 4;
	var ENDING = 5;
	var ENDED = 6;
	
	var schedule = function(node, name, id, index, group, timing) {
	  var schedules = node.__transition;
	  if (!schedules) node.__transition = {};
	  else if (id in schedules) return;
	  create(node, id, {
	    name: name,
	    index: index, // For context during callback.
	    group: group, // For context during callback.
	    on: emptyOn,
	    tween: emptyTween,
	    time: timing.time,
	    delay: timing.delay,
	    duration: timing.duration,
	    ease: timing.ease,
	    timer: null,
	    state: CREATED
	  });
	};
	
	function init(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
	  return schedule;
	}
	
	function set$1(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
	  return schedule;
	}
	
	function get$1(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
	  return schedule;
	}
	
	function create(node, id, self) {
	  var schedules = node.__transition,
	      tween;
	
	  // Initialize the self timer when the transition is created.
	  // Note the actual delay is not known until the first callback!
	  schedules[id] = self;
	  self.timer = timer(schedule, 0, self.time);
	
	  function schedule(elapsed) {
	    self.state = SCHEDULED;
	    self.timer.restart(start, self.delay, self.time);
	
	    // If the elapsed delay is less than our first sleep, start immediately.
	    if (self.delay <= elapsed) start(elapsed - self.delay);
	  }
	
	  function start(elapsed) {
	    var i, j, n, o;
	
	    // If the state is not SCHEDULED, then we previously errored on start.
	    if (self.state !== SCHEDULED) return stop();
	
	    for (i in schedules) {
	      o = schedules[i];
	      if (o.name !== self.name) continue;
	
	      // While this element already has a starting transition during this frame,
	      // defer starting an interrupting transition until that transition has a
	      // chance to tick (and possibly end); see d3/d3-transition#54!
	      if (o.state === STARTED) return timeout$1(start);
	
	      // Interrupt the active transition, if any.
	      // Dispatch the interrupt event.
	      if (o.state === RUNNING) {
	        o.state = ENDED;
	        o.timer.stop();
	        o.on.call("interrupt", node, node.__data__, o.index, o.group);
	        delete schedules[i];
	      }
	
	      // Cancel any pre-empted transitions. No interrupt event is dispatched
	      // because the cancelled transitions never started. Note that this also
	      // removes this transition from the pending list!
	      else if (+i < id) {
	        o.state = ENDED;
	        o.timer.stop();
	        delete schedules[i];
	      }
	    }
	
	    // Defer the first tick to end of the current frame; see d3/d3#1576.
	    // Note the transition may be canceled after start and before the first tick!
	    // Note this must be scheduled before the start event; see d3/d3-transition#16!
	    // Assuming this is successful, subsequent callbacks go straight to tick.
	    timeout$1(function() {
	      if (self.state === STARTED) {
	        self.state = RUNNING;
	        self.timer.restart(tick, self.delay, self.time);
	        tick(elapsed);
	      }
	    });
	
	    // Dispatch the start event.
	    // Note this must be done before the tween are initialized.
	    self.state = STARTING;
	    self.on.call("start", node, node.__data__, self.index, self.group);
	    if (self.state !== STARTING) return; // interrupted
	    self.state = STARTED;
	
	    // Initialize the tween, deleting null tween.
	    tween = new Array(n = self.tween.length);
	    for (i = 0, j = -1; i < n; ++i) {
	      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
	        tween[++j] = o;
	      }
	    }
	    tween.length = j + 1;
	  }
	
	  function tick(elapsed) {
	    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
	        i = -1,
	        n = tween.length;
	
	    while (++i < n) {
	      tween[i].call(null, t);
	    }
	
	    // Dispatch the end event.
	    if (self.state === ENDING) {
	      self.on.call("end", node, node.__data__, self.index, self.group);
	      stop();
	    }
	  }
	
	  function stop() {
	    self.state = ENDED;
	    self.timer.stop();
	    delete schedules[id];
	    for (var i in schedules) return; // eslint-disable-line no-unused-vars
	    delete node.__transition;
	  }
	}
	
	var interrupt = function(node, name) {
	  var schedules = node.__transition,
	      schedule$$1,
	      active,
	      empty = true,
	      i;
	
	  if (!schedules) return;
	
	  name = name == null ? null : name + "";
	
	  for (i in schedules) {
	    if ((schedule$$1 = schedules[i]).name !== name) { empty = false; continue; }
	    active = schedule$$1.state > STARTING && schedule$$1.state < ENDING;
	    schedule$$1.state = ENDED;
	    schedule$$1.timer.stop();
	    if (active) schedule$$1.on.call("interrupt", node, node.__data__, schedule$$1.index, schedule$$1.group);
	    delete schedules[i];
	  }
	
	  if (empty) delete node.__transition;
	};
	
	var selection_interrupt = function(name) {
	  return this.each(function() {
	    interrupt(this, name);
	  });
	};
	
	function tweenRemove(id, name) {
	  var tween0, tween1;
	  return function() {
	    var schedule$$1 = set$1(this, id),
	        tween = schedule$$1.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = tween0 = tween;
	      for (var i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1 = tween1.slice();
	          tween1.splice(i, 1);
	          break;
	        }
	      }
	    }
	
	    schedule$$1.tween = tween1;
	  };
	}
	
	function tweenFunction(id, name, value) {
	  var tween0, tween1;
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    var schedule$$1 = set$1(this, id),
	        tween = schedule$$1.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = (tween0 = tween).slice();
	      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1[i] = t;
	          break;
	        }
	      }
	      if (i === n) tween1.push(t);
	    }
	
	    schedule$$1.tween = tween1;
	  };
	}
	
	var transition_tween = function(name, value) {
	  var id = this._id;
	
	  name += "";
	
	  if (arguments.length < 2) {
	    var tween = get$1(this.node(), id).tween;
	    for (var i = 0, n = tween.length, t; i < n; ++i) {
	      if ((t = tween[i]).name === name) {
	        return t.value;
	      }
	    }
	    return null;
	  }
	
	  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
	};
	
	function tweenValue(transition, name, value) {
	  var id = transition._id;
	
	  transition.each(function() {
	    var schedule$$1 = set$1(this, id);
	    (schedule$$1.value || (schedule$$1.value = {}))[name] = value.apply(this, arguments);
	  });
	
	  return function(node) {
	    return get$1(node, id).value[name];
	  };
	}
	
	var interpolate = function(a, b) {
	  var c;
	  return (typeof b === "number" ? reinterpolate
	      : b instanceof color ? interpolateRgb
	      : (c = color(b)) ? (b = c, interpolateRgb)
	      : interpolateString)(a, b);
	};
	
	function attrRemove$1(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS$1(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant$1(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrConstantNS$1(fullname, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrFunction$1(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttribute(name);
	    value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function attrFunctionNS$1(fullname, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
	    value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_attr = function(name, value) {
	  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate;
	  return this.attrTween(name, typeof value === "function"
	      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue(this, "attr." + name, value))
	      : value == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname)
	      : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value + ""));
	};
	
	function attrTweenNS(fullname, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttributeNS(fullname.space, fullname.local, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	function attrTween(name, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttribute(name, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_attrTween = function(name, value) {
	  var key = "attr." + name;
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  var fullname = namespace(name);
	  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
	};
	
	function delayFunction(id, value) {
	  return function() {
	    init(this, id).delay = +value.apply(this, arguments);
	  };
	}
	
	function delayConstant(id, value) {
	  return value = +value, function() {
	    init(this, id).delay = value;
	  };
	}
	
	var transition_delay = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? delayFunction
	          : delayConstant)(id, value))
	      : get$1(this.node(), id).delay;
	};
	
	function durationFunction(id, value) {
	  return function() {
	    set$1(this, id).duration = +value.apply(this, arguments);
	  };
	}
	
	function durationConstant(id, value) {
	  return value = +value, function() {
	    set$1(this, id).duration = value;
	  };
	}
	
	var transition_duration = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? durationFunction
	          : durationConstant)(id, value))
	      : get$1(this.node(), id).duration;
	};
	
	function easeConstant(id, value) {
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    set$1(this, id).ease = value;
	  };
	}
	
	var transition_ease = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each(easeConstant(id, value))
	      : get$1(this.node(), id).ease;
	};
	
	var transition_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, this._name, this._id);
	};
	
	var transition_merge = function(transition$$1) {
	  if (transition$$1._id !== this._id) throw new Error;
	
	  for (var groups0 = this._groups, groups1 = transition$$1._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Transition(merges, this._parents, this._name, this._id);
	};
	
	function start(name) {
	  return (name + "").trim().split(/^|\s+/).every(function(t) {
	    var i = t.indexOf(".");
	    if (i >= 0) t = t.slice(0, i);
	    return !t || t === "start";
	  });
	}
	
	function onFunction(id, name, listener) {
	  var on0, on1, sit = start(name) ? init : set$1;
	  return function() {
	    var schedule$$1 = sit(this, id),
	        on = schedule$$1.on;
	
	    // If this node shared a dispatch with the previous node,
	    // just assign the updated shared dispatch and we’re done!
	    // Otherwise, copy-on-write.
	    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
	
	    schedule$$1.on = on1;
	  };
	}
	
	var transition_on = function(name, listener) {
	  var id = this._id;
	
	  return arguments.length < 2
	      ? get$1(this.node(), id).on.on(name)
	      : this.each(onFunction(id, name, listener));
	};
	
	function removeFunction(id) {
	  return function() {
	    var parent = this.parentNode;
	    for (var i in this.__transition) if (+i !== id) return;
	    if (parent) parent.removeChild(this);
	  };
	}
	
	var transition_remove = function() {
	  return this.on("end.remove", removeFunction(this._id));
	};
	
	var transition_select = function(select$$1) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select$$1 !== "function") select$$1 = selector(select$$1);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select$$1.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	        schedule(subgroup[i], name, id, i, subgroup, get$1(node, id));
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, name, id);
	};
	
	var transition_selectAll = function(select$$1) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select$$1 !== "function") select$$1 = selectorAll(select$$1);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        for (var children = select$$1.call(node, node.__data__, i, group), child, inherit = get$1(node, id), k = 0, l = children.length; k < l; ++k) {
	          if (child = children[k]) {
	            schedule(child, name, id, k, children, inherit);
	          }
	        }
	        subgroups.push(children);
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, parents, name, id);
	};
	
	var Selection$1 = selection.prototype.constructor;
	
	var transition_selection = function() {
	  return new Selection$1(this._groups, this._parents);
	};
	
	function styleRemove$1(name, interpolate$$1) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0 = styleValue(this, name),
	        value1 = (this.style.removeProperty(name), styleValue(this, name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function styleRemoveEnd(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant$1(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = styleValue(this, name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function styleFunction$1(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0 = styleValue(this, name),
	        value1 = value(this);
	    if (value1 == null) value1 = (this.style.removeProperty(name), styleValue(this, name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_style = function(name, value, priority) {
	  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate;
	  return value == null ? this
	          .styleTween(name, styleRemove$1(name, i))
	          .on("end.style." + name, styleRemoveEnd(name))
	      : this.styleTween(name, typeof value === "function"
	          ? styleFunction$1(name, i, tweenValue(this, "style." + name, value))
	          : styleConstant$1(name, i, value + ""), priority);
	};
	
	function styleTween(name, value, priority) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.style.setProperty(name, i(t), priority);
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_styleTween = function(name, value, priority) {
	  var key = "style." + (name += "");
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
	};
	
	function textConstant$1(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction$1(value) {
	  return function() {
	    var value1 = value(this);
	    this.textContent = value1 == null ? "" : value1;
	  };
	}
	
	var transition_text = function(value) {
	  return this.tween("text", typeof value === "function"
	      ? textFunction$1(tweenValue(this, "text", value))
	      : textConstant$1(value == null ? "" : value + ""));
	};
	
	var transition_transition = function() {
	  var name = this._name,
	      id0 = this._id,
	      id1 = newId();
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        var inherit = get$1(node, id0);
	        schedule(node, name, id1, i, group, {
	          time: inherit.time + inherit.delay + inherit.duration,
	          delay: 0,
	          duration: inherit.duration,
	          ease: inherit.ease
	        });
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id1);
	};
	
	var id = 0;
	
	function Transition(groups, parents, name, id) {
	  this._groups = groups;
	  this._parents = parents;
	  this._name = name;
	  this._id = id;
	}
	
	function transition(name) {
	  return selection().transition(name);
	}
	
	function newId() {
	  return ++id;
	}
	
	var selection_prototype = selection.prototype;
	
	Transition.prototype = transition.prototype = {
	  constructor: Transition,
	  select: transition_select,
	  selectAll: transition_selectAll,
	  filter: transition_filter,
	  merge: transition_merge,
	  selection: transition_selection,
	  transition: transition_transition,
	  call: selection_prototype.call,
	  nodes: selection_prototype.nodes,
	  node: selection_prototype.node,
	  size: selection_prototype.size,
	  empty: selection_prototype.empty,
	  each: selection_prototype.each,
	  on: transition_on,
	  attr: transition_attr,
	  attrTween: transition_attrTween,
	  style: transition_style,
	  styleTween: transition_styleTween,
	  text: transition_text,
	  remove: transition_remove,
	  tween: transition_tween,
	  delay: transition_delay,
	  duration: transition_duration,
	  ease: transition_ease
	};
	
	function linear$1(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI;
	var halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11;
	var b2 = 6 / 11;
	var b3 = 8 / 11;
	var b4 = 3 / 4;
	var b5 = 9 / 11;
	var b6 = 10 / 11;
	var b7 = 15 / 16;
	var b8 = 21 / 22;
	var b9 = 63 / 64;
	var b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI;
	var amplitude = 1;
	var period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	var defaultTiming = {
	  time: null, // Set on use.
	  delay: 0,
	  duration: 250,
	  ease: cubicInOut
	};
	
	function inherit(node, id) {
	  var timing;
	  while (!(timing = node.__transition) || !(timing = timing[id])) {
	    if (!(node = node.parentNode)) {
	      return defaultTiming.time = now(), defaultTiming;
	    }
	  }
	  return timing;
	}
	
	var selection_transition = function(name) {
	  var id,
	      timing;
	
	  if (name instanceof Transition) {
	    id = name._id, name = name._name;
	  } else {
	    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
	  }
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        schedule(node, name, id, i, group, timing || inherit(node, id));
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id);
	};
	
	selection.prototype.interrupt = selection_interrupt;
	selection.prototype.transition = selection_transition;
	
	var root$1 = [null];
	
	var active = function(node, name) {
	  var schedules = node.__transition,
	      schedule$$1,
	      i;
	
	  if (schedules) {
	    name = name == null ? null : name + "";
	    for (i in schedules) {
	      if ((schedule$$1 = schedules[i]).state > SCHEDULED && schedule$$1.name === name) {
	        return new Transition([[node]], root$1, name, +i);
	      }
	    }
	  }
	
	  return null;
	};
	
	var constant$4 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var BrushEvent = function(target, type, selection) {
	  this.target = target;
	  this.type = type;
	  this.selection = selection;
	};
	
	function nopropagation$1() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent$1 = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	};
	
	var MODE_DRAG = {name: "drag"};
	var MODE_SPACE = {name: "space"};
	var MODE_HANDLE = {name: "handle"};
	var MODE_CENTER = {name: "center"};
	
	var X = {
	  name: "x",
	  handles: ["e", "w"].map(type),
	  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
	  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
	};
	
	var Y = {
	  name: "y",
	  handles: ["n", "s"].map(type),
	  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
	  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
	};
	
	var XY = {
	  name: "xy",
	  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
	  input: function(xy) { return xy; },
	  output: function(xy) { return xy; }
	};
	
	var cursors = {
	  overlay: "crosshair",
	  selection: "move",
	  n: "ns-resize",
	  e: "ew-resize",
	  s: "ns-resize",
	  w: "ew-resize",
	  nw: "nwse-resize",
	  ne: "nesw-resize",
	  se: "nwse-resize",
	  sw: "nesw-resize"
	};
	
	var flipX = {
	  e: "w",
	  w: "e",
	  nw: "ne",
	  ne: "nw",
	  se: "sw",
	  sw: "se"
	};
	
	var flipY = {
	  n: "s",
	  s: "n",
	  nw: "sw",
	  ne: "se",
	  se: "ne",
	  sw: "nw"
	};
	
	var signsX = {
	  overlay: +1,
	  selection: +1,
	  n: null,
	  e: +1,
	  s: null,
	  w: -1,
	  nw: -1,
	  ne: +1,
	  se: +1,
	  sw: -1
	};
	
	var signsY = {
	  overlay: +1,
	  selection: +1,
	  n: -1,
	  e: null,
	  s: +1,
	  w: null,
	  nw: -1,
	  ne: -1,
	  se: +1,
	  sw: +1
	};
	
	function type(t) {
	  return {type: t};
	}
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter() {
	  return !exports.event.button;
	}
	
	function defaultExtent() {
	  var svg = this.ownerSVGElement || this;
	  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
	}
	
	// Like d3.local, but with the name “__brush” rather than auto-generated.
	function local$$1(node) {
	  while (!node.__brush) if (!(node = node.parentNode)) return;
	  return node.__brush;
	}
	
	function empty(extent) {
	  return extent[0][0] === extent[1][0]
	      || extent[0][1] === extent[1][1];
	}
	
	function brushSelection(node) {
	  var state = node.__brush;
	  return state ? state.dim.output(state.selection) : null;
	}
	
	function brushX() {
	  return brush$1(X);
	}
	
	function brushY() {
	  return brush$1(Y);
	}
	
	var brush = function() {
	  return brush$1(XY);
	};
	
	function brush$1(dim) {
	  var extent = defaultExtent,
	      filter = defaultFilter,
	      listeners = dispatch(brush, "start", "brush", "end"),
	      handleSize = 6,
	      touchending;
	
	  function brush(group) {
	    var overlay = group
	        .property("__brush", initialize)
	      .selectAll(".overlay")
	      .data([type("overlay")]);
	
	    overlay.enter().append("rect")
	        .attr("class", "overlay")
	        .attr("pointer-events", "all")
	        .attr("cursor", cursors.overlay)
	      .merge(overlay)
	        .each(function() {
	          var extent = local$$1(this).extent;
	          select(this)
	              .attr("x", extent[0][0])
	              .attr("y", extent[0][1])
	              .attr("width", extent[1][0] - extent[0][0])
	              .attr("height", extent[1][1] - extent[0][1]);
	        });
	
	    group.selectAll(".selection")
	      .data([type("selection")])
	      .enter().append("rect")
	        .attr("class", "selection")
	        .attr("cursor", cursors.selection)
	        .attr("fill", "#777")
	        .attr("fill-opacity", 0.3)
	        .attr("stroke", "#fff")
	        .attr("shape-rendering", "crispEdges");
	
	    var handle = group.selectAll(".handle")
	      .data(dim.handles, function(d) { return d.type; });
	
	    handle.exit().remove();
	
	    handle.enter().append("rect")
	        .attr("class", function(d) { return "handle handle--" + d.type; })
	        .attr("cursor", function(d) { return cursors[d.type]; });
	
	    group
	        .each(redraw)
	        .attr("fill", "none")
	        .attr("pointer-events", "all")
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
	        .on("mousedown.brush touchstart.brush", started);
	  }
	
	  brush.move = function(group, selection) {
	    if (group.selection) {
	      group
	          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
	          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
	          .tween("brush", function() {
	            var that = this,
	                state = that.__brush,
	                emit = emitter(that, arguments),
	                selection0 = state.selection,
	                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
	                i = interpolateValue(selection0, selection1);
	
	            function tween(t) {
	              state.selection = t === 1 && empty(selection1) ? null : i(t);
	              redraw.call(that);
	              emit.brush();
	            }
	
	            return selection0 && selection1 ? tween : tween(1);
	          });
	    } else {
	      group
	          .each(function() {
	            var that = this,
	                args = arguments,
	                state = that.__brush,
	                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
	                emit = emitter(that, args).beforestart();
	
	            interrupt(that);
	            state.selection = selection1 == null || empty(selection1) ? null : selection1;
	            redraw.call(that);
	            emit.start().brush().end();
	          });
	    }
	  };
	
	  function redraw() {
	    var group = select(this),
	        selection = local$$1(this).selection;
	
	    if (selection) {
	      group.selectAll(".selection")
	          .style("display", null)
	          .attr("x", selection[0][0])
	          .attr("y", selection[0][1])
	          .attr("width", selection[1][0] - selection[0][0])
	          .attr("height", selection[1][1] - selection[0][1]);
	
	      group.selectAll(".handle")
	          .style("display", null)
	          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
	          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
	          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
	          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
	    }
	
	    else {
	      group.selectAll(".selection,.handle")
	          .style("display", "none")
	          .attr("x", null)
	          .attr("y", null)
	          .attr("width", null)
	          .attr("height", null);
	    }
	  }
	
	  function emitter(that, args) {
	    return that.__brush.emitter || new Emitter(that, args);
	  }
	
	  function Emitter(that, args) {
	    this.that = that;
	    this.args = args;
	    this.state = that.__brush;
	    this.active = 0;
	  }
	
	  Emitter.prototype = {
	    beforestart: function() {
	      if (++this.active === 1) this.state.emitter = this, this.starting = true;
	      return this;
	    },
	    start: function() {
	      if (this.starting) this.starting = false, this.emit("start");
	      return this;
	    },
	    brush: function() {
	      this.emit("brush");
	      return this;
	    },
	    end: function() {
	      if (--this.active === 0) delete this.state.emitter, this.emit("end");
	      return this;
	    },
	    emit: function(type) {
	      customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function started() {
	    if (exports.event.touches) { if (exports.event.changedTouches.length < exports.event.touches.length) return noevent$1(); }
	    else if (touchending) return;
	    if (!filter.apply(this, arguments)) return;
	
	    var that = this,
	        type = exports.event.target.__data__.type,
	        mode = (exports.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (exports.event.altKey ? MODE_CENTER : MODE_HANDLE),
	        signX = dim === Y ? null : signsX[type],
	        signY = dim === X ? null : signsY[type],
	        state = local$$1(that),
	        extent = state.extent,
	        selection = state.selection,
	        W = extent[0][0], w0, w1,
	        N = extent[0][1], n0, n1,
	        E = extent[1][0], e0, e1,
	        S = extent[1][1], s0, s1,
	        dx,
	        dy,
	        moving,
	        shifting = signX && signY && exports.event.shiftKey,
	        lockX,
	        lockY,
	        point0 = mouse(that),
	        point = point0,
	        emit = emitter(that, arguments).beforestart();
	
	    if (type === "overlay") {
	      state.selection = selection = [
	        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
	        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
	      ];
	    } else {
	      w0 = selection[0][0];
	      n0 = selection[0][1];
	      e0 = selection[1][0];
	      s0 = selection[1][1];
	    }
	
	    w1 = w0;
	    n1 = n0;
	    e1 = e0;
	    s1 = s0;
	
	    var group = select(that)
	        .attr("pointer-events", "none");
	
	    var overlay = group.selectAll(".overlay")
	        .attr("cursor", cursors[type]);
	
	    if (exports.event.touches) {
	      group
	          .on("touchmove.brush", moved, true)
	          .on("touchend.brush touchcancel.brush", ended, true);
	    } else {
	      var view = select(exports.event.view)
	          .on("keydown.brush", keydowned, true)
	          .on("keyup.brush", keyupped, true)
	          .on("mousemove.brush", moved, true)
	          .on("mouseup.brush", ended, true);
	
	      dragDisable(exports.event.view);
	    }
	
	    nopropagation$1();
	    interrupt(that);
	    redraw.call(that);
	    emit.start();
	
	    function moved() {
	      var point1 = mouse(that);
	      if (shifting && !lockX && !lockY) {
	        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
	        else lockX = true;
	      }
	      point = point1;
	      moving = true;
	      noevent$1();
	      move();
	    }
	
	    function move() {
	      var t;
	
	      dx = point[0] - point0[0];
	      dy = point[1] - point0[1];
	
	      switch (mode) {
	        case MODE_SPACE:
	        case MODE_DRAG: {
	          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
	          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
	          break;
	        }
	        case MODE_HANDLE: {
	          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
	          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
	          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
	          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
	          break;
	        }
	        case MODE_CENTER: {
	          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
	          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
	          break;
	        }
	      }
	
	      if (e1 < w1) {
	        signX *= -1;
	        t = w0, w0 = e0, e0 = t;
	        t = w1, w1 = e1, e1 = t;
	        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
	      }
	
	      if (s1 < n1) {
	        signY *= -1;
	        t = n0, n0 = s0, s0 = t;
	        t = n1, n1 = s1, s1 = t;
	        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
	      }
	
	      if (state.selection) selection = state.selection; // May be set by brush.move!
	      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
	      if (lockY) n1 = selection[0][1], s1 = selection[1][1];
	
	      if (selection[0][0] !== w1
	          || selection[0][1] !== n1
	          || selection[1][0] !== e1
	          || selection[1][1] !== s1) {
	        state.selection = [[w1, n1], [e1, s1]];
	        redraw.call(that);
	        emit.brush();
	      }
	    }
	
	    function ended() {
	      nopropagation$1();
	      if (exports.event.touches) {
	        if (exports.event.touches.length) return;
	        if (touchending) clearTimeout(touchending);
	        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
	        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
	      } else {
	        yesdrag(exports.event.view, moving);
	        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
	      }
	      group.attr("pointer-events", "all");
	      overlay.attr("cursor", cursors.overlay);
	      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
	      if (empty(selection)) state.selection = null, redraw.call(that);
	      emit.end();
	    }
	
	    function keydowned() {
	      switch (exports.event.keyCode) {
	        case 16: { // SHIFT
	          shifting = signX && signY;
	          break;
	        }
	        case 18: { // ALT
	          if (mode === MODE_HANDLE) {
	            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	            mode = MODE_CENTER;
	            move();
	          }
	          break;
	        }
	        case 32: { // SPACE; takes priority over ALT
	          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
	            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
	            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
	            mode = MODE_SPACE;
	            overlay.attr("cursor", cursors.selection);
	            move();
	          }
	          break;
	        }
	        default: return;
	      }
	      noevent$1();
	    }
	
	    function keyupped() {
	      switch (exports.event.keyCode) {
	        case 16: { // SHIFT
	          if (shifting) {
	            lockX = lockY = shifting = false;
	            move();
	          }
	          break;
	        }
	        case 18: { // ALT
	          if (mode === MODE_CENTER) {
	            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
	            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
	            mode = MODE_HANDLE;
	            move();
	          }
	          break;
	        }
	        case 32: { // SPACE
	          if (mode === MODE_SPACE) {
	            if (exports.event.altKey) {
	              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	              mode = MODE_CENTER;
	            } else {
	              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
	              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
	              mode = MODE_HANDLE;
	            }
	            overlay.attr("cursor", cursors[type]);
	            move();
	          }
	          break;
	        }
	        default: return;
	      }
	      noevent$1();
	    }
	  }
	
	  function initialize() {
	    var state = this.__brush || {selection: null};
	    state.extent = extent.apply(this, arguments);
	    state.dim = dim;
	    return state;
	  }
	
	  brush.extent = function(_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$4([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
	  };
	
	  brush.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$4(!!_), brush) : filter;
	  };
	
	  brush.handleSize = function(_) {
	    return arguments.length ? (handleSize = +_, brush) : handleSize;
	  };
	
	  brush.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? brush : value;
	  };
	
	  return brush;
	}
	
	var cos = Math.cos;
	var sin = Math.sin;
	var pi$1 = Math.PI;
	var halfPi$1 = pi$1 / 2;
	var tau$1 = pi$1 * 2;
	var max$1 = Math.max;
	
	function compareValue(compare) {
	  return function(a, b) {
	    return compare(
	      a.source.value + a.target.value,
	      b.source.value + b.target.value
	    );
	  };
	}
	
	var chord = function() {
	  var padAngle = 0,
	      sortGroups = null,
	      sortSubgroups = null,
	      sortChords = null;
	
	  function chord(matrix) {
	    var n = matrix.length,
	        groupSums = [],
	        groupIndex = sequence(n),
	        subgroupIndex = [],
	        chords = [],
	        groups = chords.groups = new Array(n),
	        subgroups = new Array(n * n),
	        k,
	        x,
	        x0,
	        dx,
	        i,
	        j;
	
	    // Compute the sum.
	    k = 0, i = -1; while (++i < n) {
	      x = 0, j = -1; while (++j < n) {
	        x += matrix[i][j];
	      }
	      groupSums.push(x);
	      subgroupIndex.push(sequence(n));
	      k += x;
	    }
	
	    // Sort groups…
	    if (sortGroups) groupIndex.sort(function(a, b) {
	      return sortGroups(groupSums[a], groupSums[b]);
	    });
	
	    // Sort subgroups…
	    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
	      d.sort(function(a, b) {
	        return sortSubgroups(matrix[i][a], matrix[i][b]);
	      });
	    });
	
	    // Convert the sum to scaling factor for [0, 2pi].
	    // TODO Allow start and end angle to be specified?
	    // TODO Allow padding to be specified as percentage?
	    k = max$1(0, tau$1 - padAngle * n) / k;
	    dx = k ? padAngle : tau$1 / n;
	
	    // Compute the start and end angle for each group and subgroup.
	    // Note: Opera has a bug reordering object literal properties!
	    x = 0, i = -1; while (++i < n) {
	      x0 = x, j = -1; while (++j < n) {
	        var di = groupIndex[i],
	            dj = subgroupIndex[di][j],
	            v = matrix[di][dj],
	            a0 = x,
	            a1 = x += v * k;
	        subgroups[dj * n + di] = {
	          index: di,
	          subindex: dj,
	          startAngle: a0,
	          endAngle: a1,
	          value: v
	        };
	      }
	      groups[di] = {
	        index: di,
	        startAngle: x0,
	        endAngle: x,
	        value: groupSums[di]
	      };
	      x += dx;
	    }
	
	    // Generate chords for each (non-empty) subgroup-subgroup link.
	    i = -1; while (++i < n) {
	      j = i - 1; while (++j < n) {
	        var source = subgroups[j * n + i],
	            target = subgroups[i * n + j];
	        if (source.value || target.value) {
	          chords.push(source.value < target.value
	              ? {source: target, target: source}
	              : {source: source, target: target});
	        }
	      }
	    }
	
	    return sortChords ? chords.sort(sortChords) : chords;
	  }
	
	  chord.padAngle = function(_) {
	    return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
	  };
	
	  chord.sortGroups = function(_) {
	    return arguments.length ? (sortGroups = _, chord) : sortGroups;
	  };
	
	  chord.sortSubgroups = function(_) {
	    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
	  };
	
	  chord.sortChords = function(_) {
	    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
	  };
	
	  return chord;
	};
	
	var slice$2 = Array.prototype.slice;
	
	var constant$5 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var pi$2 = Math.PI;
	var tau$2 = 2 * pi$2;
	var epsilon$1 = 1e-6;
	var tauEpsilon = tau$2 - epsilon$1;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon$1)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon$1) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau$2 + tau$2;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon$1) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$2)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	function defaultSource(d) {
	  return d.source;
	}
	
	function defaultTarget(d) {
	  return d.target;
	}
	
	function defaultRadius(d) {
	  return d.radius;
	}
	
	function defaultStartAngle(d) {
	  return d.startAngle;
	}
	
	function defaultEndAngle(d) {
	  return d.endAngle;
	}
	
	var ribbon = function() {
	  var source = defaultSource,
	      target = defaultTarget,
	      radius = defaultRadius,
	      startAngle = defaultStartAngle,
	      endAngle = defaultEndAngle,
	      context = null;
	
	  function ribbon() {
	    var buffer,
	        argv = slice$2.call(arguments),
	        s = source.apply(this, argv),
	        t = target.apply(this, argv),
	        sr = +radius.apply(this, (argv[0] = s, argv)),
	        sa0 = startAngle.apply(this, argv) - halfPi$1,
	        sa1 = endAngle.apply(this, argv) - halfPi$1,
	        sx0 = sr * cos(sa0),
	        sy0 = sr * sin(sa0),
	        tr = +radius.apply(this, (argv[0] = t, argv)),
	        ta0 = startAngle.apply(this, argv) - halfPi$1,
	        ta1 = endAngle.apply(this, argv) - halfPi$1;
	
	    if (!context) context = buffer = path();
	
	    context.moveTo(sx0, sy0);
	    context.arc(0, 0, sr, sa0, sa1);
	    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
	      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
	      context.arc(0, 0, tr, ta0, ta1);
	    }
	    context.quadraticCurveTo(0, 0, sx0, sy0);
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  ribbon.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$5(+_), ribbon) : radius;
	  };
	
	  ribbon.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : startAngle;
	  };
	
	  ribbon.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : endAngle;
	  };
	
	  ribbon.source = function(_) {
	    return arguments.length ? (source = _, ribbon) : source;
	  };
	
	  ribbon.target = function(_) {
	    return arguments.length ? (target = _, ribbon) : target;
	  };
	
	  ribbon.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
	  };
	
	  return ribbon;
	};
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map$1.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map$1(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map$1(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map, depth) {
	    if (++depth > keys.length) return map;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map.entries();
	    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map$1();
	}
	
	function setMap(map, key, value) {
	  map.set(key, value);
	}
	
	function Set() {}
	
	var proto = map$1.prototype;
	
	Set.prototype = set$2.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set$2(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function(name, i) {
	    return JSON.stringify(name) + ": d[" + i + "]";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function(row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function(row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}
	
	var dsv = function(delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
	      delimiterCode = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert, columns, rows = parseRows(text, function(row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns;
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var EOL = {}, // sentinel value for end-of-line
	        EOF = {}, // sentinel value for end-of-file
	        rows = [], // output rows
	        N = text.length,
	        I = 0, // current character index
	        n = 0, // the current line number
	        t, // the current token
	        eol; // is the current token followed by EOL?
	
	    function token() {
	      if (I >= N) return EOF; // special case: end of file
	      if (eol) return eol = false, EOL; // special case: end of line
	
	      // special case: quotes
	      var j = I, c;
	      if (text.charCodeAt(j) === 34) {
	        var i = j;
	        while (i++ < N) {
	          if (text.charCodeAt(i) === 34) {
	            if (text.charCodeAt(i + 1) !== 34) break;
	            ++i;
	          }
	        }
	        I = i + 2;
	        c = text.charCodeAt(i + 1);
	        if (c === 13) {
	          eol = true;
	          if (text.charCodeAt(i + 2) === 10) ++I;
	        } else if (c === 10) {
	          eol = true;
	        }
	        return text.slice(j + 1, i).replace(/""/g, "\"");
	      }
	
	      // common case: find next delimiter or newline
	      while (I < N) {
	        var k = 1;
	        c = text.charCodeAt(I++);
	        if (c === 10) eol = true; // \n
	        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
	        else if (c !== delimiterCode) continue;
	        return text.slice(j, I - k);
	      }
	
	      // special case: last token before EOF
	      return text.slice(j);
	    }
	
	    while ((t = token()) !== EOF) {
	      var a = [];
	      while (t !== EOL && t !== EOF) {
	        a.push(t);
	        t = token();
	      }
	      if (f && (a = f(a, n++)) == null) continue;
	      rows.push(a);
	    }
	
	    return rows;
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
	      return columns.map(function(column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    })).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(text) {
	    return text == null ? ""
	        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
	        : text;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatRows: formatRows
	  };
	};
	
	var csv = dsv(",");
	
	var csvParse = csv.parse;
	var csvParseRows = csv.parseRows;
	var csvFormat = csv.format;
	var csvFormatRows = csv.formatRows;
	
	var tsv = dsv("\t");
	
	var tsvParse = tsv.parse;
	var tsvParseRows = tsv.parseRows;
	var tsvFormat = tsv.format;
	var tsvFormatRows = tsv.formatRows;
	
	var center$1 = function(x, y) {
	  var nodes;
	
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force() {
	    var i,
	        n = nodes.length,
	        node,
	        sx = 0,
	        sy = 0;
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], sx += node.x, sy += node.y;
	    }
	
	    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
	      node = nodes[i], node.x -= sx, node.y -= sy;
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	};
	
	var constant$6 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var jiggle = function() {
	  return (Math.random() - 0.5) * 1e-6;
	};
	
	var tree_add = function(d) {
	  var x = +this._x.call(null, d),
	      y = +this._y.call(null, d);
	  return add(this.cover(x, y), x, y, d);
	};
	
	function add(tree, x, y, d) {
	  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
	
	  var parent,
	      node = tree._root,
	      leaf = {data: d},
	      x0 = tree._x0,
	      y0 = tree._y0,
	      x1 = tree._x1,
	      y1 = tree._y1,
	      xm,
	      ym,
	      xp,
	      yp,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return tree._root = leaf, tree;
	
	  // Find the existing leaf for the new point, or add it.
	  while (node.length) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
	  }
	
	  // Is the new point is exactly coincident with the existing point?
	  xp = +tree._x.call(null, node.data);
	  yp = +tree._y.call(null, node.data);
	  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
	
	  // Otherwise, split the leaf node until the old and new point are separated.
	  do {
	    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
	  return parent[j] = node, parent[i] = leaf, tree;
	}
	
	function addAll(data) {
	  var d, i, n = data.length,
	      x,
	      y,
	      xz = new Array(n),
	      yz = new Array(n),
	      x0 = Infinity,
	      y0 = Infinity,
	      x1 = -Infinity,
	      y1 = -Infinity;
	
	  // Compute the points and their extent.
	  for (i = 0; i < n; ++i) {
	    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
	    xz[i] = x;
	    yz[i] = y;
	    if (x < x0) x0 = x;
	    if (x > x1) x1 = x;
	    if (y < y0) y0 = y;
	    if (y > y1) y1 = y;
	  }
	
	  // If there were no (valid) points, inherit the existing extent.
	  if (x1 < x0) x0 = this._x0, x1 = this._x1;
	  if (y1 < y0) y0 = this._y0, y1 = this._y1;
	
	  // Expand the tree to cover the new points.
	  this.cover(x0, y0).cover(x1, y1);
	
	  // Add the new points.
	  for (i = 0; i < n; ++i) {
	    add(this, xz[i], yz[i], data[i]);
	  }
	
	  return this;
	}
	
	var tree_cover = function(x, y) {
	  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
	
	  var x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1;
	
	  // If the quadtree has no extent, initialize them.
	  // Integer extent are necessary so that if we later double the extent,
	  // the existing quadrant boundaries don’t change due to floating point error!
	  if (isNaN(x0)) {
	    x1 = (x0 = Math.floor(x)) + 1;
	    y1 = (y0 = Math.floor(y)) + 1;
	  }
	
	  // Otherwise, double repeatedly to cover.
	  else if (x0 > x || x > x1 || y0 > y || y > y1) {
	    var z = x1 - x0,
	        node = this._root,
	        parent,
	        i;
	
	    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
	      case 0: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
	        break;
	      }
	      case 1: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
	        break;
	      }
	      case 2: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
	        break;
	      }
	      case 3: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
	        break;
	      }
	    }
	
	    if (this._root && this._root.length) this._root = node;
	  }
	
	  // If the quadtree covers the point already, just return.
	  else return this;
	
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  return this;
	};
	
	var tree_data = function() {
	  var data = [];
	  this.visit(function(node) {
	    if (!node.length) do data.push(node.data); while (node = node.next)
	  });
	  return data;
	};
	
	var tree_extent = function(_) {
	  return arguments.length
	      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
	      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
	};
	
	var Quad = function(node, x0, y0, x1, y1) {
	  this.node = node;
	  this.x0 = x0;
	  this.y0 = y0;
	  this.x1 = x1;
	  this.y1 = y1;
	};
	
	var tree_find = function(x, y, radius) {
	  var data,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1,
	      y1,
	      x2,
	      y2,
	      x3 = this._x1,
	      y3 = this._y1,
	      quads = [],
	      node = this._root,
	      q,
	      i;
	
	  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
	  if (radius == null) radius = Infinity;
	  else {
	    x0 = x - radius, y0 = y - radius;
	    x3 = x + radius, y3 = y + radius;
	    radius *= radius;
	  }
	
	  while (q = quads.pop()) {
	
	    // Stop searching if this quadrant can’t contain a closer node.
	    if (!(node = q.node)
	        || (x1 = q.x0) > x3
	        || (y1 = q.y0) > y3
	        || (x2 = q.x1) < x0
	        || (y2 = q.y1) < y0) continue;
	
	    // Bisect the current quadrant.
	    if (node.length) {
	      var xm = (x1 + x2) / 2,
	          ym = (y1 + y2) / 2;
	
	      quads.push(
	        new Quad(node[3], xm, ym, x2, y2),
	        new Quad(node[2], x1, ym, xm, y2),
	        new Quad(node[1], xm, y1, x2, ym),
	        new Quad(node[0], x1, y1, xm, ym)
	      );
	
	      // Visit the closest quadrant first.
	      if (i = (y >= ym) << 1 | (x >= xm)) {
	        q = quads[quads.length - 1];
	        quads[quads.length - 1] = quads[quads.length - 1 - i];
	        quads[quads.length - 1 - i] = q;
	      }
	    }
	
	    // Visit this point. (Visiting coincident points isn’t necessary!)
	    else {
	      var dx = x - +this._x.call(null, node.data),
	          dy = y - +this._y.call(null, node.data),
	          d2 = dx * dx + dy * dy;
	      if (d2 < radius) {
	        var d = Math.sqrt(radius = d2);
	        x0 = x - d, y0 = y - d;
	        x3 = x + d, y3 = y + d;
	        data = node.data;
	      }
	    }
	  }
	
	  return data;
	};
	
	var tree_remove = function(d) {
	  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
	
	  var parent,
	      node = this._root,
	      retainer,
	      previous,
	      next,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1,
	      x,
	      y,
	      xm,
	      ym,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return this;
	
	  // Find the leaf node for the point.
	  // While descending, also retain the deepest parent with a non-removed sibling.
	  if (node.length) while (true) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
	    if (!node.length) break;
	    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
	  }
	
	  // Find the point to remove.
	  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
	  if (next = node.next) delete node.next;
	
	  // If there are multiple coincident points, remove just the point.
	  if (previous) return (next ? previous.next = next : delete previous.next), this;
	
	  // If this is the root point, remove it.
	  if (!parent) return this._root = next, this;
	
	  // Remove this leaf.
	  next ? parent[i] = next : delete parent[i];
	
	  // If the parent now contains exactly one leaf, collapse superfluous parents.
	  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
	      && node === (parent[3] || parent[2] || parent[1] || parent[0])
	      && !node.length) {
	    if (retainer) retainer[j] = node;
	    else this._root = node;
	  }
	
	  return this;
	};
	
	function removeAll(data) {
	  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
	  return this;
	}
	
	var tree_root = function() {
	  return this._root;
	};
	
	var tree_size = function() {
	  var size = 0;
	  this.visit(function(node) {
	    if (!node.length) do ++size; while (node = node.next)
	  });
	  return size;
	};
	
	var tree_visit = function(callback) {
	  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
	  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
	      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	    }
	  }
	  return this;
	};
	
	var tree_visitAfter = function(callback) {
	  var quads = [], next = [], q;
	  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    var node = q.node;
	    if (node.length) {
	      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	    }
	    next.push(q);
	  }
	  while (q = next.pop()) {
	    callback(q.node, q.x0, q.y0, q.x1, q.y1);
	  }
	  return this;
	};
	
	function defaultX(d) {
	  return d[0];
	}
	
	var tree_x = function(_) {
	  return arguments.length ? (this._x = _, this) : this._x;
	};
	
	function defaultY(d) {
	  return d[1];
	}
	
	var tree_y = function(_) {
	  return arguments.length ? (this._y = _, this) : this._y;
	};
	
	function quadtree(nodes, x, y) {
	  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
	  return nodes == null ? tree : tree.addAll(nodes);
	}
	
	function Quadtree(x, y, x0, y0, x1, y1) {
	  this._x = x;
	  this._y = y;
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  this._root = undefined;
	}
	
	function leaf_copy(leaf) {
	  var copy = {data: leaf.data}, next = copy;
	  while (leaf = leaf.next) next = next.next = {data: leaf.data};
	  return copy;
	}
	
	var treeProto = quadtree.prototype = Quadtree.prototype;
	
	treeProto.copy = function() {
	  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
	      node = this._root,
	      nodes,
	      child;
	
	  if (!node) return copy;
	
	  if (!node.length) return copy._root = leaf_copy(node), copy;
	
	  nodes = [{source: node, target: copy._root = new Array(4)}];
	  while (node = nodes.pop()) {
	    for (var i = 0; i < 4; ++i) {
	      if (child = node.source[i]) {
	        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
	        else node.target[i] = leaf_copy(child);
	      }
	    }
	  }
	
	  return copy;
	};
	
	treeProto.add = tree_add;
	treeProto.addAll = addAll;
	treeProto.cover = tree_cover;
	treeProto.data = tree_data;
	treeProto.extent = tree_extent;
	treeProto.find = tree_find;
	treeProto.remove = tree_remove;
	treeProto.removeAll = removeAll;
	treeProto.root = tree_root;
	treeProto.size = tree_size;
	treeProto.visit = tree_visit;
	treeProto.visitAfter = tree_visitAfter;
	treeProto.x = tree_x;
	treeProto.y = tree_y;
	
	function x(d) {
	  return d.x + d.vx;
	}
	
	function y(d) {
	  return d.y + d.vy;
	}
	
	var collide = function(radius) {
	  var nodes,
	      radii,
	      strength = 1,
	      iterations = 1;
	
	  if (typeof radius !== "function") radius = constant$6(radius == null ? 1 : +radius);
	
	  function force() {
	    var i, n = nodes.length,
	        tree,
	        node,
	        xi,
	        yi,
	        ri,
	        ri2;
	
	    for (var k = 0; k < iterations; ++k) {
	      tree = quadtree(nodes, x, y).visitAfter(prepare);
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        ri = radii[node.index], ri2 = ri * ri;
	        xi = node.x + node.vx;
	        yi = node.y + node.vy;
	        tree.visit(apply);
	      }
	    }
	
	    function apply(quad, x0, y0, x1, y1) {
	      var data = quad.data, rj = quad.r, r = ri + rj;
	      if (data) {
	        if (data.index > node.index) {
	          var x = xi - data.x - data.vx,
	              y = yi - data.y - data.vy,
	              l = x * x + y * y;
	          if (l < r * r) {
	            if (x === 0) x = jiggle(), l += x * x;
	            if (y === 0) y = jiggle(), l += y * y;
	            l = (r - (l = Math.sqrt(l))) / l * strength;
	            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
	            node.vy += (y *= l) * r;
	            data.vx -= x * (r = 1 - r);
	            data.vy -= y * r;
	          }
	        }
	        return;
	      }
	      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
	    }
	  }
	
	  function prepare(quad) {
	    if (quad.data) return quad.r = radii[quad.data.index];
	    for (var i = quad.r = 0; i < 4; ++i) {
	      if (quad[i] && quad[i].r > quad.r) {
	        quad.r = quad[i].r;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    radii = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = +_, force) : strength;
	  };
	
	  force.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : radius;
	  };
	
	  return force;
	};
	
	function index(d) {
	  return d.index;
	}
	
	function find(nodeById, nodeId) {
	  var node = nodeById.get(nodeId);
	  if (!node) throw new Error("missing: " + nodeId);
	  return node;
	}
	
	var link = function(links) {
	  var id = index,
	      strength = defaultStrength,
	      strengths,
	      distance = constant$6(30),
	      distances,
	      nodes,
	      count,
	      bias,
	      iterations = 1;
	
	  if (links == null) links = [];
	
	  function defaultStrength(link) {
	    return 1 / Math.min(count[link.source.index], count[link.target.index]);
	  }
	
	  function force(alpha) {
	    for (var k = 0, n = links.length; k < iterations; ++k) {
	      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
	        link = links[i], source = link.source, target = link.target;
	        x = target.x + target.vx - source.x - source.vx || jiggle();
	        y = target.y + target.vy - source.y - source.vy || jiggle();
	        l = Math.sqrt(x * x + y * y);
	        l = (l - distances[i]) / l * alpha * strengths[i];
	        x *= l, y *= l;
	        target.vx -= x * (b = bias[i]);
	        target.vy -= y * b;
	        source.vx += x * (b = 1 - b);
	        source.vy += y * b;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	
	    var i,
	        n = nodes.length,
	        m = links.length,
	        nodeById = map$1(nodes, id),
	        link;
	
	    for (i = 0, count = new Array(n); i < m; ++i) {
	      link = links[i], link.index = i;
	      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
	      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
	      count[link.source.index] = (count[link.source.index] || 0) + 1;
	      count[link.target.index] = (count[link.target.index] || 0) + 1;
	    }
	
	    for (i = 0, bias = new Array(m); i < m; ++i) {
	      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
	    }
	
	    strengths = new Array(m), initializeStrength();
	    distances = new Array(m), initializeDistance();
	  }
	
	  function initializeStrength() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      strengths[i] = +strength(links[i], i, links);
	    }
	  }
	
	  function initializeDistance() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      distances[i] = +distance(links[i], i, links);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.links = function(_) {
	    return arguments.length ? (links = _, initialize(), force) : links;
	  };
	
	  force.id = function(_) {
	    return arguments.length ? (id = _, force) : id;
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initializeStrength(), force) : strength;
	  };
	
	  force.distance = function(_) {
	    return arguments.length ? (distance = typeof _ === "function" ? _ : constant$6(+_), initializeDistance(), force) : distance;
	  };
	
	  return force;
	};
	
	function x$1(d) {
	  return d.x;
	}
	
	function y$1(d) {
	  return d.y;
	}
	
	var initialRadius = 10;
	var initialAngle = Math.PI * (3 - Math.sqrt(5));
	
	var simulation = function(nodes) {
	  var simulation,
	      alpha = 1,
	      alphaMin = 0.001,
	      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
	      alphaTarget = 0,
	      velocityDecay = 0.6,
	      forces = map$1(),
	      stepper = timer(step),
	      event = dispatch("tick", "end");
	
	  if (nodes == null) nodes = [];
	
	  function step() {
	    tick();
	    event.call("tick", simulation);
	    if (alpha < alphaMin) {
	      stepper.stop();
	      event.call("end", simulation);
	    }
	  }
	
	  function tick() {
	    var i, n = nodes.length, node;
	
	    alpha += (alphaTarget - alpha) * alphaDecay;
	
	    forces.each(function(force) {
	      force(alpha);
	    });
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i];
	      if (node.fx == null) node.x += node.vx *= velocityDecay;
	      else node.x = node.fx, node.vx = 0;
	      if (node.fy == null) node.y += node.vy *= velocityDecay;
	      else node.y = node.fy, node.vy = 0;
	    }
	  }
	
	  function initializeNodes() {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.index = i;
	      if (isNaN(node.x) || isNaN(node.y)) {
	        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
	        node.x = radius * Math.cos(angle);
	        node.y = radius * Math.sin(angle);
	      }
	      if (isNaN(node.vx) || isNaN(node.vy)) {
	        node.vx = node.vy = 0;
	      }
	    }
	  }
	
	  function initializeForce(force) {
	    if (force.initialize) force.initialize(nodes);
	    return force;
	  }
	
	  initializeNodes();
	
	  return simulation = {
	    tick: tick,
	
	    restart: function() {
	      return stepper.restart(step), simulation;
	    },
	
	    stop: function() {
	      return stepper.stop(), simulation;
	    },
	
	    nodes: function(_) {
	      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
	    },
	
	    alpha: function(_) {
	      return arguments.length ? (alpha = +_, simulation) : alpha;
	    },
	
	    alphaMin: function(_) {
	      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
	    },
	
	    alphaDecay: function(_) {
	      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
	    },
	
	    alphaTarget: function(_) {
	      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
	    },
	
	    velocityDecay: function(_) {
	      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
	    },
	
	    force: function(name, _) {
	      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
	    },
	
	    find: function(x, y, radius) {
	      var i = 0,
	          n = nodes.length,
	          dx,
	          dy,
	          d2,
	          node,
	          closest;
	
	      if (radius == null) radius = Infinity;
	      else radius *= radius;
	
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        dx = x - node.x;
	        dy = y - node.y;
	        d2 = dx * dx + dy * dy;
	        if (d2 < radius) closest = node, radius = d2;
	      }
	
	      return closest;
	    },
	
	    on: function(name, _) {
	      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
	    }
	  };
	};
	
	var manyBody = function() {
	  var nodes,
	      node,
	      alpha,
	      strength = constant$6(-30),
	      strengths,
	      distanceMin2 = 1,
	      distanceMax2 = Infinity,
	      theta2 = 0.81;
	
	  function force(_) {
	    var i, n = nodes.length, tree = quadtree(nodes, x$1, y$1).visitAfter(accumulate);
	    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    strengths = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
	  }
	
	  function accumulate(quad) {
	    var strength = 0, q, c, x, y, i;
	
	    // For internal nodes, accumulate forces from child quadrants.
	    if (quad.length) {
	      for (x = y = i = 0; i < 4; ++i) {
	        if ((q = quad[i]) && (c = q.value)) {
	          strength += c, x += c * q.x, y += c * q.y;
	        }
	      }
	      quad.x = x / strength;
	      quad.y = y / strength;
	    }
	
	    // For leaf nodes, accumulate forces from coincident quadrants.
	    else {
	      q = quad;
	      q.x = q.data.x;
	      q.y = q.data.y;
	      do strength += strengths[q.data.index];
	      while (q = q.next);
	    }
	
	    quad.value = strength;
	  }
	
	  function apply(quad, x1, _, x2) {
	    if (!quad.value) return true;
	
	    var x = quad.x - node.x,
	        y = quad.y - node.y,
	        w = x2 - x1,
	        l = x * x + y * y;
	
	    // Apply the Barnes-Hut approximation if possible.
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (w * w / theta2 < l) {
	      if (l < distanceMax2) {
	        if (x === 0) x = jiggle(), l += x * x;
	        if (y === 0) y = jiggle(), l += y * y;
	        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	        node.vx += x * quad.value * alpha / l;
	        node.vy += y * quad.value * alpha / l;
	      }
	      return true;
	    }
	
	    // Otherwise, process points directly.
	    else if (quad.length || l >= distanceMax2) return;
	
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (quad.data !== node || quad.next) {
	      if (x === 0) x = jiggle(), l += x * x;
	      if (y === 0) y = jiggle(), l += y * y;
	      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	    }
	
	    do if (quad.data !== node) {
	      w = strengths[quad.data.index] * alpha / l;
	      node.vx += x * w;
	      node.vy += y * w;
	    } while (quad = quad.next);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
	  };
	
	  force.distanceMin = function(_) {
	    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
	  };
	
	  force.distanceMax = function(_) {
	    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
	  };
	
	  force.theta = function(_) {
	    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
	  };
	
	  return force;
	};
	
	var x$2 = function(x) {
	  var strength = constant$6(0.1),
	      nodes,
	      strengths,
	      xz;
	
	  if (typeof x !== "function") x = constant$6(x == null ? 0 : +x);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    xz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : x;
	  };
	
	  return force;
	};
	
	var y$2 = function(y) {
	  var strength = constant$6(0.1),
	      nodes,
	      strengths,
	      yz;
	
	  if (typeof y !== "function") y = constant$6(y == null ? 0 : +y);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    yz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : y;
	  };
	
	  return force;
	};
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent$1 = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity$3 = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","\xB5","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$3,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity$3,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale$1;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.format = locale$1.format;
	  exports.formatPrefix = locale$1.formatPrefix;
	  return locale$1;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent$1(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
	};
	
	// Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	var adder = function() {
	  return new Adder;
	};
	
	function Adder() {
	  this.reset();
	}
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function(y) {
	    add$1(temp, y, this.t);
	    add$1(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;
	    else this.s = temp.t;
	  },
	  valueOf: function() {
	    return this.s;
	  }
	};
	
	var temp = new Adder;
	
	function add$1(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = (a - av) + (b - bv);
	}
	
	var epsilon$2 = 1e-6;
	var epsilon2$1 = 1e-12;
	var pi$3 = Math.PI;
	var halfPi$2 = pi$3 / 2;
	var quarterPi = pi$3 / 4;
	var tau$3 = pi$3 * 2;
	
	var degrees$1 = 180 / pi$3;
	var radians = pi$3 / 180;
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	var cos$1 = Math.cos;
	var ceil = Math.ceil;
	var exp = Math.exp;
	
	var log = Math.log;
	var pow = Math.pow;
	var sin$1 = Math.sin;
	var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sqrt = Math.sqrt;
	var tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi$3 : Math.acos(x);
	}
	
	function asin(x) {
	  return x > 1 ? halfPi$2 : x < -1 ? -halfPi$2 : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin$1(x / 2)) * x;
	}
	
	function noop$1() {}
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function(object, stream) {
	    streamGeometry(object.geometry, stream);
	  },
	  FeatureCollection: function(object, stream) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) streamGeometry(features[i].geometry, stream);
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function(object, stream) {
	    stream.sphere();
	  },
	  Point: function(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	  },
	  LineString: function(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamLine(coordinates[i], stream, 0);
	  },
	  Polygon: function(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamPolygon(coordinates[i], stream);
	  },
	  GeometryCollection: function(object, stream) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) streamGeometry(geometries[i], stream);
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1, n = coordinates.length - closed, coordinate;
	  stream.lineStart();
	  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1, n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) streamLine(coordinates[i], stream, 1);
	  stream.polygonEnd();
	}
	
	var geoStream = function(object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	};
	
	var areaRingSum = adder();
	
	var areaSum = adder();
	var lambda00;
	var phi00;
	var lambda0;
	var cosPhi0;
	var sinPhi0;
	
	var areaStream = {
	  point: noop$1,
	  lineStart: noop$1,
	  lineEnd: noop$1,
	  polygonStart: function() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? tau$3 + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = noop$1;
	  },
	  sphere: function() {
	    areaSum.add(tau$3);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= radians, phi *= radians;
	  lambda0 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  phi = phi / 2 + quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = cos$1(phi),
	      sinPhi = sin$1(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * cos$1(adLambda),
	      v = k * sdLambda * sin$1(adLambda);
	  areaRingSum.add(atan2(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}
	
	var area = function(object) {
	  areaSum.reset();
	  geoStream(object, areaStream);
	  return areaSum * 2;
	};
	
	function spherical(cartesian) {
	  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
	  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}
	
	var lambda0$1;
	var phi0;
	var lambda1;
	var phi1;
	var lambda2;
	var lambda00$1;
	var phi00$1;
	var p0;
	var deltaSum = adder();
	var ranges;
	var range;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    areaStream.polygonStart();
	  },
	  polygonEnd: function() {
	    areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	    else if (deltaSum > epsilon$2) phi1 = 90;
	    else if (deltaSum < -epsilon$2) phi0 = -90;
	    range[0] = lambda0$1, range[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = cartesian([lambda * radians, phi * radians]);
	  if (p0) {
	    var normal = cartesianCross(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = cartesianCross(equatorial, normal);
	    cartesianNormalizeInPlace(inflection);
	    inflection = spherical(inflection);
	    var delta = lambda - lambda2,
	        sign$$1 = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * degrees$1 * sign$$1,
	        phii,
	        antimeridian = abs(delta) > 180;
	    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = inflection[1] * degrees$1;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = -inflection[1] * degrees$1;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0$1) {
	        if (lambda < lambda0$1) lambda0$1 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	        }
	      }
	    }
	  } else {
	    ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
	  }
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range[0] = lambda0$1, range[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00$1 = lambda, phi00$1 = phi;
	  }
	  areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00$1, phi00$1);
	  areaStream.lineEnd();
	  if (abs(deltaSum) > epsilon$2) lambda0$1 = -(lambda1 = 180);
	  range[0] = lambda0$1, range[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range, x) {
	  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	}
	
	var bounds = function(feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
	  ranges = [];
	  geoStream(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range = null;
	
	  return lambda0$1 === Infinity || phi0 === Infinity
	      ? [[NaN, NaN], [NaN, NaN]]
	      : [[lambda0$1, phi0], [lambda1, phi1]];
	};
	
	var W0;
	var W1;
	var X0;
	var Y0;
	var Z0;
	var X1;
	var Y1;
	var Z1;
	var X2;
	var Y2;
	var Z2;
	var lambda00$2;
	var phi00$2;
	var x0;
	var y0;
	var z0; // previous point
	
	var centroidStream = {
	  sphere: noop$1,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi);
	  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi);
	  x0 = cosPhi * cos$1(lambda);
	  y0 = cosPhi * sin$1(lambda);
	  z0 = sin$1(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi),
	      x = cosPhi * cos$1(lambda),
	      y = cosPhi * sin$1(lambda),
	      z = sin$1(phi),
	      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00$2, phi00$2);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00$2 = lambda, phi00$2 = phi;
	  lambda *= radians, phi *= radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = cos$1(phi);
	  x0 = cosPhi * cos$1(lambda);
	  y0 = cosPhi * sin$1(lambda);
	  z0 = sin$1(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi),
	      x = cosPhi * cos$1(lambda),
	      y = cosPhi * sin$1(lambda),
	      z = sin$1(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = sqrt(cx * cx + cy * cy + cz * cz),
	      w = asin(m), // line weight = angle
	      v = m && -w / m; // area weight multiplier
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	var centroid = function(object) {
	  W0 = W1 =
	  X0 = Y0 = Z0 =
	  X1 = Y1 = Z1 =
	  X2 = Y2 = Z2 = 0;
	  geoStream(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < epsilon2$1) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < epsilon$2) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < epsilon2$1) return [NaN, NaN];
	  }
	
	  return [atan2(y, x) * degrees$1, asin(z / sqrt(m)) * degrees$1];
	};
	
	var constant$7 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var compose = function(a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function(x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	};
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= tau$3) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
	    : rotationLambda(deltaLambda))
	    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
	    : rotationIdentity);
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function(lambda, phi) {
	    return lambda += deltaLambda, [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = cos$1(deltaPhi),
	      sinDeltaPhi = sin$1(deltaPhi),
	      cosDeltaGamma = cos$1(deltaGamma),
	      sinDeltaGamma = sin$1(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = cos$1(phi),
	        x = cos$1(lambda) * cosPhi,
	        y = sin$1(lambda) * cosPhi,
	        z = sin$1(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [
	      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	      asin(k * cosDeltaGamma + y * sinDeltaGamma)
	    ];
	  }
	
	  rotation.invert = function(lambda, phi) {
	    var cosPhi = cos$1(phi),
	        x = cos$1(lambda) * cosPhi,
	        y = sin$1(lambda) * cosPhi,
	        z = sin$1(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [
	      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	      asin(k * cosDeltaPhi - x * sinDeltaPhi)
	    ];
	  };
	
	  return rotation;
	}
	
	var rotation = function(rotate) {
	  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
	  }
	
	  forward.invert = function(coordinates) {
	    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
	  };
	
	  return forward;
	};
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = cos$1(radius),
	      sinRadius = sin$1(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * tau$3;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$3;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = cartesian(point), point[0] -= cosRadius;
	  cartesianNormalizeInPlace(point);
	  var radius = acos(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + tau$3 - epsilon$2) % tau$3;
	}
	
	var circle = function() {
	  var center = constant$7([0, 0]),
	      radius = constant$7(90),
	      precision = constant$7(6),
	      ring,
	      rotate,
	      stream = {point: point};
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= degrees$1, x[1] *= degrees$1;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * radians,
	        p = precision.apply(this, arguments) * radians;
	    ring = [];
	    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = {type: "Polygon", coordinates: [ring]};
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function(_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : constant$7([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$7(+_), circle) : radius;
	  };
	
	  circle.precision = function(_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : constant$7(+_), circle) : precision;
	  };
	
	  return circle;
	};
	
	var clipBuffer = function() {
	  var lines = [],
	      line;
	  return {
	    point: function(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function() {
	      lines.push(line = []);
	    },
	    lineEnd: noop$1,
	    rejoin: function() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	};
	
	var clipLine = function(a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	};
	
	var pointEqual = function(a, b) {
	  return abs(a[0] - b[0]) < epsilon$2 && abs(a[1] - b[1]) < epsilon$2;
	};
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function(segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n, p0 = segment[0], p1 = segment[n], x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if (pointEqual(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	      stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link$1(subject);
	  link$1(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) if ((current = current.n) === start) return;
	    points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	};
	
	function link$1(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}
	
	var clipMax = 1e9;
	var clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipExtent(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0, a1 = 0;
	    if (from == null
	        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
	        || comparePoint(from, to) < 0 ^ direction > 0) {
	      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return abs(p[0] - x0) < epsilon$2 ? direction > 0 ? 0 : 3
	        : abs(p[0] - x1) < epsilon$2 ? direction > 0 ? 2 : 1
	        : abs(p[1] - y0) < epsilon$2 ? direction > 0 ? 1 : 0
	        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb
	        : ca === 0 ? b[1] - a[1]
	        : ca === 1 ? a[0] - b[0]
	        : ca === 2 ? a[1] - b[1]
	        : b[0] - a[0];
	  }
	
	  return function(stream) {
	    var activeStream = stream,
	        bufferStream = clipBuffer(),
	        segments,
	        polygon,
	        ring,
	        x__, y__, v__, // first point
	        x_, y_, v_, // previous point
	        first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
	          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = merge(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);
	        else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if (clipLine(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}
	
	var extent$1 = function() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
	    },
	    extent: function(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	};
	
	var sum$1 = adder();
	
	var polygonContains = function(polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      normal = [sin$1(lambda), -cos$1(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum$1.reset();
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + quarterPi,
	        sinPhi0 = sin$1(phi0),
	        cosPhi0 = cos$1(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + quarterPi,
	          sinPhi1 = sin$1(phi1),
	          cosPhi1 = cos$1(phi1),
	          delta = lambda1 - lambda0,
	          sign$$1 = delta >= 0 ? 1 : -1,
	          absDelta = sign$$1 * delta,
	          antimeridian = absDelta > pi$3,
	          k = sinPhi0 * sinPhi1;
	
	      sum$1.add(atan2(k * sign$$1 * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
	      angle += antimeridian ? delta + sign$$1 * tau$3 : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = cartesianCross(cartesian(point0), cartesian(point1));
	        cartesianNormalizeInPlace(arc);
	        var intersection = cartesianCross(normal, arc);
	        cartesianNormalizeInPlace(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -epsilon$2 || angle < epsilon$2 && sum$1 < -epsilon$2) ^ (winding & 1);
	};
	
	var lengthSum = adder();
	var lambda0$2;
	var sinPhi0$1;
	var cosPhi0$1;
	
	var lengthStream = {
	  sphere: noop$1,
	  point: noop$1,
	  lineStart: lengthLineStart,
	  lineEnd: noop$1,
	  polygonStart: noop$1,
	  polygonEnd: noop$1
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = noop$1;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  lambda0$2 = lambda, sinPhi0$1 = sin$1(phi), cosPhi0$1 = cos$1(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var sinPhi = sin$1(phi),
	      cosPhi = cos$1(phi),
	      delta = abs(lambda - lambda0$2),
	      cosDelta = cos$1(delta),
	      sinDelta = sin$1(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
	      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
	  lengthSum.add(atan2(sqrt(x * x + y * y), z));
	  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
	}
	
	var length$1 = function(object) {
	  lengthSum.reset();
	  geoStream(object, lengthStream);
	  return +lengthSum;
	};
	
	var coordinates = [null, null];
	var object$1 = {type: "LineString", coordinates: coordinates};
	
	var distance = function(a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return length$1(object$1);
	};
	
	var containsObjectType = {
	  Feature: function(object, point) {
	    return containsGeometry(object.geometry, point);
	  },
	  FeatureCollection: function(object, point) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
	    return false;
	  }
	};
	
	var containsGeometryType = {
	  Sphere: function() {
	    return true;
	  },
	  Point: function(object, point) {
	    return containsPoint(object.coordinates, point);
	  },
	  MultiPoint: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
	    return false;
	  },
	  LineString: function(object, point) {
	    return containsLine(object.coordinates, point);
	  },
	  MultiLineString: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsLine(coordinates[i], point)) return true;
	    return false;
	  },
	  Polygon: function(object, point) {
	    return containsPolygon(object.coordinates, point);
	  },
	  MultiPolygon: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
	    return false;
	  },
	  GeometryCollection: function(object, point) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
	    return false;
	  }
	};
	
	function containsGeometry(geometry, point) {
	  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
	      ? containsGeometryType[geometry.type](geometry, point)
	      : false;
	}
	
	function containsPoint(coordinates, point) {
	  return distance(coordinates, point) === 0;
	}
	
	function containsLine(coordinates, point) {
	  var ab = distance(coordinates[0], coordinates[1]),
	      ao = distance(coordinates[0], point),
	      ob = distance(point, coordinates[1]);
	  return ao + ob <= ab + epsilon$2;
	}
	
	function containsPolygon(coordinates, point) {
	  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
	}
	
	function ringRadians(ring) {
	  return ring = ring.map(pointRadians), ring.pop(), ring;
	}
	
	function pointRadians(point) {
	  return [point[0] * radians, point[1] * radians];
	}
	
	var contains = function(object, point) {
	  return (object && containsObjectType.hasOwnProperty(object.type)
	      ? containsObjectType[object.type]
	      : containsGeometry)(object, point);
	};
	
	function graticuleX(y0, y1, dy) {
	  var y = sequence(y0, y1 - epsilon$2, dy).concat(y1);
	  return function(x) { return y.map(function(y) { return [x, y]; }); };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = sequence(x0, x1 - epsilon$2, dx).concat(x1);
	  return function(y) { return x.map(function(x) { return [x, y]; }); };
	}
	
	function graticule() {
	  var x1, x0, X1, X0,
	      y1, y0, Y1, Y0,
	      dx = 10, dy = dx, DX = 90, DY = 360,
	      x, y, X, Y,
	      precision = 2.5;
	
	  function graticule() {
	    return {type: "MultiLineString", coordinates: lines()};
	  }
	
	  function lines() {
	    return sequence(ceil(X0 / DX) * DX, X1, DX).map(X)
	        .concat(sequence(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
	        .concat(sequence(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon$2; }).map(x))
	        .concat(sequence(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon$2; }).map(y));
	  }
	
	  graticule.lines = function() {
	    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
	  };
	
	  graticule.outline = function() {
	    return {
	      type: "Polygon",
	      coordinates: [
	        X(X0).concat(
	        Y(Y1).slice(1),
	        X(X1).reverse().slice(1),
	        Y(Y0).reverse().slice(1))
	      ]
	    };
	  };
	
	  graticule.extent = function(_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function(_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function(_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function(_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function(_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function(_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function(_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule
	      .extentMajor([[-180, -90 + epsilon$2], [180, 90 - epsilon$2]])
	      .extentMinor([[-180, -80 - epsilon$2], [180, 80 + epsilon$2]]);
	}
	
	function graticule10() {
	  return graticule()();
	}
	
	var interpolate$1 = function(a, b) {
	  var x0 = a[0] * radians,
	      y0 = a[1] * radians,
	      x1 = b[0] * radians,
	      y1 = b[1] * radians,
	      cy0 = cos$1(y0),
	      sy0 = sin$1(y0),
	      cy1 = cos$1(y1),
	      sy1 = sin$1(y1),
	      kx0 = cy0 * cos$1(x0),
	      ky0 = cy0 * sin$1(x0),
	      kx1 = cy1 * cos$1(x1),
	      ky1 = cy1 * sin$1(x1),
	      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
	      k = sin$1(d);
	
	  var interpolate = d ? function(t) {
	    var B = sin$1(t *= d) / k,
	        A = sin$1(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [
	      atan2(y, x) * degrees$1,
	      atan2(z, sqrt(x * x + y * y)) * degrees$1
	    ];
	  } : function() {
	    return [x0 * degrees$1, y0 * degrees$1];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	};
	
	var identity$4 = function(x) {
	  return x;
	};
	
	var areaSum$1 = adder();
	var areaRingSum$1 = adder();
	var x00;
	var y00;
	var x0$1;
	var y0$1;
	
	var areaStream$1 = {
	  point: noop$1,
	  lineStart: noop$1,
	  lineEnd: noop$1,
	  polygonStart: function() {
	    areaStream$1.lineStart = areaRingStart$1;
	    areaStream$1.lineEnd = areaRingEnd$1;
	  },
	  polygonEnd: function() {
	    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop$1;
	    areaSum$1.add(abs(areaRingSum$1));
	    areaRingSum$1.reset();
	  },
	  result: function() {
	    var area = areaSum$1 / 2;
	    areaSum$1.reset();
	    return area;
	  }
	};
	
	function areaRingStart$1() {
	  areaStream$1.point = areaPointFirst$1;
	}
	
	function areaPointFirst$1(x, y) {
	  areaStream$1.point = areaPoint$1;
	  x00 = x0$1 = x, y00 = y0$1 = y;
	}
	
	function areaPoint$1(x, y) {
	  areaRingSum$1.add(y0$1 * x - x0$1 * y);
	  x0$1 = x, y0$1 = y;
	}
	
	function areaRingEnd$1() {
	  areaPoint$1(x00, y00);
	}
	
	var x0$2 = Infinity;
	var y0$2 = x0$2;
	var x1 = -x0$2;
	var y1 = x1;
	
	var boundsStream$1 = {
	  point: boundsPoint$1,
	  lineStart: noop$1,
	  lineEnd: noop$1,
	  polygonStart: noop$1,
	  polygonEnd: noop$1,
	  result: function() {
	    var bounds = [[x0$2, y0$2], [x1, y1]];
	    x1 = y1 = -(y0$2 = x0$2 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint$1(x, y) {
	  if (x < x0$2) x0$2 = x;
	  if (x > x1) x1 = x;
	  if (y < y0$2) y0$2 = y;
	  if (y > y1) y1 = y;
	}
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0$1 = 0;
	var Y0$1 = 0;
	var Z0$1 = 0;
	var X1$1 = 0;
	var Y1$1 = 0;
	var Z1$1 = 0;
	var X2$1 = 0;
	var Y2$1 = 0;
	var Z2$1 = 0;
	var x00$1;
	var y00$1;
	var x0$3;
	var y0$3;
	
	var centroidStream$1 = {
	  point: centroidPoint$1,
	  lineStart: centroidLineStart$1,
	  lineEnd: centroidLineEnd$1,
	  polygonStart: function() {
	    centroidStream$1.lineStart = centroidRingStart$1;
	    centroidStream$1.lineEnd = centroidRingEnd$1;
	  },
	  polygonEnd: function() {
	    centroidStream$1.point = centroidPoint$1;
	    centroidStream$1.lineStart = centroidLineStart$1;
	    centroidStream$1.lineEnd = centroidLineEnd$1;
	  },
	  result: function() {
	    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
	        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
	        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
	        : [NaN, NaN];
	    X0$1 = Y0$1 = Z0$1 =
	    X1$1 = Y1$1 = Z1$1 =
	    X2$1 = Y2$1 = Z2$1 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint$1(x, y) {
	  X0$1 += x;
	  Y0$1 += y;
	  ++Z0$1;
	}
	
	function centroidLineStart$1() {
	  centroidStream$1.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream$1.point = centroidPointLine;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidLineEnd$1() {
	  centroidStream$1.point = centroidPoint$1;
	}
	
	function centroidRingStart$1() {
	  centroidStream$1.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd$1() {
	  centroidPointRing(x00$1, y00$1);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream$1.point = centroidPointRing;
	  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0$3,
	      dy = y - y0$3,
	      z = sqrt(dx * dx + dy * dy);
	
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	
	  z = y0$3 * x - x0$3 * y;
	  X2$1 += z * (x0$3 + x);
	  Y2$1 += z * (y0$3 + y);
	  Z2$1 += z * 3;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._context.moveTo(x, y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._context.lineTo(x, y);
	        break;
	      }
	      default: {
	        this._context.moveTo(x + this._radius, y);
	        this._context.arc(x, y, this._radius, 0, tau$3);
	        break;
	      }
	    }
	  },
	  result: noop$1
	};
	
	var lengthSum$1 = adder();
	var lengthRing;
	var x00$2;
	var y00$2;
	var x0$4;
	var y0$4;
	
	var lengthStream$1 = {
	  point: noop$1,
	  lineStart: function() {
	    lengthStream$1.point = lengthPointFirst$1;
	  },
	  lineEnd: function() {
	    if (lengthRing) lengthPoint$1(x00$2, y00$2);
	    lengthStream$1.point = noop$1;
	  },
	  polygonStart: function() {
	    lengthRing = true;
	  },
	  polygonEnd: function() {
	    lengthRing = null;
	  },
	  result: function() {
	    var length = +lengthSum$1;
	    lengthSum$1.reset();
	    return length;
	  }
	};
	
	function lengthPointFirst$1(x, y) {
	  lengthStream$1.point = lengthPoint$1;
	  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
	}
	
	function lengthPoint$1(x, y) {
	  x0$4 -= x, y0$4 -= y;
	  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
	  x0$4 = x, y0$4 = y;
	}
	
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _radius: 4.5,
	  _circle: circle$1(4.5),
	  pointRadius: function(_) {
	    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
	    return this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._string.push("M", x, ",", y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._string.push("L", x, ",", y);
	        break;
	      }
	      default: {
	        if (this._circle == null) this._circle = circle$1(this._radius);
	        this._string.push("M", x, ",", y, this._circle);
	        break;
	      }
	    }
	  },
	  result: function() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    } else {
	      return null;
	    }
	  }
	};
	
	function circle$1(radius) {
	  return "m0," + radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
	      + "z";
	}
	
	var index$1 = function(projection, context) {
	  var pointRadius = 4.5,
	      projectionStream,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      geoStream(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function(object) {
	    geoStream(object, projectionStream(areaStream$1));
	    return areaStream$1.result();
	  };
	
	  path.measure = function(object) {
	    geoStream(object, projectionStream(lengthStream$1));
	    return lengthStream$1.result();
	  };
	
	  path.bounds = function(object) {
	    geoStream(object, projectionStream(boundsStream$1));
	    return boundsStream$1.result();
	  };
	
	  path.centroid = function(object) {
	    geoStream(object, projectionStream(centroidStream$1));
	    return centroidStream$1.result();
	  };
	
	  path.projection = function(_) {
	    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$4) : (projection = _).stream, path) : projection;
	  };
	
	  path.context = function(_) {
	    if (!arguments.length) return context;
	    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function(_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(projection).context(context);
	};
	
	var clip = function(pointVisible, clipLine, interpolate, start) {
	  return function(rotate, sink) {
	    var line = clipLine(sink),
	        rotatedStart = rotate.invert(start[0], start[1]),
	        ringBuffer = clipBuffer(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = merge(segments);
	        var startInside = polygonContains(polygon, rotatedStart);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      var point = rotate(lambda, phi);
	      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      var point = rotate(lambda, phi);
	      line.point(point[0], point[1]);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      var point = rotate(lambda, phi);
	      ringSink.point(point[0], point[1]);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i, n = ringSegments.length, m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
	          sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	};
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - halfPi$2 - epsilon$2 : halfPi$2 - a[1])
	       - ((b = b.x)[0] < 0 ? b[1] - halfPi$2 - epsilon$2 : halfPi$2 - b[1]);
	}
	
	var clipAntimeridian = clip(
	  function() { return true; },
	  clipAntimeridianLine,
	  clipAntimeridianInterpolate,
	  [-pi$3, -halfPi$2]
	);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      clean; // no intersections
	
	  return {
	    lineStart: function() {
	      stream.lineStart();
	      clean = 1;
	    },
	    point: function(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? pi$3 : -pi$3,
	          delta = abs(lambda1 - lambda0);
	      if (abs(delta - pi$3) < epsilon$2) { // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$2 : -halfPi$2);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        clean = 0;
	      } else if (sign0 !== sign1 && delta >= pi$3) { // line crosses antimeridian
	        if (abs(lambda0 - sign0) < epsilon$2) lambda0 -= sign0 * epsilon$2; // handle degeneracies
	        if (abs(lambda1 - sign1) < epsilon$2) lambda1 -= sign1 * epsilon$2;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function() {
	      return 2 - clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
	  return abs(sinLambda0Lambda1) > epsilon$2
	      ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1)
	          - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0))
	          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
	      : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * halfPi$2;
	    stream.point(-pi$3, phi);
	    stream.point(0, phi);
	    stream.point(pi$3, phi);
	    stream.point(pi$3, 0);
	    stream.point(pi$3, -phi);
	    stream.point(0, -phi);
	    stream.point(-pi$3, -phi);
	    stream.point(-pi$3, 0);
	    stream.point(-pi$3, phi);
	  } else if (abs(from[0] - to[0]) > epsilon$2) {
	    var lambda = from[0] < to[0] ? pi$3 : -pi$3;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}
	
	var clipCircle = function(radius, delta) {
	  var cr = cos$1(radius),
	      smallRadius = cr > 0,
	      notHemisphere = abs(cr) > epsilon$2; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    circleStream(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return cos$1(lambda) * cos$1(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	        c0, // code for previous point
	        v0, // visibility of previous point
	        v00, // visibility of first point
	        clean; // no intersections
	    return {
	      lineStart: function() {
	        v00 = v0 = false;
	        clean = 1;
	      },
	      point: function(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius
	              ? v ? 0 : code(lambda, phi)
	              : v ? code(lambda + (lambda < 0 ? pi$3 : -pi$3), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) {
	            point1[0] += epsilon$2;
	            point1[1] += epsilon$2;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !pointEqual(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function() {
	        return clean | ((v00 && v0) << 1);
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = cartesian(a),
	        pb = cartesian(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0], // normal
	        n2 = cartesianCross(pa, pb),
	        n2n2 = cartesianDot(n2, n2),
	        n1n2 = n2[0], // cartesianDot(n1, n2),
	        determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 =  cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = cartesianCross(n1, n2),
	        A = cartesianScale(n1, c1),
	        B = cartesianScale(n2, c2);
	    cartesianAddInPlace(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = cartesianDot(A, u),
	        uu = cartesianDot(u, u),
	        t2 = w * w - uu * (cartesianDot(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = sqrt(t2),
	        q = cartesianScale(u, (-w - t) / uu);
	    cartesianAddInPlace(q, A);
	    q = spherical(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = abs(delta - pi$3) < epsilon$2,
	        meridian = polar || delta < epsilon$2;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian
	        ? polar
	          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon$2 ? phi0 : phi1)
	          : phi0 <= q[1] && q[1] <= phi1
	        : delta > pi$3 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = cartesianScale(u, (-w + t) / uu);
	      cartesianAddInPlace(q1, A);
	      return [q, spherical(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : pi$3 - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$3, radius - pi$3]);
	};
	
	var transform = function(methods) {
	  return {
	    stream: transformer(methods)
	  };
	};
	
	function transformer(methods) {
	  return function(stream) {
	    var s = new TransformStream;
	    for (var key in methods) s[key] = methods[key];
	    s.stream = stream;
	    return s;
	  };
	}
	
	function TransformStream() {}
	
	TransformStream.prototype = {
	  constructor: TransformStream,
	  point: function(x, y) { this.stream.point(x, y); },
	  sphere: function() { this.stream.sphere(); },
	  lineStart: function() { this.stream.lineStart(); },
	  lineEnd: function() { this.stream.lineEnd(); },
	  polygonStart: function() { this.stream.polygonStart(); },
	  polygonEnd: function() { this.stream.polygonEnd(); }
	};
	
	function fitExtent(projection, extent, object) {
	  var w = extent[1][0] - extent[0][0],
	      h = extent[1][1] - extent[0][1],
	      clip = projection.clipExtent && projection.clipExtent();
	
	  projection
	      .scale(150)
	      .translate([0, 0]);
	
	  if (clip != null) projection.clipExtent(null);
	
	  geoStream(object, projection.stream(boundsStream$1));
	
	  var b = boundsStream$1.result(),
	      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	
	  if (clip != null) projection.clipExtent(clip);
	
	  return projection
	      .scale(k * 150)
	      .translate([x, y]);
	}
	
	function fitSize(projection, size, object) {
	  return fitExtent(projection, [[0, 0], size], object);
	}
	
	var maxDepth = 16;
	var cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)
	
	var resample = function(project, delta2) {
	  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
	};
	
	function resampleNone(project) {
	  return transformer({
	    point: function(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample$1(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = sqrt(a * a + b * b + c * c),
	          phi2 = asin(c /= m),
	          lambda2 = abs(abs(c) - 1) < epsilon$2 || abs(lambda0 - lambda1) < epsilon$2 ? (lambda0 + lambda1) / 2 : atan2(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function(stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	        lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
	      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = cartesian([lambda, phi]), p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}
	
	var transformRadians = transformer({
	  point: function(x, y) {
	    this.stream.point(x * radians, y * radians);
	  }
	});
	
	function projection(project) {
	  return projectionMutator(function() { return project; })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150, // scale
	      x = 480, y = 250, // translate
	      dx, dy, lambda = 0, phi = 0, // center
	      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
	      theta = null, preclip = clipAntimeridian, // clip angle
	      x0 = null, y0, x1, y1, postclip = identity$4, // clip extent
	      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    point = projectRotate(point[0] * radians, point[1] * radians);
	    return [point[0] * k + dx, dy - point[1] * k];
	  }
	
	  function invert(point) {
	    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
	    return point && [point[0] * degrees$1, point[1] * degrees$1];
	  }
	
	  function projectTransform(x, y) {
	    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
	  }
	
	  projection.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
	  };
	
	  projection.clipAngle = function(_) {
	    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees$1;
	  };
	
	  projection.clipExtent = function(_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function(_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function(_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function(_) {
	    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees$1, phi * degrees$1];
	  };
	
	  projection.rotate = function(_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees$1, deltaPhi * degrees$1, deltaGamma * degrees$1];
	  };
	
	  projection.precision = function(_) {
	    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
	  };
	
	  projection.fitExtent = function(extent, object) {
	    return fitExtent(projection, extent, object);
	  };
	
	  projection.fitSize = function(size, object) {
	    return fitSize(projection, size, object);
	  };
	
	  function recenter() {
	    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
	    var center = project(lambda, phi);
	    dx = x - center[0] * k;
	    dy = y + center[1] * k;
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function() {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = pi$3 / 3,
	      m = projectionMutator(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function(_) {
	    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees$1, phi1 * degrees$1];
	  };
	
	  return p;
	}
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos$1(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin$1(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;
	
	  // Are the parallels symmetrical around the Equator?
	  if (abs(n) < epsilon$2) return cylindricalEqualAreaRaw(y0);
	
	  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;
	
	  function project(x, y) {
	    var r = sqrt(c - 2 * n * sin$1(y)) / n;
	    return [r * sin$1(x *= n), r0 - r * cos$1(x)];
	  }
	
	  project.invert = function(x, y) {
	    var r0y = r0 - y;
	    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}
	
	var conicEqualArea = function() {
	  return conicProjection(conicEqualAreaRaw)
	      .scale(155.424)
	      .center([0, 33.6442]);
	};
	
	var albers = function() {
	  return conicEqualArea()
	      .parallels([29.5, 45.5])
	      .scale(1070)
	      .translate([480, 250])
	      .rotate([96, 0])
	      .center([-0.6, 38.7]);
	};
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
	    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
	    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
	    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
	    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
	    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
	var albersUsa = function() {
	  var cache,
	      cacheStream,
	      lower48 = albers(), lower48Point,
	      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
	      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
	      point, pointStream = {point: function(x, y) { point = [x, y]; }};
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0], y = coordinates[1];
	    return point = null,
	        (lower48Point.point(x, y), point)
	        || (alaskaPoint.point(x, y), point)
	        || (hawaiiPoint.point(x, y), point);
	  }
	
	  albersUsa.invert = function(coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
	        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
	        : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function(_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function(_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function(_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(), x = +_[0], y = +_[1];
	
	    lower48Point = lower48
	        .translate(_)
	        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
	        .stream(pointStream);
	
	    alaskaPoint = alaska
	        .translate([x - 0.307 * k, y + 0.201 * k])
	        .clipExtent([[x - 0.425 * k + epsilon$2, y + 0.120 * k + epsilon$2], [x - 0.214 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
	        .stream(pointStream);
	
	    hawaiiPoint = hawaii
	        .translate([x - 0.205 * k, y + 0.212 * k])
	        .clipExtent([[x - 0.214 * k + epsilon$2, y + 0.166 * k + epsilon$2], [x - 0.115 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
	        .stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = function(extent, object) {
	    return fitExtent(albersUsa, extent, object);
	  };
	
	  albersUsa.fitSize = function(size, object) {
	    return fitSize(albersUsa, size, object);
	  };
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	};
	
	function azimuthalRaw(scale) {
	  return function(x, y) {
	    var cx = cos$1(x),
	        cy = cos$1(y),
	        k = scale(cx * cy);
	    return [
	      k * cy * sin$1(x),
	      k * sin$1(y)
	    ];
	  }
	}
	
	function azimuthalInvert(angle) {
	  return function(x, y) {
	    var z = sqrt(x * x + y * y),
	        c = angle(z),
	        sc = sin$1(c),
	        cc = cos$1(c);
	    return [
	      atan2(x * sc, z * cc),
	      asin(z && y * sc / z)
	    ];
	  }
	}
	
	var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
	  return sqrt(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
	  return 2 * asin(z / 2);
	});
	
	var azimuthalEqualArea = function() {
	  return projection(azimuthalEqualAreaRaw)
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	};
	
	var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
	  return (c = acos(c)) && c / sin$1(c);
	});
	
	azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
	  return z;
	});
	
	var azimuthalEquidistant = function() {
	  return projection(azimuthalEquidistantRaw)
	      .scale(79.4188)
	      .clipAngle(180 - 1e-3);
	};
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, log(tan((halfPi$2 + phi) / 2))];
	}
	
	mercatorRaw.invert = function(x, y) {
	  return [x, 2 * atan(exp(y)) - halfPi$2];
	};
	
	var mercator = function() {
	  return mercatorProjection(mercatorRaw)
	      .scale(961 / tau$3);
	};
	
	function mercatorProjection(project) {
	  var m = projection(project),
	      center = m.center,
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      x0 = null, y0, x1, y1; // clip extent
	
	  m.scale = function(_) {
	    return arguments.length ? (scale(_), reclip()) : scale();
	  };
	
	  m.translate = function(_) {
	    return arguments.length ? (translate(_), reclip()) : translate();
	  };
	
	  m.center = function(_) {
	    return arguments.length ? (center(_), reclip()) : center();
	  };
	
	  m.clipExtent = function(_) {
	    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  function reclip() {
	    var k = pi$3 * scale(),
	        t = m(rotation(m.rotate()).invert([0, 0]));
	    return clipExtent(x0 == null
	        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
	        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
	        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
	  }
	
	  return reclip();
	}
	
	function tany(y) {
	  return tan((halfPi$2 + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = cos$1(y0),
	      n = y0 === y1 ? sin$1(y0) : log(cy0 / cos$1(y1)) / log(tany(y1) / tany(y0)),
	      f = cy0 * pow(tany(y0), n) / n;
	
	  if (!n) return mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) { if (y < -halfPi$2 + epsilon$2) y = -halfPi$2 + epsilon$2; }
	    else { if (y > halfPi$2 - epsilon$2) y = halfPi$2 - epsilon$2; }
	    var r = f / pow(tany(y), n);
	    return [r * sin$1(n * x), f - r * cos$1(n * x)];
	  }
	
	  project.invert = function(x, y) {
	    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
	    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi$2];
	  };
	
	  return project;
	}
	
	var conicConformal = function() {
	  return conicProjection(conicConformalRaw)
	      .scale(109.5)
	      .parallels([30, 30]);
	};
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;
	
	var equirectangular = function() {
	  return projection(equirectangularRaw)
	      .scale(152.63);
	};
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = cos$1(y0),
	      n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if (abs(n) < epsilon$2) return equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y, nx = n * x;
	    return [gy * sin$1(nx), g - gy * cos$1(nx)];
	  }
	
	  project.invert = function(x, y) {
	    var gy = g - y;
	    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
	  };
	
	  return project;
	}
	
	var conicEquidistant = function() {
	  return conicProjection(conicEquidistantRaw)
	      .scale(131.154)
	      .center([0, 13.9389]);
	};
	
	function gnomonicRaw(x, y) {
	  var cy = cos$1(y), k = cos$1(x) * cy;
	  return [cy * sin$1(x) / k, sin$1(y) / k];
	}
	
	gnomonicRaw.invert = azimuthalInvert(atan);
	
	var gnomonic = function() {
	  return projection(gnomonicRaw)
	      .scale(144.049)
	      .clipAngle(60);
	};
	
	function scaleTranslate(kx, ky, tx, ty) {
	  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity$4 : transformer({
	    point: function(x, y) {
	      this.stream.point(x * kx + tx, y * ky + ty);
	    }
	  });
	}
	
	var identity$5 = function() {
	  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform$$1 = identity$4, // scale, translate and reflect
	      x0 = null, y0, x1, y1, clip = identity$4, // clip extent
	      cache,
	      cacheStream,
	      projection;
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return projection = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = transform$$1(clip(cacheStream = stream));
	    },
	    clipExtent: function(_) {
	      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	    },
	    scale: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
	    },
	    translate: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
	    },
	    reflectX: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
	    },
	    reflectY: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
	    },
	    fitExtent: function(extent, object) {
	      return fitExtent(projection, extent, object);
	    },
	    fitSize: function(size, object) {
	      return fitSize(projection, size, object);
	    }
	  };
	};
	
	function orthographicRaw(x, y) {
	  return [cos$1(y) * sin$1(x), sin$1(y)];
	}
	
	orthographicRaw.invert = azimuthalInvert(asin);
	
	var orthographic = function() {
	  return projection(orthographicRaw)
	      .scale(249.5)
	      .clipAngle(90 + epsilon$2);
	};
	
	function stereographicRaw(x, y) {
	  var cy = cos$1(y), k = 1 + cos$1(x) * cy;
	  return [cy * sin$1(x) / k, sin$1(y) / k];
	}
	
	stereographicRaw.invert = azimuthalInvert(function(z) {
	  return 2 * atan(z);
	});
	
	var stereographic = function() {
	  return projection(stereographicRaw)
	      .scale(250)
	      .clipAngle(142);
	};
	
	function transverseMercatorRaw(lambda, phi) {
	  return [log(tan((halfPi$2 + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function(x, y) {
	  return [-y, 2 * atan(exp(x)) - halfPi$2];
	};
	
	var transverseMercator = function() {
	  var m = mercatorProjection(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function(_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function(_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90])
	      .scale(159.155);
	};
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	var cluster = function() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	};
	
	function count(node) {
	  var sum = 0,
	      children = node.children,
	      i = children && children.length;
	  if (!i) sum = 1;
	  else while (--i >= 0) sum += children[i].value;
	  node.value = sum;
	}
	
	var node_count = function() {
	  return this.eachAfter(count);
	};
	
	var node_each = function(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	};
	
	var node_eachBefore = function(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	};
	
	var node_eachAfter = function(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	};
	
	var node_sum = function(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	};
	
	var node_sort = function(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	};
	
	var node_path = function(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	};
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	var node_ancestors = function() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	};
	
	var node_descendants = function() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	};
	
	var node_leaves = function() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	};
	
	var node_links = function() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	};
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  count: node_count,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	var slice$3 = Array.prototype.slice;
	
	function shuffle$1(array) {
	  var m = array.length,
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m];
	    array[m] = array[i];
	    array[i] = t;
	  }
	
	  return array;
	}
	
	var enclose = function(circles) {
	  var i = 0, n = (circles = shuffle$1(slice$3.call(circles))).length, B = [], p, e;
	
	  while (i < n) {
	    p = circles[i];
	    if (e && enclosesWeak(e, p)) ++i;
	    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
	  }
	
	  return e;
	};
	
	function extendBasis(B, p) {
	  var i, j;
	
	  if (enclosesWeakAll(p, B)) return [p];
	
	  // If we get here then B must have at least one element.
	  for (i = 0; i < B.length; ++i) {
	    if (enclosesNot(p, B[i])
	        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
	      return [B[i], p];
	    }
	  }
	
	  // If we get here then B must have at least two elements.
	  for (i = 0; i < B.length - 1; ++i) {
	    for (j = i + 1; j < B.length; ++j) {
	      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
	          && enclosesNot(encloseBasis2(B[i], p), B[j])
	          && enclosesNot(encloseBasis2(B[j], p), B[i])
	          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
	        return [B[i], B[j], p];
	      }
	    }
	  }
	
	  // If we get here then something is very wrong.
	  throw new Error;
	}
	
	function enclosesNot(a, b) {
	  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
	  return dr < 0 || dr * dr < dx * dx + dy * dy;
	}
	
	function enclosesWeak(a, b) {
	  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function enclosesWeakAll(a, B) {
	  for (var i = 0; i < B.length; ++i) {
	    if (!enclosesWeak(a, B[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function encloseBasis(B) {
	  switch (B.length) {
	    case 1: return encloseBasis1(B[0]);
	    case 2: return encloseBasis2(B[0], B[1]);
	    case 3: return encloseBasis3(B[0], B[1], B[2]);
	  }
	}
	
	function encloseBasis1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function encloseBasis2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function encloseBasis3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = x1 - x2,
	      a3 = x1 - x3,
	      b2 = y1 - y2,
	      b3 = y1 - y3,
	      c2 = r2 - r1,
	      c3 = r3 - r1,
	      d1 = x1 * x1 + y1 * y1 - r1 * r1,
	      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
	      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (r1 + xa * xb + ya * yb),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
	  return {
	    x: x1 + xa + xb * r,
	    y: y1 + ya + yb * r,
	    r: r
	  };
	}
	
	function place(a, b, c) {
	  var ax = a.x,
	      ay = a.y,
	      da = b.r + c.r,
	      db = a.r + c.r,
	      dx = b.x - ax,
	      dy = b.y - ay,
	      dc = dx * dx + dy * dy;
	  if (dc) {
	    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
	        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	    c.x = ax + x * dx + y * dy;
	    c.y = ay + x * dy - y * dx;
	  } else {
	    c.x = ax + db;
	    c.y = ay;
	  }
	}
	
	function intersects(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r + b.r;
	  return dr * dr - 1e-6 > dx * dx + dy * dy;
	}
	
	function score(node) {
	  var a = node._,
	      b = node.next._,
	      ab = a.r + b.r,
	      dx = (a.x * b.r + b.x * a.r) / ab,
	      dy = (a.y * b.r + b.y * a.r) / ab;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n, aa, ca, i, j, k, sj, sk;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    // “Closeness” is determined by linear distance along the front-chain.
	    // “Ahead” or “behind” is likewise determined by linear distance.
	    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
	    do {
	      if (sj <= sk) {
	        if (intersects(j._, c._)) {
	          b = j, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sj += j._.r, j = j.next;
	      } else {
	        if (intersects(k._, c._)) {
	          a = k, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sk += k._.r, k = k.previous;
	      }
	    } while (j !== k.next);
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Compute the new closest circle pair to the centroid.
	    aa = score(a);
	    while ((c = c.next) !== b) {
	      if ((ca = score(c)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	var siblings = function(circles) {
	  packEnclose(circles);
	  return circles;
	};
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	var constant$8 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultRadius$1(d) {
	  return Math.sqrt(d.value);
	}
	
	var index$2 = function() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius$1))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant$8(+x), pack) : padding;
	  };
	
	  return pack;
	};
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	var roundNode = function(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	};
	
	var treemapDice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	};
	
	var partition = function() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	};
	
	var keyPrefix$1 = "$";
	var preroot = {depth: -1};
	var ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	var stratify = function() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix$1 + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix$1 + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	};
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	var tree = function() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	};
	
	var treemapSlice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	};
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = (function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	})(phi);
	
	var index$3 = function() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$8(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$8(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$8(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$8(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$8(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	};
	
	var binary = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((x1 - x0) > (y1 - y0)) {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    } else {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    }
	  }
	};
	
	var sliceDice = function(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	};
	
	var resquarify = (function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	})(phi);
	
	var area$1 = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      a,
	      b = polygon[n - 1],
	      area = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    area += a[1] * b[0] - a[0] * b[1];
	  }
	
	  return area / 2;
	};
	
	var centroid$1 = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      x = 0,
	      y = 0,
	      a,
	      b = polygon[n - 1],
	      c,
	      k = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    k += c = a[0] * b[1] - b[0] * a[1];
	    x += (a[0] + b[0]) * c;
	    y += (a[1] + b[1]) * c;
	  }
	
	  return k *= 3, [x / k, y / k];
	};
	
	// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
	// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
	// right, +y is up). Returns a positive value if ABC is counter-clockwise,
	// negative if clockwise, and zero if the points are collinear.
	var cross$1 = function(a, b, c) {
	  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	};
	
	function lexicographicOrder(a, b) {
	  return a[0] - b[0] || a[1] - b[1];
	}
	
	// Computes the upper convex hull per the monotone chain algorithm.
	// Assumes points.length >= 3, is sorted by x, unique in y.
	// Returns an array of indices into points in left-to-right order.
	function computeUpperHullIndexes(points) {
	  var n = points.length,
	      indexes = [0, 1],
	      size = 2;
	
	  for (var i = 2; i < n; ++i) {
	    while (size > 1 && cross$1(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
	    indexes[size++] = i;
	  }
	
	  return indexes.slice(0, size); // remove popped points
	}
	
	var hull = function(points) {
	  if ((n = points.length) < 3) return null;
	
	  var i,
	      n,
	      sortedPoints = new Array(n),
	      flippedPoints = new Array(n);
	
	  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
	  sortedPoints.sort(lexicographicOrder);
	  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];
	
	  var upperIndexes = computeUpperHullIndexes(sortedPoints),
	      lowerIndexes = computeUpperHullIndexes(flippedPoints);
	
	  // Construct the hull polygon, removing possible duplicate endpoints.
	  var skipLeft = lowerIndexes[0] === upperIndexes[0],
	      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
	      hull = [];
	
	  // Add upper hull in right-to-l order.
	  // Then add lower hull in left-to-right order.
	  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
	  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
	
	  return hull;
	};
	
	var contains$1 = function(polygon, point) {
	  var n = polygon.length,
	      p = polygon[n - 1],
	      x = point[0], y = point[1],
	      x0 = p[0], y0 = p[1],
	      x1, y1,
	      inside = false;
	
	  for (var i = 0; i < n; ++i) {
	    p = polygon[i], x1 = p[0], y1 = p[1];
	    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
	    x0 = x1, y0 = y1;
	  }
	
	  return inside;
	};
	
	var length$2 = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      b = polygon[n - 1],
	      xa,
	      ya,
	      xb = b[0],
	      yb = b[1],
	      perimeter = 0;
	
	  while (++i < n) {
	    xa = xb;
	    ya = yb;
	    b = polygon[i];
	    xb = b[0];
	    yb = b[1];
	    xa -= xb;
	    ya -= yb;
	    perimeter += Math.sqrt(xa * xa + ya * ya);
	  }
	
	  return perimeter;
	};
	
	var slice$4 = [].slice;
	
	var noabort = {};
	
	function Queue(size) {
	  this._size = size;
	  this._call =
	  this._error = null;
	  this._tasks = [];
	  this._data = [];
	  this._waiting =
	  this._active =
	  this._ended =
	  this._start = 0; // inside a synchronous task callback?
	}
	
	Queue.prototype = queue.prototype = {
	  constructor: Queue,
	  defer: function(callback) {
	    if (typeof callback !== "function") throw new Error("invalid callback");
	    if (this._call) throw new Error("defer after await");
	    if (this._error != null) return this;
	    var t = slice$4.call(arguments, 1);
	    t.push(callback);
	    ++this._waiting, this._tasks.push(t);
	    poke$1(this);
	    return this;
	  },
	  abort: function() {
	    if (this._error == null) abort(this, new Error("abort"));
	    return this;
	  },
	  await: function(callback) {
	    if (typeof callback !== "function") throw new Error("invalid callback");
	    if (this._call) throw new Error("multiple await");
	    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
	    maybeNotify(this);
	    return this;
	  },
	  awaitAll: function(callback) {
	    if (typeof callback !== "function") throw new Error("invalid callback");
	    if (this._call) throw new Error("multiple await");
	    this._call = callback;
	    maybeNotify(this);
	    return this;
	  }
	};
	
	function poke$1(q) {
	  if (!q._start) {
	    try { start$1(q); } // let the current task complete
	    catch (e) {
	      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
	      else if (!q._data) throw e; // await callback errored synchronously
	    }
	  }
	}
	
	function start$1(q) {
	  while (q._start = q._waiting && q._active < q._size) {
	    var i = q._ended + q._active,
	        t = q._tasks[i],
	        j = t.length - 1,
	        c = t[j];
	    t[j] = end(q, i);
	    --q._waiting, ++q._active;
	    t = c.apply(null, t);
	    if (!q._tasks[i]) continue; // task finished synchronously
	    q._tasks[i] = t || noabort;
	  }
	}
	
	function end(q, i) {
	  return function(e, r) {
	    if (!q._tasks[i]) return; // ignore multiple callbacks
	    --q._active, ++q._ended;
	    q._tasks[i] = null;
	    if (q._error != null) return; // ignore secondary errors
	    if (e != null) {
	      abort(q, e);
	    } else {
	      q._data[i] = r;
	      if (q._waiting) poke$1(q);
	      else maybeNotify(q);
	    }
	  };
	}
	
	function abort(q, e) {
	  var i = q._tasks.length, t;
	  q._error = e; // ignore active callbacks
	  q._data = undefined; // allow gc
	  q._waiting = NaN; // prevent starting
	
	  while (--i >= 0) {
	    if (t = q._tasks[i]) {
	      q._tasks[i] = null;
	      if (t.abort) {
	        try { t.abort(); }
	        catch (e) { /* ignore */ }
	      }
	    }
	  }
	
	  q._active = NaN; // allow notification
	  maybeNotify(q);
	}
	
	function maybeNotify(q) {
	  if (!q._active && q._call) {
	    var d = q._data;
	    q._data = undefined; // allow gc
	    q._call(q._error, d);
	  }
	}
	
	function queue(concurrency) {
	  if (concurrency == null) concurrency = Infinity;
	  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
	  return new Queue(concurrency);
	}
	
	var defaultSource$1 = function() {
	  return Math.random();
	};
	
	var uniform = (function sourceRandomUniform(source) {
	  function randomUniform(min, max) {
	    min = min == null ? 0 : +min;
	    max = max == null ? 1 : +max;
	    if (arguments.length === 1) max = min, min = 0;
	    else max -= min;
	    return function() {
	      return source() * max + min;
	    };
	  }
	
	  randomUniform.source = sourceRandomUniform;
	
	  return randomUniform;
	})(defaultSource$1);
	
	var normal = (function sourceRandomNormal(source) {
	  function randomNormal(mu, sigma) {
	    var x, r;
	    mu = mu == null ? 0 : +mu;
	    sigma = sigma == null ? 1 : +sigma;
	    return function() {
	      var y;
	
	      // If available, use the second previously-generated uniform random.
	      if (x != null) y = x, x = null;
	
	      // Otherwise, generate a new x and y.
	      else do {
	        x = source() * 2 - 1;
	        y = source() * 2 - 1;
	        r = x * x + y * y;
	      } while (!r || r > 1);
	
	      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
	    };
	  }
	
	  randomNormal.source = sourceRandomNormal;
	
	  return randomNormal;
	})(defaultSource$1);
	
	var logNormal = (function sourceRandomLogNormal(source) {
	  function randomLogNormal() {
	    var randomNormal = normal.source(source).apply(this, arguments);
	    return function() {
	      return Math.exp(randomNormal());
	    };
	  }
	
	  randomLogNormal.source = sourceRandomLogNormal;
	
	  return randomLogNormal;
	})(defaultSource$1);
	
	var irwinHall = (function sourceRandomIrwinHall(source) {
	  function randomIrwinHall(n) {
	    return function() {
	      for (var sum = 0, i = 0; i < n; ++i) sum += source();
	      return sum;
	    };
	  }
	
	  randomIrwinHall.source = sourceRandomIrwinHall;
	
	  return randomIrwinHall;
	})(defaultSource$1);
	
	var bates = (function sourceRandomBates(source) {
	  function randomBates(n) {
	    var randomIrwinHall = irwinHall.source(source)(n);
	    return function() {
	      return randomIrwinHall() / n;
	    };
	  }
	
	  randomBates.source = sourceRandomBates;
	
	  return randomBates;
	})(defaultSource$1);
	
	var exponential$1 = (function sourceRandomExponential(source) {
	  function randomExponential(lambda) {
	    return function() {
	      return -Math.log(1 - source()) / lambda;
	    };
	  }
	
	  randomExponential.source = sourceRandomExponential;
	
	  return randomExponential;
	})(defaultSource$1);
	
	var request = function(url, callback) {
	  var request,
	      event = dispatch("beforesend", "progress", "load", "error"),
	      mimeType,
	      headers = map$1(),
	      xhr = new XMLHttpRequest,
	      user = null,
	      password = null,
	      response,
	      responseType,
	      timeout = 0;
	
	  // If IE does not support CORS, use XDomainRequest.
	  if (typeof XDomainRequest !== "undefined"
	      && !("withCredentials" in xhr)
	      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;
	
	  "onload" in xhr
	      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
	      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };
	
	  function respond(o) {
	    var status = xhr.status, result;
	    if (!status && hasResponse(xhr)
	        || status >= 200 && status < 300
	        || status === 304) {
	      if (response) {
	        try {
	          result = response.call(request, xhr);
	        } catch (e) {
	          event.call("error", request, e);
	          return;
	        }
	      } else {
	        result = xhr;
	      }
	      event.call("load", request, result);
	    } else {
	      event.call("error", request, o);
	    }
	  }
	
	  xhr.onprogress = function(e) {
	    event.call("progress", request, e);
	  };
	
	  request = {
	    header: function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers.get(name);
	      if (value == null) headers.remove(name);
	      else headers.set(name, value + "");
	      return request;
	    },
	
	    // If mimeType is non-null and no Accept header is set, a default is used.
	    mimeType: function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return request;
	    },
	
	    // Specifies what type the response value should take;
	    // for instance, arraybuffer, blob, document, or text.
	    responseType: function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return request;
	    },
	
	    timeout: function(value) {
	      if (!arguments.length) return timeout;
	      timeout = +value;
	      return request;
	    },
	
	    user: function(value) {
	      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
	    },
	
	    password: function(value) {
	      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
	    },
	
	    // Specify how to convert the response content to a specific type;
	    // changes the callback value on "load" events.
	    response: function(value) {
	      response = value;
	      return request;
	    },
	
	    // Alias for send("GET", …).
	    get: function(data, callback) {
	      return request.send("GET", data, callback);
	    },
	
	    // Alias for send("POST", …).
	    post: function(data, callback) {
	      return request.send("POST", data, callback);
	    },
	
	    // If callback is non-null, it will be used for error and load events.
	    send: function(method, data, callback) {
	      xhr.open(method, url, true, user, password);
	      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
	      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
	      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
	      if (responseType != null) xhr.responseType = responseType;
	      if (timeout > 0) xhr.timeout = timeout;
	      if (callback == null && typeof data === "function") callback = data, data = null;
	      if (callback != null && callback.length === 1) callback = fixCallback(callback);
	      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
	      event.call("beforesend", request, xhr);
	      xhr.send(data == null ? null : data);
	      return request;
	    },
	
	    abort: function() {
	      xhr.abort();
	      return request;
	    },
	
	    on: function() {
	      var value = event.on.apply(event, arguments);
	      return value === event ? request : value;
	    }
	  };
	
	  if (callback != null) {
	    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    return request.get(callback);
	  }
	
	  return request;
	};
	
	function fixCallback(callback) {
	  return function(error, xhr) {
	    callback(error == null ? xhr : null);
	  };
	}
	
	function hasResponse(xhr) {
	  var type = xhr.responseType;
	  return type && type !== "text"
	      ? xhr.response // null on error
	      : xhr.responseText; // "" on error
	}
	
	var type$1 = function(defaultMimeType, response) {
	  return function(url, callback) {
	    var r = request(url).mimeType(defaultMimeType).response(response);
	    if (callback != null) {
	      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	      return r.get(callback);
	    }
	    return r;
	  };
	};
	
	var html = type$1("text/html", function(xhr) {
	  return document.createRange().createContextualFragment(xhr.responseText);
	});
	
	var json = type$1("application/json", function(xhr) {
	  return JSON.parse(xhr.responseText);
	});
	
	var text = type$1("text/plain", function(xhr) {
	  return xhr.responseText;
	});
	
	var xml = type$1("application/xml", function(xhr) {
	  var xml = xhr.responseXML;
	  if (!xml) throw new Error("parse error");
	  return xml;
	});
	
	var dsv$1 = function(defaultMimeType, parse) {
	  return function(url, row, callback) {
	    if (arguments.length < 3) callback = row, row = null;
	    var r = request(url).mimeType(defaultMimeType);
	    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
	    r.row(row);
	    return callback ? r.get(callback) : r;
	  };
	};
	
	function responseOf(parse, row) {
	  return function(request$$1) {
	    return parse(request$$1.responseText, row);
	  };
	}
	
	var csv$1 = dsv$1("text/csv", csvParse);
	
	var tsv$1 = dsv$1("text/tab-separated-values", tsvParse);
	
	var array$2 = Array.prototype;
	
	var map$3 = array$2.map;
	var slice$5 = array$2.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range) {
	  var index = map$1(),
	      domain = [],
	      unknown = implicit;
	
	  range = range == null ? [] : slice$5.call(range);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = map$1();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice$5.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range[1] < range[0],
	        start = range[reverse - 0],
	        stop = range[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = sequence(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point$1() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant$9 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number$2 = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant$9(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate$$1) {
	  return function(a, b) {
	    var r = reinterpolate$$1(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range, deinterpolate, reinterpolate$$1) {
	  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate$$1(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate$$1(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range, deinterpolate, reinterpolate$$1) {
	  var j = Math.min(domain.length, range.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range = range.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate$$1(range[i], range[i + 1]);
	  }
	
	  return function(x) {
	    var i = bisectRight(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate$$1) {
	  var domain = unit,
	      range = unit,
	      interpolate = interpolateValue,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate$$1) : reinterpolate$$1)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$3.call(_, number$2), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice$5.call(_), rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = slice$5.call(_), interpolate = interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate = _, rescale()) : interpolate;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
	      return exports.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return exports.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear$2() {
	  var scale = continuous(deinterpolateLinear, reinterpolate);
	
	  scale.copy = function() {
	    return copy(scale, linear$2());
	  };
	
	  return linearish(scale);
	}
	
	function identity$6() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$3.call(_, number$2), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity$6().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant$9(b);
	}
	
	function reinterpolate$1(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log$1() {
	  var scale = continuous(deinterpolate, reinterpolate$1).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = exports.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log$1().base(base));
	  };
	
	  return scale;
	}
	
	function raise$1(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow$1() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise$1(b, exponent) - (a = raise$1(a, exponent)))
	        ? function(x) { return (raise$1(x, exponent) - a) / b; }
	        : constant$9(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise$1(b, exponent) - (a = raise$1(a, exponent));
	    return function(t) { return raise$1(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow$1().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt$1() {
	  return pow$1().exponent(0.5);
	}
	
	function quantile() {
	  var domain = [],
	      range = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = threshold(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range[bisectRight(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice$5.call(_), rescale()) : range.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile()
	        .domain(domain)
	        .range(range);
	  };
	
	  return scale;
	}
	
	function quantize$1() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range[bisectRight(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range = slice$5.call(_)).length - 1, rescale()) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize$1()
	        .domain([x0, x1])
	        .range(range);
	  };
	
	  return linearish(scale);
	}
	
	function threshold$1() {
	  var domain = [0.5],
	      range = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range[bisectRight(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice$5.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice$5.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold$1()
	        .domain(domain)
	        .range(range);
	  };
	
	  return scale;
	}
	
	var t0$1 = new Date;
	var t1$1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0$1.setTime(+start), t1$1.setTime(+end);
	      floori(t0$1), floori(t1$1);
	      return Math.floor(count(t0$1, t1$1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond$1 = 1e3;
	var durationMinute$1 = 6e4;
	var durationHour$1 = 36e5;
	var durationDay$1 = 864e5;
	var durationWeek$1 = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond$1) * durationSecond$1);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond$1);
	}, function(start, end) {
	  return (end - start) / durationSecond$1;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute$1) * durationMinute$1);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute$1);
	}, function(start, end) {
	  return (end - start) / durationMinute$1;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute$1 % durationHour$1;
	  if (offset < 0) offset += durationHour$1;
	  date.setTime(Math.floor((+date - offset) / durationHour$1) * durationHour$1 + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour$1);
	}, function(start, end) {
	  return (end - start) / durationHour$1;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationDay$1;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute$1);
	}, function(start, end) {
	  return (end - start) / durationMinute$1;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour$1);
	}, function(start, end) {
	  return (end - start) / durationHour$1;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay$1;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek$1;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale$1(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day$$1 = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$$1 + 5) % 7 : d.w + d.U * 7 - (day$$1 + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + day.count(year(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(sunday.count(year(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(monday.count(year(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(utcSunday.count(utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(utcMonday.count(utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$2;
	
	
	
	
	
	defaultLocale$1({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale$1(definition) {
	  locale$2 = formatLocale$1(definition);
	  exports.timeFormat = locale$2.format;
	  exports.timeParse = locale$2.parse;
	  exports.utcFormat = locale$2.utcFormat;
	  exports.utcParse = locale$2.utcParse;
	  return locale$2;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date$1(t) {
	  return new Date(t);
	}
	
	function number$3(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format) {
	  var scale = continuous(deinterpolateLinear, reinterpolate),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [
	    [second$$1,  1,      durationSecond],
	    [second$$1,  5,  5 * durationSecond],
	    [second$$1, 15, 15 * durationSecond],
	    [second$$1, 30, 30 * durationSecond],
	    [minute$$1,  1,      durationMinute],
	    [minute$$1,  5,  5 * durationMinute],
	    [minute$$1, 15, 15 * durationMinute],
	    [minute$$1, 30, 30 * durationMinute],
	    [  hour$$1,  1,      durationHour  ],
	    [  hour$$1,  3,  3 * durationHour  ],
	    [  hour$$1,  6,  6 * durationHour  ],
	    [  hour$$1, 12, 12 * durationHour  ],
	    [   day$$1,  1,      durationDay   ],
	    [   day$$1,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month$$1,  1,      durationMonth ],
	    [ month$$1,  3,  3 * durationMonth ],
	    [  year$$1,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date$$1) {
	    return (second$$1(date$$1) < date$$1 ? formatMillisecond
	        : minute$$1(date$$1) < date$$1 ? formatSecond
	        : hour$$1(date$$1) < date$$1 ? formatMinute
	        : day$$1(date$$1) < date$$1 ? formatHour
	        : month$$1(date$$1) < date$$1 ? (week(date$$1) < date$$1 ? formatDay : formatWeek)
	        : year$$1(date$$1) < date$$1 ? formatMonth
	        : formatYear)(date$$1);
	  }
	
	  function tickInterval(interval$$1, start, stop, step) {
	    if (interval$$1 == null) interval$$1 = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval$$1 === "number") {
	      var target = Math.abs(stop - start) / interval$$1,
	          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = tickStep(start / durationYear, stop / durationYear, interval$$1);
	        interval$$1 = year$$1;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval$$1 = i[0];
	      } else {
	        step = tickStep(start, stop, interval$$1);
	        interval$$1 = millisecond$$1;
	      }
	    }
	
	    return step == null ? interval$$1 : interval$$1.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$3.call(_, number$3)) : domain().map(date$1);
	  };
	
	  scale.ticks = function(interval$$1, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval$$1, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function(interval$$1, step) {
	    var d = domain();
	    return (interval$$1 = tickInterval(interval$$1, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval$$1))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(year, month, sunday, day, hour, minute, second, millisecond, exports.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, exports.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$3 = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));
	
	var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
	
	var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
	
	var rainbow = cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	var constant$10 = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var abs$1 = Math.abs;
	var atan2$1 = Math.atan2;
	var cos$2 = Math.cos;
	var max$2 = Math.max;
	var min$1 = Math.min;
	var sin$2 = Math.sin;
	var sqrt$2 = Math.sqrt;
	
	var epsilon$3 = 1e-12;
	var pi$4 = Math.PI;
	var halfPi$3 = pi$4 / 2;
	var tau$4 = 2 * pi$4;
	
	function acos$1(x) {
	  return x > 1 ? 0 : x < -1 ? pi$4 : Math.acos(x);
	}
	
	function asin$1(x) {
	  return x >= 1 ? halfPi$3 : x <= -1 ? -halfPi$3 : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt$2(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt$2(max$2(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant$10(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi$3,
	        a1 = endAngle.apply(this, arguments) - halfPi$3,
	        da = abs$1(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon$3)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau$4 - epsilon$3) {
	      context.moveTo(r1 * cos$2(a0), r1 * sin$2(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon$3) {
	        context.moveTo(r0 * cos$2(a1), r0 * sin$2(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon$3) && (padRadius ? +padRadius.apply(this, arguments) : sqrt$2(r0 * r0 + r1 * r1)),
	          rc = min$1(abs$1(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon$3) {
	        var p0 = asin$1(rp / r0 * sin$2(ap)),
	            p1 = asin$1(rp / r1 * sin$2(ap));
	        if ((da0 -= p0 * 2) > epsilon$3) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon$3) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos$2(a01),
	          y01 = r1 * sin$2(a01),
	          x10 = r0 * cos$2(a10),
	          y10 = r0 * sin$2(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon$3) {
	        var x11 = r1 * cos$2(a11),
	            y11 = r1 * sin$2(a11),
	            x00 = r0 * cos$2(a00),
	            y00 = r0 * sin$2(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi$4) {
	          var oc = da0 > epsilon$3 ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin$2(acos$1((ax * bx + ay * by) / (sqrt$2(ax * ax + ay * ay) * sqrt$2(bx * bx + by * by))) / 2),
	              lc = sqrt$2(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min$1(rc, (r0 - lc) / (kc - 1));
	          rc1 = min$1(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon$3)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon$3) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon$3) || !(da0 > epsilon$3)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon$3) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$4 / 2;
	    return [cos$2(a) * r, sin$2(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x$3(p) {
	  return p[0];
	}
	
	function y$3(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x = x$3,
	      y = y$3,
	      defined = constant$10(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant$10(+_), line) : x;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant$10(+_), line) : y;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$10(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area$2 = function() {
	  var x0 = x$3,
	      x1 = null,
	      y0 = constant$10(0),
	      y1 = y$3,
	      defined = constant$10(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$10(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$10(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$10(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$10(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$10(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending$1 = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity$7 = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity$7,
	      sortValues = descending$1,
	      sort = null,
	      startAngle = constant$10(0),
	      endAngle = constant$10(tau$4),
	      padAngle = constant$10(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau$4, Math.max(-tau$4, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$10(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var lineRadial$1 = function() {
	  return lineRadial(line().curve(curveRadialLinear));
	};
	
	var areaRadial = function() {
	  var a = area$2().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var pointRadial = function(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};
	
	var slice$6 = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link$2(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x = x$3,
	      y = y$3,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice$6.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = path();
	    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant$10(+_), link) : x;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant$10(+_), link) : y;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link$2(curveHorizontal);
	}
	
	function linkVertical() {
	  return link$2(curveVertical);
	}
	
	function linkRadial() {
	  var l = link$2(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle$2 = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi$4);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau$4);
	  }
	};
	
	var cross$2 = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi$4 / 10) / Math.sin(7 * pi$4 / 10);
	var kx = Math.sin(tau$4 / 10) * kr;
	var ky = -Math.cos(tau$4 / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau$4 * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle$2,
	  cross$2,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant$10(circle$2),
	      size = constant$10(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant$10(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant$10(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop$2 = function() {};
	
	function point$2(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point$2(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point$2(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis$2 = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop$2,
	  areaEnd: noop$2,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point$2(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed$1 = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$3(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$3(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$3(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop$2,
	  areaEnd: noop$2,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$3(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal$$1(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal$$1.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal$$1;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$3(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal$$1(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal$$1.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal$$1;
	})(0);
	
	function point$4(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon$3) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon$3) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$4(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop$2,
	  areaEnd: noop$2,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$4(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom$$1(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom$$1.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom$$1;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$4(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom$$1(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom$$1.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom$$1;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop$2,
	  areaEnd: noop$2,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign$1(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign$1(s0) + sign$1(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$5(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$5(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$5(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$5(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var none$1 = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$2 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant$10([]),
	      order = none$2,
	      offset = none$1,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$10(slice$6.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$10(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$2 : typeof _ === "function" ? _ : constant$10(slice$6.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none$1(series, order);
	};
	
	var diverging = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none$1(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none$1(series, order);
	};
	
	var ascending$2 = function(series) {
	  var sums = series.map(sum$2);
	  return none$2(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum$2(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$2 = function(series) {
	  return ascending$2(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum$2),
	      order = none$2(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$2(series).reverse();
	};
	
	var constant$11 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function x$4(d) {
	  return d[0];
	}
	
	function y$4(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon$4
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon$4)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon$4 || Math.abs(endY - startY) > epsilon$4) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon$4 && y1 - endY > epsilon$4 ? [x0, Math.abs(startX - x0) < epsilon$4 ? startY : y1]
	              : Math.abs(endY - y1) < epsilon$4 && x1 - endX > epsilon$4 ? [Math.abs(startY - y1) < epsilon$4 ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon$4 && endY - y0 > epsilon$4 ? [x1, Math.abs(startX - x1) < epsilon$4 ? startY : y0]
	              : Math.abs(endY - y0) < epsilon$4 && endX - x0 > epsilon$4 ? [Math.abs(startY - y0) < epsilon$4 ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2$2) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon$4
	      && Math.abs(y - lArc.circle.cy) < epsilon$4) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon$4
	      && Math.abs(y - rArc.circle.cy) < epsilon$4) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon$4) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon$4) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon$4) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon$4) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon$4 = 1e-6;
	var epsilon2$2 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      if (!(m = (halfedges = cell.halfedges).length)) return;
	      var site = cell.site,
	          halfedges,
	          j = -1,
	          m,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function(x, y, radius) {
	    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
	
	    // Use the previously-found cell, or start with an arbitrary one.
	    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
	    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
	
	    // Traverse the half-edges to find a closer cell, if any.
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function(e) {
	        var edge = that.edges[e], v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};
	
	var voronoi = function() {
	  var x = x$4,
	      y = y$4,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x(d, i, data) / epsilon$4) * epsilon$4, Math.round(y(d, i, data) / epsilon$4) * epsilon$4];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant$11(+_), voronoi) : x;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant$11(+_), voronoi) : y;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	};
	
	var constant$12 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function ZoomEvent(target, type, transform) {
	  this.target = target;
	  this.type = type;
	  this.transform = transform;
	}
	
	function Transform(k, x, y) {
	  this.k = k;
	  this.x = x;
	  this.y = y;
	}
	
	Transform.prototype = {
	  constructor: Transform,
	  scale: function(k) {
	    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
	  },
	  translate: function(x, y) {
	    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
	  },
	  apply: function(point) {
	    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
	  },
	  applyX: function(x) {
	    return x * this.k + this.x;
	  },
	  applyY: function(y) {
	    return y * this.k + this.y;
	  },
	  invert: function(location) {
	    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
	  },
	  invertX: function(x) {
	    return (x - this.x) / this.k;
	  },
	  invertY: function(y) {
	    return (y - this.y) / this.k;
	  },
	  rescaleX: function(x) {
	    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
	  },
	  rescaleY: function(y) {
	    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
	  },
	  toString: function() {
	    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
	  }
	};
	
	var identity$8 = new Transform(1, 0, 0);
	
	transform$1.prototype = Transform.prototype;
	
	function transform$1(node) {
	  return node.__zoom || identity$8;
	}
	
	function nopropagation$2() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent$2 = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	};
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter$2() {
	  return !exports.event.button;
	}
	
	function defaultExtent$1() {
	  var e = this, w, h;
	  if (e instanceof SVGElement) {
	    e = e.ownerSVGElement || e;
	    w = e.width.baseVal.value;
	    h = e.height.baseVal.value;
	  } else {
	    w = e.clientWidth;
	    h = e.clientHeight;
	  }
	  return [[0, 0], [w, h]];
	}
	
	function defaultTransform() {
	  return this.__zoom || identity$8;
	}
	
	function defaultWheelDelta() {
	  return -exports.event.deltaY * (exports.event.deltaMode ? 120 : 1) / 500;
	}
	
	function touchable$1() {
	  return "ontouchstart" in this;
	}
	
	var zoom = function() {
	  var filter = defaultFilter$2,
	      extent = defaultExtent$1,
	      wheelDelta = defaultWheelDelta,
	      k0 = 0,
	      k1 = Infinity,
	      x0 = -k1,
	      x1 = k1,
	      y0 = x0,
	      y1 = x1,
	      duration = 250,
	      interpolate = interpolateZoom,
	      gestures = [],
	      listeners = dispatch("start", "zoom", "end"),
	      touchstarting,
	      touchending,
	      touchDelay = 500,
	      wheelDelay = 150,
	      clickDistance2 = 0;
	
	  function zoom(selection$$1) {
	    selection$$1
	        .property("__zoom", defaultTransform)
	        .on("wheel.zoom", wheeled)
	        .on("mousedown.zoom", mousedowned)
	        .on("dblclick.zoom", dblclicked)
	      .filter(touchable$1)
	        .on("touchstart.zoom", touchstarted)
	        .on("touchmove.zoom", touchmoved)
	        .on("touchend.zoom touchcancel.zoom", touchended)
	        .style("touch-action", "none")
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
	  }
	
	  zoom.transform = function(collection, transform$$1) {
	    var selection$$1 = collection.selection ? collection.selection() : collection;
	    selection$$1.property("__zoom", defaultTransform);
	    if (collection !== selection$$1) {
	      schedule(collection, transform$$1);
	    } else {
	      selection$$1.interrupt().each(function() {
	        gesture(this, arguments)
	            .start()
	            .zoom(null, typeof transform$$1 === "function" ? transform$$1.apply(this, arguments) : transform$$1)
	            .end();
	      });
	    }
	  };
	
	  zoom.scaleBy = function(selection$$1, k) {
	    zoom.scaleTo(selection$$1, function() {
	      var k0 = this.__zoom.k,
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return k0 * k1;
	    });
	  };
	
	  zoom.scaleTo = function(selection$$1, k) {
	    zoom.transform(selection$$1, function() {
	      var e = extent.apply(this, arguments),
	          t0 = this.__zoom,
	          p0 = centroid(e),
	          p1 = t0.invert(p0),
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return constrain(translate(scale(t0, k1), p0, p1), e);
	    });
	  };
	
	  zoom.translateBy = function(selection$$1, x, y) {
	    zoom.transform(selection$$1, function() {
	      return constrain(this.__zoom.translate(
	        typeof x === "function" ? x.apply(this, arguments) : x,
	        typeof y === "function" ? y.apply(this, arguments) : y
	      ), extent.apply(this, arguments));
	    });
	  };
	
	  zoom.translateTo = function(selection$$1, x, y) {
	    zoom.transform(selection$$1, function() {
	      var e = extent.apply(this, arguments),
	          t = this.__zoom,
	          p = centroid(e);
	      return constrain(identity$8.translate(p[0], p[1]).scale(t.k).translate(
	        typeof x === "function" ? -x.apply(this, arguments) : -x,
	        typeof y === "function" ? -y.apply(this, arguments) : -y
	      ), e);
	    });
	  };
	
	  function scale(transform$$1, k) {
	    k = Math.max(k0, Math.min(k1, k));
	    return k === transform$$1.k ? transform$$1 : new Transform(k, transform$$1.x, transform$$1.y);
	  }
	
	  function translate(transform$$1, p0, p1) {
	    var x = p0[0] - p1[0] * transform$$1.k, y = p0[1] - p1[1] * transform$$1.k;
	    return x === transform$$1.x && y === transform$$1.y ? transform$$1 : new Transform(transform$$1.k, x, y);
	  }
	
	  function constrain(transform$$1, extent) {
	    var dx0 = transform$$1.invertX(extent[0][0]) - x0,
	        dx1 = transform$$1.invertX(extent[1][0]) - x1,
	        dy0 = transform$$1.invertY(extent[0][1]) - y0,
	        dy1 = transform$$1.invertY(extent[1][1]) - y1;
	    return transform$$1.translate(
	      dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
	      dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
	    );
	  }
	
	  function centroid(extent) {
	    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
	  }
	
	  function schedule(transition$$1, transform$$1, center) {
	    transition$$1
	        .on("start.zoom", function() { gesture(this, arguments).start(); })
	        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
	        .tween("zoom", function() {
	          var that = this,
	              args = arguments,
	              g = gesture(that, args),
	              e = extent.apply(that, args),
	              p = center || centroid(e),
	              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
	              a = that.__zoom,
	              b = typeof transform$$1 === "function" ? transform$$1.apply(that, args) : transform$$1,
	              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
	          return function(t) {
	            if (t === 1) t = b; // Avoid rounding error on end.
	            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
	            g.zoom(null, t);
	          };
	        });
	  }
	
	  function gesture(that, args) {
	    for (var i = 0, n = gestures.length, g; i < n; ++i) {
	      if ((g = gestures[i]).that === that) {
	        return g;
	      }
	    }
	    return new Gesture(that, args);
	  }
	
	  function Gesture(that, args) {
	    this.that = that;
	    this.args = args;
	    this.index = -1;
	    this.active = 0;
	    this.extent = extent.apply(that, args);
	  }
	
	  Gesture.prototype = {
	    start: function() {
	      if (++this.active === 1) {
	        this.index = gestures.push(this) - 1;
	        this.emit("start");
	      }
	      return this;
	    },
	    zoom: function(key, transform$$1) {
	      if (this.mouse && key !== "mouse") this.mouse[1] = transform$$1.invert(this.mouse[0]);
	      if (this.touch0 && key !== "touch") this.touch0[1] = transform$$1.invert(this.touch0[0]);
	      if (this.touch1 && key !== "touch") this.touch1[1] = transform$$1.invert(this.touch1[0]);
	      this.that.__zoom = transform$$1;
	      this.emit("zoom");
	      return this;
	    },
	    end: function() {
	      if (--this.active === 0) {
	        gestures.splice(this.index, 1);
	        this.index = -1;
	        this.emit("end");
	      }
	      return this;
	    },
	    emit: function(type) {
	      customEvent(new ZoomEvent(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function wheeled() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        t = this.__zoom,
	        k = Math.max(k0, Math.min(k1, t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
	        p = mouse(this);
	
	    // If the mouse is in the same location as before, reuse it.
	    // If there were recent wheel events, reset the wheel idle timeout.
	    if (g.wheel) {
	      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
	        g.mouse[1] = t.invert(g.mouse[0] = p);
	      }
	      clearTimeout(g.wheel);
	    }
	
	    // If this wheel event won’t trigger a transform change, ignore it.
	    else if (t.k === k) return;
	
	    // Otherwise, capture the mouse point and location at the start.
	    else {
	      g.mouse = [p, t.invert(p)];
	      interrupt(this);
	      g.start();
	    }
	
	    noevent$2();
	    g.wheel = setTimeout(wheelidled, wheelDelay);
	    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent));
	
	    function wheelidled() {
	      g.wheel = null;
	      g.end();
	    }
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        v = select(exports.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
	        p = mouse(this),
	        x0 = exports.event.clientX,
	        y0 = exports.event.clientY;
	
	    dragDisable(exports.event.view);
	    nopropagation$2();
	    g.mouse = [p, this.__zoom.invert(p)];
	    interrupt(this);
	    g.start();
	
	    function mousemoved() {
	      noevent$2();
	      if (!g.moved) {
	        var dx = exports.event.clientX - x0, dy = exports.event.clientY - y0;
	        g.moved = dx * dx + dy * dy > clickDistance2;
	      }
	      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = mouse(g.that), g.mouse[1]), g.extent));
	    }
	
	    function mouseupped() {
	      v.on("mousemove.zoom mouseup.zoom", null);
	      yesdrag(exports.event.view, g.moved);
	      noevent$2();
	      g.end();
	    }
	  }
	
	  function dblclicked() {
	    if (!filter.apply(this, arguments)) return;
	    var t0 = this.__zoom,
	        p0 = mouse(this),
	        p1 = t0.invert(p0),
	        k1 = t0.k * (exports.event.shiftKey ? 0.5 : 2),
	        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments));
	
	    noevent$2();
	    if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0);
	    else select(this).call(zoom.transform, t1);
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        started,
	        n = touches$$1.length, i, t, p;
	
	    nopropagation$2();
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
	      p = [p, this.__zoom.invert(p), t.identifier];
	      if (!g.touch0) g.touch0 = p, started = true;
	      else if (!g.touch1) g.touch1 = p;
	    }
	
	    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
	    if (touchstarting) {
	      touchstarting = clearTimeout(touchstarting);
	      if (!g.touch1) {
	        g.end();
	        p = select(this).on("dblclick.zoom");
	        if (p) p.apply(this, arguments);
	        return;
	      }
	    }
	
	    if (started) {
	      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
	      interrupt(this);
	      g.start();
	    }
	  }
	
	  function touchmoved() {
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t, p, l;
	
	    noevent$2();
	    if (touchstarting) touchstarting = clearTimeout(touchstarting);
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
	      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
	      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
	    }
	    t = g.that.__zoom;
	    if (g.touch1) {
	      var p0 = g.touch0[0], l0 = g.touch0[1],
	          p1 = g.touch1[0], l1 = g.touch1[1],
	          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
	          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
	      t = scale(t, Math.sqrt(dp / dl));
	      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
	      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
	    }
	    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
	    else return;
	    g.zoom("touch", constrain(translate(t, p, l), g.extent));
	  }
	
	  function touchended() {
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t;
	
	    nopropagation$2();
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function() { touchending = null; }, touchDelay);
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i];
	      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
	      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
	    }
	    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
	    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
	    else g.end();
	  }
	
	  zoom.wheelDelta = function(_) {
	    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant$12(+_), zoom) : wheelDelta;
	  };
	
	  zoom.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$12(!!_), zoom) : filter;
	  };
	
	  zoom.extent = function(_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$12([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
	  };
	
	  zoom.scaleExtent = function(_) {
	    return arguments.length ? (k0 = +_[0], k1 = +_[1], zoom) : [k0, k1];
	  };
	
	  zoom.translateExtent = function(_) {
	    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], zoom) : [[x0, y0], [x1, y1]];
	  };
	
	  zoom.duration = function(_) {
	    return arguments.length ? (duration = +_, zoom) : duration;
	  };
	
	  zoom.interpolate = function(_) {
	    return arguments.length ? (interpolate = _, zoom) : interpolate;
	  };
	
	  zoom.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? zoom : value;
	  };
	
	  zoom.clickDistance = function(_) {
	    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
	  };
	
	  return zoom;
	};
	
	exports.version = version;
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = threshold;
	exports.range = sequence;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	exports.axisTop = axisTop;
	exports.axisRight = axisRight;
	exports.axisBottom = axisBottom;
	exports.axisLeft = axisLeft;
	exports.brush = brush;
	exports.brushX = brushX;
	exports.brushY = brushY;
	exports.brushSelection = brushSelection;
	exports.chord = chord;
	exports.ribbon = ribbon;
	exports.nest = nest;
	exports.set = set$2;
	exports.map = map$1;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	exports.dispatch = dispatch;
	exports.drag = drag;
	exports.dragDisable = dragDisable;
	exports.dragEnable = yesdrag;
	exports.dsvFormat = dsv;
	exports.csvParse = csvParse;
	exports.csvParseRows = csvParseRows;
	exports.csvFormat = csvFormat;
	exports.csvFormatRows = csvFormatRows;
	exports.tsvParse = tsvParse;
	exports.tsvParseRows = tsvParseRows;
	exports.tsvFormat = tsvFormat;
	exports.tsvFormatRows = tsvFormatRows;
	exports.easeLinear = linear$1;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	exports.forceCenter = center$1;
	exports.forceCollide = collide;
	exports.forceLink = link;
	exports.forceManyBody = manyBody;
	exports.forceSimulation = simulation;
	exports.forceX = x$2;
	exports.forceY = y$2;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	exports.geoArea = area;
	exports.geoBounds = bounds;
	exports.geoCentroid = centroid;
	exports.geoCircle = circle;
	exports.geoClipExtent = extent$1;
	exports.geoContains = contains;
	exports.geoDistance = distance;
	exports.geoGraticule = graticule;
	exports.geoGraticule10 = graticule10;
	exports.geoInterpolate = interpolate$1;
	exports.geoLength = length$1;
	exports.geoPath = index$1;
	exports.geoAlbers = albers;
	exports.geoAlbersUsa = albersUsa;
	exports.geoAzimuthalEqualArea = azimuthalEqualArea;
	exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
	exports.geoAzimuthalEquidistant = azimuthalEquidistant;
	exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
	exports.geoConicConformal = conicConformal;
	exports.geoConicConformalRaw = conicConformalRaw;
	exports.geoConicEqualArea = conicEqualArea;
	exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
	exports.geoConicEquidistant = conicEquidistant;
	exports.geoConicEquidistantRaw = conicEquidistantRaw;
	exports.geoEquirectangular = equirectangular;
	exports.geoEquirectangularRaw = equirectangularRaw;
	exports.geoGnomonic = gnomonic;
	exports.geoGnomonicRaw = gnomonicRaw;
	exports.geoIdentity = identity$5;
	exports.geoProjection = projection;
	exports.geoProjectionMutator = projectionMutator;
	exports.geoMercator = mercator;
	exports.geoMercatorRaw = mercatorRaw;
	exports.geoOrthographic = orthographic;
	exports.geoOrthographicRaw = orthographicRaw;
	exports.geoStereographic = stereographic;
	exports.geoStereographicRaw = stereographicRaw;
	exports.geoTransverseMercator = transverseMercator;
	exports.geoTransverseMercatorRaw = transverseMercatorRaw;
	exports.geoRotation = rotation;
	exports.geoStream = geoStream;
	exports.geoTransform = transform;
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index$2;
	exports.packSiblings = siblings;
	exports.packEnclose = enclose;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$3;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	exports.treemapResquarify = resquarify;
	exports.interpolate = interpolateValue;
	exports.interpolateArray = array$1;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = reinterpolate;
	exports.interpolateObject = object;
	exports.interpolateRound = interpolateRound;
	exports.interpolateString = interpolateString;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = interpolateZoom;
	exports.interpolateRgb = interpolateRgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	exports.path = path;
	exports.polygonArea = area$1;
	exports.polygonCentroid = centroid$1;
	exports.polygonHull = hull;
	exports.polygonContains = contains$1;
	exports.polygonLength = length$2;
	exports.quadtree = quadtree;
	exports.queue = queue;
	exports.randomUniform = uniform;
	exports.randomNormal = normal;
	exports.randomLogNormal = logNormal;
	exports.randomBates = bates;
	exports.randomIrwinHall = irwinHall;
	exports.randomExponential = exponential$1;
	exports.request = request;
	exports.html = html;
	exports.json = json;
	exports.text = text;
	exports.xml = xml;
	exports.csv = csv$1;
	exports.tsv = tsv$1;
	exports.scaleBand = band;
	exports.scalePoint = point$1;
	exports.scaleIdentity = identity$6;
	exports.scaleLinear = linear$2;
	exports.scaleLog = log$1;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow$1;
	exports.scaleSqrt = sqrt$1;
	exports.scaleQuantile = quantile;
	exports.scaleQuantize = quantize$1;
	exports.scaleThreshold = threshold$1;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$3;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	exports.creator = creator;
	exports.local = local$1;
	exports.matcher = matcher$1;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.style = styleValue;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = defaultView;
	exports.customEvent = customEvent;
	exports.arc = arc;
	exports.area = area$2;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle$2;
	exports.symbolCross = cross$2;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed$1;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis$2;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none$1;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending$2;
	exports.stackOrderDescending = descending$2;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$2;
	exports.stackOrderReverse = reverse;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	exports.timeFormatDefaultLocale = defaultLocale$1;
	exports.timeFormatLocale = formatLocale$1;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	exports.transition = transition;
	exports.active = active;
	exports.interrupt = interrupt;
	exports.voronoi = voronoi;
	exports.zoom = zoom;
	exports.zoomTransform = transform$1;
	exports.zoomIdentity = identity$8;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventPluginRegistry = __webpack_require__(42);
	var EventPluginUtils = __webpack_require__(43);
	var ReactErrorUtils = __webpack_require__(47);
	
	var accumulateInto = __webpack_require__(81);
	var forEachAccumulated = __webpack_require__(82);
	var invariant = __webpack_require__(1);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(24);
	var EventPluginUtils = __webpack_require__(43);
	
	var accumulateInto = __webpack_require__(81);
	var forEachAccumulated = __webpack_require__(82);
	var warning = __webpack_require__(2);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(13);
	
	var getEventTarget = __webpack_require__(52);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 28 */
3,
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(239);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(242);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(42);
	var ReactEventEmitterMixin = __webpack_require__(174);
	var ViewportMetrics = __webpack_require__(80);
	
	var getVendorPrefixedEventName = __webpack_require__(206);
	var isEventSupported = __webpack_require__(53);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(27);
	var ViewportMetrics = __webpack_require__(80);
	
	var getEventModifierState = __webpack_require__(51);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	var DOMNamespaces = __webpack_require__(41);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(49);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getExtent = getExtent;
	exports.getMean = getMean;
	exports.generateClumps = generateClumps;
	
	var _d = __webpack_require__(23);
	
	var d3 = _interopRequireWildcard(_d);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function random(min, max) {
	    return Math.floor(Math.random() * (max - min + 1) + min);
	}
	
	function getExtent(data) {
	    // Map each column to its extents [min, max, diff].
	    // Ex. If there are 7 columns in the data, this will return
	    // an array of 7 extents, each one an array of [min, max, diff].
	    var extents = data[0].map(function (d, i) {
	        // Return a default extent if the data is not numeric
	        if (isNaN(d)) {
	            return [0, 0, 0];
	        }
	
	        // use D3 extent https://github.com/d3/d3/blob/master/API.md#arrays-d3-array
	        var ext = d3.extent(data, function (d) {
	            return d[i];
	        });
	
	        // Append the difference (range), max minus min for convenience later
	        ext.push(ext[1] - ext[0]);
	        return ext;
	    });
	    return extents;
	}
	
	function getMean(data) {
	    // Map each column to a mean value.
	    // Ex. If there are 7 columns in the data, this will return
	    // an array of 7 mean values.
	    var means = data[0].map(function (d, i) {
	        // Return a default value if the data is not numeric
	        if (isNaN(d)) {
	            return 0;
	        }
	
	        // Use D3 mean https://github.com/d3/d3/blob/master/API.md#arrays-d3-array
	        var mean = d3.mean(data, function (d) {
	            return d[i];
	        });
	
	        return mean;
	    });
	
	    return means;
	}
	
	function generateClumps(clumpCount, size, radius) {
	    clumpCount = clumpCount || 3;
	    size = size || 25;
	    radius = radius || 15;
	    var data = [];
	
	    for (var i = 0; i < clumpCount; i++) {
	        var center = [random(radius, 100 - radius), random(radius, 100 - radius)];
	
	        var pointCount = random(Math.round(size / 2), size);
	
	        for (var j = 0; j < pointCount; j++) {
	            var translate = [random(-radius, radius), random(-radius, radius)];
	            var x = center[0] + translate[0];
	            var y = center[1] + translate[1];
	            if (x > 0 && x < 101 && y > 0 && y < 101) {
	                data.push([x, y]);
	            }
	        }
	    }
	
	    return data;
	}

/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(18);
	var Danger = __webpack_require__(151);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInstrumentation = __webpack_require__(11);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(49);
	var setInnerHTML = __webpack_require__(36);
	var setTextContent = __webpack_require__(88);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactErrorUtils = __webpack_require__(47);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 44 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactPropTypesSecret = __webpack_require__(180);
	var propTypesFactory = __webpack_require__(67);
	
	var React = __webpack_require__(21);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactInstanceMap = __webpack_require__(26);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(12);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 49 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 50 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 51 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 52 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 54 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyFunction = __webpack_require__(10);
	var warning = __webpack_require__(2);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(139);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(10);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 60 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 61 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(30);
	
	var _PathUtils = __webpack_require__(17);
	
	var _createTransitionManager = __webpack_require__(39);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(30);
	
	var _PathUtils = __webpack_require__(17);
	
	var _createTransitionManager = __webpack_require__(39);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(17);
	
	var _LocationUtils = __webpack_require__(30);
	
	var _createTransitionManager = __webpack_require__(39);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 65 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(99);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(144);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 68 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(15);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(19);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInstrumentation = __webpack_require__(11);
	
	var quoteAttributeValueForBrowser = __webpack_require__(207);
	var warning = __webpack_require__(2);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(12);
	
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 75 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(167);
	
	var containsNode = __webpack_require__(126);
	var focusNode = __webpack_require__(59);
	var getActiveElement = __webpack_require__(60);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(18);
	var DOMProperty = __webpack_require__(19);
	var React = __webpack_require__(21);
	var ReactBrowserEventEmitter = __webpack_require__(32);
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMContainerInfo = __webpack_require__(161);
	var ReactDOMFeatureFlags = __webpack_require__(163);
	var ReactFeatureFlags = __webpack_require__(75);
	var ReactInstanceMap = __webpack_require__(26);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactMarkupChecksum = __webpack_require__(177);
	var ReactReconciler = __webpack_require__(20);
	var ReactUpdateQueue = __webpack_require__(48);
	var ReactUpdates = __webpack_require__(12);
	
	var emptyObject = __webpack_require__(29);
	var instantiateReactComponent = __webpack_require__(86);
	var invariant = __webpack_require__(1);
	var setInnerHTML = __webpack_require__(36);
	var shouldUpdateReactComponent = __webpack_require__(54);
	var warning = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var React = __webpack_require__(21);
	
	var invariant = __webpack_require__(1);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(79);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(5);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  delete inst._wrapperState.valueTracker;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var ReactCompositeComponent = __webpack_require__(158);
	var ReactEmptyComponent = __webpack_require__(74);
	var ReactHostComponent = __webpack_require__(76);
	
	var getNextDebugID = __webpack_require__(235);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 87 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	var escapeTextContentForBrowser = __webpack_require__(35);
	var setInnerHTML = __webpack_require__(36);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(14);
	var REACT_ELEMENT_TYPE = __webpack_require__(173);
	
	var getIteratorFn = __webpack_require__(204);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(44);
	var warning = __webpack_require__(2);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(209);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(210);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(90);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(211);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(212);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(213);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(214);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(215);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(216);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(217);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(218);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(219);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(220);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(57);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, _ref2) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact;
	    var route = _ref2.route;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        component = _props.component,
	        render = _props.render,
	        children = _props.children;
	
	
	    (0, _warning2.default)(!(component && render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(component && children), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(render && children), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props2 = this.props,
	        children = _props2.children,
	        component = _props2.component,
	        render = _props2.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !Array.isArray(children) || children.length ? // Preact defaults to empty children array
	    _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(28),
	    _assign = __webpack_require__(4);
	
	var ReactNoopUpdateQueue = __webpack_require__(96);
	
	var canDefineProperty = __webpack_require__(97);
	var emptyObject = __webpack_require__(29);
	var invariant = __webpack_require__(1);
	var lowPriorityWarning = __webpack_require__(236);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(28);
	
	var ReactCurrentOwner = __webpack_require__(14);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 95 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(2);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(141).enable();
	  window.Promise = __webpack_require__(140);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(243);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(4);


/***/ },
/* 99 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(91);
	
	__webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	    _inherits(App, _Component);
	
	    function App() {
	        _classCallCheck(this, App);
	
	        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	    }
	
	    _createClass(App, [{
	        key: "render",
	        value: function render() {
	
	            var activeStyle = {
	                color: "#fff",
	                fontWeight: "bold"
	            };
	
	            return _react2.default.createElement(
	                "div",
	                { className: "application" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "ui fixed inverted blue menu" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ui grid", style: { width: '100%' } },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "three wide center aligned column" },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { to: "/knn", activeStyle: activeStyle, style: { display: 'inline-block' } },
	                                "kNN"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "three wide center aligned column" },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { to: "/kmc", activeStyle: activeStyle, style: { display: 'inline-block' } },
	                                "k Means"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "three wide center aligned column" },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { to: "/dbscan", activeStyle: activeStyle, style: { display: 'inline-block' } },
	                                "DBSCAN"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "three wide center aligned column" },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { to: "/bayes", activeStyle: activeStyle, style: { display: 'inline-block' } },
	                                "Language Classifier"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "three wide center aligned column" },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { to: "/sentiment", activeStyle: activeStyle, style: { display: 'inline-block' } },
	                                "Sentiment Analysis"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "child-container" },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	__webpack_require__(118);
	
	var _trainingDocuments = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Special thanks to Burak Kanber. This code was heavily influenced by the article
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               https://www.burakkanber.com/blog/machine-learning-in-other-languages-introduction/ by Burak Kanber.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var BayesDemo = function (_Component) {
	    _inherits(BayesDemo, _Component);
	
	    function BayesDemo() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, BayesDemo);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BayesDemo.__proto__ || Object.getPrototypeOf(BayesDemo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            inputStems: [],
	            winnerLabel: null,
	            winnerScore: null,
	            wordicityMessages: []
	        }, _this.stats = null, _this.resetStats = function () {
	            _this.stats = {
	                labels: {},
	                docCount: {},
	                stemCount: {},
	                stemLabelCount: {}
	            };
	        }, _this.tokenize = function (text) {
	            text = text.toLowerCase().replace(/\W/g, " ").replace(/\s+/g, " ").trim().split(" ");
	            text = _this.unique(text);
	            return text;
	        }, _this.registerLabel = function (label) {
	            _this.stats.labels[label] = true;
	            return true;
	        }, _this.getStemLabelCount = function (stem, label) {
	            return _this.stats.stemLabelCount[_this.stemLabelKey(stem, label)] || 0;
	        }, _this.getStemInverseLabelCount = function (stem, label) {
	            var labels = _this.getLabels();
	            var total = 0;
	
	            for (var i = 0, length = labels.length; i < length; i++) {
	                if (labels[i] === label) {
	                    continue;
	                }
	                total += _this.getStemLabelCount(stem, labels[i]);
	            }
	            return total;
	        }, _this.getStemTotalCount = function (stem) {
	            return _this.stats.stemCount[stem] || 0;
	        }, _this.getDocCount = function (label) {
	            return _this.stats.docCount[label] || 0;
	        }, _this.getDocInverseCount = function (label) {
	            var labels = _this.getLabels();
	            var total = 0;
	
	            for (var i = 0, length = labels.length; i < length; i++) {
	                if (labels[i] === label) {
	                    continue;
	                }
	                total += _this.stats.docCount[labels[i]] || 0;
	            }
	            return total;
	        }, _this.incrementStem = function (stem, label) {
	            _this.stats.stemCount[stem] = _this.getStemCount(stem) + 1;
	            var stemLabelKey = _this.stemLabelKey(stem, label);
	            _this.stats.stemLabelCount[stemLabelKey] = _this.getStemLabelCount(stem, label) + 1;
	        }, _this.incrementDocCount = function (label) {
	            _this.stats.docCount[label] = _this.getDocCount(label) + 1;
	        }, _this.train = function (trainingDocs) {
	            trainingDocs.forEach(function (t) {
	                _this.trainOne(t[0], t[1]);
	            });
	        }, _this.trainOne = function (text, label) {
	            // Remember each label
	            _this.registerLabel(label);
	
	            var words = _this.tokenize(text);
	            var length = words.length;
	
	            // Tally number of times each word appears for the label
	            for (var i = 0; i < length; i++) {
	                _this.incrementStem(words[i], label);
	            }
	
	            // Tally number of training document for each label
	            _this.incrementDocCount(label);
	        }, _this.guess = function (text) {
	            var wordicityMessages = [];
	            var words = _this.tokenize(text);
	            var wordCount = words.length;
	
	            // labels are french, spanish, english
	            var labels = _this.getLabels();
	
	            var totalDocCount = 0;
	            var docCounts = {};
	            var docInverseCounts = {};
	            var scores = {};
	            var labelProbability = {};
	
	            // For each language (label) get number of training docs and number of training docs in other languages (inverse)
	            for (var labelIdx = 0; labelIdx < labels.length; labelIdx++) {
	                var label = labels[labelIdx];
	                docCounts[label] = _this.getDocCount(label);
	                docInverseCounts[label] = _this.getDocInverseCount(label);
	                totalDocCount += docCounts[label];
	            }
	
	            // Iterate languages (labels)
	            for (var _labelIdx = 0; _labelIdx < labels.length; _labelIdx++) {
	                var _label = labels[_labelIdx];
	                var logSum = 0;
	                labelProbability[_label] = docCounts[_label] / totalDocCount;
	
	                // Iterate test words
	                for (var wordIdx = 0; wordIdx < wordCount; wordIdx++) {
	                    var word = words[wordIdx];
	                    var _stemTotalCount = _this.getStemTotalCount(word);
	
	                    var wordicity = void 0;
	
	                    if (_stemTotalCount === 0) {
	                        continue;
	                    } else {
	                        // Get word's "wordicity" -- probabiility it appears in one language and not the others
	                        var wordProbability = _this.getStemLabelCount(word, _label) / docCounts[_label];
	
	                        var wordInverseProbability = _this.getStemInverseLabelCount(word, _label) / docInverseCounts[_label];
	
	                        wordicity = wordProbability / (wordProbability + wordInverseProbability);
	
	                        wordicity = (0.5 + _stemTotalCount * wordicity) / (1 + _stemTotalCount);
	
	                        if (wordicity === 0) {
	                            wordicity = 0.01;
	                        } else if (wordicity === 1) {
	                            wordicity = 0.99;
	                        }
	                    }
	
	                    // Add up logrithmic sums for the language (label)
	                    logSum += Math.log(1 - wordicity) - Math.log(wordicity);
	
	                    wordicityMessages.push({
	                        lang: _label,
	                        word: word,
	                        value: wordicity
	                    });
	                }
	
	                // More math to get the language's final score
	                scores[_label] = 1 / (1 + Math.exp(logSum));
	            }
	
	            return { scores: scores, words: words, wordicityMessages: wordicityMessages };
	        }, _this.go = function () {
	            _this.resetStats();
	            var trainingDocs = _this.props.trainingDocs;
	
	            _this.train(trainingDocs);
	
	            var text = document.getElementById("test_phrase").value;
	
	            var _this$guess = _this.guess(text),
	                scores = _this$guess.scores,
	                words = _this$guess.words,
	                wordicityMessages = _this$guess.wordicityMessages;
	
	            var winner = _this.extractWinner(scores);
	
	            _this.setState({
	                words: words,
	                winnerLabel: winner.label,
	                winnerScore: winner.score,
	                wordicityMessages: wordicityMessages
	            });
	
	            console.log(scores);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(BayesDemo, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.resetStats();
	        }
	
	        /* Find unique elements in array */
	
	    }, {
	        key: "unique",
	        value: function unique(arr) {
	            var u = {},
	                a = [];
	            for (var i = 0, l = arr.length; i < l; ++i) {
	                if (u.hasOwnProperty(arr[i])) {
	                    continue;
	                }
	                a.push(arr[i]);
	                u[arr[i]] = 1;
	            }
	            return a;
	        }
	
	        /* Hash keys for various composite values */
	
	    }, {
	        key: "stemLabelKey",
	        value: function stemLabelKey(stem, label) {
	            return stem + "_" + label;
	        }
	    }, {
	        key: "docCountKey",
	        value: function docCountKey(label) {
	            return label;
	        }
	    }, {
	        key: "stemCountKey",
	        value: function stemCountKey(stem) {
	            return stem;
	        }
	    }, {
	        key: "log",
	        value: function log(text) {
	            console.log(text);
	        }
	
	        /* Tokenize text (simple stemming). Applied to training docs and input text.
	          o lower case
	          o remove punctuation
	          o split into words by spaces
	          o remove duplicate words
	        */
	
	    }, {
	        key: "getLabels",
	
	
	        /* Get stored labels */
	        value: function getLabels() {
	            return Object.keys(this.stats.labels);
	        }
	
	        /* Store one label */
	
	    }, {
	        key: "getStemCount",
	        value: function getStemCount(stem) {
	            return this.stats.stemCount[stem] || 0;
	        }
	
	        /* Get specific stem count for a label */
	
	
	        /* Get specific stem count NOT for a label */
	
	
	        /* Total stem count */
	
	
	        /* Get count of docs assigned to the label */
	
	
	        /* Get count of docs NOT assigned to the label */
	
	
	        /* Increment count of one stem (training word)  */
	
	
	        /* Increment label's document count */
	
	
	        /* Learn all training documents */
	
	
	        /* Learn one training document */
	
	
	        /* Calculate guess */
	
	    }, {
	        key: "extractWinner",
	        value: function extractWinner(scores) {
	            var bestScore = 0;
	            var bestLabel = null;
	
	            // Get language (label) with the best score
	            for (var label in scores) {
	                if (scores[label] > bestScore) {
	                    bestScore = scores[label];
	                    bestLabel = label;
	                }
	            }
	            return { label: bestLabel, score: bestScore };
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _state = this.state,
	                winnerLabel = _state.winnerLabel,
	                winnerScore = _state.winnerScore;
	
	            var displayScore = !isNaN(winnerScore) ? (winnerScore * 100).toFixed(1) + "%" : "";
	            var displayLabel = winnerLabel || "";
	
	            return _react2.default.createElement(
	                "div",
	                { className: "dark-panel" },
	                _react2.default.createElement(
	                    "h1",
	                    { className: "ui header" },
	                    "Naive Bayes Classifier"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "centered-panel" },
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Uses Bayes Theorem to determine the language of the input text based on the training data. Each word is evaluated independently (naive)."
	                    ),
	                    _react2.default.createElement("textarea", {
	                        id: "test_phrase",
	                        placeholder: "Enter English, Spanish, or French text here.",
	                        style: {
	                            color: "#000",
	                            width: 655,
	                            height: 256,
	                            marginLeft: 0
	                        }
	                    }),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: "ui button",
	                            id: "test_button",
	                            onClick: this.go
	                        },
	                        "Train, then Guess Language"
	                    ),
	                    _react2.default.createElement(
	                        "h2",
	                        { id: "test_result" },
	                        displayLabel
	                    ),
	                    _react2.default.createElement(
	                        "h2",
	                        { id: "test_probability" },
	                        displayScore
	                    ),
	                    this.state.wordicityMessages && this.state.wordicityMessages.length > 0 && _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "h2",
	                            null,
	                            "Result Details"
	                        ),
	                        _react2.default.createElement(
	                            "table",
	                            null,
	                            this.state.wordicityMessages.map(function (m, i) {
	                                return _react2.default.createElement(
	                                    "tr",
	                                    { key: i },
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        m.lang,
	                                        "-icity"
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "\xA0of\xA0\"",
	                                        m.word,
	                                        "\"\xA0"
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "=\xA0",
	                                        m.value.toFixed(2)
	                                    )
	                                );
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Samples for Spanish, French, English"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Son las diez en punto. Las siete y media."
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Charade en action , Esp\xE8ce de divertissement o\xF9 plusieurs personnes donnent \xE0 deviner \xE0 d\u2019autres chaque partie d\u2019un mot et le mot entier , en ex\xE9cutant des sc\xE8nes de pantomime ou de com\xE9die qui en expriment la signification ."
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Mary and Samantha arrived at the bus station before noon, and they left on the bus before I arrived."
	                )
	            );
	        }
	    }]);
	
	    return BayesDemo;
	}(_react.Component);
	
	BayesDemo.propTypes = {
	    trainingDocs: _propTypes.PropTypes.array
	};
	BayesDemo.defaultProps = {
	    trainingDocs: _trainingDocuments.TRAINING_DOCUMENTS
	};
	exports.default = BayesDemo;

/***/ },
/* 102 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TRAINING_DOCUMENTS = exports.TRAINING_DOCUMENTS = [
	// French
	["L'Italie a été gouvernée pendant un an par un homme qui n'avait pas été élu par le peuple. Dès la nomination de Mario Monti au poste de président du conseil, fin 2011, j'avais dit :Attention, c'est prendre un risque politique majeur. Par leur vote, les Italiens n'ont pas seulement adressé un message à leurs élites nationales, ils ont voulu dire : Nous, le peuple, nous voulons garder la maîtrise de notre destin. Et ce message pourrait être envoyé par n'importe quel peuple européen, y compris le peuple français.", "French"], ["Il en faut peu, parfois, pour passer du statut d'icône de la cause des femmes à celui de renégate. Lorsqu'elle a été nommée à la tête de Yahoo!, le 26 juillet 2012, Marissa Mayer était vue comme un modèle. Elle montrait qu'il était possible de perforer le fameux plafond de verre, même dans les bastions les mieux gardés du machisme (M du 28 juillet 2012). A 37 ans, cette brillante diplômée de Stanford, formée chez Google, faisait figure d'exemple dans la Silicon Valley californienne, où moins de 5 % des postes de direction sont occupés par des femmes. En quelques mois, le symbole a beaucoup perdu de sa puissance.", "French"], ["Premier intervenant de taille à SXSW 2013, Bre Pettis, PDG de la société Makerbot, spécialisée dans la vente d'imprimantes 3D, a posé une question toute simple, avant de dévoiler un nouveau produit qui l'est un peu moins. Voulez-vous rejoindre notre environnement 3D ?, a-t-il demandé à la foule qui débordait de l'Exhibit Hall 5 du Convention Center.", "French"], ["Des milliers de manifestants ont défilé samedi 9 mars à Tokyo pour exiger l'abandon rapide de l'énergie nucléaire au Japon, près de deux ans jour pour jour après le début de la catastrophe de Fukushima.", "French"], ["Oui, ça en a tout l'air, même si le conflit en Syrie n'était pas confessionnel au départ et ne l'est pas encore vraiment. Il faut saluer là l'extraordinaire résistance de la société civile syrienne à la tentation confessionnelle, mais cela ne durera pas éternellement.", "French"],
	// Spanish
	["El ex presidente sudafricano, Nelson Mandela, ha sido hospitalizado la tarde del sábado, según confirmó un hospital de Pretoria a CNN. Al parecer se trata de un chequeo médico que ya estaba previsto, relacionado con su avanzada edad, según explicó el portavoz de la presidencia Sudafricana Mac Maharaj.", "Spanish"], ["Trabajadores del Vaticano escalaron al techo de la Capilla Sixtina este sábado para instalar la chimenea de la que saldrá el humo negro o blanco para anunciar el resultado de las votaciones para elegir al nuevo papa.La chimenea es el primer signo visible al público de las preparaciones que se realizan en el interior de la capilla donde los cardenales católicos se reunirán a partir de este martes para el inicio del cónclave.", "Spanish"], ["La Junta Directiva del Consejo Nacional Electoral (CNE) efectuará hoy una sesión extraordinaria para definir la fecha de las elecciones presidenciales, después de que Nicolás Maduro fuera juramentado ayer Viernes presidente de la República por la Asamblea Nacional.", "Spanish"], [" A 27 metros bajo el agua, la luz se vuelve de un azul profundo y nebuloso. Al salir de la oscuridad, tres bailarinas en tutú blanco estiran las piernas en la cubierta de un buque de guerra hundido. No es una aparición fantasmal, aunque lo parezca, es la primera de una serie de fotografías inolvidables que se muestran en la única galería submarina del mundo.", "Spanish"], ["Uhuru Kenyatta, hijo del líder fundador de Kenia, ganó por estrecho margen las elecciones presidenciales del país africano a pesar de enfrentar cargos de crímenes contra la humanidad por la violencia electoral de hace cinco años. Según anunció el sábado la comisión electoral, Kenyatta logró el 50,07% de los votos. Su principal rival, el primer ministro Raila Odinga, obtuvo 43,31% de los votos, y dijo que reclamará el resultado en los tribunales. La Constitución exige que el 50% más un voto para una victoria absoluta.", "Spanish"],
	// English
	["One morning in late September 2011, a group of American drones took off from an airstrip the C.I.A. had built in the remote southern expanse of Saudi Arabia. The drones crossed the border into Yemen, and were soon hovering over a group of trucks clustered in a desert patch of Jawf Province, a region of the impoverished country once renowned for breeding Arabian horses. Hello.", "English"], ["Just months ago, demonstrators here and around Egypt were chanting for the end of military rule. But on Saturday, as a court ruling about a soccer riot set off angry mobs, many in the crowd here declared they now believed that a military coup might be the best hope to restore order. Although such calls are hardly universal and there is no threat of an imminent coup, the growing murmurs that military intervention may be the only solution to the collapse of public security can be heard across the country, especially in circles opposed to the Islamists who have dominated post-Mubarak elections. ", "English"], [" Syrian rebels released 21 detained United Nations peacekeepers to Jordanian forces on Saturday, ending a standoff that raised new tensions in the region and new questions about the fighters just as the United States and other Western nations were grappling over whether to arm them. The rebels announced the release of the Filipino peacekeepers, and Col. Arnulfo Burgos, a spokesman for the Armed Forces of the Philippines, confirmed it.", "English"], [" The 83rd International Motor Show, which opened here last week, features the world premieres of 130 vehicles. These include an unprecedented number of models with seven-figure prices, including the $1.3 million LaFerrari supercar, the $1.15 million McLaren P1, the $1.6 million Koenigsegg Hundra and a trust-fund-busting Lamborghini, the $4 million Veneno. The neighborhood has become so rich that the new Rolls-Royce Wraith, expected to sell for more than $300,000, seemed, in comparison, like a car for the masses.", "English"], ["David Hallberg, the statuesque ballet star who is a principal dancer at both the storied Bolshoi Ballet of Moscow and American Ballet Theater in New York, is theoretically the type of front-row coup that warrants a fit of camera flashes. But when Mr. Hallberg, 30, showed up at New York Fashion Week last month, for a presentation by the Belgian designer Tim Coppens, he glided into the front row nearly unnoticed, save for a quick chat with Tumblr’s fashion evangelist, Valentine Uhovski, and a warm embrace from David Farber, the executive style editor at WSJ.", "English"]];

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _dbscan = __webpack_require__(104);
	
	var _dbscan2 = _interopRequireDefault(_dbscan);
	
	var _d = __webpack_require__(23);
	
	var d3 = _interopRequireWildcard(_d);
	
	__webpack_require__(119);
	
	var _common = __webpack_require__(37);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLUSTER_DUR = 1000;
	var BASE_COLOR = "#888";
	
	var DbscanView = function (_Component) {
	    _inherits(DbscanView, _Component);
	
	    function DbscanView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DbscanView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DbscanView.__proto__ || Object.getPrototypeOf(DbscanView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            data: null,
	            scales: null,
	            extent: null,
	            epsilon: 10,
	            maxTestPoints: 100, // max test data points
	            minPoints: 3,
	            colors: d3.scaleOrdinal(d3.schemeCategory20)
	        }, _this.generateData = function () {
	            var clumpCount = 3;
	            var _this$props = _this.props,
	                width = _this$props.width,
	                height = _this$props.height;
	            var maxTestPoints = _this.state.maxTestPoints;
	
	
	            var data = (0, _common.generateClumps)(clumpCount, Math.round(maxTestPoints / clumpCount), 15);
	
	            var extent = _this.getMax(data);
	            var scales = _this.getScales(extent, width, height);
	            _this.setState({ data: data, extent: extent, scales: scales });
	
	            _this.renderDataPoints(data, scales);
	        }, _this.getMax = function (data) {
	            return [d3.max(data, function (d) {
	                return d[0];
	            }), d3.max(data, function (d) {
	                return d[1];
	            })];
	        }, _this.getScales = function (extent, width, height) {
	            return {
	                x: d3.scaleLinear().domain([0, extent[0]]).range([0, width]),
	                y: d3.scaleLinear().domain([0, extent[1]]).range([0, height])
	            };
	        }, _this.renderDataPoints = function (data, scales) {
	            data.forEach(function (d, i) {
	                return d.id = i;
	            });
	
	            d3.select(".data-plot-area").selectAll(".data-point").remove();
	
	            d3.select(".epsilon-plot-area").selectAll(".epsilon").remove();
	
	            d3.select(".data-plot-area").selectAll(".data-points").data(data).enter().append("circle").attr("class", "data-point").attr("cx", function (d) {
	                return scales.x(d[0]);
	            }).attr("cy", function (d) {
	                return scales.y(d[1]);
	            }).attr("r", 5).style("fill", BASE_COLOR);
	        }, _this.renderClusters = function (animPoints, clusters, epsilon, scales) {
	            var colors = _this.state.colors;
	
	            var eRadius = scales.x(epsilon);
	
	            d3.select(".epsilon-plot-area").selectAll(".epsilon").remove();
	
	            var _loop = function _loop(c, len) {
	                var cluster = clusters[c];
	                var inc = CLUSTER_DUR / cluster.length;
	
	                d3.select(".epsilon-plot-area").selectAll(".epsilon cluster" + c).data(cluster).enter().append("circle").attr("class", "epsilon cluster" + c).attr("cx", function (cpi) {
	                    return animPoints[cpi].x;
	                }).attr("cy", function (cpi) {
	                    return animPoints[cpi].y;
	                }).attr("r", 0).style("visibility", "hidden").style("fill", colors(c)).style("opacity", 0.25).style("stroke", "none")
	
	                // delay the start of subsequent transitions
	                .transition().delay(function (d, i) {
	                    var delay = c * CLUSTER_DUR + inc * i;
	                    return delay;
	                }).duration(1)
	
	                // visible
	                .transition().duration(1).style("visibility", "visible")
	
	                // grow radius
	                .transition().duration(250).attr("r", eRadius);
	
	                d3.select(".epsilon-plot-area").selectAll(".epsilon").transition().delay(clusters.length * 1000).duration(1000).style("opacity", 0);
	            };
	
	            for (var c = 0, len = clusters.length; c < len; c++) {
	                _loop(c, len);
	            }
	        }, _this.setPointColors = function (animPoints) {
	            var colors = _this.state.colors;
	
	
	            var update = d3.select(".data-plot-area").selectAll(".data-point");
	
	            update.transition().duration(1).delay(function (d) {
	                var d1 = animPoints[d.id];
	                return d1.clusterId !== undefined ? CLUSTER_DUR * (d1.clusterId + 1) : 0;
	            }).style("fill", function (d) {
	                var d1 = animPoints[d.id];
	                return d1.clusterId !== undefined ? colors(d1.clusterId) : BASE_COLOR;
	            });
	        }, _this.resetPointColors = function (animPoints) {
	            d3.select(".data-plot-area").selectAll(".data-points").style("fill", BASE_COLOR);
	        }, _this.getAnimPoints = function (data, clusters, scales) {
	            return data.map(function (d, i) {
	                var clusterId = void 0;
	                for (var c = 0, len = clusters.length; c < len; c++) {
	                    var cluster = clusters[c];
	                    if (cluster.indexOf(i) !== -1) {
	                        clusterId = c;
	                        break;
	                    }
	                }
	                return { id: i, x: scales.x(d[0]), y: scales.y(d[1]), clusterId: clusterId };
	            });
	        }, _this.start = function () {
	            var _this$props2 = _this.props,
	                width = _this$props2.width,
	                height = _this$props2.height;
	            var _this$state = _this.state,
	                data = _this$state.data,
	                epsilon = _this$state.epsilon,
	                minPoints = _this$state.minPoints;
	
	
	            var extent = _this.getMax(data);
	            var scales = _this.getScales(extent, width, height);
	
	            var dbscan = new _dbscan2.default(data, epsilon, minPoints);
	            var clusters = dbscan.run(data, epsilon, minPoints);
	
	            var animPoints = _this.getAnimPoints(data, clusters, scales);
	            _this.renderClusters(animPoints, clusters, epsilon, scales);
	
	            _this.setPointColors(animPoints);
	        }, _this.onChangeEpsilon = function (e) {
	            _this.setState({ epsilon: e.target.value });
	        }, _this.onChangeMaxTestPoints = function (e) {
	            _this.setState({ maxTestPoints: e.target.value });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    /**
	     * Helper array for animations
	     */
	
	
	    _createClass(DbscanView, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                width = _props.width,
	                height = _props.height;
	            var _state = this.state,
	                epsilon = _state.epsilon,
	                maxTestPoints = _state.maxTestPoints;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "dbscan dark-panel" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "DBSCAN (clustering)"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "acronym" },
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "D"
	                    ),
	                    "ensity\xA0",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "B"
	                    ),
	                    "ased\xA0",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "S"
	                    ),
	                    "patial\xA0",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "C"
	                    ),
	                    "lustering of\xA0",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "A"
	                    ),
	                    "pplications with\xA0",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "N"
	                    ),
	                    "oise\xA0"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "centered-panel" },
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Find clusters one point at a time. Use \"nearest neighbor\" to find other points close to one point within a threshold (epsilon). For each found point do the same until no more close points are found. Then start another cluster and keep going until all points have been touched. Outliers are skipped as \"noise\". When this runs, each colored circle is a nearest neighbor boundary."
	                    ),
	                    _react2.default.createElement(
	                        "svg",
	                        { width: width, height: height },
	                        _react2.default.createElement("rect", { x1: 0, y1: 0, width: width, height: height }),
	                        _react2.default.createElement("g", { className: "epsilon-plot-area" }),
	                        _react2.default.createElement("g", { className: "data-plot-area" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ui grid" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "eight wide column" },
	                                _react2.default.createElement(
	                                    "h4",
	                                    null,
	                                    "Max Points"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "ui left labeled input" },
	                                    _react2.default.createElement("input", {
	                                        type: "number",
	                                        value: maxTestPoints,
	                                        onChange: this.onChangeMaxTestPoints
	                                    })
	                                ),
	                                _react2.default.createElement("br", null),
	                                _react2.default.createElement("br", null),
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        className: "ui blue button",
	                                        onClick: this.generateData
	                                    },
	                                    "1. Generate data"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "eight wide column" },
	                                _react2.default.createElement(
	                                    "h4",
	                                    null,
	                                    "Epsilon"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "ui left labeled input" },
	                                    _react2.default.createElement("input", {
	                                        type: "number",
	                                        value: epsilon,
	                                        onChange: this.onChangeEpsilon
	                                    })
	                                ),
	                                _react2.default.createElement("br", null),
	                                _react2.default.createElement("br", null),
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        className: "ui orange button",
	                                        onClick: this.start
	                                    },
	                                    "2. Find Clusters"
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DbscanView;
	}(_react.Component);
	
	DbscanView.propTypes = {
	    epsilon: _propTypes.PropTypes.number,
	    minPoints: _propTypes.PropTypes.number,
	    width: _propTypes.PropTypes.number,
	    height: _propTypes.PropTypes.number
	};
	DbscanView.defaultProps = {
	    width: 800,
	    height: 600
	};
	exports.default = DbscanView;

/***/ },
/* 104 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * DBSCAN - Density based clustering
	 *
	 * @author Lukasz Krawczyk <contact@lukaszkrawczyk.eu>
	 * @copyright MIT
	 */
	
	/**
	 * DBSCAN class constructor
	 * @constructor
	 *
	 * @param {Array} dataset
	 * @param {number} epsilon
	 * @param {number} minPts
	 * @returns {DBSCAN}
	 */
	
	/**
	 * Lukasz Krawczyk's original code converted to ES6 class
	 */
	var DBSCAN = function DBSCAN(dataset, epsilon, minPts) {
	    _classCallCheck(this, DBSCAN);
	
	    _initialiseProps.call(this);
	
	    /** @type {Array} */
	    this.dataset = [];
	    /** @type {number} */
	    this.epsilon = 1;
	    /** @type {number} */
	    this.minPts = 2;
	    /** @type {function} */
	    this.distance = this._euclideanDistance;
	    /** @type {Array} */
	    this.clusters = [];
	    /** @type {Array} */
	    this.noise = [];
	
	    // temporary variables used during computation
	
	    /** @type {Array} */
	    this._visited = [];
	    /** @type {Array} */
	    this._assigned = [];
	    /** @type {number} */
	    this._datasetLength = 0;
	
	    this._init(dataset, epsilon, minPts);
	}
	
	/******************************************************************************/
	// public functions
	
	/**
	* Start clustering
	*
	* @param {Array} dataset
	* @param {number} epsilon
	* @param {number} minPts
	* @returns {undefined}
	* @access public
	*/
	
	
	/******************************************************************************/
	// protected functions
	
	/**
	* Set object properties
	*
	* @param {Array} dataset
	* @param {number} epsilon
	* @param {number} minPts
	* @param {function} distance
	* @returns {undefined}
	* @access protected
	*/
	
	
	/**
	* Expand cluster to closest points of given neighborhood
	*
	* @param {number} clusterId
	* @param {Array} neighbors
	* @returns {undefined}
	* @access protected
	*/
	
	
	/**
	* Add new point to cluster
	*
	* @param {number} pointId
	* @param {number} clusterId
	*/
	
	
	/**
	* Find all neighbors around given point
	*
	* @param {number} pointId,
	* @param {number} epsilon
	* @returns {Array}
	* @access protected
	*/
	
	
	/******************************************************************************/
	// helpers
	
	/**
	* @param {Array} a
	* @param {Array} b
	* @returns {Array}
	* @access protected
	*/
	
	
	/**
	* Calculate euclidean distance in multidimensional space
	*
	* @param {Array} p
	* @param {Array} q
	* @returns {number}
	* @access protected
	*/
	;
	
	// if (typeof module !== "undefined" && module.exports) {
	//     module.exports = DBSCAN;
	// }
	
	
	var _initialiseProps = function _initialiseProps() {
	    this.run = function (dataset, epsilon, minPts) {
	        this._init(dataset, epsilon, minPts);
	
	        for (var pointId = 0; pointId < this._datasetLength; pointId++) {
	            // if point is not visited, check if it forms a cluster
	            if (this._visited[pointId] !== 1) {
	                this._visited[pointId] = 1;
	
	                // if closest neighborhood is too small to form a cluster, mark as noise
	                var neighbors = this._regionQuery(pointId);
	
	                if (neighbors.length < this.minPts) {
	                    this.noise.push(pointId);
	                } else {
	                    // create new cluster and add point
	                    var clusterId = this.clusters.length;
	                    this.clusters.push([]);
	                    this._addToCluster(pointId, clusterId);
	
	                    this._expandCluster(clusterId, neighbors);
	                }
	            }
	        }
	
	        return this.clusters;
	    };
	
	    this._init = function (dataset, epsilon, minPts, distance) {
	        if (dataset) {
	            if (!(dataset instanceof Array)) {
	                throw Error("Dataset must be of type array, " + (typeof dataset === "undefined" ? "undefined" : _typeof(dataset)) + " given");
	            }
	
	            this.dataset = dataset;
	            this.clusters = [];
	            this.noise = [];
	
	            this._datasetLength = dataset.length;
	            this._visited = new Array(this._datasetLength);
	            this._assigned = new Array(this._datasetLength);
	        }
	
	        if (epsilon) {
	            this.epsilon = epsilon;
	        }
	
	        if (minPts) {
	            this.minPts = minPts;
	        }
	
	        if (distance) {
	            this.distance = distance;
	        }
	    };
	
	    this._expandCluster = function (clusterId, neighbors) {
	        /**
	        * It's very important to calculate length of neighbors array each time,
	        * as the number of elements changes over time
	        */
	        for (var i = 0; i < neighbors.length; i++) {
	            var pointId2 = neighbors[i];
	
	            if (this._visited[pointId2] !== 1) {
	                this._visited[pointId2] = 1;
	                var neighbors2 = this._regionQuery(pointId2);
	
	                if (neighbors2.length >= this.minPts) {
	                    neighbors = this._mergeArrays(neighbors, neighbors2);
	                }
	            }
	
	            // add to cluster
	            if (this._assigned[pointId2] !== 1) {
	                this._addToCluster(pointId2, clusterId);
	            }
	        }
	    };
	
	    this._addToCluster = function (pointId, clusterId) {
	        this.clusters[clusterId].push(pointId);
	        this._assigned[pointId] = 1;
	    };
	
	    this._regionQuery = function (pointId) {
	        var neighbors = [];
	
	        for (var id = 0; id < this._datasetLength; id++) {
	            var dist = this.distance(this.dataset[pointId], this.dataset[id]);
	            if (dist < this.epsilon) {
	                neighbors.push(id);
	            }
	        }
	
	        return neighbors;
	    };
	
	    this._mergeArrays = function (a, b) {
	        var len = b.length;
	
	        for (var i = 0; i < len; i++) {
	            var P = b[i];
	            if (a.indexOf(P) < 0) {
	                a.push(P);
	            }
	        }
	
	        return a;
	    };
	
	    this._euclideanDistance = function (p, q) {
	        var sum = 0;
	        var i = Math.min(p.length, q.length);
	
	        while (i--) {
	            sum += (p[i] - q[i]) * (p[i] - q[i]);
	        }
	
	        return Math.sqrt(sum);
	    };
	};
	
	exports.default = DBSCAN;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactDom = __webpack_require__(145);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(120);
	
	var _routes = __webpack_require__(110);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_routes2.default, document.getElementById('root'));

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _d = __webpack_require__(23);
	
	var d3 = _interopRequireWildcard(_d);
	
	__webpack_require__(121);
	
	var _common = __webpack_require__(37);
	
	var _trainingData = __webpack_require__(107);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MIN_COLUMN = 0;
	var MAX_COLUMN = 1;
	var RANGE_COLUMN = 2;
	var MEANS_ANIM_DURATION = 1000;
	var ITERATION_DELAY = 2000;
	
	function random(min, max) {
	    return Math.floor(Math.random() * (max - min + 1) + min);
	}
	
	/*
	    Algorithm:
	
	    1. Plot data points
	    2. Create "k" additional points, placing them randomly on your graph. These points are the "cluster centroids" -- or the candidates for the centers of your clusters.
	
	    Repeat the following:
	    1. Assign each data point to the closest of the "k" clusterer centroids. Some points may change the centroid to which they belong.
	    2. Move the centroid to the average position of all the data points that belong to it
	    3. If any of the centroids moved in the last step, repeat. If nothing moved, were done. Currently point assignments are the clusters
	*/
	
	var Knn = function (_Component) {
	    _inherits(Knn, _Component);
	
	    function Knn() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Knn);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Knn.__proto__ || Object.getPrototypeOf(Knn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            means: null,
	            k: 3
	        }, _this.getScales = function (extents, width, height) {
	            // Always two scales (x,y) since we can only plot 2 dimensional data,
	            // even though the algorithm can support any number of dimensions!
	            var scaleX = d3.scaleLinear().domain([0, extents[0][MAX_COLUMN]]).range([0, width]);
	
	            var scaleY = d3.scaleLinear().domain([0, extents[1][MAX_COLUMN]]).range([0, height]);
	
	            return { x: scaleX, y: scaleY };
	        }, _this.initMeans = function (k, extents) {
	            var means = [];
	
	            while (k--) {
	                var mean = [random(extents[0][0], extents[0][1]), random(extents[1][0], extents[1][1])];
	
	                // Generate coordinates in all dimensions
	                // for (let dimensionIndex in extents) {
	                //     mean[dimensionIndex] = random(10, 90);
	                // }
	                means.push(mean);
	            }
	
	            return means;
	        }, _this.renderMeans = function (means, scales, iteration) {
	            var update = d3.select(".means-plot-area").selectAll(".mean-point").data(means);
	
	            // add new
	            update.enter().append("circle").attr("class", "mean-point").attr("cx", function (d) {
	                return scales.x(d[0]);
	            }).attr("cy", function (d) {
	                return scales.y(d[1]);
	            }).attr("r", 5);
	
	            // animate move existing
	            update.transition().duration(MEANS_ANIM_DURATION).delay(ITERATION_DELAY * iteration).attr("cx", function (d) {
	                return scales.x(d[0]);
	            }).attr("cy", function (d) {
	                return scales.y(d[1]);
	            });
	        }, _this.renderAssignmentLines = function (assignments, trainingData, means, iteration, retain) {
	            var scales = _this.state.scales;
	
	            // Iteration must be added to the class name since all lines are drawn at the
	            // same time. Only the the delay is increases for each iteration.
	
	            var update = d3.select(".assignments-plot-area").selectAll(".assignment-line i" + iteration).data(assignments);
	
	            // line from mean point to training data point
	            update.enter().append("line").attr("class", "assignment-line i" + iteration).attr("x1", function (a) {
	                return scales.x(means[a][0]);
	            }).attr("y1", function (a) {
	                return scales.y(means[a][1]);
	            }).attr("x2", function (a, i) {
	                return scales.x(trainingData[i][0]);
	            }).attr("y2", function (a, i) {
	                return scales.y(trainingData[i][1]);
	            }).style("visibility", "hidden").transition().duration(1).delay(ITERATION_DELAY * iteration + MEANS_ANIM_DURATION).style("visibility", "visible").transition().duration(1).delay(500).filter(function () {
	                return !retain;
	            }).remove();
	        }, _this.stepPlotTraining = function () {
	            var _this$props = _this.props,
	                width = _this$props.width,
	                height = _this$props.height,
	                pad = _this$props.pad;
	
	            var innerWidth = width - pad * 2;
	            var innerHeight = height - pad * 2;
	
	            //const data = this.generateRandomTargetData();
	            var data = (0, _common.generateClumps)();
	
	            var extents = (0, _common.getExtent)(data);
	            var scales = _this.getScales(extents, innerWidth, innerHeight);
	
	            _this.removeAssignmentLines();
	
	            _this.setState({
	                trainingData: data,
	                extents: extents,
	                scales: scales
	            });
	        }, _this.stepGenerateMeans = function () {
	            var _this$state = _this.state,
	                extents = _this$state.extents,
	                scales = _this$state.scales,
	                k = _this$state.k;
	
	            var means = _this.initMeans(k, extents);
	
	            _this.removeAssignmentLines();
	
	            _this.setState({ means: means }, function () {
	                _this.renderMeans(means, scales, 0);
	            });
	        }, _this.stepFindCentroids = function () {
	            var _this$state2 = _this.state,
	                trainingData = _this$state2.trainingData,
	                means = _this$state2.means,
	                scales = _this$state2.scales,
	                extents = _this$state2.extents;
	
	
	            var moveResult = {};
	            var assignments = void 0;
	
	            // Loop until mean points stop moving
	            // (don't hang the browser -- 100 max interations)
	            for (var iteration = 0; iteration < 100; iteration++) {
	                assignments = _this.makeAssignments(trainingData, means);
	                moveResult = _this.moveMeans(means, assignments, trainingData, extents);
	
	                if (moveResult.moved) {
	                    means = moveResult.nextMeans;
	                    _this.renderMeans(means, scales, iteration);
	                    _this.renderAssignmentLines(assignments, trainingData, means, iteration, false);
	                } else {
	                    _this.renderAssignmentLines(assignments, trainingData, means, iteration, true);
	                    break;
	                }
	            }
	        }, _this.handleKChange = function (e) {
	            _this.setState({ k: e.target.value });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Knn, [{
	        key: "generateRandomTargetData",
	        value: function generateRandomTargetData() {
	            var count = random(30, 50);
	            var data = [];
	
	            for (var i = 0; i < count; i++) {
	                data.push([random(1, 100), random(1, 100)]);
	            }
	            return data;
	        }
	
	        /* Create D3 scales for all rendering to follow */
	
	
	        /* Create k random points */
	
	    }, {
	        key: "makeAssignments",
	
	
	        /* Assign each training data point to its closest mean point (nearest neighbor) */
	        value: function makeAssignments(data, means) {
	            var assignments = [];
	
	            // Iterate data points
	            for (var dataIndex in data) {
	                var dataPoint = data[dataIndex];
	                var distances = [];
	
	                // Iterate means points
	                for (var meanIndex in means) {
	                    var meanPoint = means[meanIndex];
	                    var sum = 0;
	
	                    // Measure distance of eacg meanPoint to the dataPoint
	                    for (var dimensionIndex in dataPoint) {
	                        var difference = dataPoint[dimensionIndex] - meanPoint[dimensionIndex];
	                        difference *= difference;
	                        sum += difference;
	                    }
	                    distances[meanIndex] = Math.sqrt(sum);
	                }
	
	                // Assign dataPoint to index of mean with shortest distance
	                assignments[dataIndex] = distances.indexOf(Math.min.apply(null, distances));
	            }
	
	            // Each dataPoint's closest meanPoint
	            return assignments;
	        }
	
	        /* D3 animate the mean points */
	
	    }, {
	        key: "removeAssignmentLines",
	
	
	        /* Delete all previous assignment lines */
	        value: function removeAssignmentLines() {
	            d3.select(".assignments-plot-area").selectAll(".assignment-line").remove();
	            d3.select(".means-plot-area").selectAll(".mean-point").remove();
	        }
	
	        /* D3 render a line connecting each training point to its assigned mean point */
	
	    }, {
	        key: "moveMeans",
	
	
	        /* For each mean point, calculate the centeroid of its current cluster, then move the mean point to that centeroid */
	        value: function moveMeans(means, assignments, data, extents) {
	            var sums = new Array(means.length);
	            var counts = new Array(means.length);
	            var moved = false;
	
	            for (var j in means) {
	                counts[j] = 0;
	                sums[j] = Array(means[j].length);
	                for (var dimension in means[j]) {
	                    sums[j][dimension] = 0;
	                }
	            }
	
	            for (var pointIndex in assignments) {
	                var meanIndex = assignments[pointIndex];
	                var point = data[pointIndex];
	                var mean = means[meanIndex];
	
	                counts[meanIndex]++;
	
	                for (var dimensionIndex in mean) {
	                    sums[meanIndex][dimensionIndex] += point[dimensionIndex];
	                }
	            }
	
	            for (var _meanIndex in sums) {
	                console.log(counts[_meanIndex]);
	                if (0 === counts[_meanIndex]) {
	                    sums[_meanIndex] = means[_meanIndex];
	                    console.log("Mean with no points");
	                    console.log(sums[_meanIndex]);
	
	                    for (var _dimensionIndex in extents) {
	                        sums[_meanIndex][_dimensionIndex] = extents[_dimensionIndex][MIN_COLUMN] + Math.random() * extents[_dimensionIndex][RANGE_COLUMN];
	                    }
	                    continue;
	                }
	
	                for (var _dimensionIndex2 in sums[_meanIndex]) {
	                    sums[_meanIndex][_dimensionIndex2] /= counts[_meanIndex];
	                }
	            }
	
	            if (means.toString() !== sums.toString()) {
	                moved = true;
	            }
	
	            return { nextMeans: sums, moved: moved };
	        }
	
	        // STEP 1 - Plot data points
	
	
	        // STEP 2 - Draw random mean points
	
	
	        // STEP 3 - Iterate the clusting algorithm until mean points settle into position
	
	    }, {
	        key: "render",
	        value: function render() {
	            var _state = this.state,
	                trainingData = _state.trainingData,
	                scales = _state.scales;
	            var _props = this.props,
	                width = _props.width,
	                height = _props.height,
	                pad = _props.pad;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "kmc dark-panel" },
	                _react2.default.createElement(
	                    "h1",
	                    { className: "ui header" },
	                    "k Means (clustering)"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "centered-panel" },
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Find clusters by iteration. For each blue point find the nearest red point. Then calculate the centroid of each group and move each red point to the centroid of it's group. Repeat until red points no longer move. Data points (blue) might change alegiance to their cluster point (red) during this process."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "\"k\" refers to the number of cluster points to use (3 for this demo)."
	                    ),
	                    _react2.default.createElement(
	                        "svg",
	                        { className: "container", width: width, height: height },
	                        _react2.default.createElement("rect", {
	                            className: "border",
	                            width: width,
	                            height: height
	                        }),
	                        _react2.default.createElement("g", {
	                            className: "measurement-area",
	                            transform: "translate(" + pad + " " + pad + ")"
	                        }),
	                        _react2.default.createElement("g", {
	                            className: "assignments-plot-area",
	                            transform: "translate(" + pad + " " + pad + ")"
	                        }),
	                        _react2.default.createElement(
	                            "g",
	                            {
	                                className: "plot-area",
	                                transform: "translate(" + pad + " " + pad + ")"
	                            },
	                            scales && trainingData.map(function (d, i) {
	                                return _react2.default.createElement("circle", {
	                                    className: "training-point",
	                                    key: i,
	                                    cx: scales.x(d[0]),
	                                    cy: scales.y(d[1]),
	                                    r: "5",
	                                    style: { fill: "#55f" }
	                                });
	                            })
	                        ),
	                        _react2.default.createElement("g", {
	                            className: "means-plot-area",
	                            transform: "translate(" + pad + " " + pad + ")"
	                        })
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: "ui blue button",
	                                onClick: this.stepPlotTraining,
	                                style: { width: 220, textAlign: "left" }
	                            },
	                            "1. Plot random data"
	                        )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ui left labeled input" },
	                        _react2.default.createElement(
	                            "label",
	                            { className: "ui label" },
	                            "k ="
	                        ),
	                        _react2.default.createElement("input", {
	                            value: this.state.k,
	                            onChange: this.handleKChange
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: "ui red button",
	                                onClick: this.stepGenerateMeans,
	                                style: { width: 220, textAlign: "left" }
	                            },
	                            "2. Set random cluster points"
	                        )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: "ui orange button",
	                                onClick: this.stepFindCentroids,
	                                style: { width: 220, textAlign: "left" }
	                            },
	                            "3. Find Clusters"
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Knn;
	}(_react.Component);
	
	Knn.propTypes = {
	    trainingData: _propTypes.PropTypes.array
	};
	Knn.defaultProps = {
	    trainingData: _trainingData.TRAINING_DATA,
	    width: 600,
	    height: 600,
	    pad: 30
	};
	exports.default = Knn;

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TRAINING_DATA = exports.TRAINING_DATA = [[1, 2], [2, 1], [2, 4], [1, 3], [2, 2], [3, 1], [1, 1], [7, 3], [8, 2], [6, 4], [7, 4], [8, 1], [9, 2], [10, 8], [9, 10], [7, 8], [7, 9], [8, 11], [9, 9]];

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _d = __webpack_require__(23);
	
	var d3 = _interopRequireWildcard(_d);
	
	__webpack_require__(122);
	
	var _common = __webpack_require__(37);
	
	var _trainingData = __webpack_require__(109);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEMO_ANIM_TIME = 1000;
	
	/*
	    The basic procedure of this class is as follows:
	
	    1. Render underlying HTML structure and training data points. React does this rendering step.
	    2. Wait for click
	    3. Upon click calculate kNN and related data and save to state
	    4. After state is saved and view updates, run animations with appropriate stagger delays. D3 renders this step directly to the DOM.
	*/
	
	var Knn = function (_Component) {
	    _inherits(Knn, _Component);
	
	    function Knn() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Knn);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Knn.__proto__ || Object.getPrototypeOf(Knn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            color: null,
	            distances: null,
	            extents: null,
	            guesses: null,
	            innerHeight: null,
	            innerWidth: null,
	            roi: null,
	            scales: null,
	            typeCol: null,
	            types: null,
	            unknownNode: null
	        }, _this.getScales = function (extents, width, height) {
	            // Always two scales (x,y) since we can only plot 2 dimensional data,
	            // even though the algorithm can support any number of dimensions!
	            var scaleX = d3.scaleLinear().domain([0, extents[0][1]]).range([0, width]);
	
	            var scaleY = d3.scaleLinear().domain([0, extents[1][1]]).range([height, 0]);
	
	            return { x: scaleX, y: scaleY };
	        }, _this.measureDistancesFromUnknown = function (node, extents, data) {
	            var distances = [];
	
	            // Iterate dimensions (columns)
	            for (var di = 0, dlen = data.length; di < dlen; di++) {
	                var datum = data[di];
	
	                // Get distance from unknown node to training node
	                // Pythagorean Theorem works for any number of dimensions!
	                var squares = [];
	
	                // Subtract one to skip the "type" column
	                for (var ci = 0, clen = datum.length; ci < clen - 1; ci++) {
	                    // Difference of training node value and unknown node value
	                    var delta = datum[ci] - node[ci];
	
	                    // Divide the difference by the size of this dimension's extent
	                    delta /= extents[ci][2]; // 2 = size column
	
	                    // Square the result for summing later
	                    squares.push(delta * delta);
	                }
	
	                // Length of vector from this node to training node. Complete's Pythagorean Theorem
	                distances.push([Math.sqrt(d3.sum(squares)), di]);
	            }
	
	            distances.sort(function (a, b) {
	                return a[0] - b[0];
	            });
	            return distances;
	        }, _this.guessType = function (node, data, distances, typeCol, k) {
	            var typeTallies = {};
	
	            // Tally type count of the top K training nodes
	            for (var i = 0; i < k; i++) {
	                var distanceData = distances[i];
	
	                // Get data element referenced by distanceData, and get it's type.
	                // distanceData includes a reference index into the trainingData
	                var type = data[distanceData[1]][typeCol];
	
	                if (!typeTallies[type]) {
	                    typeTallies[type] = 0;
	                }
	
	                typeTallies[type] += 1;
	            }
	
	            var guesses = Object.keys(typeTallies).map(function (type) {
	                return { type: type, count: typeTallies[type] };
	            });
	
	            // Sort highest tally counts first
	            guesses.sort(function (a, b) {
	                return b.count - a.count;
	            });
	
	            return guesses;
	        }, _this.getTypeColumnIndex = function (dimensions) {
	            // Assumed to be the last column for now
	            return dimensions ? dimensions.length - 1 : 0;
	        }, _this.getUniqueTypes = function (trainingData) {
	            if (!trainingData) {
	                return [];
	            }
	
	            var dimensions = trainingData.dimensions,
	                data = trainingData.data;
	
	            var typeCol = _this.getTypeColumnIndex(dimensions);
	
	            var uniqueTypes = data.reduce(function (acc, d) {
	                acc[d[typeCol]] = true;
	                return acc;
	            }, {});
	
	            return Object.keys(uniqueTypes);
	        }, _this.setupClick = function () {
	            var self = _this;
	            d3.select(".click-area").on("click", function () {
	                var coords = d3.mouse(this);
	                self.onClick(coords[0], coords[1]);
	            });
	        }, _this.onClick = function (dx, dy) {
	            var _this$props = _this.props,
	                trainingData = _this$props.trainingData,
	                k = _this$props.k;
	            var _this$state = _this.state,
	                extents = _this$state.extents,
	                innerWidth = _this$state.innerWidth,
	                scales = _this$state.scales,
	                typeCol = _this$state.typeCol;
	
	            // calculate kNN
	
	            var unknownNode = [scales.x.invert(dx), scales.y.invert(dy), null];
	
	            // Get distance from unknown node to every training node
	            var distances = _this.measureDistancesFromUnknown(unknownNode, extents, trainingData.data);
	
	            // Run the algorithm to get a ranked list of guesses
	            var guesses = _this.guessType(unknownNode, trainingData.data, distances, typeCol, k);
	
	            // Calculate radius of influence
	            var roi = distances[k - 1][0] * innerWidth;
	
	            _this.setState({
	                unknownNode: unknownNode,
	                distances: distances,
	                guesses: guesses,
	                roi: roi
	            });
	        }, _this.renderMeasurementLines = function () {
	            var data = _this.props.trainingData.data;
	            var _this$state2 = _this.state,
	                scales = _this$state2.scales,
	                unknownNode = _this$state2.unknownNode;
	
	            // Determine animation increment
	
	            var len = data.length;
	            var inc = DEMO_ANIM_TIME / len;
	
	            // D3 data bind
	            var update = d3.select("g.measurement-lines").selectAll(".measurement-line").data(data);
	
	            // Draw each line invisible
	            update.enter().append("line").attr("class", "measurement-line").attr("x1", scales.x(unknownNode[0])).attr("y1", scales.y(unknownNode[1])).attr("x2", function (d) {
	                return scales.x(d[0]);
	            }).attr("y2", function (d) {
	                return scales.y(d[1]);
	            }).style("visibility", "hidden")
	            // Reveal each line with a staggered delay
	            .transition().duration(1).delay(function (d, i) {
	                return i * inc;
	            }).style("visibility", "visible")
	            // After a short delay delete the line
	            .transition(1).delay(125).remove();
	        }, _this.renderRadiusOfInfluence = function () {
	            var _this$state3 = _this.state,
	                unknownNode = _this$state3.unknownNode,
	                scales = _this$state3.scales,
	                roi = _this$state3.roi;
	
	
	            d3.select(".unknown-group .radius-of-influence").remove();
	
	            d3.select(".unknown-group").append("circle").attr("class", "radius-of-influence").attr("cx", scales.x(unknownNode[0])).attr("cy", scales.y(unknownNode[1])).attr("r", 0).style("fill", "none")
	            // Animate size
	            .transition().delay(DEMO_ANIM_TIME).duration(500).attr("r", roi);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Knn, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.setupClick();
	        }
	
	        /* Get scales which translate data values to screen pixels */
	
	
	        /* Get distance from unknown node to every training node */
	
	
	        /* Get top k guesses for the unknown node */
	
	
	        /* Get index of category column */
	
	
	        /* Find all unique category types in the training data */
	
	    }, {
	        key: "componentWillMount",
	
	
	        /* Before rendering calculate scales for the plot area */
	        value: function componentWillMount() {
	            // Calculate extents and scales and save in state
	            var _props = this.props,
	                trainingData = _props.trainingData,
	                width = _props.width,
	                height = _props.height,
	                pad = _props.pad;
	            var dimensions = trainingData.dimensions,
	                data = trainingData.data;
	
	
	            var extents = (0, _common.getExtent)(data);
	            var innerWidth = width - pad * 2;
	            var innerHeight = height - pad * 2;
	            var scales = this.getScales(extents, innerWidth, innerHeight);
	
	            // Get unique types in the data and assign a color to each
	            var types = this.getUniqueTypes(trainingData);
	            var typesLen = types.length;
	            var color = d3.scaleOrdinal().domain(types).range(d3.schemeCategory10.filter(function (d, i) {
	                return i < typesLen;
	            }));
	
	            var typeCol = this.getTypeColumnIndex(dimensions);
	
	            // Save state for rendering
	            this.setState({
	                extents: extents,
	                innerWidth: innerWidth,
	                innerHeight: innerHeight,
	                scales: scales,
	                types: types,
	                color: color,
	                typeCol: typeCol
	            });
	        }
	
	        /* Initialize the click handler */
	
	
	        /* Upon click calculate guesses and related data and save to state */
	
	    }, {
	        key: "componentDidUpdate",
	
	
	        /* Now that calculation data is saved to state render click feedback (click point, measurement lines, radius of influence) */
	        value: function componentDidUpdate() {
	            this.renderUnknownNode();
	            this.renderMeasurementLines();
	            this.renderRadiusOfInfluence();
	        }
	
	        /* Render unknown node directly to the DOM with D3 */
	
	    }, {
	        key: "renderUnknownNode",
	        value: function renderUnknownNode() {
	            var _state = this.state,
	                unknownNode = _state.unknownNode,
	                scales = _state.scales;
	
	
	            d3.select(".unknown-group .unknown-node").remove();
	
	            d3.selectAll(".unknown-group").append("circle").attr("class", "unknown-node").attr("cx", scales.x(unknownNode[0])).attr("cy", scales.y(unknownNode[1])).attr("r", 7).style("fill", "#aaa");
	        }
	
	        /* Render measurement lines directly to the DOM with D3 */
	
	
	        /* Render radius of influence directly to the DOM with D3 */
	
	    }, {
	        key: "render",
	
	
	        /* React render hook renders the underlying HTML structure whenever state changes.
	           We render click feedback and results with the D3 functions above */
	        value: function render() {
	            var _props2 = this.props,
	                trainingData = _props2.trainingData,
	                k = _props2.k,
	                width = _props2.width,
	                height = _props2.height,
	                pad = _props2.pad;
	            var dimensions = trainingData.dimensions;
	            var _state2 = this.state,
	                unknownNode = _state2.unknownNode,
	                scales = _state2.scales,
	                typeCol = _state2.typeCol,
	                color = _state2.color,
	                types = _state2.types,
	                guesses = _state2.guesses;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "knn dark-panel" },
	                _react2.default.createElement(
	                    "h1",
	                    { className: "ui header" },
	                    "kNN - k Nearest Neighbor (classifier)"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "centered-panel" },
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Classify a data point as a house, apartment, or loft, based on square footage and number of rooms.  The colored points below are training data of known values. When you click a new point below, it's classification is determined based on the known values. The distance to every known value is measured. The closest known points determine the answer."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "\"k\" refers to the number of close points to find in determining the classification (3 for this demo)."
	                    ),
	                    _react2.default.createElement(
	                        "svg",
	                        { className: "container", width: width, height: height },
	                        _react2.default.createElement(
	                            "text",
	                            { x: width / 2, y: height - 3, textAnchor: "middle" },
	                            dimensions[0]
	                        ),
	                        _react2.default.createElement(
	                            "g",
	                            { transform: "translate(10 " + height / 2 + ")" },
	                            _react2.default.createElement(
	                                "text",
	                                { textAnchor: "middle", transform: "rotate(-90)" },
	                                dimensions[1]
	                            )
	                        ),
	                        _react2.default.createElement("rect", {
	                            className: "border",
	                            width: width,
	                            height: height
	                        }),
	                        _react2.default.createElement("g", {
	                            className: "measurement-area",
	                            transform: "translate(" + pad + " " + pad + ")"
	                        }),
	                        _react2.default.createElement(
	                            "g",
	                            {
	                                className: "plot-area",
	                                transform: "translate(" + pad + " " + pad + ")"
	                            },
	                            _react2.default.createElement("rect", {
	                                className: "click-area",
	                                width: innerWidth,
	                                height: innerHeight,
	                                style: { opacity: 0 }
	                            }),
	                            /* Render all training points */
	                            scales.x && trainingData.data.map(function (d, i) {
	                                return _react2.default.createElement("circle", {
	                                    className: "training-point",
	                                    key: i,
	                                    cx: scales.x(d[0]),
	                                    cy: scales.y(d[1]),
	                                    r: "5",
	                                    style: { fill: color(d[typeCol]) }
	                                });
	                            }),
	                            _react2.default.createElement("g", { className: "measurement-lines" }),
	                            _react2.default.createElement("g", { className: "unknown-group" })
	                        )
	                    ),
	                    unknownNode && _react2.default.createElement(
	                        "div",
	                        null,
	                        "Unknown node: " + dimensions[0] + ": " + unknownNode[0].toFixed(0) + ", " + dimensions[1] + ": " + unknownNode[1].toFixed(0)
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        {
	                            className: "ui grid result",
	                            style: { width: width, marginTop: 30 }
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "eight wide column" },
	                                _react2.default.createElement(
	                                    "h4",
	                                    { className: "ui header" },
	                                    "Legend"
	                                ),
	                                types.map(function (d, i) {
	                                    return _react2.default.createElement(
	                                        "div",
	                                        { key: i, className: "legend" },
	                                        _react2.default.createElement("div", {
	                                            className: "legend-box",
	                                            style: {
	                                                backgroundColor: color(i)
	                                            }
	                                        }),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "legend-label" },
	                                            d
	                                        )
	                                    );
	                                })
	                            ),
	                            /* Render list of guesses */
	                            guesses && _react2.default.createElement(
	                                "div",
	                                { className: "eight wide column" },
	                                _react2.default.createElement(
	                                    "h4",
	                                    { className: "ui header" },
	                                    "Guesses"
	                                ),
	                                guesses.map(function (d, i) {
	                                    return _react2.default.createElement(
	                                        "div",
	                                        { key: i, className: "legend" },
	                                        _react2.default.createElement("div", {
	                                            className: "legend-box",
	                                            style: {
	                                                backgroundColor: color(d.type)
	                                            }
	                                        }),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "legend-label" },
	                                            d.type,
	                                            " ",
	                                            "(confidence:",
	                                            " ",
	                                            (d.count * (100 / k)).toFixed(0),
	                                            "%)"
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Knn;
	}(_react.Component);
	
	Knn.propTypes = {
	    trainingData: _propTypes.PropTypes.object,
	    k: _propTypes.PropTypes.number
	};
	Knn.defaultProps = {
	    trainingData: _trainingData.TRAINING_DATA,
	    k: 3,
	    width: 600,
	    height: 600,
	    pad: 30
	};
	exports.default = Knn;

/***/ },
/* 109 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TRAINING_DATA = exports.TRAINING_DATA = {
	    data: [[1, 350, "apartment"], [2, 300, "apartment"], [3, 300, "apartment"], [4, 250, "apartment"], [4, 500, "apartment"], [4, 400, "apartment"], [5, 450, "apartment"], [7, 850, "house"], [7, 900, "house"], [7, 1200, "house"], [8, 1500, "house"], [9, 1300, "house"], [8, 1240, "house"], [10, 1700, "house"], [9, 1000, "house"], [1, 800, "loft"], [3, 900, "loft"], [2, 700, "loft"], [1, 900, "loft"], [2, 1150, "loft"], [1, 1000, "loft"], [2, 1200, "loft"], [1, 1300, "loft"]],
	    dimensions: ["rooms", "area", "type"]
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(91);
	
	var _reactRouter = __webpack_require__(9);
	
	var _history = __webpack_require__(136);
	
	var _application = __webpack_require__(100);
	
	var _application2 = _interopRequireDefault(_application);
	
	var _knn = __webpack_require__(108);
	
	var _knn2 = _interopRequireDefault(_knn);
	
	var _kmc = __webpack_require__(106);
	
	var _kmc2 = _interopRequireDefault(_kmc);
	
	var _bayes = __webpack_require__(101);
	
	var _bayes2 = _interopRequireDefault(_bayes);
	
	var _sentiment = __webpack_require__(114);
	
	var _sentiment2 = _interopRequireDefault(_sentiment);
	
	var _dbscanView = __webpack_require__(103);
	
	var _dbscanView2 = _interopRequireDefault(_dbscanView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	    _reactRouterDom.BrowserRouter,
	    { history: _history.browserHistory },
	    _react2.default.createElement(
	        _application2.default,
	        null,
	        _react2.default.createElement(
	            _reactRouter.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/knn', component: _knn2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/kmc', component: _kmc2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/bayes', component: _bayes2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/sentiment', component: _sentiment2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/dbscan', component: _dbscanView2.default }),
	            _react2.default.createElement(_reactRouterDom.Redirect, { from: '/', to: '/knn' })
	        )
	    )
	);

/***/ },
/* 111 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	The following is not free software. You may use it for educational purposes, but you may not redistribute or use it commercially.
	(C) All Rights Reserved, Burak Kanber 2013
	*/
	var getStorage = exports.getStorage = function getStorage() {
	    var Storage = {};
	    Storage._data = {};
	    Storage.setItem = function (k, v) {
	        Storage._data[k] = v;
	        return Storage;
	    };
	    Storage.getItem = function (k) {
	        if (typeof Storage._data[k] === 'undefined') return null;
	        return Storage._data[k];
	    };
	
	    return Storage;
	};
	
	var getBayes = exports.getBayes = function getBayes() {
	    var Bayes = {};
	    Bayes.debug = true;
	    Array.prototype.unique = function () {
	        var u = {},
	            a = [];
	        for (var i = 0, l = this.length; i < l; ++i) {
	            if (u.hasOwnProperty(this[i])) {
	                continue;
	            }
	            a.push(this[i]);
	            u[this[i]] = 1;
	        }
	        return a;
	    };
	    var stemKey = function stemKey(stem, label) {
	        return '_Bayes::stem:' + stem + '::label:' + label;
	    };
	    var docCountKey = function docCountKey(label) {
	        return '_Bayes::docCount:' + label;
	    };
	    var stemCountKey = function stemCountKey(stem) {
	        return '_Bayes::stemCount:' + stem;
	    };
	
	    var log = function log(text) {
	        if (Bayes.debug) console.log(text);
	    };
	
	    var getLabels = function getLabels() {
	        var labels = Bayes.storage.getItem('_Bayes::registeredLabels');
	        if (!labels) labels = '';
	        return labels.split(',').filter(function (a) {
	            return a.length;
	        });
	    };
	
	    var registerLabel = function registerLabel(label) {
	        var labels = getLabels();
	        if (labels.indexOf(label) === -1) {
	            labels.push(label);
	            Bayes.storage.setItem('_Bayes::registeredLabels', labels.join(','));
	        }
	        return true;
	    };
	
	    var stemLabelCount = function stemLabelCount(stem, label) {
	        var count = parseInt(Bayes.storage.getItem(stemKey(stem, label)));
	        if (!count) count = 0;
	        return count;
	    };
	    var stemInverseLabelCount = function stemInverseLabelCount(stem, label) {
	        var labels = getLabels();
	        var total = 0;
	        for (var i = 0, length = labels.length; i < length; i++) {
	            if (labels[i] === label) continue;
	            total += parseInt(stemLabelCount(stem, labels[i]));
	        }
	        return total;
	    };
	
	    var stemTotalCount = function stemTotalCount(stem) {
	        var count = parseInt(Bayes.storage.getItem(stemCountKey(stem)));
	        if (!count) count = 0;
	        return count;
	    };
	    var docCount = function docCount(label) {
	        var count = parseInt(Bayes.storage.getItem(docCountKey(label)));
	        if (!count) count = 0;
	        return count;
	    };
	    var docInverseCount = function docInverseCount(label) {
	        var labels = getLabels();
	        var total = 0;
	        for (var i = 0, length = labels.length; i < length; i++) {
	            if (labels[i] === label) continue;
	            total += parseInt(docCount(labels[i]));
	        }
	        return total;
	    };
	    var increment = function increment(key) {
	        var count = parseInt(Bayes.storage.getItem(key));
	        if (!count) count = 0;
	        Bayes.storage.setItem(key, parseInt(count) + 1);
	        return count + 1;
	    };
	
	    var incrementStem = function incrementStem(stem, label) {
	        increment(stemCountKey(stem));
	        increment(stemKey(stem, label));
	    };
	
	    var incrementDocCount = function incrementDocCount(label) {
	        return increment(docCountKey(label));
	    };
	
	    Bayes.unigramTokenizer = function (text) {
	        text = text.toLowerCase().replace(/'/g, '').replace(/\W/g, ' ').replace(/\s+/g, ' ').trim().split(' ');
	        return text;
	    };
	
	    Bayes.bigramTokenizer = function (text) {
	        text = Bayes.unigramTokenizer(text);
	        var toks = [];
	        for (var i = 0, len = text.length; i < len - 1; i++) {
	            toks.push(text.slice(i, i + 2).join(' '));
	        }return toks;
	    };
	
	    // Set the default tokenizer to unigramTokenizer
	    Bayes.tokenizer = Bayes.unigramTokenizer;
	    // Set the storage engine.
	    Bayes.storage = localStorage;
	
	    Bayes.train = function (text, label) {
	        registerLabel(label);
	        var words = Bayes.tokenizer(text);
	        var length = words.length;
	        for (var i = 0; i < length; i++) {
	            incrementStem(words[i], label);
	        }incrementDocCount(label);
	    };
	
	    Bayes.guess = function (text) {
	        var words = Bayes.tokenizer(text);
	        var length = words.length;
	        var labels = getLabels();
	        var totalDocCount = 0;
	        var docCounts = {};
	        var docInverseCounts = {};
	        var scores = {};
	        var labelProbability = {};
	        var wordicities = {};
	
	        for (var j = 0; j < labels.length; j++) {
	            var label = labels[j];
	            docCounts[label] = docCount(label);
	            docInverseCounts[label] = docInverseCount(label);
	            totalDocCount += parseInt(docCounts[label]);
	        }
	
	        for (var j = 0; j < labels.length; j++) {
	            var label = labels[j];
	            var logSum = 0;
	            labelProbability[label] = docCounts[label] / totalDocCount;
	
	            for (var i = 0; i < length; i++) {
	                var word = words[i];
	                var _stemTotalCount = stemTotalCount(word);
	                if (_stemTotalCount === 0) {
	                    continue;
	                } else {
	                    var wordProbability = stemLabelCount(word, label) / docCounts[label];
	                    var wordInverseProbability = stemInverseLabelCount(word, label) / docInverseCounts[label];
	                    var wordicity = wordProbability / (wordProbability + wordInverseProbability);
	                    // Adjusted wordicity for rare words.
	                    wordicity = (3 * 0.5 + _stemTotalCount * wordicity) / (3 + _stemTotalCount);
	
	                    if (wordicity === 0) wordicity = 0.00001;else if (wordicity === 1) wordicity = 0.99999;
	                }
	                logSum += Math.log(1 - wordicity) - Math.log(wordicity);
	                log(label + "icity of " + word + ": " + wordicity);
	
	                // Save wordicities for datavis
	                if (!wordicities.hasOwnProperty(word)) {
	                    wordicities[word] = { index: i };
	                }
	                if (label === 'negative') {
	                    wordicities[word].neg = wordicity;
	                } else {
	                    wordicities[word].pos = wordicity;
	                }
	            }
	            scores[label] = 1 / (1 + Math.exp(logSum));
	        }
	
	        var wordicitiesArray = Object.keys(wordicities).map(function (d) {
	            return { index: wordicities[d].index, word: d, neg: wordicities[d].neg, pos: wordicities[d].pos };
	        });
	        wordicitiesArray.sort(function (a, b) {
	            return a.index - b.index;
	        });
	        return { scores: scores, wordicities: wordicitiesArray };
	    };
	
	    Bayes.extractWinner = function (scores) {
	        var bestScore = 0;
	        var bestLabel = null;
	        for (var label in scores) {
	            if (scores[label] > bestScore) {
	                bestScore = scores[label];
	                bestLabel = label;
	            }
	        }
	        return { label: bestLabel, score: bestScore };
	    };
	
	    return Bayes;
	};

/***/ },
/* 112 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});/* Source: http://www.cs.cornell.edu/people/pabo/movie-review-data/ */var negatives=exports.negatives=["bad","terrible","simplistic , silly and tedious . ","it's so laddish and juvenile , only teenage boys could possibly find it funny . ","exploitative and largely devoid of the depth or sophistication that would make watching such a graphic treatment of the crimes bearable . ","[garbus] discards the potential for pathological study , exhuming instead , the skewed melodrama of the circumstantial situation . ","a visually flashy but narratively opaque and emotionally vapid exercise in style and mystification . ","the story is also as unoriginal as they come , already having been recycled more times than i'd care to count . ","about the only thing to give the movie points for is bravado -- to take an entirely stale concept and push it through the audience's meat grinder one more time . ","not so much farcical as sour . ","unfortunately the story and the actors are served with a hack script . ","all the more disquieting for its relatively gore-free allusions to the serial murders , but it falls down in its attempts to humanize its subject . ","a sentimental mess that never rings true . ","while the performances are often engaging , this loose collection of largely improvised numbers would probably have worked better as a one-hour tv documentary . ","interesting , but not compelling . ","on a cutting room floor somewhere lies . . . footage that might have made no such thing a trenchant , ironic cultural satire instead of a frustrating misfire . ","while the ensemble player who gained notice in guy ritchie's lock , stock and two smoking barrels and snatch has the bod , he's unlikely to become a household name on the basis of his first starring vehicle . ","there is a difference between movies with the courage to go over the top and movies that don't care about being stupid","nothing here seems as funny as it did in analyze this , not even joe viterelli as de niro's right-hand goombah . ","such master screenwriting comes courtesy of john pogue , the yale grad who previously gave us  the skulls  and last year's  rollerball .  enough said , except : film overboard ! ","here , common sense flies out the window , along with the hail of bullets , none of which ever seem to hit sascha . ","this 100-minute movie only has about 25 minutes of decent material . ","the execution is so pedestrian that the most positive comment we can make is that rob schneider actually turns in a pretty convincing performance as a prissy teenage girl . ","on its own , it's not very interesting . as a remake , it's a pale imitation . ","it shows that some studios firmly believe that people have lost the ability to think and will forgive any shoddy product as long as there's a little girl-on-girl action . ","a farce of a parody of a comedy of a premise , it isn't a comparison to reality so much as it is a commentary about our knowledge of films . ","as exciting as all this exoticism might sound to the typical pax viewer , the rest of us will be lulled into a coma . ","the party scenes deliver some tawdry kicks . the rest of the film . . . is dudsville . ","our culture is headed down the toilet with the ferocity of a frozen burrito after an all-night tequila bender — and i know this because i've seen 'jackass : the movie . '","the criticism never rises above easy , cynical potshots at morally bankrupt characters . . . ","the movie's something-borrowed construction feels less the product of loving , well integrated homage and more like a mere excuse for the wan , thinly sketched story . killing time , that's all that's going on here . ","stupid , infantile , redundant , sloppy , over-the-top , and amateurish . yep , it's  waking up in reno .  go back to sleep . ","somewhere in the middle , the film compels , as demme experiments he harvests a few movie moment gems , but the field of roughage dominates . ","the action clichés just pile up . ","payami tries to raise some serious issues about iran's electoral process , but the result is a film that's about as subtle as a party political broadcast . ","the only surprise is that heavyweights joel silver and robert zemeckis agreed to produce this ; i assume the director has pictures of them cavorting in ladies' underwear . ","another useless recycling of a brutal mid-'70s american sports movie . ","i didn't laugh . i didn't smile . i survived . ","please , someone , stop eric schaeffer before he makes another film . ","most of the problems with the film don't derive from the screenplay , but rather the mediocre performances by most of the actors involved"," . . . if you're just in the mood for a fun -- but bad -- movie , you might want to catch freaks as a matinee . ","curling may be a unique sport but men with brooms is distinctly ordinary . ","though the opera itself takes place mostly indoors , jacquot seems unsure of how to evoke any sort of naturalism on the set . ","there's no getting around the fact that this is revenge of the nerds revisited -- again . ","the effort is sincere and the results are honest , but the film is so bleak that it's hardly watchable . ","analyze that regurgitates and waters down many of the previous film's successes , with a few new swings thrown in . ","with flashbulb editing as cover for the absence of narrative continuity , undisputed is nearly incoherent , an excuse to get to the closing bout . . . by which time it's impossible to care who wins . ","stinks from start to finish , like a wet burlap sack of gloom . ","to the civilized mind , a movie like ballistic : ecks vs . sever is more of an ordeal than an amusement . ","equlibrium could pass for a thirteen-year-old's book report on the totalitarian themes of 1984 and farenheit 451 . ","the lack of naturalness makes everything seem self-consciously poetic and forced . . . it's a pity that [nelson's] achievement doesn't match his ambition . ","everything is off . ","when seagal appeared in an orange prison jumpsuit , i wanted to stand up in the theater and shout , 'hey , kool-aid ! '","an easy watch , except for the annoying demeanour of its lead character . ","imagine the cleanflicks version of 'love story , ' with ali macgraw's profanities replaced by romance-novel platitudes . ","pc stability notwithstanding , the film suffers from a simplistic narrative and a pat , fairy-tale conclusion . ","forget the misleading title , what's with the unexplained baboon cameo ? ","an odd , haphazard , and inconsequential romantic comedy . ","though her fans will assuredly have their funny bones tickled , others will find their humor-seeking dollars best spent elsewhere . ","pascale bailly's rom-com provides amélie's audrey tautou with another fabuleux destin -- i . e . , a banal spiritual quest . ","a static and sugary little half-hour , after-school special about interfaith understanding , stretched out to 90 minutes . ","watching the chemistry between freeman and judd , however , almost makes this movie worth seeing . almost . "," . . . a pretentious and ultimately empty examination of a sick and evil woman . ","the country bears has no scenes that will upset or frighten young viewers . unfortunately , there is almost nothing in this flat effort that will amuse or entertain them , either . ","the cumulative effect of watching this 65-minute trifle is rather like being trapped while some weird relative trots out the video he took of the family vacation to stonehenge . before long , you're desperate for the evening to end . ","the characters are never more than sketches . . . which leaves any true emotional connection or identification frustratingly out of reach . ","mattei's underdeveloped effort here is nothing but a convenient conveyor belt of brooding personalities that parade about as if they were coming back from stock character camp -- a drowsy drama infatuated by its own pretentious self-examination . ","only in its final surprising shots does rabbit-proof fence find the authority it's looking for . ","isn't as sharp as the original . . . despite some visual virtues , 'blade ii' just doesn't cut it . "," . . . plays like a badly edited , 91-minute trailer ( and ) the director can't seem to get a coherent rhythm going . in fact , it doesn't even seem like she tried . ","maybe leblanc thought ,  hey , the movie about the baseball-playing monkey was worse .  ","what you expect is just what you get . . . assuming the bar of expectations hasn't been raised above sixth-grade height . ","barry sonnenfeld owes frank the pug big time","the biggest problem with roger avary's uproar against the mpaa is that , even in all its director's cut glory , he's made a film that's barely shocking , barely interesting and most of all , barely anything . ","so riddled with unanswered questions that it requires gargantuan leaps of faith just to watch it plod along . ","i approached the usher and said that if she had to sit through it again , she should ask for a raise . ","earnest but heavy-handed . ","if sinise's character had a brain his ordeal would be over in five minutes but instead the plot goes out of its way to introduce obstacles for him to stumble over . ","too slow for a younger crowd , too shallow for an older one . ","there's a reason the studio didn't offer an advance screening .  the adventures of pluto nash  is a big time stinker . ","a punch line without a premise , a joke built entirely from musty memories of half-dimensional characters . ","takes one character we don't like and another we don't believe , and puts them into a battle of wills that is impossible to care about and isn't very funny . ","the things this movie tries to get the audience to buy just won't fly with most intelligent viewers . ","even if the enticing prospect of a lot of nubile young actors in a film about campus depravity didn't fade amid the deliberate , tiresome ugliness , it would be rendered tedious by avary's failure to construct a story with even a trace of dramatic interest . ","sitting through the last reel ( spoiler alert ! ) is significantly less charming than listening to a four-year-old with a taste for exaggeration recount his halloween trip to the haunted house . ","confuses its message with an ultimate desire to please , and contorting itself into an idea of expectation is the last thing any of these three actresses , nor their characters , deserve . ","deadly dull , pointless meditation on losers in a gone-to-seed hotel . ","with this new rollerball , sense and sensibility have been overrun by what can only be characterized as robotic sentiment . ","one can only assume that the jury who bestowed star hoffman's brother gordy with the waldo salt screenwriting award at 2002's sundance festival were honoring an attempt to do something different over actually pulling it off","a movie more to be prescribed than recommended -- as visually bland as a dentist's waiting room , complete with soothing muzak and a cushion of predictable narrative rhythms . ","sex ironically has little to do with the story , which becomes something about how lame it is to try and evade your responsibilities and that you should never , ever , leave a large dog alone with a toddler . but never mind all that ; the boobs are fantasti","the script covers huge , heavy topics in a bland , surfacey way that doesn't offer any insight into why , for instance , good things happen to bad people . ","a portrait of alienation so perfect , it will certainly succeed in alienating most viewers . ","the code talkers deserved better than a hollow tribute . ","skip the film and buy the philip glass soundtrack cd . ","feels like a cold old man going through the motions . ","dignified ceo's meet at a rustic retreat and pee against a tree . can you bear the laughter ? ","dull and mechanical , kinda like a very goofy museum exhibit","there's no point of view , no contemporary interpretation of joan's prefeminist plight , so we're left thinking the only reason to make the movie is because present standards allow for plenty of nudity . ","beware the quirky brit-com . they can and will turn on a dime from oddly humorous to tediously sentimental . ","has its moments -- and almost as many subplots . ","the gags , and the script , are a mixed bag . ","completely awful iranian drama . . . as much fun as a grouchy ayatollah in a cold mosque . ","narratively , trouble every day is a plodding mess . ","there's no point in extracting the bare bones of byatt's plot for purposes of bland hollywood romance . ","directors john musker and ron clements , the team behind the little mermaid , have produced sparkling retina candy , but they aren't able to muster a lot of emotional resonance in the cold vacuum of space . ","adam sandler's heart may be in the right place , but he needs to pull his head out of his butt","there's no doubting that this is a highly ambitious and personal project for egoyan , but it's also one that , next to his best work , feels clumsy and convoluted . ","despite engaging offbeat touches , knockaround guys rarely seems interested in kicking around a raison d'etre that's as fresh-faced as its young-guns cast . ","it's all pretty tame . the most offensive thing about the movie is that hollywood expects people to pay to see it . ","the movie is a mess from start to finish . ","the trouble with making this queen a thoroughly modern maiden is that it also makes her appear foolish and shallow rather than , as was more likely , a victim of mental illness . ","i'm not saying that ice age doesn't have some fairly pretty pictures , but there's not enough substance in the story to actually give them life . ","in the telling of a story largely untold , bui chooses to produce something that is ultimately suspiciously familiar . ","the plot is nothing but boilerplate clichés from start to finish , and the script assumes that not only would subtlety be lost on the target audience , but that it's also too stupid to realize that they've already seen this exact same movie a hundred times","terminally brain dead production . ","some episodes work , some don't . ","beautifully filmed and well acted . . . but admittedly problematic in its narrative specifics . ","j . lo will earn her share of the holiday box office pie , although this movie makes one thing perfectly clear : she's a pretty woman , but she's no working girl . ","rymer doesn't trust laughs -- and doesn't conjure proper respect for followers of the whole dead-undead genre , who deserve more from a vampire pic than a few shrieky special effects . ","not only are the film's sopranos gags incredibly dated and unfunny , they also demonstrate how desperate the makers of this 'we're -doing-it-for -the-cash' sequel were . ","wow . i have not been this disappointed by a movie in a long time . ","off the hook is overlong and not well-acted , but credit writer-producer-director adam watstein with finishing it at all . ","it's a drag how nettelbeck sees working women -- or at least this working woman -- for whom she shows little understanding . ","watching harris ham it up while physically and emotionally disintegrating over the course of the movie has a certain poignancy in light of his recent death , but boyd's film offers little else of consequence . ","it's also curious to note that this film , like the similarly ill-timed antitrust , is easily as bad at a fraction the budget . ","'ejemplo de una cinta en que no importa el talento de su reparto o lo interesante que pudo haber resultado su premisa , pues el resultado es francamente aburrido y , por momentos , deplorable . '","will probably be one of those movies barely registering a blip on the radar screen of 2002 . ","the problem is not that it's all derivative , because plenty of funny movies recycle old tropes . the problem is that van wilder does little that is actually funny with the material . ","there's nothing interesting in unfaithful whatsoever . ","none of this is half as moving as the filmmakers seem to think . ","a processed comedy chop suey . ","as spent screen series go , star trek : nemesis is even more suggestive of a 65th class reunion mixer where only eight surviving members show up -- and there's nothing to drink . ","fails as a dystopian movie , as a retooling of fahrenheit 451 , and even as a rip-off of the matrix . ","full of the kind of obnoxious chitchat that only self-aware neurotics engage in . ","an erotic thriller that's neither too erotic nor very thrilling , either . ","the movie , like bartleby , is something of a stiff -- an extra-dry office comedy that seems twice as long as its 83 minutes . ","with its parade of almost perpetually wasted characters . . . margarita feels like a hazy high that takes too long to shake . ","if you value your time and money , find an escape clause and avoid seeing this trite , predictable rehash . ","the director and her capable cast appear to be caught in a heady whirl of new age-inspired good intentions , but the spell they cast isn't the least bit mesmerizing . ","everything is pegged into the groove of a new york dating comedy with 'issues' to simplify . ","a dramatic comedy as pleasantly dishonest and pat as any hollywood fluff . ","the cameo-packed , m : i-2-spoofing title sequence is the funniest 5 minutes to date in this spy comedy franchise . . . then mike myers shows up and ruins everything . ","it comes off as so silly that you wouldn't be surprised if ba , murdock and rest of the a-team were seen giving chase in a black and red van . ","the 50-something lovebirds are too immature and unappealing to care about . ","so genial is the conceit , this is one of those rare pictures that you root for throughout , dearly hoping that the rich promise of the script will be realized on the screen . it never is , not fully . ","even in the summertime , the most restless young audience deserves the dignity of an action hero motivated by something more than franchise possibilities . ","what with all the blanket statements and dime-store ruminations on vanity , the worries of the rich and sudden wisdom , the film becomes a sermon for most of its running time . ","one lousy movie . ","as gamely as the movie tries to make sense of its title character , there remains a huge gap between the film's creepy , clean-cut dahmer ( jeremy renner ) and fiendish acts that no amount of earnest textbook psychologizing can bridge . ","plodding , peevish and gimmicky . ","the four feathers is definitely horse feathers , but if you go in knowing that , you might have fun in this cinematic sandbox . ","oozes condescension from every pore . ","solaris  is a shapeless inconsequential move relying on the viewer to do most of the work . ","the direction , by george hickenlooper , has no snap to it , no wiseacre crackle or hard-bitten cynicism . "," . . . hypnotically dull . ","though this saga would be terrific to read about , it is dicey screen material that only a genius should touch . ","it has plenty of laughs . it just doesn't have much else . . . especially in a moral sense . ","an awful lot like one of [spears'] music videos in content -- except that it goes on for at least 90 more minutes and , worse , that you have to pay if you want to see it . ","confusion is one of my least favourite emotions , especially when i have to put up with 146 minutes of it . ","[h]ad i suffered and bled on the hard ground of ia drang , i'd want something a bit more complex than we were soldiers to be remembered by . ","occasionally loud and offensive , but more often , it simply lulls you into a gentle waking coma . ","it may play well as a double feature with mainstream foreign mush like my big fat greek wedding","by the time you reach the finale , you're likely wondering why you've been watching all this strutting and posturing . ","journalistically dubious , inept and often lethally dull . ","putting the primitive murderer inside a high-tech space station unleashes a pandora's box of special effects that run the gamut from cheesy to cheesier to cheesiest . "," at its best , it's black hawk down with more heart . at its worst , it's rambo- meets-john ford . ","exactly what you'd expect from a guy named kaos . ","calculated swill . ","this movie . . . doesn't deserve the energy it takes to describe how bad it is . ","with or without ballast tanks , k-19 sinks to a harrison ford low . ","director oliver parker labors so hard to whip life into the importance of being earnest that he probably pulled a muscle or two . ","you might be shocked to discover that seinfeld's real life is boring . ","it's not nearly as fresh or enjoyable as its predecessor , but there are enough high points to keep this from being a complete waste of time . ","walsh can't quite negotiate the many inconsistencies in janice's behavior or compensate for them by sheer force of charm . ","this 10th film in the series looks and feels tired . ","it leers , offering next to little insight into its intriguing subject . ","i found myself growing more and more frustrated and detached as vincent became more and more abhorrent . ","one of the oddest and most inexplicable sequels in movie history . ","there's nothing to gain from watching they . it isn't scary . it hates its characters . it finds no way to entertain or inspire its viewers . ","fear permeates the whole of stortelling , todd solondz' oftentimes funny , yet ultimately cowardly autocritique . ","the skirmishes for power waged among victims and predators settle into an undistinguished rhythm of artificial suspense . ","thoroughly awful . "," . . . ice age treads predictably along familiar territory , making it a passable family film that won't win many fans over the age of 12 . ","though the film is well-intentioned , one could rent the original and get the same love story and parable . ","just too silly and sophomoric to ensnare its target audience . ","the video work is so grainy and rough , so dependent on being 'naturalistic' rather than carefully lit and set up , that it's exhausting to watch . ","truly terrible . ","a cleverly crafted but ultimately hollow mockumentary . ","it gets bogged down by hit-and-miss topical humour before getting to the truly good stuff . ","an achingly enthralling premise , the film is hindered by uneven dialogue and plot lapses . ","it's tommy's job to clean the peep booths surrounding her , and after viewing this one , you'll feel like mopping up , too . ","rifkin no doubt fancies himself something of a hubert selby jr . , but there isn't an ounce of honest poetry in his entire script ; it's simply crude and unrelentingly exploitative . ","fluffy and disposible . ","such a bad movie that its luckiest viewers will be seated next to one of those ignorant pinheads who talk throughout the show . ","if you go into the theater expecting a scary , action-packed chiller , you might soon be looking for a sign . an exit sign , that is . ","holds limited appeal to those who like explosions , sadism and seeing people beat each other to a pulp . ","the dialogue is very choppy and monosyllabic despite the fact that it is being dubbed . ","a feature-length , r-rated , road-trip version of mama's family . ","what you end up getting is the vertical limit of surfing movies - memorable stunts with lots of downtime in between . ","stealing harvard doesn't care about cleverness , wit or any other kind of intelligent humor . ","bigelow handles the nuclear crisis sequences evenly but milks drama when she should be building suspense , and drags out too many scenes toward the end that should move quickly . ","there's undeniable enjoyment to be had from films crammed with movie references , but the fun wears thin -- then out -- when there's nothing else happening . ","imagine kevin smith , the blasphemous bad boy of suburban jersey , if he were stripped of most of his budget and all of his sense of humor . the result might look like vulgar . ","suffers from a lack of clarity and audacity that a subject as monstrous and pathetic as dahmer demands . ","what soured me on the santa clause 2 was that santa bumps up against 21st century reality so hard , it's icky . ","it's an 88-minute highlight reel that's 86 minutes too long . ","the film favors the scientific over the spectacular ( visually speaking ) . ","such an incomprehensible mess that it feels less like bad cinema than like being stuck in a dark pit having a nightmare about bad cinema . ","with the exception of mccoist , the players don't have a clue on the park . the acting isn't much better . ","the whole affair is as predictable as can be . ","a not-so-divine secrets of the ya-ya sisterhood with a hefty helping of re-fried green tomatoes . ","this cloying , voices-from-the-other-side story is hell . ","a suffocating rape-payback horror show that hinges on the subgenre's most enabling victim . . . and an ebullient affection for industrial-model meat freezers . ","star trek was kind of terrific once , but now it is a copy of a copy of a copy . ","[n]o matter how much good will the actors generate , showtime eventually folds under its own thinness . ","every potential twist is telegraphed well in advance , every performance respectably muted ; the movie itself seems to have been made under the influence of rohypnol . ","puts on airs of a hal hartley wannabe film -- without the vital comic ingredient of the hilarious writer-director himself . ","ver wiel's desperate attempt at wit is lost , leaving the character of critical jim two-dimensional and pointless . ","despite a performance of sustained intelligence from stanford and another of subtle humour from bebe neuwirth , as an older woman who seduces oscar , the film founders on its lack of empathy for the social milieu - rich new york intelligentsia - and its off","although disney follows its standard formula in this animated adventure , it feels more forced than usual . ","gaghan . . . has thrown every suspenseful cliché in the book at this nonsensical story . ","a sham construct based on theory , sleight-of-hand , and ill-wrought hypothesis . ","[p]artnering murphy with robert de niro for the tv-cops comedy showtime would seem to be surefire casting . the catch is that they're stuck with a script that prevents them from firing on all cylinders . ","'you'll laugh for not quite and hour and a half , but come out feeling strangely unsatisfied . you'll feel like you ate a reeses without the peanut butter . . . '","gooding offers a desperately ingratiating performance . ","parker should be commended for taking a fresh approach to familiar material , but his determination to remain true to the original text leads him to adopt a somewhat mannered tone . . . that ultimately dulls the human tragedy at the story's core . ","the director has injected self-consciousness into the proceedings at every turn . the results are far more alienating than involving . ","bogdanich is unashamedly pro-serbian and makes little attempt to give voice to the other side . ","a lack of thesis makes maryam , in the end , play out with the intellectual and emotional impact of an after-school special . ","the worst film of the year . ","by-the-numbers yarn . ","without shakespeare's eloquent language , the update is dreary and sluggish . ","if h . g . wells had a time machine and could take a look at his kin's reworked version , what would he say ? 'it looks good , sonny , but you missed the point . '","during the tuxedo's 90 minutes of screen time , there isn't one true 'chan moment' . ","bisset delivers a game performance , but she is unable to save the movie . ","watching austin powers in goldmember is like binging on cotton candy . it's sweet and fluffy at the time , but it may leave you feeling a little sticky and unsatisfied . ","the most anti-human big studio picture since 3000 miles to graceland . ","the film can depress you about life itself . ","i'm sure the filmmakers found this a remarkable and novel concept , but anybody who has ever seen an independent film can report that it is instead a cheap cliché . ","the acting is fine but the script is about as interesting as a recording of conversations at the wal-mart checkout line . ","its weighty themes are too grave for youngsters , but the story is too steeped in fairy tales and other childish things to appeal much to teenagers . ","the plot plummets into a comedy graveyard before janice comes racing to the rescue in the final reel . ","sometimes there are very , very good reasons for certain movies to be sealed in a jar and left on a remote shelf indefinitely . ","at 90 minutes this movie is short , but it feels much longer . ","here's my advice , kev . start reading your scripts before signing that dotted line . ","an alternately raucous and sappy ethnic sitcom . . . you'd be wise to send your regrets . ","an ugly-duckling tale so hideously and clumsily told it feels accidental . ","unfortunately , it's also not very good . especially compared with the television series that inspired the movie . ","it wraps up a classic mother/daughter struggle in recycled paper with a shiny new bow and while the audience can tell it's not all new , at least it looks pretty . ","glazed with a tawdry b-movie scum . ","this is the kind of movie during which you want to bang your head on the seat in front of you , at its cluelessness , at its idiocy , at its utterly misplaced earnestness . ","it winds up moving in many directions as it searches ( vainly , i think ) for something fresh to say . ","all in all , road to perdition is more in love with strangeness than excellence . ","a big fat pain . ","a mimetic approximation of better films like contempt and 8 1/2 . ","unintelligible , poorly acted , brain-slappingly bad , harvard man is ludicrous enough that it could become a cult classic . ","watching the powerpuff girls movie , my mind kept returning to one anecdote for comparison : the cartoon in japan that gave people seizures . ","aan opportunity wasted . ","an inelegant combination of two unrelated shorts that falls far short of the director's previous work in terms of both thematic content and narrative strength . ","to build a feel-good fantasy around a vain dictator-madman is off-putting , to say the least , not to mention inappropriate and wildly undeserved . ","with the cheesiest monsters this side of a horror spoof , which they isn't , it is more likely to induce sleep than fright . ","mild , meandering teen flick . ","though its atmosphere is intriguing . . . the drama is finally too predictable to leave much of an impression . ","though this rude and crude film does deliver a few gut-busting laughs , its digs at modern society are all things we've seen before . ","although it tries to be much more , it's really just another major league . ","astonishing isn't the word -- neither is incompetent , incoherent or just plain crap . indeed , none of these words really gets at the very special type of badness that is deuces wild . ","one thing is for sure : this movie does not tell you a whole lot about lily chou-chou . ","with a tone as variable as the cinematography , schaeffer's film never settles into the light-footed enchantment the material needs , and the characters' quirks and foibles never jell into charm . ","to better understand why this didn't connect with me would require another viewing , and i won't be sitting through this one again . . . that in itself is commentary enough . ","cuba gooding jr . valiantly mugs his way through snow dogs , but even his boisterous energy fails to spark this leaden comedy . ","diane lane's sophisticated performance can't rescue adrian lyne's unfaithful from its sleazy moralizing . ","not at all clear what it's trying to say and even if it were – i doubt it would be all that interesting . ","storytelling feels slight . ","[swimfan] falls victim to sloppy plotting , an insultingly unbelievable final act and a villainess who is too crazy to be interesting . ","this remake of lina wertmuller's 1975 eroti-comedy might just be the biggest husband-and-wife disaster since john and bo derek made the ridiculous bolero . ","silly , loud and goofy . ","why spend $9 on the same stuff you can get for a buck or so in that greasy little vidgame pit in the theater lobby ? ","the french director has turned out nearly 21/2 hours of unfocused , excruciatingly tedious cinema that , half an hour in , starts making water torture seem appealing . ","the basic premise is intriguing but quickly becomes distasteful and downright creepy . ","the pool drowned me in boredom . ","it's like an all-star salute to disney's cheesy commercialism . ","it's hard to imagine any recent film , independent or otherwise , that makes as much of a mess as this one . ","some of the computer animation is handsome , and various amusing sidekicks add much-needed levity to the otherwise bleak tale , but overall the film never rises above mediocrity . ","there's an excellent 90-minute film here ; unfortunately , it runs for 170 . ","as saccharine movies go , this is likely to cause massive cardiac arrest if taken in large doses . ","die another day is only intermittently entertaining but it's hard not to be a sucker for its charms , or perhaps it's just impossible not to feel nostalgia for movies you grew up with . ","as is often the case with ambitious , eager first-time filmmakers , mr . murray , a prolific director of music videos , stuffs his debut with more plot than it can comfortably hold . ","the mystery of enigma is how a rich historical subject , combined with so much first-rate talent . . . could have yielded such a flat , plodding picture . ","it throws quirky characters , odd situations , and off-kilter dialogue at us , all as if to say ,  look at this ! this is an interesting movie !  but the film itself is ultimately quite unengaging . ","the inherent limitations of using a video game as the source material movie are once again made all too clear in this schlocky horror/action hybrid . ","bad company . bad movie . just plain bad . ","it's not only dull because we've seen [eddie] murphy do the genial-rogue shtick to death , but because the plot is equally hackneyed . ","avary's film never quite emerges from the shadow of ellis' book . ","a poorly scripted , preachy fable that forgets about unfolding a coherent , believable story in its zeal to spread propaganda . ","while it is interesting to witness the conflict from the palestinian side , longley's film lacks balance . . . and fails to put the struggle into meaningful historical context . ","woo has as much right to make a huge action sequence as any director , but how long will filmmakers copy the  saving private ryan  battle scenes before realizing steven spielberg got it right the first time ? ","it's sincere to a fault , but , unfortunately , not very compelling or much fun . "," . . . jones , despite a definitely distinctive screen presence , just isn't able to muster for a movie that , its title notwithstanding , should have been a lot nastier if it wanted to fully capitalize on its lead's specific gifts . ","this follow-up seems so similar to the 1953 disney classic that it makes one long for a geriatric peter . ","why , you may ask , why should you buy the movie milk when the tv cow is free ? there's no good answer to that one . ","this slow-moving swedish film offers not even a hint of joy , preferring to focus on the humiliation of martin as he defecates in bed and urinates on the plants at his own birthday party . ","a muddled limp biscuit of a movie , a vampire soap opera that doesn't make much sense even on its own terms . ","there's the plot , and a maddeningly insistent and repetitive piano score that made me want to scream . ","this is a movie so insecure about its capacity to excite that it churns up not one but two flagrantly fake thunderstorms to underscore the action . ","this is amusing for about three minutes . ","klein , charming in comedies like american pie and dead-on in election , delivers one of the saddest action hero performances ever witnessed . ","it's rare to see a movie that takes such a speedy swan dive from  promising  to  interesting  to  familiar  before landing squarely on  stupid  . ","this is the sort of low-grade dreck that usually goes straight to video --with a lousy script , inept direction , pathetic acting , poorly dubbed dialogue and murky cinematography , complete with visible boom mikes . ","the direction occasionally rises to the level of marginal competence , but for most of the film it is hard to tell who is chasing who or why . ","there are few things more frustrating to a film buff than seeing an otherwise good movie marred beyond redemption by a disastrous ending . ","it won't harm anyone , but neither can i think of a very good reason to rush right out and see it . after all , it'll probably be in video stores by christmas , and it might just be better suited to a night in the living room than a night at the movies . ","looks more like a travel-agency video targeted at people who like to ride bikes topless and roll in the mud than a worthwhile glimpse of independent-community guiding lights . ","given too much time to consider the looseness of the piece , the picture begins to resemble the shapeless , grasping actors' workshop that it is . ","they kept much of the plot but jettisoned the stuff that would make this a moving experience for people who haven't read the book . ","just because a walk to remember is shrewd enough to activate girlish tear ducts doesn't mean it's good enough for our girls . ","[carvey's] characters are both overplayed and exaggerated , but then again , subtlety has never been his trademark . ","it's mildly interesting to ponder the peculiar american style of justice that plays out here , but it's so muddled and derivative that few will bother thinking it all through . ","this dreadfully earnest inversion of the concubine love triangle eschews the previous film's historical panorama and roiling pathos for bug-eyed mugging and gay-niche condescension . ","brown's saga , like many before his , makes for snappy prose but a stumblebum of a movie . ","the boys' sparring , like the succession of blows dumped on guei , wears down the story's more cerebral , and likable , plot elements . ","the script by vincent r . nebrida . . . tries to cram too many ingredients into one small pot . ","the story is so light and sugary that were it a macy's thanksgiving day parade balloon , extra heavy-duty ropes would be needed to keep it from floating away . ","oedekerk mugs mercilessly , and the genuinely funny jokes are few and far between . ","since dahmer resorts to standard slasher flick thrills when it should be most in the mind of the killer , it misses a major opportunity to be truly revelatory about his psyche . ","only those most addicted to film violence in all its forms will find anything here to appreciate . ","cold and scattered , minority report commands interest almost solely as an exercise in gorgeous visuals . that's not vintage spielberg and that , finally , is minimally satisfying . ","every now and again , a movie comes along to remind us of how very bad a motion picture can truly be . frank mcklusky c . i . is that movie ! ","it's not difficult to spot the culprit early-on in this predictable thriller . ","[a] soulless , stupid sequel . . . "," . . . a mostly boring affair with a confusing sudden finale that's likely to irk viewers . ","the trappings of i spy are so familiar you might as well be watching a rerun . ","what starts off as a potentially incredibly twisting mystery becomes simply a monster chase film . ","in the wake of saving private ryan , black hawk down and we were soldiers , you are likely to be as heartily sick of mayhem as cage's war-weary marine . ","it is messy , uncouth , incomprehensible , vicious and absurd . ","really does feel like a short stretched out to feature length . ","hampered -- no , paralyzed -- by a self-indulgent script . . . that aims for poetry and ends up sounding like satire . ","cheap , vulgar dialogue and a plot that crawls along at a snail's pace . ","and if you appreciate the one-sided theme to lawrence's over-indulgent tirade , then knock yourself out and enjoy the big screen postcard that is a self-glorified martin lawrence lovefest . if you are willing to do this , then you so crazy ! ","directed without the expected flair or imagination by hong kong master john woo , windtalkers airs just about every cliche in the war movie compendium across its indulgent two-hour-and-fifteen-minute length . ","it's a very tasteful rock and roll movie . you could put it on a coffee table anywhere . ","the movie is loaded with good intentions , but in his zeal to squeeze the action and our emotions into the all-too-familiar dramatic arc of the holocaust escape story , minac drains his movie of all individuality . ","an infuriating film . just when you think you are making sense of it , something happens that tells you there is no sense . ","the entire movie is so formulaic and forgettable that it's hardly over before it begins to fade from memory . ","the setting turns out to be more interesting than any of the character dramas , which never reach satisfying conclusions . ","as an entertainment destination for the general public , kung pow sets a new benchmark for lameness . ","this misty-eyed southern nostalgia piece , in treading the line between sappy and sanguine , winds up mired in tear-drenched quicksand . ","as pure over-the-top trash , any john waters movie has it beat by a country mile . ","wendigo wants to be a monster movie for the art-house crowd , but it falls into the trap of pretention almost every time . ","bigelow offers some flashy twists and turns that occasionally fortify this turgid fable . but for the most part , the weight of water comes off as a two-way time-switching myopic mystery that stalls in its lackluster gear of emotional blandness . ","this film biggest problem ? no laughs . ","less-than-compelling documentary of a yiddish theater clan . ","that the chuck norris  grenade gag  occurs about 7 times during windtalkers is a good indication of how serious-minded the film is . ","viewers are asked so often to suspend belief that were it not for holm's performance , the film would be a total washout . ","it's not exactly worth the bucks to expend the full price for a date , but when it comes out on video , it's well worth a rental . ","i can't begin to tell you how tedious , how resolutely unamusing , how thoroughly unrewarding all of this is , and what a reckless squandering of four fine acting talents . . . ","everybody loves a david and goliath story , and this one is told almost entirely from david's point of view . ","throw smoochy from the train ! ","eventually , they will have a showdown , but , by then , your senses are as mushy as peas and you don't care who fires the winning shot . ","irwin and his director never come up with an adequate reason why we should pay money for what we can get on television for free . ","a light , engaging comedy that fumbles away almost all of its accumulated enjoyment with a crucial third act miscalculation . ","cedar somewhat defuses this provocative theme by submerging it in a hoary love triangle . ","to paraphrase a line from another dickens' novel , nicholas nickleby is too much like a fragment of an underdone potato . ","the actresses may have worked up a back story for the women they portray so convincingly , but viewers don't get enough of that background for the characters to be involving as individuals rather than types . ","the result , however well-intentioned , is ironically just the sort of disposable , kitchen-sink homage that illustrates why the whole is so often less than the sum of its parts in today's hollywood . ","an extremely unpleasant film . ","a movie just for friday fans , critics be damned . if you already like this sort of thing , this is that sort of thing all over again . ","a sincere but dramatically conflicted gay coming-of-age tale . ","wait for it to hit cable . ","ultimately feels like just one more in the long line of films this year about the business of making movies . ","a high-minded snoozer . ","nothing but one relentlessly depressing situation after another for its entire running time , something that you could easily be dealing with right now in your lives . ","77 minutes of pokemon may not last 4ever , it just seems like it does . my only wish is that celebi could take me back to a time before i saw this movie and i could just skip it . ","the one not-so-small problem with expecting is that the entire exercise has no real point . ","a movie you observe , rather than one you enter into . ","[at least] moore is a real charmer . ","john carlen's script is full of unhappy , two-dimensional characters who are anything but compelling . ","labute can't avoid a fatal mistake in the modern era : he's changed the male academic from a lower-class brit to an american , a choice that upsets the novel's exquisite balance and shreds the fabric of the film . ","the notion of deleting emotion from people , even in an advanced prozac nation , is so insanely dysfunctional that the rampantly designed equilibrium becomes a concept doofus . ","stale first act , scrooge story , blatant product placement , some very good comedic songs , strong finish , dumb fart jokes . ","unsurprisingly , the way this all works out makes the women look more like stereotypical caretakers and moral teachers , instead of serious athletes . ","a film that loses sight of its own story . ","adam sandler's eight crazy nights grows on you -- like a rash . ","the big-screen scooby makes the silly original cartoon seem smart and well-crafted in comparison . ","few of the increasingly far-fetched events that first-time writer-director neil burger follows up with are terribly convincing , which is a pity , considering barry's terrific performance . ","gets better after foster leaves that little room . ","the movie is as padded as allen's jelly belly . ","resident evil isn't a product of its cinematic predecessors so much as an mtv , sugar hysteria , and playstation cocktail . ","a rather average action film that benefits from several funny moments supplied by epps . "," . . . unspeakably , unbearably dull , featuring reams of flatly delivered dialogue and a heroine who comes across as both shallow and dim-witted . ","resembles a soft porn brian de palma pastiche . ","bluto blutarsky , we miss you . ","innocuous enough to make even jean-claude van damme look good . ","it's a glorified sitcom , and a long , unfunny one at that . ","woody allen can write and deliver a one liner as well as anybody . but i had a lot of problems with this movie . ","execrable . ","devoid of any of the qualities that made the first film so special . ","all movie long , city by the sea swings from one approach to the other , but in the end , it stays in formula -- which is a waste of de niro , mcdormand and the other good actors in the cast . ","plotless collection of moronic stunts is by far the worst movie of the year . ","however sincere it may be , the rising place never quite justifies its own existence . ","parker updates the setting in an attempt to make the film relevant today , without fully understanding what it was that made the story relevant in the first place . ","it's sort of a 21st century morality play with a latino hip hop beat . but the second half of the movie really goes downhill . ","paxton's uneven directorial debut fails to unlock the full potential of what is in many ways a fresh and dramatically substantial spin on the genre . ","the script becomes lifeless and falls apart like a cheap lawn chair . ","the script falls back on too many tried-and-true shenanigans that hardly distinguish it from the next teen comedy . ","the film starts promisingly , but the ending is all too predictable and far too cliched to really work . ","let's issue a moratorium , effective immediately , on treacly films about inspirational prep-school professors and the children they so heartwarmingly motivate . ","it's the element of condescension , as the filmmakers look down on their working-class subjects from their lofty perch , that finally makes sex with strangers , which opens today in the new york metropolitan area , so distasteful . ","alternately frustrating and rewarding . ","it's impossible to even categorize this as a smutty guilty pleasure . ","despite suffering a sense-of-humour failure , the man who wrote rocky does not deserve to go down with a ship as leaky as this . ","swinging , the film makes it seem , is not a hobby that attracts the young and fit . or intelligent . ","the most memorable moment was when green threw medical equipment at a window ; not because it was particularly funny , but because i had a serious urge to grab the old lady at the end of my aisle's walker and toss it at the screen in frustration . ","see clockstoppers if you have nothing better to do with 94 minutes . but be warned , you too may feel time has decided to stand still . or that the battery on your watch has died . ","suffers from over-familiarity since hit-hungry british filmmakers have strip-mined the monty formula mercilessly since 1997 . ","there are enough throwaway references to faith and rainbows to plant smile-button faces on that segment of the populace that made a walk to remember a niche hit . ","yes , i have given this movie a rating of zero . but fans of the show should not consider this a diss . consider it 'perfection . '","the cumulative effect of the movie is repulsive and depressing . ","children and adults enamored of all things pokemon won't be disappointed . ","i don't even care that there's no plot in this antonio banderas-lucy liu faceoff . it's still terrible ! ","children of the century , though well dressed and well made , ultimately falls prey to the contradiction that afflicts so many movies about writers . ","it's not so much a movie as a joint promotion for the national basketball association and teenaged rap and adolescent poster-boy lil' bow wow . ","peralta's mythmaking could have used some informed , adult hindsight . ","amazingly dopey . ","a close-to-solid espionage thriller with the misfortune of being released a few decades too late . ","cloaks a familiar anti-feminist equation ( career - kids = misery ) in tiresome romantic-comedy duds . ","the good girl is a film in which the talent is undeniable but the results are underwhelming . ","just a collection of this and that -- whatever fills time -- with no unified whole . ","the animation and game phenomenon that peaked about three years ago is actually dying a slow death , if the poor quality of pokemon 4 ever is any indication . ","only about as sexy and dangerous as an actress in a role that reminds at every turn of elizabeth berkley's flopping dolphin-gasm . ","kids who are into this thornberry stuff will probably be in wedgie heaven . anyone else who may , for whatever reason , be thinking about going to see this movie is hereby given fair warning . ","mr . soderbergh's direction and visual style struck me as unusually and unimpressively fussy and pretentious . ","do you say  hi  to your lover when you wake up in the morning ? ","it makes me feel weird / thinking about all the bad things in the world / like puppies with broken legs / and butterflies that die / and movies starring pop queens","director tom dey demonstrated a knack for mixing action and idiosyncratic humor in his charming 2000 debut shanghai noon , but showtime's uninspired send-up of tv cop show cliches mostly leaves him shooting blanks . ","banal and predictable . ","'yes , that's right : it's forrest gump , angel of death . '","a wildly erratic drama with sequences that make you wince in embarrassment and others , thanks to the actors , that are quite touching . ","while easier to sit through than most of jaglom's self-conscious and gratingly irritating films , it's still tainted by cliches , painful improbability and murky points . ","about as enjoyable , i would imagine , as searching for a quarter in a giant pile of elephant feces . . . positively dreadful . ","a generic international version of a typical american horror film . "," . . . while certainly clever in spots , this too-long , spoofy update of shakespeare's macbeth doesn't sustain a high enough level of invention . ","crikey indeed . ","lucas has in fact come closer than anyone could desire to the cheap , graceless , hackneyed sci-fi serials of the '30s and '40s . ","there's a lot of good material here , but there's also a lot of redundancy and unsuccessful crudeness accompanying it . ","absurdities and clichés accumulate like lint in a fat man's navel . ","if you think it's a riot to see rob schneider in a young woman's clothes , then you'll enjoy the hot chick . ","the sheer dumbness of the plot ( other than its one good idea ) and the movie's inescapable air of sleaziness get you down . ","strangely comes off as a kingdom more mild than wild . ","the next big thing's not-so-big ( and not-so-hot ) directorial debut . ","yet another iteration of what's become one of the movies' creepiest conventions , in which the developmentally disabled are portrayed with almost supernatural powers to humble , teach and ultimately redeem their mentally  superior  friends , family . . . ","bond-inspired ? certainly . likely to have decades of life as a classic movie franchise ? let's hope not . ","this flat run at a hip-hop tootsie is so poorly paced you could fit all of pootie tang in between its punchlines . ","davis has energy , but she doesn't bother to make her heroine's book sound convincing , the gender-war ideas original , or the comic scenes fly . ","surprisingly , considering that baird is a former film editor , the movie is rather choppy . ","none of this is very original , and it isn't particularly funny . "," . . . a bland murder-on-campus yawner . ","a humorless journey into a philosophical void . ","these two are generating about as much chemistry as an iraqi factory poised to receive a un inspector . ","responsável direto pelo fracasso 'artístico' de doce lar , o roteirista c . jay cox não consegue sequer aproveitar os pouquíssimos momentos em que escapa da mediocridade . ","just as the lousy tarantino imitations have subsided , here comes the first lousy guy ritchie imitation . ","a passable romantic comedy , in need of another couple of passes through the word processor . ","the movie attempts to mine laughs from a genre -- the gangster/crime comedy -- that wore out its welcome with audiences several years ago , and its cutesy reliance on movie-specific cliches isn't exactly endearing . ","shows holmes has the screen presence to become a major-league leading lady , ( but ) the movie itself is an underachiever , a psychological mystery that takes its sweet time building to a climax that's scarcely a surprise by the time it arrives . ","in the book-on-tape market , the film of  the kid stays in the picture  would be an abridged edition","ultimately . . . the movie is too heady for children , and too preachy for adults . ","it's just a little too self-satisfied . ","clever but not especially compelling . ","mckay seems embarrassed by his own invention and tries to rush through the intermediary passages , apparently hoping that the audience will not notice the glaring triteness of the plot device he has put in service . ","a piece of mildly entertaining , inoffensive fluff that drifts aimlessly for 90 minutes before lodging in the cracks of that ever-growing category : unembarrassing but unmemorable . ","labute was more fun when his characters were torturing each other psychologically and talking about their genitals in public . ","the movie weighs no more than a glass of flat champagne . ","brisk hack job . ","the problem with antwone fisher is that it has a screenplay written by antwone fisher based on the book by antwone fisher . ","alarms for duvall's throbbing sincerity and his elderly propensity for patting people while he talks . ","…the maudlin way its story unfolds suggests a director fighting against the urge to sensationalize his material . ","what little grace [rifkin's] tale of precarious skid-row dignity achieves is pushed into the margins by predictable plotting and tiresome histrionics . ","tries to work in the same vein as the brilliance of animal house but instead comes closer to the failure of the third revenge of the nerds sequel . ","unfortunately , kapur modernizes a . e . w . mason's story to suit the sensibilities of a young american , a decision that plucks  the four feathers  bare . "," . . . what a banal bore the preachy circuit turns out to be","falsehoods pile up , undermining the movie's reality and stifling its creator's comic voice . ","a mechanical action-comedy whose seeming purpose is to market the charismatic jackie chan to even younger audiences . ","one of the most incoherent features in recent memory . ","low rent from frame one . ","eight legged freaks ? no big hairy deal . ","the issues are presented in such a lousy way , complete with some of the year's ( unintentionally ) funniest moments , that it's impossible to care . ","laggard drama wending its way to an uninspired philosophical epiphany . ","the respective charms of sandra bullock and hugh grant have worn threadbare . ","'this movie sucks . '","none of this so-called satire has any sting to it , as if woody is afraid of biting the hand that has finally , to some extent , warmed up to him . "," . . . bibbidy-bobbidi-bland . ","a few nonbelievers may rethink their attitudes when they see the joy the characters take in this creed , but skeptics aren't likely to enter the theater . ","bad in such a bizarre way that it's almost worth seeing , if only to witness the crazy confluence of purpose and taste . ","there's more repetition than creativity throughout the movie . ","hugh grant's act is so consuming that sometimes it's difficult to tell who the other actors in the movie are . ","although the sequel has all the outward elements of the original , the first film's lovely flakiness is gone , replaced by the forced funniness found in the dullest kiddie flicks . ","i've had more interesting -- and , dare i say , thematically complex -- bowel movements than this long-on-the-shelf , point-and-shoot exercise in gimmicky crime drama . ","what we get . . . is caddyshack crossed with the loyal order of raccoons . ","the jokes are flat , and the action looks fake . ","when a movie asks you to feel sorry for mick jagger's sex life , it already has one strike against it . ","there are now two signs that m . night shyamalan's debut feature sucked up all he has to give to the mystic genres of cinema : unbreakable and signs . "," . . . hokey art house pretension . "," . . . a weak and ineffective ghost story without a conclusion or pay off . ","gussied up with so many distracting special effects and visual party tricks that it's not clear whether we're supposed to shriek or laugh . ","plodding , poorly written , murky and weakly acted , the picture feels as if everyone making it lost their movie mojo . ","this is a fudged opportunity of gigantic proportions -- a lunar mission with no signs of life . ","a baffling subplot involving smuggling drugs inside danish cows falls flat , and if you're going to alter the bard's ending , you'd better have a good alternative . ","soderbergh seems capable only of delivering artfully lighted , earnest inquiries that lack the kind of genuine depth that would make them redeemable . ","the only thing that distinguishes a randall wallace film from any other is the fact that there is nothing distinguishing in a randall wallace film . ","silly stuff , all mixed up together like a term paper from a kid who can't quite distinguish one sci-fi work from another . ","there is so much plodding sensitivity . ","the town has kind of an authentic feel , but each one of these people stand out and everybody else is in the background and it just seems manufactured to me and artificial . "," . . . too sappy for its own good . ","circuit queens won't learn a thing , they'll be too busy cursing the film's strategically placed white sheets . ","as an actress , madonna is one helluva singer . as the mediterranean sparkles , 'swept away' sinks . ","every so often a film comes along that is so insanely stupid , so awful in so many ways that watching it leaves you giddy . half past dead is just such an achievement . ","expanded to 65 minutes for theatrical release , it still feels somewhat unfinished . ","it all looks and plays like a $40 million version of a game you're more likely to enjoy on a computer . ","[javier bardem is] one of the few reasons to watch the film , which director gerardo vera has drenched in swoony music and fever-pitched melodrama . ","feels shrill , simple and soapy . ","adults , other than the parents . . . will be hard pressed to succumb to the call of the wild . ","brady achieves the remarkable feat of squandering a topnotch foursome of actors . . . by shoving them into every clichéd white-trash situation imaginable . ","in the name of an allegedly inspiring and easily marketable flick , the emperor's club turns a blind eye to the very history it pretends to teach . ","no amount of blood and disintegrating vampire cadavers can obscure this movie's lack of ideas . ","a direct-to-void release , heading nowhere . ","typical animé , with cheapo animation ( like saturday morning tv in the '60s ) , a complex sword-and-sorcery plot and characters who all have big round eyes and japanese names . ","below is well below expectations . ","at no point during k-19 : the widowmaker did this viewer feel enveloped in a story that , though meant to be universal in its themes of loyalty , courage and dedication to a common goal , never seems to leave the lot . "," . . . standard guns versus martial arts cliche with little new added . ","empire can't make up its mind whether it wants to be a gangster flick or an art film . it doesn't work as either . ","given the fact that virtually no one is bound to show up at theatres for it , the project should have been made for the tube . ","possession is in the end an honorable , interesting failure . it falls far short of poetry , but it's not bad prose . ","jonathan parker's bartleby should have been the be-all-end-all of the modern-office anomie films . ","there may have been a good film in  trouble every day ,  but it is not what is on the screen . ","unfortunately , carvey's rubber-face routine is no match for the insipid script he has crafted with harris goldberg . ","viewed as a comedy , a romance , a fairy tale , or a drama , there's nothing remotely triumphant about this motion picture . ","there's something unintentionally comic in the film's drumbeat about authenticity , given the stale plot and pornographic way the film revels in swank apartments , clothes and parties . ","the master of disguise is funny--not  ha ha  funny ,  dead circus performer  funny . and for all the wrong reasons besides . ","a zippy 96 minutes of mediocre special effects , hoary dialogue , fluxing accents , and -- worst of all -- silly-looking morlocks . ","a 75-minute sample of puerile rubbish that is listless , witless , and devoid of anything resembling humor . ","you leave feeling like you've endured a long workout without your pulse ever racing . ","the waterlogged script plumbs uncharted depths of stupidity , incoherence and sub-sophomoric sexual banter . ","with mcconaughey in an entirely irony-free zone and bale reduced mainly to batting his sensitive eyelids , there's not enough intelligence , wit or innovation on the screen to attract and sustain an older crowd . ","it's the type of stunt the academy loves : a powerful political message stuffed into an otherwise mediocre film . ","in theory , a middle-aged romance pairing clayburgh and tambor sounds promising , but in practice it's something else altogether -- clownish and offensive and nothing at all like real life . ","so mind-numbingly awful that you hope britney won't do it one more time , as far as movies are concerned . ","the images are usually abbreviated in favor of mushy obviousness and telegraphed pathos , particularly where whitaker's misfit artist is concerned . ","if welles was unhappy at the prospect of the human race splitting in two , he probably wouldn't be too crazy with his great-grandson's movie splitting up in pretty much the same way . ","sets animation back 30 years , musicals back 40 years and judaism back at least 50 . ","weirdly , broomfield has compelling new material but he doesn't unveil it until the end , after endless scenes of him wheedling reluctant witnesses and pointing his camera through the smeared windshield of his rental car . ","might best be enjoyed as a daytime soaper . ","eventually arrives at its heart , as simple self-reflection meditation . ","a showcase for both the scenic splendor of the mountains and for legendary actor michel serrault , the film is less successful on other levels . ","boy oh boy , it's a howler . ","a few pieces of the film buzz and whir ; very little of it actually clicks . the thing just never gets off the ground . "," . . . contains very few laughs and even less surprises . ","the actors must indeed be good to recite some of this laughable dialogue with a straight face . ","most of the storylines feel like time fillers between surf shots . the movie isn't horrible , but you can see mediocre cresting on the next wave . ","however stale the material , lawrence's delivery remains perfect ; his great gift is that he can actually trick you into thinking some of this worn-out , pandering palaver is actually funny . ","there's nothing remotely topical or sexy here . ","the tuxedo wasn't just bad ; it was , as my friend david cross would call it , 'hungry-man portions of bad' . ","blue crush is so prolonged and boring it isn't even close to being the barn-burningly bad movie it promised it would be . ","the sequel plays out like a flimsy excuse to give blade fans another look at wesley snipes' iconic hero doing battle with dozens of bad guys -- at once . ","while van wilder may not be the worst national lampoon film , it's far from being this generation's animal house . ","so devoid of pleasure or sensuality that it cannot even be dubbed hedonistic . ","reeks of rot and hack work from start to finish . ","an exhausting family drama about a porcelain empire and just as hard a flick as its subject matter . ","woody allen has really found his groove these days . the problem is that it is one that allows him to churn out one mediocre movie after another . ","the bland outweighs the nifty , and cletis tout never becomes the clever crime comedy it thinks it is . ","it's such a mechanical endeavor [that] it never bothers to question why somebody might devote time to see it . ","the art direction is often exquisite , and the anthropomorphic animal characters are beautifully realized through clever makeup design , leaving one to hope that the eventual dvd release will offer subtitles and the original italian-language soundtrack . "," if the predictability of bland comfort food appeals to you , then the film is a pleasant enough dish . ","ultimately , in the history of the academy , people may be wondering what all that jazz was about  chicago  in 2002 . zellweger's whiny pouty-lipped poof faced and spindly attempt at playing an ingenue makes her nomination as best actress even more of a an a","a seriously bad film with seriously warped logic by writer-director kurt wimmer at the screenplay level . ","a pleasant and engaging enough sit , but in trying to have the best of both worlds it ends up falling short as a whole . ","its plot and animation offer daytime tv serviceability , but little more . ","a tired , unimaginative and derivative variation of that already-shallow genre . ","human nature , in short , isn't nearly as funny as it thinks it is ; neither is it as smart . ","a film with a great premise but only a great premise . ","instead of building to a laugh riot we are left with a handful of disparate funny moments of no real consequence . ","kirshner and monroe seem to be in a contest to see who can out-bad-act the other . ( kirshner wins , but it's close . ) ","a lame romantic comedy about an unsympathetic character and someone who would not likely be so stupid as to get involved with her . ","what started out as a taut contest of wills between bacon and theron , deteriorates into a protracted and borderline silly chase sequence . ","[sam's] self-flagellation is more depressing than entertaining . ","an ugly , pointless , stupid movie . ","simply put , there should have been a more compelling excuse to pair susan sarandon and goldie hawn . ","the master of disguise represents adam sandler's latest attempt to dumb down the universe . ","this is an ungainly movie , ill-fitting , with its elbows sticking out where the knees should be . ","too silly to take seriously . ","obvious","the inevitable double- and triple-crosses arise , but the only drama is in waiting to hear how john malkovich's reedy consigliere will pronounce his next line . ","everything's serious , poetic , earnest and -- sadly -- dull . ","i like it . no , i hate it . no , i love it . . . hell , i dunno . ","this mess of a movie is nothing short of a travesty of a transvestite comedy . ","it's clotted with heavy-handed symbolism , dime-store psychology and endless scenic shots that make 105 minutes seem twice as long . ","a fifty car pileup of cliches . ","it's a stale , overused cocktail using the same olives since 1962 as garnish . not only is entry number twenty the worst of the brosnan bunch , it's one of the worst of the entire franchise . ","what ultimately makes windtalkers a disappointment is the superficial way it deals with its story . ","as an actor's showcase , hart's war has much to recommend it , even if the top-billed willis is not the most impressive player . as a story of dramatic enlightenment , the screenplay by billy ray and terry george leaves something to be desired . ","a non-britney person might survive a screening with little harm done , except maybe for the last 15 minutes , which are as maudlin as any after-school special you can imagine . ","it's not hateful . it's simply stupid , irrelevant and deeply , truly , bottomlessly cynical . ","possibly not since grumpy old men have i heard a film so solidly connect with one demographic while striking out with another . ","the drama was so uninspiring that even a story immersed in love , lust , and sin couldn't keep my attention . ","a rather tired exercise in nostalgia . ","the misery of these people becomes just another voyeuristic spectacle , to be consumed and forgotten . ","some body often looks like an episode of the tv show blind date , only less technically proficient and without the pop-up comments . ","bad company has one of the most moronic screenplays of the year , full of holes that will be obvious even to those who aren't looking for them . ","predecessors the mummy and the mummy returns stand as intellectual masterpieces next to the scorpion king . ","a markedly inactive film , city is conversational bordering on confessional . ","while kids will probably eat the whole thing up , most adults will be way ahead of the plot . ","its one-sidedness . . . flirts with propaganda . ","despite an impressive roster of stars and direction from kathryn bigelow , the weight of water is oppressively heavy . ","we've liked klein's other work but rollerball left us cold . ","they were afraid to show this movie to reviewers before its opening , afraid of the bad reviews they thought they'd earn . they were right . ","it would be churlish to begrudge anyone for receiving whatever consolation that can be found in dragonfly , yet it is impossible to find the film anything but appalling , shamelessly manipulative and contrived , and totally lacking in conviction . ","offers no new insight on the matter , nor do its characters exactly spring to life . ","nohe has made a decent 'intro' documentary , but he feels like a spectator and not a participant . ","apparently designed as a reverie about memory and regret , but the only thing you'll regret is remembering the experience of sitting through it . ","a 94-minute travesty of unparalleled proportions , writer-director parker seems to go out of his way to turn the legendary wit's classic mistaken identity farce into brutally labored and unfunny hokum . ","guy gets girl , guy loses girl , audience falls asleep . ","too ordinary to restore [harmon] to prominence , despite some creepy scenes that evoke childish night terrors , and a praiseworthy attempt to generate suspense rather than gross out the audience . ","stirs potentially enticing ingredients into an uneasy blend of ghost and close encounters of the third kind . ","the weird thing about the santa clause 2 , purportedly a children's movie , is that there is nothing in it to engage children emotionally . ","it's pretentious in a way that verges on the amateurish . ","contains the humor , characterization , poignancy , and intelligence of a bad sitcom . ","it doesn't matter that the film is less than 90 minutes . it still feels like a prison stretch . ","partly a schmaltzy , by-the-numbers romantic comedy , partly a shallow rumination on the emptiness of success -- and entirely soulless . ","ong chooses to present ah na's life as a slight , weightless fairy tale , whose most unpleasant details seem to melt away in the face of the character's blank-faced optimism . ","the overall feel is not unlike watching a glorified episode of  7th heaven .  ","just a kiss is a just a waste . "," . . . this isn't even a movie we can enjoy as mild escapism ; it is one in which fear and frustration are provoked to intolerable levels . ","frankly , it's kind of insulting , both to men and women . and it's not that funny -- which is just generally insulting . ","as if drop dead gorgeous wasn't enough , this equally derisive clunker is fixated on the spectacle of small-town competition . ","a wretched movie that reduces the second world war to one man's quest to find an old flame . ","this is a remake by the numbers , linking a halfwit plot to a series of standup routines in which wilson and murphy show how funny they could have been in a more ambitious movie . ","it's better than mid-range steven seagal , but not as sharp as jet li on rollerblades . ","no dia em que aceitou dirigir esta continuação , harold ramis deve ter saído da cama com o pé esquerdo . e aqueles que decidiram assistir a este filme também . ","there's a reason why halftime is only fifteen minutes long . ","the talk-heavy film plays like one of robert altman's lesser works . ","as happily glib and vicious as its characters . ","one of those films that started with a great premise and then just fell apart . "," . . . a pretentious mess . . . ","no better or worse than 'truth or consequences , n . m . ' or any other interchangeable actioner with imbecilic mafia toolbags botching a routine assignment in a western backwater . ","a sour attempt at making a farrelly brothers-style , down-and-dirty laugher for the female set . ","[macdowell] ventures beyond her abilities several times here and reveals how bad an actress she is . ","i can imagine this movie as a b&w british comedy , circa 1960 , with peter sellers , kenneth williams , et al . , but at this time , with this cast , this movie is hopeless . ","talky , artificial and opaque . . . an interesting technical exercise , but a tedious picture . ","kurys never shows why , of all the period's volatile romantic lives , sand and musset are worth particular attention . ","almost nothing else -- raunchy and graphic as it may be in presentation -- is one-sided , outwardly sexist or mean-spirited . and in a sense , that's a liability . ","it's easy to love robin tunney -- she's pretty and she can act -- but it gets harder and harder to understand her choices . ","if you've got a house full of tots -- don't worry , this will be on video long before they grow up and you can wait till then . ","the new film of anton chekhov's the cherry orchard puts the 'ick' in 'classic . '","has an uppity musical beat that you can dance to , but its energy can't compare to the wit , humor and snappy dialogue of the original . if i want music , i'll buy the soundtrack . if i want a real movie , i'll buy the criterion dvd . ","an unremarkable , modern action/comedy buddy movie whose only nod to nostalgia is in the title . ","has all the right elements but completely fails to gel together . ","writer-director stephen gaghan has made the near-fatal mistake of being what the english call 'too clever by half . '","seagal ran out of movies years ago , and this is just the proof . ","the movie is so contrived , nonsensical and formulaic that , come to think of it , the day-old shelf would be a more appropriate location to store it . ","an awkwardly garish showcase that diverges from anything remotely probing or penetrating . ","the name says it all . jackass is a vulgar and cheap-looking version of candid camera staged for the marquis de sade set . ","children , christian or otherwise , deserve to hear the full story of jonah's despair -- in all its agonizing , catch-22 glory -- even if they spend years trying to comprehend it . ","pleasant but not more than recycled jock piffle . "," . . . the kind of movie you see because the theater has air conditioning . ","with zoe clarke-williams's lackluster thriller  new best friend  , who needs enemies ? just another generic drama that has nothing going for it other than its exploitive array of obligatory cheap thrills . ","hip-hop prison thriller of stupefying absurdity . ","an uneven mix of dark satire and childhood awakening . ","aside from showing us in explicit detail how difficult it is to win over the two-drink-minimum crowd , there's little to be learned from watching 'comedian'","a perfectly acceptable , perfectly bland , competently acted but by no means scary horror movie . ","the film would have been more enjoyable had the balance shifted in favor of water-bound action over the land-based 'drama , ' but the emphasis on the latter leaves blue crush waterlogged . ","the problem is the needlessly poor quality of its archival prints and film footage . the images lack contrast , are murky and are frequently too dark to be decipherable . ","like a soft drink that's been sitting open too long : it's too much syrup and not enough fizz . ","as the movie dragged on , i thought i heard a mysterious voice , and felt myself powerfully drawn toward the light -- the light of the exit sign . i have returned from the beyond to warn you : this movie is 90 minutes long , and life is too short . ","there are some fairly unsettling scenes , but they never succeed in really rattling the viewer . ","the emperor's club is one of those films that possesses all the good intentions in the world , but . . . ","in the end , the weight of water comes to resemble the kind of soft-core twaddle you'd expect to see on showtime's 'red shoe diaries . '","a straight-ahead thriller that never rises above superficiality . ","glizty but formulaic and silly . . . cagney's 'top of the world' has been replaced by the bottom of the barrel . ","the re- enactments , however fascinating they may be as history , are too crude to serve the work especially well . ","eisenstein lacks considerable brio for a film about one of cinema's directorial giants . ","is anyone else out there getting tired of the whole slo-mo , double-pistoled , ballistic-pyrotechnic hong kong action aesthetic ? ","once again , director chris columbus takes a hat-in-hand approach to rowling that stifles creativity and allows the film to drag on for nearly three hours . ","serving sara is little more than a mall movie designed to kill time . ","too smart to ignore but a little too smugly superior to like , this could be a movie that ends up slapping its target audience in the face by shooting itself in the foot . ","a well-made but emotionally scattered film whose hero gives his heart only to the dog . ","the most repugnant adaptation of a classic text since roland joffé and demi moore's the scarlet letter . ","the isolated moments of creative insanity finally are lost in the thin soup of canned humor . ","as a movie , it never seems fresh and vital . it never plays as dramatic even when dramatic things happen to people . it labours as storytelling . ","the adventures of pluto nash is a whole lot of nada . ","a really good premise is frittered away in middle-of-the-road blandness . ","lawrence should stick to his day job . he's a better actor than a standup comedian . ","despite the fact that this film wasn't as bad as i thought it was going to be , it's still not a good movie","a well made indieflick in need of some trims and a more chemistry between its stars . ","i never thought i'd say this , but i'd much rather watch teens poking their genitals into fruit pies ! ","a film neither bitter nor sweet , neither romantic nor comedic , neither warm nor fuzzy . ","tiresomely derivative and hammily acted . ","we never truly come to care about the main characters and whether or not they'll wind up together , and michele's spiritual quest is neither amusing nor dramatic enough to sustain interest . ","the plot grows thin soon , and you find yourself praying for a quick resolution . ","too bad maggio couldn't come up with a better script . ","much of the cast is stiff or just plain bad . ","rice is too pedestrian a filmmaker to bring any edge or personality to the rising place that would set it apart from other deep south stories . ","at best , cletis tout might inspire a trip to the video store -- in search of a better movie experience . ","witless , pointless , tasteless and idiotic . ","not really a thriller so much as a movie for teens to laugh , groan and hiss at . ","as plain and pedestrian as catsup--","an improvement on the feeble examples of big-screen poke-mania that have preceded it . ","i know we're not supposed to take it seriously , but i can't shake the thought that undercover brother missed an opportunity to strongly present some profound social commentary . ","your stomach for heaven depends largely on your appetite for canned corn . ","a picture as erratic as its central character . ","whatever satire lucky break was aiming for , it certainly got lost in the  soon-to-be-forgettable  section of the quirky rip-off prison romp pile . it's petty thievery like this that puts flimsy flicks like this behind bars","the package in which this fascinating -- and timely -- content comes wrapped is disappointingly generic . ","guys say mean things and shoot a lot of bullets . some of the characters die and others don't , and the film pretends that those living have learned some sort of lesson , and , really , nobody in the viewing audience cares . ","wildly incompetent but brilliantly named half past dead -- or for seagal pessimists : totally past his prime . ","just another combination of bad animation and mindless violence . . . lacking the slightest bit of wit or charm . ","all the movie's narrative gymnastics can't disguise the fact that it's inauthentic at its core and that its story just isn't worth telling . ","much like its easily dismissive take on the upscale lifestyle , there isn't much there here . ","the film ultimately offers nothing more than people in an urban jungle needing other people to survive . . . ","for all its shoot-outs , fistfights , and car chases , this movie is a phlegmatic bore , so tedious it makes the silly spy vs . spy film the sum of all fears , starring ben affleck , seem downright hitchcockian . ","this mild-mannered farce , directed by one of its writers , john c . walsh , is corny in a way that bespeaks an expiration date passed a long time ago . ","[a] rather thinly-conceived movie . ","a bit too eager to please . ","you'd be hard put to find a movie character more unattractive or odorous [than leon] . ","kapur's contradictory feelings about his material result in a movie that works against itself . ","  the road paved with good intentions leads to the video store  ","animated drivel meant to enhance the self-image of drooling idiots . ","so-so entertainment . ","one scene after another in this supposedly funny movie falls to the floor with a sickening thud . ","'the château is never quite able to overcome the cultural moat surrounding its ludicrous and contrived plot . '","meyjes focuses too much on max when he should be filling the screen with this tortured , dull artist and monster-in-the- making . ","jacobi , the most fluent of actors , is given relatively dry material from nijinsky's writings to perform , and the visuals , even erotically frank ones , become dullingly repetitive . ","crudup's screen presence is the one thing that holds interest in the midst of a mushy , existential exploration of why men leave their families . ","there is one surefire way to get a nomination for a best-foreign-film oscar : make a movie about whimsical folk who learn a nonchallenging , life-affirming lesson while walking around a foreign city with stunning architecture . ","despite terrific special effects and funnier gags , harry potter and the chamber of secrets finds a way to make j . k . rowling's marvelous series into a deadly bore . ","an incredibly narrow in-joke targeted to the tiniest segment of an already obscure demographic . ","the only thing i laughed at were the people who paid to see it . ","all of the elements are in place for a great film noir , but director george hickenlooper's approach to the material is too upbeat . ","the hackneyed story about an affluent damsel in distress who decides to fight her bully of a husband is simply too overdone . ","the phone rings and a voice tells you you've got seven days left to live . then you get another phone call warning you that if the video isn't back at blockbuster before midnight , you're going to face frightening late fees . o . k . , not really . ","possibly the most irresponsible picture ever released by a major film studio . ","the film's overall mood and focus is interesting but constantly unfulfilling . "," . . . a cheap , ludicrous attempt at serious horror . ","those of you who are not an eighth grade girl will most likely doze off during this one . ","punitively affirmational parable . ","befuddled in its characterizations as it begins to seem as long as the two year affair which is its subject","from beginning to end , this overheated melodrama plays like a student film . ","the movie would seem less of a trifle if ms . sugarman followed through on her defiance of the saccharine . ","it's just not very smart . ","like the excruciating end of days , collateral damage presents schwarzenegger as a tragic figure , but sympathy really belongs with any viewer forced to watch him try out so many complicated facial expressions . ","imagine ( if possible ) a pasolini film without passion or politics , or an almodovar movie without beauty or humor , and you have some idea of the glum , numb experience of watching o fantasma . ","in trying to be daring and original , it comes off as only occasionally satirical and never fresh . ","90 punitive minutes of eardrum-dicing gunplay , screeching-metal smashups , and flaccid odd-couple sniping . ","sadly , though many of the actors throw off a spark or two when they first appear , they can't generate enough heat in this cold vacuum of a comedy to start a reaction . ","never capitalizes on this concept and opts for the breezy and amateurish feel of an after school special on the subject of tolerance . ","after a while , hoffman's quirks and mannerisms , particularly his penchant for tearing up on cue -- things that seem so real in small doses -- become annoying and artificial . ","this wretchedly unfunny wannabe comedy is inane and awful - no doubt , it's the worst movie i've seen this summer . ","it's drab . it's uninteresting . it squanders chan's uniqueness ; it could even be said to squander jennifer love hewitt ! ","the movie keeps coming back to the achingly unfunny phonce and his several silly subplots . ","this tale has been told and retold ; the races and rackets change , but the song remains the same . ","a surprisingly flat retread , hobbled by half-baked setups and sluggish pacing . ","forget the psychology 101 study of romantic obsession and just watch the procession of costumes in castles and this won't seem like such a bore . ","a film that should be relegated to a dark video store corner is somehow making its way instead to theaters . it's hard to imagine acting that could be any flatter . ","new ways of describing badness need to be invented to describe exactly how bad it is . ","lots of effort and intelligence are on display but in execution it is all awkward , static , and lifeless rumblings . ","when cowering and begging at the feet a scruffy giannini , madonna gives her best performance since abel ferrara had her beaten to a pulp in his dangerous game . ","i suspect that there are more interesting ways of dealing with the subject . ","decent but dull . ","the film itself is about something very interesting and odd that would probably work better as a real documentary without the insinuation of mediocre acting or a fairly trite narrative . ","an unintentional parody of every teen movie made in the last five years . ","only for young children , if them . their parents would do well to cram earplugs in their ears and put pillowcases over their heads for 87 minutes . ","for all its violence , the movie is remarkably dull with only caine making much of an impression . ","no matter how firmly director john stainton has his tongue in his cheek , the fact remains that a wacky concept does not a movie make . ","a sub-formulaic slap in the face to seasonal cheer . ","the action is reasonably well-done . . . yet story , character and comedy bits are too ragged to ever fit smoothly together . ","several uninteresting , unlikeable people do bad things to and with each other in  unfaithful .  why anyone who is not a character in this movie should care is beyond me . ","thin period piece . ","hill looks to be going through the motions , beginning with the pale script . ","howard conjures the past via surrealist flourishes so overwrought you'd swear he just stepped out of a buñuel retrospective . ","the best thing that can be said of the picture is that it does have a few cute moments . ","it's not a bad premise , just a bad movie . ","an already thin story boils down to surviving invaders seeking an existent anti-virus . if only there were one for this kind of movie . ","by the time the surprise ending is revealed , interest cannot be revived . ","the heedless impetuousness of youth is on full , irritating display in [this] meandering and pointless french coming-of-age import from writer-director anne-sophie birot . ","a peculiar misfire that even tunney can't save . ","watching queen of the damned is like reading a research paper , with special effects tossed in . ","i can't remember the last time i saw worse stunt editing or cheaper action movie production values than in extreme ops . ","too much of nemesis has a tired , talky feel . ","i felt trapped and with no obvious escape for the entire 100 minutes . ","when mr . hundert tells us in his narration that 'this is a story without surprises , ' we nod in agreement . ","leaves us wondering less about its ideas and more about its characterization of hitler and the contrived nature of its provocative conclusion . ","it is that rare combination of bad writing , bad direction and bad acting -- the trifecta of badness . ","each scene wreaks of routine ; the film never manages to generate a single threat of suspense . ","a soulless jumble of ineptly assembled cliches and pabulum that plays like a 95-minute commercial for nba properties . ","borstal boy represents the worst kind of filmmaking , the kind that pretends to be passionate and truthful but is really frustratingly timid and soggy . ","the film's lack of personality permeates all its aspects — from the tv movie-esque , affected child acting to the dullest irish pub scenes ever filmed . ","works on the whodunit level as its larger themes get lost in the murk of its own making","crush could be the worst film a man has made about women since valley of the dolls . ","4ever has the same sledgehammer appeal as pokemon videos , but it breathes more on the big screen and induces headaches more slowly . ","feels like the work of someone who may indeed have finally aged past his prime . . . and , perhaps more than he realizes , just wants to be liked by the people who can still give him work . ","trailer park magnolia : too long , too cutesy , too sure of its own importance , and possessed of that peculiar tension of being too dense & about nothing at all . ","[a] stuporously solemn film . ","viewers of barney's crushingly self-indulgent spectacle will see nothing in it to match the ordeal of sitting through it . "," . . . its stupidities wind up sticking in one's mind a lot more than the cool bits . ","sayles . . . once again strands his superb performers in the same old story . ","the piano teacher , like its title character , is repellantly out of control . ","i have to admit i walked out of runteldat . i did go back and check out the last 10 minutes , but these were more repulsive than the first 30 or 40 minutes . ","the filmmakers lack the nerve . . . to fully exploit the script's potential for sick humor . ","the film wasn't preachy , but it was feminism by the book . "," . . . the same tired old gags , modernized for the extreme sports generation . there's already been too many of these films . . . ","several of steven soderbergh's earlier films were hailed as the works of an artist . sadly , full frontal plays like the work of a dilettante . ","clockstoppers is one of those crazy , mixed-up films that doesn't know what it wants to be when it grows up . ","although bright , well-acted and thought-provoking , tuck everlasting suffers from a laconic pace and a lack of traditional action . ","'the war of the roses , ' trailer-trash style . entertaining but like shooting fish in a barrel . ","supposedly , pokemon can't be killed , but pokemon 4ever practically assures that the pocket monster movie franchise is nearly ready to keel over . ","white hasn't developed characters so much as caricatures , one-dimensional buffoons that get him a few laughs but nothing else . ","when you resurrect a dead man , hard copy should come a-knocking , no ? ","cattaneo should have followed the runaway success of his first film , the full monty , with something different . ","the film feels formulaic , its plot and pacing typical hollywood war-movie stuff , while the performances elicit more of a sense of deja vu than awe . ","this overproduced piece of dreck is shockingly bad and absolutely unnecessary . hmmm…might i suggest that the wayward wooden one end it all by stuffing himself into an electric pencil sharpener ? ","the makers of mothman prophecies succeed in producing that most frightening of all movies -- a mediocre horror film too bad to be good and too good to be bad . ","mr . deeds is not really a film as much as it is a loose collection of not-so-funny gags , scattered moments of lazy humor . ","how this one escaped the lifetime network i'll never know . ","couldn't someone take rob schneider and have him switch bodies with a funny person ? ","one of these days hollywood will come up with an original idea for a teen movie , but until then there's always these rehashes to feed to the younger generations . ","for all its brilliant touches , dragon loses its fire midway , nearly flickering out by its perfunctory conclusion . ","i have to admit that i am baffled by jason x . ","a mean-spirited film made by someone who surely read the catcher in the rye but clearly suffers from dyslexia","instead of a witty expose on the banality and hypocrisy of too much kid-vid , we get an ugly , mean-spirited lashing out by an adult who's apparently been forced by his kids to watch too many barney videos . ","this is a film living far too much in its own head . ","the umpteenth summer skinny dip in jerry bruckheimer's putrid pond of retread action twaddle . ","national lampoon's van wilder may aim to be the next animal house , but it more closely resembles this year's version of tomcats . ","the film thrusts the inchoate but already eldritch christian right propaganda machine into national media circles . ","dogtown is hollow , self-indulgent , and - worst of all - boring . ","a movie so bad that it quickly enters the pantheon of wreckage that includes battlefield earth and showgirls . ","more of a career curio than a major work . ","it's just too bad the screenwriters eventually shoot themselves in the feet with cop flick cliches like an oily arms dealer , squad car pile-ups and the requisite screaming captain . ","cox is far more concerned with aggrandizing madness , not the man , and the results might drive you crazy . ","to be influenced chiefly by humanity's greatest shame , reality shows -- reality shows for god's sake ! -- is a crime that should be punishable by chainsaw . ","taken as a whole , the tuxedo doesn't add up to a whole lot . ","as we have come to learn -- as many times as we have fingers to count on -- jason is a killer who doesn't know the meaning of the word 'quit . ' the filmmakers might want to look it up . ","a frustrating 'tweener' -- too slick , contrived and exploitative for the art houses and too cynical , small and decadent for the malls . ","what's surprising about this traditional thriller , moderately successful but not completely satisfying , is exactly how genteel and unsurprising the execution turns out to be . ","drowning's too good for this sucker . ","an instantly forgettable snow-and-stuntwork extravaganza that likely will be upstaged by an avalanche of more appealing holiday-season product . ","frankly , it's pretty stupid . i had more fun with ben stiller's zoolander , which i thought was rather clever . but there's plenty to offend everyone . . . ","love liza is a festival film that would have been better off staying on the festival circuit . ","there are things to like about murder by numbers -- but , in the end , the disparate elements don't gel . "," . . . tackling a low-budget movie in which inexperienced children play the two main characters might not be the best way to cut your teeth in the film industry . ","quite frankly , i can't see why any actor of talent would ever work in a mcculloch production again if they looked at how this movie turned out . ","my precious new star wars movie is a lumbering , wheezy drag . . . ","the innocence of holiday cheer ain't what it used to be . ","too campy to work as straight drama and too violent and sordid to function as comedy , vulgar is , truly and thankfully , a one-of-a-kind work . ","horrid little propaganda film with fascinating connections not only to the serbs themselves but also to a network of american right-wing extremists . ","should have gone straight to video . it looks like an action movie , but it's so poorly made , on all levels , that it doesn't even qualify as a spoof of such . ","it is supremely unfunny and unentertaining to watch middle-age and older men drink to excess , piss on trees , b . s . one another and put on a show in drag . ","consider the film a celluloid litmus test for the intellectual and emotional pedigree of your date and a giant step backward for a director i admire . ","a boring , pretentious muddle that uses a sensational , real-life 19th-century crime as a metaphor for -- well , i'm not exactly sure what -- and has all the dramatic weight of a raindrop . ","sheridan had a wonderful account to work from , but , curiously , he waters it down , turning grit and vulnerability into light reading . ","heavy with flabby rolls of typical toback machinations . ","it is very difficult to care about the character , and that is the central flaw of the film . ","snow dogs finds its humour in a black man getting humiliated by a pack of dogs who are smarter than him","whole stretches of the film may be incomprehensible to moviegoers not already clad in basic black . ","reggio and glass so rhapsodize cynicism , with repetition and languorous slo-mo sequences , that glass's dirgelike score becomes a fang-baring lullaby . ","es triste tener que decirles que lo único grato de la cinta es el cuerpo desnudo de la heather . . . ","ends up offering nothing more than the latest schwarzenegger or stallone flick would . ","the film makes strong arguments regarding the social status of america's indigenous people , but really only exists to try to eke out an emotional tug of the heart , one which it fails to get . ","charlize chases kevin with a gun . courtney chases stuart with a cell phone . the sound of gunfire and cell phones ringing . ","if the tuxedo actually were a suit , it would fit chan like a $99 bargain-basement special . ","parents beware ; this is downright movie penance . "," . . . a complete shambles of a movie so sloppy , so uneven , so damn unpleasant that i can't believe any viewer , young or old , would have a good time here . ","has nothing good to speak about other than the fact that it is relatively short , tries its best to hide the fact that seagal's overweight and out of shape . ","a pathetically inane and unimaginative cross between xxx and vertical limit . ","impeccably filmed , sexually charged , but ultimately lacking in substance , not to mention dragged down by a leaden closing act . ","feels at times like a giant commercial for universal studios , where much of the action takes place . ","while the mystery unravels , the characters respond by hitting on each other . ","britney spears' phoniness is nothing compared to the movie's contrived , lame screenplay and listless direction . ","every sequel you skip will be two hours gained . consider this review life-affirming . ","if the movie were all comedy , it might work better . but it has an ambition to say something about its subjects , but not a willingness . ","the movie , while beautiful , feels labored , with a hint of the writing exercise about it . ","twenty-three movies into a mostly magnificent directorial career , clint eastwood's efficiently minimalist style finally has failed him . big time . ","this heist flick about young brooklyn hoods is off the shelf after two years to capitalize on the popularity of vin diesel , seth green and barry pepper . it should have stayed there . ","the film has a childlike quality about it . but the feelings evoked in the film are lukewarm and quick to pass . ","the most opaque , self-indulgent and just plain goofy an excuse for a movie as you can imagine . ","it's not a film to be taken literally on any level , but its focus always appears questionable . ","big fat liar is little more than home alone raised to a new , self-deprecating level . ","the movie is gorgeously made , but it is also somewhat shallow and art-conscious . ","the only time 8 crazy nights comes close to hitting a comedic or satirical target is during the offbeat musical numbers . ","loses its sense of humor in a vat of failed jokes , twitchy acting , and general boorishness . ","there's a delightfully quirky movie to be made from curling , but brooms isn't it . ","the story suffers a severe case of oversimplification , superficiality and silliness . ","chamber of secrets will find millions of eager fans . but if the essence of magic is its make-believe promise of life that soars above the material realm , this is the opposite of a truly magical movie . ","too clever by about nine-tenths . ","has all the hallmarks of a movie designed strictly for children's home video , a market so insatiable it absorbs all manner of lame entertainment , as long as 3-year-olds find it diverting . ","well-meant but unoriginal . ","bears about as much resemblance to the experiences of most battered women as spider-man does to the experiences of most teenagers . ","toward the end sum of all fears morphs into a mundane '70s disaster flick . ","director carl franklin , so crisp and economical in one false move , bogs down in genre cliches here . ","mendes still doesn't quite know how to fill a frame . like the hanks character , he's a slow study : the action is stilted and the tabloid energy embalmed . ","this thing is just garbage . ","as crimes go , writer-director michael kalesniko's how to kill your neighbor's dog is slight but unendurable . ","there must be an audience that enjoys the friday series , but i wouldn't be interested in knowing any of them personally . ","a bold ( and lovely ) experiment that will almost certainly bore most audiences into their own brightly colored dreams . ","an uplifting , largely bogus story . ","an empty exercise , a florid but ultimately vapid crime melodrama with lots of surface flash but little emotional resonance . ","if you are curious to see the darker side of what's going on with young tv actors ( dawson leery did what ? ! ? ) , or see some interesting storytelling devices , you might want to check it out , but there's nothing very attractive about this movie . ","my own minority report is that it stinks . ","trying to make head or tail of the story in the hip-hop indie snipes is enough to give you brain strain -- and the pay-off is negligible . ","the script is high on squaddie banter , low on shocks . "," . . . if you , like me , think an action film disguised as a war tribute is disgusting to begin with , then you're in for a painful ride . ","while solondz tries and tries hard , storytelling fails to provide much more insight than the inside column of a torn book jacket . ","with very little to add beyond the dark visions already relayed by superb recent predecessors like swimming with sharks and the player , this latest skewering . . . may put off insiders and outsiders alike . ","[davis] wants to cause his audience an epiphany , yet he refuses to give us real situations and characters . ","without a fresh infusion of creativity , 4ever is neither a promise nor a threat so much as wishful thinking . "," . . . unlike [scorsese's mean streets] , ash wednesday is essentially devoid of interesting characters or even a halfway intriguing plot . ","being unique doesn't necessarily equate to being good , no matter how admirably the filmmakers have gone for broke . ","a few hours after you've seen it , you forget you've been to the movies . ","odd and weird . ","waydowntown may not be an important movie , or even a good one , but it provides a nice change of mindless pace in collision with the hot oscar season currently underway . ","yes , i suppose it's lovely that cal works out his issues with his dad and comes to terms with his picture-perfect life -- but world traveler gave me no reason to care , so i didn't . ","shadyac , who belongs with the damned for perpetrating patch adams , trots out every ghost trick from the sixth sense to the mothman prophecies . ","the photographer's show-don't-tell stance is admirable , but it can make him a problematic documentary subject . ","it is not the first time that director sara sugarman stoops to having characters drop their pants for laughs and not the last time she fails to provoke them . ","i'd be hard pressed to think of a film more cloyingly sappy than evelyn this year . ","nothing more than an amiable but unfocused bagatelle that plays like a loosely-connected string of acting-workshop exercises . ","meanders between its powerful moments . ","what remains is a variant of the nincompoop benigni persona , here a more annoying , though less angry version of the irresponsible sandlerian manchild , undercut by the voice of the star of road trip . ","a backhanded ode to female camaraderie penned by a man who has little clue about either the nature of women or of friendship . ","pure of intention and passably diverting , his secret life is light , innocuous and unremarkable . "," . . . delivers few moments of inspiration amid the bland animation and simplistic story . ","take away the controversy , and it's not much more watchable than a mexican soap opera . ","it's got the brawn , but not the brains . ","mindless and boring martial arts and gunplay with too little excitement and zero compelling storyline . ","a lot of talent is wasted in this crass , low-wattage endeavor . ","to show these characters in the act and give them no feelings of remorse -- and to cut repeatedly to the flashback of the original rape -- is overkill to the highest degree . ","[t]oo many of these gross out scenes . . . ","about one in three gags in white's intermittently wise script hits its mark ; the rest are padding unashamedly appropriated from the teen-exploitation playbook . ","little is done to support the premise other than fling gags at it to see which ones shtick . ","reno does what he can in a thankless situation , the film ricochets from humor to violence and back again , and ryoko hirosue makes us wonder if she is always like that . ","if jews were catholics , this would be catechism","one of those films that seems tailor made to air on pay cable to offer some modest amusements when one has nothing else to watch . ","the big ending surprise almost saves the movie . it's too bad that the rest isn't more compelling . ","charming , if overly complicated . . . ","schneider's mugging is relentless and his constant need to suddenly transpose himself into another character undermines the story's continuity and progression . ","all very stylish and beautifully photographed , but far more trouble than it's worth , with fantasy mixing with reality and actors playing more than one role just to add to the confusion . ","it's probably not easy to make such a worthless film . . . ","hope keeps arising that the movie will live up to the apparent skills of its makers and the talents of its actors , but it doesn't . ","has no reason to exist , other than to employ hollywood kids and people who owe favors to their famous parents . ","for a guy who has waited three years with breathless anticipation for a new hal hartley movie to pore over , no such thing is a big letdown . ","constantly slips from the grasp of its maker . ","smothered by its own solemnity . ","'christian bale's quinn [is] a leather clad grunge-pirate with a hairdo like gandalf in a wind-tunnel and a simply astounding cor-blimey-luv-a-duck cockney accent . '","might be one of those vanity projects in which a renowned filmmaker attempts to show off his talent by surrounding himself with untalented people . ","after you laugh once ( maybe twice ) , you will have completely forgotten the movie by the time you get back to your car in the parking lot . ","not one moment in the enterprise didn't make me want to lie down in a dark room with something cool to my brow . ","in the era of the sopranos , it feels painfully redundant and inauthentic . ","the overall vibe is druggy and self-indulgent , like a spring-break orgy for pretentious arts majors . ","breen's script is sketchy with actorish notations on the margin of acting . ","there's no question that epps scores once or twice , but it's telling that his funniest moment comes when he falls about ten feet onto his head . ","if only merchant paid more attention the story . ","at the one-hour mark , herzog simply runs out of ideas and the pace turns positively leaden as the movie sputters to its inevitable tragic conclusion . "," . . . too contrived to be as naturally charming as it needs to be . ","a simpler , leaner treatment would have been preferable ; after all , being about nothing is sometimes funnier than being about something . ","the characters are based on stock clichés , and the attempt to complicate the story only defies credibility . ","everything about it from the bland songs to the colorful but flat drawings is completely serviceable and quickly forgettable . ","not the great american comedy , but if you liked the previous movies in the series , you'll have a good time with this one too . ","a domestic melodrama with weak dialogue and biopic cliches . ","mr . goyer's loose , unaccountable direction is technically sophisticated in the worst way . ","the movie is so thoughtlessly assembled . ","benigni presents himself as the boy puppet pinocchio , complete with receding hairline , weathered countenance and american breckin meyer's ridiculously inappropriate valley boy voice . ","plays like some corny television production from a bygone era","the end result is like cold porridge with only the odd enjoyably chewy lump . ","for all the charm of kevin kline and a story that puts old-fashioned values under the microscope , there's something creepy about this movie . ","i was feeling this movie until it veered off too far into the exxon zone , and left me behind at the station looking for a return ticket to realism . ","producer john penotti surveyed high school students . . . and came back with the astonishing revelation that  they wanted to see something that didn't talk down to them .  ignoring that , he made swimfan anyway","naipaul fans may be disappointed . those who are not acquainted with the author's work , on the other hand , may fall fast asleep . ","hoffman waits too long to turn his movie in an unexpected direction , and even then his tone retains a genteel , prep-school quality that feels dusty and leatherbound . ","if you're a crocodile hunter fan , you'll enjoy at least the  real  portions of the film . if you're looking for a story , don't bother . ","full frontal had no effect and elicited no sympathies for any of the characters . by that measure , it is a failure . ","a baffling mixed platter of gritty realism and magic realism with a hard-to-swallow premise . ","an affable but undernourished romantic comedy that fails to match the freshness of the actress-producer and writer's previous collaboration , miss congeniality . ","sometimes this modest little number clicks , and sometimes it doesn't . ","like a pack of dynamite sticks , built for controversy . the film is explosive , but a few of those sticks are wet . ","has its charming quirks and its dull spots . ","an admitted egomaniac , evans is no hollywood villain , and yet this grating showcase almost makes you wish he'd gone the way of don simpson . ","the audience when i saw this one was chuckling at all the wrong times , and that's a bad sign when they're supposed to be having a collective heart attack . ","everyone's to blame here . ","you get the impression that writer and director burr steers knows the territory . . . but his sense of humor has yet to lose the smug self-satisfaction usually associated with the better private schools . ","less a study in madness or love than a study in schoolgirl obsession . ","rice never clearly defines his characters or gives us a reason to care about them . ","it's a bizarre curiosity memorable mainly for the way it fritters away its potentially interesting subject matter via a banal script , unimpressive acting and indifferent direction . ","a slight and obvious effort , even for one whose target demographic is likely still in the single digits , age-wise . ","sex with strangers will shock many with its unblinking frankness . but what is missing from it all is a moral . what is the filmmakers' point ? why did they deem it necessary to document all this emotional misery ? ","you see robin williams and psycho killer , and you think , hmmmmm . you see the movie and you think , zzzzzzzzz . ","downright transparent is the script's endless assault of embarrassingly ham-fisted sex jokes that reek of a script rewrite designed to garner the film a  cooler  pg-13 rating . ","the movie slides downhill as soon as macho action conventions assert themselves . ","formulaic to the 51st power , more like . ","draggin' about dragons","howard and his co-stars all give committed performances , but they're often undone by howard's self-conscious attempts to find a 'literary' filmmaking style to match his subject . ","a respectable but uninspired thriller that's intelligent and considered in its details , but ultimately weak in its impact . ","jones helps breathe some life into the insubstantial plot , but even he is overwhelmed by predictability . ","the movie just has too much on its plate to really stay afloat for its just under ninety minute running time . ","comes off more like a misdemeanor , a flat , unconvincing drama that never catches fire . ","cinematic poo . ","offers absolutely nothing i hadn't already seen . ","  analyze that  is one of those crass , contrived sequels that not only fails on its own , but makes you second-guess your affection for the original . ","you might say tykwer has done all that heaven allows , if you wanted to make as anti-kieslowski a pun as possible . suffice to say its total promise is left slightly unfulfilled . ","complex , sinuously plotted and , somehow , off-puttingly cold . ","first-time writer-director dylan kidd also has a good ear for dialogue , and the characters sound like real people . "," . . . an airless , prepackaged julia roberts wannabe that stinks so badly of hard-sell image-mongering you'll wonder if lopez's publicist should share screenwriting credit . ","goldmember has none of the visual wit of the previous pictures , and it looks as though jay roach directed the film from the back of a taxicab . ","could as easily have been called 'under siege 3 : in alcatraz' . . . a cinematic corpse that never springs to life . ","in comparison to his earlier films it seems a disappointingly thin slice of lower-class london life ; despite the title . . . amounts to surprisingly little . ","lame sweet home leaves no southern stereotype unturned . ","slow , dry , poorly cast , but beautifully shot . ","the jokes are sophomoric , stereotypes are sprinkled everywhere and the acting ranges from bad to bodacious . ","will give many ministers and bible-study groups hours of material to discuss . but mainstream audiences will find little of interest in this film , which is often preachy and poorly acted . ","in its chicken heart , crush goes to absurd lengths to duck the very issues it raises . ","this long and relentlessly saccharine film is a clear case of preaching to the converted . ","the film is flat . ","the movie is a lumbering load of hokum but . . . it's at least watchable . ","it's a boom-box of a movie that might have been titled 'the loud and the ludicrous' . . . the pandering to a moviegoing audience dominated by young males is all too calculated . ","an unbelievably stupid film , though occasionally fun enough to make you forget its absurdity . ","the first fatal attraction was vile enough . do we really need the tiger beat version ? ","this bond film goes off the beaten path , not necessarily for the better . ","the problem is that the movie has no idea of it is serious or not . ","when the fire burns out , we've only come face-to-face with a couple dragons and that's where the film ultimately fails . ","it would work much better as a one-hour tv documentary . ","the elements were all there but lack of a pyschological center knocks it flat . ","anemic chronicle of money grubbing new yorkers and their serial loveless hook ups . ","simply doesn't have sufficient heft to justify its two-hour running time . ","an unsuccessful attempt at a movie of ideas . ","queen of the damned as you might have guessed , makes sorry use of aaliyah in her one and only starring role -- she does little here but point at things that explode into flame . ","this toothless dog , already on cable , loses all bite on the big screen . ","it made me feel unclean , and i'm the guy who liked there's something about mary and both american pie movies . oh , and booty call . ","not only is it hokey , manipulative and as bland as wonder bread dipped in milk , but it also does the absolute last thing we need hollywood doing to us : it preaches . ","it's so crammed with scenes and vistas and pretty moments that it's left a few crucial things out , like character development and coherence . ","serving sara should be served an eviction notice at every theater stuck with it . ","director roger michell does so many of the little things right that it's difficult not to cuss him out severely for bungling the big stuff . ","a loud , low-budget and tired formula film that arrives cloaked in the euphemism 'urban drama . '","the movie has a script ( by paul pender ) made of wood , and it's relentlessly folksy , a procession of stagy set pieces stacked with binary oppositions . ","a pathetic exploitation film that tries to seem sincere , and just seems worse for the effort . ","at some point , all this visual trickery stops being clever and devolves into flashy , vaguely silly overkill . ","despite some charm and heart , this quirky soccer import is forgettable","meyjes's movie , like max rothman's future , does not work . ","what's needed so badly but what is virtually absent here is either a saving dark humor or the feel of poetic tragedy . ","schneidermeister . . . makin' a fool of himself . . . losin' his fan base . . . ","an ambitious , serious film that manages to do virtually everything wrong ; sitting through it is something akin to an act of cinematic penance . ","not once does it come close to being exciting . ","a frankenstein mishmash that careens from dark satire to cartoonish slapstick , bartleby performs neither one very well . ","it plays like a big-budget , after-school special with a generous cast , who at times lift the material from its well-meaning clunkiness . ","there's something not entirely convincing about the quiet american . and that holds true for both the movie and the title character played by brendan fraser . ","one of those strained caper movies that's hardly any fun to watch and begins to vaporize from your memory minutes after it ends . ","needed a little less bling-bling and a lot more romance . ","the ending doesn't work . . . but most of the movie works so well i'm almost recommending it , anyway -- maybe not to everybody , but certainly to people with a curiosity about how a movie can go very right , and then step wrong . ","it's hard to believe these jokers are supposed to have pulled off four similar kidnappings before . ","i'm not exactly sure what this movie thinks it is about . ","cal is an unpleasantly shallow and immature character with whom to spend 110 claustrophobic minutes . ","so brisk is wang's pacing that none of the excellent cast are given air to breathe . ","the bottom line , at least in my opinion , is imposter makes a better short story than it does a film . ","some elements of it really blow the big one , but other parts are decent . ","it is just too bad the film's story does not live up to its style . ","unless you're a fanatic , the best advice is : 'scooby' don't . ","a cautionary tale about the folly of superficiality that is itself endlessly superficial . ","for single digits kidlets stuart little 2 is still a no brainer . if you're looking to rekindle the magic of the first film , you'll need a stronger stomach than us . ","shreve's graceful dual narrative gets clunky on the screen , and we keep getting torn away from the compelling historical tale to a less-compelling soap opera . ","contains a few big laughs but many more that graze the funny bone or miss it altogether , in part because the consciously dumbed-down approach wears thin . ","nothing more than a widget cranked out on an assembly line to see if stupid americans will get a kick out of goofy brits with cute accents performing ages-old slapstick and unfunny tricks . ","this is a film tailor-made for those who when they were in high school would choose the cliff-notes over reading a full-length classic . ","the movie is undone by a filmmaking methodology that's just experimental enough to alienate the mainstream audience while ringing cliched to hardened indie-heads . ","a jumbled fantasy comedy that did not figure out a coherent game plan at scripting , shooting or post-production stages . ","a sad and rote exercise in milking a played-out idea -- a straight guy has to dress up in drag -- that shockingly manages to be even worse than its title would imply . ","personal velocity ought to be exploring these women's inner lives , but it never moves beyond their surfaces . ","we hate [madonna] within the film's first five minutes , and she lacks the skill or presence to regain any ground . ","sounding like arnold schwarzenegger , with a physique to match , [ahola] has a wooden delivery and encounters a substantial arc of change that doesn't produce any real transformation . ","two big things are missing -- anything approaching a visceral kick , and anything approaching even a vague reason to sit through it all . ","a fascinating but choppy documentary . ","scarcely worth a mention apart from reporting on the number of tumbleweeds blowing through the empty theatres graced with its company . ","the doofus-on- the-loose banter of welcome to collinwood has a cocky , after-hours loopiness to it . and as with most late-night bull sessions , eventually the content isn't nearly as captivating as the rowdy participants think it is . ","too stagey , talky -- and long -- for its own good . ","apparently reassembled from the cutting-room floor of any given daytime soap . ","the sinister inspiration that fuelled devito's early work is confused in death to smoochy into something both ugly and mindless . ","despite auteuil's performance , it's a rather listless amble down the middle of the road , where the thematic ironies are too obvious and the sexual politics too smug . ","director boris von sychowski instead opts for a routine slasher film that was probably more fun to make than it is to sit through . "," . . . little more than a well-acted television melodrama shot for the big screen . ","never comes together as a coherent whole . ","an unintentionally surreal kid's picture . . . in which actors in bad bear suits enact a sort of inter-species parody of a vh1 behind the music episode . ","first , for a movie that tries to be smart , it's kinda dumb . and second , what's with all the shooting ? ","don't even bother to rent this on video . ","there is something in full frontal , i guess , about artifice and acting and how it distorts reality for people who make movies and watch them , but like most movie riddles , it works only if you have an interest in the characters you see . ","this is the kind of movie that gets a quick release before real contenders arrive in september . ","not counting a few gross-out comedies i've been trying to forget , this is the first film in a long time that made me want to bolt the theater in the first 10 minutes . ","plays like one long , meandering sketch inspired by the works of john waters and todd solondz , rather than a fully developed story . ","the film doesn't have enough innovation or pizazz to attract teenagers , and it lacks the novel charm that made spy kids a surprising winner with both adults and younger audiences . ","a mawkish self-parody that plays like some weird masterpiece theater sketch with neither a point of view nor a compelling reason for being . ","an average b-movie with no aspirations to be anything more . ","bartlett's hero remains a reactive cipher , when opening the man's head and heart is the only imaginable reason for the film to be made . ","gibney and jarecki just want to string the bastard up . ","the plot is plastered with one hollywood cliche after another , most of which involve precocious kids getting the better of obnoxious adults . ","less worrying about covering all the drama in frida's life and more time spent exploring her process of turning pain into art would have made this a superior movie . ","a film that suffers because of its many excesses . ","too bland and fustily tasteful to be truly prurient . ","in any case , i would recommend big bad love only to winger fans who have missed her since 1995's forget paris . but even then , i'd recommend waiting for dvd and just skipping straight to her scenes . ","depicts the sorriest and most sordid of human behavior on the screen , then laughs at how clever it's being . ","nijinsky says , 'i know how to suffer' and if you see this film you'll know too . ","'cq may one day be fondly remembered as roman coppola's brief pretentious period before going on to other films that actually tell a story worth caring about","the only thing scary about feardotcom is that the filmmakers and studio are brazen enough to attempt to pass this stinker off as a scary movie . "," . . . stale and uninspired . ","a dreary movie . "," . . . the story simply putters along looking for astute observations and coming up blank . ","instead of contriving a climactic hero's death for the beloved-major- character-who-shall- remain-nameless , why not invite some genuine spontaneity into the film by having the evil aliens' laser guns actually hit something for once ? ","it just didn't mean much to me and played too skewed to ever get a hold on ( or be entertained by ) . ","this action-thriller/dark comedy is one of the most repellent things to pop up in a cinematic year already littered with celluloid garbage . ","mib ii is a movie that makes it possible for the viewer to doze off for a few minutes or make several runs to the concession stand and/or restroom and not feel as if he or she has missed anything . that's because relatively nothing happens . ","no amount of arty theorizing -- the special effects are 'german-expressionist , ' according to the press notes -- can render it anything but laughable . ","blue crush follows the formula , but throws in too many conflicts to keep the story compelling . ","boyd's screenplay ( co-written with guardian hack nick davies ) has a florid turn of phrase that owes more to guy ritchie than the bard of avon . ","there's not a spark of new inspiration in it , just more of the same , done with noticeably less energy and imagination . ","jackson shamefully strolls through this mess with a smug grin , inexplicably wearing a kilt and carrying a bag of golf clubs over one shoulder . ","a moving picture that does not move . ","ruh-roh ! romething's really wrong with this ricture ! ","its salient points are simultaneously buried , drowned and smothered in the excesses of writer-director roger avary . ","i'm not sure these words have ever been together in the same sentence : this erotic cannibal movie is boring . ","'god help us , but capra and cooper are rolling over in their graves . '"," . . . an hour-and-a-half of inoffensive , unmemorable filler . ","is it a comedy ? a drama ? a romance ? a cartoon ? ","ze movie starts out so funny , then she is nothing . ","did the film inform and educate me ? yes . did it move me to care about what happened in 1915 armenia ? no . and that is where ararat went astray . ","it's a bad sign in a thriller when you instantly know whodunit . ","has a customarily jovial air but a deficit of flim-flam inventiveness . ","eight legged freaks won't join the pantheon of great monster/science fiction flicks that we have come to love . . . ","it gets the details of its time frame right but it completely misses its emotions . ","who , exactly , is fighting whom here ? ah , yes , that would be me : fighting off the urge to doze . ","a kilted jackson is an unsettling sight , and indicative of his , if you will , out-of-kilter character , who rambles aimlessly through ill-conceived action pieces . ","contrived , awkward and filled with unintended laughs , the film shows signs that someone other than the director got into the editing room and tried to improve things by making the movie go faster . ","starts out with tremendous promise , introducing an intriguing and alluring premise , only to fall prey to a boatload of screenwriting cliches that sink it faster than a leaky freighter . ","the film lapses too often into sugary sentiment and withholds delivery on the pell-mell pyrotechnics its punchy style promises . ","the only question . . . is to determine how well the schmaltz is manufactured -- to assess the quality of the manipulative engineering . average , at best , i'm afraid . ","this movie is so bad , that it's almost worth seeing because it's so bad . ","a crisply made movie that is no more than mildly amusing . ","this movie feel more like a non-stop cry for attention , than an attempt at any kind of satisfying entertainment . ","overall , it's a pretty mediocre family film . ","love may have been in the air onscreen , but i certainly wasn't feeling any of it . ","in addition to the overcooked , ham-fisted direction , which has all the actors reaching for the back row , the dialogue sounds like horrible poetry . ","the very definition of what critics have come to term an  ambitious failure .  ","it's as if de palma spent an hour setting a fancy table and then served up kraft macaroni and cheese . ","the movie ends with outtakes in which most of the characters forget their lines and just utter 'uhhh , ' which is better than most of the writing in the movie . ","worthy of the gong . ","while certainly more naturalistic than its australian counterpart , amari's film falls short in building the drama of lilia's journey . ","i found the movie as divided against itself as the dysfunctional family it portrays . ","the soul-searching deliberateness of the film , although leavened nicely with dry absurdist wit , eventually becomes too heavy for the plot . ","the movie doesn't add anything fresh to the myth . ","as inept as big-screen remakes of the avengers and the wild wild west . ","comes across as a relic from a bygone era , and its convolutions . . . feel silly rather than plausible . ","moves in such odd plot directions and descends into such message-mongering moralism that its good qualities are obscured . ","it's a very sincere work , but it would be better as a diary or documentary . ","once one experiences mr . haneke's own sadistic tendencies toward his audience , one is left with a sour taste in one's mouth , and little else . ","oops , she's really done it this time . that chirpy songbird britney spears has popped up with more mindless drivel . ","it's a loathsome movie , it really is and it makes absolutely no sense . ","a chiller resolutely without chills . ","for those of us who respond more strongly to storytelling than computer-generated effects , the new star wars installment hasn't escaped the rut dug by the last one . ","the director mostly plays it straight , turning leys' fable into a listless climb down the social ladder . ","  bad  is the operative word for  bad company ,  and i don't mean that in a good way . ","though frida is easier to swallow than julie taymor's preposterous titus , the eye candy here lacks considerable brio . ","drumline is -- the mere suggestion , albeit a visually compelling one , of a fully realized story . ","the whole movie is simply a lazy exercise in bad filmmaking that asks you to not only suspend your disbelief but your intelligence as well . ","the film affords us intriguing glimpses of the insights gleaned from a lifetime of spiritual inquiry , but ram dass : fierce grace doesn't organize it with any particular insight . ","pompous and garbled . ","billy crystal and robert de niro sleepwalk through vulgarities in a sequel you can refuse . ","it's loud and boring ; watching it is like being trapped at a bad rock concert . ","merely ( and literally ) tosses around sex toys and offers half-hearted paeans to empowerment that are repeatedly undercut by the brutality of the jokes , most at women's expense . ","if you want a movie time trip , the 1960 version is a far smoother ride . ","traffics in the kind of prechewed racial clichés that have already been through the corporate stand-up-comedy mill . ","the story is -- forgive me -- a little thin , and the filmmaking clumsy and rushed . "," . . . grows decidedly flimsier with its many out-sized , out of character and logically porous action set pieces . ","i wish windtalkers had had more faith in the dramatic potential of this true story . this would have been better than the fiction it has concocted , and there still could have been room for the war scenes . ","aggressive self-glorification and a manipulative whitewash . stay for the credits and see a devastating comic impersonation by dustin hoffman that is revelatory . ","none of the characters or plot-lines are fleshed-out enough to build any interest . ","as social exposé , skins has its heart in the right place , but that's not much to hang a soap opera on . ","the whole film has this sneaky feel to it – as if the director is trying to dupe the viewer into taking it all as very important simply because the movie is ugly to look at and not a hollywood product . ","there's a bit of thematic meat on the bones of queen of the damned , as its origins in an anne rice novel dictate , but generally , it's a movie that emphasizes style over character and substance . ","the only way to tolerate this insipid , brutally clueless film might be with a large dose of painkillers . ","this one is certainly well-meaning , but it's also simple-minded and contrived . ","coppola has made a film of intoxicating atmosphere and little else . ","bad and baffling from the get-go . ","a series of immaculately composed shots of patch adams quietly freaking out does not make for much of a movie . ","at a time when we've learned the hard way just how complex international terrorism is , collateral damage paints an absurdly simplistic picture . ","the impulses that produced this project . . . are commendable , but the results are uneven . ","a well-acted movie that simply doesn't gel . ","like a can of 2-day old coke . you can taste it , but there's no fizz . ","there's no excuse for following up a delightful , well-crafted family film with a computer-generated cold fish . ","both the crime story and the love story are unusual . but they don't fit well together and neither is well told . ","it's both sitcomishly predictable and cloying in its attempts to be poignant . ","other than a mildly engaging central romance , hospital is sickly entertainment at best and mind-destroying cinematic pollution at worst . ","jaglom offers the none-too-original premise that everyone involved with moviemaking is a con artist and a liar . ","outside of burger's desire to make some kind of film , it's really unclear why this project was undertaken","was i scared ? only at the prospect of beck's next project . let's see , a haunted house , a haunted ship , what's next . . . ghost blimp ? ","a fragile framework upon which to hang broad , mildly fleshed-out characters that seem to have been conjured up only 10 minutes prior to filming . ","by the time the plot grinds itself out in increasingly incoherent fashion , you might be wishing for a watch that makes time go faster rather than the other way around . ","since lee is a sentimentalist , the film is more worshipful than your random e ! true hollywood story . ","wes craven's presence is felt ; not the craven of 'a nightmare on elm street' or 'the hills have eyes , ' but the sad schlock merchant of 'deadly friend . '","sunshine state surveys the landscape and assesses the issues with a clear passion for sociology . but the cinematography is cloudy , the picture making becalmed . ","it's one long bore . ","it gets old quickly . watch barbershop again if you're in need of a cube fix--this isn't worth sitting through . ","it's leaden and predictable , and laughs are lacking . "," . . . a cinematic disaster so inadvertently sidesplitting it's worth the price of admission for the ridicule factor alone . ","skip this dreck , rent animal house and go back to the source . ","the movie is a desperate miscalculation . it gives poor dana carvey nothing to do that is really funny , and then expects us to laugh because he acts so goofy all the time . ","we just don't really care too much about this love story . in that setting , their struggle is simply too ludicrous and borderline insulting . ","the transporter bombards the viewer with so many explosions and side snap kicks that it ends up being surprisingly dull . ","uzumaki's interesting social parallel and defiant aesthetic seems a prostituted muse . . . ","'men in black ii creates a new threat for the mib , but recycles the same premise . ","large budget notwithstanding , the movie is such a blip on the year's radar screen that it's tempting just to go with it for the ride . but this time , the old mib label stands for milder isn't better . ","feels familiar and tired . ","a retread of material already thoroughly plumbed by martin scorsese . ","instead of making his own style , director marcus adams just copies from various sources – good sources , bad mixture","criminal conspiracies and true romances move so easily across racial and cultural lines in the film that it makes my big fat greek wedding look like an apartheid drama . ","a bore that tends to hammer home every one of its points . ","a story which fails to rise above its disgusting source material . ","it's fitting that a movie as artificial and soulless as the country bears owes its genesis to an animatronic display at disneyland . ","starts as an intense political and psychological thriller but is sabotaged by ticking time bombs and other hollywood-action cliches . ","completely creatively stillborn and executed in a manner that i'm not sure could be a single iota worse . . . a soulless hunk of exploitative garbage . ","an uneven look into a grim future that doesn't come close to the level of intelligence and visual splendour that can be seen in other films based on philip k . dick stories . ","horrible","the disjointed mess flows as naturally as jolie's hideous yellow 'do . ","bolstered by an astonishing voice cast ( excepting love hewitt ) , an interesting racial tension , and a storyline that i haven't encountered since at least pete's dragon . ","an authentically vague , but ultimately purposeless , study in total pandemonium . ","makes a joke out of car chases for an hour and then gives us half an hour of car chases . ","as the sulking , moody male hustler in the title role , [franco] has all of dean's mannerisms and self-indulgence , but none of his sweetness and vulnerability . ","the only thing to fear about  fear dot com  is hitting your head on the theater seat in front of you when you doze off thirty minutes into the film . ","it's too interested in jerking off in all its byzantine incarnations to bother pleasuring its audience . ","'synthetic' is the best description of this well-meaning , beautifully produced film that sacrifices its promise for a high-powered star pedigree . ","it concentrates far too much on the awkward interplay and utter lack of chemistry between chan and hewitt . ","impostor can't think of a thing to do with these characters except have them run through dark tunnels , fight off various anonymous attackers , and evade elaborate surveillance technologies . ","judd's characters ought to pick up the durable best seller smart women , foolish choices for advice . ","the script has less spice than a rat burger and the rock's fighting skills are more in line with steven seagal . ","this ill-conceived and expensive project winds up looking like a bunch of talented thesps slumming it . "," . . . there's a choppy , surface-effect feeling to the whole enterprise . ","doesn't get the job done , running off the limited chemistry created by ralph fiennes and jennifer lopez . ","a particularly joyless , and exceedingly dull , period coming-of-age tale . ","it's impossible to indulge the fanciful daydreams of janice beard ( eileen walsh ) when her real-life persona is so charmless and vacant . ","…it wasn't the subject matter that ultimately defeated the film…it was the unfulfilling , incongruous ,  wait a second , did i miss something ?  ending . ","this is a movie where the most notable observation is how long you've been sitting still . ","poor editing , bad bluescreen , and ultra-cheesy dialogue highlight the radical action . ","it's super- violent , super-serious and super-stupid . ","so earnest and well-meaning , and so stocked with talent , that you almost forget the sheer , ponderous awfulness of its script . ","just a string of stale gags , with no good inside dope , and no particular bite . ","it's splash without the jokes . ","the château would have been benefited from a sharper , cleaner script before it went in front of the camera . not to mention a sharper , cleaner camera lens . ","shallow , noisy and pretentious . ","morrissette has performed a difficult task indeed - he's taken one of the world's most fascinating stories and made it dull , lifeless , and irritating . ","granddad of le nouvelle vague , jean-luc godard continues to baffle the faithful with his games of hide-and-seek . ","this loud and thoroughly obnoxious comedy about a pair of squabbling working-class spouses is a deeply unpleasant experience . ","it's better than the phantom menace . but unless you're an absolute raving star wars junkie , it isn't much fun . ","philosophically , intellectually and logistically a mess . ","a standard police-oriented drama that , were it not for de niro's participation , would have likely wound up a tnt original . ","coupling disgracefully written dialogue with flailing bodily movements that substitute for acting , circuit is the awkwardly paced soap opera-ish story . ","hollywood ending just isn't very funny . ","though clearly well-intentioned , this cross-cultural soap opera is painfully formulaic and stilted . ","a technical triumph and an extraordinary bore . ","i can easily imagine benigni's pinocchio becoming a christmas perennial . coal isn't as easy to come by as it used to be and this would be a worthy substitute for naughty children's stockings . ","two hours of junk . ","ends up being mostly about ravishing costumes , eye-filling , wide-screen production design and joan's wacky decision to stand by her man , no matter how many times he demonstrates that he's a disloyal satyr . ","self-congratulatory , misguided , and ill-informed , if nonetheless compulsively watchable . ","a clumsily manufactured exploitation flick , a style-free exercise in manipulation and mayhem . ","the whole affair , true story or not , feels incredibly hokey . . . [it] comes off like a hallmark commercial . ","what's missing is what we call the 'wow' factor . ","the nicest thing that can be said about stealing harvard ( which might have been called freddy gets molested by a dog ) is that it's not as obnoxious as tom green's freddie got fingered . "," . . . tara reid plays a college journalist , but she looks like the six-time winner of the miss hawaiian tropic pageant , so i don't know what she's doing in here . . . ","the young stars are too cute ; the story and ensuing complications are too manipulative ; the message is too blatant ; the resolutions are too convenient . ","normally , rohmer's talky films fascinate me , but when he moves his setting to the past , and relies on a historical text , he loses the richness of characterization that makes his films so memorable . ","i highly recommend irwin , but not in the way this film showcases him . ","it's been 13 months and 295 preview screenings since i last walked out on a movie , but resident evil really earned my indignant , preemptive departure . ","this picture is mostly a lump of run-of-the-mill profanity sprinkled with a few remarks so geared toward engendering audience sympathy that you might think he was running for office -- or trying to win over a probation officer . ","malone does have a gift for generating nightmarish images that will be hard to burn out of your brain . but the movie's narrative hook is way too muddled to be an effectively chilling guilty pleasure . ","though it goes further than both , anyone who has seen the hunger or cat people will find little new here , but a tasty performance from vincent gallo lifts this tale of cannibal lust above the ordinary . ","a blair witch- style adventure that plays like a bad soap opera , with passable performances from everyone in the cast . ","diaz wears out her welcome in her most charmless performance","it is too bad that this likable movie isn't more accomplished . the actors try hard but come off too amateurish and awkward . ","the plot has a number of holes , and at times it's simply baffling . ","an ill-conceived jumble that's not scary , not smart and not engaging . ","brainless , but enjoyably over-the-top , the retro gang melodrama , deuces wild represents fifties teen-gang machismo in a way that borders on rough-trade homo-eroticism . ","gets bogged down by an overly sillified plot and stop-and-start pacing . ","utter mush . . . conceited pap . ","  what john does is heroic , but we don't condone it ,  one of the film's stars recently said , a tortuous comment that perfectly illustrates the picture's moral schizophrenia . ","like coming into a long-running , well-written television series where you've missed the first half-dozen episodes and probably won't see the next six . ","this is no  waterboy !  ","its generic villains lack any intrigue ( other than their funny accents ) and the action scenes are poorly delivered . ","dripping with cliche and bypassing no opportunity to trivialize the material . ","hard-core slasher aficionados will find things to like . . . but overall the halloween series has lost its edge . ","stiff and schmaltzy and clumsily directed . ","the story the movie tells is of brian de palma's addiction to the junk-calorie suspense tropes that have all but ruined his career . ","too many improbabilities and rose-colored situations temper what could've been an impacting film . ","generic slasher-movie nonsense , but it's not without style . ","with tiny little jokes and nary an original idea , this sappy ethnic sleeper proves that not only blockbusters pollute the summer movie pool . ","it sticks rigidly to the paradigm , rarely permitting its characters more than two obvious dimensions and repeatedly placing them in contrived , well-worn situations . ","ever see one of those comedies that just seem like a bad idea from frame one ? ","once ice-t sticks his mug in the window of the couple's bmw and begins haranguing the wife in bad stage dialogue , all credibility flies out the window . ","the best drug addition movies are usually depressing but rewarding . quitting , however , manages just to be depressing , as the lead actor phones in his autobiographical performance . ","it would be great to see this turd squashed under a truck , preferably a semi . ","in the end , all you can do is admire the ensemble players and wonder what the point of it is . ","for most movies , 84 minutes is short , but this one feels like a life sentence . ","while glover , the irrepressible eccentric of river's edge , dead man and back to the future , is perfect casting for the role , he represents bartleby's main overall flaw . ","something has been lost in the translation . . . another routine hollywood frightfest in which the slack execution italicizes the absurdity of the premise . ","shatner is probably the funniest person in the film , which gives you an idea just how bad it was . ","tries so hard to be quirky and funny that the strain is all too evident . ","as immaculate as stuart little 2 is , it could be a lot better if it were , well , more adventurous . ","simply a re-hash of the other seven films . ","with jump cuts , fast editing and lots of pyrotechnics , yu clearly hopes to camouflage how bad his movie is . he fails . ","i found myself more appreciative of what the director was trying to do than of what he had actually done . ","a very depressing movie of many missed opportunities . ","goes on and on to the point of nausea . ","by turns numbingly dull-witted and disquietingly creepy . ","boy , has this franchise ever run out of gas . ","one problem with the movie , directed by joel schumacher , is that it jams too many prefabricated story elements into the running time . ","the comedy is nonexistent . "," . . . a bland , pretentious mess . ","it's a pedestrian , flat drama that screams out 'amateur' in almost every frame . ","a bland animated sequel that hardly seems worth the effort . ","it's not just the vampires that are damned in queen of the damned -- the viewers will feel they suffer the same fate . ","if religious films aren't your bailiwick , stay away . otherwise , this could be a passable date film . ","this is the case of a pregnant premise being wasted by a script that takes few chances and manages to insult the intelligence of everyone in the audience . ","the pace and the visuals are so hyped up that a curious sense of menace informs everything . ","stuffy , full of itself , morally ambiguous and nothing to shout about . ","it is most of the things costner movies are known for ; it's sanctimonious , self-righteous and so eager to earn our love that you want to slap it . ","don't let the subtitles fool you ; the movie only proves that hollywood no longer has a monopoly on mindless action . ","chai's structure and pacing are disconcertingly slack . ","to be oblivious to the existence of this film would be very sweet indeed . ","the director , with his fake backdrops and stately pacing , never settles on a consistent tone . ","one just waits grimly for the next shock without developing much attachment to the characters . ","instead of panoramic sweep , kapur gives us episodic choppiness , undermining the story's emotional thrust . ","the director seems to take an unseemly pleasure in [the characters'] misery and at the same time to congratulate himself for having the guts to confront it . ","this dubious product of a college-spawned ( colgate u . ) comedy ensemble known as broken lizard plays like a mix of cheech and chong and chips . ","the movie doesn't think much of its characters , its protagonist , or of us . ","super troopers is an odd amalgam of comedy genres , existing somewhere between the often literal riffs of early zucker brothers/abrahams films , and the decidedly foul stylings of their post-modern contemporaries , the farrelly brothers . "," . . . will always be remembered for the 9-11 terrorist attacks . after seeing the film , i can tell you that there's no other reason why anyone should bother remembering it . ","made me feel uneasy , even queasy , because [solondz's] cool compassion is on the border of bemused contempt . ","as a kind of colorful , dramatized pbs program , frida gets the job done . but , for that , why not watch a documentary ? ","with minimal imagination , you could restage the whole thing in your bathtub . ","nights feels more like a quickie tv special than a feature film . . . it's not even a tv special you'd bother watching past the second commercial break . ","although . . . visually striking and slickly staged , it's also cold , grey , antiseptic and emotionally desiccated . ","you can see where big bad love is trying to go , but it never quite gets there . ","friday after next is the kind of film that could only be made by african-americans because of its broad racial insensitivity towards african-americans . ","it's not as awful as some of the recent hollywood trip tripe . . . but it's far from a groundbreaking endeavor . ","the only thing  swept away  is the one hour and thirty-three minutes spent watching this waste of time . ","one-sided documentary offers simplistic explanations to a very complex situation . . . . stylistically , the movie is a disaster . ","the corpse count ultimately overrides what little we learn along the way about vicarious redemption . ","as violent , profane and exploitative as the most offensive action flick you've ever seen . ","egoyan's work often elegantly considers various levels of reality and uses shifting points of view , but here he has constructed a film so labyrinthine that it defeats his larger purpose . ","life or something like it has its share of high points , but it misses too many opportunities . ","this is a truly , truly bad movie . ","despite bearing the paramount imprint , it's a bargain-basement european pickup . what's hard to understand is why anybody picked it up . wiser souls would have tactfully pretended not to see it and left it lying there","believability wasn't one of the film's virtues . ","sewer rats could watch this movie and be so skeeved out that they'd need a shower . ","the santa clause 2's plot may sound like it was co-written by mattel executives and lobbyists for the tinsel industry . ","his best film remains his shortest , the hole , which makes many of the points that this film does but feels less repetitive . ","just another disjointed , fairly predictable psychological thriller . "," . . . stumbles over every cheap trick in the book trying to make the outrage come even easier . ","even the hastily and amateurishly drawn animation cannot engage . ","kung pow is oedekerk's realization of his childhood dream to be in a martial-arts flick , and proves that sometimes the dreams of youth should remain just that . ","busy urban comedy is clearly not zhang's forte , his directorial touch is neither light nor magical enough to bring off this kind of whimsy . ","well-meaning but inert . ","not completely loveable -- but what underdog movie since the bad news bears has been ? -- but certainly hard to hate . ","a movie that can't get sufficient distance from leroy's delusions to escape their maudlin influence . ","it's young guns meets goodfellas in this easily skippable hayseeds-vs . -greaseballs mob action-comedy . ","louiso lets the movie dawdle in classic disaffected-indie-film mode , and brother hoffman's script stumbles over a late-inning twist that just doesn't make sense . ","the movie straddles the fence between escapism and social commentary , and on both sides it falls short . ","the film is old-fashioned , occasionally charming and as subtle as boldface . ","can't get enough of libidinous young city dwellers ? try this obscenely bad dark comedy , so crass that it makes edward burns' sidewalks of new york look like oscar wilde . ","in the new guy , even the bull gets recycled . "," . . . overly melodramatic . . . ","largely , this is a movie that also does it by the numbers . ","on top of a foundering performance , [madonna's] denied her own athleticism by lighting that emphasizes every line and sag . ","the result is an 'action film' mired in stasis . ","this is the first full scale wwii flick from hong kong's john woo . he's not good with people . ","patchy combination of soap opera , low-tech magic realism and , at times , ploddingly sociological commentary . ","[stevens is] so stoked to make an important film about human infidelity and happenstance that he tosses a kitchen sink onto a story already overladen with plot conceits . ","so boring that even its target audience talked all the way through it . ","one of the more glaring signs of this movie's servitude to its superstar is the way it skirts around any scenes that might have required genuine acting from ms . spears . ","hollywood ending is the most disappointing woody allen movie ever . he has a great cast and a great idea . but the execution is a flop with the exception of about six gags that really work . "," . . . generically , forgettably pleasant from start to finish . ","it's just hard to believe that a life like this can sound so dull . ","when not wallowing in its characters' frustrations , the movie is busy contriving false , sitcom-worthy solutions to their problems . ","an overstylized , puréed mélange of sex , psychology , drugs and philosophy . sometimes entertaining , sometimes indulgent -- but never less than pure wankery . ","'lovely and amazing , ' unhappily , is neither . . . excessively strained and contrived . ","ringu is a disaster of a story , full of holes and completely lacking in chills . ignore the reputation , and ignore the film . ","this one is a few bits funnier than malle's dud , if only because the cast is so engagingly messing around like slob city reductions of damon runyon crooks . ","'it's painful to watch witherspoon's talents wasting away inside unnecessary films like legally blonde and sweet home abomination , i mean , alabama . '","a plodding teen remake that's so mechanical you can smell the grease on the plot twists . ","trying to figure out the rules of the country bear universe -- when are bears bears and when are they like humans , only hairier -- would tax einstein's brain . ","even in terms of the low-grade cheese standards on which it operates , it never quite makes the grade as tawdry trash . ","amidst the action , the script carries arnold ( and the viewers ) into the forbidden zone of sympathizing with terrorist motivations by presenting the  other side of the story .  ","rife with nutty cliches and far too much dialogue . ","it's a 100-year old mystery that is constantly being interrupted by elizabeth hurley in a bathing suit . "," . . . one big laugh , three or four mild giggles , and a whole lot of not much else . ","too intensely focused on the travails of being hal hartley to function as pastiche , no such thing is hartley's least accessible screed yet . ","kenneth branagh's energetic sweet-and-sour performance as a curmudgeonly british playwright grounds this overstuffed , erratic dramedy in which he and his improbably forbearing wife contend with craziness and child-rearing in los angeles . ","director uwe boll and writer robert dean klein fail to generate any interest in an unsympathetic hero caught up in an intricate plot that while cleverly worked out , cannot overcome blah characters . ","ms . phoenix is completely lacking in charm and charisma , and is unable to project either esther's initial anomie or her eventual awakening . ","the movie fails to portray its literarily talented and notorious subject as anything much more than a dirty old man . ","extremely bad . ","a clichéd and shallow cautionary tale about the hard-partying lives of gay men . ","the fetid underbelly of fame has never looked uglier . ","a little weak -- and it isn't that funny . ","while it is welcome to see a chinese film depict a homosexual relationship in a mature and frank fashion , lan yu never catches dramatic fire . ","the script boasts some tart tv-insider humor , but the film has not a trace of humanity or empathy . ","despite the pyrotechnics , narc is strictly by the book . ","in both the writing and cutting , it does not achieve the kind of dramatic unity that transports you . you end up simply admiring this bit or that , this performance or that . ","cacoyannis is perhaps too effective in creating an atmosphere of dust-caked stagnation and labored gentility . ","worth seeing once , but its charm quickly fades . ","the original wasn't a good movie but this remake makes it look like a masterpiece ! ","one suspects that craven endorses they simply because this movie makes his own look much better by comparison . ","gere gives a good performance in a film that doesn't merit it . ","your appreciation of it will depend on what experiences you bring to it and what associations you choose to make . ","includes too much obvious padding . ","there's no palpable chemistry between lopez and male lead ralph fiennes , plus the script by working girl scribe kevin wade is workmanlike in the extreme . ","i'm not sure which half of dragonfly is worse : the part where nothing's happening , or the part where something's happening , but it's stupid . ","don't expect any subtlety from this latest entry in the increasingly threadbare gross-out comedy cycle . ","the only camouflage carvey should now be considering is a paper bag to wear over his head when he goes out into public , to avoid being recognized as the man who bilked unsuspecting moviegoers . ","shot like a postcard and overacted with all the boozy self-indulgence that brings out the worst in otherwise talented actors . . . ","spain's greatest star wattage doesn't overcome the tumult of maudlin tragedy . "," . . . a movie that , quite simply , shouldn't have been made . ","conforms itself with creating a game of 'who's who' . . . where the characters' moves are often more predictable than their consequences . ","looks and feels like a low-budget hybrid of scarface or carlito's way . ","the script is a tired one , with few moments of joy rising above the stale material . ","suffers from all the excesses of the genre . ","the verdict : two bodies and hardly a laugh between them . ","the latest adam sandler assault and possibly the worst film of the year . ","downbeat , period-perfect biopic hammers home a heavy-handed moralistic message . ","while the film is competent , it's also uninspired , lacking the real talent and wit to elevate it beyond its formula to the level of classic romantic comedy to which it aspires . ","they ought to be a whole lot scarier than they are in this tepid genre offering . ","it's harmless , diverting fluff . but it's hard to imagine a more generic effort in the genre . ","it's just plain lurid when it isn't downright silly . ","comedy troupe broken lizard's first movie is very funny but too concerned with giving us a plot . ","pap invested in undergraduate doubling subtexts and ridiculous stabs at existentialism reminding of the discovery of the wizard of god in the fifth trek flick . ","a horror movie with seriously dumb characters , which somewhat dilutes the pleasure of watching them stalked by creepy-crawly bug things that live only in the darkness . ","it's a film with an idea buried somewhere inside its fabric , but never clearly seen or felt . ","'all in all , reign of fire will be a good ( successful ) rental . '","occasionally funny , sometimes inspiring , often boring . ","a movie in which two not very absorbing characters are engaged in a romance you can't wait to see end . ","the predominantly amateur cast is painful to watch , so stilted and unconvincing are the performances . ","who are 'they' ? well , they're 'they' . they're the unnamed , easily substitutable forces that serve as whatever terror the heroes of horror movies try to avoid . they exist for hushed lines like  they're back !  ,  they're out there !  and  they're coming !  ","elegantly crafted but emotionally cold , a puzzle whose intricate construction one can admire but is difficult to connect with on any deeper level . ","were dylan thomas alive to witness first-time director ethan hawke's strained chelsea walls , he might have been tempted to change his landmark poem to , 'do not go gentle into that good theatre . '","the story has its redundancies , and the young actors , not very experienced , are sometimes inexpressive . ","i'm sure the filmmaker would disagree , but , honestly , i don't see the point . it's a visual rorschach test and i must have failed . ","the film is really closer to porn than a serious critique of what's wrong with this increasingly pervasive aspect of gay culture . ","murder by numbers just doesn't add up . ","clare peploe's airless movie adaptation could use a little american pie-like irreverence . ","video games are more involving than this mess . ","clayburgh and tambor are charming performers ; neither of them deserves eric schaeffer . ","a pale xerox of other , better crime movies . "," . . . a hokey piece of nonsense that tries too hard to be emotional . ","illiterate , often inert sci-fi action thriller . ","a perfect example of rancid , well-intentioned , but shamelessly manipulative movie making . ","the adventure doesn't contain half the excitement of balto , or quarter the fun of toy story 2 . ","essentially a collection of bits -- and they're all naughty . ","a mess . the screenplay does too much meandering , norton has to recite bland police procedural details , fiennes wanders around in an attempt to seem weird and distanced , hopkins looks like a drag queen . ","the screenplay by james eric , james horton and director peter o'fallon . . . is so pat it makes your teeth hurt . ","before it takes a sudden turn and devolves into a bizarre sort of romantic comedy , steven shainberg's adaptation of mary gaitskill's harrowing short story . . . is a brilliantly played , deeply unsettling experience . ","solaris is rigid and evasive in ways that soderbergh's best films ,  erin brockovich ,   out of sight  and  ocean's eleven ,  never were . ","seems like something american and european gay movies were doing 20 years ago . ","in the process of trimming the movie to an expeditious 84 minutes , director roger kumble seems to have dumped a whole lot of plot in favor of . . . outrageous gags . ","you can see the would-be surprises coming a mile away , and the execution of these twists is delivered with a hammer . thumbs down . ","the characters are paper thin and the plot is so cliched and contrived that it makes your least favorite james bond movie seem as cleverly plotted as the usual suspects . "," . . . del toro maintains a dark mood that makes the film seem like something to endure instead of enjoy . ","the movie eventually snaps under the strain of its plot contrivances and its need to reassure . ","the real question this movie poses is not 'who ? ' but 'why ? '","now here's a sadistic bike flick that would have made vittorio de sica proud . ","a movie that's about as overbearing and over-the-top as the family it depicts . ","a movie in which laughter and self-exploitation merge into jolly soft-porn 'empowerment . '","occasionally interesting but essentially unpersuasive , a footnote to a still evolving story . ","if we're to slap protagonist genevieve leplouff because she's french , do we have that same option to slap her creators because they're clueless and inept ? ","moretti plays giovanni , a psychiatrist who predictably finds it difficult to sustain interest in his profession after the family tragedy . too predictably , in fact . ","alternative medicine obviously has its merits . . . but ayurveda does the field no favors . ","this thing works on no level whatsoever for me . ","it follows the basic plot trajectory of nearly every schwarzenegger film : someone crosses arnie . arnie blows things up . ","ice age posits a heretofore unfathomable question : is it possible for computer-generated characters to go through the motions ? ","an incoherent jumble of a film that's rarely as entertaining as it could have been . "," . . . they missed the boat . ","more dutiful than enchanting . . . terribly episodic and lacking the spark of imagination that might have made it an exhilarating treat . ","laconic and very stilted in its dialogue , this indie flick never found its audience , probably because it's extremely hard to relate to any of the characters . ","the comedy death to smoochy is a rancorous curiosity : a movie without an apparent audience . ","barney's ideas about creation and identity don't really seem all that profound , at least by way of what can be gleaned from this three-hour endurance test built around an hour's worth of actual material . ","affleck merely creates an outline for a role he still needs to grow into , a role that ford effortlessly filled with authority . ","cinematic pyrotechnics aside , the only thing avary seems to care about are mean giggles and pulchritude . it makes sense that he went back to school to check out the girls -- his film is a frat boy's idea of a good time . ","the narrative is so consistently unimaginative that probably the only way to have saved the film is with the aid of those wisecracking mystery science theater 3000 guys . ","nothing more or less than an outright bodice-ripper -- it should have ditched the artsy pretensions and revelled in the entertaining shallows . ","a living testament to the power of the eccentric and the strange . the fact that it isn't very good is almost beside the point . ","feels less like a cousin to blade runner than like a bottom-feeder sequel in the escape from new york series . ","what might have been acceptable on the printed page of iles' book does not translate well to the screen . ","if oscar had a category called best bad film you thought was going to be really awful but wasn't , guys would probably be duking it out with the queen of the damned for the honor . ","a poky and pseudo-serious exercise in sham actor workshops and an affected malaise . ","mediocre fable from burkina faso . ","fessenden has nurtured his metaphors at the expense of his narrative , but he does display an original talent . ","since the movie is based on a nicholas sparks best seller , you know death is lurking around the corner , just waiting to spoil things . ","bottom-rung new jack city wannabe . ","fincher takes no apparent joy in making movies , and he gives none to the audience . ","it's mildly amusing , but i certainly can't recommend it . ","nicholas nickleby celebrates the human spirit with such unrelenting dickensian decency that it turned me ( horrors ! ) into scrooge . ","fear dot com is more frustrating than a modem that disconnects every 10 seconds . ","full of flatulence jokes and mild sexual references , kung pow ! is the kind of movie that's critic-proof , simply because it aims so low . ","may cause you to bite your tongue to keep from laughing at the ridiculous dialog or the oh-so convenient plot twists . ","there are just too many characters saying too many clever things and getting into too many pointless situations . where's the movie here ? ","a dark , dull thriller with a parting shot that misfires . ","lacking substance and soul , crossroads comes up shorter than britney's cutoffs . ","cassavetes thinks he's making dog day afternoon with a cause , but all he's done is to reduce everything he touches to a shrill , didactic cartoon . ","buries an interesting storyline about morality and the choices we make underneath such a mountain of clichés and borrowed images that it might more accurately be titled mr . chips off the old block . ","although sensitive to a fault , it's often overwritten , with a surfeit of weighty revelations , flowery dialogue , and nostalgia for the past and roads not taken . ","it's so badly made on every level that i'm actually having a hard time believing people were paid to make it . ","without non-stop techno or the existential overtones of a kieslowski morality tale , maelström is just another winter sleepers . ","nicks , seemingly uncertain what's going to make people laugh , runs the gamut from stale parody to raunchy sex gags to formula romantic comedy . ","'a' for creativity but comes across more as a sketch for a full-length comedy . ","if there's one thing this world needs less of , it's movies about college that are written and directed by people who couldn't pass an entrance exam . ","the script kicks in , and mr . hartley's distended pace and foot-dragging rhythms follow . ","[e]ventually , every idea in this film is flushed down the latrine of heroism . ","i am sorry that i was unable to get the full brunt of the comedy . ","no telegraphing is too obvious or simplistic for this movie . ","looks and feels like a project better suited for the small screen . ","in its best moments , resembles a bad high school production of grease , without benefit of song . ","indifferently implausible popcorn programmer of a movie . ","it's inoffensive , cheerful , built to inspire the young people , set to an unending soundtrack of beach party pop numbers and aside from its remarkable camerawork and awesome scenery , it's about as exciting as a sunburn . ","his comedy premises are often hackneyed or just plain crude , calculated to provoke shocked laughter , without following up on a deeper level . ","christina ricci comedy about sympathy , hypocrisy and love is a misfire . ","at times , the suspense is palpable , but by the end there's a sense that the crux of the mystery hinges on a technicality that strains credulity and leaves the viewer haunted by the waste of potential . ","they should have called it gutterball . ","thekids will probably stay amused at the kaleidoscope of big , colorful characters . mom and dad can catch some quality naptime along the way . ","it's too self-important and plodding to be funny , and too clipped and abbreviated to be an epic . ","the best that can be said about the work here of scottish director ritchie . . . is that he obviously doesn't have his heart in it . ","less dizzying than just dizzy , the jaunt is practically over before it begins . ","slick piece of cross-promotion . ","taylor appears to have blown his entire budget on soundtrack rights and had nothing left over for jokes . ","it believes it's revealing some great human truths , when , in reality , it's churning ground that has long passed the point of being fertile . ","by turns pretentious , fascinating , ludicrous , provocative and vainglorious . ","it all drags on so interminably it's like watching a miserable relationship unfold in real time . ","villeneuve spends too much time wallowing in bibi's generic angst ( there are a lot of shots of her gazing out windows ) . ","[t]here's only so much anyone can do with a florid , overplotted , anne rice rock 'n' roll vampire novel before the built-in silliness of the whole affair defeats them . ","it's another video movie photographed like a film , with the bad lighting that's often written off as indie film naturalism . ","the techno tux is good for a few laughs , as are chan and hewitt , but when such a good design turns out to be a cheap knockoff , we can't recommend anything but a rental for the tuxedo . ","i got a headache watching this meaningless downer . ","apart from dazzling cinematography , we've seen just about everything in blue crush in one form or the other . ","too much of the humor falls flat . ","detox is ultimately a pointless endeavor . ","van wilder doesn't bring anything new to the proverbial table , but it does possess a coherence absent in recent crass-a-thons like tomcats , freddy got fingered , and slackers . ","the piquant story needs more dramatic meat on its bones . ","very special effects , brilliantly bold colors and heightened reality can't hide the giant achilles' heel in  stuart little 2  : there's just no story , folks . ","the plot combines the blues brothers and almost famous ( but with bears , and a g rating ) , with an excruciating dollop of disney sentimentality mixed in for good measure . ","no way i can believe this load of junk . ","  roger michell (  notting hill  ) directs a morality thriller .  ","it's dumb , but more importantly , it's just not scary . ","there is no pleasure in watching a child suffer . just embarrassment and a vague sense of shame . ","the movie's accumulated force still feels like an ugly knot tightening in your stomach . but is that knot from dramatic tension or a symptom of artistic malnutrition ? ","even with a green mohawk and a sheet of fire-red flame tattoos covering his shoulder , however , kilmer seems to be posing , rather than acting . and that leaves a hole in the center of the salton sea . ","there's just no currency in deriding james bond for being a clichéd , doddering , misogynistic boy's club . ","when the film ended , i felt tired and drained and wanted to lie on my own deathbed for a while . ","full of witless jokes , dealing in broad stereotypes and outrageously unbelievable scenarios , and saddled with a general air of misogyny","the film's hackneyed message is not helped by the thin characterizations , nonexistent plot and pretentious visual style . ","the iditarod lasts for days - this just felt like it did . "," it feels like an after-school special gussied up with some fancy special effects , and watching its rote plot points connect is about as exciting as gazing at an egg timer for 93 minutes . ","this movie is maddening . it conveys a simple message in a visual style that is willfully overwrought . ","should have been someone else-","the film is based on truth and yet there is something about it that feels incomplete , as if the real story starts just around the corner . ","why make a documentary about these marginal historical figures ? wouldn't one about their famous dad , author of death in venice , etc . , be more valuable ? ","the lower your expectations , the more you'll enjoy it . ","rarely has leukemia looked so shimmering and benign . ","… is an arthritic attempt at directing by callie khouri . i had to look away - this was god awful . ","even in this less-than-magic kingdom , reese rules . ","velocity represents everything wrong with ''independent film'' as a commodified , sold-out concept on the american filmmaking scene . ","just one bad idea after another . ","because of an unnecessary and clumsy last scene , 'swimfan' left me with a very bad feeling . ","though moonlight mile is replete with acclaimed actors and actresses and tackles a subject that's potentially moving , the movie is too predictable and too self-conscious to reach a level of high drama . ","a movie that hovers somewhere between an acute character study and a trite power struggle . ","i can't recommend it . but it's surprisingly harmless . ","corpus collosum -- while undeniably interesting -- wore out its welcome well before the end credits rolled about 45 minutes in . ","the last 20 minutes are somewhat redeeming , but most of the movie is the same teenage american road-trip drek we've seen before - only this time you have to read the fart jokes","it's hard to like a film about a guy who is utterly unlikeable , and shiner , starring michael caine as an aging british boxing promoter desperate for a taste of fame and fortune , is certainly that . ","a by-the-numbers effort that won't do much to enhance the franchise . ","involves two mysteries -- one it gives away and the other featuring such badly drawn characters that its outcome hardly matters . ","overall the film feels like a low-budget tv pilot that could not find a buyer to play it on the tube . ","it's of the quality of a lesser harrison ford movie - six days , seven nights , maybe , or that dreadful sabrina remake . ","it appears that something has been lost in the translation to the screen . ","despite all evidence to the contrary , this clunker has somehow managed to pose as an actual feature movie , the kind that charges full admission and gets hyped on tv and purports to amuse small children and ostensible adults . ","shrewd but pointless . ","an unclassifiably awful study in self- and audience-abuse . ","sluggish , tonally uneven . ","this movie is something of an impostor itself , stretching and padding its material in a blur of dead ends and distracting camera work . ","hey arnold ! the movie could have been made 40 years ago , and parents' appreciation of it may depend on whether they consider that a good thing . ","this one is definitely one to skip , even for horror movie fanatics . ","excessive , profane , packed with cartoonish violence and comic-strip characters . ","once the 50 year old benigni appears as the title character , we find ourselves longing for the block of wood to come back . ","a working class  us vs . them  opera that leaves no heartstring untugged and no liberal cause unplundered . ","if the movie succeeds in instilling a wary sense of 'there but for the grace of god , ' it is far too self-conscious to draw you deeply into its world . ","there are simply too many ideas floating around -- part farce , part sliding doors , part pop video -- and yet failing to exploit them . ","it takes a strange kind of laziness to waste the talents of robert forster , anne meara , eugene levy , and reginald veljohnson all in the same movie . ","we haven't seen such hilarity since say it isn't so ! ","expect the same-old , lame-old slasher nonsense , just with different scenery . ","the cold turkey would've been a far better title . ","the idea of 49-year-old roberto benigni playing the wooden boy pinocchio is scary enough . the reality of the new live-action pinocchio he directed , cowrote and starred in borders on the grotesque . ","the ga-zillionth airhead movie about a wife in distress who resorts to desperate measures . ","zaidan's script has barely enough plot to string the stunts together and not quite enough characterization to keep the faces straight . ","try as i may , i can't think of a single good reason to see this movie , even though everyone in my group extemporaneously shouted , 'thank you ! ' when leguizamo finally plugged an irritating character late in the movie . ","while it's nice to watch a movie that hasn't been focus-grouped into tedium , yu's cinematic alchemy produces nearly as much lead as gold . ","it treats women like idiots . ","though catch me if you can isn't badly made , the fun slowly leaks out of the movie . ","just an average comedic dateflick but not a waste of time . ","a valueless kiddie paean to pro basketball underwritten by the nba . ","impostor has a handful of thrilling moments and a couple of good performances , but the movie doesn't quite fly . for starters , the story is just too slim . ","so much facile technique , such cute ideas , so little movie . ","the experience of going to a film festival is a rewarding one ; the experiencing of sampling one through this movie is not . ","the film takes the materials of human tragedy and dresses them in lovely costumes , southern california locations and star power . ","it has its moments of swaggering camaraderie , but more often just feels generic , derivative and done to death . ","almost gags on its own gore . ","how do you spell cliché ? ","it's sweet , harmless , dumb , occasionally funny and about as compelling as a fishing show . ","the moviegoing equivalent of going to a dinner party and being forced to watch the host and hostess's home video of their baby's birth . ","while [hill] has learned new tricks , the tricks alone are not enough to salvage this lifeless boxing film . ","in the real world , an actor this uncharismatically beautiful would have a résumé loaded with credits like  girl in bar #3 .  ","too much of it feels unfocused and underdeveloped . ","under 15 ? a giggle a minute . over age 15 ? big fat waste of time . ","hey arnold ! the movie is what happens when you blow up small potatoes to 10 times their natural size , and it ain't pretty . ","sometimes seems less like storytelling than something the otherwise compelling director needed to get off his chest . ","this is not the undisputed worst boxing movie ever , but it's certainly not a champion - the big loser is the audience . ","you really have to wonder how on earth anyone , anywhere could have thought they'd make audiences guffaw with a script as utterly diabolical as this . ","in the end , we are left with something like two ships passing in the night rather than any insights into gay love , chinese society or the price one pays for being dishonest . ","chokes on its own depiction of upper-crust decorum . ","well-nigh unendurable . . . though the picture strains to become cinematic poetry , it remains depressingly prosaic and dull . ","i thought my own watch had stopped keeping time as i slogged my way through clockstoppers . ","while much of the cast has charm -- especially allodi and nolden -- the performers are sunk by the film's primitive approach to the mechanics of comedy . ","this directorial debut from music video show-off higuchinsky is all flash . ","yes , ballistic is silly . unfortunately , it's not silly fun unless you enjoy really bad movies . ","the twist that ends the movie is the one with the most emotional resonance , but twists are getting irritating , and this is the kind of material where the filmmakers should be very careful about raising eyebrows . ","the longer the movie goes , the worse it gets , but it's actually pretty good in the first few minutes . ","while it's genuinely cool to hear characters talk about early rap records ( sugar hill gang , etc . ) , the constant referencing of hip-hop arcana can alienate even the savviest audiences . ","not only unfunny , but downright repellent . ","care deftly captures the wonder and menace of growing up , but he never really embraces the joy of fuhrman's destructive escapism or the grace-in-rebellion found by his characters . ","forced , familiar and thoroughly condescending . ","does little more than play an innocuous game of fill-in- the-blanks with a tragic past . ","k-19 exploits our substantial collective fear of nuclear holocaust to generate cheap hollywood tension . ","has a long and clunky ending . . . which forces the audience to fidget through ten pseudo-serious minutes while waiting for the ending credits and the deleted scenes montage to break the audience's awkward silence","a ragbag of promising ideas and failed narrative , of good acting and plain old bad filmmaking . ","whaley's determination to immerse you in sheer , unrelenting wretchedness is exhausting . ","uncommonly stylish but equally silly . . . the picture fails to generate much suspense , nor does it ask searching enough questions to justify its pretensions . ","the entire movie is about a boring , sad man being boring and sad . ","the plot convolutions ultimately add up to nothing more than jerking the audience's chain . ","confirms the nagging suspicion that ethan hawke would be even worse behind the camera than he is in front of it . ","made with no discernible craft and monstrously sanctimonious in dealing with childhood loss . ","it's a trifle of a movie , with a few laughs surrounding an unremarkable soft center . ","holden caulfield did it better . ","a synthesis of cliches and absurdities that seems positively decadent in its cinematic flash and emptiness . ","oh come on . like you couldn't smell this turkey rotting from miles away . ","if it's seldom boring , well , it's also rarely coherent . ","simplistic fluff-ball of whimsy . ","not exactly the bees knees","it does nothing new with the old story , except to show fisticuffs in this sort of stop-go slow motion that makes the gang rumbles look like they're being streamed over a 28k modem . ","the kind of spectacularly misconceived enterprise that only a sophisticated cinephile could have perpetrated . ","makes for some truly odd , at times confusing , kids entertainment . . . but at least this time there's some centered storytelling to go along with all the weird stuff . ","the film contains no good jokes , no good scenes , barely a moment when carvey's saturday night live-honed mimicry rises above the level of embarrassment . ","jacquot's rendering of puccini's tale of devotion and double-cross is more than just a filmed opera . in his first stab at the form , jacquot takes a slightly anarchic approach that works only sporadically . ","chabrol has taken promising material for a black comedy and turned it instead into a somber chamber drama . ","it's as if you're watching a movie that was made in 1978 but not released then because it was so weak , and it has been unearthed and released now , when it has become even weaker . ","this is nothing but familiar territory . ","in execution , this clever idea is far less funny than the original , killers from space . ","one of the more irritating cartoons you will see this , or any , year . ","a broad , melodramatic estrogen opera that's pretty toxic in its own right . ","too slow , too long and too little happens . ","the film's few ideas are stretched to the point of evaporation ; the whole central section is one big chase that seems to have no goal and no urgency . it's just filler . ","sacrifices the value of its wealth of archival foot-age with its less-than-objective stance . ","utterly lacking in charm , wit and invention , roberto benigni's pinocchio is an astonishingly bad film . ","a hamfisted romantic comedy that makes our girl the hapless facilitator of an extended cheap shot across the mason-dixon line . ","scores no points for originality , wit , or intelligence . it's a cookie-cutter movie , a cut-and-paste job . ","they takes a long time to get to its gasp-inducing ending . ","barely gets off the ground . ","even on those rare occasions when the narrator stops yammering , miller's hand often feels unsure . ","pumpkin means to be an outrageous dark satire on fraternity life , but its ambitions far exceed the abilities of writer adam larson broder and his co-director , tony r . abrams , in their feature debut . ","at its best , queen is campy fun like the vincent price horror classics of the '60s . at its worst , it implodes in a series of very bad special effects . ","from the opening scenes , it's clear that all about the benjamins is a totally formulaic movie . ","it takes a certain kind of horror movie to qualify as 'worse than expected , ' but ghost ship somehow manages to do exactly that . ","on the bright side , it contains jesse ventura's best work since the xfl . ","despite impeccable acting . . . and a script that takes some rather unexpected ( even , at times , preposterous ) turns , love is just too , too precious in the end . ","a tv style murder mystery with a few big screen moments ( including one that seems to be made for a different film altogether ) . ","by getting myself wrapped up in the visuals and eccentricities of many of the characters , i found myself confused when it came time to get to the heart of the movie . ","too often , the viewer isn't reacting to humor so much as they are wincing back in repugnance . ","what's next ? the porky's revenge : ultimate edition ? ","dilbert without the right-on satiric humor . ","manages to show life in all of its banality when the intention is quite the opposite . ","do not see this film . ","minority report is exactly what the title indicates , a report . ","delivers the same old same old , tarted up with latin flava and turned out by hollywood playas . ","if you believe any of this , i can make you a real deal on leftover enron stock that will double in value a week from friday . ","to call the other side of heaven  appalling  would be to underestimate just how dangerous entertainments like it can be . ","in exactly 89 minutes , most of which passed as slowly as if i'd been sitting naked on an igloo , formula 51 sank from quirky to jerky to utter turkey . ","if only the story about a multi-million dollar con bothered to include the con . ","i'd have to say the star and director are the big problems here . ","without the dark spookiness of crystal lake camp , the horror concept completely loses its creepy menace . ","it's like every bad idea that's ever gone into an after-school special compiled in one place , minus those daytime programs' slickness and sophistication ( and who knew they even had any ? ) . ","while the resident evil games may have set new standards for thrills , suspense , and gore for video games , the movie really only succeeds in the third of these . ","for close to two hours the audience is forced to endure three terminally depressed , mostly inarticulate , hyper dysfunctional families for the price of one . ","to my taste , the film's comic characters come perilously close to being amoses and andys for a new generation . ","what the director can&#8217 ; t do is make either of val kilmer&#8217 ; s two personas interesting or worth caring about . ","in an effort , i suspect , not to offend by appearing either too serious or too lighthearted , it offends by just being wishy-washy . ","it's difficult to imagine the process that produced such a script , but here's guessing that spray cheese and underarm noises played a crucial role . ","harland williams is so funny in drag he should consider permanent sex-reassignment . "," . . . nothing scary here except for some awful acting and lame special effects . ","it's not that kung pow isn't funny some of the time -- it just isn't any funnier than bad martial arts movies are all by themselves , without all oedekerk's impish augmentation . ","a very long movie , dull in stretches , with entirely too much focus on meal preparation and igloo construction . ","not an objectionable or dull film ; it merely lacks everything except good intentions . ","a science-fiction pastiche so lacking in originality that if you stripped away its inspirations there would be precious little left . ","once [kim] begins to overplay the shock tactics and bait-and-tackle metaphors , you may decide it's too high a price to pay for a shimmering picture postcard . ","the words , 'frankly , my dear , i don't give a damn , ' have never been more appropriate . ","what's next :  my mother the car ?  ","all the amped-up tony hawk-style stunts and thrashing rap-metal can't disguise the fact that , really , we've been here , done that . ","a sequel that's much too big for its britches . ","so unremittingly awful that labeling it a dog probably constitutes cruelty to canines . ","what was once original has been co-opted so frequently that it now seems pedestrian . ","a perplexing example of promise unfulfilled , despite many charming moments . ","for all the writhing and wailing , tears , rage and opium overdoses , there's no sense of actual passion being washed away in love's dissolution . ","a coarse and stupid gross-out . ","a nightmare date with a half-formed wit done a great disservice by a lack of critical distance and a sad trust in liberal arts college bumper sticker platitudes . ","doesn't offer much besides glib soullessness , raunchy language and a series of brutal set pieces . . . that raise the bar on stylized screen violence . ","there's something with potential here , but the movie decides , like lavinia , to go the conservative route . ","it's one pussy-ass world when even killer-thrillers revolve around group therapy sessions . ","the stripped-down approach does give the film a certain timeless quality , but the measured pace and lack of dramatic inflection can also seem tedious . ","but the power of these [subjects] is obscured by the majority of the film that shows a stationary camera on a subject that could be mistaken for giving a public oration , rather than contributing to a film's narrative . ","rarely has so much money delivered so little entertainment . ","tries to add some spice to its quirky sentiments but the taste is all too familiar . ","paid in full is so stale , in fact , that its most vibrant scene is one that uses clips from brian de palma's scarface . that's a cheat . ","harrison's flowers puts its heart in the right place , but its brains are in no particular place at all . ","this re-do is so dumb and so exploitative in its violence that , ironically , it becomes everything that the rather clumsy original was railing against . ","a string of rehashed sight gags based in insipid vulgarity . ","the movie is dawn of the dead crossed with john carpenter's ghosts of mars , with zombies not as ghoulish as the first and trains not as big as the second . ","basically a static series of semi-improvised ( and semi-coherent ) raps between the stars . ","too restrained to be a freak show , too mercenary and obvious to be cerebral , too dull and pretentious to be engaging . . . the isle defies an easy categorization . ","an unpredictable blend of gal-pal smart talk , romantic comedy and dark tragedy that bites off considerably more than writer/director john mckay can swallow . ","it's one of those baseball pictures where the hero is stoic , the wife is patient , the kids are as cute as all get-out and the odds against success are long enough to intimidate , but short enough to make a dream seem possible . ","  the time machine  is a movie that has no interest in itself . it doesn't believe in itself , it has no sense of humor…it's just plain bored . "," . . . a hollow joke told by a cinematic gymnast having too much fun embellishing the misanthropic tale to actually engage it . ","a morose little soap opera about three vapid , insensitive people who take turns hurting each other . it's a feature-length adaptation of one of those  can this marriage be saved ?  columns from ladies home journal . . . ","the film's essentially over by the meet-cute . ","i'm sure if you're a hartley fan , you might enjoy yourself . . . me , i didn't care for it . ","it's about following your dreams , no matter what your parents think . socrates motions for hemlock . ","the script isn't very good ; not even someone as gifted as hoffman ( the actor ) can make it work . ","walter hill's pulpy , stylized boxing melodrama undisputed nearly overcomes its questionable in-the-ring match-up with solid fight choreography and gritty prison authenticity . ","it has all the excitement of eating oatmeal . ","it's hard to know whether or not to recommend this film because for every thing it does right there's at least one and occasionally two things it gets ever so wrong . ","although there are several truly jolting scares , there's also an abundance of hackneyed dialogue and more silly satanic business than you can shake a severed limb at . ","i'll bet the video game is a lot more fun than the film . ","star trek : nemesis meekly goes where nearly every star trek movie has gone before . wince-inducing dialogue , thrift-shop costumes , prosthetic makeup by silly putty and kmart blue-light-special effects all conspire to test trekkie loyalty . ","like all abstract art , the film does not make this statement in an easily accessible way , and -- unless prewarned -- it would be very possible for a reasonably intelligent person to sit through its tidal wave of imagery and not get this vision at all . ","i don't mind having my heartstrings pulled , but don't treat me like a fool . "," . . . although this idea is  new  the results are tired . ","i'm guessing the director is a magician . after all , he took three minutes of dialogue , 30 seconds of plot and turned them into a 90-minute movie that feels five hours long . ","an unencouraging threefold expansion on the former mtv series , accompanying the stunt-hungry dimwits in a random series of collected gags , pranks , pratfalls , dares , injuries , etc . ","the script is a dim-witted pairing of teen-speak and animal gibberish . ","its well of thorn and vinegar ( and simple humanity ) has long been plundered by similar works featuring the insight and punch this picture so conspicuously lacks . ","for all its impressive craftsmanship , and despite an overbearing series of third-act crescendos , lily chou-chou never really builds up a head of emotional steam . ","don't be fooled by the impressive cast list - eye see you is pure junk . ","not since freddy got fingered has a major release been so painful to sit through . ","the documentary does little , apart from raising the topic , to further stoke the conversation . ","plays like a volatile and overlong w magazine fashion spread . ","a better title , for all concerned , might be swept under the rug . ","this movie seems to have been written using mad-libs . there can be no other explanation . hilariously inept and ridiculous . ","vera's technical prowess ends up selling his film short ; he smoothes over hard truths even as he uncovers them . ","[a] shapeless blob of desperate entertainment . ","feels too formulaic and too familiar to produce the transgressive thrills of early underground work . ","generic thriller junk . teens only . ","given how heavy-handed and portent-heavy it is , this could be the worst thing soderbergh has ever done . ","a by-the-numbers patient/doctor pic that covers all the usual ground","a dumb movie with dumb characters doing dumb things and you have to be really dumb not to see where this is going . ","stealing harvard aspires to comedic grand larceny but stands convicted of nothing more than petty theft of your time . ","pretension , in its own way , is a form of bravery . for this reason and this reason only -- the power of its own steadfast , hoity-toity convictions -- chelsea walls deserves a medal . ","with the exception of some fleetingly amusing improvisations by cedric the entertainer as perry's boss , there isn't a redeeming moment here . ","it's a grab bag of genres that don't add up to a whole lot of sense . ","movie fans , get ready to take off . . . the other direction . ","[director] o'fallon manages to put some lovely pictures up on the big screen , but his skill at telling a story -- he also contributed to the screenplay -- falls short . ","the intent is almost exactly the same [as the full monty] . all that's missing is the spontaneity , originality and delight . ","no one but a convict guilty of some truly heinous crime should have to sit through the master of disguise . ","even the finest chef can't make a hotdog into anything more than a hotdog , and robert de niro can't make this movie anything more than a trashy cop buddy comedy . ","there's too much falseness to the second half , and what began as an intriguing look at youth fizzles into a dull , ridiculous attempt at heart-tugging . ","it's not without its pleasures , but i'll stick with the tune . ","miller is playing so free with emotions , and the fact that children are hostages to fortune , that he makes the audience hostage to his swaggering affectation of seriousness . ","despite the evocative aesthetics evincing the hollow state of modern love life , the film never percolates beyond a monotonous whine . ","more maudlin than sharp . ","this is an egotistical endeavor from the daughter of horror director dario argento ( a producer here ) , but her raw performance and utter fearlessness make it strangely magnetic . ","it's slow -- very , very slow . it's not the ultimate depression-era gangster movie . that's pure pr hype . ","characters still need to function according to some set of believable and comprehensible impulses , no matter how many drugs they do or how much artistic license avary employs . ","comes . . . uncomfortably close to coasting in the treads of the bicycle thief . ","visually rather stunning , but ultimately a handsome-looking bore , the true creativity would have been to hide treasure planet entirely and completely reimagine it . ","stealing harvard is evidence that the farrelly bros . -- peter and bobby -- and their brand of screen comedy are wheezing to an end , along with green's half-hearted movie career . ","there seems to be no clear path as to where the story's going , or how long it's going to take to get there . ","if you're a wwf fan , or you related to the people who watched the robots getting butchered in a . i . , you'll probably like rollerball . ","i don't think i laughed out loud once . and when you're talking about a slapstick comedy , that's a pretty big problem . ","it's so mediocre , despite the dynamic duo on the marquee , that we just can't get no satisfaction . ","slapstick buffoonery can tickle many a preschooler's fancy , but when it costs a family of four about $40 to see a film in theaters , why spend money on a dog like this when you can rent a pedigree instead ? "," . . . turns so unforgivably trite in its last 10 minutes that anyone without a fortified sweet tooth will likely go into sugar shock . ","the notion that bombing buildings is the funniest thing in the world goes entirely unexamined in this startlingly unfunny comedy . ","my reaction in a word : disappointment . his last movie was poetically romantic and full of indelible images , but his latest has nothing going for it . ","it kinda works and qualifies as cool at times , but is just too lame to work or be cool at others . ","sustains its dreamlike glide through a succession of cheesy coincidences and voluptuous cheap effects , not the least of which is rebecca romijn-stamos . ","intriguing documentary which is emotionally diluted by focusing on the story's least interesting subject . ","a non-mystery mystery . ","feels haphazard , as if the writers mistakenly thought they could achieve an air of frantic spontaneity by simply tossing in lots of characters doing silly stuff and stirring the pot . ","what an embarrassment . ","for each chuckle there are at least 10 complete misses , many coming from the amazingly lifelike tara reid , whose acting skills are comparable to a cardboard cutout . ","in its own way , joshua is as blasphemous and nonsensical as a luis buñuel film without the latter's attendant intelligence , poetry , passion , and genius . ","i've always dreamed of attending cannes , but after seeing this film , it's not that big a deal . ","the vintage is pure '87 , with a halfhearted twist on its cautionary message : fatal attraction = don't have an affair with a nutjob ; unfaithful = don't if you're married to one . ","a workshop mentality prevails . ","it cannot be enjoyed , even on the level that one enjoys a bad slasher flick , primarily because it is dull . yes , dull . ","pumpkin wants to have it both ways . ","director uwe boll and the actors provide scant reason to care in this crude '70s throwback . ","[w]hile long on amiable monkeys and worthy environmentalism , jane goodall's wild chimpanzees is short on the thrills the oversize medium demands . ","outer-space buffs might love this film , but others will find its pleasures intermittent . ","this piece of channel 5 grade trash is , quite frankly , an insult to the intelligence of the true genre enthusiast . ","an occasionally funny , but overall limp , fish-out-of-water story . ","a bloated gasbag thesis grotesquely impressed by its own gargantuan aura of self-importance . . . ","it's mighty tedious for the viewer who has to contend with unpleasant characters , hit-and-miss performances and awkwardly staged scenes . ","as a rumor of angels reveals itself to be a sudsy tub of supernatural hokum , not even ms . redgrave's noblest efforts can redeem it from hopeless sentimentality . ","new best friend's playboy-mansion presentation of college life is laugh-out-loud ludicrous . ","an appalling 'ace ventura' rip-off that somehow manages to bring together kevin pollak , former wrestler chyna and dolly parton . if any of them list this 'credit' on their resumes in the future , that'll be much funnier than anything in the film . . . ","the humor is forced and heavy-handed , and occasionally simply unpleasant . ","scorsese at his best makes gangster films that are equally lovely but also relentlessly brutal and brutally intelligent ; perdition , meanwhile , reads more like driving miss daisy than goodfellas . ","while the script starts promisingly , it loses steam towards the middle and never really develops beyond attacking obvious target . ","as the latest bid in the tv-to-movie franchise game , i spy makes its big-screen entry with little of the nervy originality of its groundbreaking small-screen progenitor . ","this isn't even madonna's swept away . this is her blue lagoon . ","the director knows how to apply textural gloss , but his portrait of sex-as-war is strictly sitcom . "," . . . the film suffers from a lack of humor ( something needed to balance out the violence ) . . . ","burns never really harnesses to full effect the energetic cast . ","an overemphatic , would-be wacky , ultimately tedious sex farce . ","has all the depth of a wading pool . ","this is the sort of burly action flick where one coincidence pummels another , narrative necessity is a drunken roundhouse , and whatever passes for logic is a factor of the last plot device left standing . ","the so-inept- it's-surreal dubbing ( featuring the voices of glenn close , regis philbin and breckin meyer ) brings back memories of cheesy old godzilla flicks . "," . . . the movie is just a plain old monster . ","if this disposable tissue has one wild card , it's john turturro , who's simply fab as a spanish butler with a foot fetish . ","one long string of cliches . ","a noble failure . ","fancy a real downer ? [leigh] lays it on so thick this time that it feels like a suicide race . ","professionally speaking , it's tempting to jump ship in january to avoid ridiculous schlock like this shoddy suspense thriller . ","nelson's brutally unsentimental approach . . . sucks the humanity from the film , leaving behind an horrific but weirdly unemotional spectacle . ","weaves a spell over you , with its disturbingly close-up look at damaged psyches and its subtle undercurrents of danger . but its awkward structure keeps breaking the spell . ","at once half-baked and overheated . ","there's a solid woman- finding-herself story somewhere in here , but you'd have to dig pretty deep to uncover it . ","i still can't relate to stuart : he's a mouse , for cryin' out loud , and all he does is milk it with despondent eyes and whine that nobody treats him human enough . ","[serry] wants to blend politics and drama , an admirable ambition . it's too bad that the helping hand he uses to stir his ingredients is also a heavy one . ","by the miserable standards to which the slasher genre has sunk , . . . actually pretty good . of course , by more objective measurements it's still quite bad . ","the only entertainment you'll derive from this choppy and sloppy affair will be from unintentional giggles – several of them . ","sam mendes has become valedictorian at the school for soft landings and easy ways out . ","lástima por schwarzenegger , pero es hora de que deje la estafeta a las nuevas generaciones . ","exactly what it claims to be -- a simple diversion for the kids . ","its story may be a thousand years old , but why did it have to seem like it took another thousand to tell it to us ? ","woefully pretentious . ","the problem with this film is that it lacks focus . i sympathize with the plight of these families , but the movie doesn't do a very good job conveying the issue at hand . ","a momentary escape from the summer heat and the sedentary doldrums that set in at this time of year . "," . . . think of it as american pie on valium . ","dull , lifeless , and amateurishly assembled . ","puportedly  based on true events ,  a convolution of language that suggests it's impossible to claim that it is  based on a true story  with a straight face . "," . . . a plotline that's as lumpy as two-day old porridge . . . the filmmakers' paws , sad to say , were all over this  un-bear-able  project ! "," . . . irritating soul-searching garbage . ","it's a bad thing when a movie has about as much substance as its end credits blooper reel . ","with its dogged hollywood naturalism and the inexorable passage of its characters toward sainthood , windtalkers is nothing but a sticky-sweet soap . ","some of it is clever , but it is never melodic/","a relative letdown . ","better to just call it abc kiarostami . for aids and africa are nothing more than part of the scenery . ","no aspirations to social import inform the movie version . this is a shameless sham , calculated to cash in on the popularity of its stars . ","manages to be somewhat well-acted , not badly art-directed and utterly unengaging no matter how hard it tries to be thrilling , touching or , yikes , uproarious . ","warmed-over hash . ","this rather superficial arthouse middle-brow film knows how to please a crowd , and that's about all it does well . ","it's clear the filmmakers weren't sure where they wanted their story to go , and even more clear that they lack the skills to get us to this undetermined destination . ","as vulgar as it is banal . ","a puzzling experience . ","you wonder why enough wasn't just a music video rather than a full-length movie . ","the film's tone and pacing are off almost from the get-go . ","the talented and clever robert rodriguez perhaps put a little too much heart into his first film and didn't reserve enough for his second . ","more whiny downer than corruscating commentary . ","tambor and clayburgh make an appealing couple — he's understated and sardonic , she's appealingly manic and energetic . both deserve better . ","suffocated by its fussy script and uptight characters , this musty adaptation is all the more annoying since it's been packaged and sold back to us by hollywood . ","coughs and sputters on its own postmodern conceit . ","a wildly inconsistent emotional experience . ","sit through this one , and you won't need a magic watch to stop time ; your dvd player will do it for you . ","a sometimes tedious film . ","teen movies have really hit the skids . ","there are plot holes big enough for shamu the killer whale to swim through . "," . . . plays like somebody spliced random moments of a chris rock routine into what is otherwise a cliche-riddled but self-serious spy thriller . ","nasty , ugly , pointless and depressing , even if you hate clowns . ","what is 100% missing here is a script of even the most elemental literacy , an inkling of genuine wit , and anything resembling acting . ","does paint some memorable images . . . , but makhmalbaf keeps her distance from the characters","it uses the pain and violence of war as background material for color . ","just not campy enough","the movie , directed by mick jackson , leaves no cliche unturned , from the predictable plot to the characters straight out of central casting . ","it's everything you don't go to the movies for . ","like watching a dress rehearsal the week before the show goes up : everything's in place but something's just a little off-kilter . ","the affectionate loopiness that once seemed congenital to demme's perspective has a tough time emerging from between the badly dated cutesy-pie mystery scenario and the newfangled hollywood post-production effects . ","for all its technical virtuosity , the film is so mired in juvenile and near-xenophobic pedagogy that it's enough to make one pine for the day when godard can no longer handle the rigors of filmmaking . ","american chai encourages rueful laughter at stereotypes only an indian-american would recognize . and the lesson , in the end , is nothing new . ","it made me want to wrench my eyes out of my head and toss them at the screen . ","due to some script weaknesses and the casting of the director's brother , the film trails off into inconsequentiality . "," . . . plot holes so large and obvious a marching band might as well be stomping through them in clown clothes , playing a college football fight song on untuned instruments . ","so devoid of any kind of intelligible story that it makes films like xxx and collateral damage seem like thoughtful treatises","combining quick-cut editing and a blaring heavy metal much of the time , beck seems to be under the illusion that he's shooting the latest system of a down video . ","dragonfly has no atmosphere , no tension -- nothing but costner , flailing away . it's a buggy drag . ","works hard to establish rounded characters , but then has nothing fresh or particularly interesting to say about them . ","the action switches between past and present , but the material link is too tenuous to anchor the emotional connections that purport to span a 125-year divide . ","nonsensical , dull  cyber-horror  flick is a grim , hollow exercise in flat scares and bad acting . ","instead of hiding pinocchio from critics , miramax should have hidden it from everyone . ","manages to be both repulsively sadistic and mundane . ","a great ensemble cast can't lift this heartfelt enterprise out of the familiar . ","there ought to be a directing license , so that ed burns can have his revoked . ","the structure the film takes may find matt damon and ben affleck once again looking for residuals as this officially completes a good will hunting trilogy that was never planned . ","whereas last year's exemplary sexy beast seemed to revitalize the british gangster movie , this equally brutal outing merely sustains it . "," . . . a boring parade of talking heads and technical gibberish that will do little to advance the linux cause . ","green might want to hang onto that ski mask , as robbery may be the only way to pay for his next project . ","i can take infantile humor . . . but this is the sort of infantile that makes you wonder about changing the director and writer's diapers . ","there isn't nearly enough fun here , despite the presence of some appealing ingredients . ","the tale of tok ( andy lau ) , a sleek sociopath on the trail of o ( takashi sorimachi ) , the most legendary of asian hitmen , is too scattershot to take hold . ","directed in a paint-by-numbers manner . ","a cheerful enough but imminently forgettable rip-off of [besson's] earlier work . ","a lackluster , unessential sequel to the classic disney adaptation of j . m . barrie's peter pan . ","samira makhmalbaf's new film blackboards is much like the ethos of a stream of consciousness , although , it's unfortunate for the viewer that the thoughts and reflections coming through are torpid and banal"," . . . routine , harmless diversion and little else . ","late marriage's stiffness is unlikely to demonstrate the emotional clout to sweep u . s . viewers off their feet . ","this time mr . burns is trying something in the martin scorsese street-realist mode , but his self-regarding sentimentality trips him up again . ","while there's something intrinsically funny about sir anthony hopkins saying 'get in the car , bitch , ' this jerry bruckheimer production has little else to offer","it's hampered by a lifetime-channel kind of plot and a lead actress who is out of her depth . ","let's hope -- shall we ? -- that the 'true story' by which all the queen's men is allegedly  inspired  was a lot funnier and more deftly enacted than what's been cobbled together onscreen . ","is there a group of more self-absorbed women than the mother and daughters featured in this film ? i don't think so . nothing wrong with performances here , but the whiney characters bugged me . ","there is very little dread or apprehension , and though i like the creepy ideas , they are not executed with anything more than perfunctory skill . ","if you've ever entertained the notion of doing what the title of this film implies , what sex with strangers actually shows may put you off the idea forever . ","in the end , the movie collapses on its shaky foundation despite the best efforts of director joe carnahan . ","adults will wish the movie were less simplistic , obvious , clumsily plotted and shallowly characterized . but what are adults doing in the theater at all ? ","sticky sweet sentimentality , clumsy plotting and a rosily myopic view of life in the wwii-era mississippi delta undermine this adaptation . ","it's another stale , kill-by-numbers flick , complete with blade-thin characters and terrible , pun-laden dialogue . ","every time you look , sweet home alabama is taking another bummer of a wrong turn . ","partway through watching this saccharine , easter-egg-colored concoction , you realize that it is made up of three episodes of a rejected tv show . ","the overall effect is less like a children's movie than a recruitment film for future hollywood sellouts . ","portentous and pretentious , the weight of water is appropriately titled , given the heavy-handedness of it drama . ","a fitfully amusing romp that , if nothing else , will appeal to fans of malcolm in the middle and its pubescent star , frankie muniz . ","jason x is positively anti-darwinian : nine sequels and 400 years later , the teens are none the wiser and jason still kills on auto-pilot . ","to say this was done better in wilder's some like it hot is like saying the sun rises in the east . ","at the very least , if you don't know anything about derrida when you walk into the theater , you won't know much more when you leave . ","the actors are appealing , but elysian fields is idiotic and absurdly sentimental . ","as 'chick flicks' go , this one is pretty miserable , resorting to string-pulling rather than legitimate character development and intelligent plotting . ","the only excitement comes when the credits finally roll and you get to leave the theater . ","there's no emotional pulse to solaris . with an emotional sterility to match its outer space setting , soderbergh's spectacular swing for the fence yields only a spectacular whiff . ","it can't decide if it wants to be a mystery/thriller , a romance or a comedy . ","denis o'neill's script avoids the prime sports cliche , a last-second goal to win the championship , but it neglects few others . ","the character of zigzag is not sufficiently developed to support a film constructed around him . ","one of those pictures whose promising , if rather precious , premise is undercut by amateurish execution . ","serving sara doesn't serve up a whole lot of laughs . ","the most hopelessly monotonous film of the year , noteworthy only for the gimmick of being filmed as a single unbroken 87-minute take . ","with virtually no interesting elements for an audience to focus on , chelsea walls is a triple-espresso endurance challenge . ","stale , futile scenario . ","deadeningly dull , mired in convoluted melodrama , nonsensical jargon and stiff-upper-lip laboriousness . ","a misogynistic piece of filth that attempts to pass itself off as hip , young adult entertainment . ","like the chelsea's denizens . . . burdette's collage-form scenario tends to over-romanticize the spiritual desolation of the struggling artiste . ","it's basically an overlong episode of tales from the crypt . ","the film makes a fatal mistake : it asks us to care about a young man whose only apparent virtue is that he is not quite as unpleasant as some of the people in his life . ","another in-your-face wallow in the lower depths made by people who have never sung those blues . ","shaky close-ups of turkey-on-rolls , stubbly chins , liver spots , red noses and the filmmakers new bobbed do draw easy chuckles but lead nowhere . ","i can't quite recommend it -- it's too patched together -- but i almost can ; it's the kind of movie that makes you want to like it . ","complete lack of originality , cleverness or even visible effort","though perry and hurley make inspiring efforts to breathe life into the disjointed , haphazard script by jay scherick and david ronn , neither the actors nor director reginald hudlin can make it more than fitfully entertaining . ","something akin to a japanese alice through the looking glass , except that it seems to take itself far more seriously . ","it takes talent to make a lifeless movie about the most heinous man who ever lived . ","on the whole , the movie lacks wit , feeling and believability to compensate for its incessant coarseness and banality . ","the story and the friendship proceeds in such a way that you're watching a soap opera rather than a chronicle of the ups and downs that accompany lifelong friendships . ","offers very little genuine romance and even fewer laughs . . . a sad sitcom of a movie , largely devoid of charm . ","makes for a pretty unpleasant viewing experience . ","the movie fails to live up to the sum of its parts . ","although huppert's intensity and focus has a raw exhilaration about it , the piano teacher is anything but fun . ","it showcases carvey's talent for voices , but not nearly enough and not without taxing every drop of one's patience to get to the good stuff . ","bad . very bad . stultifyingly , dumbfoundingly , mind-numbingly bad . ","may reawaken discussion of the kennedy assassination but this fictional film looks made for cable rather than for the big screen . ","if looking for a thrilling sci-fi cinematic ride , don't settle for this imposter . ","not really bad so much as distasteful : we need kidnapping suspense dramas right now like we need doomsday thrillers . ","the result is a gaudy bag of stale candy , something from a halloween that died . ","davis . . . is so enamored of her own creation that she can't see how insufferable the character is . ","the man from elysian fields is a cold , bliss-less work that groans along thinking itself some important comment on how life throws us some beguiling curves . ","the messages of compassion and mercy are clearly , squarely and specifically expounded via computer animated old testament tale of jonah and the whale . determined to be fun , and bouncy , with energetic musicals , the humor didn't quite engage this adult . ","historical dramas fused with love triangle is a well worn conceit . but this films lacks the passion required to sell the material . ","long time dead ? not nearly long enough . ","nothing more substantial than a fitfully clever doodle . ","a solid film . . . but more conscientious than it is truly stirring . ","there's not enough here to justify the almost two hours . ","the x potion gives the quickly named blossom , bubbles and buttercup supernatural powers that include extraordinary strength and laser-beam eyes , which unfortunately don't enable them to discern flimsy screenplays . ","perceptive in its vision of nascent industrialized world politics as a new art form , but far too clunky , didactic and saddled with scenes that seem simply an ill fit for this movie . ","verbinski implements every hack-artist trick to give us the ooky-spookies . ","mcconaughey's fun to watch , the dragons are okay , not much fire in the script . ","an unwise amalgam of broadcast news and vibes . ","skins has a right to yawp , and we have a right to our grains of salt . ","who needs love like this ? ","hit and miss as far as the comedy goes and a big ole' miss in the way of story . ","returning aggressively to his formula of dimwitted comedy and even dimmer characters , sandler , who also executive produces , has made a film that makes previous vehicles look smart and sassy . ","exists then as an occasionally insightful acting exercise . ","trite , banal , cliched , mostly inoffensive . ","mattei is tiresomely grave and long-winded , as if circularity itself indicated profundity . ","it's not original , and , robbed of the element of surprise , it doesn't have any huge laughs in its story of irresponsible cops who love to play pranks . ","whenever its story isn't bogged down by idiocy involving the cia and a lost u . s . satellite , hunter -- starring irwin and his american wife/colleague , terri -- is a movie children should enjoy . ","it offers little beyond the momentary joys of pretty and weightless intellectual entertainment . ","a sequence of ridiculous shoot-'em-up scenes . ","nothing in waking up in reno ever inspired me to think of its inhabitants as anything more than markers in a screenplay . ","i'm just too bored to care . ","irwin is a man with enough charisma and audacity to carry a dozen films , but this particular result is ultimately held back from being something greater . ","not a stereotype is omitted nor a cliché left unsaid . ","as befits its title , this pg-13-rated piffle is ultimately as threatening as the snuggle fabric softener bear . ","attempts by this ensemble film to impart a message are so heavy-handed that they instead pummel the audience . ","it all feels like a monty python sketch gone horribly wrong . ","nervous breakdowns are not entertaining . ","scorsese doesn't give us a character worth giving a damn about . ","a beautifully made piece of unwatchable drivel . ","like being trapped at a perpetual frat party . . . how can something so gross be so boring ? ","this is so bad . ","even film silliness needs a little gravity , beyond good hair and humping . ","i felt sad for lise not so much because of what happens as because she was captured by this movie when she obviously belongs in something lighter and sunnier , by rohmer , for example . ","prurient playthings aside , there's little to love about this english trifle . ","this is a train wreck of an action film -- a stupefying attempt by the filmmakers to force-feed james bond into the mindless xxx mold and throw 40 years of cinematic history down the toilet in favor of bright flashes and loud bangs . ","the film flat lines when it should peak and is more missed opportunity and trifle than dark , decadent truffle . ","it's played in the most straight-faced fashion , with little humor to lighten things up . the heavy-handed film is almost laughable as a consequence . ","van wilder brings a whole new meaning to the phrase 'comedy gag . ' at least one scene is so disgusting that viewers may be hard pressed to retain their lunch . ","a disappointment for those who love alternate versions of the bard , particularly ones that involve deep fryers and hamburgers . ","the film tries too hard to be funny and tries too hard to be hip . the end result is a film that's neither . ","every nanosecond of the the new guy reminds you that you could be doing something else far more pleasurable . something like scrubbing the toilet . or emptying rat traps . or doing last year's taxes with your ex-wife . ","scooby dooby doo / and shaggy too / you both look and sound great . / but daphne , you're too buff / fred thinks he's tough / and velma - wow , you've lost weight ! ","is the time really ripe for a warmed-over james bond adventure , with a village idiot as the 007 clone ? ","there's enough melodrama in this magnolia primavera to make pta proud yet director muccino's characters are less worthy of puccini than they are of daytime television . ","however it may please those who love movies that blare with pop songs , young science fiction fans will stomp away in disgust . ","the humor isn't as sharp , the effects not as innovative , nor the story as imaginative as in the original . but it could have been worse . ","some of their jokes work , but most fail miserably and in the end , pumpkin is far more offensive than it is funny . ","even horror fans will most likely not find what they're seeking with trouble every day ; the movie lacks both thrills and humor . ","comes off like a rejected abc afterschool special , freshened up by the dunce of a screenwriting 101 class . . . . designed to provide a mix of smiles and tears ,  crossroads  instead provokes a handful of unintentional howlers and numerous yawns . ","it seems to me the film is about the art of ripping people off without ever letting them consciously know you have done so","it's just disappointingly superficial -- a movie that has all the elements necessary to be a fascinating , involving character study , but never does more than scratch the surface . ","the title not only describes its main characters , but the lazy people behind the camera as well . ","sometimes it feels as if it might have been made in the '70s or '80s , and starred chevy chase and goldie hawn . ","schaeffer has to find some hook on which to hang his persistently useless movies , and it might as well be the resuscitation of the middle-aged character . ","demands too much of most viewers . ","the story drifts so inexorably into cliches about tortured ( and torturing ) artists and consuming but impossible love that you can't help but become more disappointed as each overwrought new sequence plods on . ","it should be mentioned that the set design and interiors of the haunted vessel are more than effectively creepy and moodily lit . so i just did . ","shamelessly sappy and , worse , runs away from its own provocative theme . ","aggravating and tedious . ","the ring just left me cold and wet like i was out in the seattle drizzle without rainwear . ","the film seems a dead weight . the lack of pace kills it , although , in a movie about cancer , this might be apt . ","for anyone who grew up on disney's 1950 treasure island , or remembers the 1934 victor fleming classic , this one feels like an impostor . ","a clutchy , indulgent and pretentious travelogue and diatribe against . . . well , just stuff . watching scarlet diva , one is poised for titillation , raw insight or both . instead , we just get messy anger , a movie as personal therapy . ","meandering , sub-aquatic mess : it's so bad it's good , but only if you slide in on a freebie . ","the ending is a cop-out . what happens to john q ? i don't have an i am sam clue . ","has the feel of an unedited personal journal . ","remember when bond had more glamour than clamor ? no more . ","cry havoc and let slip the dogs of cheese , indeed . ","this charmless nonsense ensues amid clanging film references that make jay and silent bob's excellent adventure seem understated . ","it doesn't quite deserve the gong , but there are more fascinating acts than  confessions of a dangerous mind .  ","the subject of swinging still seems ripe for a documentary -- just not this one . "," . . . hudlin is stuck trying to light a fire with soggy leaves . ","unlike his directorial efforts , la femme nikita and the professional , the transporter lacks besson's perspective as a storyteller . ","the overall effect is so completely inane that one would have to be mighty bored to even think of staying with this for more than , say , ten . . . make that three minutes . ","lacks depth . ","most of the supporting characters in eastwood films are weak , as are most of the subplots . this one's weaker than most . ","there's no real reason to see it , and no real reason not to . ","audiences will find no mention of political prisoners or persecutions that might paint the castro regime in less than saintly tones . ","under-rehearsed and lifeless","the film takes too long getting to the good stuff , then takes too long figuring out what to do next . ","you can practically smell the patchouli oil . ","to say analyze that is de niro's best film since meet the parents sums up the sad state of his recent career . ","the actors don't inhabit their roles -- they're trapped by them , forced to change behavior in bizarre unjustified fashion and spout dialog that consists mostly of platitudes . ","an often-deadly boring , strange reading of a classic whose witty dialogue is treated with a baffling casual approach","this film was made to get laughs from the slowest person in the audience -- just pure slapstick with lots of inane , inoffensive screaming and exaggerated facial expressions . ","consists of a plot and jokes done too often by people far more talented than ali g","another week , another gross-out college comedy--ugh . ","laughably , irredeemably awful . ","moderately involving despite bargain-basement photography and hackneyed romance . ","there is no insight into the anguish of heidi's life -- only a depiction of pain , today's version of greek tragedy , the talk-show guest decrying her fate . ","the editing is chaotic , the photography grainy and badly focused , the writing unintentionally hilarious , the direction unfocused , the performances as wooden . ","when [de palma's] bad , he's really bad , and femme fatale ranks with the worst he has done . ","tadpole is emblematic of the witless ageism afflicting films : young is cool , and too young is too cool . ","i doubt anyone will remember the picture by the time christmas really rolls around , but maybe it'll be on video by then . ","uncertain in tone . . . a garbled exercise in sexual politics , a junior varsity short cuts by way of very bad things . ","all's well that ends well , and rest assured , the consciousness-raising lessons are cloaked in gross-out gags . ","the only thing worse than your substandard , run-of-the-mill hollywood picture is an angst-ridden attempt to be profound . ","if you think that jennifer lopez has shown poor judgment in planning to marry ben affleck , wait till you see maid in manhattan . ","stars matthew perry and elizabeth hurley illicit more than a chuckle , and more jokes land than crash , but ultimately serving sara doesn't distinguish itself from the herd . ","it's best to avoid imprisonment with the dull , nerdy folks that inhabit cherish . ","culkin exudes none of the charm or charisma that might keep a more general audience even vaguely interested in his bratty character . ","in the end , ted bundy's only justification is the director's common but unexplored fascination with the frustrated maniac ; there's no larger point , and little social context . "," . . . ( like ) channel surfing between the discovery channel and a late-night made-for-cable action movie . ","a movie that , rather than skip along the seine , more or less slogs its way through soggy paris , tongue uncomfortably in cheek . ","shot perhaps 'artistically' with handheld cameras and apparently no movie lights by joaquin baca-asay , the low-budget production swings annoyingly between vertigo and opacity . ","imagine a really bad community theater production of west side story without the songs . ","soul is what's lacking in every character in this movie and , subsequently , the movie itself . ","a one-trick pony whose few t&a bits still can't save itself from being unoriginal , unfunny and unrecommendable . ","the worst kind of independent ; the one where actors play dress down hicks and ponderously mope around trying to strike lightning as captured by their 1970s predecessors","it may be a prize winner , but teacher is a bomb . ","the production values are up there . the use of cgi and digital ink-and-paint make the thing look really slick . the voices are fine as well . the problem , it is with most of these things , is the script . ","it's got its heart in the right place , but it also wilts after awhile . ","proves that a movie about goodness is not the same thing as a good movie . ","well , it does go on forever . ","this overproduced and generally disappointing effort isn't likely to rouse the rush hour crowd . ","topkapi this is not . ","if shayamalan wanted to tell a story about a man who loses his faith , why didn't he just do it , instead of using bad sci-fi as window dressing ? ","ethan hawke has always fancied himself the bastard child of the beatnik generation and it's all over his chelsea walls . ","equal parts bodice-ripper and plodding costume drama . ","i'm not suggesting that you actually see it , unless you're the kind of person who has seen every wim wenders film of the '70s . ","while the film misfires at every level , the biggest downside is the paucity of laughter in what's supposed to be a comedy . ","if you liked the 1982 film then , you'll still like it now . ","a 93-minute condensation of a 26-episode tv series , with all of the pitfalls of such you'd expect . ","guillen rarely gets beneath the surface of things . she lists ingredients , but never mixes and stirs . ","audiences can be expected to suspend their disbelief only so far -- and that does not include the 5 o'clock shadow on the tall wooden kid as he skips off to school . ","to imagine the life of harry potter as a martial arts adventure told by a lobotomized woody allen is to have some idea of the fate that lies in store for moviegoers lured to the mediocrity that is kung pow : enter the fist . ","it delivers some chills and sustained unease , but flounders in its quest for deeper meaning . ","credibility levels are low and character development a non-starter . ","i would have preferred a transfer down the hall to mr . holland's class for the music , or to robin williams's lecture so i could listen to a teacher with humor , passion , and verve . ","for the most part , the ingredients are there . but an unwillingness to explore beyond the surfaces of her characters prevents nettelbeck's film from coming together . ","an earnest , heartrending look at the divide between religious fundamentalists and their gay relatives . it's also heavy-handed and devotes too much time to bigoted views . ","a mawkish , implausible platonic romance that makes chaplin's city lights seem dispassionate by comparison . ","yes , one enjoys seeing joan grow from awkward young woman to strong , determined monarch , but her love for the philandering philip only diminishes her stature . ","it's a film that hinges on its casting , and glover really doesn't fit the part . ","this is a throwaway , junk-food movie whose rap soundtrack was better tended to than the film itself . "," . . . with the candy-like taste of it fading faster than 25-cent bubble gum , i realized this is a throwaway movie that won't stand the test of time . it's a trifle . ","literally nothing in the pool is new , but if you grew up on the stalker flicks of the 1980's this one should appease you for 90 minutes . ","arguably the year's silliest and most incoherent movie . ","anyway , for one reason or another , crush turns into a dire drama partway through . after that , it just gets stupid and maudlin . too bad , but thanks to some lovely comedic moments and several fine performances , it's not a total loss . ","chao was chen kaige's assistant for years in china . he has not learnt that storytelling is what the movies are about . ","a mixed bag of a comedy that can't really be described as out of this world . ","unwieldy contraption . ","the film is a travesty of the genre and even as spoof takes itself too seriously . ","marries the amateurishness of the blair witch project with the illogic of series 7 : the contenders to create a completely crass and forgettable movie . ","the piano teacher is the sort of movie that discourages american audiences from ever wanting to see another foreign film . ","if it's another regurgitated action movie you're after , there's no better film than half past dead . ","so what is the point ? lovingly choreographed bloodshed taking place in a pristine movie neverland , basically . ","this is junk food cinema at its greasiest . ","when it's all wet , blue crush is highly enjoyable . when it's on dry land , though , this surfer-girl melodrama starts gasping like a beached grouper . ","most new movies have a bright sheen . some , like ballistic , arrive stillborn . . . looking like the beaten , well-worn video box cover of seven years into the future . ","the story is naturally poignant , but first-time screenwriter paul pender overloads it with sugary bits of business . ","you see robert de niro singing - and dancing to - west side story show tunes . choose your reaction : a . ) that sure is funny ! b . ) that sure is pathetic ! ","a sermonizing and lifeless paean to teenage dullards . ","this dramatically shaky contest of wills only reiterates the old hollywood saw : evil is interesting and good is boring . ","before long , the film starts playing like general hospital crossed with a saturday night live spoof of dog day afternoon . ","the charms of willful eccentricity , at least as evidenced by this latest cinematic essay , are beginning to wear a bit thin . ","instead of accurately accounting a terrible true story , the film's more determined to become the next texas chainsaw massacre . but what about the countless other people who'd merely like to watch a solid tale about a universally interesting soul ? ","a silly , self-indulgent film about a silly , self-indulgent filmmaker . ","scarlet diva has a voyeuristic tug , but all in all it's a lot less sensational than it wants to be . ","the character is too forced and overwritten to be funny or believable much of the time , and clayburgh doesn't always improve the over-the-top mix . ","flashy , pretentious and as impenetrable as morvern's thick , working-class scottish accent . ","a battle between bug-eye theatre and dead-eye matinee . ","the movie is virtually without context -- journalistic or historical . what's worse is that pelosi knows it . "," . . . instead go rent  shakes the clown  , a much funnier film with a similar theme and an equally great robin williams performance . ","lame , haphazard teen comedy . ","it's the kind of movie that ends up festooning u . s . art house screens for no reason other than the fact that it's in french ( well , mostly ) with english subtitles and is magically 'significant' because of that . ","this miserable excuse of a movie runs on empty , believing flatbush machismo will get it through . ","expect to be reminded of other , better films , especially seven , which director william malone slavishly copies . ","nair stuffs the film with dancing , henna , ornamentation , and group song , but her narrative clichés and telegraphed episodes smell of old soap opera . ","it's getting harder and harder to ignore the fact that hollywood isn't laughing with us , folks . it's laughing at us . ","might have been better off as a documentary , with less of mr . eyre's uninspired dramatics and more of his sense of observation and outrage . ","every good actor needs to do his or her own hamlet . for benigni it wasn't shakespeare whom he wanted to define his career with but pinocchio . it might as well have been problem child iv . ","arnold's jump from little screen to big will leave frowns on more than a few faces . ","both awful and appealing . ","the lack of opposing viewpoints soon grows tiresome -- the film feels more like a series of toasts at a testimonial dinner than a documentary . ","nothing plot-wise is worth e-mailing home about . ","we are left with a superficial snapshot that , however engaging , is insufficiently enlightening and inviting . ","helmer devito . . . attempts to do too many things in this story about ethics , payola , vice , murder , kids' tv and revenge . ","it wouldn't be my preferred way of spending 100 minutes or $7 . 00 . ","i hated every minute of it . ","[t]hose same extremes prevent us from taking its message seriously , and the stepford wives mentality doesn't work in a modern context . ","obvious politics and rudimentary animation reduce the chances that the appeal of hey arnold ! the movie will reach far beyond its core demographic . ","there's no mistaking the fact that this hybrid misses the impact of the disney classic , and even that of the excellent 1934 mgm version . ","a simple , sometimes maddeningly slow film that has just enough charm and good acting to make it interesting , but is ultimately pulled under by the pacing and lack of creativity within . ","roger michell , who did an appealing job directing persuasion and notting hill in england , gets too artsy in his american debut . ","there is an almost poignant dimension to the way that every major stunt seagal's character . . . performs is shot from behind , as if it could fool us into thinking that we're not watching a double . ","anthony hopkins ? big deal ! we've already seen the prequel to the silence of the lambs and hannibal -- and it was better the first time . ","ostensibly celebrates middle-aged girl power , even as it presents friendship between women as pathetic , dysfunctional and destructive . ","if this is an example of the type of project that robert redford's lab is willing to lend its imprimatur to , then perhaps it's time to rethink independent films . ","pumpkin sits in a patch somewhere between mirthless todd solondzian satire and callow student film . ","not so much funny as aggressively sitcom-cute , it's full of throwaway one-liners , not-quite jokes , and a determined tv amiability that allen personifies . ","it's not that waiting for happiness is a bad film , because it isn't . it's just incredibly dull . ","the sad thing about knockaround guys is its lame aspiration for grasping the coolness vibes when in fact the film isn't as flippant or slick as it thinks it is . ","a cumbersome and cliche-ridden movie greased with every emotional device known to man . ","director ferzan ozpetek creates an interesting dynamic with the members of this group , who live in the same apartment building . but he loses his focus when he concentrates on any single person . ","egoyan's movie is too complicated to sustain involvement , and , if you'll excuse a little critical heresy , too intellectually ambitious . ","it wants to be thought of as a subversive little indie film , but it has all the qualities of a modern situation comedy . ","despite apparent motives to the contrary , it ends up being , like [seinfeld's] revered tv show , about pretty much nothing . ","shadyac shoots his film like an m . night shyamalan movie , and he frequently maintains the same snail's pace ; he just forgot to add any genuine tension . ","plays less like a coming-of-age romance than an infomercial . ","there are a few laughs and clever sight gags scattered about , but not enough to make this anything more than another big-budget bust . ","the story's so preposterous that i didn't believe it for a second , despite the best efforts of everyone involved . ","i've heard that the fans of the first men in black have come away hating the second one . i wonder why . they felt like the same movie to me . ","despite her relentless vim and winsome facial symmetry , witherspoon is just too dialed-up to be america's sweetheart . ","an ultra-low-budget indie debut that smacks more of good intentions than talent . ","birot is a competent enough filmmaker , but her story has nothing fresh or very exciting about it . ","de niro and mcdormand give solid performances , but their screen time is sabotaged by the story's inability to create interest . ","even those of a single digit age will be able to recognize that this story is too goofy . . . even for disney . ","that is essentially what's missing from blackboards -- the sense of something bigger , some ultimate point . ","a compendium of solondz's own worst instincts in under 90 minutes . ","if the title is a jeopardy question , then the answer might be  how does steven seagal come across these days ?  or maybe  how will you feel after an 88-minute rip-off of the rock with action confined to slo-mo gun firing and random glass-shattering ? ","it is a comedy that's not very funny and an action movie that is not very thrilling ( and an uneasy alliance , at that ) . ","the story is familiar from its many predecessors ; like them , it eventually culminates in the not-exactly -stunning insight that crime doesn't pay . ","you'll have more fun setting fire to yourself in the parking lot . you'll be more entertained getting hit by a bus . ","dissing a bond movie is quite like calling a dog stupid , but when it has the temerity to run over two hours , you feel like winding up with a kick . ","ritchie's treatment of the class reversal is majorly ham-fisted , from the repetitive manifestos that keep getting thrown in people's faces to the fact amber is such a joke . ","flat , but with a revelatory performance by michelle williams . ","little more than a frothy vanity project . ","the film goes from being an unusual sci-fi character study to a chase flick that detracts from its ending . ","verbinski substitutes atmosphere for action , tedium for thrills . ","for all its surface frenzy , high crimes should be charged with loitering -- so much on view , so little to offer . ","the sum of all fears is almost impossible to follow -- and there's something cringe-inducing about seeing an american football stadium nuked as pop entertainment . ","alex nohe's documentary plays like a travelogue for what mostly resembles a real-life , big-budget nc-17 version of tank girl . ","the title trapped turns out to be a pretty fair description of how you feel while you're watching this ultra-manipulative thriller . ","the appeal of the vulgar , sexist , racist humour went over my head or -- considering just how low brow it is -- perhaps it snuck under my feet . ","the story really has no place to go since simone is not real—she can't provide any conflict . ","ihops don't pile on this much syrup . ","for the most part , i spy was an amusing lark that will probably rank as one of murphy's better performances in one of his lesser-praised movies . ","focuses on joan's raging hormones and sledgehammers the audience with spanish inquisitions about her  madness  so much that i became mad that i wasted 123 minutes and $9 . 50 on this 21st century torture device . ","this series should have died long ago , but they keep bringing it back another day as punishment for paying money to see the last james bond movie . ","a bit of an unwieldy mess . ","with a story as bizarre and mysterious as this , you don't want to be worrying about whether the ineffectual broomfield is going to have the courage to knock on that door . ","the filmmakers juggle and juxtapose three story lines but fail to come up with one cogent point , unless it's that life stinks , especially for sensitive married women who really love other women . ","the movie feels like it's going to be great , and it carries on feeling that way for a long time , but takeoff just never happens . ","a gimmick in search of a movie : how to get carvey into as many silly costumes and deliver as many silly voices as possible , plot mechanics be damned . "," . . . the last time i saw a theater full of people constantly checking their watches was during my sats . "," . . . fifty minutes of tedious adolescent melodramatics followed by thirty-five minutes of inflated nonsense . "," . . . lacks the punch and verve needed to make this genre soar . ","it's often faintly amusing , but the problems of the characters never become important to us , and the story never takes hold . ","it's tough , astringent , darkly funny and . . . well , it's also generic , untidy , condescending and mild of impact rather than stunning . ","largely a for-fans artifact . ","there's no denying the elaborateness of the artist's conceptions , nor his ability to depict them with outrageous elan , but really the whole series is so much pretentious nonsense , lavishly praised by those who equate obscurity with profundity . ","characters wander into predictably treacherous situations even though they should know better . ","there's plenty of style in guillermo del toro's sequel to the 1998 hit but why do we need 117 minutes to tell a tale that simply can't sustain more than 90 minutes . ","[i]f you've been to more than one indie flick in your life , chances are you've already seen this kind of thing . ","first-time director joão pedro rodrigues' unwillingness to define his hero's background or motivations becomes more and more frustrating as the film goes on . ","no reason for anyone to invest their hard-earned bucks into a movie which obviously didn't invest much into itself either . ","a strong first quarter , slightly less so second quarter , and average second half . ","a boring , wincingly cute and nauseatingly politically correct cartoon guaranteed to drive anyone much over age 4 screaming from the theater . ","the vampire thriller blade ii starts off as a wild hoot and then sucks the blood out of its fun – toward the end , you can feel your veins cringing from the workout . ","when the first few villians are introduced as  spider  and  snake  you know you're in for a real winner , creativity at its peak . ","an afterschool special without the courage of its convictions . ","the final result makes for adequate entertainment , i suppose , but anyone who has seen chicago on stage will leave the theater feeling they've watched nothing but a pale imitation of the real deal . ","[director] byler may yet have a great movie in him , but charlotte sometimes is only half of one . ","so few movies explore religion that it's disappointing to see one reduce it to an idea that fits in a sampler . ","it's also clear from the start that the transporter is running purely on adrenaline , and once the initial high wears off , the film's shortcomings start to shine through . ","watching it is rather like viewing a long soap opera in which only the first episode was any good . ","it's fun , but a psychological mess , with austin powers bumping his head on the way out of the closet . ","there are touching moments in etoiles , but for the most part this is a dull , dour documentary on what ought to be a joyful or at least fascinating subject . ","overwrought , melodramatic bodice-ripper . ","could the whole plan here have been to produce something that makes fatal attraction look like a classic by comparison ? that's the only sane rationale i can think of for swimfan's existence . ","i didn't laugh at the ongoing efforts of cube , and his skinny buddy mike epps , to make like laurel and hardy 'n the hood . ","the only way this supernatural snore-fest could give anyone a case of the frights is if they were put to sleep by the movie and had a nightmare . ","i wonder what the reaction of israelis will be to this supposedly evenhanded presentation . ","the film would work much better as a video installation in a museum , where viewers would be free to leave . immediately . ","human nature initially succeeds by allowing itself to go crazy , but ultimately fails by spinning out of control . ","[it's] a prison soccer movie starring charismatic tough guy vinnie jones , but it had too much spitting for me to enjoy . ","not even the hanson brothers can save it","the thriller side of this movie is falling flat , as the stalker doesn't do much stalking , and no cop or lawyer grasps the concept of actually investigating the case . "," . . . [a] strained comedy that jettisons all opportunities for rock to make his mark by serving up the usual chaotic nonsense . ","a sour , nasty offering . ","feels like one of those contrived , only-in -hollywood productions where name actors deliver big performances created for the sole purpose of generating oscar talk . ","obstacles are too easily overcome and there isn't much in the way of character development in the script . ","it tells more than it shows . ","earnest falls short of its ideal predecessor largely due to parker's ill-advised meddling with the timeless source material . ","the film might have been more satisfying if it had , in fact , been fleshed out a little more instead of going for easy smiles . ","pretentious editing ruins a potentially terrific flick . ","not every animated film from disney will become a classic , but forgive me if i've come to expect more from this studio than some 79-minute after-school  cartoon  . ","do not , under any circumstances , consider taking a child younger than middle school age to this wallow in crude humor . ","nothing debases a concept comedy quite like the grinding of bad ideas , and showtime is crammed full of them . ","much-anticipated and ultimately lackluster movie . ","this is really just another genre picture . ","each story on its own could have been expanded and worked into a compelling single feature , but in its current incarnation , storytelling never quite gets over its rather lopsided conception . ","william shatner , as a pompous professor , is the sole bright spot . . . ","a trite psychological thriller designed to keep the audience guessing and guessing -- which is not to be confused with suspecting -- until it comes time to wrap things up and send the viewers home . ","neither funny nor suspenseful nor particularly well-drawn . ","'carente de imaginación , mal dirigida , peor actuada y sin un ápice de romance , es una verdadera pérdida de tiempo y dinero'","acting , particularly by tambor , almost makes  never again  worthwhile , but [writer/director] schaeffer should follow his titular advice","both stars manage to be funny , but , like the recent i spy , the star chemistry begs the question of whether random gags add up to a movie . ","  collateral damage  goes by the numbers and reps decent action entertainment – until the silly showdown ending that forces the viewer to totally suspend disbelief","'enigma' is a good name for a movie this delibrately obtuse and unapproachable . a waste of good performances . ","a dreary , incoherent , self-indulgent mess of a movie in which a bunch of pompous windbags drone on inanely for two hours . . . a cacophony of pretentious , meaningless prattle . ","i kept thinking over and over again , 'i should be enjoying this . ' but i wasn't . ","as conceived by mr . schaeffer , christopher and grace are little more than collections of quirky traits lifted from a screenwriter's outline and thrown at actors charged with the impossible task of making them jell . ","like so many other allegedly scary movies , it gets so tangled up in the twist that it chokes the energy right out of the very audience it seeks to frighten . ","the essential problem in orange county is that , having created an unusually vivid set of characters worthy of its strong cast , the film flounders when it comes to giving them something to do . ","just like hearst's enormous yacht , it's slow and unwieldy and takes a long time to reach its destination . ","there is not a character in the movie with a shred of plausibility , not an event that is believable , not a confrontation that is not staged , not a moment that is not false . ","where last time jokes flowed out of cho's life story , which provided an engrossing dramatic through line , here the comedian hides behind obviously constructed routines . ","why come up with something even quasi-original , when you can pillage from shirley jackson , richard matheson . . . and puke up something like rose red ? ","a broadly played , lowbrow comedy in which the cast delivers mildly amusing performances and no farm animals were injured by any of the gags . "," . . . too gory to be a comedy and too silly to be an effective horror film . ","lacks heart , depth and , most of all , purpose . ","though a bit of a patchwork in script and production , a glossy , rich green , environment almost makes the picture work . ","perfectly enjoyable , instantly forgettable , nothing to write home about . ","wasabi is slight fare indeed , with the entire project having the feel of something tossed off quickly ( like one of hubert's punches ) , but it should go down smoothly enough with popcorn . ","somehow both wildly implausible and strangely conventional . ","this ill-fitting tuxedo is strictly off-the-rack . ","is  ballistic  worth the price of admission ? absolutely not . it sucked . would i see it again ? please see previous answer . ","the premise is in extremely bad taste , and the film's supposed insights are so poorly thought-out and substance-free that even a high school senior taking his or her first psychology class could dismiss them . ","sets up a nice concept for its fiftysomething leading ladies , but fails loudly in execution . ","kidman is really the only thing that's worth watching in birthday girl , a film by the stage-trained jez butterworth ( mojo ) that serves as yet another example of the sad decline of british comedies in the post-full monty world . ","imagine the james woods character from videodrome making a home movie of audrey rose and showing it to the kid from the sixth sense and you've imagined the ring . ","this time kaufman's imagination has failed him . ","an intermittently pleasing but mostly routine effort . ","it becomes gimmicky instead of compelling .  interview  loses its overall sense of mystery and becomes a tv episode rather than a documentary that you actually buy into . ","'unfaithful' cheats on itself and retreats to comfortable territory . too bad . ","frenetic but not really funny . ","taken individually or collectively , the stories never add up to as much as they promise . ","if you're not a prepubescent girl , you'll be laughing at britney spears' movie-starring debut whenever it doesn't have you impatiently squinting at your watch . ","a didactic and dull documentary glorifying software anarchy . ","an awful snooze . ","sluggishly directed by episodic tv veteran joe zwick , it's a sitcom without the snap-crackle . ","you could nap for an hour and not miss a thing . ","director clare kilner's debut is never as daft as it should have been . ","new best friend shouldn't have gone straight to video ; it should have gone straight to a mystery science theater 3000 video . ","wallace seems less like he's been burning to tell a war story than he's been itching to somehow tack one together","the thrill is ( long ) gone . ","just plain silly . ","began life as a computer game , then morphed into a movie -- a bad one , of course . ","part comedy , part drama , the movie winds up accomplishing neither in full , and leaves us feeling touched and amused by several moments and ideas , but nevertheless dissatisfied with the movie as a whole . ","godawful boring slug of a movie . ","dull , if not devoid of wit , this shaggy dog longs to frisk through the back alleys of history , but scarcely manages more than a modest , snoozy charm . ","scene-by-scene , things happen , but you'd be hard-pressed to say what or why . "," . . . an unimaginative , nasty , glibly cynical piece of work . ","it is , by conventional standards , a fairly terrible movie . . . but it is also weirdly fascinating , a ready-made eurotrash cult object . it is also , at times , curiously moving . ","the tug-of-war at the core of beijing bicycle becomes weighed down with agonizing contrivances , overheated pathos and long , wistful gazes . ","vile and tacky are the two best adjectives to describe ghost ship . ","some decent actors inflict big damage upon their reputations . ","being author wells' great-grandson , you'd think filmmaker simon wells would have more reverence for the material . but this costly dud is a far cry from either the book or the beloved film . ","offensive in the way it exploits the hot-button issue of domestic abuse for cheap thrills and disgusting in the manner it repeatedly puts a small child in jeopardy , treating her as little more than a prop to be cruelly tormented . ","mark me down as a non-believer in werewolf films that are not serious and rely on stupidity as a substitute for humor . ","thoughtless , random , superficial humour and a lot of very bad scouse accents","aspires for the piquant but only really achieves a sort of ridiculous sourness . ","accuracy and realism are terrific , but if your film becomes boring , and your dialogue isn't smart , then you need to use more poetic license . ","for all its highfalutin title and corkscrew narrative , the movie turns out to be not much more than a shaggy human tale . ","a soggy , cliche-bound epic-horror yarn that ends up being even dumber than its title . ","one groan-inducing familiarity begets another . ","although based on a real-life person , john , in the movie , is a rather dull person to be stuck with for two hours . ","feeble comedy . ","great story , bad idea for a movie . ","with spy kids 2 : the island of lost dreams writer/director/producer robert rodriguez has cobbled together a film that feels like a sugar high gone awry . ","there is no entry portal in the rules of attraction , and i spent most of the movie feeling depressed by the shallow , selfish , greedy characters . ","it's hard to tell with all the crashing and banging where the salesmanship ends and the movie begins . ","  my god , i'm behaving like an idiot !  yes , you are , ben kingsley . ","a dreadful live-action movie . ","divertingly ridiculous , headbangingly noisy . ","an earnest racial-issues picture that might have gotten respectful critical praise in a different era -- say , the '60s . ","a hideous , confusing spectacle , one that may well put the nail in the coffin of any future rice adaptations . ","all i can say is fuhgeddaboutit . ","between bedroom scenes , viewers may find themselves wishing they could roll over and take a nap . ","if you collected all the moments of coherent dialogue , they still wouldn't add up to the time required to boil a four- minute egg . ","despite all the talking , by the time the bloody climax arrives we still don't feel enough of an attachment to these guys to care one way or another . ","every bit as bogus as most disney live action family movies are -- no real plot , no real conflict , no real point . ","a sensual performance from abbass buoys the flimsy story , but her inner journey is largely unexplored and we're left wondering about this exotic-looking woman whose emotional depths are only hinted at . ","never engaging , utterly predictable and completely void of anything remotely interesting or suspenseful . ","spousal abuse is a major problem in contemporary society , but the film reduces this domestic tragedy to florid melodrama . ","oedekerk wrote patch adams , for which he should not be forgiven . why he was given free reign over this project -- he wrote , directed , starred and produced -- is beyond me . ","the creaking , rusty ship makes a fine backdrop , but the ghosts' haunting is routine . ","whatever eyre's failings as a dramatist , he deserves credit for bringing audiences into this hard and bitter place . ","scotland , pa . blurs the line between black comedy and black hole . ","it tries too hard , and overreaches the logic of its own world . ","the whole damn thing is ripe for the jerry springer crowd . it's all pretty cynical and condescending , too . ","i cry for i spy -- or i would if this latest and laziest imaginable of all vintage-tv spinoffs were capable of engendering an emotional response of any kind . ","a boring , formulaic mix of serial killers and stalk'n'slash . ","what you would end up with if you took orwell , bradbury , kafka , george lucas and the wachowski brothers and threw them into a blender . but that's just the problem with it - the director hasn't added enough of his own ingredients . ","with recent tensions rekindled by the kathleen soliah trial and the upcoming trial of sla members emily and william harris , not to mention sept . 11 , its difficult these days to appreciate fire's bright side . ","flaunts its quirky excesses like a new year's eve drunk sporting a paper party hat . ","writhing under dialogue like 'you're from two different worlds' and 'tonight the maid is a lie and this , this is who you are , ' this schlock-filled fairy tale hits new depths of unoriginality and predictability . "," . . . too slow , too boring , and occasionally annoying . ","is there enough material to merit a documentary on the making of wilco's last album ? ","faultlessly professional but finally slight . ","schmaltzy and unfunny , adam sandler's cartoon about hanukkah is numbingly bad , little nicky bad , 10 worst list bad . ","it's really yet another anemic and formulaic lethal weapon-derived buddy-cop movie , trying to pass off its lack of imagination as hip knowingness . ","scotland , pa . is a strangely drab romp . some studio pizazz might have helped . ","when perry fists a bull at the moore farm , it's only a matter of time before he gets the upper hand in matters of the heart . ","there's more scatological action in 8 crazy nights than a proctologist is apt to encounter in an entire career . ","too loud , too long and too frantic by half , die another day suggests that the bond franchise has run into a creative wall that 007 cannot fly over , tunnel under or barrel through . ","the cartoon is about as true to the spirit of the festival of lights as mr . deeds was to that of frank capra . "," . . . the sum of the parts equals largely a confused mediocrity . ","the tone shifts abruptly from tense to celebratory to soppy . ","if we don't demand a standard of quality for the art that we choose , we deserve the trash that we get . ","a modest and messy metaphysical thriller offering more questions than answers . ","julia is played with exasperating blandness by laura regan . ","morrissette's script and direction show a fair amount of intelligence and wit -- but it doesn't signify a whole lot either . ","there's suspension of disbelief and then there's bad screenwriting . . . this film packs a wallop of the latter . ","all ms . jovovich , as the sanctified heroine , has to do is look radiant , grimly purposeful and mildly alarmed while forcing open doors , wielding wrenches and fleeing monsters . ","mocking kung fu pictures when they were a staple of exploitation theater programming was witty . mocking them now is an exercise in pointlessness . ","this is a particularly toxic little bonbon , palatable to only a chosen and very jaundiced few . ","this isn't just the cliffsnotes version of nicholas nickleby , it's the cliffsnotes with pages missing . ","considering the harsh locations and demanding stunts , this must have been a difficult shoot , but the movie proves rough going for the audience as well . ","better at putting you to sleep than a sound machine . ","so clichéd that , at one point , they literally upset an apple cart . ","it's a decent glimpse into a time period , and an outcast , that is no longer accessible , but it doesn't necessarily shed more light on its subject than the popular predecessor . ","it might be the first sci-fi comedy that could benefit from a three's company-style laugh track . ","when the plot kicks in , the film loses credibility . ","credibility sinks into a mire of sentiment . ","the movie takes itself too seriously and , as a result , it makes for only intermittent fun . ","[davis] has a bright , chipper style that keeps things moving , while never quite managing to connect her wish-fulfilling characters to the human race . ","doesn't amount to much of anything . ","bullock's complete lack of focus and ability quickly derails the film","so stupid , so ill-conceived , so badly drawn , it created whole new levels of ugly . ","the truth is that the truth about charlie gets increasingly tiresome . ","enduring love but exhausting cinema . ","some of seagal's action pictures are guilty pleasures , but this one is so formulaic that it seems to be on auto-pilot . ","a ponderous meditation on love that feels significantly longer than its relatively scant 97 minutes . ","a long-winded and stagy session of romantic contrivances that never really gels like the shrewd feminist fairy tale it could have been . ","a little too pat for its own good . ","there are films that try the patience of even the most cinema-besotted critic -- and this was one of them . ","watching trouble every day , at least if you don't know what's coming , is like biting into what looks like a juicy , delicious plum on a hot summer day and coming away with your mouth full of rotten pulp and living worms . ","well-intentioned though it may be , its soap-opera morality tales have the antiseptic , preprogrammed feel of an after-school special . ","what would jesus do if he was a film director ? he'd create a movie better than this . ","when a set of pre-shooting guidelines a director came up with for his actors turns out to be cleverer , better written and of considerable more interest than the finished film , that's a bad sign . a very bad sign . ","it's a deeply serious movie that cares passionately about its subject , but too often becomes ponderous in its teaching of history , or lost in the intricate connections and multiple timelines of its story . ","can't kick about the assembled talent and the russos show genuine promise as comic filmmakers . still , this thing feels flimsy and ephemeral . ","diane lane shines in unfaithful . almost everything else is wan . ","i'm afraid you won't get through this frankly fantastical by-the-numbers b-flick with just a suspension of disbelief . rather , you'll have to wrestle disbelief to the ground and then apply the chloroform-soaked handkerchief . ","so relentlessly wholesome it made me want to swipe something . ","the title helpfully offers the most succinct review of it you'll read anywhere . ","the makers of divine secrets of the ya-ya sisterhood should offer a free ticket ( second prize , of course , two free tickets ) to anyone who can locate a genuinely honest moment in their movie . ","god help the poor woman if attal is this insecure in real life : his fictional yvan's neuroses are aggravating enough to exhaust the patience of even the most understanding spouse . ","let's cut to the consumer-advice bottom line : stay home . ","undercover brother doesn't go far enough . it's just a silly black genre spoof . ","the film's implicit premise is that the faith of the tonga people is in every way inferior to that of john . ","rates an 'e' for effort -- and a 'b' for boring . ","you've already seen heartbreak if you've watched the far superior nurse betty or sunset boulevard . even the unwatchable soapdish is more original . ","plays like one of those conversations that comic book guy on  the simpsons  has . ","a journey that's too random and inconclusive to be compelling , but which hoffman's brilliance almost makes worth taking . ","the movie bounces all over the map . ","but buying into sham truths and routine  indie  filmmaking , freundlich has made just another safe movie . it's not horrible , just horribly mediocre . ","not always too whimsical for its own good ( but enough to do harm ) , this strange hybrid of crime thriller , quirky character study , third-rate romance and female empowerment fantasy never really finds the tonal or thematic glue it needs . ","  juwanna mann ?  no thanks . wewannour money back , actually . ","it's a sometimes interesting remake that doesn't compare to the brilliant original . ","you're too conscious of the effort it takes to be this spontaneous . "," . . . salaciously simplistic . ","feel bad for king , who's honestly trying , and schwartzman , who's shot himself in the foot . ","some actors steal scenes . tom green just gives them a bad odor . this self-infatuated goofball is far from the only thing wrong with the clumsy comedy stealing harvard , but he's the most obvious one . ","sometimes , fond memories should stay in the past : a lesson this film teaches all too well . ","the enormous comic potential of an oafish idiot impersonating an aristocrat remains sadly unrealized . ","shallow . ","begins as a promising meditation on one of america's most durable obsessions but winds up as a slender cinematic stunt . ","a monster combat thriller as impersonal in its relentlessness as the videogame series that inspired it . ","proof that a thriller can be sleekly shot , expertly cast , paced with crisp professionalism . . . and still be a letdown if its twists and turns hold no more surprise than yesterday's weather report . ","the reason we keep seeing the same movie with roughly the same people every year is because so many of us keep going and then , out of embarrassment or stupidity , not warning anyone . ","there's not much going on in this movie unless you simply decide to buy into the notion that something inexplicably strange once happened in point pleasant . ","in the second half of the film , frei's control loosens in direct proportion to the amount of screen time he gives nachtwey for self-analysis . ","director barry skolnick and his screenwriters glibly tick off every point of  the longest yard  playbook like a checklist . ","the furious coherence that [deniro] brings to this part only underscores the fuzzy sentimentality of the movie itself , which feels , as it plods toward the end , less like a movie than like the filmed reading of a script in need of polishing . ","oh , it's extreme , all right . extremely dumb . extremely confusing . extremely boring . ","we never really feel involved with the story , as all of its ideas remain just that : abstract ideas . ","for a shoot-'em-up , ballistic is oddly lifeless . ","one minute , you think you're watching a serious actioner ; the next , it's as though clips from the pink panther strikes again and/or sailor moon have been spliced in . ","what happened with pluto nash ? how did it ever get made ? ","we may never think of band camp as a geeky or nerdy thing again . ","opens as promising as any war/adventure film you'll ever see and dissolves into a routine courtroom drama , better suited for a movie titled  glory : a soldier's story .  ","the result is solemn and horrifying , yet strangely detached . ","these spiders can outrun a motorcycle and wrap a person in a sticky cocoon in seconds , but they fall short of being interesting or entertaining . ","a less-than-thrilling thriller . ","a long slog for anyone but the most committed pokemon fan . ","matthew mcconaughey tries , and fails , to control the screen with swaggering machismo and over-the-top lunacy . ","how on earth , or anywhere else , did director ron underwood manage to blow $100 million on this ? ","everyone connected to this movie seems to be part of an insider clique , which tends to breed formulaic films rather than fresh ones . ","with a story inspired by the tumultuous surroundings of los angeles , where feelings of marginalization loom for every dreamer with a burst bubble , the dogwalker has a few characters and ideas , but it never manages to put them on the same path . ","its lack of quality earns it a place alongside those other two recent dumas botch-jobs , the man in the iron mask and the musketeer . ","a benign but forgettable sci-fi diversion . ","the plot grinds on with yawn-provoking dullness . ","it's never a good sign when a film's star spends the entirety of the film in a coma . it's a worse sign when you begin to envy her condition . ","it doesn't help that the director and cinematographer stephen kazmierski shoot on grungy video , giving the whole thing a dirty , tasteless feel . ","desperately unfunny when it tries to makes us laugh and desperately unsuspenseful when it tries to make us jump out of our seats . ","this film's relationship to actual tension is the same as what christmas-tree flocking in a spray can is to actual snow : a poor -- if durable -- imitation . ","john mctiernan's botched remake may be subtler than norman jewison's 1975 ultraviolent futuristic corporate-sports saga . it's also stupider . ","director dirk shafer and co-writer greg hinton ride the dubious divide where gay porn reaches for serious drama . ","borrows from so many literary and cinematic sources that this future world feels absolutely deja vu . ","as [the characters] get more depressed , the story gets more tiresome , especially as it continues to mount a conspicuous effort to be profound . ","the acting by the over-25s lacks spark , with csokas particularly unconnected . ","though howard demonstrates a great eye as a director , this southern gothic drama is sadly a tough sit , with an undeveloped narrative and enough flashbacks and heavy-handed metaphors to choke a horse -- or at least slow him down to a canter . ","falters when it takes itself too seriously and when it depends too heavily on its otherwise talented cast to clown in situations that aren't funny . ","the fight scenes are fun , but it grows tedious . ","anyone who can count to five ( the film's target market ? ) can see where this dumbed-down concoction is going . ","all this turns out to be neither funny nor provocative - only dull . ","demme's loose approach kills the suspense . ","this idea has lost its originality . . . and neither star appears very excited at rehashing what was basically a one-joke picture . ","[plays] in broad outline as pandering middle-age buddy-comedy . ","the film is itself a sort of cinematic high crime , one that brings military courtroom dramas down very , very low . ","nothing more than a mediocre trifle . ","a turgid little history lesson , humourless and dull . ","too silly to be frightening , too stolid to be funny , it projects the same lazy affability as its nominal star , david arquette . ","if kaufman kept cameron diaz a prisoner in a cage with her ape , in his latest , he'd have them mate . ","trivial where it should be profound , and hyper-cliched where it should be sincere . ","it would be hard to think of a recent movie that has worked this hard to achieve this little fun . ","theology aside , why put someone who ultimately doesn't learn at the center of a kids' story ? ","all that ( powerpuff girls ) charm is present in the movie , but it's spread too thin . ","sometimes smart but more often sophomoric . ","the ill-conceived modern-day ending falls flat where it should deliver a moral punch . ","collateral damage is , despite its alleged provocation post-9/11 , an antique , in the end . as are its star , its attitude and its obliviousness . ","dawdles and drags when it should pop ; it doesn't even have the virtue of enough mindless violence to break up the tedium of all its generational bonding . ","its save-the-planet message clashes with its crass marketing . ","a great idea becomes a not-great movie . "," . . . watching this film nearly provoked me to take my own life . and if the hours wins 'best picture' i just might . ","by the end , i was looking for something hard with which to bludgeon myself unconscious . ","not a movie but a live-action agitprop cartoon so shameless and coarse , it's almost funny . ","feels like six different movies fighting each other for attention . ","life is a crock -- or something like it . ","made by jackasses for jackasses . ","despite a powerful portrayal by binoche , it's a period romance that suffers from an overly deliberate pace and uneven narrative momentum . ","the picture is a primer on what happens when lack of know-how mixes with lack of give-a-damn . ","bartleby is a one-joke movie , and a bad joke at that . ","disjointed parody . ","given that both movies expect us to root for convicted violent felons over those assigned to protect us from same , we need every bit of sympathy the cons can muster ; this time , there isn't much . ","a bravura exercise in emptiness . ","philip k . dick must be turning in his grave , along with my stomach . ","despite the premise of a good story . . . it wastes all its star power on cliched or meaningless roles . ","all prints of this film should be sent to and buried on pluto . ","not only does the movie fail to make us part of its reality , it fails the most basic relevancy test as well . ","first good , then bothersome . excellent acting and direction . ","this goofy gangster yarn never really elevates itself from being yet another earnestly generic crime-busting comic vehicle -- a well-intentioned remake that shows some spunk and promise but fails to register as anything distinctive or daring","it's difficult to say whether the tuxedo is more boring or embarrassing--i'm prepared to call it a draw . ","even as lame horror flicks go , this is lame . ","so routine , familiar and predictable , it raises the possibility that it wrote itself as a newly automated final draft computer program . ","sunshine state lacks the kind of dynamic that limbo offers , and in some ways is a rather indulgent piece . ","even legends like alfred hitchcock and john huston occasionally directed trifles . . . so it's no surprise to see a world-class filmmaker like zhang yimou behind the camera for a yarn that's ultimately rather inconsequential . ","a long-winded , predictable scenario . ","too close to phantom menace for comfort . "," . . . silly humbuggery . . . ","although trying to balance self-referential humor and a normal ol' slasher plot seemed like a decent endeavor , the result doesn't fully satisfy either the die-hard jason fans or those who can take a good joke . ","too clunky and too busy ribbing itself to be truly entertaining . ","this movie is about lying , cheating , but loving the friends you betray . ","it smacks of purely commercial motivation , with no great love for the original . ","melanie eventually slugs the yankee . too bad the former murphy brown doesn't pop reese back . ","at the bottom rung of the series' entries . ","a real clunker . a well-made , thoughtful , well-acted clunker , but a clunker nonetheless . ","a dreary rip-off of goodfellas that serves as a muddled and offensive cautionary tale for hispanic americans . ","the picture , scored by a perversely cheerful marcus miller accordion/harmonica/banjo abomination , is a monument to bad in all its florid variety . ","good for a few unintentional laughs ,  extreme ops  was obviously made for the  xxx  crowd , people who enjoy mindless action without the benefit of decent acting , writing , and direction . ","…a big , baggy , sprawling carnival of a movie , stretching out before us with little rhyme or reason . ","a frustrating combination of strained humor and heavy-handed sentimentality . ","lawrence preaches strictly to the converted . ","as written by michael berg and michael j . wilson from a story by wilson , this relentless , all-wise-guys-all-the-time approach tries way too hard and gets tiring in no time at all . ","will probably stay in the shadow of its two older , more accessible qatsi siblings . ","just when the movie seems confident enough to handle subtlety , it dives into soapy bathos . ","choppy editing and too many repetitive scenes spoil what could have been an important documentary about stand-up comedy . "," . . . the film falls back on the same old formula of teen sex , outrageous pranks and scenes designed to push the envelope of bad taste for laughs . ","the only thing in pauline and paulette that you haven't seen before is a scene featuring a football field-sized oriental rug crafted out of millions of vibrant flowers . ","if you're looking for comedy to be served up , better look elsewhere . ","it virtually defines a comedy that's strongly mediocre , with funny bits surfacing every once in a while . ","an instant candidate for worst movie of the year . ","despite its title , amy's orgasm is not a porno , though it is as tedious as one . ","like a tone-deaf singer at a benefit concert , john q . is a bad movie appearing on behalf of a good cause . ","adam sandler is to gary cooper what a gnat is to a racehorse . ","what kids will discover is a new collectible . what parents will suspect is that they're watching a 76-minute commercial . ","beers , who , when she's given the right lines , can charm the paint off the wall . . . [but] the script goes wrong at several key junctures . ","without september 11 , collateral damage would have been just another bad movie . now it's a bad , embarrassing movie . ","drags along in a dazed and enervated , drenched-in-the- past numbness . ","there's a disturbing 'great white hope' undertone to the other side of heaven that subtly undermines its message of christian love and compassion . ","unless you are in dire need of a diesel fix , there is no real reason to see it . wait for video -- and then don't rent it . ","the attempt is courageous , even if the result is wildly uneven . ","there's something fundamental missing from this story : something or someone to care about . ","too much of this well-acted but dangerously slow thriller feels like a preamble to a bigger , more complicated story , one that never materializes . ","when a film is created solely because it's a marketable product , soulless and ugly movies like this are the result . let your silly childhood nostalgia slumber unmolested . ","unfortunately , heartbreak hospital wants to convey the same kind of haughtiness in its own sketchy material but this territory has already been explored previously with better aplomb and sardonic wit . ","the more kevin costner rests on his pretty-boy laurels , the public is , regrettably , going to have tepid films like dragonfly tossed at them . ","[it's] difficult to get beyond the overall blandness of american chai , despite its likable performances and refreshingly naive point of view . ","the latest installment in the pokemon canon , pokemon 4ever is surprising less moldy and trite than the last two , likely because much of the japanese anime is set in a scenic forest where pokemon graze in peace . ","taken purely as an exercise in style , this oppressively gloomy techno-horror clambake is impossible to ignore . but as a movie , it's a humorless , disjointed mess . ","if myers decides to make another austin powers movie , maybe he should just stick with austin and dr evil . ","the backyard battles you staged with your green plastic army men were more exciting and almost certainly made more sense . ","too stupid to be satire , too obviously hateful to be classified otherwise , frank novak's irritating slice of lumpen life is as reliably soul-killing as its title is nearly meaningless . ","overly stylized with lots of flash black-&-white freeze frames reminiscent of a pseudo-hip luxury car commercial , ( it's ) at its worst when it's actually inside the ring . ","what is captured during the conceptual process doesn't add up to a sufficient explanation of what the final dance work , the selection , became in its final form . ","if this is satire , it's the smug and self-congratulatory kind that lets the audience completely off the hook . ","had the film boasted a clearer , more memorable , the creepiness would have gotten under the skin . ","these people wouldn't know subtle characterization if it put on a giant furry monster costume and then gave them a lapdance . ","imagine if you will a tony hawk skating video interspliced with footage from behind enemy lines and set to jersey shore techno . ","it doesn't quite work , but there's enough here to make us look forward to the russos' next offering . ","any film featuring young children threatened by a terrorist bomb can no longer pass as mere entertainment . ","the director's twitchy sketchbook style and adroit perspective shifts grow wearisome amid leaden pacing and indifferent craftsmanship ( most notably wretched sound design ) . ","about as satisfying and predictable as the fare at your local drive through . ","apparently kissing leads to suicide attempts and tragic deaths . marisa tomei is good , but just a kiss is just a mess . ","opens at a funeral , ends on the protagonist's death bed and doesn't get much livelier in the three hours in between . ","the noble tradition of men in drag hits an all-time low in sorority boys , whose makers apparently believe that women's clothing can cover up any deficiency in acting , writing or direction . ","to portray modern women the way director davis has done is just unthinkable . ","too simple for its own good . ","flaccid drama and exasperatingly slow journey . ","a chaotic panorama that's too busy flying a lot of metaphoric flags . ","suffers from rambling , repetitive dialogue and the visual drabness endemic to digital video . ","the screenplay sabotages the movie's strengths at almost every juncture . all the characters are stereotypes , and their interaction is numbingly predictable . ","a trashy , exploitative , thoroughly unpleasant experience . ","newcomer helmer kevin donovan is hamstrung by a badly handled screenplay of what is really an amusing concept – a high-tech tux that transforms its wearer into a superman . ","shouldn't have been allowed to use the word  new  in its title , because there's not an original character , siuation or joke in the entire movie . ","often silly – and gross – but it's rarely as moronic as some campus gross-out films . ","the advantage of a postapocalyptic setting is that it can be made on the cheap . any rock pile will do for a set . reign of fire has the disadvantage of also looking cheap . ","it's exactly what you'd expect . ","the performances are so leaden , michael rymer's direction is so bloodless and the dialogue is so corny that the audience laughs out loud . ","a subtle variation on i spit on your grave in which our purported heroine pathologically avenges a hatred for men . ","reggio's trippy , ambitious downer can also sometimes come across like nothing more than a glorified nike ad . ","as tweedy talks about canning his stockbroker and repairing his pool , you yearn for a few airborne tv sets or nude groupies on the nod to liven things up . ","if somebody was bored and . . . decided to make a dull , pretentious version of jesus' son , they'd come up with something like bart freundlich's world traveler . ","the best you can say about it is it's so uninspired , it barely gives one pause when considering some of the other dreck out there right now . ","a tough go , but leigh's depth and rigor , and his skill at inspiring accomplished portrayals that are all the more impressive for their lack of showiness , offsets to a notable degree the film's often-mined and despairing milieu . ","an overstuffed compendium of teen-catholic-movie dogma . ","too leisurely paced and visually drab for its own good , it succeeds in being only sporadically amusing . ","ben affleck as jack ryan , tom clancy's intrepid hero ? ridiculous . what's next ? d . j . qualls as indiana jones ? or tom green as han solo ? ","eh . ","the movie's biggest offense is its complete and utter lack of tension . ","the film is directed by wally wolodarsky from a script by joe jarvis and greg coolidge . these are names to remember , in order to avoid them in the future . ","if this is the resurrection of the halloween franchise , it would have been better off dead . ","this formulaic chiller will do little to boost stallone's career . ","i saw knockaround guys yesterday , and already the details have faded like photographs from the spanish-american war . . . it's so unmemorable that it turned my ballpoint notes to invisible ink . ","though avary has done his best to make something out of ellis' nothing novel , in the end , his rules is barely worth following . ","the average local news columnist has a bigger rant on the war between modern landscape architecture and small-town america . ","no worse than a lot of the crap we've been offered this summer , and slightly better than men in black 2 as far as slapdash extraterrestrial comedies go . ","the plot is so predictable and sentimental that viewers are likely to lose interest before sandrine and her goats walk off into the sunset . ","at first , the sight of a blind man directing a film is hilarious , but as the film goes on , the joke wears thin . ","never again swings between false sentiment and unfunny madcap comedy and , along the way , expects the audience to invest in the central relationship as some kind of marriage of true minds . ","the story itself is uninteresting , and the songs are painfully undistinguished : they might be giants' so to be one of us may be the most tuneless tune ever composed . ","este é apenas mais um ( longo ) episódio do programa da mtv . a única diferença é que , desta vez , a paramount teve o mau gosto de exibi-lo nos cinemas . ","technically , the film is about as interesting as an insurance commercial . ","the title's lameness should clue you in on how bad the movie is . ","the parts are better than the whole ( bizarre , funny , tragic - like love in new york ) . ","while the film shuns the glamour or glitz that an american movie might demand , scherfig tosses us a romantic scenario that is just as simplistic as a hollywood production . ","the humor is hinged on the belief that knees in the crotch , elbows in the face and spit in the eye are inherently funny . ","it's a movie forged in the fires of chick flick hell . ","its characters are thinner than cardboard -- or even comic-book paper . ","any one episode of the sopranos would send this ill-conceived folly to sleep with the fishes . ","feels like the grittiest movie that was ever made for the lifetime cable television network . ","lanie's professional success means she must be a failure at life , because she's driven by ambition and doesn't know how to have fun . ","credit must be given to harland williams , michael rosenbaum and barry watson , who inject far more good-natured spirit and talent into this project than it deserves","denzel washington's efforts are sunk by all the sanctimony . ","if this holiday movie is supposed to be a gift , somebody unwrapped it early , took out all the good stuff , and left behind the crap ( literally ) . ","so faithful to the doldrums of the not-quite-urban , not-quite-suburban milieu as to have viewers recoiling from the reality check . ","rambles on in a disjointed , substandard fashion from one poorly executed action sequence to the next . ","there's an audience for it , but it could have been funnier and more innocent . ","i can only imagine one thing worse than kevin spacey trying on an irish accent , and that's sultry linda fiorentino doing the same thing . ","an awkward and indigestible movie . ","the movie has very little to offer besides unintentional laughs . ","haneke keeps us at arm's length . guided more by intellect than heart , his story flattens instead of sharpens . ","all the well-meaningness in the world can't erase the fact that the believer feels like a 12-step program for the jewish nazi . ","like most sequels , it takes what worked last time , repeats it and adds more characters , more stunts , more stuff in attempt to camouflage its sameness . ","there's no way to sort out the mess in our heads and deconstruct where it all went wrong . this is an hour and a half of daydreaming . ","message movie or an action-packed submarine spectacular ? alas , it's neither . ","no movement , no yuks , not much of anything . ","'dragonfly' is a movie about a bus wreck that turns into a film wreck . ","thirty years ago , it would have been groundbreaking . now it's just tired . ","heavy-handed exercise in time-vaulting literary pretension . ","the movie is too cute to take itself too seriously , but it still feels like it was made by some very stoned college students . ","a thinly veiled excuse for wilson to play his self-deprecating act against murphy's well-honed prima donna shtick . ","a minor picture with a major identity crisis -- it's sort of true and it's sort of bogus and it's ho-hum all the way through . ","the movie succumbs to being nothing more than a formulaic chase in the dark . ","plays as hollow catharsis , with lots of tears but very little in the way of insights . ","it will come as no surprise that the movie isn't scary . but here's the real damn : it isn't funny , either . ","quick : who wants to see a comedy about shoddy airport security ? ","the reason i found myself finally unmoved by this film , which is immaculately produced and has serious things to say , is that it comes across rather too plainly as allegory . ","what you get with empire is a movie you've seen many times before , repackaged as new material because there is a latino in the lead . ","cho's fans are sure to be entertained ; it's only fair in the interest of full disclosure to say that -- on the basis of this film alone -- i'm not one of them . ","looks awfully like one long tourist spot for a mississippi that may never have existed outside of a scriptwriter's imagination . ","the period -- swinging london in the time of the mods and the rockers -- gets the once-over once again in gangster no . 1 , but falls apart long before the end . ","high crimes miscasts nearly every leading character . ","the overall feel of the film is pretty cheesy , but there's still a real sense that the star trek tradition has been honored as best it can , given the embarrassing script and weak direction . ","de niro looks bored , murphy recycles murphy , and you mentally add showtime to the pile of hollywood dreck that represents nothing more than the art of the deal . ","i didn't believe for a moment in these villains or their plot . ","another rent installment for the ian fleming estate . ","with danilo donati's witty designs and dante spinotti's luscious cinematography , this might have made a decent children's movie -- if only benigni hadn't insisted on casting himself in the title role . ","so lazy and slipshod it confuses the mere flashing of kinky soft-core imagery with naughty fun . ","though it draws several decent laughs , it's low-cal woody at best . ","has little on its mind aside from scoring points with drag gags . ","britney's performance cannot be faulted . lucy's a dull girl , that's all . ","  the kid stays in the picture  is a great story , terrifically told by the man who wrote it but this cliff notes edition is a cheat . ","well-shot but badly written tale set in a future ravaged by dragons . ","sadly , hewitt's forte is leaning forward while wearing low-cut gowns , not making snappy comebacks . ","if melville is creatively a great whale , this film is canned tuna . ","this film is so slick , superficial and trend-hoppy , that it's easy to imagine that a new software program spit out the screenplay . ","just one more collection of penis , breast and flatulence gags in search of a story . or a profit . or some damn thing . ","the acting is stiff , the story lacks all trace of wit , the sets look like they were borrowed from gilligan's island -- and the cgi scooby might well be the worst special-effects creation of the year . ","enough trivializes an important crisis , reduces it to an almost comic embarrassment . ","the makers have forsaken the entertaining elements of the original and , instead , rehash old jokes and leave any life at the doorstep . i like frank the pug , though . ","a restrained ribisi convinces as an italian , though if ever a movie needed one of the actor's whiny jags to pump it up , this has to be among the rare ones . ","gee , a second assassin shot kennedy ? moot point . ","a hysterical yet humorless disquisition on the thin line between sucking face and literally sucking face . ","needless to say , the dramatics that follow are utter hooey . ","the problem is that rather than dramatizing this premise , mr . desplechin is content to state it . ","madonna still can't act a lick . ","even the imaginative gore can't hide the musty scent of todd farmer's screenplay , which is a simple retread of the 1979 alien , with a plucky heroine battling a monster loose in a spaceship . ","if you pitch your expectations at an all time low , you could do worse than this oddly cheerful -- but not particularly funny -- body-switching farce . ","the episodic film makes valid points about the depersonalization of modern life . but the characters tend to be cliches whose lives are never fully explored . ","serry does a fine job of capturing the climate of the times and , perhaps unwittingly , relating it to what is happening in america in 2002 . but hard-to-believe plot twists force the movie off track in its final half hour . ","don't let your festive spirit go this far . ","though the book runs only about 300 pages , it is so densely packed . . . that even an ambitious adaptation and elaborate production like mr . schepisi's seems skimpy and unclear . ","hey , at least the title of this film lets you know exactly where it's heading . ","intended to be a comedy about relationships , this wretched work falls flat in just about every conceivable area . ","sensitive though not quite revelatory documentary . ","director brian levant , who never strays far from his sitcom roots , skates blithely from one implausible situation to another , pausing only to tie up loose ends with more bows than you'll find on a french poodle . "," . . . perhaps the heaviest , most joyless movie ever made about giant dragons taking over the world . ","suggests puns about ingredients and soup and somebody being off their noodle , but let's just say the ingredients don't quite add up to a meal . ","i'd give real money to see the perpetrators of chicago torn apart by dingoes . ","movies like this are selling the old european candor , the old wink of 'bold' revelation . but in 2002 , such revelations wilt . ","the timing in nearly every scene seems a half beat off . ","i admire it and yet cannot recommend it , because it overstays its natural running time . ","a fairly by-the-books blend of action and romance with sprinklings of intentional and unintentional comedy . ","flounders due to the general sense that no two people working on the production had exactly the same thing in mind . ","even if you feel like you've seen this movie a thousand times before , it is kind of enjoyable thanks mainly to belushi's easy-going likableness . ","the story bogs down in a mess of purposeless violence . ","despite some gulps the film is a fuzzy huggy . ","mckay deflates his piece of puffery with a sour cliche and heavy doses of mean-spiritedness","a recipe for cinematic disaster . . . part quentin tarantino , part guy ritchie , and part 1960s spy spoof , it's all bad . ","the cumulative effect of the relentless horror on parade numbs the movie's power as a work of drama . ","another big , dumb action movie in the vein of xxx , the transporter is riddled with plot holes big enough for its titular hero to drive his sleek black bmw through . ","aaliyah rarely dampens her diva persona enough to spark genuine chemistry with townsend . when she speaks , her creepy egyptian demigod voice is as computer processed and overproduced as it was in her music . ","outrageousness is all plympton seemed to be going for this time . we miss the quirky amazement that used to come along for an integral part of the ride . ","much of what is meant to be 'inspirational' and 'uplifting' is simply distasteful to audiences not already sharing [the movie's] mindset . ","well before it's over , beijing bicycle begins spinning its wheels . ","home alone goes hollywood , a funny premise until the kids start pulling off stunts not even steven spielberg would know how to do . besides , real movie producers aren't this nice . ","[nelson's] movie about morally compromised figures leaves viewers feeling compromised , unable to find their way out of the fog and the ashes . ","passion , lip-synching , tragedy , and lots of really really high notes . for me , this opera isn't a favorite , so it's a long time before the fat lady sings . ","looks like a high school film project completed the day before it was due . ","truth to tell , if you've seen more than half-a-dozen horror films , there's nothing here you haven't seen before . ","abandons all pretense of creating historical context and waltzes off into a hectic soap about the ups and downs of the heavy breathing between the two artists . ","even die-hard fans of japanese animation . . . will find this one a challenge . ","filmmakers have to dig deep to sink this low . fortunately for all involved , this movie is likely to disappear as quickly as an ice cube thrown into a pot of boiling water . ","the movie gets muted and routine . ","the issue of faith is not explored very deeply","it's a bad sign when you're rooting for the film to hurry up and get to its subjects' deaths just so the documentary will be over , but it's indicative of how uncompelling the movie is unless it happens to cover your particular area of interest . ","the situations and jokes are as predictable and as lowbrow as the endless pratfalls the boys take in their high heels . ","it's frustrating to see these guys -- who are obviously pretty clever -- waste their talent on parodies of things they probably thought were funniest when they were high . ","i was perplexed to watch it unfold with an astonishing lack of passion or uniqueness . ","k-19 may not hold a lot of water as a submarine epic , but it holds even less when it turns into an elegiacally soggy saving private ryanovich . ","a very stylish but ultimately extremely silly tale . . . a slick piece of nonsense but nothing more . ","automatically pegs itself for the straight-to-video sci-fi rental shelf . ","black-and-white and unrealistic . ","the film is like a series of beginnings and middles that never take off . ","feels less like it's about teenagers , than it was written by teenagers . ","ja rule and kurupt should have gotten to rap . it would have benefitted the dialogue . ","a standard haunted house tale transplanted to the high seas . ","elicits more groans from the audience than jar jar binks , scrappy doo and scooby dumb , all wrapped up into one . ","it's badly acted , blandly directed , and could have been scripted by someone who just graduated from elementary school . "," in the end , white oleander isn't an adaptation of a novel . it's a flashy , star-splashed reduction . ","this film , starring anthony hopkins and chris rock , is your typical 'fish out of water' story . you've seen them a million times . just one problem : fish out of water usually die . this one does . ","the angst-ridden , affluent slacker characters are more grating than engaging . ","a soggy , shapeless mess . . . just a dumb excuse for a waterlogged equivalent of a haunted-house movie . ","men in black ii has sequel-itis something fierce . an ungainly , comedy-deficient , b-movie rush job . . . ","a combination of standard , stiff tv-style animation and snazzy-looking digital effects that do little to disguise the fact that the characters barely move . ","an unsatisfying hybrid of blair witch and typical stalk-and-slash fare , where the most conservative protagonist is always the last one living . ","say this for the soundtrack , it drowns out the lousy dialogue . ","after seeing swept away , i feel sorry for madonna . ","instead of kicking off the intrigue and suspense and mystery of the whole thing , hart's war , like the st . louis rams in the super bowl , waits until after halftime to get started . ","two-bit potboiler . ","a gob of drivel so sickly sweet , even the eager consumers of moore's pasteurized ditties will retch it up like rancid crème brûlée . ","maudlin and melodramatic we expected . boring we didn't . ","never quite transcends jokester status . . . and the punchline doesn't live up to barry's dead-eyed , perfectly chilled delivery . ","the film's bathos often overwhelms what could have been a more multifaceted look at this interesting time and place . ","it almost plays like solaris , but with guns and jokes . ","a baffling misfire , and possibly the weakest movie [woody allen] has made in the last twenty years . ","it won't be long before you'll spy i spy at a video store near you . ","this film looks like it was produced in 1954 , shelved for 48 years , and repackaged for a 2002 audience . ","propelled not by characters but by caricatures . ","there is not an ounce of honesty in the entire production . ","this extremely unfunny film clocks in at 80 minutes , but feels twice as long . ","earnest but earthbound . . . a slow , soggy , soporific , visually dank crime melodrama/character study that would be more at home on the small screen but for its stellar cast . ","the pivotal narrative point is so ripe the film can't help but go soft and stinky . ","for all its alleged youthful fire , xxx is no less subservient to bond's tired formula of guns , girls and gadgets while brandishing a new action hero . ","a predictable and stereotypical little b-movie . ","if i spy were funny ( enough ) or exciting ( enough ) then it would be fairly simple to forgive the financial extortion it's trying to reap from the moviegoing public . ","frustratingly , dridi tells us nothing about el gallo other than what emerges through his music . ","places a slightly believable love triangle in a difficult-to-swallow setting , and then disappointingly moves the story into the realm of an improbable thriller . ","stephen earnhart's documentary is a decomposition of healthy eccentric inspiration and ambition – wearing a cloak of unsentimental , straightforward text – when it's really an exercise in gross romanticization of the delusional personality type . ","a very average science fiction film . ","undone by its overly complicated and derivative screenplay , the glacier-paced direction and the stereotypical characters . ","how anyone over the age of 2 can stomach the touchy-feely message this preachy produce promotes is beyond us . ","the sort of movie that gives tastelessness a bad rap . ","the cold and dreary weather is a perfect metaphor for the movie itself , which contains few laughs and not much drama . ","the plot is straight off the shelf , the performances are television- caliber and the message of providing solace through deception is a little creepy . ","ordinary melodrama that is heavy on religious symbols but wafer-thin on dramatic substance","a whimsical if predictable time-travel fable marred by a willful single-mindedness . ","those who managed to avoid the deconstructionist theorizing of french philosopher jacques derrida in college can now take an 85-minute brush-up course with the documentary derrida . or , you can do something fun tonight . ","jolie's performance vanishes somewhere between her hair and her lips . ","as with too many studio pics , plot mechanics get in the way of what should be the lighter-than-air adventure . ","static , repetitive , muddy and blurry , hey arnold ! would seem to have a lock on the title of ugliest movie of the year . ","for all of the contemporary post-colonialist consciousness that kapur tries to bring to the four feathers , the oddest thing about the movie is how it winds up affirming the same damn moldy values the material has always held dear . ","un thriller manqué qui tombe sur les nerfs presque dès la première image . ","when it comes to entertainment , children deserve better than pokemon 4ever . ","what the four feathers lacks is genuine sweep or feeling or even a character worth caring about . ","while benigni ( who stars and co-wrote ) seems to be having a wonderful time , he might be alone in that . ","yes , 4ever is harmless in the extreme and it'll mute your kids for nearly 80 minutes , but why not just treat the little yard apes to the real deal and take them to spirited away ? ","preposterous and tedious , sonny is spiked with unintentional laughter that , unfortunately , occurs too infrequently to make the film even a guilty pleasure . ","calling this movie brainless would be paying it a compliment : it's more like entertainment for trolls . ","none of these characters resembles anyone you've ever met in real life , unless you happen to know annoyingly self-involved people who speak in glib sentences that could have only come from the pen of a screenwriter . "," . . . just a big mess of a movie , full of images and events , but no tension or surprise . ","as elegantly crafted as it often is , anderson's movie is essentially a one-trick pony that , hampered by an undeveloped script , ultimately pulls up lame . ","splashes its drama all over the screen , subjecting its audience and characters to action that feels not only manufactured , but also so false you can see the filmmakers' puppet strings . "," . . . has virtually no script at all . . . ","will only satisfy those who can't tell the difference between the good , the bad and the ugly . ","this kind of dark comedy requires a delicate , surgical touch . but director danny devito and screenwriter adam resnick ( remember cabin boy ? ) just pound away . ","at times , however , dogtown and z-boys lapses into an insider's lingo and mindset that the uninitiated may find hard to follow , or care about . ","rather quickly , the film falls into a soothing formula of brotherly conflict and reconciliation . ","screenwriters scott abbott and michael petroni have turned rice's complex akasha into a cartoon monster . ","the writers , director wally wolodarsky , and all the actors should start their own coeducational fraternity : kappa rho alpha phi . ","bad beyond belief and ridiculous beyond description . ","the new faces are interesting , but the old story isn't , especially when it starts to seem more improvised than scripted . ","most of the action setups are incoherent . ","liman , of swingers and go , makes his big-budget action film debut something of a clunker as he delivers a long , low-heat chase , interrupted by a middling car chase . "," . . . surprisingly inert for a movie in which the main character travels back and forth between epochs . ","the problem isn't that the movie hits so close to home so much as that it hits close to home while engaging in such silliness as that snake-down-the-throat business and the inevitable shot of schwarzenegger outrunning a fireball . ","dreary , highly annoying . . . 'some body' will appeal to no one . ","a prison comedy that never really busts out of its comfy little cell . ","there's something deeply creepy about never again , a new arrow in schaeffer's quiver of ineptitudes . ","the problem with concept films is that if the concept is a poor one , there's no saving the movie . sorry , charlie","a painfully leaden film destined for pre-dawn cable television slots . ","blessed with immense physical prowess he may well be , but ahola is simply not an actor . and in truth , cruel as it may sound , he makes arnold schwarzenegger look like spencer tracy . ","the cartoon that isn't really good enough to be on afternoon tv is now a movie that isn't really good enough to be in theaters . ","shocking only in that it reveals the filmmaker's bottomless pit of self-absorption . ","this pep-talk for faith , hope and charity does little to offend , but if saccharine earnestness were a crime , the film's producers would be in the clink for life . ","all ends well , sort of , but the frenzied comic moments never click . ","if this is the danish idea of a good time , prospective tourists might want to consider a different destination -- some jolly country embroiled in a bloody civil war , perhaps . ","formula 51 is so trite that even yu's high-energy action stylings can't break through the stupor . ","only a few minutes elapse before the daddy of all slashers arrives , still with the boiler suit and white mask , which look remarkably clean for a guy who has been mass-murdering since 1978 but has never been seen doing laundry . ","when the painted backdrops in a movie are more alive than its characters , you know you're in trouble . ","[two] fairly dull -- contrasting and interlocking stories about miserable scandinavian settlers in 18th-century canada , and yuppie sailboaters in the here and now . ","the film is really not so much bad as bland . ","the central story lacks punch . ","though ganesh is successful in a midlevel sort of way , there's nothing so striking or fascinating or metaphorically significant about his career as to rate two hours of our attention . ","this may be the dumbest , sketchiest movie on record about an aspiring writer's coming-of-age . ","succumbs to the same kind of maudlin , sentimental mysticism that mars the touched by an angel school of non-god spiritual-uplift movies . ","a harmless and mildly amusing family comedy . ","what was subtle and mystifying in the novella is now broad and farcical . ","the kids often appear to be reading the lines and are incapable of conveying any emotion . ","  men in black ii ,  has all the earmarks of a sequel . the story is less vibrant , the jokes are a little lukewarm , but will anyone really care ? ","sucking all the 'classic' out of robert louis stevenson's treasure island and filling the void with sci-fi video game graphics and disney-fied adolescent angst . . . ","this 72-minute film does have some exciting scenes , but it's a tad slow . ","while super troopers is above academy standards , its quintet of writers could still use some more schooling . ","a mix of velocity and idiocy , this ruinous remake lacks the brawn -- and the brains -- of the 1970s original . ","the low-budget full frontal was one of the year's murkiest , intentionally obscure and self-indulgent pictures , and solaris is its big-budget brother . ","the plot is very clever , but boyd weighs it down with too many characters and events , all intertwined and far too complicated to keep track of . ","the film seems all but destined to pop up on a television screen in the background of a scene in a future quentin tarantino picture","a free-for-all of half-baked thoughts , clumsily used visual tricks and self-indulgent actor moments . ","apallingly absurd . . . the chemistry or lack thereof between newton and wahlberg could turn an imax theater into a 9  black and white portable tv . ","a well acted and well intentioned snoozer . ","the smug , oily demeanor that donovan adopts throughout the stupidly named pipe dream is just repulsive . ","must-see viewing for anyone involved in the high-tech industry . others may find it migraine-inducing , despite moore's attempts at whimsy and spoon feeding . ","despite its good nature and some genuinely funny moments , super troopers suffers from a bad case of arrested development . ","it's hard not to feel you've just watched a feature-length video game with some really heavy back story . ","i watched the brainless insanity of no such thing with mounting disbelief . ","this limp gender-bender-baller from a first-time director and rookie screenwriter steals wholesale from that 1982's tootsie , forgetting only to retain a single laugh . ","kwan makes the mix-and- match metaphors intriguing , while lulling us into torpor with his cultivated allergy to action . ","while obviously an extremely personal work , it remains inextricably stuck in an emotionally unavailable rut . ","any movie this boring should be required to have ushers in the theater that hand you a cup of coffee every few minutes . like a marathon runner trying to finish a race , you need a constant influx of liquid just to get through it . ","i loved looking at this movie . i just didn't care as much for the story . ","has all the poignancy of a hallmark card and all the comedy of a gallagher stand-up act . ","it doesn't do the original any particular dishonor , but neither does it exude any charm or personality . ","fear dot com is so rambling and disconnected it never builds any suspense . ","a gorgeous , somnolent show that is splendidly mummified and thoroughly unsurprising . ","a semi-autobiographical film that's so sloppily written and cast that you cannot believe anyone more central to the creation of bugsy than the caterer had anything to do with it . ","it feels like a community theater production of a great broadway play : even at its best , it will never hold a candle to the original . ","the film apparently takes place in a fantasy world where people in hotel hallways recite poetry in voice-over instead of speaking to each other . ","the element of surprise might be the only thing femme fatale has going for it . ","it's the kind of movie you can't quite recommend because it is all windup and not much of a pitch , yet you can't bring yourself to dislike it . ","maybe it's asking too much , but if a movie is truly going to inspire me , i want a little more than this . ","a graceless , witless attempt at mating some like it hot with the wwii espionage thriller . ","the story and characters are nowhere near gripping enough . ","based on a david leavitt story , the film shares that writer's usual blend of observant cleverness , too-facile coincidence and slightly noxious preciousness . ","just like every other seagal movie , only louder and without that silly ponytail . ","to enjoy this movie's sharp dialogue and delightful performance by jolie and burns , you have to gloss over the no sense ending . ","national lampoon's van wilder could be the worst thing to come out of national lampoon since class reunion","this is a great subject for a movie , but hollywood has squandered the opportunity , using it as a prop for warmed-over melodrama and the kind of choreographed mayhem that director john woo has built his career on . ","ecks this one off your must-see list . ","overall , the film misses the brilliance of jelinek's novel by some way . it settles for being merely grim . ","the irwins emerge unscathed , but the fictional footage is unconvincing and criminally badly acted . ","it's not thirsty , consuming passion which drives this movie . no , it's the repetition of said behavior , and so children of the century is more mindless love than mad , more grating and boring than anything else . ","just because it really happened to you , honey , doesn't mean that it's interesting to anyone else . ","just like the deli sandwich : lots of ham , lots of cheese , with a sickly sweet coating to disguise its excrescence until just after ( or during ) consumption of its second half . ","every so often a movie comes along that confirms one's worse fears about civilization as we know it . the new guy is one of them . ","this isn't a  friday  worth waiting for . ","everything that's worthwhile about collision course can already be seen on television . ","if this movie belonged to a sorority , it would be called beta alpha delta . ","not a cheap slasher flick , as the subject matter would suggest , but is a little like a nature film , showing a patient predator and his foolish prey . ","uneasy mishmash of styles and genres . ","herzog is obviously looking for a moral to his fable , but the notion that a strong , unified showing among germany and eastern european jews might have changed 20th-century history is undermined by ahola's inadequate performance . ","all in all , there's only one thing to root for : expulsion for everyone . ","beyond a handful of mildly amusing lines . . . there just isn't much to laugh at . ","secret ballot is too contemplative to be really funny . ","the film's center will not hold . ","myers never knows when to let a gag die ; thus , we're subjected to one mind-numbingly lengthy riff on poo and pee jokes after another . ","too lazy to take advantage of its semi-humorous premise . ","a great ending doesn't make up for a weak movie , and crazy as hell doesn't even have a great ending . ","dialogue-heavy and too cerebral for its own good -- or , at any rate , too cerebral for its racy subject matter . ","its over-reliance on genre conventions , character types and formulaic conflict resolutions crushes all the goodwill it otherwise develops . ","as an actor , the rock is aptly named . ","a mostly tired retread of several other mob tales . ","i wish i could say  thank god it's friday  , but the truth of the matter is i was glad when it was over . ","nothing about it fits . ","as it abruptly crosscuts among the five friends , it fails to lend the characters' individual stories enough dramatic resonance to make us care about them . ","somehow we're meant to buy that this doting mother would shun her kids , travel to one of the most dangerous parts of the world , don fatigues and become g . i . jane . ","the cast is so low-wattage that none of the characters comes off as big . . . and the setting remains indistinct . ","consider the title's clunk-on-the-head that suggests the overtime someone put in to come up with an irritatingly unimaginative retread concept . ","the movie quickly drags on becoming boring and predictable . i tried to read the time on my watch . ","the film makes a tragic error by going on for too long , trying to mirror every subsequent event in chinese history : war , revolution , communism , etc . ","johnson has , in his first film , set himself a task he is not nearly up to . ","ultimately the project comes across as clinical , detached , uninvolving , possibly prompting audience members to wonder , 'what's the point ? '","the two leads are almost good enough to camouflage the dopey plot , but so much naturalistic small talk , delivered in almost muffled exchanges , eventually has a lulling effect . ","the film meant well in its horse tale about freedom , but wasn't able to reach the heart because it was too overbearing . ","the movie is as far as you can get from racy , to the point where it almost stops the blood flow to your brain ; it has a dull , costumey feel . ","once the audience figure out what's being said , the filmmaker's relative passivity will make it tough for them to really care . ","there's nothing provocative about this film save for the ways in which it studiously avoids provoking thought . ","it seems just a long , convoluted ploy to get men into drag -- period drag , no less . ","the premise for this kegger comedy probably sounded brilliant four six-packs and a pitcher of margaritas in , but the film must have been written . . . in the thrall of a vicious hangover . ","even by dumb action-movie standards , ballistic : ecks vs . sever is a dumb action movie . ","the film equivalent of a toy chest whose contents get scattered over the course of 80 minutes . ","just a bloody mess . ","creepy but ultimately unsatisfying thriller . ","martin scorsese cria um espetáculo visual que não possui alma - um filme esteticamente belo , mas emocionalmente frio . ","you would be better off investing in the worthy emi recording that serves as the soundtrack , or the home video of the 1992 malfitano-domingo production . ","has something to say . . . but it is a statement and issue worthy of a much more thoughtfulness and insight than a melodramatic and wholly predictable thriller . ","bears is bad . not 'terrible filmmaking' bad , but more like , 'i once had a nightmare like this , and it's now coming true' bad . ","as is most commonly case with projects such noble and lofty ambitions , the film is less poetic than simply pretentious . ","george , hire a real director and good writers for the next installment , please . ","for a film about two mismatched buddies , crystal and de niro share little screen time and even less chemistry . ","however clever nelson has been in providing variation within the confines of her structure and staging , the question remains whether this should , indeed , have been presented as a theatrical release . ","extreme oops - oops , ops , no matter how you spell it , it's still a mistake to go see it . ","what could and should have been biting and droll is instead a tepid waste of time and talent . ","what will , most likely , turn out to be the most repellent movie of 2002 . "," . . . too dull to enjoy . ","a morality tale whose thought-provoking potential is hampered by a made-for-tv look , rigid performances and an asinine 'twist' that brazenly rips off the sixth sense . ","here's a self-congratulatory 3d imax rah-rah . ","eastwood is an icon of moviemaking , one of the best actors , directors and producers around , responsible for some excellent work . but even a hero can stumble sometimes . ","a sophomoric exploration of 'life problems' most people solved long ago -- or at least got tired of hearing people kvetch about . ","it's all very cute , though not terribly funny if you're more than six years old . ","the impact of the armenian genocide is diluted by too much stage business in the modern day . ","[u]nrelentingly stupid . ","going to the website may be just as fun ( and scary ) as going to the film . ","lacking gravitas , macdowell is a placeholder for grief , and ergo this sloppy drama is an empty vessel . leave these flowers unpicked -- they're dead on the vine . ","admirable , certainly , but not much fun to watch . for caine lovers only . ","a shambles of a movie--visually unattractive , unbearably loud and utterly silly . . . its hilarity is completely unintentional . ","de niro may enjoy the same free ride from critics afforded to clint eastwood in the lazy bloodwork . but like bruce springsteen's gone-to-pot asbury park , new jersey , this sad-sack waste of a movie is a city of ruins . ","no , it's not nearly as good as any of its influences . ","a reasonably efficient mechanism , but it offers few surprises and finds its stars slumming in territory they should have avoided . ","the rest of the plot is impossible to explain without blowing whatever tension there is , although it's more comedy than suspense de palma creates . ","human nature talks the talk , but it fails to walk the silly walk that distinguishes the merely quirky from the surreal . ","city by the sea is the cinematic equivalent of defensive driving : it's careful , conscientious and makes no major mistakes . but what saves lives on the freeway does not necessarily make for persuasive viewing . ","the marquis de sade couldn't have been as dull a person as this film makes him out to be . ","what could have been a neat little story about believing in yourself is swamped by heavy-handed melodrama . ","the cast is uniformly excellent . . . but the film itself is merely mildly charming . ","drives for the same kind of bittersweet , conciliatory tone that three seasons achieved but loses its way in rhetorical excess and blatant sentimentality . ","a bigger holiday downer than your end-of-year 401 ( k ) statement . ","the whole thing plays out with the drowsy heaviness of synchronized swimmer wearing a wool wetsuit . ","fairly successful at faking some pretty cool stunts but a complete failure at trying to create some pretty cool characters . and forget about any attempt at a plot ! ","it will probably prove interesting to ram dass fans , but to others it may feel like a parody of the mellow , peace-and-love side of the '60s counterculture . ","take away all the cliches and the carbon copy scenes from every drug movie we've seen and all you have left are john leguizamo's cool jackets . ","it's so full of wrong choices that all you can do is shake your head in disbelief -- and worry about what classic oliver parker intends to mangle next time . ","showtime is closer to slowtime . ","it may be an easy swipe to take , but this barbershop just doesn't make the cut . ","the weight of water uses water as a metaphor for subconscious desire , but this leaky script barely stays afloat . ","'how many more voyages can this limping but dearly-loved franchise survive ? '","despite a blue-chip cast and a provocative title , writer-director peter mattei's first feature microwaves dull leftover romantic motifs basted in faux-contemporary gravy . ","fans of the tv series will be disappointed , and everyone else will be slightly bored . ","the only element of suspense is whether the movie will change titles or distributors again before the closing credits roll . ","barely goes beyond comic book status . ","it's disappointing when filmmakers throw a few big-name actors and cameos at a hokey script . ","i spy is an embarrassment , a monotonous , disjointed jumble of borrowed plot points and situations . it's as flat as an open can of pop left sitting in the sun . ","an eccentric little comic/thriller deeply in love with its own quirky personality . ","afraid to pitch into farce , yet only half-hearted in its spy mechanics , all the queen's men is finally just one long drag . ","painfully padded . ","maybe it's the star power of the cast or the redundant messages , but something aboul  full frontal  seems , well , contrived . ","[morgan] , judd and franklin can't save the script , rooted in a novel by joseph finder , from some opportunism . ","the movie is obviously a labour of love so howard appears to have had free rein to be as pretentious as he wanted . ","passably entertaining but also mechanical and joyless . ","safe conduct , however ambitious and well-intentioned , fails to hit the entertainment bull's-eye . ","my response to the film is best described as lukewarm . maybe i found the proceedings a little bit too conventional . ","too timid to bring a sense of closure to an ugly chapter of the twentieth century . ","it's push-the-limits teen comedy , the type written by people who can't come up with legitimate funny , and it's used so extensively that good bits are hopelessly overshadowed . ","it's too long , too repetitive , and takes way too many years to resolve to be a total winner . ","a sudsy cautionary tale . ","a movie that tries to fuse the two 'woods' but winds up a bolly-holly masala mess . ","mr . wedge and mr . saldanha handle the mix of verbal jokes and slapstick well . their film falters , however , in its adherence to the disney philosophy of required poignancy , a salute that i'd hoped the movie would avoid . ","leaves you with a knot in your stomach , its power is undercut by its own head-banging obviousness . ","watching it is rather like an overlong visit from a large group of your relatives . as your relatives swap one mundane story after another , you begin to wonder if they are ever going to depart . ","unfortunately , as a writer , mr . montias isn't nearly as good to his crew as he is as a director or actor . ","on the right track to something that's creepy and effective . . . it's just going to take more than a man in a bullwinkle costume to get there . ","the only thing that could possibly make them less interesting than they already are is for them to get full montied into a scrappy , jovial team . ","one of those movies where you walk out of the theater not feeling cheated exactly , but feeling pandered to , which , in the end , might be all the more infuriating . "," . . . this movie has a glossy coat of action movie excess while remaining heartless at its core . ","murder by numbers is like a couple of mediocre tv-movie -of-the-week films clumsily stuck together . ","the film is surprisingly well-directed by brett ratner , who keeps things moving well -- at least until the problematic third act . ","warmed-over tarantino by way of wannabe elmore leonard . ","[sen's] soap opera-ish approach undermines his good intentions . ","showtime is one of the hapless victims of the arrogant  if we put together a wry white man and a chatty black man and give them guns , the movie will be funny  syndrome . ","sushi for the connoisseurs of the macabre . ","don't waste your money . ","though certainly original in form , altar boys requires a taste for swamp thing-type animation , doubled with a deafening score . ","there aren't many laughs in this interesting study of the cultural mores of georgian jews in tel aviv . ","there's not enough to sustain the comedy . ","like those to rome , all roads in the banger sisters inevitably lead to a joke about hawn's breasts , which constantly threaten to upstage the woman sporting them . ","we may get the full visceral impact of a ruthless army on the warpath but no sense of the devilish complexity of the balkans conflict . ","you're better off staying home and watching the x-files . ","chaotic , self-indulgent and remarkably ugly to look at , it's . . . like a series of pretentiously awful student films strung together into one feature-length horror . ","bears resemblance to , and shares the weaknesses of , too many recent action-fantasy extravaganzas in which special effects overpower cogent story-telling and visual clarity during the big action sequences . ","this is the type of movie best enjoyed by frat boys and college kids while sucking on the bong and downing one alcoholic beverage after another . ","friday after next has the same problem that next friday did -- it's called where's chris tucker when you need him ? ","this film is full of rabbits . brimful . but like most rabbits , it seems to lack substance . ","i weep for the future when a good portion of the respected critical community in this country consider blue crush to be an intelligent film about young women . ","i kept wishing i was watching a documentary about the wartime navajos and what they accomplished instead of all this specious hollywood hoo-ha . ","no number of fantastic sets , extras , costumes and spectacular locales can disguise the emptiness at the center of the story . ","a movie far more cynical and lazy than anything a fictitious charlie kaufman might object to . ","could the country bears really be as bad as its trailers ? in a word -- yes . ","if high crimes were any more generic it would have a universal product code instead of a title . ","reggio falls victim to relying on the very digital technology that he fervently scorns , creating a meandering , inarticulate and ultimately disappointing film . ","the movie makes absolutely no sense . its underlying mythology is a hodgepodge of inconsistencies that pose the question : since when did dumb entertainment have to be this dumb ? ","the problem with this film is that it's forced to make its characters idiots in order to advance the plot . had anyone here done anything remotely intelligent , we all could have stopped watching long ago . ","despite the authenticity of the trappings , the film is overblown in its plotting , hackneyed in its dialogue and anachronistic in its style . ","murder and mayhem of this sort quickly becomes monotonous . ","the journey toward redemption feels more like a cinematic experiment than a full-blown movie . ","that zhang would make such a strainingly cute film -- with a blind orphan at its center , no less -- indicates where his ambitions have wandered . ","the gantzes' interviews tend to let the guys off the hook . ","the streets , shot by cinematographer michael ballhaus , may be as authentic as they are mean , but it is nearly impossible to care about what happens on them . ","this is a good movie in spurts , but when it doesn't work , it's at important times . ","parker probably thinks he's shaking up a classic the way kenneth branagh and baz luhrmann have , but this half-hearted messing-about just makes us miss wilde's still-contemporary play . ","flotsam in the sea of moviemaking , not big enough for us to worry about it causing significant harm and not smelly enough to bother despising . ","a tv episode inflated past its natural length . ","involving at times , but lapses quite casually into the absurd . ","all these developments and challenges facing santa weigh down the plot so heavily that they drain all the film of its energy and needlessly strain credibility . ","anemic , pretentious . ","there are weird resonances between actor and role here , and they're not exactly flattering . ","the unceasing sadism is so graphically excessive , the director just ends up exposing his own obsession . ","the story . . . is moldy and obvious . ","it's drained of life in an attempt to be sober and educational , and yet it's so devoid of realism that its lack of whistles and bells just makes it obnoxious and stiff . ","suffocated at conception by its munchausen-by-proxy mum . punish the vehicle to adore the star . ","even if britney spears is really cute , her movie is really bad . ","big fat liar is just futile silliness looking to tap into the kiddie sensibilities . ","usually when i get this much syrup , i like pancakes to go with it . ","all the necessary exposition prevents the picture from rising above your generic sand 'n' sandal adventure . ","glib , satirical documentary that fudges facts , makes facile points and engages in the cinematic equivalent of tabloid journalism . ","gangs of new york is an unapologetic mess , whose only saving grace is that it ends by blowing just about everything up . ","an overblown clunker full of bad jokes , howling cliches and by-the-numbers action sequences . ","without a strong script and energetic acting , dogma films can produce the same sleep-inducing effects as watching your neighbor's home videos . ","a mild , reluctant , thumbs down . ","strong setup and ambitious goals fade as the film descends into unsophisticated scare tactics and b-film thuggery . ","schindler's list it ain't . ","a cinematic sleeping pill of impressive potency . ","it's an awfully derivative story . ","the movie barely makes sense , with its unbelievable naïveté and arbitrary flashbacks . ","it's an earnest debut full of heartfelt performances , but is ultimately let down by a story that is all too predictable . ","about as cutting-edge as pet rock : the movie . ","with generic sets and b-grade special effects , jason is about as convincing on the sci-fi front as tv's defunct cleopatra 2525 . ","not sweet enough to liven up its predictable story and will leave even fans of hip-hop sorely disappointed . ","winds up feeling like lots of other quirky movies that try to score hipness points with young adults . ","oft-described as the antidote to american pie-type sex comedies , it actually has a bundle in common with them , as the film diffuses every opportunity for a breakthrough","the pacing is glacial , the screenplay is stiff as a board , and things heat up only in the movie's final scenes . ","the premise is overshadowed by the uberviolence of the clericks as this becomes just another kung-fu sci-fi movie with silly action sequences . ","with its hints of a greater intelligence lurking somewhere , the ring makes its stupidity more than obvious . it's painful . ","pumpkin struts about with  courage  pinned to its huckster lapel while a yellow streak a mile wide decorates its back . ","an uneven film dealing with too many problems to be taken seriously . ","sheridan . . . smoothes over sources of conflict that could have lent the film a bit more depth . ","an atonal estrogen opera that demonizes feminism while gifting the most sympathetic male of the piece with a nice vomit bath at his wedding . ","half of it is composed of snappy patter and pseudo-sophisticated cultural observations , while the remainder . . . would be more at home on a daytime television serial . ","writer/director john mckay ignites some charming chemistry between kate and jed but , when he veers into sodden melodrama , punctuated by violins , it's disastrous and kate's jealous female friends become downright despicable . ","[newton]wanders through charlie completely unaware she needs to show some presence and star quality . ","unfortunately , the picture failed to capture me . i found it slow , drab , and bordering on melodramatic . ","a lousy movie that's not merely unwatchable , but also unlistenable . ","the best way to hope for any chance of enjoying this film is by lowering your expectations . then lower them a bit more . ","when not obscured by the booming bass-heavy soundtrack , the conversation presents the kind of linguistic fumbling not heard since macy gray's game of chinese whispers with mr bean . ","cliches are as thick as the cigarette smoke . ","a woozy , roisterous , exhausting mess , and the off-beat casting of its two leads turns out to be as ill-starred as you might expect . ","'abandon all hope , ye who enter here' . . . you should definitely let dante's gloomy words be your guide . ","what begins as a seemingly brainless , bubbly romantic comedy becomes a cliche-drenched melodrama by mid-film and , by film's end , a feminist action fantasy . ","a grim , flat and boring werewolf movie that refuses to develop an energy level . ","birot's directorial debut ( she co-wrote the script with christophe honoré ) isn't so much bad as it is bland . ","watching the film is like reading a times portrait of grief that keeps shifting focus to the journalist who wrote it . ","enough similarities to gymkata and howie long's firestorm that my fingernails instinctively crawled towards my long-suffering eyeballs . ","succeeds in providing a disquiet world the long-dreaded completion of the police academy series . ","christians sensitive to a reductionist view of their lord as a luv-spreading dr . feelgood or omnipotent slacker will feel vastly more affronted than secularists , who might even praise god for delivering such an instant camp classic . ","if this dud had been made in the '70s , it would have been called the hills have antlers and played for about three weeks in drive-ins . ","a frantic search for laughs , with a hit-to-miss ratio that doesn't exactly favour the audience . ","like a documentary version of fight club , shorn of social insight , intellectual pretension and cinematic interest . ","  an entire film about researchers quietly reading dusty old letters .  ","pryor lite , with half the demons , half the daring , much less talent , many fewer laughs . ","what's at stake in this film is nothing more than an obsolete , if irritating , notion of class . ","the stories here suffer from the chosen format . ","while the mystery surrounding the nature of the boat's malediction remains intriguing enough to sustain mild interest , the picture refuses to offer much accompanying sustenance in the way of characterization , humor or plain old popcorn fun . ","just how extreme are these ops ? i regret to report that these ops are just not extreme enough . ","the actors are forced to grapple with hazy motivations that never come into focus . ","john leguizamo may be a dramatic actor -- just not in this movie . ","the sequel has turned completely and irrevocably bizarre to the point of utter nonsense . ","hardly makes the kind of points egoyan wanted to make , nor does it exist as the kind of monument he wanted to build , to victims whose voices have never gained the ears of the world . ","build some robots , haul 'em to the theatre with you for the late show , and put on your own mystery science theatre 3000 tribute to what is almost certainly going to go down as the worst -- and only -- killer website movie of this or any other year . ","rainy days and movies about the disintegration of families always get me down . "," . . . has about 3/4th the fun of its spry 2001 predecessor — but it's a rushed , slapdash , sequel-for-the-sake- of-a-sequel with less than half the plot and ingenuity . ","a incompetência de marcus adams como roteirista só é superada por sua péssima direção . ","the master of disaster - it's a piece of dreck disguised as comedy . ","this isn't a movie ; it's a symptom . ","the film has a few cute ideas and several modest chuckles but it isn't exactly kiddie-friendly… alas , santa is more ho-hum than ho-ho-ho and the snowman ( who never gets to play that flute ) has all the charm of a meltdown . ","the stupidest , most insulting movie of 2002's first quarter . ","it's so underwritten that you can't figure out just where the other characters , including ana's father and grandfather , come down on the issue of ana's future . ","a film so tedious that it is impossible to care whether that boast is true or not . ","none of this violates the letter of behan's book , but missing is its spirit , its ribald , full-throated humor . ","bad company leaves a bad taste , not only because of its bad-luck timing , but also the staleness of its script . ","even if it ultimately disappoints , the picture does have about a matinee admission's worth of funny to keep it afloat . ","fails to bring as much to the table . ","a film made with as little wit , interest , and professionalism as artistically possible for a slummy hollywood caper flick . ","disturbingly superficial in its approach to the material . ","if you're not the target demographic . . . this movie is one long chick-flick slog . ","i hate this movie","it's tough to tell which is in more abundant supply in this woefully hackneyed movie , directed by scott kalvert , about street gangs and turf wars in 1958 brooklyn -- stale cliches , gratuitous violence , or empty machismo . ","gooding and coburn are both oscar winners , a fact which , as you watch them clumsily mugging their way through snow dogs , seems inconceivable . ","at every opportunity to do something clever , the film goes right over the edge and kills every sense of believability . . . all you have left is a no-surprise series of explosions and violence while banderas looks like he's not trying to laugh at how bad it"," . . . pitiful , slapdash disaster . a doa dud from frame one . ","jaw-droppingly superficial , straining to get by on humor that is not even as daring as john ritter's glory days on three's company . ","there are plenty of scenes in frida that do work , but rarely do they involve the title character herself . ","although god is great addresses interesting matters of identity and heritage , it's hard to shake the feeling that it was intended to be a different kind of film . ","the dark and bittersweet twist feels strange as things turn nasty and tragic during the final third of the film . first-timer john mckay is never able to pull it back on course . ","distances you by throwing out so many red herrings , so many false scares , that the genuine ones barely register . ","godard uses his characters -- if that's not too glorified a term -- as art things , mouthpieces , visual motifs , blanks . ","the movie generates plot points with a degree of randomness usually achieved only by lottery drawing . ","a predictable , manipulative stinker . the story passes time until it's time for an absurd finale of twisted metal , fireballs and revenge . ","eastwood winces , clutches his chest and gasps for breath . it's a spectacular performance - ahem , we hope it's only acting . ","the movie suffers from two fatal ailments -- a dearth of vitality and a story that's shapeless and uninflected . ","it's just weirdness for the sake of weirdness , and where human nature should be ingratiating , it's just grating . ","an ambitiously naturalistic , albeit half-baked , drama about an abused , inner-city autistic teen . ","once she lets her love depraved leads meet , [denis'] story becomes a hopeless , unsatisfying muddle","the dose is strong and funny , for the first 15 minutes anyway ; after that , the potency wanes dramatically . ","the people in abc africa are treated as docile , mostly wordless ethnographic extras . ","what's really sad is to see two academy award winning actresses ( and one academy award winning actor ) succumb to appearing in this junk that's tv sitcom material at best . ","no doubt the star and everyone else involved had their hearts in the right place . where their heads were is anyone's guess . ","call me a cynic , but there's something awfully deadly about any movie with a life-affirming message . ","a gratingly unfunny groaner littered with zero-dimensional , unlikable characters and hackneyed , threadbare comic setups . ","got some good , organic character work , lots of obvious political insights and little room for engaging , imaginative filmmaking in its nearly 2 1/2-hour , dissipated length . ","a painfully slow cliche-ridden film filled with more holes than clyde barrow's car . ","like leafing through an album of photos accompanied by the sketchiest of captions . ","i guess it just goes to show that if you give a filmmaker an unlimited amount of phony blood , nothing good can happen . ","gaghan captures the half-lit , sometimes creepy intimacy of college dorm rooms , a subtlety that makes the silly , over-the-top coda especially disappointing . ","feels less like a change in [herzog's] personal policy than a half-hearted fluke . ","one of the most unpleasant things the studio has ever produced . ","will anyone who isn't a fangoria subscriber be excited that it hasn't gone straight to video ? ","a selection of scenes in search of a movie . ","[janey] forgets about her other obligations , leading to a tragedy which is somehow guessable from the first few minutes , maybe because it echoes the by now intolerable morbidity of so many recent movies . ","will undoubtedly play well in european markets , where mr . besson is a brand name , and in asia , where ms . shu is an institution , but american audiences will probably find it familiar and insufficiently cathartic . ","true to its animatronic roots : . . . as stiff , ponderous and charmless as a mechanical apparatus . . . 'the country bears' should never have been brought out of hibernation . ","[evans is] a fascinating character , and deserves a better vehicle than this facetious smirk of a movie . ","the script's judgment and sense of weight is way , way off . ","you come away wishing , though , that the movie spent a lot less time trying to make a credible case for reports from the afterlife and a lot more time on the romantic urgency that's at the center of the story . ","evelyn may be based on a true and historically significant story , but the filmmakers have made every effort to disguise it as an unimaginative screenwriter's invention . ","a derivative collection of horror and sci-fi cliches . ","loosely speaking , we're in all of me territory again , and , strictly speaking , schneider is no steve martin . ","as aimless as an old pickup skidding completely out of control on a long patch of black ice , the movie makes two hours feel like four . ","limps along on a squirm-inducing fish-out-of-water formula that goes nowhere and goes there very , very slowly . ","just the sort of lazy tearjerker that gives movies about ordinary folk a bad name . ","the redeeming feature of chan's films has always been the action , but the stunts in the tuxedo seem tired and , what's worse , routine . ","while the importance of being earnest offers opportunities for occasional smiles and chuckles , it doesn't give us a reason to be in the theater beyond wilde's wit and the actors' performances . ","has all the scenic appeal of a cesspool . ","a rambling ensemble piece with loosely connected characters and plots that never quite gel . ","a lifetime movie about men . ","the balkans provide the obstacle course for the love of a good woman . ","it's hard to say who might enjoy this , are there tolstoy groupies out there ? it's dark and tragic , and lets the business of the greedy talent agents get in the way of saying something meaningful about facing death","this is a movie that starts out like heathers , then becomes bring it on , then becomes unwatchable . ","the screenplay flounders under the weight of too many story lines . ","i think it was plato who said , 'i think , therefore i know better than to rush to the theatre for this one . '","if damon and affleck attempt another project greenlight , next time out they might try paying less attention to the miniseries and more attention to the film it is about . ","this is rote drivel aimed at mom and dad's wallet . ","contrived , maudlin and cliche-ridden . . . if this sappy script was the best the contest received , those rejected must have been astronomically bad . ","i hate the feeling of having been slimed in the name of high art . ","this is more a case of 'sacre bleu ! ' than 'magnifique' . ","the kids in the audience at the preview screening seemed bored , cheering the pratfalls but little else ; their parents , wise folks that they are , read books . ","whether jason x is this bad on purpose is never clear . but one thing's for sure : it never comes close to being either funny or scary . ","yet another weepy southern bore-athon . ","i like all four of the lead actors a lot and they manage to squeeze a few laughs out of the material , but they're treading water at best in this forgettable effort . ","perhaps the most annoying thing about who is cletis tout ? is that it's a crime movie made by someone who obviously knows nothing about crime . ","except as an acting exercise or an exceptionally dark joke , you wonder what anyone saw in this film that allowed it to get made . ","this insufferable movie is meant to make you think about existential suffering . instead , it'll only put you to sleep . ","who is this movie for ? not kids , who don't need the lesson in repugnance . it's also not smart or barbed enough for older viewers -- not everyone thinks poo-poo jokes are 'edgy . '","a sleep-inducingly slow-paced crime drama with clumsy dialogue , heavy-handed phoney-feeling sentiment , and an overly-familiar set of plot devices . ","it's so tedious that it makes you forgive every fake , dishonest , entertaining and , ultimately , more perceptive moment in bridget jones's diary . ","almost as offensive as  freddy got fingered .  ","the gifted crudup has the perfect face to play a handsome blank yearning to find himself , and his cipherlike personality and bad behavior would play fine if the movie knew what to do with him . ","it is depressing , ruthlessly pained and depraved , the movie equivalent of staring into an open wound . ","ponderous , plodding soap opera disguised as a feature film . ","cold , pretentious , thoroughly dislikable study in sociopathy . ","for the future , one hopes mr . plympton will find room for one more member of his little band , a professional screenwriter . ","a cheap scam put together by some cynical creeps at revolution studios and imagine entertainment to make the suckers out there surrender $9 and 93 minutes of unrecoverable life . ","reign of fire never comes close to recovering from its demented premise , but it does sustain an enjoyable level of ridiculousness . ","human nature is a goofball movie , in the way that malkovich was , but it tries too hard . ","originality is sorely lacking . ","the plot's clearly mythic structure may owe more to disney's strong sense of formula than to the original story . but while the highly predictable narrative falls short , treasure planet is truly gorgeous to behold . ","though there are entertaining and audacious moments , the movie's wildly careening tone and an extremely flat lead performance do little to salvage this filmmaker's flailing reputation . ","ram dass fierce grace moulds itself as an example to up-and-coming documentarians , of the overlooked pitfalls of such an endeavour . ","lucky break is perfectly inoffensive and harmless , but it's also drab and inert . ","for a story set at sea , ghost ship is pretty landbound , with its leaden acting , dull exposition and telegraphed 'surprises . '","there might be some sort of credible gender-provoking philosophy submerged here , but who the hell cares ? ","what we have is a character faced with the possibility that her life is meaningless , vapid and devoid of substance , in a movie that is definitely meaningless , vapid and devoid of substance . ","nothing more than a stifling morality tale dressed up in peekaboo clothing . ","i like my christmas movies with more elves and snow and less pimps and ho's . ","it all seemed wasted like deniro's once promising career and the once grand long beach boardwalk . ","[i]t's certainly laudable that the movie deals with hot-button issues in a comedic context , but barbershop isn't as funny as it should be . ","unfortunately , a cast of competent performers from movies , television and the theater are cast adrift in various new york city locations with no unifying rhythm or visual style . ","just entertaining enough not to hate , too mediocre to love . ","'sophisticated' viewers who refuse to admit that they don't like it will likely call it 'challenging' to their fellow sophisticates . ","equilibrium the movie , as opposed to the manifesto , is really , really stupid . ","excruciatingly unfunny and pitifully unromantic . ","the film's thoroughly recycled plot and tiresome jokes . . . drag the movie down . ","it doesn't offer audiences any way of gripping what its point is , or even its attitude toward its subject . ","this kiddie-oriented stinker is so bad that i even caught the gum stuck under my seat trying to sneak out of the theater","though impostor deviously adopts the guise of a modern motion picture , it too is a bomb . ","cox offers plenty of glimpses at existing photos , but there are no movies of nijinsky , so instead the director treats us to an aimless hodgepodge . ","every note rings false . ","when the screenwriter responsible for one of the worst movies of one year directs an equally miserable film the following year , you'd have a hard time believing it was just coincidence . ","it never rises to its clever what-if concept . ","admirably ambitious but self-indulgent . ","this story of unrequited love doesn't sustain interest beyond the first half-hour . ","this angst-ridden territory was covered earlier and much better in ordinary people . ","the entire film is one big excuse to play one lewd scene after another . about half of them are funny , a few are sexy and none are useful in telling the story , which is paper-thin and decidedly unoriginal . ","a big , loud , bang-the-drum bore . ","grating and tedious . ","[less a movie than] an appalling , odoriferous thing . . . so rotten in almost every single facet of production that you'll want to crawl up your own * * * in embarrassment . ","the concept behind kung pow : enter the fist is hilarious . it's too bad nothing else is . ","hardman is a grating , mannered onscreen presence , which is especially unfortunate in light of the fine work done by most of the rest of her cast . ","el crimen del padre amaro would likely be most effective if used as a tool to rally anti-catholic protestors . ","interesting and thoroughly unfaithful version of carmen","a serious movie with serious ideas . but seriously , folks , it doesn't work . ","there's nothing exactly wrong here , but there's not nearly enough that's right . ","the action here is unusually tame , the characters are too simplistic to maintain interest , and the plot offers few surprises . ","i couldn't help but feel the wasted potential of this slapstick comedy . ","what madonna does here can't properly be called acting -- more accurately , it's moving and it's talking and it's occasionally gesturing , sometimes all at once . ","[a] painfully flat gross-out comedy . . . ","even if you're an elvis person , you won't find anything to get excited about on this dvd . ","the movie certainly has its share of clever moments and biting dialogue , but there's just not much lurking below its abstract surface . ","it's bedeviled by labored writing and slack direction . ","i'm sure there's a teenage boy out there somewhere who's dying for this kind of entertainment . ","the tuxedo miscalculates badly by forcing the star to play second fiddle to the dull effects that allow the suit to come to life . ","the film is a confusing melange of tones and styles , one moment a romantic trifle and the next a turgid drama . ","obviously , a lot of people wasted a lot of their time ( including mine ) on something very inconsequential . ","there's a little violence and lots of sex in a bid to hold our attention , but it grows monotonous after a while , as do joan and philip's repetitive arguments , schemes and treachery . ","it drowns in sap . ","deliberately and devotedly constructed , far from heaven is too picture postcard perfect , too neat and new pin-like , too obviously a recreation to resonate . ","it's rare that a movie can be as intelligent as this one is in every regard except its storyline ; everything that's good is ultimately scuttled by a plot that's just too boring and obvious . ","i'm giving it thumbs down due to the endlessly repetitive scenes of embarrassment . there's got to be a more graceful way of portraying the devastation of this disease . ","the good thing -- the only good thing -- about extreme ops is that it's so inane that it gave me plenty of time to ponder my thanksgiving to-do list . ","the modern-day characters are nowhere near as vivid as the 19th-century ones . ","blessed with a searing lead performance by ryan gosling ( murder by numbers ) , the movie is powerful and provocative . it's also built on a faulty premise , one it follows into melodrama and silliness . ","uneven performances and a spotty script add up to a biting satire that has no teeth . ","director jay russell stomps in hobnail boots over natalie babbitt's gentle , endearing 1975 children's novel . ","benigni's pinocchio is extremely straight and mind-numbingly stilted , its episodic pacing keeping the film from developing any storytelling flow . ","the troubling thing about clockstoppers is that it doesn't make any sense . ","with its paint fights , motorized scooter chases and dewy-eyed sentiment , it's a pretty listless collection of kid-movie clichés . ","mostly the film is just hectic and homiletic : two parts exhausting men in black mayhem to one part family values . ","kicks off with an inauspicious premise , mopes through a dreary tract of virtually plotless meanderings and then ends with a whimper . ","a rote exercise in both animation and storytelling . ","the material and the production itself are little more than routine . ","the movie's major and most devastating flaw is its reliance on formula , though , and it's quite enough to lessen the overall impact the movie could have had . ","not even steven spielberg has dreamed up such blatant and sickening product placement in a movie . ","it's all surface psychodramatics . ","the mothman prophecies , which is mostly a bore , seems to exist only for its climactic setpiece . ","that frenetic spectacle [on the tv show] has usually been leavened by a charm that's conspicuously missing from the girls' big-screen blowout . ","kitschy , flashy , overlong soap opera . ","for all the time we spend with these people , we never really get inside of them . ","yet another arnold vehicle that fails to make adequate use of his particular talents . ","sandra bullock , despite downplaying her good looks , carries a little too much ain't- she-cute baggage into her lead role as a troubled and determined homicide cop to quite pull off the heavy stuff . ","an undistinguished attempt to make a classic theater piece cinematic . ","too many scenarios in which the hero might have an opportunity to triumphantly sermonize , and too few that allow us to wonder for ourselves if things will turn out okay . ","there is simply not enough of interest onscreen to sustain its seventy-minute running time . ","a wordy wisp of a comedy . ","broomfield's style of journalism is hardly journalism at all , and even those with an avid interest in the subject will grow impatient . ","[seagal's] strenuous attempt at a change in expression could very well clinch him this year's razzie . ","has the disjointed feel of a bunch of strung-together tv episodes . ","a series of escapades demonstrating the adage that what is good for the goose is also good for the gander , some of which occasionally amuses but none of which amounts to much of a story . ","ozpetek offers an aids subtext , skims over the realities of gay sex , and presents yet another tired old vision of the gay community as an all-inclusive world where uptight , middle class bores like antonia can feel good about themselves . ","a dopey movie clothed in excess layers of hipness . ","the sweetest thing is expressly for idiots who don't care what kind of sewage they shovel into their mental gullets to simulate sustenance . ","sinks so low in a poorly played game of absurd plot twists , idiotic court maneuvers and stupid characters that even freeman can't save it . ","i realized that no matter how fantastic reign of fire looked , its story was making no sense at all . ","it made me realize that we really haven't had a good cheesy b-movie playing in theaters since . . . well . . . since last week's reign of fire . ","some movies were made for the big screen , some for the small screen , and some , like ballistic : ecks vs . sever , were made for the palm screen . ","sc2 is an autopilot hollywood concoction lacking in imagination and authentic christmas spirit , yet it's geared toward an audience full of masters of both . ","after all the big build-up , the payoff for the audience , as well as the characters , is messy , murky , unsatisfying . ","seems content to dog-paddle in the mediocre end of the pool , and it's a sad , sick sight . ","it's refreshing that someone understands the need for the bad boy ; diesel , with his brawny frame and cool , composed delivery , fits the bill perfectly . ","if all of eight legged freaks was as entertaining as the final hour , i would have no problem giving it an unqualified recommendation . ","suffers from a flat script and a low budget . ","there are deeply religious and spiritual people in this world who would argue that entering a church , synagogue or temple doesn't mean you have to check your brain at the door . the same should go for movie theaters . ","seemingly a vehicle to showcase the canadian's inane ramblings , stealing harvard is a smorgasbord of soliloquies about nothing delivered by the former mr . drew barrymore . ","the film tries to touch on spousal abuse but veers off course and becomes just another revenge film . ","as it stands it's an opera movie for the buffs . ","la cinta comienza intentando ser un drama , rápidamente se transforma en una comedia y termina por ser una parodia absolutamente predecible","this franchise has not spawned a single good film . the crap continues . ","if only it were , well , funnier . ","its inescapable absurdities are tantamount to insulting the intelligence of anyone who hasn't been living under a rock ( since sept . 11 ) . ","high drama , disney-style - a wing and a prayer and a hunky has-been pursuing his castle in the sky . ","like its script , which nurses plot holes gaping enough to pilot an entire olympic swim team through , the characters in swimfan seem motivated by nothing short of dull , brain-deadening hangover . ","one big blustery movie where nothing really happens . when it comes out on video , then it's the perfect cure for insomnia . ","like a comedian who starts off promisingly but then proceeds to flop , comedian runs out of steam after a half hour . ","the pairing does sound promising in theory . . . but their lack of chemistry makes eddie murphy and robert deniro in showtime look like old , familiar vaudeville partners . ","director chris eyre is going through the paces again with his usual high melodramatic style of filmmaking . ","as it stands , there's some fine sex onscreen , and some tense arguing , but not a whole lot more . ","i could just feel the screenwriter at every moment 'tap , tap , tap , tap , tapping away' on this screenplay . ","the picture doesn't know it's a comedy . ","a stupid , derivative horror film that substitutes extreme gore for suspense . ","the rollerball sequences feel sanitised and stagey . ","roman polanski directs the pianist like a surgeon mends a broken heart ; very meticulously but without any passion . ","nothing more than a run-of-the-mill action flick . ","lan yu is certainly a serviceable melodrama , but it doesn't even try for the greatness that happy together shoots for ( and misses ) . ","this is an action movie with an action icon who's been all but decommissioned . ","even if it is generally amusing from time to time , i spy has all the same problems the majority of action comedies have . ","much like robin williams , death to smoochy has already reached its expiration date . ","an annoying orgy of excess and exploitation that has no point and goes nowhere . ","a tired , unnecessary retread . . . a stale copy of a picture that wasn't all that great to begin with . ","an often unfunny romp . ","a worthy idea , but the uninspired scripts , acting and direction never rise above the level of an after-school tv special . ","twenty years later , reggio still knows how to make a point with poetic imagery , but his ability to startle has been stifled by the very prevalence of the fast-forward technology that he so stringently takes to task . ","it bites hard . ","ear-splitting exercise in formula crash-and-bash action . ","we have an actor who is great fun to watch performing in a film that is only mildly diverting . ","despite hoffman's best efforts , wilson remains a silent , lumpish cipher ; his encounters reveal nothing about who he is or who he was before . ","there's a thin line between likably old-fashioned and fuddy-duddy , and the count of monte cristo . . . never quite settles on either side . ","the emotional overload of female angst irreparably drags the film down . ","schaefer's . . . determination to inject farcical raunch . . . drowns out the promise of the romantic angle . ","like showgirls and glitter , the most entertaining moments here are unintentional . ","while some of the camera work is interesting , the film's mid-to-low budget is betrayed by the surprisingly shoddy makeup work . ","the origin story is well told , and the characters will not disappoint anyone who values the original comic books . it's in the action scenes that things fall apart . ","impostor is a step down for director gary fleder . ","seagal , who looks more like danny aiello these days , mumbles his way through the movie . ","the movie is a negligible work of manipulation , an exploitation piece doing its usual worst to guilt-trip parents . ","lacks dramatic punch and depth . ","there are moments of real pleasure to be found in sara sugarman's whimsical comedy very annie-mary but not enough to sustain the film . ","i can analyze this movie in three words : thumbs friggin' down . ","sadly , 'garth' hasn't progressed as nicely as 'wayne . '","make like the title and dodge this one . ","this is not one of the movies you'd want to watch if you only had a week to live . ","the first hour is tedious though ford and neeson capably hold our interest , but its just not a thrilling movie . ","here's a case of two actors who do everything humanly possible to create characters who are sweet and believable , and are defeated by a screenplay that forces them into bizarre , implausible behavior . ","it's obvious [je-gyu is] trying for poetry ; what he gets instead has all the lyricism of a limerick scrawled in a public restroom . ","sweet home alabama is one dumb movie , but its stupidity is so relentlessly harmless that it almost wins you over in the end . ","[green is] the comedy equivalent of saddam hussein , and i'm just about ready to go to the u . n . and ask permission for a preemptive strike . ","no amount of good acting is enough to save oleander's uninspired story . ","a vile , incoherent mess . . . a scummy ripoff of david cronenberg's brilliant 'videodrome . '","murphy and wilson actually make a pretty good team . . . but the project surrounding them is distressingly rote . ","despite its raucous intent , xxx is as conventional as a nike ad and as rebellious as spring break . ","think the lion king redone for horses , with fewer deliberate laughs , more inadvertent ones and stunningly trite songs by bryan adams , the world's most generic rock star . ","it is one more celluloid testimonial to the cruelties experienced by southern blacks as distilled through a caucasian perspective . ","it's tough being a black man in america , especially when the man has taken away your car , your work-hours and denied you health insurance . ","a small fortune in salaries and stunt cars might have been saved if the director , tom dey , had spliced together bits and pieces of midnight run and 48 hours ( and , for that matter , shrek ) . ","an amateurish , quasi-improvised acting exercise shot on ugly digital video . ","the holes in this film remain agape -- holes punched through by an inconsistent , meandering , and sometimes dry plot . ","would benigni's italian pinocchio have been any easier to sit through than this hastily dubbed disaster ? ","unofficially , national lampoon's van wilder is son of animal house . officially , it is twice as bestial but half as funny . ","this is a fragmented film , once a good idea that was followed by the bad idea to turn it into a movie . ","mindless yet impressively lean spinoff of last summer's bloated effects fest the mummy returns . ","halfway through the movie , the humor dwindles . it's replaced by some dramatic scenes that are jarring and deeply out of place in what could have ( and probably should have ) been a lighthearted comedy . ","will be far more interesting to the soderbergh faithful than it will be to the casual moviegoer who might be lured in by julia roberts . . . ","authentic , and at times endearing , humorous , spooky , educational , but at other times as bland as a block of snow . ","[a] mess . ","control-alt-delete simone as quickly as possible","follows the original film virtually scene for scene and yet manages to bleed it almost completely dry of humor , verve and fun . ","the filmmaker ascends , literally , to the olympus of the art world , but he would have done well to end this flawed , dazzling series with the raising of something other than his own cremaster . ","the screenplay comes across , rather unintentionally , as hip-hop scooby-doo . ","has lost some of the dramatic conviction that underlies the best of comedies . . . ","vaguely interesting , but it's just too too much . "," . . . no charm , no laughs , no fun , no reason to watch . ","a generic family comedy unlikely to be appreciated by anyone outside the under-10 set . ","kung pow seems like some futile concoction that was developed hastily after oedekerk and his fellow moviemakers got through crashing a college keg party . ","kurys seems intimidated by both her subject matter and the period trappings of this debut venture into the heritage business . ","the film virtually chokes on its own self-consciousness . ","a manipulative feminist empowerment tale thinly posing as a serious drama about spousal abuse . ","everything in maid in manhattan is exceedingly pleasant , designed not to offend . it goes down easy , leaving virtually no aftertaste . ","a profoundly stupid affair , populating its hackneyed and meanspirited storyline with cardboard characters and performers who value cash above credibility . "," . . . pays tribute to heroes the way julia roberts hands out awards--with phony humility barely camouflaging grotesque narcissism . ","time stands still in more ways that one in clockstoppers , a sci-fi thriller as lazy as it is interminable . ","as a director , eastwood is off his game -- there's no real sense of suspense , and none of the plot 'surprises' are really surprising . ","eccentric enough to stave off doldrums , caruso's self-conscious debut is also eminently forgettable . ","to work , love stories require the full emotional involvement and support of a viewer . that is made almost impossible by events that set the plot in motion . ","although barbershop boasts some of today's hottest and hippest acts from the world of television , music and stand-up comedy , this movie strangely enough has the outdated swagger of a shameless ‘70s blaxploitation shuck-and-jive sitcom . ","a puzzle whose pieces do not fit . some are fascinating and others are not , and in the end , it is almost a good movie . ","would that greengrass had gone a tad less for grit and a lot more for intelligibility . ","the good is very , very good . . . the rest runs from mildly unimpressive to despairingly awful . ","'butterfingered' is the word for the big-fisted direction of jez butterworth , who manages to blast even the smallest sensitivities from the romance with his clamorous approach . ","be forewarned , if you're depressed about anything before watching this film , you may just end up trying to drown yourself in a lake afterwards . ","a terrible adaptation of a play that only ever walked the delicate tightrope between farcical and loathsome . in the wrong hands , i . e . peploe's , it's simply unbearable","an inexperienced director , mehta has much to learn . ","a limp eddie murphy vehicle that even he seems embarrassed to be part of . ","dramatically lackluster . ","so muddled , repetitive and ragged that it says far less about the horrifying historical reality than about the filmmaker's characteristic style . ","a gushy episode of  m * a * s * h  only this time from an asian perspective . ","  looking for leonard  just seems to kinda sit in neutral , hoping for a stiff wind to blow it uphill or something . ","nothing more than four or five mild chuckles surrounded by 86 minutes of overly-familiar and poorly-constructed comedy . ","definitely in the guilty pleasure b-movie category , reign of fire is so incredibly inane that it is laughingly enjoyable . ","good-looking but relentlessly lowbrow outing plays like clueless does south fork . ","entertaining enough , but nothing new"," . . . one resurrection too many . ","this is a film about the irksome , tiresome nature of complacency that remains utterly satisfied to remain the same throughout . even as the hero of the story rediscovers his passion in life , the mood remains oddly detached . ","demeo is not without talent ; he just needs better material . ","in spite of featuring a script credited to no fewer than five writers , apparently nobody here bothered to check it twice . ","no one involved , save dash , shows the slightest aptitude for acting , and the script , credited to director abdul malik abbott and ernest 'tron' anderson , seems entirely improvised . ","initially gripping , eventually cloying pow drama . ","a timid , soggy near miss . ","works better in the conception than it does in the execution . . . winds up seeming just a little too clever . ","to the vast majority of more casual filmgoers , it will probably be a talky bore . ","observant intelligence constantly vies with pretension -- and sometimes plain wacky implausibility -- throughout maelstrom . ","this version of h . g . wells' time machine was directed by h . g . wells' great-grandson . they should have found orson welles' great-grandson . ","shunji iwai's all about lily chou chou is a beautifully shot , but ultimately flawed film about growing up in japan . ","with more character development this might have been an eerie thriller ; with better payoffs , it could have been a thinking man's monster movie . ","thriller directorial debut for traffic scribe gaghan has all the right parts , but the pieces don't quite fit together . "," . . . would be a total loss if not for two supporting performances taking place at the movie's edges . ","there's not a single jump-in-your-seat moment and believe it or not , jason actually takes a backseat in his own film to special effects . ","goldbacher draws on an elegant visual sense and a talent for easy , seductive pacing . . . but she and writing partner laurence coriat don't manage an equally assured narrative coinage . ","though harris is affecting at times , he cannot overcome the sense that pumpkin is a mere plot pawn for two directors with far less endearing disabilities . ","the documentary is much too conventional -- lots of boring talking heads , etc . -- to do the subject matter justice . ","the movie itself appears to be running on hypertime in reverse as the truly funny bits get further and further apart . ","this is not a jackie chan movie . it's just a movie that happens to have jackie chan in it . and that makes all the difference . ","far too clever by half , howard's film is really a series of strung-together moments , with all the spaces in between filled with fantasies , daydreams , memories and one fantastic visual trope after another . ","the problem with movies about angels is they have a tendency to slip into hokum . a rumor of angels doesn't just slip -- it avalanches into forced fuzziness . ","no big whoop , nothing new to see , zero thrills , too many flashbacks and a choppy ending make for a bad film . ","i don't think this movie loves women at all . ","shankman . . . and screenwriter karen janszen bungle their way through the narrative as if it were a series of bible parables and not an actual story . ","a negligible british comedy . ","fails to convince the audience that these brats will ever be anything more than losers . ","stay away . far away . ","slack and uninspired , and peopled mainly by characters so unsympathetic that you're left with a sour taste in your mouth . ","skip this turd and pick your nose instead because you're sure to get more out of the latter experience . ","what can one say about a balding 50-year-old actor playing an innocent boy carved from a log ? ","trailer trash cinema so uncool the only thing missing is the  gadzooks !  ","her film is like a beautiful food entrée that isn't heated properly , so that it ends up a bit cold and relatively flavorless . ","like the world of his film , hartley created a monster but didn't know how to handle it . ","no new plot conceptions or environmental changes , just different bodies for sharp objects to rip through . ","needs more impressionistic cinematography and exhilarating point-of-view shots and fewer slow-motion 'grandeur' shots and quick-cut edits that often detract from the athleticism . ","in the end , there isn't much to it . ","a waste of fearless purity in the acting craft . ","the film is ultimately about as inspiring as a hallmark card . ","anyone not into high-tech splatterfests is advised to take the warning literally , and log on to something more user-friendly . ","disreputable doings and exquisite trappings are dampened by a lackluster script and substandard performances . ","you could easily mistake it for a sketchy work-in-progress that was inexplicably rushed to the megaplexes before its time . ","directors harry gantz and joe gantz have chosen a fascinating subject matter , but the couples exposing themselves aren't all that interesting . ","yet another entry in the sentimental oh-those-wacky-brits genre that was ushered in by the full monty and is still straining to produce another smash hit . ","for those for whom the name woody allen was once a guarantee of something fresh , sometimes funny , and usually genuinely worthwhile , hollywood ending is a depressing experience","femme fatale offers nothing more than a bait-and-switch that is beyond playing fair with the audience . are we dealing with dreams , visions or being told what actually happened as if it were the third ending of clue ? ","it could have been something special , but two things drag it down to mediocrity -- director clare peploe's misunderstanding of marivaux's rhythms , and mira sorvino's limitations as a classical actress . ","fluffy neo-noir hiding behind cutesy film references . ","imagine susan sontag falling in love with howard stern . ","like being trapped inside a huge video game , where exciting , inane images keep popping past your head and the same illogical things keep happening over and over again . ","should have been worth cheering as a breakthrough but is devoid of wit and humor . ","the best thing about the movie is its personable , amusing cast . ","these guys seem great to knock back a beer with but they're simply not funny performers . ","everything was as superficial as the forced new jersey lowbrow accent uma had . ","o ótimo esforço do diretor acaba sendo frustrado pelo roteiro , que , depois de levar um bom tempo para colocar a trama em andamento , perde-se de vez a partir do instante em que os estranhos acontecimentos são explicados . ","director david fincher and writer david koepp can't sustain it . ","finally coming down off of miramax's deep shelves after a couple of aborted attempts , waking up in reno makes a strong case for letting sleeping dogs lie . ","a movie that feels like the pilot episode of a new teen-targeted action tv series . ","one of the most highly-praised disappointments i've had the misfortune to watch in quite some time . ","the animation and backdrops are lush and inventive , yet return to neverland never manages to take us to that elusive , lovely place where we suspend our disbelief . ","director shekhar kapur and screenwriters michael schiffer and hossein amini have tried hard to modernize and reconceptualize things , but the barriers finally prove to be too great . ","strong filmmaking requires a clear sense of purpose , and in that oh-so-important category , the four feathers comes up short . ","the thought of watching this film with an audience full of teenagers fixating on its body humour and reinforcement of stereotypes ( of which they'll get plenty ) fills me with revulsion . ","devolves into the derivative , leaning on badly-rendered cgi effects . ","anyone who gets chills from movies with giant plot holes will find plenty to shake and shiver about in 'the ring . '","a grand fart coming from a director beginning to resemble someone's crazy french grandfather . ","the script is a disaster , with cloying messages and irksome characters . ","both overstuffed and undernourished . . . the film can't be called a solid success , although there's plenty of evidence here to indicate clooney might have better luck next time . ","plods along , minus the twisted humor and eye-popping visuals that have made miike . . . a cult hero . ","hollywood has taken quite a nosedive from alfred hitchcock's imaginative flight to shyamalan's self-important summer fluff . ","the film's maudlin focus on the young woman's infirmity and her naive dreams play like the worst kind of hollywood heart-string plucking . ","a pretentious mess . ","predictably soulless techno-tripe . ","i firmly believe that a good video game movie is going to show up soon . i also believe that resident evil is not it . ","it has the air of a surprisingly juvenile lark , a pop-influenced prank whose charms are immediately apparent and wear thin with repetition . ","the plot meanders from gripping to plodding and back . ","this is cruel , misanthropic stuff with only weak claims to surrealism and black comedy . ","no amount of nostalgia for carvey's glory days can disguise the fact that the new film is a lame kiddie flick and that carvey's considerable talents are wasted in it . ","best described as i know what you did last winter . ","[taylor] takes us on a ride that's consistently surprising , easy to watch -- but , oh , so dumb . ","it's difficult for a longtime admirer of his work to not be swept up in invincible and overlook its drawbacks . ","lazily directed by charles stone iii . . . from a leaden script by matthew cirulnick and novelist thulani davis . ","though jones and snipes are enthralling , the movie bogs down in rhetoric and cliché . ","the most remarkable ( and frustrating ) thing about world traveler , which opens today in manhattan , is that its protagonist , after being an object of intense scrutiny for 104 minutes , remains a complete blank . ","an artsploitation movie with too much exploitation and too little art . ","the pacing is often way off and there are too many bona fide groaners among too few laughs . ","with lines that feel like long soliloquies -- even as they are being framed in conversation -- max is static , stilted . ","barely manages for but a few seconds over its seemingly eternal running time to pique your interest , your imagination , your empathy or anything , really , save your disgust and your indifference . ","writer/director burr steers emphasizes the q in quirky , with mixed results . ","one senses in world traveler and in his earlier film that freundlich bears a grievous but obscure complaint against fathers , and circles it obsessively , without making contact . ","in between the icy stunts , the actors spout hilarious dialogue about following your dream and 'just letting the mountain tell you what to do . '","the obligatory break-ups and hook-ups don't seem to have much emotional impact on the characters . ","make no mistake , ivans xtc . is a mess . ","hypnotically dull , relentlessly downbeat , laughably predictable wail pitched to the cadence of a depressed fifteen-year-old's suicidal poetry . ","the concept is a hoot . the trailer is a riot . the movie is a dud . ","it's a boring movie about a boring man , made watchable by a bravura performance from a consummate actor incapable of being boring . ","because the intelligence level of the characters must be low , very low , very very low , for the masquerade to work , the movie contains no wit , only labored gags . ","it's hard to imagine another director ever making his wife look so bad in a major movie . ","some stunning visuals -- and some staggeringly boring cinema . ","these characters become wearisome . ","a hit- and-miss affair , consistently amusing but not as outrageous or funny as cho may have intended or as imaginative as one might have hoped . ","this may be the first cartoon ever to look as if it were being shown on the projection television screen of a sports bar . ","kim ki-deok seems to have in mind an ( emotionally at least ) adolescent audience demanding regular shocks and bouts of barely defensible sexual violence to keep it interested . ","a sterling film - a cross between boys don't cry , deliverance , and ode to billy joe - lies somewhere in the story of matthew shepard , but that film is yet to be made . ","after sitting through this sloppy , made-for-movie comedy special , it makes me wonder if lawrence hates criticism so much that he refuses to evaluate his own work . ","contrived pastiche of caper clichés . ","many shallower movies these days seem too long , but this one is egregiously short . ","just a kiss wants desperately to come off as a fanciful film about the typical problems of average people . but it is set in a world that is very , very far from the one most of us inhabit . ","the most ill-conceived animated comedy since the 1991 dog rover dangerfield . ","like shave ice without the topping , this cinematic snow cone is as innocuous as it is flavorless . ","despite its sincere acting , signs is just another unoriginal run of the mill sci-fi film with a flimsy ending and lots of hype . ","yet another movie which presumes that high school social groups are at war , let alone conscious of each other's existence . ","loud , chaotic and largely unfunny . ","i can't remember the last time i saw an audience laugh so much during a movie , but there's only one problem…it's supposed to be a drama . ","qualities that were once amusing are becoming irritating . ","well , jason's gone to manhattan and hell , i guess a space station in the year 2455 can be crossed off the list of ideas for the inevitable future sequels ( hey , don't shoot the messenger ) . ","donovan . . . squanders his main asset , jackie chan , and fumbles the vital action sequences . ","there is no psychology here , and no real narrative logic -- just a series of carefully choreographed atrocities , which become strangely impersonal and abstract . ","bread , my sweet has so many flaws it would be easy for critics to shred it . it may even fall into the category of films you love to hate . i admit it , i hate to like it . ","frida is certainly no disaster , but neither is it the kahlo movie frida fans have been looking for . ","leaks treacle from every pore . ","the characters are so generic and the plot so bland that even as rogue cia assassins working for chris cooper's agency boss close in on the resourceful amnesiac , we don't feel much for damon/bourne or his predicament . ","kapur weighs down the tale with bogus profundities . ","while we want macdowell's character to retrieve her husband , we have to ask whether her personal odyssey trumps the carnage that claims so many lives around her . ","blue crush is as predictable as the tides . . . . the movie feels stitched together from stock situations and characters from other movies . ","if you enjoy being rewarded by a script that assumes you aren't very bright , then blood work is for you . ","trouble every day is a success in some sense , but it's hard to like a film so cold and dead . ","the film's stagecrafts are intimate and therefore bolder than the otherwise calculated artifice that defines and overwhelms the film's production design . ","a well-intentioned effort that's still too burdened by the actor's offbeat sensibilities for the earnest emotional core to emerge with any degree of accessibility . ","a family-friendly fantasy that ends up doing very little with its imaginative premise . ","a plodding look at the french revolution through the eyes of aristocrats . ","tom shadyac has learned a bit more craft since directing adams , but he still lingers over every point until the slowest viewer grasps it . ","unspools like a highbrow , low-key , 102-minute infomercial , blending entrepreneurial zeal with the testimony of satisfied customers . ","a fast-paced , glitzy but extremely silly piece . ","any reasonably creative eighth-grader could have written a more credible script , though with the same number of continuity errors . "," . . . while the humor aspects of 'jason x' were far more entertaining than i had expected , everything else about the film tanks . ","your taste for jonah - a veggie tales movie may well depend on your threshold for pop manifestations of the holy spirit . ","like an afterschool special with costumes by gianni versace , mad love looks better than it feels . ","while certain cues , like the happy music , suggest that this movie is supposed to warm our hearts , jeong-hyang lee's film is just as likely to blacken that organ with cold vengefulness . ","the script , the gags , the characters are all direct-to-video stuff , and that's where this film should have remained . ","a thriller without thrills and a mystery devoid of urgent questions . ","a collage of clichés and a dim echo of allusions to other films . ","the film is hampered by its predictable plot and paper-thin supporting characters . ","arty gay film . ","jonah is only so-so . . . the addition of a biblical message will either improve the film for you , or it will lessen it . ","an excruciating demonstration of the unsalvageability of a movie saddled with an amateurish screenplay . ","how many more times will indie filmmakers subject us to boring , self-important stories of how horrible we are to ourselves and each other ? ","there are some laughs in this movie , but williams' anarchy gets tiresome , the satire is weak . ","as steamy as last week's pork dumplings . ","incoherence reigns . ","the somber pacing and lack of dramatic fireworks make green dragon seem more like medicine than entertainment . ","the filmmakers needed more emphasis on the storytelling and less on the glamorous machine that thrusts the audience into a future they won't much care about . ","another wholly unnecessary addition to the growing , moldering pile of , well , extreme stunt pictures . ","this strenuously unfunny showtime deserves the hook . ","the whole thing's fairly lame , making it par for the course for disney sequels . ","…its solemn pretension prevents us from sharing the awe in which it holds itself . "," . . . the good and different idea [of middle-aged romance] is not handled well and , except for the fine star performances , there is little else to recommend  never again .  ","if disney's cinderella proved that 'a dream is a wish your heart makes , ' then cinderella ii proves that a nightmare is a wish a studio's wallet makes . ","features nonsensical and laughable plotting , wooden performances , ineptly directed action sequences and some of the worst dialogue in recent memory . ","with rare birds , as with the shipping news before it , an attempt is made to transplant a hollywood star into newfoundland's wild soil -- and the rock once again resists the intrusion . ","nothing about this movie works . ","if the idea of the white man arriving on foreign shores to show wary natives the true light is abhorrent to you , the simplistic heaven will quite likely be more like hell . ","a spooky yarn of demonic doings on the high seas that works better the less the brain is engaged . ","none of birthday girl's calculated events take us by surprise . . . ","are monsters born , or made ? ","lisa rinzler's cinematography may be lovely , but love liza's tale itself virtually collapses into an inhalant blackout , maintaining consciousness just long enough to achieve callow pretension . ","the narrator and the other characters try to convince us that acting transfigures esther , but she's never seen speaking on stage ; one feels cheated , and esther seems to remain an unchanged dullard . ","it's exactly the kind of movie toback's detractors always accuse him of making . ","with the dog days of august upon us , think of this dog of a movie as the cinematic equivalent of high humidity . ","less about shakespeare than the spawn of fools who saw quentin tarantino's handful of raucous gangster films and branched out into their own pseudo-witty copycat interpretations . ","the film is like sitting in a downtown café , overhearing a bunch of typical late-twenty-somethings natter on about nothing , and desperately wishing you could change tables . ","this rather unfocused , all-over-the-map movie would be a lot better if it pared down its plots and characters to a few rather than dozens . . . or if it were subtler . . . or if it had a sense of humor . ","takes a clunky tv-movie approach to detailing a chapter in the life of the celebrated irish playwright , poet and drinker . ","not only does the thoroughly formulaic film represent totally exemplify middle-of-the-road mainstream , it also represents glossy hollywood at its laziest . ","a shame that stealing harvard is too busy getting in its own way to be anything but frustrating , boring , and forgettable . ","nearly every attempt at humor here is doa . ","collapses under its own meager weight . ","this is mild-mannered , been-there material given a pedestrian spin by a director who needed a touch of the flamboyant , the outrageous . ","if you adored the full monty so resoundingly that you're dying to see the same old thing in a tired old setting , then this should keep you reasonably entertained . ","technically and artistically inept . ","those who are only mildly curious , i fear , will be put to sleep or bewildered by the artsy and often pointless visuals . ","though tom shadyac's film kicks off spookily enough , around the halfway mark it takes an abrupt turn into glucose sentimentality and laughable contrivance . ","a long , dull procession of despair , set to cello music culled from a minimalist funeral . ","call me a cold-hearted curmudgeon for not being able to enjoy a mindless action movie , but i believe a movie can be mindless without being the peak of all things insipid . ","death might be a release . ","'[hopkins]doesn't so much phone in his performance as fax it . no , even that's too committed . he gets his secretary to fax it .  ","sodden and glum , even in those moments where it's supposed to feel funny and light . ","priggish , lethargically paced parable of renewal . ","a beautifully shot but dull and ankle-deep 'epic . '","even with its $50-million us budget , pinocchio never quite achieves the feel of a fanciful motion picture . ","this is a third-person story now , told by hollywood , and much more ordinary for it . ","the filmmakers know how to please the eye , but it is not always the prettiest pictures that tell the best story . ","written , flatly , by david kendall and directed , barely , by there's something about mary co-writer ed decter . ","the characters are interesting and the relationship between yosuke and saeko is worth watching as it develops , but there's not enough to the story to fill two hours . ","very well made , but doesn't generate a lot of tension . ","like being invited to a classy dinner soiree and not knowing anyone . you leave the same way you came -- a few tasty morsels under your belt , but no new friends . ","it's depressing to see how far herzog has fallen . ","the question hanging over the time machine is not , as the main character suggests , 'what if ? ' but rather , 'how can you charge money for this ? '","millions of dollars heaped upon a project of such vast proportions need to reap more rewards than spiffy bluescreen technique and stylish weaponry . ","  freaky friday ,  it's not . ","perhaps a better celebration of these unfairly dismissed heroes would be a film that isn't this painfully forced , false and fabricated . ","although no pastry is violated , this nasty comedy pokes fun at the same easy targets as other rowdy raunch-fests -- farts , boobs , unmentionables -- without much success . ","in this film , aussie david caesar channels the not-quite-dead career of guy ritchie . ","maybe you'll be lucky , and there'll be a power outage during your screening so you can get your money back . ","the characterizations and dialogue lack depth or complexity , with the ironic exception of scooter . ","this film was made by and for those folks who collect the serial killer cards and are fascinated by the mere suggestion of serial killers . for the rest of us , sitting through dahmer's two hours amounts to little more than punishment . ","narc can only remind us of brilliant crime dramas without becoming one itself . ","somewhere inside the mess that is world traveler , there is a mediocre movie trying to get out . ","a tedious parable about honesty and good sportsmanship . ","its strengths and weaknesses play off each other virtually to a stand-off , with the unfortunate trump card being the dreary mid-section of the film . ","an artful yet depressing film that makes a melodramatic mountain out of the molehill of a missing bike . ","the movie's ultimate point -- that everyone should be themselves -- is trite , but the screenwriter and director michel gondry restate it to the point of ridiculousness . ","a glossy knock-off of a b-movie revenge flick . "," . . . expands the horizons of boredom to the point of collapse , turning into a black hole of dullness , from which no interesting concept can escape . ","it's just plain boring . ","sad nonsense , this . but not without cheesy fun factor . ","one of those decades-spanning historical epics that strives to be intimate and socially encompassing but fails to do justice to either effort in three hours of screen time . ","really dumb but occasionally really funny . ","the movie wavers between hallmark card sentimentality and goofy , life-affirming moments straight out of a cellular phone commercial . ","a half-assed film . ","the director's many dodges and turns add up to little more than a screenful of gamesmanship that's low on both suspense and payoff . ","while the transgressive trappings ( especially the frank sex scenes ) ensure that the film is never dull , rodrigues's beast-within metaphor is ultimately rather silly and overwrought , making the ambiguous ending seem goofy rather than provocative . ","the satire is unfocused , while the story goes nowhere . ","they threw loads of money at an idea that should've been so much more even if it was only made for teenage boys and wrestling fans . ","it's mired in a shabby script that piles layer upon layer of action man cliché atop wooden dialogue and a shifting tone that falls far short of the peculiarly moral amorality of [woo's] best work . ","reyes' directorial debut has good things to offer , but ultimately it's undone by a sloppy script","if you're over 25 , have an iq over 90 , and have a driver's license , you should be able to find better entertainment . ","the darker elements of misogyny and unprovoked violence suffocate the illumination created by the two daughters and the sparse instances of humor meant to shine through the gloomy film noir veil . "," . . . the picture's cleverness is ironically muted by the very people who are intended to make it shine . ","never does  lilo & stitch  reach the emotion or timelessness of disney's great past , or even that of more recent successes such as  mulan  or  tarzan .  ","one of those so-so films that could have been much better . ","crossroads feels like a teenybopper ed wood film , replete with the pubescent scandalous innuendo and the high-strung but flaccid drama . ","fails to satisfactorily exploit its gender politics , genre thrills or inherent humor . ","interview with the assassin is structured less as a documentary and more as a found relic , and as such the film has a difficult time shaking its blair witch project real-time roots . ","cacoyannis' vision is far less mature , interpreting the play as a call for pity and sympathy for anachronistic phantasms haunting the imagined glory of their own pasts . ","it has more in common with a fireworks display than a movie , which normally is expected to have characters and a storyline . ","it appears to have been made by people to whom the idea of narrative logic or cohesion is an entirely foreign concept . ","less a heartfelt appeal for the handicapped than a nice belgian waffle . ","it's not helpful to listen to extremist name-calling , regardless of whether you think kissinger was a calculating fiend or just a slippery self-promoter . ","abandon spends 90 minutes trying figure out whether or not some cocky pseudo-intellectual kid has intentionally left college or was killed . the only problem is that , by the end , no one in the audience or the film seems to really care . ","no such thing is sort of a minimalist beauty and the beast , but in this case the beast should definitely get top billing . robert john burke as the monster horns in and steals the show . ","due to stodgy , soap opera-ish dialogue , the rest of the cast comes across as stick figures reading lines from a teleprompter . ","[t]he film is never sure to make a clear point – even if it seeks to rely on an ambiguous presentation . ","while it may not add up to the sum of its parts , holofcener's film offers just enough insight to keep it from being simpleminded , and the ensemble cast is engaging enough to keep you from shifting in your chair too often . ","an overwrought taiwanese soaper about three people and their mixed-up relationship . ","nobody seems to have cared much about any aspect of it , from its cheesy screenplay to the grayish quality of its lighting to its last-minute , haphazard theatrical release . ","a thoroughly awful movie--dumb , narratively chaotic , visually sloppy . . . a weird amalgam of 'the thing' and a geriatric 'scream . '"," . . . another example of how sandler is losing his touch . ","nothing sticks , really , except a lingering creepiness one feels from being dragged through a sad , sordid universe of guns , drugs , avarice and damaged dreams . ","what goes on for the 110 minutes of  panic room  is a battle of witlessness between a not-so-bright mother and daughter and an even less capable trio of criminals . ","the plot's contrivances are uncomfortably strained . ","guilty of the worst sin of attributable to a movie like this : it's not scary in the slightest . ","schnieder bounces around with limp wrists , wearing tight tummy tops and hip huggers , twirling his hair on his finger and assuming that's enough to sustain laughs . . . ","its simplicity puts an exclamation point on the fact that this isn't something to be taken seriously , but it also wrecks any chance of the movie rising above similar fare . ","by the final whistle you're convinced that this mean machine was a decent tv outing that just doesn't have big screen magic . ","to say that this vapid vehicle is downright doltish and uneventful is just as obvious as telling a country skunk that he has severe body odor . ","a film of empty , fetishistic violence in which murder is casual and fun . ","pretend it's a werewolf itself by avoiding eye contact and walking slowly away . it's fun , but it's a real howler . ","some fine acting , but ultimately a movie with no reason for being . ","it's difficult to feel anything much while watching this movie , beyond mild disturbance or detached pleasure at the acting . ","a waterlogged version of 'fatal attraction' for the teeny-bopper set . . . a sad , soggy potboiler that wastes the talents of its attractive young leads . ","it tells its story in a flat manner and leaves you with the impression that you should have gotten more out of it than you did . ","sweet gentle jesus , did the screenwriters just do a cut-and-paste of every bad action-movie line in history ? ","it's not the worst comedy of the year , but it certainly won't win any honors . ","this is for the most part a useless movie , even with a great director at the helm . ","a loud , witless mess that has none of the charm and little of the intrigue from the tv series . ","even on its own ludicrous terms , the sum of all fears generates little narrative momentum , and invites unflattering comparisons to other installments in the ryan series . ","though it inspires some ( out-of-field ) creative thought , the film is -- to its own detriment -- much more a cinematic collage than a polemical tract . ","as predictable as the outcome of a globetrotters-generals game , juwanna mann is even more ludicrous than you'd expect from the guy-in-a-dress genre , and a personal low for everyone involved . ","sinks into the usual cafeteria goulash of fart jokes , masturbation jokes , and racist japanese jokes . ","where tom green stages his gags as assaults on america's knee-jerk moral sanctimony , jackass lacks aspirations of social upheaval . ","more of an intriguing curiosity than a gripping thriller . ","the april 2002 instalment of the american war for independence , complete with loads of cgi and bushels of violence , but not a drop of human blood . ","contains all the substance of a twinkie -- easy to swallow , but scarcely nourishing . ","return to neverland manages to straddle the line between another classic for the company and just another run-of-the-mill disney sequel intended for the home video market . ","rarely does a film so graceless and devoid of merit as this one come along . ","it's a thin notion , repetitively stretched out to feature length , awash in self-consciously flashy camera effects , droning house music and flat , flat dialogue . ","on a certain base level , blue crush delivers what it promises , just not well enough to recommend it . ","the colorful masseur wastes its time on mood rather than riding with the inherent absurdity of ganesh's rise up the social ladder . "," . . . an incredibly heavy-handed , manipulative dud that feels all too familiar . ","wimps out by going for that pg-13 rating , so the more graphic violence is mostly off-screen and the sexuality is muted . ","trapped presents a frightening and compelling 'what if ? ' scenario that will give most parents pause . . . . then , something terrible happens . ","madonna has made herself over so often now , there's apparently nothing left to work with , sort of like michael jackson's nose . ","never having seen the first two films in the series , i can't compare friday after next to them , but nothing would change the fact that what we have here is a load of clams left in the broiling sun for a good three days . ","the story is lacking any real emotional impact , and the plot is both contrived and cliched . ","a depraved , incoherent , instantly disposable piece of hackery . ","it's a bad action movie because there's no rooting interest and the spectacle is grotesque and boring . ","[soderbergh] tends to place most of the psychological and philosophical material in italics rather than trust an audience's intelligence , and he creates an overall sense of brusqueness . ","handsome and sincere but slightly awkward in its combination of entertainment and evangelical boosterism . ","so aggressively cheery that pollyana would reach for a barf bag . ","scooby-doo doesn't know if it wants to be a retro-refitting exercise in campy recall for older fans or a silly , nickelodeon-esque kiddie flick . ","russell lacks the visual panache , the comic touch , and perhaps the budget of sommers's title-bout features . ","highly uneven and inconsistent . . . margarita happy hour kinda resembles the el cheapo margaritas served within . ","very stupid and annoying . ","the sum of all fears pretends to be a serious exploration of nuclear terrorism , but it's really nothing more than warmed-over cold war paranoia . ","a listless and desultory affair . ","represents the depths to which the girls-behaving-badly film has fallen . ","how inept is serving sara ? it makes even elizabeth hurley seem graceless and ugly . ","jam-packed with literally bruising jokes . every five minutes or so , someone gets clocked . ","wins my vote for 'the 2002 enemy of cinema' award . ","any chekhov is better than no chekhov , but it would be a shame if this was your introduction to one of the greatest plays of the last 100 years . ","helmer hudlin tries to make a hip comedy , but his dependence on slapstick defeats the possibility of creating a more darkly edged tome . ","lazy , miserable and smug . this is one of the biggest disappointments of the year . ","formula 51 has dulled your senses faster and deeper than any recreational drug on the market . ","every visual joke is milked , every set-up obvious and lengthy , every punchline predictable . there's no energy . ","apparently writer-director attal thought he need only cast himself and his movie-star wife sitting around in their drawers to justify a film . ","after the setup , the air leaks out of the movie , flattening its momentum with about an hour to go . ","this is a poster movie , a mediocre tribute to films like them ! ","at three hours and with very little story or character development , there is plenty of room for editing , and a much shorter cut surely would have resulted in a smoother , more focused narrative without sacrificing any of the cultural intrigue . ","a bit too derivative to stand on its own as the psychological thriller it purports to be . ","a crude teen-oriented variation on a theme that the playwright craig lucas explored with infinitely more grace and eloquence in his prelude to a kiss . ","the film's darker moments become smoothed over by an overwhelming need to tender inspirational tidings , especially in the last few cloying moments . ","if you recognize zeus ( the dog from snatch ) it will make you wish you were at home watching that movie instead of in the theater watching this one . ","abysmally pathetic","this is the kind of movie that you only need to watch for about thirty seconds before you say to yourself , 'ah , yes , here we have a bad , bad , bad movie . '","shanghai ghetto should be applauded for finding a new angle on a tireless story , but you might want to think twice before booking passage . ","plays like a checklist of everything rob reiner and his cast were sending up . ","there's too much forced drama in this wildly uneven movie , about a young man's battle with his inescapable past and uncertain future in a very shapable but largely unfulfilling present . ","it's at once laughable and compulsively watchable , in its committed dumbness . ","all the sensuality , all the eroticism of a good vampire tale has been , pardon the pun , sucked out and replaced by goth goofiness . ","a cross between blow and boyz n the hood , this movie strives to be more , but doesn't quite get there . good performances keep it from being a total rehash . ","the screenplay is hugely overwritten , with tons and tons of dialogue -- most of it given to children . ","troll the cult section of your local video store for the real deal . ","at times , the movie looks genuinely pretty . your nightmares , on the other hand , will be anything but . not even felinni would know what to make of this italian freakshow . ","elmo touts his drug as being 51 times stronger than coke . if you're looking for a tale of brits behaving badly , watch snatch again . it's 51 times better than this . ","it's difficult to conceive of anyone who has reached puberty actually finding the characters in slackers or their antics amusing , let alone funny . ","despite its promising cast of characters , big trouble remains a loosely tied series of vignettes which only prove that 'zany' doesn't necessarily mean 'funny . '","both shrill and soporific , and because everything is repeated five or six times , it can seem tiresomely simpleminded . ","does not go far enough in its humor or stock ideas to stand out as particularly memorable or even all that funny . ","neither revelatory nor truly edgy--merely crassly flamboyant and comedically labored . ","just about everyone involved here seems to be coasting . there are a few modest laughs , but certainly no thrills . ","fails so fundamentally on every conventional level that it achieves some kind of goofy grandeur . ","there's a persistent theatrical sentiment and a woozy quality to the manner of the storytelling , which undercuts the devastatingly telling impact of utter loss personified in the film's simple title . ","while howard's appreciation of brown and his writing is clearly well-meaning and sincere , the movie would be impossible to sit through were it not for the supporting cast . ","a preposterous , prurient whodunit . ","go , girls , right down the reality drain . ","boasting some of the most poorly staged and lit action in memory , impostor is as close as you can get to an imitation movie . ","can be classified as one of those 'alternate reality' movies . . . except that it would have worked so much better dealing in only one reality . ","predictable and cloying , though brown sugar is so earnest in its yearning for the days before rap went nihilistic that it summons more spirit and bite than your average formulaic romantic quadrangle . "," . . . unlikable , uninteresting , unfunny , and completely , utterly inept . ","the film is so busy making reference to other films and trying to be other films that it fails to have a heart , mind or humor of its own . ","an imponderably stilted and self-consciously arty movie . ","muddled , melodramatic paranormal romance is an all-time low for kevin costner . ","too clumsy in key moments . . . to make a big splash . ","just a bunch of good actors flailing around in a caper that's neither original nor terribly funny . ","`matrix'-style massacres erupt throughout . . . but the movie has a tougher time balancing its violence with kafka-inspired philosophy . ","at least it's a fairly impressive debut from the director , charles stone iii . ","it all unfolds predictably , and the adventures that happen along the way seem repetitive and designed to fill time , providing no real sense of suspense . ","wanker goths are on the loose ! run for your lives ! ","why would anyone cast the magnificent jackie chan in a movie full of stunt doubles and special effects ? ","a grating , emaciated flick . ","unambitious writing emerges in the movie , using a plot that could have come from an animated-movie screenwriting textbook . ","presents a good case while failing to provide a reason for us to care beyond the very basic dictums of human decency . ","we have poignancy jostling against farce , thoughtful dialogue elbowed aside by one-liners , and a visual style that incorporates rotoscope animation for no apparent reason except , maybe , that it looks neat . "," . . . unbearably lame . ","according to the script , grant and bullock's characters are made for each other . but you'd never guess that from the performances . ","the animation merely serves up a predictable , maudlin story that swipes heavily from bambi and the lion king , yet lacks the emotional resonance of either of those movies . ","ararat feels like a book report","steve oedekerk is , alas , no woody allen . ","a lot like the imaginary sport it projects onto the screen -- loud , violent and mindless . ","an amalgam of the fugitive , blade runner , and total recall , only without much energy or tension . ","the acting is amateurish , the cinematography is atrocious , the direction is clumsy , the writing is insipid and the violence is at once luridly graphic and laughably unconvincing . ","shows that jackie chan is getting older , and that's something i would rather live in denial about","with miscast leads , banal dialogue and an absurdly overblown climax , killing me softly belongs firmly in the so-bad-it's-good camp . ","alas , the black-and-white archival footage of their act showcases pretty mediocre shtick . ","the slapstick is labored , and the bigger setpieces flat . ","this is the kind of movie where people who have never picked a lock do so easily after a few tries and become expert fighters after a few weeks . ","the problem with the mayhem in formula 51 is not that it's offensive , but that it's boring . ","much of the digitally altered footage appears jagged , as if filmed directly from a television monitor , while the extensive use of stock footage quickly becomes a tiresome cliché . ","the film never rises above a conventional , two dimension tale","mark wahlberg . . . may look classy in a '60s-homage pokepie hat , but as a character he's dry , dry , dry . ","told in scattered fashion , the movie only intermittently lives up to the stories and faces and music of the men who are its subject . ","the irony is that this film's cast is uniformly superb ; their performances could have -- should have -- been allowed to stand on their own . ","now i can see why people thought i was too hard on  the mothman prophecies  . ","if ever a concept came handed down from the movie gods on a silver platter , this is it . if ever such a dependable concept was botched in execution , this is it . ","with an unusual protagonist ( a kilt-wearing jackson ) and subject matter , the improbable  formula 51  is somewhat entertaining , but it could have been much stronger . ","sandra bullock's best dramatic performance to date ( is ) almost enough to lift ( this ) thrill-kill cat-and-mouser . . . above its paint-by-numbers plot . ","a feel-good movie that doesn't give you enough to feel good about . ","adolescents will be adequately served by the movie's sophomoric blend of shenanigans and slapstick , although the more lascivious-minded might be disappointed in the relative modesty of a movie that sports a 'topless tutorial service . '","this mistaken-identity picture is so film-culture referential that the final product is a ghost . ","the picture emerges as a surprisingly anemic disappointment . ","de niro cries . you'll cry for your money back . ","slap me , i saw this movie . ","[the kid's] just too bratty for sympathy , and as the film grows to its finale , his little changes ring hollow . ","behind the glitz , hollywood is sordid and disgusting . quelle surprise ! ","scherfig , who has had a successful career in tv , tackles more than she can handle . ","just consider what new best friend does not have , beginning with the minor omission of a screenplay . ","oscar caliber cast doesn't live up to material","the problems of the people in love in the time of money are hardly specific to their era . they just have problems , which are neither original nor are presented in convincing way . ","carrying this wafer-thin movie on his nimble shoulders , chan wades through putrid writing , direction and timing with a smile that says , 'if i stay positive , maybe i can channel one of my greatest pictures , drunken master . '","so putrid it is not worth the price of the match that should be used to burn every print of the film . ","in the end , the movie bogs down in insignificance , saying nothing about kennedy's assassination and revealing nothing about the pathology it pretends to investigate . ","starts out ballsy and stylish but fails to keep it up and settles into clichés . ","sometimes makes less sense than the bruckheimeresque american action flicks it emulates . ","one of those films where the characters inhabit that special annex of hell where adults behave like kids , children behave like adults and everyone screams at the top of their lungs no matter what the situation . ","there's only one way to kill michael myers for good : stop buying tickets to these movies . ","bland but harmless . ","'rare birds' tries to force its quirkiness upon the audience . ","the movie is about as humorous as watching your favorite pet get buried alive . ","resident evil is what comes from taking john carpenter's ghosts of mars and eliminating the beheadings . in other words , about as bad a film you're likely to see all year . ","five screenwriters are credited with the cliché-laden screenplay ; it seems as if each watered down the version of the one before . ","the whole thing comes off like a particularly amateurish episode of bewitched that takes place during spring break . ","well made but uninvolving , bloodwork isn't a terrible movie , just a stultifyingly obvious one -- an unrewarding collar for a murder mystery . ","so we got ten little indians meets friday the 13th by way of clean and sober , filmed on the set of carpenter's the thing and loaded with actors you're most likely to find on the next inevitable incarnation of the love boat . ","the movie's blatant derivativeness is one reason it's so lackluster . ","la de salma es una versión de frida superficial , preciosista y sin ningún contenido . ","kids don't mind crappy movies as much as adults , provided there's lots of cute animals and clumsy people . 'snow dogs' has both . ","it's almost as if it's an elaborate dare more than a full-blooded film . ","wobbly senegalese updating of  carmen  which is best for the stunning star turn by djeinaba diop gai","it's the humanizing stuff that will probably sink the film for anyone who doesn't think about percentages all day long . ","ken russell would love this . in one scene , we get a stab at soccer hooliganism , a double-barreled rip-off of quentin tarantino's climactic shootout — and meat loaf explodes . ","bella is the picture of health with boundless energy until a few days before she dies . this is absolutely and completely ridiculous and an insult to every family whose mother has suffered through the horrible pains of a death by cancer . ","the premise of  abandon  holds promise , . . . but its delivery is a complete mess . ","what could have been a pointed little chiller about the frightening seductiveness of new technology loses faith in its own viability and succumbs to joyless special-effects excess . ","a little too ponderous to work as shallow entertainment , not remotely incisive enough to qualify as drama , monsoon wedding serves mostly to whet one's appetite for the bollywood films . ","unless bob crane is someone of particular interest to you , this film's impressive performances and adept direction aren't likely to leave a lasting impression . ","the rock has a great presence but one battle after another is not the same as one battle followed by killer cgi effects . ","the bottom line with nemesis is the same as it has been with all the films in the series : fans will undoubtedly enjoy it , and the uncommitted needn't waste their time on it . ","the lousy john q all but spits out denzel washington's fine performance in the title role . ","the whole thing feels like a ruse , a tactic to cover up the fact that the picture is constructed around a core of flimsy -- or , worse yet , nonexistent -- ideas . ","what a stiflingly unfunny and unoriginal mess this is ! ","the film is so packed with subplots involving the various silbersteins that it feels more like the pilot episode of a tv series than a feature film . ","opera on film is never satisfactory . the art demands live viewing . the innate theatrics that provide its thrills and extreme emotions lose their luster when flattened onscreen . ","despite all the closed-door hanky-panky , the film is essentially juiceless . ","it is parochial , accessible to a chosen few , standoffish to everyone else , and smugly suggests a superior moral tone is more important than filmmaking skill","the sweetest thing leaves an awful sour taste . ","it's lost the politics and the social observation and become just another situation romance about a couple of saps stuck in an inarticulate screenplay . ","terminally bland , painfully slow and needlessly confusing . . . the movie , shot on digital videotape rather than film , is frequently indecipherable . ","as dumb and cheesy as they may be , the cartoons look almost shakespearean -- both in depth and breadth -- after watching this digital-effects-heavy , supposed family-friendly comedy . ","aloof and lacks any real raw emotion , which is fatal for a film that relies on personal relationships . ","a low-rent retread of the alien pictures . ","serviceable at best , slightly less than serviceable at worst . ","its initial excitement settles into a warmed over pastiche . ","a big meal of cliches that the talented cast generally chokes on . ","the story has little wit and no surprises . ","the merchant-ivory team continues to systematically destroy everything we hold dear about cinema , only now it's begun to split up so that it can do even more damage . ","what should have been a cutting hollywood satire is instead about as fresh as last week's issue of variety . ","hey everybody , wanna watch a movie in which a guy dressed as a children's party clown gets violently gang-raped ? i didn't think so . ","a little more intensity and a little less charm would have saved this film a world of hurt . ","dense and enigmatic . . . elusive . . . stagy and stilted","[t]his slop doesn't even have potential as a cult film , as it's too loud to shout insults at the screen . ","the movie's plot is almost entirely witless and inane , carrying every gag two or three times beyond its limit to sustain a laugh . "," . . . may work as an addictive guilty pleasure but the material never overcomes its questionable satirical ambivalence . this scarlet's letter is a . . . as in aimless , arduous , and arbitrary . ","plays like a glossy melodrama that occasionally verges on camp . ","the central character isn't complex enough to hold our interest . ","a modestly comic , modestly action-oriented world war ii adventure that , in terms of authenticity , is one of those films that requires the enemy to never shoot straight . ","a puppy dog so desperate for attention it nearly breaks its little neck trying to perform entertaining tricks . ","just about all of the film is confusing on one level or another , making ararat far more demanding than it needs to be . ","a little less extreme than in the past , with longer exposition sequences between them , and with fewer gags to break the tedium . ","there's a heavy stench of 'been there , done that' hanging over the film . it's everything you'd expect -- but nothing more . ","the biggest problem with satin rouge is lilia herself . she's a cipher , played by an actress who smiles and frowns but doesn't reveal an inner life . ","a quaint , romanticized rendering . ","what with the incessant lounge music playing in the film's background , you may mistake love liza for an adam sandler chanukah song . ","the movie's heavy-handed screenplay navigates a fast fade into pomposity and pretentiousness . ","a potentially good comic premise and excellent cast are terribly wasted . ","woody allen used to ridicule movies like hollywood ending . now he makes them . ","she's not yet an actress , not quite a singer . . . ","not a bad premise , but the execution is lackluster at best . ","been there done that . ","there is only so much baked cardboard i need to chew . ","a movie like the guys is why film criticism can be considered work . ","schnitzler's film has a great hook , some clever bits and well-drawn , if standard issue , characters , but is still only partly satisfying . ","even if it made its original release date last fall , it would've reeked of a been-there , done-that sameness . ","only two-fifths of a satisfying movie experience . ","a loud , ugly , irritating movie without any of its satirical salvos hitting a discernible target . ","[l]ame and unnecessary . ","a movie version of a paint-by-numbers picture . we can tell what it is supposed to be , but can't really call it a work of art . ","it's a brilliant , honest performance by nicholson , but the film is an agonizing bore except when the fantastic kathy bates turns up . bravado kathy ! "," . . . liotta is put in an impossible spot because his character's deceptions ultimately undo him and the believability of the entire scenario . too bad . ","you can thank me for this . i saw juwanna mann so you don't have to . ","unfunny and lacking any sense of commitment to or affection for its characters , the reginald hudlin comedy relies on toilet humor , ethnic slurs . ","basically , it's pretty but dumb . ","this romantic/comedy asks the question how much souvlaki can you take before indigestion sets in . ","squandering his opportunity to make absurdist observations , burns gets caught up in the rush of slapstick thoroughfare . ","there's a neat twist , subtly rendered , that could have wrapped things up at 80 minutes , but kang tacks on three or four more endings . ","reeboir varies between a sweet smile and an angry bark , while said attempts to wear down possible pupils through repetition . it has no affect on the kurds , but it wore me down . ","the actors improvise and scream their way around this movie directionless , lacking any of the rollicking dark humor so necessary to make this kind of idea work on screen . ","co-writer/director jonathan parker's attempts to fashion a brazil-like , hyper-real satire fall dreadfully short . ","if this silly little cartoon can inspire a few kids not to grow up to be greedy bastards , more power to it . ","a superfluous sequel . . . plagued by that old familiar feeling of 'let's get this thing over with' : everyone has shown up at the appointed time and place , but visible enthusiasm is mighty hard to find . ","if there's a heaven for bad movies , deuces wild is on its way . ","comes off like a bad imitation of the bard . ","what's missing in murder by numbers is any real psychological grounding for the teens' deviant behaviour . being latently gay and liking to read are hardly enough . ","an uninspired preachy and clichéd war film . ","horrendously amateurish filmmaking that is plainly dull and visually ugly when it isn't incomprehensible . ","a movie that harps on media-constructed 'issues' like whether compromise is the death of self… this orgasm [won't be an] exceedingly memorable one for most people . ","slackers' jokey approach to college education is disappointingly simplistic -- the film's biggest problem -- and there are no unforgettably stupid stunts or uproariously rude lines of dialogue to remember it by . ","if festival in cannes nails hard- boiled hollywood argot with a bracingly nasty accuracy , much about the film , including some of its casting , is frustratingly unconvincing . ","the movie is too impressed with its own solemn insights to work up much entertainment value . ","i haven't seen such self-amused trash since freddy got fingered . ","little more than a well-mounted history lesson . ","rob schneider's infantile cross-dressing routines fill the hot chick , the latest gimmick from this unimaginative comedian . ","a horrible , 99-minute stink bomb . ","the film is weighed down by supporting characters who are either too goodly , wise and knowing or downright comically evil . ","her fans walked out muttering words like  horrible  and  terrible ,  but had so much fun dissing the film that they didn't mind the ticket cost . in this case zero . ","the film is so bad it doesn't improve upon the experience of staring at a blank screen . ","sheridan's take on the author's schoolboy memoir . . . is a rather toothless take on a hard young life . ","it jumps around with little logic or continuity , presenting backstage bytes of information that never amount to a satisfying complete picture of this particular , anciently demanding métier . ","how i killed my father is one of those art house films that makes you feel like you're watching an iceberg melt -- only it never melts . ","when it comes to the battle of hollywood vs . woo , it looks like woo's a p . o . w . ","there are a few chuckles , but not a single gag sequence that really scores , and the stars seem to be in two different movies . ","the chateau has one very funny joke and a few other decent ones , but all it amounts to is a mildly funny , sometimes tedious , ultimately insignificant film . ","it's dull , spiritless , silly and monotonous : an ultra-loud blast of pointless mayhem , going nowhere fast . ","the mushy finale turns john q into a movie-of-the-week tearjerker . ","content merely to lionize its title character and exploit his anger - all for easy sanctimony , formulaic thrills and a ham-fisted sermon on the need for national health insurance . ","the movie turns out to be [assayas'] homage to the gallic 'tradition of quality , ' in all its fusty squareness . ","its message has merit and , in the hands of a brutally honest individual like prophet jack , might have made a point or two regarding life . ","[seems] even more uselessly redundant and shamelessly money-grubbing than most third-rate horror sequels . ","it's hard to imagine that even very small children will be impressed by this tired retread . ","neither as scary-funny as tremors nor demented-funny as starship troopers , the movie isn't tough to take as long as you've paid a matinee price . ","if swimfan does catch on , it may be because teens are looking for something to make them laugh . ","what might've been an exhilarating exploration of an odd love triangle becomes a sprawl of uncoordinated vectors . ","the master of disguise may have made a great saturday night live sketch , but a great movie it is not . ","it's quite an achievement to set and shoot a movie at the cannes film festival and yet fail to capture its visual appeal or its atmosphere . ","boll uses a lot of quick cutting and blurry step-printing to goose things up , but dopey dialogue and sometimes inadequate performances kill the effect . ","it's always disappointing when a documentary fails to live up to -- or offer any new insight into -- its chosen topic . unfortunately , that's precisely what arthur dong's family fundamentals does . ","has the marks of a septuagenarian ; it's a crusty treatment of a clever gimmick . ","like a medium-grade network sitcom--mostly inoffensive , fitfully amusing , but ultimately so weightless that a decent draft in the auditorium might blow it off the screen . ","something must have been lost in the translation . ","becomes the last thing you would expect from a film with this title or indeed from any plympton film : boring . ","in the end , the film feels homogenized and a bit contrived , as if we're looking back at a tattered and ugly past with rose-tinted glasses . ","chan's stunts are limited and so embellished by editing that there's really not much of a sense of action or even action-comedy . ","rock's stand-up magic wanes . hopkins , squarely fills the screen . action - mechanical . ","  the tuxedo  should have been the vehicle for chan that  the mask  was for jim carrey . alas , it's the man that makes the clothes . ","for casual moviegoers who stumble into rules expecting a slice of american pie hijinks starring the kid from dawson's creek , they'll probably run out screaming . ","the biggest problem i have ( other than the very sluggish pace ) is we never really see her esther blossom as an actress , even though her talent is supposed to be growing . ","what puzzles me is the lack of emphasis on music in britney spears' first movie . ","plot , characters , drama , emotions , ideas -- all are irrelevant to the experience of seeing the scorpion king . ","city by the sea is a gritty police thriller with all the dysfunctional family dynamics one could wish for . but how it washed out despite all of that is the project's prime mystery . ","whatever the movie's sentimental , hypocritical lessons about sexism , its true colors come out in various wet t-shirt and shower scenes . ","as a hybrid teen thriller and murder mystery , murder by numbers fits the profile too closely . ","there ain't a lot more painful than an unfunny movie that thinks it's hilarious . ","i enjoyed the movie in a superficial way , while never sure what its purpose was . ","what a pity . . . that the material is so second-rate . ","doesn't deliver a great story , nor is the action as gripping as in past seagal films . ","the kind of film that leaves you scratching your head in amazement over the fact that so many talented people could participate in such an ill-advised and poorly executed idea . ","nicks refuses to let slackers be seen as just another teen movie , which means he can be forgiven for frequently pandering to fans of the gross-out comedy . ","nothing about the film -- with the possible exception of elizabeth hurley's breasts -- is authentic . ","amid the cliché and foreshadowing , cage manages a degree of casual realism . . . that is routinely dynamited by blethyn . ","mostly , shafer and co-writer gregory hinton lack a strong-minded viewpoint , or a sense of humor . ","no cliche escapes the perfervid treatment of gang warfare called ces wild . ","eddie murphy and owen wilson have a cute partnership in i spy , but the movie around them is so often nearly nothing that their charm doesn't do a load of good . ","strictly a 'guy's film' in the worst sense of the expression . ","there's some good material in their story about a retail clerk wanting more out of life , but the movie too often spins its wheels with familiar situations and repetitive scenes . ","it's a lot to ask people to sit still for two hours and change watching such a character , especially when rendered in as flat and impassive a manner as phoenix's . ","there's something fishy about a seasonal holiday kids' movie . . . that derives its moment of most convincing emotional gravity from a scene where santa gives gifts to grownups . ","we're left with a story that tries to grab us , only to keep letting go at all the wrong moments . ","like many such biographical melodramas , it suffers from the awkwardness that results from adhering to the messiness of true stories . ","there is nothing redeeming about this movie . ","the film has [its] moments , but they are few and far between . ","a dreary indulgence . ","i was trying to decide what annoyed me most about god is great . . . i'm not , and then i realized that i just didn't care . ","derailed by bad writing and possibly also by some of that extensive post-production reworking to aim the film at young males in the throes of their first full flush of testosterone . ","deserves high marks for political courage but barely gets by on its artistic merits . "," . . . comes alive only when it switches gears to the sentimental . ","brosnan's finest non-bondish performance yet fails to overcome the film's manipulative sentimentality and annoying stereotypes . ","a film that will be best appreciated by those willing to endure its extremely languorous rhythms , waiting for happiness is ultimately thoughtful without having much dramatic impact . ","to me , it sounds like a cruel deception carried out by men of marginal intelligence , with reactionary ideas about women and a total lack of empathy . ","tsai may be ploughing the same furrow once too often . ","flashy gadgets and whirling fight sequences may look cool , but they can't distract from the flawed support structure holding equilibrium up . ","zigzag might have been richer and more observant if it were less densely plotted . ","[a] crushing disappointment . ","how can such a cold movie claim to express warmth and longing ? in truth , it has all the heart of a porno flick ( but none of the sheer lust ) . ","nicks and steinberg match their own creations for pure venality -- that's giving it the old college try . ","episode ii-- attack of the clones is a technological exercise that lacks juice and delight . ","the problem with all of this : it's not really funny . ","[denis'] bare-bones narrative more closely resembles an outline for a '70s exploitation picture than the finished product . ","wanders all over the map thematically and stylistically , and borrows heavily from lynch , jeunet , and von trier while failing to find a spark of its own . ","viewing this underdramatized but overstated film is like watching a transcript of a therapy session brought to humdrum life by some freudian puppet . ","overall tomfoolery like this is a matter of taste . ","the mantra behind the project seems to have been 'it's just a kids' flick . ' translation : 'we don't need to try very hard . '","in all the annals of the movies , few films have been this odd , inexplicable and unpleasant . ","it takes a really long , slow and dreary time to dope out what tuck everlasting is about . so here it is : it's about a family of sour immortals . ","an essentially awkward version of the lightweight female empowerment picture we've been watching for decades","the author's devotees will probably find it fascinating ; others may find it baffling . ","writer-director walter hill and co-writer david giler try to create characters out of the obvious cliches , but wind up using them as punching bags . ","there's a scientific law to be discerned here that producers would be well to heed : mediocre movies start to drag as soon as the action speeds up ; when the explosions start , they fall to pieces . ","a cockeyed shot all the way . ","lush and beautifully photographed ( somebody suggested the stills might make a nice coffee table book ) , but ultimately you'll leave the theater wondering why these people mattered . ","unfortunately , one hour photo lives down to its title . thanks largely to williams , all the interesting developments are processed in 60 minutes -- the rest is just an overexposed waste of film . ","cold , sterile and lacking any color or warmth . ","the film is undone by anachronistic quick edits and occasional jarring glimpses of a modern theater audience watching the events unfold . ","seems like someone going through the motions . ","for a film about explosions and death and spies ,  ballistic : ecks vs . sever  seems as safe as a children's film . well , in some of those , the mother deer even dies . ","wallace gets a bit heavy handed with his message at times , and has a visual flair that waxes poetic far too much for our taste . ","impostor doesn't do much with its template , despite a remarkably strong cast . ","wraps itself in the guise of a dark and quirky comedy , but it isn't as quirky as it thinks it is and its comedy is generally mean-spirited . ","choppy , overlong documentary about 'the lifestyle . '","one sloughs one's way through the mire of this alleged psychological thriller in search of purpose or even a plot . ","a film which presses familiar herzog tropes into the service of a limpid and conventional historical fiction , when really what we demand of the director is to be mesmerised . ","it's a fanboy 'what if ? ' brought to life on the big screen . ","the story itself is actually quite vapid . ","it's a hellish , numbing experience to watch , and it doesn't offer any insights that haven't been thoroughly debated in the media already , back in the dahmer heyday of the mid-'90s . ","wait for pay per view or rental but don't dismiss barbershop out of hand . ","a few zingers aside , the writing is indifferent , and jordan brady's direction is prosaic . ","each scene drags , underscoring the obvious , and sentiment is slathered on top . ","would've been nice if the screenwriters had trusted audiences to understand a complex story , and left off the film's predictable denouement . then nadia's birthday might not have been such a bad day after all . ","one of those staggeringly well-produced , joylessly extravagant pictures that keep whooshing you from one visual marvel to the next , hastily , emptily . ","nair just doesn't have the necessary self-control to guide a loose , poorly structured film through the pitfalls of incoherence and redundancy . ","enthusiastically taking up the current teen movie concern with bodily functions , walt becker's film pushes all the demographically appropriate comic buttons . ","it's the funniest american comedy since graffiti bridge . ","that neither protagonist has a distinguishable condition hardly matters because both are just actory concoctions , defined by childlike dimness and a handful of quirks . ","what starts off as a possible argentine american beauty reeks like a room stacked with pungent flowers . ","the project's filmmakers forgot to include anything even halfway scary as they poorly rejigger fatal attraction into a high school setting . ","in old-fashioned screenwriting parlance , ms . shreve's novel proved too difficult a text to 'lick , ' despite the efforts of a first-rate cast . ","solondz may well be the only one laughing at his own joke","stitch is a bad mannered , ugly and destructive little * * * * . no cute factor here… . not that i mind ugly ; the problem is he has no character , loveable or otherwise . ","deep down , i realized the harsh reality of my situation : i would leave the theater with a lower i . q . than when i had entered . ","a really funny fifteen-minute short stretched beyond its limits to fill an almost feature-length film . ","aside from the fact that the film idiotically uses the website feardotcom . com or the improperly hammy performance from poor stephen rea , the film gets added disdain for the fact that it is nearly impossible to look at or understand . ","it is bad , but certainly not without merit as entertainment . ","for its 100 minutes running time , you'll wait in vain for a movie to happen . ","a work that lacks both a purpose and a strong pulse . ","a faster paced family flick . upper teens may get cynical . smaller numbered kidlets will enjoy . ","while this film has an 'a' list cast and some strong supporting players , the tale -- like its central figure , vivi -- is just a little bit hard to love . ","it's a road-trip drama with too many wrong turns . ","most fish stories are a little peculiar , but this is one that should be thrown back in the river . ","it's all gratuitous before long , as if schwentke were fulfilling a gross-out quota for an anticipated audience demographic instead of shaping the material to fit the story . ","  i blame all men for war ,  [the warden's daughter] tells her father . the movie is about as deep as that sentiment . ","it's fitfully funny but never really takes off . ","i've seen some bad singer-turned actors , but lil bow wow takes the cake . ","by halfway through this picture i was beginning to hate it , and , of course , feeling guilty for it . . . . then , miracle of miracles , the movie does a flip-flop . ","for all the complications , it's all surprisingly predictable . ","it's been 20 years since 48 hrs . made eddie murphy a movie star and the man hasn't aged a day . but his showboating wise-cracker stock persona sure is getting old . ","if deuces wild had been tweaked up a notch it would have become a camp adventure , one of those movies that's so bad it starts to become good . but it wasn't . ","for a film about action , ultimate x is the gabbiest giant-screen movie ever , bogging down in a barrage of hype . "," . . . a low rate annie featuring some kid who can't act , only echoes of jordan , and weirdo actor crispin glover screwing things up old school . ","it might not be 1970s animation , but everything else about it is straight from the saturday morning cartoons – a retread story , bad writing , and the same old silliness . ","the picture seems uncertain whether it wants to be an acidic all-male all about eve or a lush , swooning melodrama in the intermezzo strain . ","tends to plod . ","a nearly 21/2 hours , the film is way too indulgent . ","gorgeous to look at but insufferably tedious and turgid . . . a curiously constricted epic . ","it looks much more like a cartoon in the end than the simpsons ever has . ","with a tighter editorial process and firmer direction this material could work , especially since the actresses in the lead roles are all more than competent , but as is , personal velocity seems to be idling in neutral . ","doesn't really add up to much . ","it's better suited for the history or biography channel , but there's no arguing the tone of the movie - it leaves a bad taste in your mouth and questions on your mind . ","an entertainment so in love with its overinflated mythology that it no longer recognizes the needs of moviegoers for real characters and compelling plots . ","a prolonged extrusion of psychopathic pulp . ","borrows from other movies like it in the most ordinary and obvious fashion . ","it's surprisingly bland despite the heavy doses of weird performances and direction . ","a chilly , remote , emotionally distant piece . . . so dull that its tagline should be : 'in space , no one can hear you snore . '","the characters seem one-dimensional , and the film is superficial and will probably be of interest primarily to its target audience . ","sorvino makes the princess seem smug and cartoonish , and the film only really comes alive when poor hermocrates and leontine pathetically compare notes about their budding amours . ","it's like a drive-by . you can drive right by it without noticing anything special , save for a few comic turns , intended and otherwise . ","everything -- even life on an aircraft carrier -- is sentimentalized . ","this would-be 'james bond for the extreme generation' pic is one big , dumb action movie . stress 'dumb . '","the movie has generic virtues , and despite a lot of involved talent , seems done by the numbers . ","when your subject is illusion versus reality , shouldn't the reality seem at least passably real ? ","it's a terrible movie in every regard , and utterly painful to watch . ","this is rote spookiness , with nary an original idea ( or role , or edit , or score , or anything , really ) in sight , and the whole of the proceedings beg the question 'why ? '","a fan film that for the uninitiated plays better on video with the sound turned down . ","too infuriatingly quirky and taken with its own style . ","there's a whole heap of nothing at the core of this slight coming-of-age/coming-out tale . ","as much as i laughed throughout the movie , i cannot mount a cogent defense of the film as entertainment , or even performance art , although the movie does leave you marveling at these guys' superhuman capacity to withstand pain . ","the type of dumbed-down exercise in stereotypes that gives the [teen comedy] genre a bad name . ","distinctly sub-par . . . more likely to drown a viewer in boredom than to send any shivers down his spine . ","plays like a bad blend of an overripe episode of tv's dawson's creek and a recycled and dumbed-down version of love story . ","unless you come in to the film with a skateboard under your arm , you're going to feel like you weren't invited to the party . ","when the casting call for this movie went out , it must have read 'seeking anyone with acting ambition but no sense of pride or shame . '","just isn't as weird as it ought to be . ","a  home alone  film that is staged like  rosemary's baby ,  but is not as well-conceived as either of those films . ","[siegel] and co-writers lisa bazadona and grace woodard have relied too much on convention in creating the characters who surround frankie . ","no film could possibly be more contemptuous of the single female population . ","`hey arnold ! ' has some visual wit . . . but little imagination elsewhere . ","they're going through the motions , but the zip is gone . ","a sluggish pace and lack of genuine narrative hem the movie in every bit as much as life hems in the spirits of these young women . ","a low-budget affair , tadpole was shot on digital video , and the images often look smeary and blurry , to the point of distraction . then again , in a better movie , you might not have noticed . ","it's mindless junk like this that makes you appreciate original romantic comedies like punch-drunk love . ","the movie is like a year late for tapping into our reality tv obsession , and even tardier for exploiting the novelty of the  webcast .  ","tale will be all too familiar for anyone who's seen george roy hill's 1973 film ,  the sting .  ","gets the look and the period trappings right , but it otherwise drowns in a sea of visual and verbal clichés . ","it's hard to quibble with a flick boasting this many genuine cackles , but notorious c . h . o . still feels like a promising work-in-progress . ","anyone who wants to start writing screenplays can just follow the same blueprint from hundreds of other films , sell it to the highest bidder and walk away without anyone truly knowing your identity . ","a major waste . . . generic . ","the problem with the bread , my sweet is that it's far too sentimental . ","a late-night cable sexploitation romp masquerading as a thriller about the ruthless social order that governs college cliques . ","falls short in explaining the music and its roots . ","never inspires more than an interested detachment . ","what might have emerged as hilarious lunacy in the hands of woody allen or mel brooks ( at least during their '70s heyday ) comes across as lame and sophomoric in this debut indie feature . ","despite slick production values and director roger michell's tick-tock pacing , the final effect is like having two guys yelling in your face for two hours . ","pretty much sucks , but has a funny moment or two . ","they do a good job of painting this family dynamic for the audience but they tried to squeeze too many elements into the film . ","a supernatural mystery that doesn't know whether it wants to be a suspenseful horror movie or a weepy melodrama . it ends up being neither , and fails at both endeavors . ","two badly interlocked stories drowned by all too clever complexity . ","it is so earnest , so overwrought and so wildly implausible that it begs to be parodied . ","these are textbook lives of quiet desperation . ","swimfan , like fatal attraction , eventually goes overboard with a loony melodramatic denouement in which a high school swimming pool substitutes for a bathtub . ","claims to sort the bad guys from the good , which is its essential problem . ","purposefully shocking in its eroticized gore , if unintentionally dull in its lack of poetic frissons . ","feels like pieces a bunch of other , better movies slapped together . ","almost everything about the film is unsettling , from the preposterous hairpiece worn by lai's villainous father to the endless action sequences . ","writer-director randall wallace has bitten off more than he or anyone else could chew , and his movie veers like a drunken driver through heavy traffic . ","it follows the blair witch formula for an hour , in which we're told something creepy and vague is in the works , and then it goes awry in the final 30 minutes . ","one can't shake the feeling that crossroads is nothing more than an hour-and-a-half-long commercial for britney's latest album . ","phoned-in business as usual . ","there's an epic here , but you have to put it together yourself . ","what little atmosphere is generated by the shadowy lighting , macabre sets , and endless rain is offset by the sheer ugliness of everything else . ","director-chef gabriele muccino keeps it fast -- zippy , comin' at ya -- as if fearing that his film is molto superficiale . ","tartakovsky's team has some freakish powers of visual charm , but the five writers slip into the modern rut of narrative banality . ","the most horrific movie experience i've had since  can't stop the music .  it may as well be called  jar-jar binks : the movie .  it's that painful . ","god is great , the movie's not . ","like a three-ring circus , there are side stories aplenty -- none of them memorable . ","when in doubt , the film ratchets up the stirring soundtrack , throws in a fish-out-of-water gag and lets the cliched dialogue rip . or else a doggie winks . ","a 'girls gone wild' video for the boho art-house crowd , the burning sensation isn't a definitive counter-cultural document -- its makers aren't removed and inquisitive enough for that . ","as original and insightful as last week's episode of behind the music . ","plays like john le carré with a couple of burnt-out cylinders . ","you may be galled that you've wasted nearly two hours of your own precious life with this silly little puddle of a movie . ","it's neither as sappy as big daddy nor as anarchic as happy gilmore or the waterboy , but it has its moments . ","despite the surface attractions -- conrad l . hall's cinematography will likely be nominated for an oscar next year -- there's something impressive and yet lacking about everything . ","a smug and convoluted action-comedy that doesn't allow an earnest moment to pass without reminding audiences that it's only a movie . ","[crystal and de niro] manage to squeeze out some good laughs but not enough to make this silly con job sing . ","worthless , from its pseudo-rock-video opening to the idiocy of its last frames . ","the christ allegory doesn't work because there is no foundation for it","go for la salle's performance , and make do as best you can with a stuttering script . ","it's hard to care about a film that proposes as epic tragedy the plight of a callow rich boy who is forced to choose between his beautiful , self-satisfied 22-year-old girlfriend and an equally beautiful , self-satisfied 18-year-old mistress . ","tries too hard to be funny in a way that's too loud , too goofy and too short of an attention span . ","i didn't find much fascination in the swinging . what they're doing is a matter of plumbing arrangements and mind games , of no erotic or sensuous charge . but that they are doing it is thought-provoking . ","the acting is just fine , but there's not enough substance here to sustain interest for the full 90 minutes , especially with the weak payoff . ","after collateral damage , you might imagine that most every aggrieved father cliché has been unturned . but no . ","ultimately the , yes , snail-like pacing and lack of thematic resonance make the film more silly than scary , like some sort of martha stewart decorating program run amok . ","releasing a film with the word 'dog' in its title in january lends itself to easy jokes and insults , and snow dogs deserves every single one of them . ","tedious norwegian offering which somehow snagged an oscar nomination . ","it was a dark and stormy night . . . ","a dark-as-pitch comedy that frequently veers into corny sentimentality , probably would not improve much after a therapeutic zap of shock treatment . ","this sort of cute and cloying material is far from zhang's forte and it shows . ","bray is completely at sea ; with nothing but a savage garden music video on his resume , he has no clue about making a movie . ","freundlich's made [crudup] a suburban architect , and a cipher . ","a huge disappointment coming , as it does , from filmmakers and performers of this calibre","though it pretends to expose the life of male hustlers , it's exploitive without being insightful . ","aimed squarely at the least demanding of demographic groups : very small children who will be delighted simply to spend more time with familiar cartoon characters . ","what starts off as a satisfying kids flck becomes increasingly implausible as it races through contrived plot points . ","exhibits the shallow sensationalism characteristic of soap opera . . . more salacious telenovela than serious drama . ","seagal is painfully foolish in trying to hold onto what's left of his passe' chopsocky glory . ","even with harris's strong effort , the script gives him little to effectively probe lear's soul-stripping breakdown . ","the story is bogus and its characters tissue-thin . ","whereas the extremely competent hitman films such as pulp fiction and get shorty resonate a sardonic verve to their caustic purpose for existing , who is cletis tout ? is an inexpressible and drab wannabe looking for that exact niche . ","while american adobo has its heart ( and its palate ) in the right place , its brain is a little scattered -- ditsy , even . "," . . . a confusing drudgery . ","imagine a film that begins as a seven rip-off , only to switch to a mix of the shining , the thing , and any naked teenagers horror flick from the 1980s . ","most of the dialogue made me want to pack raw dough in my ears . ","costner's warm-milk persona is just as ill-fitting as shadyac's perfunctory directing chops , and some of the more overtly silly dialogue would sink laurence olivier . ","it's coherent , well shot , and tartly acted , but it wears you down like a dinner guest showing off his doctorate . ","directed by kevin bray , whose crisp framing , edgy camera work , and wholesale ineptitude with acting , tone and pace very obviously mark him as a video helmer making his feature debut . ","turns a potentially interesting idea into an excruciating film school experience that plays better only for the film's publicists or for people who take as many drugs as the film's characters","robin williams departs from his fun friendly demeanor in exchange for a darker unnerving role . ","high crimes is a cinematic misdemeanor , a routine crime thriller remarkable only for its lack of logic and misuse of two fine actors , morgan freeman and ashley judd . ","set in a 1986 harlem that doesn't look much like anywhere in new york . ","the chocolate factory without charlie . ","long on twinkly-eyed close-ups and short on shame . ","hip-hop rarely comes alive as its own fire-breathing entity in this picture . ","a well-crafted letdown . ","a dull , somnambulant exercise in pretension whose pervasive quiet is broken by frequent outbursts of violence and noise . ","deserving of its critical backlash and more . ","boring and meandering . ","neither a rousing success nor a blinding embarrassment . still , it just sits there like a side dish no one ordered . ","the sum of all fears is remarkably fuddled about motives and context , which drains it of the dramatic substance that would shake us in our boots ( or cinema seats ) . ","the movie spends more time with schneider than with newcomer mcadams , even though her performance is more interesting ( and funnier ) than his . ","this low-rent -- and even lower-wit -- rip-off of the farrelly brothers' oeuvre gets way too mushy -- and in a relatively short amount of time . ","it recycles every cliché about gays in what is essentially an extended soap opera . ","i'm all for the mentally challenged getting their fair shot in the movie business , but surely it doesn't have to be as a collection of keening and self-mutilating sideshow geeks . ","may offend viewers not amused by the sick sense of humor . ","many of benjamins' elements feel like they've been patched in from an episode of miami vice . ","it aimlessly and unsuccessfully attempts to fuse at least three dull plots into one good one . ","most folks with a real stake in the american sexual landscape will find it either moderately amusing or just plain irrelevant . ","if you're not fans of the adventues of steve and terri , you should avoid this like the dreaded king brown snake . personally , i'd rather watch them on the animal planet . ","cherish is a dud -- a romantic comedy that's not the least bit romantic and only mildly funny . ","feels as if the inmates have actually taken over the asylum . ","all of the filmmakers' calculations can't rescue brown sugar from the curse of blandness . ","the movie's gloomy atmosphere is fascinating , though , even if the movie itself doesn't stand a ghost of a chance . "," . . . post-september 11 ,  the sum of all fears  seems more tacky and reprehensible , manipulating our collective fear without bestowing the subject with the intelligence or sincerity it unequivocally deserves . ","the exclamation point seems to be the only bit of glee you'll find in this dreary mess . ","no matter how you slice it , mark wahlberg and thandie newton are not hepburn and grant , two cinematic icons with chemistry galore . ","godard's ode to tackling life's wonderment is a rambling and incoherent manifesto about the vagueness of topical excess . . . in praise of love remains a ponderous and pretentious endeavor that's unfocused and tediously exasperating . ","humorless , self-conscious art drivel , made without a glimmer of intelligence or invention . ","the movie's progression into rambling incoherence gives new meaning to the phrase 'fatal script error . '","solondz may be convinced that he has something significant to say , but he isn't talking a talk that appeals to me . ","more tiring than anything . ","nelson's intentions are good , but the end result does no justice to the story itself . it's horribly depressing and not very well done . "," . . . the efforts of its star , kline , to lend some dignity to a dumb story are for naught . ","a good-natured ensemble comedy that tries hard to make the most of a bumper cast , but never quite gets off the ground . ","isn't it a bit early in his career for director barry sonnenfeld to do a homage to himself ? and it's a lousy one at that . ","overly long and worshipful bio-doc . ","i'll go out on a limb . it isn't quite one of the worst movies of the year . it's just merely very bad . ","writer-director ritchie reduces wertmuller's social mores and politics to tiresome jargon . ","about amy's cuteness , amy's career success ( she's a best-selling writer of self-help books who can't help herself ) , and amy's neuroses when it comes to men . ","everything about girls can't swim , even its passages of sensitive observation , feels secondhand , familiar -- and not in a good way . ","feels aimless for much of its running time , until late in the film when a tidal wave of plot arrives , leaving questions in its wake . ","less than fresh . ","in my own very humble opinion , in praise of love lacks even the most fragmented charms i have found in almost all of his previous works . ","the script is too mainstream and the psychology too textbook to intrigue . ","muddled , simplistic and more than a little pretentious . ","meandering and glacially paced , and often just plain dull . ","a disaster of a drama , saved only by its winged assailants . ","a road trip that will get you thinking , 'are we there yet ? '","director elie chouraqui , who co-wrote the script , catches the chaotic horror of war , but why bother if you're going to subjugate truth to the tear-jerking demands of soap opera ? ","dong never pushes for insights beyond the superficial tensions of the dynamic he's dissecting , and the film settles too easily along the contours of expectation . ","if there was any doubt that peter o'fallon didn't have an original bone in his body , a rumor of angels should dispel it . ","an occasionally interesting but mostly repetitive look at a slice of counterculture that might be best forgotten . ","what could have been right at home as a nifty plot line in steven soderbergh's traffic fails to arrive at any satisfying destination . ","the movie is like scorsese's mean streets redone by someone who ignored it in favor of old 'juvenile delinquent' paperbacks with titles like leather warriors and switchblade sexpot . ","this pathetic junk is barely an hour long . nevertheless , it still seems endless . ","it isn't that stealing harvard is a horrible movie—if only it were that grand a failure ! it's just that it's so not-at-all-good . and i expect much more from a talent as outstanding as director bruce mcculloch . ","dolman confines himself to shtick and sentimentality -- the one bald and the other sloppy . ","is it possible for a documentary to be utterly entranced by its subject and still show virtually no understanding of it ? ","it's supposed to be a romantic comedy - it suffers from too much norma rae and not enough pretty woman . ","the leads are so unmemorable , despite several attempts at lengthy dialogue scenes , that one eventually resents having to inhale this gutter romancer's secondhand material . ","the script ? please . ","staggers between flaccid satire and what is supposed to be madcap farce . ","not that any of us should be complaining when a film clocks in around 90 minutes these days , but the plotting here leaves a lot to be desired . ","brainy , artistic and muted , almost to the point of suffocation . ","plays like the old disease-of-the-week small-screen melodramas . ","like life on the island , the movie grows boring despite the scenery . ","the truth about charlie is that it's a brazenly misguided project . ","caso você sinta necessidade de sair da sala antes do término da projeção , não se preocupe : ninguém lhe enviará penas simbolizando covardia . ","displays the potential for a better movie than what bailly manages to deliver","so exaggerated and broad that it comes off as annoying rather than charming . ","an awkward hybrid of genres that just doesn't work . ","the latest vapid actor's exercise to appropriate the structure of arthur schnitzler's reigen . ","snipes is both a snore and utter tripe . ","ritchie's film is easier to swallow than wertmuller's polemical allegory , but it's self-defeatingly decorous . ","chalk it up as the worst kind of hubristic folly . ","it's the kind of under-inspired , overblown enterprise that gives hollywood sequels a bad name . ","rosenthal ( halloween ii ) seems to have forgotten everything he ever knew about generating suspense . ","even murphy's expert comic timing and famed charisma can't rescue this effort . ","rodriguez . . . was unable to reproduce the special spark between the characters that made the first film such a delight . ","a sleek advert for youthful anomie that never quite equals the sum of its pretensions . ","some body smacks of exhibitionism more than it does cathartic truth telling . ","this isn't a terrible film by any means , but it's also far from being a realized work . ","apparently , romantic comedy with a fresh point of view just doesn't figure in the present hollywood program . ","a lame comedy . ","depressingly thin and exhaustingly contrived . only masochistic moviegoers need apply . ","a movie that's held captive by mediocrity . not bad , but not all that good . bacon keeps things interesting , but don't go out of your way to pay full price . ","what's next ? rob schneider , dana carvey and sarah michelle gellar in the philadelphia story ? david spade as citizen kane ? ","can't seem to get anywhere near the story's center . ","the problem , amazingly enough , is the screenplay . ","it's a frankenstein-monster of a film that doesn't know what it wants to be . ","upper west sidey exercise in narcissism and self-congratulation disguised as a tribute . ","on its icy face , the new film is a subzero version of monsters , inc . , without the latter's imagination , visual charm or texture . ","i can't say this enough : this movie is about an adult male dressed in pink jammies . ","it's a mindless action flick with a twist -- far better suited to video-viewing than the multiplex . ","after a while , the only way for a reasonably intelligent person to get through the country bears is to ponder how a whole segment of pop-music history has been allowed to get wet , fuzzy and sticky . ","we get light showers of emotion a couple of times , but then -- strangely -- these wane to an inconsistent and ultimately unsatisfying drizzle . ","summer's far too fleeting to squander on offal like this . ","the film is grossly contradictory in conveying its social message , if indeed there is one . ","often lingers just as long on the irrelevant as on the engaging , which gradually turns what time is it there ? into how long is this movie ? ","too bad kramer couldn't make a guest appearance to liven things up . ","deuces wild is an encyclopedia of cliches that shoplifts shamelessly from farewell-to-innocence movies like the wanderers and a bronx tale without cribbing any of their intelligence . ","it's a barely tolerable slog over well-trod ground . ","epps has neither the charisma nor the natural affability that has made tucker a star . ","it's sweet . . . but just a little bit too precious at the start and a little too familiar at the end . ","a dull , dumb and derivative horror film . ","an awkwardly contrived exercise in magic realism . ","demme gets a lot of flavor and spice into his charade remake , but he can't disguise that he's spiffing up leftovers that aren't so substantial or fresh . ","this is a heartfelt story . . . it just isn't a very involving one . ","these self-styled athletes have banged their brains into the ground so frequently and furiously , their capacity to explain themselves has gone the same way as their natural instinct for self-preservation . ","the fact that the 'best part' of the movie comes from a 60-second homage to one of demme's good films doesn't bode well for the rest of it . ","richard pryor mined his personal horrors and came up with a treasure chest of material , but lawrence gives us mostly fool's gold . ","the band performances featured in drumline are red hot . . . [but] from a mere story point of view , the film's ice cold . "," . . . built on the premise that middle-class arkansas consists of monster truck-loving good ol' boys and peroxide blond honeys whose worldly knowledge comes from tv reruns and supermarket tabloids . ","a laughable -- or rather , unlaughable -- excuse for a film . ","the sequel is everything the original was not : contrived , overblown and tie-in ready . ","like a grinning jack o' lantern , its apparent glee is derived from a lobotomy , having had all its vital essence scooped out and discarded . ","a sentimental hybrid that could benefit from the spice of specificity . "," . . . familiar and predictable , and 4/5ths of it might as well have come from a xerox machine rather than ( writer-director ) franc . reyes' word processor . ","give shapiro , goldman , and bolado credit for good intentions , but there's nothing here that they couldn't have done in half an hour . ","it's so devoid of joy and energy it makes even jason x . . . look positively shakesperean by comparison . ","a little objectivity could have gone a long way . ","one of the worst films of 2002 . ","i believe silberling had the best intentions here , but he just doesn't have the restraint to fully realize them . ","plays like an unbalanced mixture of graphic combat footage and almost saccharine domestic interludes that are pure hollywood . ","mctiernan's remake may be lighter on its feet -- the sober-minded original was as graceful as a tap-dancing rhino -- but it is just as boring and as obvious . ","high crimes carries almost no organic intrigue as a government/ marine/legal mystery , and that's because the movie serves up all of that stuff , nearly subliminally , as the old-hat province of male intrigue . ","this movie is about the worst thing chan has done in the united states . ","the explosion essentially ruined -- or , rather , overpowered -- the fiction of the movie for me . ","this ludicrous film is predictable at every turn . ","an incredibly irritating comedy about thoroughly vacuous people . . . manages to embody the worst excesses of nouvelle vague without any of its sense of fun or energy . ","the film desperately sinks further and further into comedy futility . ","instead of a balanced film that explains the zeitgeist that is the x games , we get a cinematic postcard that's superficial and unrealized . ","the crassness of this reactionary thriller is matched only by the ridiculousness of its premise . ","i wish it would have just gone more over-the-top instead of trying to have it both ways . ","the superior plotline isn't quite enough to drag along the dead ( water ) weight of the other . ","the film doesn't really care about the thousands of americans who die hideously , it cares about how ryan meets his future wife and makes his start at the cia . ","adrift , bentley and hudson stare and sniffle , respectively , as ledger attempts , in vain , to prove that movie-star intensity can overcome bad hair design . ","after an hour and a half of wondering -- sometimes amusedly , sometimes impatiently -- just what this strenuously unconventional movie is supposed to be , you discover that the answer is as conventional as can be . ","'linklater fans , or pretentious types who want to appear avant-garde will suck up to this project . . . '","a woefully dull , redundant concept that bears more than a whiff of exploitation , despite iwai's vaunted empathy . ","screenwriter chris ver weil's directing debut is good-natured and never dull , but its virtues are small and easily overshadowed by its predictability . ","if you really want to understand what this story is really all about , you're far better served by the source material . ","it's mildly sentimental , unabashedly consumerist . . . studiously inoffensive and completely disposable . ","like its title character , esther kahn is unusual but unfortunately also irritating . ","the star who helped give a spark to  chasing amy  and  changing lanes  falls flat as thinking man cia agent jack ryan in this summer's new action film ,  the sum of all fears .  ","a summary of the plot doesn't quite do justice to the awfulness of the movie , for that comes through all too painfully in the execution . ","every conceivable mistake a director could make in filming opera has been perpetrated here . ","snoots will no doubt rally to its cause , trotting out threadbare standbys like 'masterpiece' and 'triumph' and all that malarkey , but rarely does an established filmmaker so ardently waste viewers' time with a gobbler like this . ","[the film's] taste for  shock humor  will wear thin on all but those weaned on the comedy of tom green and the farrelly brothers . ","any enjoyment will be hinge from a personal threshold of watching sad but endearing characters do extremely unconventional things . ","if legendary shlockmeister ed wood had ever made a movie about a vampire , it probably would look a lot like this alarming production , adapted from anne rice's novel the vampire chronicles . ","hardly a nuanced portrait of a young woman's breakdown , the film nevertheless works up a few scares . ","interminably bleak , to say nothing of boring . ","things really get weird , though not particularly scary : the movie is all portent and no content . ","it's difficult to discern if this is a crazy work of disturbed genius or merely 90 minutes of post-adolescent electra rebellion . ","bogs down badly as we absorb jia's moody , bad-boy behavior which he portrays himself in a one-note performance . ","the camera whirls ! the camera twirls ! oh , look at that clever angle ! wow , a jump cut ! ","demme finally succeeds in diminishing his stature from oscar-winning master to lowly studio hack . ","the action scenes have all the suspense of a 20-car pileup , while the plot holes are big enough for a train car to drive through -- if kaos hadn't blown them all up . ","it almost feels as if the movie is more interested in entertaining itself than in amusing us . ","it puts washington , as honest working man john q . archibald , on a pedestal , then keeps lifting the pedestal higher . ","ultimately , the film amounts to being lectured to by tech-geeks , if you're up for that sort of thing . ","far more enjoyable than its predecessor . ","[gayton's script] telegraphs every discovery and layers on the gloss of convenience . ","full frontal , which opens today nationwide , could almost be classified as a movie-industry satire , but it lacks the generous inclusiveness that is the genre's definitive , if disingenuous , feature . ","a ragbag of cliches . ","this rough trade punch-and-judy act didn't play well then and it plays worse now . ","a reality-snubbing hodgepodge . ","the three leads produce adequate performances , but what's missing from this material is any depth of feeling . ","it's possible that something hip and transgressive was being attempted here that stubbornly refused to gel , but the result is more puzzling than unsettling . ","this painfully unfunny farce traffics in tired stereotypes and encumbers itself with complications . . . that have no bearing on the story . ","short and sweet , but also more than anything else slight… tadpole pulls back from the consequences of its own actions and revelations . ","has its moments , but it's pretty far from a treasure . ","what more can be expected from a college comedy that's target audience hasn't graduated from junior high school ? ","collateral damage offers formula payback and the big payoff , but the explosions tend to simply hit their marks , pyro-correctly . ","the plan to make enough into ‘an inspiring tale of survival wrapped in the heart-pounding suspense of a stylish psychological thriller' has flopped as surely as a soufflé gone wrong . ","instead of letting the laughs come as they may , lawrence unleashes his trademark misogyny -- er , comedy -- like a human volcano or an overflowing septic tank , take your pick . ","you know that ten bucks you'd spend on a ticket ? just send it to cranky . we don't get paid enough to sit through crap like this . ","an even more predictable , cliche-ridden endeavor than its predecessor . ","the whole thing plays like a tired tyco ad . ","the film doesn't show enough of the creative process or even of what was created for the non-fan to figure out what makes wilco a big deal . ","the soupy end result has the odd distinction of being playful without being fun , too . ","no , i don't know why steven seagal is considered a star , nor why he keeps being cast in action films when none of them are ever any good or make any money . ","even by the intentionally low standards of frat-boy humor , sorority boys is a bowser . ","one well-timed explosion in a movie can be a knockout , but a hundred of them can be numbing . proof of this is ballistic : ecks vs . sever . ","halfway through , however , having sucked dry the undead action flick formula , blade ii mutates into a gross-out monster movie with effects that are more silly than scary . ","weighted down with slow , uninvolving storytelling and flat acting . ","we can't accuse kung pow for misfiring , since it is exactly what it wants to be : an atrociously , mind-numbingly , indescribably bad movie . unfortunately , we'd prefer a simple misfire . ","there isn't one moment in the film that surprises or delights . ","'wouldn't it be nice if all guys got a taste of what it's like on the other side of the bra ? '","the movie is essentially a series of fleetingly interesting actors' moments . ","most of the information has already appeared in one forum or another and , no matter how broomfield dresses it up , it tends to speculation , conspiracy theories or , at best , circumstantial evidence . ","this movie , a certain scene in particular , brought me uncomfortably close to losing my lunch . ","the secrets of time travel will have been discovered , indulged in and rejected as boring before i see this piece of crap again . ","smug , artificial , ill-constructed and fatally overlong . . . it never finds a consistent tone and lacks bite , degenerating into a pious , preachy soap opera . ","chelsea walls is a case of too many chefs fussing over too weak a recipe . ","every joke is repeated at least four times . every joke is repeated at least four times . every joke is repeated at least--annoying , isn't it ? ","comes across as a fairly weak retooling . ","the lousy lead performances . . . keep the movie from ever reaching the comic heights it obviously desired . ","its and pieces of the hot chick are so hilarious , and schneider's performance is so fine , it's a real shame that so much of the movie -- again , as in the animal -- is a slapdash mess . ","[creates] the worst kind of mythologizing , the kind that sacrifices real heroism and abject suffering for melodrama . ","the movie resolutely avoids all the comic possibilities of its situation , and becomes one more dumb high school comedy about sex gags and prom dates . ","earnest and heartfelt but undernourished and plodding . ","a sugar-coated rocky whose valuable messages are forgotten 10 minutes after the last trombone honks . ","romanek keeps adding flourishes -- artsy fantasy sequences -- that simply feel wrong . they cheapen the overall effect . ","has all the complexity and realistic human behavior of an episode of general hospital . ","an acceptable way to pass a little over an hour with moviegoers ages 8-10 , but it's unlikely to inspire anything more than a visit to mcdonald's , let alone some savvy street activism . ","[allen's] been making piffle for a long while , and hollywood ending may be his way of saying that piffle is all that the airhead movie business deserves from him right now . ","an exercise in cynicism every bit as ugly as the shabby digital photography and muddy sound . ","mildly amusing . ","not good enough to pass for a litmus test of the generation gap and not bad enough to repulse any generation of its fans . ","the movie is silly beyond comprehension , and even if it weren't silly , it would still be beyond comprehension . ","watchable up until the point where the situations and the dialogue spin hopelessly out of control -- that is to say , when carol kane appears on the screen . ","the scriptwriters are no less a menace to society than the film's characters . ","fairly run-of-the-mill . ","merchant hasn't directed this movie so much as produced it -- like sausage . ","the film has a nearly terminal case of the cutes , and it's neither as funny nor as charming as it thinks it is . ","more a gunfest than a rock concert . ","it's a frightful vanity film that , no doubt , pays off what debt miramax felt they owed to benigni . ","a muddy psychological thriller rife with miscalculations . it makes me say the obvious : abandon all hope of a good movie ye who enter here . ","mildly entertaining . ","it's not original enough . ","a listless sci-fi comedy in which eddie murphy deploys two guises and elaborate futuristic sets to no particularly memorable effect . ","terrible . ","little more than a super-sized infomercial for the cable-sports channel and its summer x games . ","degenerates into hogwash . ","a generic bloodbath that often becomes laughably unbearable when it isn't merely offensive . ","julie davis is the kathie lee gifford of film directors , sadly proving once again ego doesn't always go hand in hand with talent . ","an unholy mess , driven by the pathetic idea that if you shoot something on crummy-looking videotape , it must be labelled 'hip' , 'innovative' and 'realistic' . ","the story's pathetic and the gags are puerile . "," . curiously , super troopers suffers because it doesn't have enough vices to merit its 103-minute length . ","so bland and utterly forgettable that it might as well have been titled generic jennifer lopez romantic comedy . ","i was sent a copyof this film to review on dvd . for free . i still want my money back . ","it plods along methodically , somehow under the assumption that its  dead wife communicating from beyond the grave  framework is even remotely new or interesting . ","it's hard to believe that a relationship like holly and marina's could survive the hothouse emotions of teendom , and its longevity gets more inexplicable as the characterizations turn more crassly reductive . ","all too familiar . . . basically the sort of cautionary tale that was old when 'angels with dirty faces' appeared in 1938 . ","…passable enough for a shoot-out in the o . k . court house of life type of flick . strictly middle of the road . ","although purportedly a study in modern alienation , it's really little more than a particularly slanted , gay s/m fantasy , enervating and deadeningly drawn-out . ","after the first 10 minutes , which is worth seeing , the movie sinks into an abyss of clichés , depression and bad alternative music . ","no one can doubt the filmmakers' motives , but the guys still feels counterproductive . ","a very slow , uneventful ride around a pretty tattered old carousel . ","with little visible talent and no energy , colin hanks is in bad need of major acting lessons and maybe a little coffee . ","  feardotcom  has the makings of an interesting meditation on the ethereal nature of the internet and the otherworldly energies it could channel , but it simply becomes a routine shocker . ","a meatballs for the bare-midriff generation . ","well-meaning to a fault , antwone fisher manages the dubious feat of turning one man's triumph of will into everyman's romance comedy . ","seemingly disgusted with the lazy material and the finished product's unshapely look , director fisher stevens inexplicably dips key moments from the film in waking life water colors . ","formula 51 promises a new kind of high but delivers the same old bad trip . ","everything that was right about blade is wrong in its sequel . ","a few energetic stunt sequences briefly enliven the film , but the wheezing terrorist subplot hasn't the stamina for the 100-minute running time , and the protagonists' bohemian boorishness mars the spirit of good clean fun . ","the film was produced by jerry bruckheimer and directed by joel schumacher , and reflects the worst of their shallow styles : wildly overproduced , inadequately motivated every step of the way and demographically targeted to please every one ( and no one ) . ","disney again ransacks its archives for a quick-buck sequel . "," coarse , cliched and clunky , this trifling romantic comedy in which opposites attract for no better reason than that the screenplay demands it squanders the charms of stars hugh grant and sandra bullock . ","anyone who suffers through this film deserves , at the very least , a big box of consolation candy . ","how much you are moved by the emotional tumult of [françois and michèle's] relationship depends a lot on how interesting and likable you find them . ","they presume their audience won't sit still for a sociology lesson , however entertainingly presented , so they trot out the conventional science-fiction elements of bug-eyed monsters and futuristic women in skimpy clothes . ","collapses after 30 minutes into a slap-happy series of adolescent violence . ","the following things are not at all entertaining : the bad sound , the lack of climax and , worst of all , watching seinfeld ( who is also one of the film's producers ) do everything he can to look like a good guy . ","attal's hang-ups surrounding infidelity are so old-fashioned and , dare i say , outdated , it's a wonder that he couldn't have brought something fresher to the proceedings simply by accident . ","obvious , obnoxious and didactic burlesque . ","the most surprising thing about this film is that they are actually releasing it into theaters . ","michele is a such a brainless flibbertigibbet that it's hard to take her spiritual quest at all seriously . ","ultimately , clarity matters , both in breaking codes and making movies . enigma lacks it . ","potty-mouthed enough for pg-13 , yet not as hilariously raunchy as south park , this strangely schizo cartoon seems suited neither to kids or adults . "," . . . has its moments , but ultimately , its curmudgeon doesn't quite make the cut of being placed on any list of favorites . ","a distinctly minor effort that will be seen to better advantage on cable , especially considering its barely feature-length running time of one hour . ","most of the movie is so deadly dull that watching the proverbial paint dry would be a welcome improvement . ","in the end , tuck everlasting falls victim to that everlasting conundrum experienced by every human who ever lived : too much to do , too little time to do it in . ","rather less than the sum of its underventilated père-fils confrontations . ","mckay shows crushingly little curiosity about , or is ill-equipped to examine , the interior lives of the characters in his film , much less incorporate them into his narrative . ","plays like a series of vignettes -- clips of a film that are still looking for a common through-line . ","new yorkers always seem to find the oddest places to dwell . . . ","amid the shock and curiosity factors , the film is just a corny examination of a young actress trying to find her way . ","yes , spirited away is a triumph of imagination , but it's also a failure of storytelling . ","a characteristically engorged and sloppy coming-of-age movie . ","a somewhat disappointing and meandering saga . ","whenever you think you've seen the end of the movie , we cut to a new scene , which also appears to be the end . but , no , we get another scene , and then another . you begin to long for the end credits as the desert does for rain . ","an empty , ugly exercise in druggy trance-noir and trumped-up street credibility . ","the screenplay , co-written by director imogen kimmel , lacks the wit necessary to fully exploit the comic elements of the premise , making the proceedings more bizarre than actually amusing . ","the milieu is wholly unconvincing . . . and the histrionics reach a truly annoying pitch . ","unfunny comedy with a lot of static set ups , not much camera movement , and most of the scenes take place indoors in formal settings with motionless characters . ","each story is built on a potentially interesting idea , but the first two are ruined by amateurish writing and acting , while the third feels limited by its short running time . ","except for paymer as the boss who ultimately expresses empathy for bartleby's pain , the performances are so stylized as to be drained of human emotion . ","will no doubt delight plympton's legion of fans ; others may find 80 minutes of these shenanigans exhausting . ","the laughs are as rare as snake foo yung . ","for a film that celebrates radical , nonconformist values , what to do in case of fire ? lazily and glumly settles into a most traditional , reserved kind of filmmaking . ","knockaround guys plays like a student film by two guys who desperately want to be quentin tarantino when they grow up . but they lack their idol's energy and passion for detail . ","mattei so completely loses himself to the film's circular structure to ever offer any insightful discourse on , well , love in the time of money . ","it briefly flirts with player masochism , but the point of real interest -– audience sadism -- is evaded completely . ","holland lets things peter out midway , but it's notably better acted -- and far less crass - than some other recent efforts in the burgeoning genre of films about black urban professionals . ","for every articulate player , such as skateboarder tony hawk or bmx rider mat hoffman , are about a half dozen young turks angling to see how many times they can work the words  radical  or  suck  into a sentence . ","there's not a fresh idea at the core of this tale . ","an impenetrable and insufferable ball of pseudo-philosophic twaddle . ","it's unfortunate that wallace , who wrote gibson's braveheart as well as the recent pearl harbor , has such an irrepressible passion for sappy situations and dialogue . ","i liked the movie , but i know i would have liked it more if it had just gone that one step further . i'm left slightly disappointed that it didn't . ","dreary tale of middle-class angst","for a movie about the power of poetry and passion , there is precious little of either . ","[jackson and bledel] seem to have been picked not for their acting chops , but for their looks and appeal to the pre-teen crowd . ","lillard and cardellini earn their scooby snacks , but not anyone else . ","like schindler's list , the grey zone attempts to be grandiloquent , but ends up merely pretentious -- in a grisly sort of way . ","an unremittingly ugly movie to look at , listen to , and think about , it is quite possibly the sturdiest example yet of why the dv revolution has cheapened the artistry of making a film . ","[screenwriter] pimental took the farrelly brothers comedy and feminized it , but it is a rather poor imitation . ","it's kind of sad that so many people put so much time and energy into this turkey . ","friday after next is a lot more bluster than bite . ","its juxtaposition of overwrought existentialism and stomach-churning gore will have you forever on the verge of either cracking up or throwing up . ","a decidedly mixed bag . ","meandering and confusing . ","there are cheesy backdrops , ridiculous action sequences , and many tired jokes about men in heels . ","ice cube isn't quite out of ripe screwball ideas , but friday after next spreads them pretty thin . ","not everything in the film works , including its somewhat convenient ending . ","the characters , cast in impossibly contrived situations , are totally estranged from reality . ","everything else about high crimes is , like the military system of justice it portrays , tiresomely regimented . ","just dreadful . i don't blame eddie murphy but shouldn't owen wilson know a movie must have a story and a script ? ","sweet home alabama certainly won't be remembered as one of [witherspoon's] better films . ","hard as this may be to believe , here on earth , a surprisingly similar teen drama , was a better film . ","this is just lazy writing . even kids deserve better . ","the pretensions -- and disposable story -- sink the movie . and diesel isn't the actor to save it . ","bravo reveals the true intent of her film by carefully selecting interview subjects who will construct a portrait of castro so predominantly charitable it can only be seen as propaganda . "," . . . a preachy parable stylized with a touch of john woo bullet ballet . ","frank capra played this story straight . but the 2002 film doesn't really believe in it , and breaks the mood with absurdly inappropriate 'comedy' scenes . ","how about starting with a more original story instead of just slapping extreme humor and gross-out gags on top of the same old crap ? ","the problem is that for the most part , the film is deadly dull . ","handled correctly , wilde's play is a masterpiece of elegant wit and artifice . here , alas , it collapses like an overcooked soufflé . ","  sorority boys  was funnier , and that movie was pretty bad . ","a bizarre piece of work , with premise and dialogue at the level of kids' television and plot threads as morose as teen pregnancy , rape and suspected murder","paul bettany is good at being the ultra-violent gangster wannabe , but the movie is certainly not number 1 . ","it's a gag that's worn a bit thin over the years , though don't ask still finds a few chuckles . ","an uplifting drama . . . what antwone fisher isn't , however , is original . ","often likable , but just as often it's meandering , low on energy , and too eager to be quirky at moments when a little old-fashioned storytelling would come in handy . ","certain to be distasteful to children and adults alike , eight crazy nights is a total misfire . ","elaborate special effects take centre screen , so that the human story is pushed to one side . ","showtime isn't particularly assaultive , but it can still make you feel that you never want to see another car chase , explosion or gunfight again . ","all the characters are clinically depressed and have abandoned their slim hopes and dreams . ","this tuxedo . . . should have been sent back to the tailor for some major alterations . ","i have no problem with  difficult  movies , or movies that ask the audience to meet them halfway and connect the dots instead of having things all spelled out . but first , you have to give the audience a reason to <b>want</b> to put for that effort , and  i","been there , done that . . . a thousand times already , and better . ","what's most offensive isn't the waste of a good cast , but the film's denial of sincere grief and mourning in favor of bogus spiritualism . ","sunk by way too much indulgence of scene-chewing , teeth-gnashing actorliness . ","fans of plympton's shorts may marginally enjoy the film , but it is doubtful this listless feature will win him any new viewers . ","barrels along at the start before becoming mired in sentimentality . ","none of this sounds promising and , indeed , the first half of sorority boys is as appalling as any 'comedy' to ever spill from a projector's lens . ","the kind of movie that leaves vague impressions and a nasty aftertaste but little clear memory of its operational mechanics . ","'punch-drunk love is so convinced of its own brilliance that , if it were a person , you'd want to smash its face in . '","at once overly old-fashioned in its sudsy plotting and heavy-handed in its effort to modernize it with encomia to diversity and tolerance . ","the trashy teen-sleaze equivalent of showgirls . ","while the production details are lavish , film has little insight into the historical period and its artists , particularly in how sand developed a notorious reputation . ","a crass and insulting homage to great films like some like it hot and the john wayne classics . ","what's the most positive thing that can be said about the new rob schneider vehicle ? well , it's not as pathetic as the animal . ","with all the sympathy , empathy and pity fogging up the screen . . . his secret life enters the land of unintentional melodrama and tiresome love triangles . ","the problematic characters and overly convenient plot twists foul up shum's good intentions . ","what 'blade runner' would've looked like as a low-budget series on a uhf channel . ","doesn't add up to much . ","has all the values of a straight-to-video movie , but because it has a bigger-name cast , it gets a full theatrical release . ","with its lackadaisical plotting and mindless action , all about the benjamins evokes the bottom tier of blaxploitation flicks from the 1970s . ","it never quite makes it to the boiling point , but manages to sustain a good simmer for most of its running time . ","loud , silly , stupid and pointless . ","mandel holland's direction is uninspired , and his scripting unsurprising , but the performances by phifer and black are ultimately winning . you'll find yourself wishing that you and they were in another movie . ","a yawn-provoking little farm melodrama . ","did no one on the set have a sense of humor , or did they not have the nerve to speak up ? ","crummy","seriously , rent the disney version . ","as david letterman and the onion have proven , the worst of tragedies can be fertile sources of humor , but lawrence has only a fleeting grasp of how to develop them . ","like its parade of predecessors , this halloween is a gory slash-fest . it can't escape its past , and it doesn't want to . ","  abandon  will leave you wanting to abandon the theater . ","problem is , we have no idea what in creation is going on . ","a live-action cartoon , a fast-moving and cheerfully simplistic 88 minutes of exaggerated action put together with the preteen boy in mind . ","a loquacious and dreary piece of business . ","what the audience feels is exhaustion , from watching a movie that is dark ( dark green , to be exact ) , sour , bloody and mean . ","director hoffman , his writer and kline's agent should serve detention","dodgy mixture of cutesy romance , dark satire and murder mystery . ","meticulously mounted , exasperatingly well-behaved film , which ticks off kahlo's lifetime milestones with the dutiful precision of a tax accountant . ","time of favor could have given audiences the time of day by concentrating on the elements of a revealing alienation among a culture of people who sadly are at hostile odds with one another through recklessness and retaliation . ","i'm not sure which will take longer to heal : the welt on johnny knoxville's stomach from a riot-control projectile or my own tortured psyche . ","while serving sara does have a long way to go before it reaches the level of crudity in the latest austin powers extravaganza , there's nothing here to match that movie's intermittent moments of inspiration . ","i'm not sure which is worse : the poor acting by the ensemble cast , the flat dialogue by vincent r . nebrida or the gutless direction by laurice guillen . ","the only reason you should see this movie is if you have a case of masochism and an hour and a half to blow . ","whatever about warning kids about the dangers of ouija boards , someone should dispense the same advice to film directors . ","as with so many merchandised-to-the-max movies of this type , more time appears to have gone into recruiting the right bands for the playlist and the costuming of the stars than into the script , which has a handful of smart jokes and not much else . ","the irwins' scenes are fascinating ; the movie as a whole is cheap junk and an insult to their death-defying efforts . ","if routine action and jokes like this are your cup of tea , then pay your $8 and get ready for the big shear . this is one baaaaaaaaad movie . ","a man leaving the screening said the film was better than saving private ryan . he may have meant the internet short saving ryan's privates . but windtalkers doesn't beat that one , either . ","may puzzle his most ardent fans . ","starts as a tart little lemon drop of a movie and ends up as a bitter pill . ","we never feel anything for these characters , and as a result the film is basically just a curiosity . ","those unfamiliar with mormon traditions may find the singles ward occasionally bewildering . ","ritchie may not have a novel thought in his head , but he knows how to pose madonna . ","the story , touching though it is , does not quite have enough emotional resonance or variety of incident to sustain a feature , and even at 85 minutes it feels a bit long . ","feels like the work of an artist who is simply tired -- of fighting the same fights , of putting the weight of the world on his shoulders , of playing with narrative form . ","while you have to admit it's semi-amusing to watch robert deniro belt out  when you're a jet , you're a jet all the way ,  it's equally distasteful to watch him sing the lyrics to  tonight .  ","an opportunity missed . ","the whole mess boils down to a transparently hypocritical work that feels as though it's trying to set the women's liberation movement back 20 years . ","' . . . the cast portrays their cartoon counterparts well . . . but quite frankly , scoob and shag don't eat enough during the film . '","more of the same old garbage hollywood has been trying to pass off as acceptable teen entertainment for some time now . ","tv skit-com material fervently deposited on the big screen . ","[johnnie to and wai ka fai are] sure to find an enthusiastic audience among american action-adventure buffs , but the film's interests may be too narrow to attract crossover viewers . ","if there was ever a movie where the upbeat ending feels like a copout , this is the one . ","it's as sorry a mess as its director's diabolical debut , mad cows . ","any attempts at nuance given by the capable cast is drowned out by director jon purdy's sledgehammer sap . ","its audacious ambitions sabotaged by pomposity , steven soderbergh's space opera emerges as a numbingly dull experience . ","despite some strong performances , never rises above the level of a telanovela . ","this is a picture that maik , the firebrand turned savvy ad man , would be envious of : it hijacks the heat of revolution and turns it into a sales tool . ","feels slight , as if it were an extended short , albeit one made by the smartest kids in class . ","unspeakable , of course , barely begins to describe the plot and its complications . vulgar is too optimistic a title . ","the actors pull out all the stops in nearly every scene , but to diminishing effect . the characters never change . ","if the last man were the last movie left on earth , there would be a toss-up between presiding over the end of cinema as we know it and another night of delightful hand shadows . ","welles groupie/scholar peter bogdanovich took a long time to do it , but he's finally provided his own broadside at publishing giant william randolph hearst . ","makes the same mistake as the music industry it criticizes , becoming so slick and watered-down it almost loses what made you love it in the first place . ","even as i valiantly struggled to remain interested , or at least conscious , i could feel my eyelids . . . getting . . . very . . . heavy . . . ","a bad movie that happened to good actors . ","wishy-washy . ","boasts eye-catching art direction but has a forcefully quirky tone that quickly wears out its limited welcome . ","screenwriter dan schneider and director shawn levy substitute volume and primary colors for humor and bite . ","oversexed , at times overwrought comedy/drama that offers little insight into the experience of being forty , female and single . ","that such a horrible movie could have sprung from such a great one is one of the year's worst cinematic tragedies . ","it all starts to smack of a hallmark hall of fame , with a few four letter words thrown in that are generally not heard on television . ","rarely has a film's title served such dire warning . ","if you saw benigni's pinocchio at a public park , you'd grab your kids and run and then probably call the police . ","the animation is competent , and some of the gags are quite funny , but jonah . . . never shakes the oppressive , morally superior good-for-you quality that almost automatically accompanies didactic entertainment . ","the pace of the film is very slow ( for obvious reasons ) and that too becomes off-putting . ","mr . wollter and ms . seldhal give strong and convincing performances , but neither reaches into the deepest recesses of the character to unearth the quaking essence of passion , grief and fear . ","shafer's feature doesn't offer much in terms of plot or acting . ","in his role of observer of the scene , lawrence sounds whiny and defensive , as if his life-altering experiences made him bitter and less mature . ","[t]he ideas of revolution #9 are more compelling than the execution","the film didn't convince me that calvin jr . 's barbershop represents some sort of beacon of hope in the middle of chicago's south side . ","what happens when something goes bump in the night and nobody cares ? ","despite some comic sparks , welcome to collinwood never catches fire . ","director george hickenlooper has had some success with documentaries , but here his sense of story and his juvenile camera movements smack of a film school undergrad , and his maudlin ending might not have gotten him into film school in the first place . ","shows moments of promise but ultimately succumbs to cliches and pat storytelling . ","even accepting this in the right frame of mind can only provide it with so much leniency . ","some body is a shaky , uncertain film that nevertheless touches a few raw nerves . ","all the small moments and flashbacks don't add up to much more than trite observations on the human condition . ","[a] stale retread of the '53 original . ","one thing's for sure—if george romero had directed this movie , it wouldn't have taken the protagonists a full hour to determine that in order to kill a zombie you must shoot it in the head . ","for dance completists only . ","one of the worst movies of the year . ","spreads itself too thin , leaving these actors , as well as the members of the commune , short of profound characterizations","it wouldn't matter so much that this arrogant richard pryor wannabe's routine is offensive , puerile and unimaginatively foul-mouthed if it was at least funny . ","the locale . . . remains far more interesting than the story at hand . ","yo , it's the days of our lives meets electric boogaloo . ","inconsequential road-and-buddy pic . ","i liked the original short story but this movie , even at an hour and twenty-some minutes , it's too long and it goes nowhere . ","this little film is so slovenly done , so primitive in technique , that it can't really be called animation . ","makes 98 minutes feel like three hours . ","hawke's film , a boring , pretentious waste of nearly two hours , doesn't tell you anything except that the chelsea hotel today is populated by whiny , pathetic , starving and untalented artistes . ","aspires to the cracked lunacy of the adventures of buckaroo banzai , but thanks to an astonishingly witless script ends up more like the adventures of ford fairlane . ","real-life strongman ahola lacks the charisma and ability to carry the film on his admittedly broad shoulders . ","the title , alone , should scare any sane person away . ","low comedy doesn't come much lower . ","appropriately cynical social commentary aside , #9 never quite ignites . ","it's crap on a leash--far too polite to scale the lunatic heights of joe dante's similarly styled gremlins . ","one of the most depressing movie-going experiences i can think of is to sit through about 90 minutes of a so-called 'comedy' and not laugh once . ","this is the kind of movie where the big scene is a man shot out of a cannon into a vat of ice cream . ","let's face it -- there aren't many reasons anyone would want to see crossroads if they're not big fans of teen pop kitten britney spears . ","a loud , brash and mainly unfunny high school comedy . ","an exceptionally dreary and overwrought bit of work , every bit as imperious as katzenberg's the prince of egypt from 1998 . ","insufferably naive . ","the movie is so resolutely cobbled together out of older movies that it even uses a totally unnecessary prologue , just because it seems obligatory . ","the movie's vision of a white american zealously spreading a puritanical brand of christianity to south seas islanders is one only a true believer could relish . ","maid in manhattan proves that it's easier to change the sheets than to change hackneyed concepts when it comes to dreaming up romantic comedies . ","a fairly harmless but ultimately lifeless feature-length afterschool special . ","i can't remember the last time i saw a movie where i wanted so badly for the protagonist to fail . ","ill-considered , unholy hokum . ","amazingly lame . "," . . . the whole thing succeeded only in making me groggy . ","like most of jaglom's films , some of it is honestly affecting , but more of it seems contrived and secondhand . ","one long , numbing action sequence made up mostly of routine stuff yuen has given us before . ","forgettable , if good-hearted , movie . ","the film's most improbable feat ? it didn't go straight to video . "," . . . about as exciting to watch as two last-place basketball teams playing one another on the final day of the season . ","the chateau . . . is less concerned with cultural and political issues than doting on its eccentric characters . ","cruel and inhuman cinematic punishment . . . simultaneously degrades its characters , its stars and its audience . ","it's not too fast and not too slow . it's not too racy and it's not too offensive . it's not too much of anything . ","the great pity is that those responsible didn't cut their losses – and ours – and retitle it the adventures of direct-to-video nash , and send it to its proper home . ","about as original as a gangster sweating bullets while worrying about a contract on his life . ","an empty shell of an epic rather than the real deal . ","we could have expected a little more human being , and a little less product . ","instead of using george and lucy's most obvious differences to ignite sparks , lawrence desperately looks elsewhere , seizing on george's haplessness and lucy's personality tics . ","whether quitting will prove absorbing to american audiences is debatable . ","becomes a bit of a mishmash : a tearjerker that doesn't and a thriller that won't . ","family togetherness takes a back seat to inter-family rivalry and workplace ambition&#133 ; whole subplots have no explanation or even plot relevance . ","grant isn't cary and bullock isn't katherine . ","like a fish that's lived too long , austin powers in goldmember has some unnecessary parts and is kinda wrong in places . ","two tedious acts light on great scares and a good surprise ending . ","shyamalan should stop trying to please his mom . ","the entire movie is in need of a scented bath . ","i'm sorry to say that this should seal the deal - arnold is not , nor will he be , back . ","the story of trouble every day . . . is so sketchy it amounts to little more than preliminary notes for a science-fiction horror film , and the movie's fragmentary narrative style makes piecing the story together frustrating difficult . ","a movie to forget","for all of its insights into the dream world of teen life , and its electronic expression through cyber culture , the film gives no quarter to anyone seeking to pull a cohesive story out of its 2 1/2-hour running time . ","enough is not a bad movie , just mediocre . the performances are so overstated , the effect comes off as self-parody . ","it looks good , but it is essentially empty . ","the film never finds its tone and several scenes run too long . ","the idea is more interesting than the screenplay , which lags badly in the middle and lurches between not-very-funny comedy , unconvincing dramatics and some last-minute action strongly reminiscent of run lola run . ","van wilder has a built-in audience , but only among those who are drying out from spring break and are still unconcerned about what they ingest . ","a complete waste of time . ","it's hard to believe that something so short could be so flabby . ","do we really need another film that praises female self-sacrifice ? ","the major problem with windtalkers is that the bulk of the movie centers on the wrong character . ","tennessee williams by way of oprah's book club . ","so verbally flatfooted and so emotionally predictable or bland that it plays like the standard made-for-tv movie . ","the entire point of a shaggy dog story , of course , is that it goes nowhere , and this is classic nowheresville in every sense . ","stale and clichéd to a fault . ","this film is too busy hitting all of its assigned marks to take on any life of its own . ","watching junk like this induces a kind of abstract guilt , as if you were paying dues for good books unread , fine music never heard . ","the script feels as if it started to explore the obvious voyeuristic potential of 'hypertime' but then backed off when the producers saw the grosses for spy kids . ","starts off witty and sophisticated and you want to love it -- but filmmaker yvan attal quickly writes himself into a corner . ","some like it hot on the hardwood proves once again that a man in drag is not in and of himself funny . ","unfortunately , contrived plotting , stereotyped characters and woo's over-the-top instincts as a director undermine the moral dilemma at the movie's heart . ","witless and utterly pointless . ","when 'science fiction' takes advantage of the fact that its intended audience hasn't yet had much science , it does a disservice to the audience and to the genre . ","show me the mugging . ","represents something very close to the nadir of the thriller/horror genre . ","visually sumptuous but intellectually stultifying . ","as a feature-length film , it wears out its welcome as tryingly as the title character . ","a guilty pleasure at best , and not worth seeing unless you want to laugh at it . ","a sleep-inducing thriller with a single twist that everyone except the characters in it can see coming a mile away . ","with a  spy kids  sequel opening next week , why bother with a contemptible imitator starring a  snl  has-been acting like an 8-year-old channeling roberto benigni ? ","it's just rather leaden and dull . ","lacks the visual flair and bouncing bravado that characterizes better hip-hop clips and is content to recycle images and characters that were already tired 10 years ago . ","'pocas ideas interesantes , un final pseudo místico que no corresponde al tono general del filme y que deja una sensación de inconformidad que hace pensar más de una vez si vale la pena ir a la taquilla y reclamar el precio del boleto . '","statham employs an accent that i think is supposed to be an attempt at hardass american but sometimes just lapses into unhidden british . ","instead of trying to bust some blondes , [diggs] should be probing why a guy with his talent ended up in a movie this bad . ","initial strangeness inexorably gives way to rote sentimentality and mystical tenderness becomes narrative expedience . ","de ayala is required to supply too much of the energy in a film that is , overall , far too staid for its subject matter . ","dismally dull sci-fi comedy . ","there's surely something wrong with a comedy where the only belly laughs come from the selection of outtakes tacked onto the end credits . ","when one hears harry shearer is going to make his debut as a film director , one would hope for the best","the leads we are given here are simply too bland to be interesting . ","[toback's] fondness for fancy split-screen , stuttering editing and pompous references to wittgenstein and kirkegaard . . . blends uneasily with the titillating material . ","adam sandler's 8 crazy nights is 75 wasted minutes of sandler as the voice-over hero in columbia pictures' perverse idea of an animated holiday movie . ","essentially  fatal attraction  remade for viewers who were in diapers when the original was released in 1987 . . . . this story gets sillier , not scarier , as it goes along . . . ","even a hardened voyeur would require the patience of job to get through this interminable , shapeless documentary about the swinging subculture . ","the film's hero is a bore and his innocence soon becomes a questionable kind of inexcusable dumb innocence . ","a singularly off-putting romantic comedy . ","this is an exercise not in biography but in hero worship . ","it all comes down to whether you can tolerate leon barlow . i can't . ","in the spirit of the season , i assign one bright shining star to roberto benigni's pinocchio -- but i guarantee that no wise men will be following after it . ","check your brain and your secret agent decoder ring at the door because you don't want to think too much about what's going on . the movie does has some entertainment value - how much depends on how well you like chris rock . ","a movie that seems motivated more by a desire to match mortarboards with dead poets society and good will hunting than by its own story . ","a culture clash comedy only half as clever as it thinks it is . ","the logic of it all will be greek to anyone not predisposed to the movie's rude and crude humor . ","as self-aware movies go , who is cletis tout ? is clever enough , though thin writing proves its undoing . ","starts out strongly before quickly losing its focus , point and purpose in a mess of mixed messages , over-blown drama and bruce willis with a scar . "," . . . a fascinating curiosity piece -- fascinating , that is , for about ten minutes . after that it becomes long and tedious like a classroom play in a college history course . ","director jay russell weighs down his capricious fairy-tale with heavy sentiment and lightweight meaning . ","there are many things that solid acting can do for a movie , but crafting something promising from a mediocre screenplay is not one of them . ","its screenplay serves as auto-critique , and its clumsiness as its own most damning censure . ","at times , it actually hurts to watch . ","nemesis suffers from a paunchy midsection , several plodding action sequences and a wickedly undramatic central theme . ","the jokes are telegraphed so far in advance they must have been lost in the mail . ","[tries] to parody a genre that's already a joke in the united states . the movie is the equivalent of french hip-hop , which also seems to play on a 10-year delay . ","a beyond-lame satire , teddy bears' picnic ranks among the most pitiful directing debuts by an esteemed writer-actor . ","long before it's over , you'll be thinking of 51 ways to leave this loser . ","i've never seen ( a remake ) do anything as stomach-turning as the way adam sandler's new movie rapes , pillages and incinerates frank capra's classic . . . ","hollywood's answer to an air ball . ","and people make fun of me for liking showgirls</> . ","such a wildly uneven hit-and-miss enterprise , you can't help suspecting that it was improvised on a day-to-day basis during production . ","a weird little movie that's amusing enough while you watch it , offering fine acting moments and pungent insights into modern l . a . 's show-biz and media subcultures . but it doesn't leave you with much . ","i'm convinced i could keep a family of five blind , crippled , amish people alive in this situation better than these british soldiers do at keeping themselves kicking . ","like mike is a slight and uninventive movie : like the exalted michael jordan referred to in the title , many can aspire but none can equal . ","there is nothing funny in this every-joke-has- been-told-a- thousand-times- before movie . ","always destined to be measured against anthony asquith's acclaimed 1952 screen adaptation . ","this is standard crime drama fare . . . instantly forgettable and thoroughly dull . ","there's some outrageously creative action in the transporter . . . [b]ut by the time frank parachutes down onto a moving truck , it's just another cartoon with an unstoppable superman . ","one of those based-on-truth stories that persuades you , with every scene , that it could never really have happened this way . ","from its nauseating spinning credits sequence to a very talented but underutilized supporting cast , bartleby squanders as much as it gives out . ","yet another genre exercise , gangster no . 1 is as generic as its title . ","despite the holes in the story and the somewhat predictable plot , moments of the movie caused me to jump in my chair . . . ","there's an admirable rigor to jimmy's relentless anger , and to the script's refusal of a happy ending , but as those monologues stretch on and on , you realize there's no place for this story to go but down . ","once again , the intelligence of gay audiences has been grossly underestimated , and a meaty plot and well-developed characters have been sacrificed for skin and flash that barely fizzle . ","a lightweight , uneven action comedy that freely mingles french , japanese and hollywood cultures . ","[a] slummer . ","such a fine idea for a film , and such a stultifying , lifeless execution . ","[allen's] best works understand why snobbery is a better satiric target than middle-america diversions could ever be . ","this overlong infomercial , due out on video before month's end , is tepid and tedious . ","an ambitious , guilt-suffused melodrama crippled by poor casting . ","rarely has sex on screen been so aggressively anti-erotic . ","a dull , inconsistent , dishonest female bonding picture . ","so much about the film is loopy and ludicrous . . . that it could have been a hoot in a bad-movie way if the laborious pacing and endless exposition had been tightened . ","a disappointment for a movie that should have been the ultimate imax trip . ","does little to elaborate the conceit of setting this blood-soaked tragedy of murderous ambition in the era of richard nixon . ","this sade is hardly a perverse , dangerous libertine and agitator -- which would have made for better drama . he's just a sad aristocrat in tattered finery , and the film seems as deflated as he does . ","the film's needlessly opaque intro takes its doe-eyed crudup out of pre-9/11 new york and onto a cross-country road trip of the homeric kind . ","it's as if a bored cage spent the duration of the film's shooting schedule waiting to scream :  got aids yet ?  ","in a strange way , egoyan has done too much . he's worked too hard on this movie . ","the film has the thrown-together feel of a summer-camp talent show : hastily written , underrehearsed , arbitrarily plotted and filled with crude humor and vulgar innuendo . ","the last three narcissists left on earth compete for each others' affections . ","a clash between the artificial structure of the story and the more contemporary , naturalistic tone of the film . . . ","[a] poorly executed comedy . ","the movie's messages are quite admirable , but the story is just too clichéd and too often strains credulity . ","what we have here isn't a disaster , exactly , but a very handsomely produced let-down . ","the script was reportedly rewritten a dozen times -- either 11 times too many or else too few . ","a shoddy male hip hop fantasy filled with guns , expensive cars , lots of naked women and rocawear clothing . ","to the filmmakers , ivan is a prince of a fellow , but he comes across as shallow and glib though not mean-spirited , and there's no indication that he's been responsible for putting together any movies of particular value or merit . ","this is a movie filled with unlikable , spiteful idiots ; whether or not their friendship is salvaged makes no difference in the least . ","it's as if allen , at 66 , has stopped challenging himself . ","scotland , pa is entirely too straight-faced to transcend its clever concept . ","a movie that the less charitable might describe as a castrated cross between highlander and lolita . ","not only does leblanc make one spectacularly ugly-looking broad , but he appears miserable throughout as he swaggers through his scenes . ","there's little to recommend snow dogs , unless one considers cliched dialogue and perverse escapism a source of high hilarity . ","it's deep-sixed by a compulsion to catalog every bodily fluids gag in there's something about mary and devise a parallel clone-gag . ","the film rehashes several old themes and is capped with pointless extremes -- it's insanely violent and very graphic . ","sorority boys , which is as bad at it is cruel , takes every potential laugh and stiletto-stomps the life out of it . ","here the love scenes all end in someone screaming . maybe there's a metaphor here , but figuring it out wouldn't make trouble every day any better . ","this is the first film i've ever seen that had no obvious directing involved . ","fans of so-bad-they're-good cinema may find some fun in this jumbled mess . ","weiss and speck never make a convincing case for the relevance of these two 20th-century footnotes . ","sheridan is painfully bad , a fourth-rate jim carrey who doesn't understand the difference between dumb fun and just plain dumb . ","presents nothing special and , until the final act , nothing overtly disagreeable . ","the most excruciating 86 minutes one might sit through this summer that do not involve a dentist drill . ","was that movie nothing more than a tepid exercise in trotting out a formula that worked five years ago but has since lost its fizz ? ","it goes on for too long and bogs down in a surfeit of characters and unnecessary subplots . ","it's absolutely amazing how first-time director kevin donovan managed to find something new to add to the canon of chan . make chan's action sequences boring . ","you . . . get a sense of good intentions derailed by a failure to seek and strike just the right tone . ","'in this poor remake of such a well loved classic , parker exposes the limitations of his skill and the basic flaws in his vision . '","it's the movie equivalent of a sweaty old guy in a rain coat shopping for cheap porn . ","the film's final hour , where nearly all the previous unseen material resides , is unconvincing soap opera that tornatore was right to cut . ","the movie does such an excellent job of critiquing itself at every faltering half-step of its development that criticizing feels more like commiserating . ","i found it slow , predictable and not very amusing . ","director yu seems far more interested in gross-out humor than in showing us well-thought stunts or a car chase that we haven't seen 10 , 000 times . ","viewers will need all the luck they can muster just figuring out who's who in this pretentious mess . ","a pint-sized 'goodfellas' designed to appeal to the younger set , it's not a very good movie in any objective sense , but it does mostly hold one's interest . ","get out your pooper-scoopers . ","while the material is slight , the movie is better than you might think . ","it's definitely not made for kids or their parents , for that matter , and i think even fans of sandler's comic taste may find it uninteresting . ","sheridan seems terrified of the book's irreverent energy , and scotches most of its élan , humor , bile , and irony . ","more busy than exciting , more frantic than involving , more chaotic than entertaining . ","there are more shots of children smiling for the camera than typical documentary footage which hurts the overall impact of the film . it's makes a better travelogue than movie . "," . . . really horrible drek . ","it's as if solondz had two ideas for two movies , couldn't really figure out how to flesh either out , so he just slopped ‘em together here . ","the fourth in a series that i'll bet most parents had thought --hoped ! -- was a fad that had long since vanished . ","it's a long way from orwell's dark , intelligent warning cry [1984] to the empty stud knockabout of equilibrium , and what once was conviction is now affectation . ","its premise is smart , but the execution is pretty weary . ","the holiday message of the 37-minute santa vs . the snowman leaves a lot to be desired . ","more precious than perspicacious","if you saw it on tv , you'd probably turn it off , convinced that you had already seen that movie . ","[t]he script isn't up to the level of the direction , nor are the uneven performances by the cast members , who seem bound and determined to duplicate bela lugosi's now-cliched vampire accent . ","if this is cinema , i pledge allegiance to cagney and lacey . ","enigma looks great , has solid acting and a neat premise . yet why it fails is a riddle wrapped in a mystery inside an enigma . ","most of the characters come off as pantomimesque sterotypes . ","starts promisingly but disintegrates into a dreary , humorless soap opera . ","while there's likely very little crossover appeal to those without much interest in the elizabethans ( as well as rank frustration from those in the know about rubbo's dumbed-down tactics ) , much ado about something is an amicable endeavor . ","it's actually too sincere -- the crime movie equivalent of a chick flick . ","most of the film feels conceived and shot on the fly -- like between lunch breaks for shearer's radio show and his simpson voice-overs . ","perry's good and his is an interesting character , but  serving sara  hasn't much more to serve than silly fluff . nor is it a romantic comedy . ","culkin turns his character into what is basically an anti-harry potter -- right down to the gryffindor scarf . ","memorable for a peculiar malaise that renders its tension flaccid and , by extension , its surprises limp and its resolutions ritual . ","it's a documentary that says that the alternate sexuality meant to set you free may require so much relationship maintenance that celibacy can start looking good . ","in the not-too-distant future , movies like ghost ship will be used as analgesic balm for overstimulated minds . right now , they're merely signposts marking the slow , lingering death of imagination . ","an intriguing near-miss . ","the movie's biggest shocks come from seeing former nymphette juliette lewis playing a salt-of-the-earth mommy named minnie and watching slim travel incognito in a ridiculous wig no respectable halloween costume shop would ever try to sell . ","like most movies about the pitfalls of bad behavior . . . circuit gets drawn into the party . ","it appears as if even the filmmakers didn't know what kind of movie they were making . ","beneath the uncanny , inevitable and seemingly shrewd facade of movie-biz farce . . . lies a plot cobbled together from largely flat and uncreative moments . ","snipes relies too much on a scorchingly plotted dramatic scenario for its own good . ","piccoli's performance is amazing , yes , but the symbols of loss and denial and life-at-arm's-length in the film seem irritatingly transparent . ","starts out mediocre , spirals downward , and thuds to the bottom of the pool with an utterly incompetent conclusion . ","nicolas cage isn't the first actor to lead a group of talented friends astray , and this movie won't create a ruffle in what is already an erratic career . ","it lacks the compassion , good-natured humor and the level of insight that made [eyre's] first film something of a sleeper success . ","the result is good gossip , entertainingly delivered , yet with a distinctly musty odour , its expiry date long gone . ","a sustained fest of self-congratulation between actor and director that leaves scant place for the viewer . ","all analyze that proves is that there is really only one movie's worth of decent gags to be gleaned from the premise . ","green ruins every single scene he's in , and the film , while it's not completely wreaked , is seriously compromised by that . ","there's not a comedic moment in this romantic comedy . ","the story is predictable , the jokes are typical sandler fare , and the romance with ryder is puzzling . ","wallace directs with such patronising reverence , it turns the stomach . ","resurrection has the dubious distinction of being a really bad imitation of the really bad blair witch project . ","poor ben bratt couldn't find stardom if mapquest emailed him point-to-point driving directions . ","pretend like your sat scores are below 120 and you might not notice the flaws . ","unlike trey parker , sandler doesn't understand that the idea of exploiting molestation for laughs is funny , not actually exploiting it yourself . ","a fake street drama that keeps telling you things instead of showing them . ","an empty , purposeless exercise . ","earnest and tentative even when it aims to shock . ","haneke's script ( from elfriede jelinek's novel ) is contrived , unmotivated , and psychologically unpersuasive , with an inconclusive ending . ","a sometimes incisive and sensitive portrait that is undercut by its awkward structure and a final veering toward melodrama . ","those 24-and-unders looking for their own caddyshack to adopt as a generational signpost may have to keep on looking . ","a distinctly mixed bag , the occasional bursts of sharp writing alternating with lots of sloppiness and the obligatory moments of sentimental ooze . ","what begins brightly gets bogged down over 140 minutes . ","ultimately , jane learns her place as a girl , softens up and loses some of the intensity that made her an interesting character to begin with . ","ah-nuld's action hero days might be over . ","it's clear why deuces wild , which was shot two years ago , has been gathering dust on mgm's shelf . ","feels like nothing quite so much as a middle-aged moviemaker's attempt to surround himself with beautiful , half-naked women . ","when the precise nature of matthew's predicament finally comes into sharp focus , the revelation fails to justify the build-up . ","this picture is murder by numbers , and as easy to be bored by as your abc's , despite a few whopping shootouts . ","hilarious musical comedy though stymied by accents thick as mud . ","if you are into splatter movies , then you will probably have a reasonably good time with the salton sea . ","a dull , simple-minded and stereotypical tale of drugs , death and mind-numbing indifference on the inner-city streets . ","the feature-length stretch . . . strains the show's concept . ","this slender plot feels especially thin stretched over the nearly 80-minute running time . ","a film that will probably please people already fascinated by behan but leave everyone else yawning with admiration . ","davis the performer is plenty fetching enough , but she needs to shake up the mix , and work in something that doesn't feel like a half-baked stand-up routine . ","the densest distillation of roberts' movies ever made . ","ultimately , the film never recovers from the clumsy cliché of the ugly american abroad , and the too-frosty exterior ms . paltrow employs to authenticate her british persona is another liability . ","a handsome but unfulfilling suspense drama more suited to a quiet evening on pbs than a night out at an amc . ","tom green and an ivy league college should never appear together on a marquee , especially when the payoff is an unschooled comedy like stealing harvard , which fails to keep 80 minutes from seeming like 800 . "," ( it ) highlights not so much the crime lord's messianic bent , but spacey's . ","master of disguise runs for only 71 minutes and feels like three hours . ","a reworking of die hard and cliffhanger but it's nowhere near as exciting as either . ","suffers from unlikable characters and a self-conscious sense of its own quirky hipness . ","a film without surprise geared toward maximum comfort and familiarity . ","fessenden continues to do interesting work , and it would be nice to see what he could make with a decent budget . but the problem with wendigo , for all its effective moments , isn't really one of resources . ","spirit is a visual treat , and it takes chances that are bold by studio standards , but it lacks a strong narrative . ","it stars schticky chris rock and stolid anthony hopkins , who seem barely in the same movie . their contrast is neither dramatic nor comic -- it's just a weird fizzle . ","this is a children's film in the truest sense . it's packed with adventure and a worthwhile environmental message , so it's great for the kids . parents , on the other hand , will be ahead of the plot at all times , and there isn't enough clever innuendo to fil","the niftiest trick perpetrated by the importance of being earnest is the alchemical transmogrification of wilde into austen--and a hollywood-ized austen at that . ","tykwer's surface flash isn't just a poor fit with kieslowski's lyrical pessimism ; it completely contradicts everything kieslowski's work aspired to , including the condition of art . ","ice age is the first computer-generated feature cartoon to feel like other movies , and that makes for some glacial pacing early on . ","too slick and manufactured to claim street credibility . ","cherry orchard is badly edited , often awkwardly directed and suffers from the addition of a wholly unnecessary pre-credit sequence designed to give some of the characters a 'back story . '","what ensues are much blood-splattering , mass drug-induced bowel evacuations , and none-too-funny commentary on the cultural distinctions between americans and brits . ","a dark comedy that goes for sick and demented humor simply to do so . the movie is without intent . ","visually exciting sci-fi film which suffers from a lackluster screenplay . ","while hollywood ending has its share of belly laughs ( including a knockout of a closing line ) , the movie winds up feeling like a great missed opportunity . ","if the full monty was a freshman fluke , lucky break is [cattaneo] sophomore slump . "," sandra bullock and hugh grant make a great team , but this predictable romantic comedy should get a pink slip . ","allegiance to chekhov , which director michael cacoyannis displays with somber earnestness in the new adaptation of the cherry orchard , is a particularly vexing handicap . ","you expect more from director michael apted ( enigma ) and screenwriter nicholas kazan ( reversal of fortune ) than this cliche pileup . ","the first mistake , i suspect , is casting shatner as a legendary professor and kunis as a brilliant college student--where's pauly shore as the rocket scientist ? ","the dramatic scenes are frequently unintentionally funny , and the action sequences -- clearly the main event -- are surprisingly uninvolving . ","replacing john carpenter's stylish tracking shots is degraded , handheld blair witch video-cam footage . of all the halloween's , this is the most visually unappealing . ","it has the requisite faux-urban vibe and hotter-two-years-ago rap and r&b names and references . ","despite its dry wit and compassion , the film suffers from a philosophical emptiness and maddeningly sedate pacing . "," . . . feels as if ( there's ) a choke leash around your neck so director nick cassavetes can give it a good , hard yank whenever he wants you to feel something . ","attal pushes too hard to make this a comedy or serious drama . he seems to want both , but succeeds in making neither . ","i could have used my two hours better watching being john malkovich again . ","it's not a bad plot ; but , unfortunately , the movie is nowhere near as refined as all the classic dramas it borrows from . ","flat , misguided comedy . ","girlfriends are bad , wives are worse and babies are the kiss of death in this bitter italian comedy . ","the only young people who possibly will enjoy it are infants . . . who might be distracted by the movie's quick movements and sounds . ","the film boasts at least a few good ideas and features some decent performances , but the result is disappointing . ","no such thing breaks no new ground and treads old turf like a hippopotamus ballerina . ","unfortunately , neither sendak nor the directors are particularly engaging or articulate . ","a wishy-washy melodramatic movie that shows us plenty of sturm und drung , but explains its characters' decisions only unsatisfactorily . ","bang ! zoom ! it's actually pretty funny , but in all the wrong places . ","lurid and less than lucid work . ","a wannabe comedy of manners about a brainy prep-school kid with a mrs . robinson complex founders on its own preciousness -- and squanders its beautiful women . ","at a brief 42 minutes , we need more x and less blab . ","if anything , see it for karen black , who camps up a storm as a fringe feminist conspiracy theorist named dirty dick . ","this 90-minute dud could pass for mike tyson's e ! true hollywood story . ","this is surely one of the most frantic , virulent and foul-natured christmas season pics ever delivered by a hollywood studio . ","once the expectation of laughter has been quashed by whatever obscenity is at hand , even the funniest idea isn't funny . ","a porn film without the sex scenes . ","the connected stories of breitbart and hanussen are actually fascinating , but the filmmaking in invincible is such that the movie does not do them justice . ","a depressingly retrograde , 'post-feminist' romantic comedy that takes an astonishingly condescending attitude toward women . ","return to never land is much more p . c . than the original version ( no more racist portraits of indians , for instance ) , but the excitement is missing . ","by the end , you just don't care whether that cold-hearted snake petrovich ( that would be reno ) gets his comeuppance . just bring on the battle bots , please ! ","while it's all quite tasteful to look at , the attention process tends to do a little fleeing of its own . ","broder's screenplay is shallow , offensive and redundant , with pitifully few real laughs . ","yes they can swim , the title is merely anne-sophie birot's off-handed way of saying girls find adolescence difficult to wade through . ","don michael paul uses quick-cuts , ( very ) large shadows and wide-angle shots taken from a distance to hide the liberal use of a body double ( for seagal ) . ","slow , silly and unintentionally hilarious . ","the sweetest thing leaves a bitter taste . ","in a big corner office in hell , satan is throwing up his hands in surrender , is firing his r&d people , and has decided he will just screen the master of disguise 24/7 . ","for something as splendid-looking as this particular film , the viewer expects something special but instead gets [sci-fi] rehash . ","a thriller without a lot of thrills . ","this stuck pig of a movie flails limply between bizarre comedy and pallid horror . ","ah , the travails of metropolitan life ! alas , another breathless movie about same ! ","in moonlight mile , no one gets shut out of the hug cycle . ","though uniformly well acted , especially by young ballesta and galan ( a first-time actor ) , writer/director achero manas's film is schematic and obvious . ","done in mostly by a weak script that can't support the epic treatment . ","despite its visual virtuosity , 'naqoyqatsi' is banal in its message and the choice of material to convey it . ","slap her - she's not funny ! no french people were harmed during the making of this movie , but they were insulted and the audience was put through torture for an hour and a half . ","though its rather routine script is loaded with familiar situations , the movie has a cinematic fluidity and sense of intelligence that makes it work more than it probably should . ","  one look at a girl in tight pants and big tits and you turn stupid ?  um… . . isn't that the basis for the entire plot ? ","  not really as bad as you might think !  ","strident and inelegant in its 'message-movie' posturing . ","one regards reign of fire with awe . what a vast enterprise has been marshaled in the service of such a minute idea . ","it has the right approach and the right opening premise , but it lacks the zest and it goes for a plot twist instead of trusting the material . ","its impressive images of crematorium chimney fires and stacks of dead bodies are undermined by the movie's presentation , which is way too stagy . ","seeing as the film lacks momentum and its position remains mostly undeterminable , the director's experiment is a successful one . ","the plot is romantic comedy boilerplate from start to finish . ","i suspect this is the kind of production that would have been funnier if the director had released the outtakes theatrically and used the film as a bonus feature on the dvd . ","an unfortunate title for a film that has nothing endearing about it . ","ninety minutes of viva castro ! can be as tiresome as 9 seconds of jesse helms' anti- castro rhetoric , which are included","comes off as a long , laborious whine , the bellyaching of a paranoid and unlikable man . ","it just goes to show , an intelligent person isn't necessarily an admirable storyteller . ","in a 102-minute film , aaliyah gets at most 20 minutes of screen time . . . . most viewers will wish there had been more of the  queen  and less of the  damned .  ","hopelessly inane , humorless and under-inspired . ","kapur fails to give his audience a single character worth rooting for ( or worth rooting against , for that matter ) . ","it reduces the complexities to bromides and slogans and it gets so preachy-keen and so tub-thumpingly loud it makes you feel like a chump just for sitting through it . ","none of this has the suavity or classical familiarity of bond , but much of it is good for a laugh . the problem with  xxx  is that its own action isn't very effective . ","a great script brought down by lousy direction . same guy with both hats . big mistake . ","a mediocre exercise in target demographics , unaware that it's the butt of its own joke . ","director kevin bray excels in breaking glass and marking off the  miami vice  checklist of power boats , latin music and dog tracks . he doesn't , however , deliver nearly enough of the show's trademark style and flash . ","in gleefully , thumpingly hyperbolic terms , it covers just about every cliche in the compendium about crass , jaded movie types and the phony baloney movie biz . ","the spalding gray equivalent of a teen gross-out comedy . ","perhaps even the slc high command found writer-director mitch davis's wall of kitsch hard going . ","according to wendigo , 'nature' loves the members of the upper class almost as much as they love themselves . ","an encouraging effort from mccrudden","the romance between the leads isn't as compelling or as believable as it should be . ","if i could have looked into my future and saw how bad this movie was , i would go back and choose to skip it . fortunately , you still have that option . ","supposedly authentic account of a historical event that's far too tragic to merit such superficial treatment . ","adroit but finally a trifle flat , mad love doesn't galvanize its outrage the way , say , jane campion might have done , but at least it possesses some . ","to blandly go where we went 8 movies ago . . . ","a slow-moving police-procedural thriller that takes its title all too literally . ","this u-boat doesn't have a captain . ","with nary a glimmer of self-knowledge , [crane] becomes more specimen than character -- and auto focus remains a chilly , clinical lab report . ","this one aims for the toilet and scores a direct hit . ","dull , a road-trip movie that's surprisingly short of both adventure and song . ","i walked away not really know who  they  were , what  they  looked like . why  they  were here and what  they  wanted and quite honestly , i didn't care . ","predictably melodramatic . ","after several scenes of this tacky nonsense , you'll be wistful for the testosterone-charged wizardry of jerry bruckheimer productions , especially because half past dead is like the rock on a wal-mart budget . ","a relatively effective little potboiler until its absurd , contrived , overblown , and entirely implausible finale . ","the country bears wastes an exceptionally good idea . but the movie that doesn't really deliver for country music fans or for family audiences","adults will certainly want to spend their time in the theater thinking up grocery lists and ways to tell their kids how not to act like pinocchio . as for children , they won't enjoy the movie at all . "," . . . you can be forgiven for realizing that you've spent the past 20 minutes looking at your watch and waiting for frida to just die already . ","too bad writer-director adam rifkin situates it all in a plot as musty as one of the golden eagle's carpets . ","it's lazy for a movie to avoid solving one problem by trying to distract us with the solution to another . ","the movie is genial but never inspired , and little about it will stay with you . ","the movie obviously seeks to re-create the excitement of such '50s flicks as jules verne's '20 , 000 leagues under the sea' and the george pal version of h . g . wells' 'the time machine . ' but its storytelling prowess and special effects are both listless . ","despite the opulent lushness of every scene , the characters never seem to match the power of their surroundings . ","even after 90 minutes of playing opposite each other bullock and grant still look ill at ease sharing the same scene . what should have been a painless time-killer becomes instead a grating endurance test . ","a bland , obnoxious 88-minute infomercial for universal studios and its ancillary products . "," . . little action , almost no suspense or believable tension , one-dimensional characters up the wazoo and sets that can only be described as sci-fi generic . ","the movie strains to stay on the light , comic side of the issue , despite the difficulty of doing so when dealing with the destruction of property and , potentially , of life itself . ","the master of disguise is awful . it's pauly shore awful . don't say you weren't warned . ","disappointing in comparison to other recent war movies…or any other john woo flick for that matter . ","the entire movie is filled with deja vu moments . ","'opening up' the play more has partly closed it down . ","what [frei] gives us . . . is a man who uses the damage of war -- far more often than the warfare itself -- to create the kind of art shots that fill gallery shows . ","an ugly , revolting movie . ","the film is way too full of itself ; it's stuffy and pretentious in a give-me-an-oscar kind of way . ","the movie is concocted and carried out by folks worthy of scorn , and the nicest thing i can say is that i can't remember a single name responsible for it . ","watching  ending  is too often like looking over the outdated clothes and plastic knickknacks at your neighbor's garage sale . you can't believe anyone would really buy this stuff . ","certainly beautiful to look at , but its not very informative about its titular character and no more challenging than your average television biopic . ","it desperately wants to be a wacky , screwball comedy , but the most screwy thing here is how so many talented people were convinced to waste their time . ","the skills of a calculus major at m . i . t . are required to balance all the formulaic equations in the long-winded heist comedy who is cletis tout ? ","from the choppy editing to the annoying score to 'special effects' by way of replacing objects in a character's hands below the camera line ,  besotted  is misbegotten","my advice is to skip the film and pick up the soundtrack . ","a film that presents an interesting , even sexy premise then ruins itself with too many contrivances and goofy situations . ","filled with low-brow humor , gratuitous violence and a disturbing disregard for life . ","directed in a flashy , empty sub-music video style by a director so self-possessed he actually adds a period to his first name","the 70-year-old godard has become , to judge from in praise of love , the sort of bitter old crank who sits behind his light meter and harangues the supposed injustices of the artistic world-at-large without doing all that much to correct them . ","an unsophisticated sci-fi drama that takes itself all too seriously . ","solondz is without doubt an artist of uncompromising vision , but that vision is beginning to feel , if not morally bankrupt , at least terribly monotonous . ","harvard man is a semi-throwback , a reminiscence without nostalgia or sentimentality . ","supposedly based upon real , or at least soberly reported incidents , the film ends with a large human tragedy . alas , getting there is not even half the interest . ","while hoffman's performance is great , the subject matter goes nowhere . ","the smash 'em-up , crash 'em-up , shoot 'em-up ending comes out of nowhere substituting mayhem for suspense . ","deuces wild treads heavily into romeo and juliet/west side story territory , where it plainly has no business going . ","hart's war seems to want to be a character study , but apparently can't quite decide which character . ","theological matters aside , the movie is so clumsily sentimental and ineptly directed it may leave you speaking in tongues . ","this latest installment of the horror film franchise that is apparently as invulnerable as its trademark villain has arrived for an incongruous summer playoff , demonstrating yet again that the era of the intelligent , well-made b movie is long gone . ","novak contemplates a heartland so overwhelmed by its lack of purpose that it seeks excitement in manufactured high drama . ","been there , done that , liked it much better the first time around - when it was called the professional . ","the film is all over the place , really . it dabbles all around , never gaining much momentum . ","the beautiful , unusual music is this film's chief draw , but its dreaminess may lull you to sleep . ","the action quickly sinks into by-the-numbers territory . ","forages for audience sympathy like a temperamental child begging for attention , giving audiences no reason to truly care for its decrepit freaks beyond the promise of a reprieve from their incessant whining . ","when [reno] lets her radical flag fly , taking angry potshots at george w . bush , henry kissinger , larry king , et al . , reno devolves into a laugh-free lecture . ","such a premise is ripe for all manner of lunacy , but kaufman and gondry rarely seem sure of where it should go . ","burns' fifth beer-soaked film feels in almost every possible way -- from the writing and direction to the soggy performances -- tossed off . ","'es en verdad una pena que mandoki esté realizando cintas tan malas desde hace algún tiempo , pues talento tiene , pero quién sabe dónde lo tiene escondido . '","while this one gets off with a good natured warning , future lizard endeavors will need to adhere more closely to the laws of laughter","another boorish movie from the i-heard-a-joke- at-a-frat-party school of screenwriting . ","too much of the movie feels contrived , as if the filmmakers were worried the story wouldn't work without all those gimmicks . ","it's hard to understand why anyone in his right mind would even think to make the attraction a movie . and it's harder still to believe that anyone in his right mind would want to see the it . ","the ethos of the chelsea hotel may shape hawke's artistic aspirations , but he hasn't yet coordinated his own dv poetry with the beat he hears in his soul . ","the sight of the name bruce willis brings to mind images of a violent battlefield action picture , but the film has a lot more on its mind--maybe too much . ","why sit through a crummy , wannabe-hip crime comedy that refers incessantly to old movies , when you could just rent those movies instead , let alone seek out a respectable new one ? ","the obnoxious special effects , the obligatory outbursts of flatulence and the incessant , so-five-minutes-ago pop music on the soundtrack overwhelm what is left of the scruffy , dopey old hanna-barbera charm . ","exploring value choices is a worthwhile topic for a film -- but here the choices are as contrived and artificial as kerrigan's platinum-blonde hair . ","the movie's downfall is to substitute plot for personality . it doesn't really know or care about the characters , and uses them as markers for a series of preordained events . ","all mood and no movie . ","press the delete key . ","simone is not a bad film . it just doesn't have anything really interesting to say . ","once he starts learning to compromise with reality enough to become comparatively sane and healthy , the film becomes predictably conventional . "," . . . hopefully it'll be at the dollar theatres by the time christmas rolls around . wait to see it then . ","there's no disguising this as one of the worst films of the summer . or for the year , for that matter . ","lacks the spirit of the previous two , and makes all those jokes about hos and even more unmentionable subjects seem like mere splashing around in the muck . ","this hastily mounted production exists only to capitalize on hopkins' inclination to play hannibal lecter again , even though harris has no immediate inclination to provide a fourth book . ","death to smoochy tells a moldy-oldie , not-nearly -as-nasty -as-it- thinks-it-is joke . over and over again . ","the threat implied in the title pokémon 4ever is terrifying – like locusts in a horde these things will keep coming . ","the film never gets over its own investment in conventional arrangements , in terms of love , age , gender , race , and class . ","to call this film a lump of coal would only be to flatter it . ","entertainment more disposable than hanna-barbera's half-hour cartoons ever were . ","the film falls short on tension , eloquence , spiritual challenge -- things that have made the original new testament stories so compelling for 20 centuries . ","by the end of it all i sort of loved the people onscreen , even though i could not stand them . perhaps the film should be seen as a conversation starter . it's not an easy one to review . ","at best this is a film for the under-7 crowd . but it would be better to wait for the video . and a very rainy day . ","the whole talking-animal thing is grisly . ","never again , while nothing special , is pleasant , diverting and modest -- definitely a step in the right direction . ","wouldn't it be funny if a bunch of allied soldiers went undercover as women in a german factory during world war ii ? um , no . but here's a movie about it anyway . ","has not so much been written as assembled , frankenstein-like , out of other , marginally better shoot-em-ups . ","the punch lines that miss , unfortunately , outnumber the hits by three-to-one . but death to smoochy keeps firing until the bitter end . ","mushes the college-friends genre ( the big chill ) together with the contrivances and overwrought emotion of soap operas . ","showtime's starry cast could be both an asset and a detriment . those who trek to the 'plex predisposed to like it probably will enjoy themselves . but ticket-buyers with great expectations will wind up as glum as mr . de niro . ","a determined , ennui-hobbled slog that really doesn't have much to say beyond the news flash that loneliness can make people act weird . ","too daft by half . . . but supremely good natured . ","fails in making this character understandable , in getting under her skin , in exploring motivation . . . well before the end , the film grows as dull as its characters , about whose fate it is hard to care . ","it's a shame that the storyline and its underlying themes . . . finally seem so impersonal or even shallow . ","woody , what happened ? ","juliette binoche's sand is vivacious , but it's hard to sense that powerhouse of 19th-century prose behind her childlike smile . ","it's supposed to be post-feminist breezy but ends up as tedious as the chatter of parrots raised on oprah . ","you can tell almost immediately that welcome to collinwood isn't going to jell . ","throughout all the tumult , a question comes to mind : so why is this so boring ? ","cattaneo reworks the formula that made the full monty a smashing success . . . but neglects to add the magic that made it all work . ","routine and rather silly . ","a rip-off twice removed , modeled after [seagal's] earlier copycat under siege , sometimes referred to as die hard on a boat . ","totally overwrought , deeply biased , and wholly designed to make you feel guilty about ignoring what the filmmakers clearly believe are the greatest musicians of all time . ","you can practically hear george orwell turning over . ","behan's memoir is great material for a film -- rowdy , brawny and lyrical in the best irish sense -- but sheridan has settled for a lugubrious romance . ","while holm is terrific as both men and hjejle quite appealing , the film fails to make the most out of the intriguing premise . ","lazy filmmaking , with the director taking a hands-off approach when he should have shaped the story to show us why it's compelling . ","if it were any more of a turkey , it would gobble in dolby digital stereo . if nothing else ,  rollerball  2002 may go down in cinema history as the only movie ever in which the rest of the cast was outshined by ll cool j . ","a movie that falls victim to frazzled wackiness and frayed satire . ","how do you make a movie with depth about a man who lacked any ? on the evidence before us , the answer is clear : not easily and , in the end , not well enough . ","the film's trailer also looked like crap , so crap is what i was expecting . ","more trifle than triumph . ","the movie is almost completely lacking in suspense , surprise and consistent emotional conviction . ","festers in just such a dungpile that you'd swear you were watching monkeys flinging their feces at you . ","lyne's latest , the erotic thriller unfaithful , further demonstrates just how far his storytelling skills have eroded . ","it sounds like another clever if pointless excursion into the abyss , and that's more or less how it plays out . ","rumor , a muddled drama about coming to terms with death , feels impersonal , almost generic . ","report card : doesn't live up to the exalted tagline - there's definite room for improvement . doesn't deserve a passing grade ( even on a curve ) . ","the pacing is deadly , the narration helps little and naipaul , a juicy writer , is negated . ","as his circle of friends keeps getting smaller one of the characters in long time dead says 'i'm telling you , this is f * * * ed' . maybe he was reading the minds of the audience . "," . . . if it had been only half-an-hour long or a tv special , the humor would have been fast and furious-- at ninety minutes , it drags . ","bean drops the ball too many times . . . hoping the nifty premise will create enough interest to make up for an unfocused screenplay . ","a well-acted , but one-note film . ","blood work is laughable in the solemnity with which it tries to pump life into overworked elements from eastwood's dirty harry period . ","the movie is too amateurishly square to make the most of its own ironic implications . ","[lee] treats his audience the same way that jim brown treats his women -- as dumb , credulous , unassuming , subordinate subjects . and lee seems just as expectant of an adoring , wide-smiling reception . ","there's not one decent performance from the cast and not one clever line of dialogue . ","one of the worst movies of the year . . . . watching it was painful . ","a era do gelo diverte , mas não convence . É um passatempo descompromissado – e só . ","no amount of burning , blasting , stabbing , and shooting can hide a weak script . ","it's an odd show , pregnant with moods , stillborn except as a harsh conceptual exercise . ","nearly all the fundamentals you take for granted in most films are mishandled here . ","the armenian genocide deserves a more engaged and honest treatment . ","earnest yet curiously tepid and choppy recycling in which predictability is the only winner . ","ultimately this is a frustrating patchwork : an uneasy marriage of louis begley's source novel ( about schmidt ) and an old payne screenplay . ","the exploitative , clumsily staged violence overshadows everything , including most of the actors . ","we started to wonder if … some unpaid intern had just typed 'chris rock , ' 'anthony hopkins' and 'terrorists' into some univac-like script machine . ","even when crush departs from the 4w formula . . . it feels like a glossy rehash . ","more likely to have you scratching your head than hiding under your seat . ","bears is even worse than i imagined a movie ever could be . ","when you find yourself rooting for the monsters in a horror movie , you know the picture is in trouble . ","this is very much of a mixed bag , with enough negatives to outweigh the positives . ","marinated in clichés and mawkish dialogue . ","whether it's the worst movie of 2002 , i can't say for sure : memories of rollerball have faded , and i skipped country bears . but this new jangle of noise , mayhem and stupidity must be a serious contender for the title . ","[a] boldly stroked , luridly coloured , uni-dimensional nonsense machine that strokes the eyeballs while it evaporates like so much crypt mist in the brain . ","not once in the rush to save the day did i become very involved in the proceedings ; to me , it was just a matter of 'eh . '","rollerball is as bad as you think , and worse than you can imagine . ","the first question to ask about bad company is why anthony hopkins is in it . we assume he had a bad run in the market or a costly divorce , because there is no earthly reason other than money why this distinguished actor would stoop so low . ","not exaggerated enough to be a parody of gross-out flicks , college flicks , or even flicks in general . it merely indulges in the worst elements of all of them . ","shame on writer/director vicente aranda for making a florid biopic about mad queens , obsessive relationships , and rampant adultery so dull . ","suffers from a decided lack of creative storytelling . ","violent , vulgar and forgettably entertaining . ","nothing happens , and it happens to flat characters . ","with a completely predictable plot , you'll swear that you've seen it all before , even if you've never come within a mile of the longest yard . ","remember back when thrillers actually thrilled ? when the twist endings were actually surprising ? when the violence actually shocked ? when the heroes were actually under 40 ? sadly , as blood work proves , that was a long , long time ago . ","blue crush has all the trappings of an energetic , extreme-sports adventure , but ends up more of a creaky  pretty woman  retread , with the emphasis on self-empowering schmaltz and big-wave surfing that gives pic its title an afterthought . ","this movie plays like an extended dialogue exercise in retard 101 . ","what we get in feardotcom is more like something from a bad clive barker movie . in other words , it's badder than bad . ","if they broke out into elaborate choreography , singing and finger snapping it might have held my attention , but as it stands i kept looking for the last exit from brooklyn . ","a sloppy slapstick throwback to long gone bottom-of-the-bill fare like the ghost and mr . chicken . ","a small independent film suffering from a severe case of hollywood-itis . ","where the film falters is in its tone . ","the story alone could force you to scratch a hole in your head . ","ultimately , sarah's dedication to finding her husband seems more psychotic than romantic , and nothing in the movie makes a convincing case that one woman's broken heart outweighs all the loss we witness . ","it's supposed to be a humorous , all-too-human look at how hope can breed a certain kind of madness -- and strength -- but it never quite adds up . ","feels more like a rejected x-files episode than a credible account of a puzzling real-life happening . ","some motion pictures portray ultimate passion ; others create ultimate thrills . men in black ii achieves ultimate insignificance -- it's the sci-fi comedy spectacle as whiffle-ball epic . ","an enigmatic film that's too clever for its own good , it's a conundrum not worth solving . ","a zombie movie in every sense of the word--mindless , lifeless , meandering , loud , painful , obnoxious . ","rashomon-for-dipsticks tale . ","a film that clearly means to preach exclusively to the converted . ","it doesn't take a rocket scientist to figure out that this is a mormon family movie , and a sappy , preachy one at that . ","definitely a crowd-pleaser , but then , so was the roman colosseum . ","certainly not a good movie , but it wasn't horrible either . ","although it starts off so bad that you feel like running out screaming , it eventually works its way up to merely bad rather than painfully awful . ","the result is so tame that even slightly wised-up kids would quickly change the channel . ","it appears to have been modeled on the worst revenge-of-the-nerds clichés the filmmakers could dredge up . ","nothing but an episode of smackdown ! in period costume and with a bigger budget . ","it takes you somewhere you're not likely to have seen before , but beneath the exotic surface ( and exotic dancing ) it's surprisingly old-fashioned . ","while the story is better-focused than the incomprehensible anne rice novel it's based upon , queen of the damned is a pointless , meandering celebration of the goth-vampire , tortured woe-is-me lifestyle . ","it should be interesting , it should be poignant , it turns out to be affected and boring . ","a good-looking but ultimately pointless political thriller with plenty of action and almost no substance . ","a tired , predictable , bordering on offensive , waste of time , money and celluloid . ","if hill isn't quite his generation's don siegel ( or robert aldrich ) , it's because there's no discernible feeling beneath the chest hair ; it's all bluster and cliché . ","stealing harvard will dip into your wallet , swipe 90 minutes of your time , and offer you precisely this in recompense : a few early laughs scattered around a plot as thin as it is repetitious . ","this is an insultingly inept and artificial examination of grief and its impacts upon the relationships of the survivors . ","does anyone much think the central story of brendan behan is that he was a bisexual sweetheart before he took to drink ? ","`martin lawrence live' is so self-pitying , i almost expected there to be a collection taken for the comedian at the end of the show . ","the dialogue is cumbersome , the simpering soundtrack and editing more so . ","never decides whether it wants to be a black comedy , drama , melodrama or some combination of the three . ","it has become apparent that the franchise's best years are long past . ","does what should seem impossible : it makes serial killer jeffrey dahmer boring . ","don't hate el crimen del padre amaro because it's anti-catholic . hate it because it's lousy . "," . . . better described as a ghost story gone badly awry . ","like a bad improvisation exercise , the superficially written characters ramble on tediously about their lives , loves and the art they're struggling to create . ","the filmmakers are playing to the big boys in new york and l . a . to that end , they mock the kind of folks they don't understand , ones they figure the power-lunchers don't care to understand , either . ","competently directed but terminally cute drama . ","the big finish is a bit like getting all excited about a chocolate eclair and then biting into it and finding the filling missing . ","not just unlikable . disturbing . disgusting . without any redeeming value whatsoever . ","this thing is virtually unwatchable . ","those eternally devoted to the insanity of black will have an intermittently good time . feel free to go get popcorn whenever he's not onscreen . ","the self-serious equilibrium makes its point too well ; a movie , like life , isn't much fun without the highs and lows . ","the work of an exhausted , desiccated talent who can't get out of his own way . ","the main characters are simply named the husband , the wife and the kidnapper , emphasizing the disappointingly generic nature of the entire effort . ","in terms of execution this movie is careless and unfocused . ","swims in mediocrity , sticking its head up for a breath of fresh air now and then . ","the only type of lives this glossy comedy-drama resembles are ones in formulaic mainstream movies . ","the characters . . . are paper-thin , and their personalities undergo radical changes when it suits the script . ","a sha-na-na sketch punctuated with graphic violence . ","the trouble is , its filmmakers run out of clever ideas and visual gags about halfway through . ","spy-vs . -spy action flick with antonio banderas and lucy liu never comes together . ","a so-so , made-for-tv something posing as a real movie . ","the only upside to all of this unpleasantness is , given its labor day weekend upload , feardotcom should log a minimal number of hits . ","whether this is art imitating life or life imitating art , it's an unhappy situation all around . ","an uneasy mix of run-of-the-mill raunchy humor and seemingly sincere personal reflection . ","a formula family tearjerker told with a heavy irish brogue . . . accentuating , rather than muting , the plot's saccharine thrust . ","this is sandler running on empty , repeating what he's already done way too often . ","this is as lax and limp a comedy as i've seen in a while , a meander through worn-out material . ","time literally stops on a dime in the tries-so-hard-to-be-cool  clockstoppers ,  but that doesn't mean it still won't feel like the longest 90 minutes of your movie-going life . ","the sort of picture in which , whenever one of the characters has some serious soul searching to do , they go to a picture-perfect beach during sunset . ","aptly named , this shimmering , beautifully costumed and filmed production doesn't work for me . ","a preposterously melodramatic paean to gang-member teens in brooklyn circa 1958 . ","has none of the crackle of  fatal attraction  ,  9 ½ weeks  , or even  indecent proposal  , and feels more like lyne's stolid remake of  lolita  . ","everything its title implies , a standard-issue crime drama spat out from the tinseltown assembly line . ","an extraordinarily silly thriller . ","a rehash of every gangster movie from the past decade . ","gaping plot holes sink this 'sub'-standard thriller and drag audience enthusiasm to crush depth . ","talkiness isn't necessarily bad , but the dialogue frequently misses the mark . ","the beautiful images and solemn words cannot disguise the slack complacency of [godard's] vision , any more than the gorgeous piano and strings on the soundtrack can drown out the tinny self-righteousness of his voice . ","the stunt work is top-notch ; the dialogue and drama often food-spittingly funny . ","the movie isn't painfully bad , something to be 'fully experienced' ; it's just tediously bad , something to be fully forgotten . ","charly comes off as emotionally manipulative and sadly imitative of innumerable past love story derisions . ","what a great shame that such a talented director as chen kaige has chosen to make his english-language debut with a film so poorly plotted and scripted . ","no amount of good intentions is able to overcome the triviality of the story . ","the film . . . presents classic moral-condundrum drama : what would you have done to survive ? the problem with the film is whether these ambitions , laudable in themselves , justify a theatrical simulation of the death camp of auschwitz ii-birkenau . "," . . . for all its social and political potential , state property doesn't end up being very inspiring or insightful . ","a film really has to be exceptional to justify a three hour running time , and this isn't . ","little more than a stylish exercise in revisionism whose point . . . is no doubt true , but serves as a rather thin moral to such a knowing fable . ","the nonstop artifice ultimately proves tiresome , with the surface histrionics failing to compensate for the paper-thin characterizations and facile situations . ","this is a monumental achievement in practically every facet of inept filmmaking : joyless , idiotic , annoying , heavy-handed , visually atrocious , and often downright creepy . ","this off-putting french romantic comedy is sure to test severely the indulgence of fans of amélie . ","overburdened with complicated plotting and banal dialogue","ensemble movies , like soap operas , depend on empathy . if there ain't none , you have a problem . ","the master of disguise falls under the category of 'should have been a sketch on saturday night live . '","yet another self-consciously overwritten story about a rag-tag bunch of would-be characters that team up for a can't-miss heist -- only to have it all go wrong . ","koepp's screenplay isn't nearly surprising or clever enough to sustain a reasonable degree of suspense on its own . ","is it really an advantage to invest such subtlety and warmth in an animatronic bear when the humans are acting like puppets ? ","more successful at relating history than in creating an emotionally complex , dramatically satisfying heroine","clumsy , obvious , preposterous , the movie will likely set the cause of woman warriors back decades . ","it's hard to pity the 'plain' girl who becomes a ravishing waif after applying a smear of lip-gloss . rather , pity anyone who sees this mishmash . ","a banal , virulently unpleasant excuse for a romantic comedy . ","the drama discloses almost nothing . ","a minor-league soccer remake of the longest yard . ","belongs in the too-hot-for-tv direct-to-video/dvd category , and this is why i have given it a one-star rating . ","as earnest as a community-college advertisement , american chai is enough to make you put away the guitar , sell the amp , and apply to medical school . ","a dim-witted and lazy spin-off of the animal planet documentary series , crocodile hunter is entertainment opportunism at its most glaring . ","there is more than one joke about putting the toilet seat down . and that should tell you everything you need to know about all the queen's men . ","even fans of ismail merchant's work , i suspect , would have a hard time sitting through this one . ","it's really just another silly hollywood action film , one among a multitude of simple-minded , yahoo-ing death shows . ","it's not a particularly good film , but neither is it a monsterous one . ","the world needs more filmmakers with passionate enthusiasms like martin scorsese . but it doesn't need gangs of new york . ","enchanted with low-life tragedy and liberally seasoned with emotional outbursts . . . what is sorely missing , however , is the edge of wild , lunatic invention that we associate with cage's best acting . ","harry potter and the chamber of secrets is deja vu all over again , and while that is a cliche , nothing could be more appropriate . it's likely that whatever you thought of the first production -- pro or con -- you'll likely think of this one . ","sade achieves the near-impossible : it turns the marquis de sade into a dullard . ","[lin chung's] voice is rather unexceptional , even irritating ( at least to this western ear ) , making it awfully hard to buy the impetus for the complicated love triangle that develops between the three central characters . ","one of the most plain , unimaginative romantic comedies i've ever seen . ","though there's a clarity of purpose and even-handedness to the film's direction , the drama feels rigged and sluggish . ","unfortunately , the experience of actually watching the movie is less compelling than the circumstances of its making . ","unless there are zoning ordinances to protect your community from the dullest science fiction , impostor is opening today at a theater near you . ","it should be doing a lot of things , but doesn't . ","chen films the resolutely downbeat smokers only with every indulgent , indie trick in the book . "," . . . a rather bland affair . ","far-fetched premise , convoluted plot , and thematic mumbo jumbo about destiny and redemptive love . ","the movie tries to be ethereal , but ends up seeming goofy . ","i was hoping that it would be sleazy and fun , but it was neither . ","harris is supposed to be the star of the story , but comes across as pretty dull and wooden . ","soulless and -- even more damning -- virtually joyless , xxx achieves near virtuosity in its crapulence . ","a boring masquerade ball where normally good actors , even kingsley , are made to look bad . ","all the queen's men is a throwback war movie that fails on so many levels , it should pay reparations to viewers . ","the filmmakers keep pushing the jokes at the expense of character until things fall apart . ","rather than real figures , elling and kjell bjarne become symbolic characters whose actions are supposed to relate something about the naïf's encounter with the world . ","mariah carey gives us another peek at some of the magic we saw in glitter here in wisegirls . ","it's all arty and jazzy and people sit and stare and turn away from one another instead of talking and it's all about the silences and if you're into that , have at it . ","i suspect that you'll be as bored watching morvern callar as the characters are in it . if you go , pack your knitting needles . ","the lead actors share no chemistry or engaging charisma . we don't even like their characters . ","some writer dude , i think his name was , uh , michael zaidan , was supposed to have like written the screenplay or something , but , dude , the only thing that i ever saw that was written down were the zeroes on my paycheck . ","the movie doesn't generate a lot of energy . it is dark , brooding and slow , and takes its central idea way too seriously . ","this feature is about as necessary as a hole in the head","the cinematic equivalent of patronizing a bar favored by pretentious , untalented artistes who enjoy moaning about their cruel fate . ","spectators will indeed sit open-mouthed before the screen , not screaming but yawning . ","it feels like very light errol morris , focusing on eccentricity but failing , ultimately , to make something bigger out of its scrapbook of oddballs . ","a period story about a catholic boy who tries to help a jewish friend get into heaven by sending the audience straight to hell . ","the premise itself is just sooooo tired . pair that with really poor comedic writing . . . and you've got a huge mess . ","proves a lovely trifle that , unfortunately , is a little too in love with its own cuteness . ","did we really need a remake of  charade ?  ","some movies can get by without being funny simply by structuring the scenes as if they were jokes : a setup , delivery and payoff . stealing harvard can't even do that much . each scene immediately succumbs to gravity and plummets to earth . ","the only fun part of the movie is playing the obvious game . you try to guess the order in which the kids in the house will be gored . ","i spied with my little eye . . . a mediocre collection of cookie-cutter action scenes and occasionally inspired dialogue bits","entertains not so much because of its music or comic antics , but through the perverse pleasure of watching disney scrape the bottom of its own cracker barrel . ","the satire is just too easy to be genuinely satisfying . ","bearable . barely . ","less funny than it should be and less funny than it thinks it is . ","an  o bruin , where art thou ?  -style cross-country adventure . . . it has sporadic bursts of liveliness , some so-so slapstick and a few ear-pleasing songs on its soundtrack . ","a feeble tootsie knockoff . ","an awful movie that will only satisfy the most emotionally malleable of filmgoers . ","…the story is far-flung , illogical , and plain stupid . ","the very simple story seems too simple and the working out of the plot almost arbitrary . ","an allegory concerning the chronically mixed signals african american professionals get about overachieving could be intriguing , but the supernatural trappings only obscure the message . ","a very familiar tale , one that's been told by countless filmmakers about italian- , chinese- , irish- , latin- , indian- , russian- and other hyphenate american young men struggling to balance conflicting cultural messages . ","one key problem with these ardently christian storylines is that there is never any question of how things will turn out . ","essentially , the film is weak on detail and strong on personality","a relentless , bombastic and ultimately empty world war ii action flick . ","[hell is] looking down at your watch and realizing serving sara isn't even halfway through . ","too long , and larded with exposition , this somber cop drama ultimately feels as flat as the scruffy sands of its titular community . ","leaves viewers out in the cold and undermines some phenomenal performances . "," . . . a ho-hum affair , always watchable yet hardly memorable . ","swiftly deteriorates into a terribly obvious melodrama and rough-hewn vanity project for lead actress andie macdowell . ","the histrionic muse still eludes madonna and , playing a charmless witch , she is merely a charmless witch . ","you have no affinity for most of the characters . nothing about them is attractive . what they see in each other also is difficult to fathom . ","diaz , applegate , blair and posey are suitably kooky which should appeal to women and they strip down often enough to keep men alert , if not amused . ","a technically well-made suspenser . . . but its abrupt drop in iq points as it races to the finish line proves simply too discouraging to let slide . ","an inept , tedious spoof of '70s kung fu pictures , it contains almost enough chuckles for a three-minute sketch , and no more . ","it's a mystery how the movie could be released in this condition . ","absolutely ( and unintentionally ) terrifying . ","eckstraordinarily lame and severely boring . ","eight legged freaks falls flat as a spoof . ","no matter how much he runs around and acts like a doofus , accepting a 50-year-old in the role is creepy in a michael jackson sort of way . ","you'll just have your head in your hands wondering why lee's character didn't just go to a bank manager and save everyone the misery . ","'dragonfly' dwells on crossing-over mumbo jumbo , manipulative sentimentality , and sappy dialogue . ","in his determination to lighten the heavy subject matter , silberling also , to a certain extent , trivializes the movie with too many nervous gags and pratfalls . ","blade ii has a brilliant director and charismatic star , but it suffers from rampant vampire devaluation . ","veers uncomfortably close to pro-serb propaganda . ","staggeringly dreadful romance . ","movies like high crimes flog the dead horse of surprise as if it were an obligation . how about surprising us by trying something new ? ","final verdict : you've seen it all before . ","throwing in everything except someone pulling the pin from a grenade with his teeth , windtalkers seems to have ransacked every old world war ii movie for overly familiar material . ","if a few good men told us that we  can't handle the truth  than high crimes poetically states at one point in this movie that we  don't care about the truth .  ","further sad evidence that tom tykwer , director of the resonant and sense-spinning run lola run , has turned out to be a one-trick pony -- a maker of softheaded metaphysical claptrap . ","you'll trudge out of the theater feeling as though you rode the zipper after eating a corn dog and an extra-large cotton candy . ","the movie is a little tired ; maybe the original inspiration has run its course . ","this will go on so long as there are moviegoers anxious to see strange young guys doing strange guy things . ","a full-frontal attack on audience patience . ","any intellectual arguments being made about the nature of god are framed in a drama so clumsy , there is a real danger less sophisticated audiences will mistake it for an endorsement of the very things that bean abhors . ","it's a big idea , but the film itself is small and shriveled . ","debut effort by  project greenlight  winner is sappy and amateurish . ","one gets the impression the creators of don't ask don't tell laughed a hell of a lot at their own jokes . too bad none of it is funny . ","the cast has a high time , but de broca has little enthusiasm for such antique pulp . ","the film , like jimmy's routines , could use a few good laughs . ","the film has too many spots where it's on slippery footing , but is acceptable entertainment for the entire family and one that's especially fit for the kiddies . ","purports to be a hollywood satire but winds up as the kind of film that should be the target of something deeper and more engaging . oh , and more entertaining , too . "," . . . in the pile of useless actioners from mtv schmucks who don't know how to tell a story for more than four minutes . ","though it was made with careful attention to detail and is well-acted by james spader and maggie gyllenhaal , i felt disrespected . ","well-made but mush-hearted . ","humor in i spy is so anemic . ","the film is strictly routine . ","a real snooze . ","skillful as he is , mr . shyamalan is undone by his pretensions . ","while the new film is much more eye-catching than its blood-drenched stephen norrington-directed predecessor , the new script by the returning david s . goyer is much sillier . ","in addition to sporting one of the worst titles in recent cinematic history , ballistic : ecks vs . sever also features terrible , banal dialogue ; convenient , hole-ridden plotting ; superficial characters and a rather dull , unimaginative car chase . ","it shares the first two films' loose-jointed structure , but laugh-out-loud bits are few and far between . ","the santa clause 2 is a barely adequate babysitter for older kids , but i've got to give it thumbs down . ","you cannot guess why the cast and crew didn't sign a pact to burn the negative and the script and pretend the whole thing never existed . ","barney throws away the goodwill the first half of his movie generates by orchestrating a finale that is impenetrable and dull . ","if you're really renting this you're not interested in discretion in your entertainment choices , you're interested in anne geddes , john grisham , and thomas kincaid . ","we get the comedy we settle for . ","the uneven movie does have its charms and its funny moments but not quite enough of them . ","two hours of sepia-tinted heavy metal images and surround sound effects of people moaning . ","a word of advice to the makers of the singles ward : celebrity cameos do not automatically equal laughs . and neither do cliches , no matter how 'inside' they are . ","the campy results make mel brooks' borscht belt schtick look sophisticated . ","its appeal will probably limited to lds church members and undemanding armchair tourists . ","the hanukkah spirit seems fried in pork . ","cherish would've worked a lot better had it been a short film . ","manipulative claptrap , a period-piece movie-of-the-week , plain old blarney . . . take your pick . all three descriptions suit evelyn , a besotted and obvious drama that tells us nothing new . ","hey arnold ! is now stretched to barely feature length , with a little more attention paid to the animation . still , the updated dickensian sensibility of writer craig bartlett's story is appealing . ","true to its title , it traps audiences in a series of relentlessly nasty situations that we would pay a considerable ransom not to be looking at . ","doesn't come close to justifying the hype that surrounded its debut at the sundance film festival two years ago . ","the plot is paper-thin and the characters aren't interesting enough to watch them go about their daily activities for two whole hours . ","kaufman's script is never especially clever and often is rather pretentious . ","the film didn't move me one way or the other , but it was an honest effort and if you want to see a flick about telemarketers this one will due . ","queen of the damned is too long with too little going on . ","it collapses when mr . taylor tries to shift the tone to a thriller's rush . ","any film that doesn't even in passing mention political prisoners , poverty and the boat loads of people who try to escape the country is less a documentary and more propaganda by way of a valentine sealed with a kiss . "," . . . blade ii is still top-heavy with blazing guns , cheatfully filmed martial arts , disintegrating bloodsucker computer effects and jagged camera moves that serve no other purpose than to call attention to themselves . ","the rules of attraction gets us too drunk on the party favors to sober us up with the transparent attempts at moralizing . ","though there are many tense scenes in trapped , they prove more distressing than suspenseful . ","in this film we at least see a study in contrasts ; the wide range of one actor , and the limited range of a comedian . ","feels strangely hollow at its emotional core . ","no surprises . ","you have once again entered the bizarre realm where director adrian lyne holds sway , where all relationships are simultaneously broadly metaphorical , oddly abstract , and excruciatingly literal . ","the high-concept scenario soon proves preposterous , the acting is robotically italicized , and truth-in-advertising hounds take note : there's very little hustling on view . ","this director's cut -- which adds 51 minutes -- takes a great film and turns it into a mundane soap opera . ","characterisation has been sacrificed for the sake of spectacle . ","the venezuelans say things like  si , pretty much  and  por favor , go home  when talking to americans . that's muy loco , but no more ridiculous than most of the rest of  dragonfly .  ","it's a movie that ends with truckzilla , for cryin' out loud . if that doesn't clue you in that something's horribly wrong , nothing will . ","director tom shadyac and star kevin costner glumly mishandle the story's promising premise of a physician who needs to heal himself . ","it's difficult to imagine that a more confused , less interesting and more sloppily made film could possibly come down the road in 2002 . ","like the tuck family themselves , this movie just goes on and on and on and on","as pedestrian as they come . ","a film that plays things so nice 'n safe as to often play like a milquetoast movie of the week blown up for the big screen . ","it's a feel-bad ending for a depressing story that throws a bunch of hot-button items in the viewer's face and asks to be seen as hip , winking social commentary . ","put it somewhere between sling blade and south of heaven , west of hell in the pantheon of billy bob's body of work . ","more intellectually scary than dramatically involving . ","an inconsequential , barely there bit of piffle . ","the abiding impression , despite the mild hallucinogenic buzz , is of overwhelming waste -- the acres of haute couture can't quite conceal that there's nothing resembling a spine here . ","as saccharine as it is disposable . ","you come away thinking not only that kate isn't very bright , but that she hasn't been worth caring about and that maybe she , janine and molly -- an all-woman dysfunctional family -- deserve one another . ","the metaphors are provocative , but too often , the viewer is left puzzled by the mechanics of the delivery . ","very much a home video , and so devoid of artifice and purpose that it appears not to have been edited at all . ","too much power , not enough puff . ","the attempt to build up a pressure cooker of horrified awe emerges from the simple fact that the movie has virtually nothing to show . ","it's provocative stuff , but the speculative effort is hampered by taylor's cartoonish performance and the film's ill-considered notion that hitler's destiny was shaped by the most random of chances . ","a cellophane-pop remake of the punk classic ladies and gentlemen , the fabulous stains . . . crossroads is never much worse than bland or better than inconsequential . ","muddled , trashy and incompetent","for this sort of thing to work , we need agile performers , but the proficient , dull sorvino has no light touch , and rodan is out of his league . ","narc is all menace and atmosphere . ","though excessively tiresome , the uncertainty principle , as verbally pretentious as the title may be , has its handful of redeeming features , as long as you discount its ability to bore . ","despite juliet stevenon's attempt to bring cohesion to pamela's emotional roller coaster life , it is not enough to give the film the substance it so desperately needs . ","it's tough to be startled when you're almost dozing . ","his [nelson's] screenplay needs some serious re-working to show more of the dilemma , rather than have his characters stage shouting matches about it . ","it's so downbeat and nearly humorless that it becomes a chore to sit through -- despite some first-rate performances by its lead . ","a terrible movie that some people will nevertheless find moving . ","there are many definitions of 'time waster' but this movie must surely be one of them . ","as it stands , crocodile hunter has the hurried , badly cobbled look of the 1959 godzilla , which combined scenes of a japanese monster flick with canned shots of raymond burr commenting on the monster's path of destruction . ","the thing looks like a made-for-home-video quickie . ","enigma is well-made , but it's just too dry and too placid . "];

/***/ },
/* 113 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});/* Source: http://www.cs.cornell.edu/people/pabo/movie-review-data/ */var positives=exports.positives=["not terrible","not bad","i love this movie","everything about it is great","the rock is destined to be the 21st century's new  conan  and that he's going to make a splash even greater than arnold schwarzenegger , jean-claud van damme or steven segal . ","the gorgeously elaborate continuation of  the lord of the rings  trilogy is so huge that a column of words cannot adequately describe co-writer/director peter jackson's expanded vision of j . r . r . tolkien's middle-earth . ","effective but too-tepid biopic","if you sometimes like to go to the movies to have fun , wasabi is a good place to start . ","emerges as something rare , an issue movie that's so honest and keenly observed that it doesn't feel like one . ","the film provides some great insight into the neurotic mindset of all comics -- even those who have reached the absolute top of the game . ","offers that rare combination of entertainment and education . ","perhaps no picture ever made has more literally showed that the road to hell is paved with good intentions . ","steers turns in a snappy screenplay that curls at the edges ; it's so clever you want to hate it . but he somehow pulls it off . ","take care of my cat offers a refreshingly different slice of asian cinema . ","this is a film well worth seeing , talking and singing heads and all . ","what really surprises about wisegirls is its low-key quality and genuine tenderness . "," ( wendigo is ) why we go to the cinema : to be fed through the eye , the heart , the mind . ","one of the greatest family-oriented , fantasy-adventure movies ever . ","ultimately , it ponders the reasons we need stories so much . ","an utterly compelling 'who wrote it' in which the reputation of the most famous author who ever lived comes into question . ","illuminating if overly talky documentary . ","a masterpiece four years in the making . ","the movie's ripe , enrapturing beauty will tempt those willing to probe its inscrutable mysteries . ","offers a breath of the fresh air of true sophistication . ","a thoughtful , provocative , insistently humanizing film . ","with a cast that includes some of the top actors working in independent film , lovely & amazing involves us because it is so incisive , so bleakly amusing about how we go about our lives . ","a disturbing and frighteningly evocative assembly of imagery and hypnotic music composed by philip glass . ","not for everyone , but for those with whom it will connect , it's a nice departure from standard moviegoing fare . ","scores a few points for doing what it does with a dedicated and good-hearted professionalism . ","occasionally melodramatic , it's also extremely effective . ","spiderman rocks","an idealistic love story that brings out the latent 15-year-old romantic in everyone . ","at about 95 minutes , treasure planet maintains a brisk pace as it races through the familiar story . however , it lacks grandeur and that epic quality often associated with stevenson's tale as well as with earlier disney efforts . ","it helps that lil bow wow . . . tones down his pint-sized gangsta act to play someone who resembles a real kid . ","guaranteed to move anyone who ever shook , rattled , or rolled . ","a masterful film from a master filmmaker , unique in its deceptive grimness , compelling in its fatalist worldview . ","light , cute and forgettable . ","if there's a way to effectively teach kids about the dangers of drugs , i think it's in projects like the ( unfortunately r-rated ) paid . ","while it would be easy to give crush the new title of two weddings and a funeral , it's a far more thoughtful film than any slice of hugh grant whimsy . ","though everything might be literate and smart , it never took off and always seemed static . ","cantet perfectly captures the hotel lobbies , two-lane highways , and roadside cafes that permeate vincent's days","ms . fulford-wierzbicki is almost spooky in her sulky , calculating lolita turn . ","though it is by no means his best work , laissez-passer is a distinguished and distinctive effort by a bona-fide master , a fascinating film replete with rewards to be had by all willing to make the effort to reap them . ","like most bond outings in recent years , some of the stunts are so outlandish that they border on being cartoonlike . a heavy reliance on cgi technology is beginning to creep into the series . ","newton draws our attention like a magnet , and acts circles around her better known co-star , mark wahlberg . ","the story loses its bite in a last-minute happy ending that's even less plausible than the rest of the picture . much of the way , though , this is a refreshingly novel ride . ","fuller would surely have called this gutsy and at times exhilarating movie a great yarn . ","'compleja e intelectualmente retadora , el ladrón de orquídeas es uno de esos filmes que vale la pena ver precisamente por su originalidad . '","the film makes a strong case for the importance of the musicians in creating the motown sound . ","karmen moves like rhythm itself , her lips chanting to the beat , her long , braided hair doing little to wipe away the jeweled beads of sweat . ","gosling provides an amazing performance that dwarfs everything else in the film . ","a real movie , about real people , that gives us a rare glimpse into a culture most of us don't know . ","tender yet lacerating and darkly funny fable . ","may be spoofing an easy target -- those old '50's giant creature features -- but . . . it acknowledges and celebrates their cheesiness as the reason why people get a kick out of watching them today . ","an engaging overview of johnson's eccentric career . ","in its ragged , cheap and unassuming way , the movie works . ","some actors have so much charisma that you'd be happy to listen to them reading the phone book . hugh grant and sandra bullock are two such likeable actors . ","sandra nettelbeck beautifully orchestrates the transformation of the chilly , neurotic , and self-absorbed martha as her heart begins to open . ","behind the snow games and lovable siberian huskies ( plus one sheep dog ) , the picture hosts a parka-wrapped dose of heart . ","everytime you think undercover brother has run out of steam , it finds a new way to surprise and amuse . ","manages to be original , even though it rips off many of its ideas . ","singer/composer bryan adams contributes a slew of songs — a few potential hits , a few more simply intrusive to the story — but the whole package certainly captures the intended , er , spirit of the piece . ","you'd think by now america would have had enough of plucky british eccentrics with hearts of gold . yet the act is still charming here . ","whether or not you're enlightened by any of derrida's lectures on  the other  and  the self ,  derrida is an undeniably fascinating and playful fellow . ","a pleasant enough movie , held together by skilled ensemble actors . ","this is the best american movie about troubled teens since 1998's whatever . ","disney has always been hit-or-miss when bringing beloved kids' books to the screen . . . tuck everlasting is a little of both . ","just the labour involved in creating the layered richness of the imagery in this chiaroscuro of madness and light is astonishing . ","the animated subplot keenly depicts the inner struggles of our adolescent heroes - insecure , uncontrolled , and intense . ","the invincible werner herzog is alive and well and living in la","morton is a great actress portraying a complex character , but morvern callar grows less compelling the farther it meanders from its shocking start . ","part of the charm of satin rouge is that it avoids the obvious with humour and lightness . ","son of the bride may be a good half-hour too long but comes replete with a flattering sense of mystery and quietness . ","a simmering psychological drama in which the bursts of sudden violence are all the more startling for the slow buildup that has preceded them . ","a taut , intelligent psychological drama . ","a compelling coming-of-age drama about the arduous journey of a sensitive young girl through a series of foster homes and a fierce struggle to pull free from her dangerous and domineering mother's hold over her . ","a truly moving experience , and a perfect example of how art -- when done right -- can help heal , clarify , and comfort . ","this delicately observed story , deeply felt and masterfully stylized , is a triumph for its maverick director . ","at heart the movie is a deftly wrought suspense yarn whose richer shadings work as coloring rather than substance . ","the appearance of treebeard and gollum's expanded role will either have you loving what you're seeing , or rolling your eyes . i loved it ! gollum's 'performance' is incredible ! ","a screenplay more ingeniously constructed than  memento  ","if this movie were a book , it would be a page-turner , you can't wait to see what happens next . ","haneke challenges us to confront the reality of sexual aberration . ","absorbing and disturbing -- perhaps more disturbing than originally intended -- but a little clarity would have gone a long way . ","it's the best film of the year so far , the benchmark against which all other best picture contenders should be measured . ","painful to watch , but viewers willing to take a chance will be rewarded with two of the year's most accomplished and riveting film performances . ","this is a startling film that gives you a fascinating , albeit depressing view of iranian rural life close to the iraqi border . ","an imaginative comedy/thriller . ","a few artsy flourishes aside , narc is as gritty as a movie gets these days . ","while the isle is both preposterous and thoroughly misogynistic , its vistas are incredibly beautiful to look at . ","together , tok and o orchestrate a buoyant , darkly funny dance of death . in the process , they demonstrate that there's still a lot of life in hong kong cinema . ","director kapur is a filmmaker with a real flair for epic landscapes and adventure , and this is a better film than his earlier english-language movie , the overpraised elizabeth . ","the movie is a blast of educational energy , as bouncy animation and catchy songs escort you through the entire 85 minutes . ","a sports movie with action that's exciting on the field and a story you care about off it . ","doug liman , the director of bourne , directs the traffic well , gets a nice wintry look from his locations , absorbs us with the movie's spycraft and uses damon's ability to be focused and sincere . ","the tenderness of the piece is still intact . ","katz uses archival footage , horrifying documents of lynchings , still photographs and charming old reel-to-reel recordings of meeropol entertaining his children to create his song history , but most powerful of all is the song itself","like the film's almost anthropologically detailed realization of early-'80s suburbia , it's significant without being overstated . ","while mcfarlane's animation lifts the film firmly above the level of other coming-of-age films . . . it's also so jarring that it's hard to get back into the boys' story . ","if nothing else , this movie introduces a promising , unusual kind of psychological horror . ","in a normal screen process , these bromides would be barely enough to sustain an interstitial program on the discovery channel . but in imax 3-d , the clichés disappear into the vertiginous perspectives opened up by the photography . ","writer-director burger imaginatively fans the embers of a dormant national grief and curiosity that has calcified into chronic cynicism and fear . "," . . . a roller-coaster ride of a movie","i enjoyed time of favor while i was watching it , but i was surprised at how quickly it faded from my memory . ","chicago is sophisticated , brash , sardonic , completely joyful in its execution . ","steve irwin's method is ernest hemmingway at accelerated speed and volume . ","a refreshing korean film about five female high school friends who face an uphill battle when they try to take their relationships into deeper waters . ","on the surface , it's a lovers-on-the-run crime flick , but it has a lot in common with piesiewicz's and kieslowski's earlier work , films like the double life of veronique . ","the values that have held the enterprise crew together through previous adventures and perils do so again-courage , self-sacrifice and patience under pressure . ","if it's possible for a sequel to outshine the original , then sl2 does just that . ","a romantic comedy that operates by the rules of its own self-contained universe . ","4 friends , 2 couples , 2000 miles , and all the pabst blue ribbon beer they can drink - it's the ultimate redneck road-trip . ","the film is often filled with a sense of pure wonderment and excitement not often seen in today's cinema du sarcasm","it might be tempting to regard mr . andrew and his collaborators as oddballs , but mr . earnhart's quizzical , charming movie allows us to see them , finally , as artists . ","a feel-good picture in the best sense of the term . ","edited and shot with a syncopated style mimicking the work of his subjects , pray turns the idea of the documentary on its head , making it rousing , invigorating fun lacking any mtv puffery . ","a mostly intelligent , engrossing and psychologically resonant suspenser . ","it's this memory-as-identity obviation that gives secret life its intermittent unease , reaffirming that long-held illusions are indeed reality , and that erasing them recasts the self . ","hip-hop has a history , and it's a metaphor for this love story . ","in scope , ambition and accomplishment , children of the century . . . takes kurys' career to a whole new level . ","this may not have the dramatic gut-wrenching impact of other holocaust films , but it's a compelling story , mainly because of the way it's told by the people who were there . ","between the drama of cube ? s personal revelations regarding what the shop means in the big picture , iconic characters gambol fluidly through the story , with charming results . ","a gentle , compassionate drama about grief and healing . ","somewhere short of tremors on the modern b-scene : neither as funny nor as clever , though an agreeably unpretentious way to spend ninety minutes . ","digital-video documentary about stand-up comedians is a great glimpse into a very different world . ","unlike most teen flicks , swimming takes its time to tell its story , casts mostly little-known performers in key roles , and introduces some intriguing ambiguity . ","an enthralling , playful film that constantly frustrates our desire to know the 'truth' about this man , while deconstructing the very format of the biography in a manner that derrida would doubtless give his blessing to . ","  extreme ops  exceeds expectations . good fun , good action , good acting , good dialogue , good pace , good cinematography . ","you should pay nine bucks for this : because you can hear about suffering afghan refugees on the news and still be unaffected . dramas like this make it human . ","a thunderous ride at first , quiet cadences of pure finesse are few and far between ; their shortage dilutes the potency of otherwise respectable action . still , this flick is fun , and host to some truly excellent sequences . ","it's obviously struck a responsive chord with many south koreans , and should work its magic in other parts of the world . ","run , don't walk , to see this barbed and bracing comedy on the big screen . ","a classy item by a legend who may have nothing left to prove but still has the chops and drive to show how its done . ","it is nature against progress . in fessenden's horror trilogy , this theme has proved important to him and is especially so in the finale . ","it's not exactly a gourmet meal but the fare is fair , even coming from the drive-thru . ","this is what imax was made for : strap on a pair of 3-d goggles , shut out the real world , and take a vicarious voyage to the last frontier -- space . ","merely as a technical , logistical feat , russian ark marks a cinematic milestone . ","[schweiger is] talented and terribly charismatic , qualities essential to both movie stars and social anarchists . ","it's a great deal of sizzle and very little steak . but what spectacular sizzle it is ! . . . in this incarnation its fizz is infectious . ","an original gem about an obsession with time . ","it will delight newcomers to the story and those who know it from bygone days . ","gloriously goofy ( and gory ) midnight movie stuff . ","the film overcomes the regular minefield of coming-of-age cliches with potent doses of honesty and sensitivity . ","if your senses haven't been dulled by slasher films and gorefests , if you're a connoisseur of psychological horror , this is your ticket . ","it's a minor comedy that tries to balance sweetness with coarseness , while it paints a sad picture of the singles scene . ","it is intensely personal and yet -- unlike quills -- deftly shows us the temper of the times . ","as lo-fi as the special effects are , the folks who cobbled nemesis together indulge the force of humanity over hardware in a way that george lucas has long forgotten . ","like mike doesn't win any points for originality . it does succeed by following a feel-good formula with a winning style , and by offering its target audience of urban kids some welcome role models and optimism . ","it's a hoot and a half , and a great way for the american people to see what a candidate is like when he's not giving the same 15-cent stump speech . ","far from perfect , but its heart is in the right place . . . innocent and well-meaning . ","a sad , superior human comedy played out on the back roads of life . ","waydowntown is by no means a perfect film , but its boasts a huge charm factor and smacks of originality . ","tim allen is great in his role but never hogs the scenes from his fellow cast , as there are plenty of laughs and good lines for everyone in this comedy . ","more a load of enjoyable , conan-esque claptrap than the punishing , special-effects soul assaults the mummy pictures represent . ","enormously likable , partly because it is aware of its own grasp of the absurd . ","here's a british flick gleefully unconcerned with plausibility , yet just as determined to entertain you . ","it's an old story , but a lively script , sharp acting and partially animated interludes make just a kiss seem minty fresh . ","must be seen to be believed . ","ray liotta and jason patric do some of their best work in their underwritten roles , but don't be fooled : nobody deserves any prizes here . ","everything that has to do with yvan and charlotte , and everything that has to do with yvan's rambunctious , jewish sister and her non-jew husband , feels funny and true . ","sweet home alabama  is what it is – a nice , harmless date film . . . ","the year's happiest surprise , a movie that deals with a real subject in an always surprising way . ","fans of behan's work and of irish movies in general will be rewarded by borstal boy . ","its mysteries are transparently obvious , and it's too slowly paced to be a thriller . [but it's] worth recommending because of two marvelous performances by michael caine and brendan fraser . ","the film is faithful to what one presumes are the book's twin premises -- that we become who we are on the backs of our parents , but we have no idea who they were at our age ; and that time is a fleeting and precious commodity no matter how old you are . ","stephen earnhart's homespun documentary mule skinner blues has nothing but love for its posse of trailer park denizens . ","a solidly seaworthy chiller . ","if you can get past the fantastical aspects and harsh realities of  the isle  you'll get a sock-you-in-the-eye flick that is a visual tour-de-force and a story that is unlike any you will likely see anywhere else . ","there are as many misses as hits , but ultimately , it finds humor in the foibles of human behavior , and it's a welcome return to the roots of a genre that should depend on surprises . ","a well-made thriller with a certain level of intelligence and non-reactionary morality . ","there's enough science to make it count as educational , and enough beauty to make it unforgettable . ","remains a solid , if somewhat heavy-handed , account of the near-disaster . . . done up by howard with a steady , if not very imaginative , hand . ","makmalbaf follows a resolutely realistic path in this uncompromising insight into the harsh existence of the kurdish refugees of iran's borderlands . ","for a good chunk of its running time , trapped is an effective and claustrophobic thriller . ","most of crush is a clever and captivating romantic comedy with a welcome pinch of tartness . ","nair does capture the complexity of a big family and its trials and tribulations . . . ","the seaside splendor and shallow , beautiful people are nice to look at while you wait for the story to get going . ","rare is the 'urban comedy' that even attempts the insight and honesty of this disarming indie . ","ranks among willams' best screen work . ","engagingly captures the maddening and magnetic ebb and flow of friendship . ","an experience so engrossing it is like being buried in a new environment . ","it's traditional moviemaking all the way , but it's done with a lot of careful period attention as well as some very welcome wit . ","thoroughly enjoyable . ","maybe it's just because this past year has seen the release of some of the worst film comedies in decades . . . but honestly , analyze that really isn't all that bad . ","a droll , well-acted , character-driven comedy with unexpected deposits of feeling . ","this is simply the most fun you'll ever have with a documentary ! ","a very funny movie . ","watching haneke's film is , aptly enough , a challenge and a punishment . but watching huppert , a great actress tearing into a landmark role , is riveting . ","a cop story that understands the medium amazingly well . ","one of the best , most understated performances of [jack nicholson's] career . ","britney has been delivered to the big screen safe and sound , the way we like our 20-year-old superstar girls to travel on the fame freeway . ","those outside show business will enjoy a close look at people they don't really want to know . ","the kind of nervous film that will either give you a mild headache or exhilarate you . ","watching beanie and his gang put together his slasher video from spare parts and borrowed materials is as much fun as it must have been for them to make it . ","children may not understand everything that happens -- i'm not sure even miyazaki himself does -- but they will almost certainly be fascinated , and undoubtedly delighted . ","a fascinating and fun film . ","tadpole is a sophisticated , funny and good-natured treat , slight but a pleasure . ","this insightful , oscar-nominated documentary , in which children on both sides of the ever-escalating conflict have their say away from watchful parental eyes , gives peace yet another chance . ","i admired this work a lot . ","whether you're moved and love it , or bored or frustrated by the film , you'll still feel something . "," . . . there are enough moments of heartbreaking honesty to keep one glued to the screen . ","my goodness , queen latifah has a lot to offer and she seemed to have no problem flaunting her natural gifts . she must have a very strong back . ","a smart , sweet and playful romantic comedy . ","australian actor/director john polson and award-winning english cinematographer giles nuttgens make a terrific effort at disguising the obvious with energy and innovation . ","without heavy-handedness , dong provides perspective with his intelligent grasp of human foibles and contradictions . ","solid , lump-in-the-throat family entertainment that derives its power by sticking to the facts . ","as an entertainment , the movie keeps you diverted and best of all , it lightens your wallet without leaving a sting . ","it is interesting and fun to see goodall and her chimpanzees on the bigger-than-life screen . ","it won't bust your gut -- and it's not intended to -- it's merely a blandly cinematic surgical examination of what makes a joke a joke . ","a somewhat crudely constructed but gripping , questing look at a person so racked with self-loathing , he becomes an enemy to his own race . ","it extends the writings of jean genet and john rechy , the films of fassbinder , perhaps even the nocturnal works of goya . ","narc may not get an 'a' for originality , but it wears its b-movie heritage like a badge of honor . ","with the film's striking ending , one realizes that we have a long way to go before we fully understand all the sexual permutations involved . ","[drumline] is entertaining for what it does , and admirable for what it doesn't do . ","at its best early on as it plays the culture clashes between the brothers . ","[a] rare , beautiful film . ","an unabashedly schmaltzy and thoroughly enjoyable true story . ","a thoughtful look at a painful incident that made headlines in 1995 . ","you walk out of the good girl with mixed emotions — disapproval of justine combined with a tinge of understanding for her actions . ","tsai ming-liang has taken his trademark style and refined it to a crystalline point . ","purely propaganda , a work of unabashed hero worship , it is nonetheless -- and likely inadvertently -- a timely and invaluable implicit reminder of the role that u . s . foreign policy has played in the rise of castro . ","now trimmed by about 20 minutes , this lavish three-year-old production has enough grandeur and scale to satisfy as grown-up escapism . ","we get some truly unique character studies and a cross-section of americana that hollywood couldn't possibly fictionalize and be believed . ","though this film can be clumsy , its ambitions are equally -- and admirably -- uncommercial . ","daring , mesmerizing and exceedingly hard to forget . ","the dangerous lives of altar boys' take on adolescence feels painfully true . ","moore's performance impresses almost as much as her work with haynes in 1995's safe . ","visits spy-movie territory like a novel you can't put down , examines a footnote to history seldom brought to light on the screen , and keeps you guessing from first frame to last . ","an absorbing , slice-of-depression life that touches nerves and rings true . ","mr . parker has brilliantly updated his source and grasped its essence , composing a sorrowful and hilarious tone poem about alienated labor , or an absurdist workplace sitcom . ","the result is something quite fresh and delightful . ","all but the most persnickety preteens should enjoy this nonthreatening but thrilling adventure . ","despite its many infuriating flaws -- not the least of which is amy's self-absorbed personality -- amy's o's honesty will win you over . ","this is one of polanski's best films . ","day is not a great bond movie , but it is a good bond movie , which still makes it much better than your typical bond knock-offs . ","polished korean political-action film is just as good -- and bad -- as hollywood action epics . is this progress ? ","elling , portrayed with quiet fastidiousness by per christian ellefsen , is a truly singular character , one whose frailties are only slightly magnified versions of the ones that vex nearly everyone . ","denis and co-writer michele petin's impeccable screenplay penetrates with a rawness that that is both unflinching and tantalizing . lead provocatuers testud and parmentier give superlative performances","an absorbing trip into the minds and motivations of people under stress as well as a keen , unsentimental look at variations on the theme of motherhood . ","i admired it , particularly that unexpected downer of an ending . ","the passions aroused by the discord between old and new cultures are set against the strange , stark beauty of the mideast desert , so lovingly and perceptively filmed that you can almost taste the desiccated air . ","remarkably accessible and affecting . ","never mind whether you buy the stuff about barris being a cia hit man . the kooky yet shadowy vision clooney sustains throughout is daring , inventive and impressive . ","a triumph of art direction over narrative , but what art direction ! ","behan himself knew how to spin a tale and one can't help but think he'd appreciate this attempt to turn his life into art . ","jirí hubac's script is a gem . his characters are engaging , intimate and the dialogue is realistic and greatly moving . the scope of the silberstein family is large and we grow attached to their lives , full of strength , warmth and vitality . . ","moore's complex and important film is also , believe it or not , immensely entertaining , a david and goliath story that's still very much playing itself out . ","the additional storyline is interesting and entertaining , but it doesn't have the same magical quality as the beginning of the story . i like the new footage and still love the old stuff . ","though mama takes a bit too long to find its rhythm and a third-act plot development is somewhat melodramatic , its ribald humor and touching nostalgia are sure to please anyone in search of a jules and jim for the new millennium . ","you might not buy the ideas . but you'll definitely want the t-shirt . ","provides an intriguing window into the imagination and hermetic analysis of todd solondz . ","windtalkers is shapelessly gratifying , the kind of movie that invites you to pick apart its faults even as you have to admit that somehow it hit you where you live . ","presents an astute appraisal of middle american musical torpor and the desperate struggle to escape it . ","just what makes us happy , anyway ? ","a thoughtful , moving piece that faces difficult issues with honesty and beauty . ","one of the greatest romantic comedies of the past decade . ","you wouldn't call the good girl a date movie ( an anti-date movie is more like it ) , but when it's good , it's good and horrid . ","benefits from a strong performance from zhao , but it's dong jie's face you remember at the end . ","this is a film brimming with detail and nuance and one that speaks volumes about the ability of the human spirit to find solace in events that could easily crush it forever . ","the director , steven shainberg , has succeeded by focusing intently on his characters , making them quirky individuals rather than figures of fun . ","it ultimately stands forth as an important chronicle of the abuses of one of latin america's most oppressive regimes . ","the movie has a soft , percolating magic , a deadpan suspense . ","a well-made and often lovely depiction of the mysteries of friendship . ","using his audience as a figurative port-of-call , dong pulls his even-handed ideological ship to their dock for unloading , before he continues his longer journey still ahead . "," . . . understands that a generation defines its music as much as the music defines a generation . ","the transporter is as lively and as fun as it is unapologetically dumb","as a witness to several greek-american weddings -- but , happily , a victim of none -- i can testify to the comparative accuracy of ms . vardalos' memories and insights . ","has it ever been possible to say that williams has truly inhabited a character ? it is now . ","by presenting an impossible romance in an impossible world , pumpkin dares us to say why either is impossible -- which forces us to confront what's possible and what we might do to make it so . ","an impressive debut for first-time writer-director mark romanek , especially considering his background is in music video . ","an incendiary , deeply thought-provoking look at one of the most peculiar ( and peculiarly venomous ) bigotries in our increasingly frightening theocracy","all the performances are top notch and , once you get through the accents , all or nothing becomes an emotional , though still positive , wrench of a sit . ","  its successes are also tempered with elements which prove the direct antithesis of what it gets right .  ","it's solid and affecting and exactly as thought-provoking as it should be . ","this is such a dazzlingly self-assured directorial debut that it's hard to know what to praise first . ","parker holds true to wilde's own vision of a pure comedy with absolutely no meaning , and no desire to be anything but a polished , sophisticated entertainment that is in love with its own cleverness . ","münch's genuine insight makes the film's occasional overindulgence forgivable . ","thankfully , the film , which skirts that rapidly deteriorating line between fantasy and reality . . . takes a tongue-in-cheek attitude even as it pushes the croc hunter agenda . ","ultimately , the message of trouble every day seems to be that all sexual desire disrupts life's stasis . ","if you're like me , a sucker for a good old fashion romance and someone who shamelessly loves to eat , then mostly martha offers all the perfect ingredients to more than satisfy your appetite . ","the film has just enough of everything -- re-enactments , archival footage , talking-head interviews -- and the music is simply sublime . ","there are a few stabs at absurdist comedy . . . but mostly the humor is of the sweet , gentle and occasionally cloying kind that has become an iranian specialty . ","a wonderful character-based comedy . ","it would be interesting to hear from the other side , but in talk to her , the women are down for the count . ","an endearingly offbeat romantic comedy with a great meet-cute gimmick . ","the unique tug-of-war with viewer expectations is undeniable , if not a pleasure in its own right . ","it uses an old-time formula , it's not terribly original and it's rather messy -- but you just have to love the big , dumb , happy movie my big fat greek wedding . ","it's almost impossible not to be moved by the movie's depiction of sacrifice and its stirring epilogue in post-soviet russia . ","who knows what exactly godard is on about in this film , but his words and images don't have to add up to mesmerize you . ","the tone is balanced , reflective and reasonable . ","the principals in this cast are all fine , but bishop and stevenson are standouts . ","it could change america , not only because it is full of necessary discussion points , but because it is so accessible that it makes complex politics understandable to viewers looking for nothing but energetic entertainment . ","what's most striking about this largely celebratory film . . . is the sense of isolation that permeates these bastions of individuality in an ikea world . "," . . . if you're in a mind set for goofy comedy , the troopers will entertain with their gross outs , bawdy comedy and head games . ","somewhat blurred , but kinnear's performance is razor sharp . ","as a director , mr . ratliff wisely rejects the temptation to make fun of his subjects . ","for anyone who remembers the '60s or is interested in one man's response to stroke , ram dass : fierce grace is worth seeking out . ","intriguing and beautiful film , but those of you who read the book are likely to be disappointed . ","the new guy does have a heart . now , if it only had a brain . ","a savvy exploration of paranoia and insecurity in america's culture of fear . ","legendary irish writer brendan behan's memoir , borstal boy , has been given a loving screen transferral . ","the film's greatest asset is how much it's not just another connect-the-dots , spy-on-the-run picture . ","this clever caper movie has twists worthy of david mamet and is enormous fun for thinking audiences . ","it's one of the saddest films i have ever seen that still manages to be uplifting but not overly sentimental . ","morton is , as usual , brilliant . ","even with all those rough edges safely sanded down , the american insomnia is still pretty darned good . ","i don't know precisely what to make of steven soderbergh's full frontal , though that didn't stop me from enjoying much of it . ","the tug of war that ensues is as much a snapshot of modern china in microcosm as it is a crash course in movie mythology . ","nearly surreal , dabbling in french , this is no simple movie , and you'll be taking a risk if you choose to see it . i enjoyed the ride ( bumps and all ) , creamy depth , and ultimate theme . ","you could say that it's slow at times , you could say that a few of the characters act in ways that real people wouldn't , but one thing you couldn't say is that alias betty is predictable . ","asia authors herself as anna battista , an italian superstar and aspiring directress who just happens to be her own worst enemy . ","roman coppola may never become the filmmaker his dad was , but heck – few filmmakers will . but based on cq , i'll certainly be keeping an eye out for his next project . ","an amusing , breezily apolitical documentary about life on the campaign trail . ","high on melodrama . but it's emotionally engrossing , too , thanks to strong , credible performances from the whole cast . ","finally , a genre movie that delivers -- in a couple of genres , no less . ","it's not so much enjoyable to watch as it is enlightening to listen to new sides of a previous reality , and to visit with some of the people who were able to make an impact in the theater world . ","spielberg is the rare director who does not want to invite viewers to gawk at or applaud his special effects . he just wants them to be part of the action , the wallpaper of his chosen reality . here , thankfully , they are . ","post 9/11 the philosophical message of  personal freedom first  might not be as palatable as intended . ","hu and liu offer natural , matter-of-fact performances that glint with sorrow , longing and love . ","this bold and lyrical first feature from raja amari expands the pat notion that middle-aged women just wanna have fun into a rousing treatise of sensual empowerment . ","easier to respect than enthuse over , andersson's rigorous personal vision is not only distanced but distancing . ","girls gone wild and gone civil again"," . . . tunney is allowed to build an uncommonly human character , an almost real-live girl complete with trouble and hope . ","while this film is not in the least surprising , it is still ultimately very satisfying . think of it as a sort of comfort food for the mind . ","clever , brutal and strangely soulful movie . "," . . . always remains movingly genuine . ","an intelligent fiction about learning through cultural clash . ","will grab your children by the imagination and amaze them and amuse them . ","a remarkable 179-minute meditation on the nature of revolution . ","those who would follow haneke on his creepy explorations . . . are rewarded by brutal , committed performances from huppert and magimel . ","an involving true story of a chinese actor who takes up drugs and winds up in an institution--acted mostly by the actual people involved . ","hands down the year's most thought-provoking film . but it pays a price for its intricate intellectual gamesmanship . ","it's a terrific american sports movie and dennis quaid is its athletic heart . ","this is such a high-energy movie where the drumming and the marching are so excellent , who cares if the story's a little weak . ","compelling revenge thriller , though somewhat weakened by a miscast leading lady . ","it's amazingly perceptive in its subtle , supportive but unsentimental look at the marks family . ","a whole lot foul , freaky and funny . ","family fare . ","attal mixes comedy with a serious exploration of ego and jealousy within a seemingly serene marriage . ","the diversity of the artists represented , both in terms of style and ethnicity , prevents the proceedings from feeling repetitious , as does the appropriately brief 40-minute running time . ","the pianist is a fine valedictory work for polanski , made richer by his own experiences , making his other movies somehow richer in the bargain . ","foster nails the role , giving a tight , focused performance illuminated by shards of feeling . ","even if you can't pronounce  gyro  correctly , you'll appreciate much of vardalos' humor , which transcends ethnic boundaries . ","is office work really as alienating as 'bartleby' so effectively makes it ? ","farrell . . . thankfully manages to outshine the role and successfully plays the foil to willis's world-weary colonel . ","audiences conditioned to getting weepy over saucer-eyed , downy-cheeked moppets and their empathetic caretakers will probably feel emotionally cheated by the film's tart , sugar-free wit . ","bennett's dramatization of her personal descent into post-breakup perdition has a morbid appeal that's tough to shake . ","an intriguing and entertaining introduction to johnson . ","as expected , sayles' smart wordplay and clever plot contrivances are as sharp as ever , though they may be overshadowed by some strong performances . ","a model of what films like this should be like . ","as weber and weissman demonstrate with such insight and celebratory verve , the cockettes weren't as much about gender , sexual preference or political agitprop as they were simply a triumph of the indomitable human will to rebel , connect and create . ","yeah , these flicks are just that damn good . isn't it great ? ","an unbelievably fun film just a leading man away from perfection . ","over-the-top and a bit ostentatious , this is a movie that's got oodles of style and substance . "," . . . a poignant and powerful narrative that reveals that reading writing and arithmetic are not the only subjects to learn in life . ","nicely serves as an examination of a society in transition . ","boisterous , heartfelt comedy . ","a tender and touching drama , based on the true story of a troubled african-american's quest to come to terms with his origins , reveals the yearning we all have in our hearts for acceptance within the family circle . ","as a randy film about sexy people in gorgeous places being pushed and pulled ( literally and figuratively ) by desire . . . [sex and lucía] makes for an arousing good time . ","absorbing character study by andré turpin . ","celebrated at sundance , this slight comedy of manners has winning performances and a glossy , glib charm that's hard to beat . ","renner's performance as dahmer is unforgettable , deeply absorbing . ","if no one singles out any of these performances as award-worthy , it's only because we would expect nothing less from this bunch . ","if you love reading and/or poetry , then by all means check it out . you'll probably love it . ","though of particular interest to students and enthusiast of international dance and world music , the film is designed to make viewers of all ages , cultural backgrounds and rhythmic ability want to get up and dance . ","energetic and boldly provocative . ","star wars is back in a major way . ","it's a movie -- and an album -- you won't want to miss . ","it's rare to find a film that dazzles the eye , challenges the brain , and satisfies our lust for fast-paced action , but minority report delivers all that and a whole lot more . ","while not all transitions to adulthood are so fraught , there's much truth and no small amount of poetry in girls can't swim . ","if there's nothing fresh about wannabes , which was written by mr . demeo , who produced and directed the film with charles a . addessi , much of the time the movie feels authentic . ","jacquot's tosca is a treat . ","by the end of no such thing the audience , like beatrice , has a watchful affection for the monster . ","if you liked such movies as notting hill , four weddings and a funeral , bridget jones' diary or high fidelity , then you won't want to miss about a boy . "," . . . the gentle melding of drama and comedy makes  what time is it there ?  something the true film buff will enjoy . ","romanek keeps the film constantly taut . . . reflecting the character's instability with a metaphorical visual style and an unnerving , heartbeat-like score . ","i whole-heartedly recommend that everyone see this movie-- for its historical significance alone . ","hey , who else needs a shower ? ","longley has constructed a remarkably coherent , horrifically vivid snapshot of those turbulent days . ","although it bangs a very cliched drum at times , this crowd-pleaser's fresh dialogue , energetic music , and good-natured spunk are often infectious . ","often gruelling and heartbreaking to witness , but seldahl and wollter's sterling performances raise this far above the level of the usual maudlin disease movie . ","go see it and enjoy . ","the stunning , dreamlike visuals will impress even those viewers who have little patience for euro-film pretension . ","george clooney proves he's quite a talented director and sam rockwell shows us he's a world-class actor with confessions of a dangerous mind . ","there's a vastness implied in metropolis that is just breathtaking . ","murderous maids may well be the most comprehensive of these films and also strike closest to the truth . ","the people in dogtown and z-boys are so funny , aggressive and alive , you have to watch them because you can't wait to see what they do next . ","as green-guts monster movies go , it's a beaut . ","as bundy , michael reilly burke ( octopus 2 : river of fear ) has just the right amount of charisma and menace . ","a deceivingly simple film , one that grows in power in retrospect . ","ana is a vivid , vibrant individual and the movie's focus upon her makes it successful and accessible . ","a slick , skillful little horror film . ","a very witty take on change , risk and romance , and the film uses humour to make its points about acceptance and growth . ","[anderson] uses a hit-or-miss aesthetic that hits often enough to keep the film entertaining even if none of it makes a lick of sense . ","bubba ho-tep is a wonderful film with a bravura lead performance by bruce campbell that doesn't deserve to leave the building until everyone is aware of it . ","despite the long running time , the pace never feels slack -- there's no scene that screams  bathroom break !  ","bullock does a good job here of working against her natural likability . ","a film of precious increments artfully camouflaged as everyday activities . ","kinnear gives a tremendous performance . ","the best movie of its kind since 'brazil . ' lucas , take notes . this is how you use special effects . ","  frailty  has been written so well , that even a simple  goddammit !  near the end takes on a whole other meaning . ","one hour photo is an intriguing snapshot of one man and his delusions ; it's just too bad it doesn't have more flashes of insight . ","kaufman creates an eerie sense of not only being there at the time of these events but the very night matthew was killed . ","chalk it up to my adoration for both de niro and murphy , but i had a pretty good time with this movie - despite its myriad flaws . ","its scenes and sensibility are all more than familiar , but it exudes a kind of nostalgic spy-movie charm and , at the same time , is so fresh and free of the usual thriller nonsense that it all seems to be happening for the first time . ","it represents better-than-average movie-making that doesn't demand a dumb , distracted audience . ","a charming yet poignant tale of the irrevocable ties that bind . ","an enchanting spectacular for potter fans anxious to ride the hogwarts express toward a new year of magic and mischief . ","the talents of the actors helps  moonlight mile  rise above its heart-on-its-sleeve writing . ","it's a humble effort , but spiced with wry humor and genuine pathos , especially between morgan and redgrave . ","this examination of aquatic life off the shores of the baja california peninsula of mexico offers an engrossing way to demonstrate the virtues of the imax format . ","dark and disturbing , but also surprisingly funny . ","the movie has an avalanche of eye-popping visual effects . ","starts off with a bang , but then fizzles like a wet stick of dynamite at the very end . it's still worth a look . ","most impressive , though , is the film's open-ended finale that refuses to entirely close its characters' emotional wounds . ","a hip ride into hyper-time , clockstoppers is a lively and enjoyable adventure for all ages at any time . ","grenier is terrific , bringing an unforced , rapid-fire delivery to toback's heidegger- and nietzsche-referencing dialogue . "," . . . a polished and relatively sincere piece of escapism . ","the story wraps back around on itself in the kind of elegant symmetry that's rare in film today , but be warned : it's a slow slog to get there . ","the whole cast looks to be having so much fun with the slapstick antics and silly street patois , tossing around obscure expressions like bellini and mullinski , that the compact 86 minutes breezes by . "," . . . has freaky scenes where the crew wonder if they're ghosts imagining themselves as alive . it's a sly wink to the others without becoming a postmodern joke , made creepy by its  men in a sardine can  warped logic . ","long after you leave justine , you'll be wondering what will happen to her and wishing her the best -- whatever that might mean . ","still pretentious and filled with subtext , but entertaining enough at 'face value' to recommend to anyone looking for something different . ","call me a wimp , but i cried , not once , but three times in this animated sweet film . ","notorious c . h . o . has oodles of vulgar highlights . ","an inspiring and heart-affecting film about the desperate attempts of vietnamese refugees living in u . s . relocation camps to keep their hopes alive in 1975 . ","the level of maturity displayed by this 33-year-old first-time feature director is astonishing , considering her inexperience and her subject matter . ","a splendid entertainment , young in spirit but accomplished in all aspects with the fullness of spirit and sense of ease that comes only with experience . ","disney's live-action division has a history of releasing cinematic flotsam , but this is one occasion when they have unearthed a rare gem . ","if the message seems more facile than the earlier films , the images have such a terrible beauty you may not care . ","whether kiss is a future cult classic or destined to be completely forgotten is open to question , but the risk-takers in the crowd should check it out and form their own opinion . ","there are moments in this account of the life of artist frida kahlo that are among cinema's finest this year . unfortunately , they're sandwiched in between the most impossibly dry account of kahlo's life imaginable . ","there are moments it can be heart-rending in an honest and unaffected ( and gentle ) way . ","stay clear of reminding yourself that it's a  true story  and you're likely to have one helluva time at the movies . ","there are just enough twists in the tale to make it far more satisfying than almost any horror film in recent memory . ","the sundance film festival has become so buzz-obsessed that fans and producers descend upon utah each january to ferret out the next great thing . 'tadpole' was one of the films so declared this year , but it's really more of the next pretty good thing . ","working from elliott's memoir , rohmer fashions the sort of delicate , articulate character- and- relationship study he's favored for decades . ","the story feels more like a serious read , filled with heavy doses of always enticing sayles dialogue . ","when it really counts . . . bloody sunday connects on a visceral level that transcends language . ","the crime matters less than the characters , although the filmmakers supply enough complications , close calls and double-crosses to satisfy us . ","[an] hilarious romantic comedy . ","the actors are fantastic . they are what makes it worth the trip to the theatre . ","ranging from funny to shattering and featuring some of the year's best acting , personal velocity gathers plenty of dramatic momentum . ","i complain all the time about seeing the same ideas repeated in films over and over again , but the bourne identity proves that a fresh take is always possible . ","recalls quiet freak-outs like l'avventura and repulsion . ","only an epic documentary could get it all down , and spike lee's jim brown : all american at long last gives its subject a movie worthy of his talents . "," . . . as the story congeals you feel the pieces of the star wars saga falling into place in a way that makes your spine tingle with revelation and excitement . ","a great comedy filmmaker knows great comedy needn't always make us laugh . tim story's not there yet - but 'barbershop' shows he's on his way . ","the movie is one of the best examples of artful large format filmmaking you are likely to see anytime soon . ","lends itself to the narcotizing bland ( sinister , though not nearly so sinister as the biennial disney girl movie ) machinations of the biennial disney boy movie . ","well-written , nicely acted and beautifully shot and scored , the film works on several levels , openly questioning social mores while ensnaring the audience with its emotional pull . ","jason x has cheesy effects and a hoary plot , but its macabre , self-deprecating sense of humor makes up for a lot . ","[taymor] utilizes the idea of making kahlo's art a living , breathing part of the movie , often catapulting the artist into her own work . this isn't a new idea . it's been done before but never so vividly or with so much passion . ","an impressive if flawed effort that indicates real talent . ","two generations within one family test boundaries in this intelligent and restrained coming-of-age drama . ","it sounds sick and twisted , but the miracle of shainberg's film is that it truly is romance","disturbing and brilliant documentary . "," . . . mesmerizing , an eye-opening tour of modern beijing culture in a journey of rebellion , retreat into oblivion and return . ","one of the best examples of how to treat a subject , you're not fully aware is being examined , much like a photo of yourself you didn't know was being taken . ","not too far below the gloss you can still feel director denis villeneuve's beating heart and the fondness he has for his characters . ","as if to prove a female director can make a movie with no soft edges , kathryn bigelow offers no sugar-coating or interludes of lightness . her film is unrelentingly claustrophobic and unpleasant . ","[villeneuve] seems to realize intuitively that even morality is reduced to an option by the ultimate mysteries of life and death . ","the result is mesmerizing -- filled with menace and squalor . ","fisher has bared his soul and confronted his own shortcomings here in a way . . . that feels very human and very true to life . ","it's fun , but the code-talk will fly right over everyone's head","bourne , jason bourne . he can scale a building like a super hero , he can out-stealth any agent , he'll get the girl . he's super spy ! ","what makes the movie a comedy is the way it avoids the more serious emotions involved . ","an exhilarating experience . ","this cuddly sequel to the 1999 hit is a little more visually polished , a little funnier , and a little more madcap . ","the pleasures of super troopers may be fleeting , but they'll register strongly with anybody who still retains a soft spot for precollegiate humor . ","the film is exhilarating to watch because sandler , liberated from the constraints of formula , reveals unexpected depths as an actor . ","a distant , even sterile , yet compulsively watchable look at the sordid life of hogan's heroes star bob crane . ","the film delivers not just the full assault of reno's immense wit and insight , but a time travel back to what it felt like during those unforgettably uncertain days . ","what might have been a predictably heartwarming tale is suffused with complexity . ","sound the trumpets : for the first time since desperately seeking susan , madonna doesn't suck as an actress . ","although very much like the first movie based on j . k . rowling's phenomenal fantasy best sellers , this second go-round possesses a quite pleasing , headlong thrust and a likably delinquent attitude . ","[  take care of my cat  ] is an honestly nice little film that takes us on an examination of young adult life in urban south korea through the hearts and minds of the five principals . ","as the story moves inexorably through its seven day timeframe , the picture becomes increasingly mesmerizing . ","maguire is a surprisingly effective peter/spider-man . ","not a cozy or ingratiating work , but it's challenging , sometimes clever , and always interesting , and those are reasons enough to see it . ","the film runs on equal parts of innocence and wisdom -- wisdom that comes with experience . it has fun being grown up . ","like old myths and wonder tales spun afresh . ","rarely do films come along that are as intelligent , exuberant , and moving as monsoon wedding . ","one scarcely needs the subtitles to enjoy this colorful action farce . ","quite funny for the type of movie it is . . . ","it's often infuriatingly glib and posturing , and yet it has been made with great evident care and manages to deliver up the man in a way to arouse further curiosity in even the most unknowing viewer . ","one of [herzog's] least inspired works . ","this boisterous comedy serves up a cruel reminder of the fate of hundreds of thousands of chinese , one which can only qualify as a terrible tragedy . ","elling really is about a couple of crazy guys , and it's therapeutic to laugh along with them . ","never [sinks] into exploitation . ","an irresistible combination of a rousing good story set on a truly grand scale . ","there's no denying the physically spectacular qualities of the film . . . or the emotional integrity of the performances . ","few films this year have been as resolute in their emotional nakedness . ","exquisitely acted and masterfully if preciously interwoven… [the film] addresses in a fascinating , intelligent manner the intermingling of race , politics and local commerce . ","stevenson's performance is at once clueless and fiercely committed , a volatile combination . ","this is a very fine movie -- go see it . ","as shaky as the plot is , kaufman's script is still memorable for some great one-liners . ","despite its flaws , secretary stays in your head and makes you question your own firmly held positions . ","one of those rare , exhilarating cinematic delights that gets even better in hindsight , as you mull over its every nuance in your mind . ","not everything works , but the average is higher than in mary and most other recent comedies . ","a byzantine melodrama that stimulates the higher brain functions as well as the libido . ","a sensitive and expertly acted crowd-pleaser that isn't above a little broad comedy and a few unabashedly sentimental tears . ","the film's sharp , often mischievous sense of humor will catch some off guard . . . ","does what a fine documentary does best : it extends a warm invitation into an unfamiliar world , then illuminates it fully and allows the larger implications of the journey to sink in unobtrusively . ","almost every scene in this film is a gem that could stand alone , a perfectly realized observation of mood , behavior and intent . ","a psychologically rich and suspenseful moral thriller with a stellar performance by al pacino . ","you won't believe much of it , but you will laugh at the audacity , at the who's who casting and the sheer insanity of it all . ","this version's no classic like its predecessor , but its pleasures are still plentiful . ","the bourne identity is what summer screen escapism used to be in the decades when it was geared more to grownups . ","provide[s] nail-biting suspense and credible characters without relying on technology-of-the-moment technique or pretentious dialogue . ","if it tried to do anything more , it would fail and perhaps explode , but at this level of manic whimsy , it is just about right . ","too sincere to exploit its subjects and too honest to manipulate its audience . ","the saturation bombing of reggio's images and glass' evocative music . . . ultimately leaves viewers with the task of divining meaning . ","for all its serious sense of purpose . . . [it] finds a way to lay bare the tragedies of its setting with a good deal of warmth and humor . ","a depressing confirmation of everything those of us who don't object to the description  unelected  have suspected all along : george w . bush is an incurious , uncharismatic , overgrown frat boy with a mean streak a mile wide . ","this road movie gives you emotional whiplash , and you'll be glad you went along for the ride . ","sure , it's more of the same , but as the film proves , that's not always a bad thing . ","a lighthearted , feel-good film that embraces the time-honored truth that the most powerful thing in life is love . ","a bowel-curdling , heart-stopping recipe for terror . ","daughter from danang is a film that should be seen by all , especially those who aren't aware of , or have forgotten about the unmentioned victims of war . ","zhang yimou delivers warm , genuine characters who lie not through dishonesty , but because they genuinely believe it's the only way to bring happiness to their loved ones . "," . . . breathes surprising new life into the familiar by amalgamating genres and adding true human complexity to its not-so-stock characters . ","' . . . both hokey and super-cool , and definitely not in a hurry , so sit back , relax and have a few laughs while the little ones get a fuzzy treat . '","a pleasant romantic comedy . ","it's a count for our times . ","greengrass has delivered an undoubted stylistic tour-de-force , and has managed elements such as sound and cinematography with skill","smith's point is simple and obvious -- people's homes are extensions of themselves , and particularly eccentric people have particularly eccentric living spaces -- but his subjects are charmers . ","a romantic comedy , yes , but one with characters who think and talk about their goals , and are working on hard decisions . ","vividly conveys both the pitfalls and the pleasures of over-the-top love . "," . . . a weak , manipulative , pencil-thin story that is miraculously able to entertain anyway . ","a pro-fat farce that overcomes much of its excessive moral baggage thanks to two appealing lead performances . ","for the first two-thirds of this sparklingly inventive and artful , always fast and furious tale , kids will go happily along for the ride . ","majidi's poetic love story is a ravishing consciousness-raiser , if a bit draggy at times . ","the smartest bonehead comedy of the summer . ","effectively feeds our senses with the chilling sights and sounds from within the camp to create a completely numbing experience . ","i love the way that it took chances and really asks you to take these great leaps of faith and pays off . ","in his debut as a film director , denzel washington delivers a lean and engaging work . ","only two words will tell you what you know when deciding to see it : anthony . hopkins . ","the movie's quiet affirmation of neighborhood values gives it an honest , lived-in glow . ","a teasing drama whose relentless good-deed/bad-deed reversals are just interesting enough to make a sinner like me pray for an even more interesting , less symmetrical , less obviously cross-shaped creation . ","hayek is stunning as frida and . . . a star-making project . ","it's both a necessary political work and a fascinating documentary . . . ","hilarious , acidic brit comedy . ","as a revenge thriller , the movie is serviceable , but it doesn't really deliver the delicious guilty pleasure of the better film versions . ","an ironic speculation on democracy in a culture unaccustomed to it . ","it's not life-affirming — its vulgar and mean , but i liked it . ","several degrees shy of the gross-out contests one expects from current teen fare . ","the inherent strength of the material as well as the integrity of the filmmakers gives this coming-of-age story restraint as well as warmth . ","led by griffin's smartly nuanced performance and enthusiasm , the cast has a lot of fun with the material . ","tuck everlasting achieves a delicate balance of romantic innocence and philosophical depth . ","a gentle blend of present day testimonials , surviving footage of burstein and his family performing , historical archives , and telling stills . ","a generation x artifact , capturing a brief era of insanity in the sports arena that surely cannot last . ","possession is elizabeth barrett browning meets nancy drew , and it's directed by . . . neil labute . hmm . ","an uneven but intriguing drama that is part homage and part remake of the italian masterpiece . ","windtalkers celebrates the human spirit and packs an emotional wallop . ","having never been a huge fan of dickens' 800-page novel , it surprised me how much pleasure i had watching mcgrath's version . ","the best thing the film does is to show us not only what that mind looks like , but how the creative process itself operates . ","for all its failed connections , divine secrets of the ya-ya sisterhood is nurturing , in a gauzy , dithering way . ","this is pretty dicey material . but some unexpected zigs and zags help . ","compellingly watchable . ","the filmmakers skillfully evoke the sense of menace that nature holds for many urban dwellers . ","the laser-projected paintings provide a spell-casting beauty , while russell and dreyfus are a romantic pairing of hearts , preciously exposed as history corners them . ","you don't have to be an especially tough grader to give a charitable b-minus to the emperor's club . ","this romantic thriller is steeped in the atmosphere of wartime england , and ably captures the speech patterns , moral codes and ideals of the 1940s . ","divine secrets of the ya-ya sisterhood may not be exactly divine , but it's definitely -- defiantly -- ya ya , what with all of those terrific songs and spirited performances . ","viewed on its own terms , treasure planet is better-than-average family entertainment , but true fans of the stevenson's novel will likely prefer disney's more faithful 1950 live-action swashbuckling classic . ","a journey through memory , a celebration of living , and a sobering rumination on fatality , classism , and ignorance . ","resourceful and ingenious entertainment . ","  antwone fisher  is an earnest , by-the-numbers effort by washington . it won't rock any boats but is solid meat-and-potatoes filmmaking . ","a historical epic with the courage of its convictions about both scope and detail . ","we need [moore's] noisy , cocky energy , his passion and class consciousness ; we need his shticks , we need his stones . ","although the editing might have been tighter , hush ! sympathetically captures the often futile lifestyle of young people in modern japan . ","[gai] comes closer to any actress i can remember to personifying independence in its purest and , yes , most intimidating form . ","these are lives worth watching , paths worth following . ","it's rather like a lifetime special -- pleasant , sweet and forgettable . ","a moody horror/thriller elevated by deft staging and the director's well-known narrative gamesmanship . ","as a singular character study , it's perfect . it's also the year's sweetest movie . ","a graceful , contemplative film that gradually and artfully draws us into a world where the personal and the political get fatally intertwined . ","while not as aggressively impressive as its american counterpart ,  in the bedroom ,  moretti's film makes its own , quieter observations","the experience of watching blobby old-school cgi animation in this superlarge format is just surreal enough to be diverting . ","time changer may not be the most memorable cinema session but its profound self-evaluation message about our fragile existence and the absence of spiritual guidance should at least invade an abundance of mindsets","  the emperor's new clothes  begins with a simple plan . . . . well , at least that's the plan . ","haynes has so fanatically fetishized every bizarre old-movie idiosyncrasy with such monastic devotion you're not sure if you should applaud or look into having him committed . ","[director peter] jackson and his crew have so steeped themselves in the majesty of tolkien's writing that every frame produces new joys , whether you're a fan of the books or not . ","while the glass slipper doesn't quite fit , pumpkin is definitely a unique modern fairytale . ","the drama is played out with such aching beauty and truth that it brings tears to your eyes . ","an exciting and involving rock music doc , a smart and satisfying look inside that tumultuous world . ","an offbeat , sometimes gross and surprisingly appealing animated film about the true meaning of the holidays . ","this version incarnates the prophetic book in a way even its exacting author might admire . ","sometimes , nothing satisfies like old-fashioned swashbuckling . and in this regard , on guard delivers . "," . . . ambition is in short supply in the cinema , and egoyan tackles his themes and explores his characters' crises with seriousness and compassion . ","an impossible romance , but we root for the patronized iranian lad . ","like dickens with his passages , mcgrath crafts quite moving scenes throughout his resolutely dramatic variation on the novel . ","there's a disreputable air about the whole thing , and that's what makes it irresistible . ","an exceedingly clever piece of cinema . another great ‘what you don't see' is much more terrifying than what you do see thriller , coupled with some arresting effects , incandescent tones and stupendous performances","a carefully structured scream of consciousness that is tortured and unsettling--but unquestionably alive . ","a quietly reflective and melancholy new zealand film about an eventful summer in a 13-year-old girl's life . ","cute , funny , heartwarming digitally animated feature film with plenty of slapstick humor for the kids , lots of in-jokes for the adults and heart enough for everyone . ","very solid , very watchable first feature for director peter sheridan","a budget affair that exposes the generally sad existence of the bedouins while providing a precious twinkle of insight into their lives . ","it suggests the wide-ranging effects of media manipulation , from the kind of reporting that is done by the supposedly liberal media . . . to the intimate and ultimately tragic heartache of maverick individuals like hatfield and hicks . ","workmanlike , maybe , but still a film with all the elements that made the other three great , scary times at the movies . ","a pleasant enough comedy that should have found a summer place . ","branagh , in his most forceful non-shakespeare screen performance , grounds even the softest moments in the angry revolt of his wit . ","though the violence is far less sadistic than usual , the film is typical miike : fast , furious and full of off-the-cuff imaginative flourishes . ","compelling as it is exotic , fast runner has a plot that rivals shakespeare for intrigue , treachery and murder . ","what it lacks in originality it makes up for in intelligence and b-grade stylishness . ","the warm presence of zhao benshan makes the preposterous lying hero into something more than he reasonably should be . ","this is as powerful a set of evidence as you'll ever find of why art matters , and how it can resonate far beyond museum walls and through to the most painfully marginal lives . ","director rob marshall went out gunning to make a great one . ","skip work to see it at the first opportunity . ","bow's best moments are when he's getting busy on the basketball court because that's when he really scores . ","offers enough playful fun to entertain the preschool set while embracing a wholesome attitude . ","in the end , punch-drunk love is one of those films that i wanted to like much more than i actually did . sometimes , that's enough . ","an intimate , good-humored ethnic comedy like numerous others but cuts deeper than expected . ","ice cube holds the film together with an engaging and warm performance . . . ","both deeply weird and charmingly dear . ","as blunt as it is in depicting child abuse , el bola is a movie steeped in an ambiguity that lends its conflicts a symbolic resonance . ","despite a story predictable enough to make the sound of music play like a nail-biting thriller , its heart is so much in the right place it is difficult to get really peeved at it . ","it's a masterpiece . ","an incredibly low-rent danish film , it brings a group of people together in a sweet and charming way , if a little convenient","it's the cinematic equivalent of a good page-turner , and even if it's nonsense , its claws dig surprisingly deep . ","director nalin pan doesn't do much to weigh any arguments one way or the other . he simply presents his point of view that ayurveda works . no question . ","what  empire  lacks in depth it makes up for with its heart . ","claude miller airs out a tight plot with an easy pace and a focus on character drama over crime-film complications . ","what full frontal lacks in thematic coherence it largely makes up for as loosey-goosey , experimental entertainment . still , i'm not quite sure what the point is…","rich in detail , gorgeously shot and beautifully acted , les destinees is , in its quiet , epic way , daring , inventive and refreshingly unusual . "," ( a ) hollywood sheen bedevils the film from the very beginning . . . ( but ) lohman's moist , deeply emotional eyes shine through this bogus veneer . . . ","do we really need a 77-minute film to tell us exactly why a romantic relationship between a 15-year-old boy and a 40-year-old woman doesn't work ? ","ford deserves to be remembered at oscar time for crafting this wonderful portrait of a conflicted soldier . ","the film's 45-minute running time stops shy of overkill , though viewers may be more exhausted than the athletes onscreen . ","don't expect any surprises in this checklist of teamwork cliches . . . ","as adapted by kevin molony from simon leys' novel  the death of napoleon  and directed by alan taylor , napoleon's journey is interesting but his parisian rebirth is stillborn","the movie addresses a hungry need for pg-rated , nonthreatening family movies , but it doesn't go too much further . ","this warm and gentle romantic comedy has enough interesting characters to fill several movies , and its ample charms should win over the most hard-hearted cynics . ","a yarn that respects the marvel version without becoming ensnared by it . ","this is a happy throwback to the time when cartoons were cinema's most idiosyncratic form instead of one of its most predictable . ","complex , affecting and uniquely almodóvar , the film evokes strong emotions and pushes viewers to question their deepest notions of moral right and wrong . ","good ol' urban legend stuff . ","not so much a movie as a picture book for the big screen . this isn't my favorite in the series , still i enjoyed it enough to recommend . ","it's one of the most honest films ever made about hollywood . ","it is a film that will have people walking out halfway through , will encourage others to stand up and applaud , and will , undoubtedly , leave both camps engaged in a ferocious debate for years to come . ","on its own cinematic terms , it successfully showcases the passions of both the director and novelist byatt . ","light , silly , photographed with colour and depth , and rather a good time . ","pray's film works well and will appeal even to those who aren't too familiar with turntablism . ","troubling and powerful . ","good movie . good actress . but if you expect light romantic comedy , good gosh , will you be shocked . ","it has the courage to wonder about big questions with sincerity and devotion . it risks seeming slow and pretentious , because it thinks the gamble is worth the promise . ","with youthful high spirits , tautou remains captivating throughout michele's religious and romantic quests , and she is backed by a likable cast . ","it's an example of sophisticated , challenging filmmaking that stands , despite its noticeable lack of emotional heft , in welcome contrast to the indulgent dead-end experimentation of the director's previous full frontal . ","a very funny look at how another culture handles the process of courting and marriage . ","but tongue-in-cheek preposterousness has always been part of for the most part wilde's droll whimsy helps  being earnest  overcome its weaknesses and parker's creative interference . . . ","much of the movie's charm lies in the utter cuteness of stuart and margolo . their computer-animated faces are very expressive . ","the path ice age follows most closely , though , is the one established by warner bros . giant chuck jones , who died a matter of weeks before the movie's release . ","anchored by a terrific performance by abbass , satin rouge shows that the idea of women's self-actualization knows few continental divides . ","awkward but sincere and , ultimately , it wins you over . ","smith profiles five extraordinary american homes , and because the owners seem fully aware of the uses and abuses of fame , it's a pleasure to enjoy their eccentricities . ","though the plot is predictable , the movie never feels formulaic , because the attention is on the nuances of the emotional development of the delicate characters . ","sam jones became a very lucky filmmaker the day wilco got dropped from their record label , proving that one man's ruin may be another's fortune . ","goyer's screenplay and direction are thankfully understated , and he has drawn excellent performances from his cast . ","binoche and magimel are perfect in these roles . ","when your leading ladies are a couple of screen-eating dominatrixes like goldie hawn and susan sarandon at their raunchy best , even hokum goes down easily . ","while undercover brother is definitely one for the masses , it's also full of sharp , smart satire . ","gets under the skin of a man who has just lost his wife . ","it may not be  last tango in paris  but . . . ","no wonder they're talking about  talk to her .  it's astonishing . ","for its seriousness , high literary aspirations and stunning acting , the film can only be applauded . ","look , this is a terrific flick replete with dazzling camera-work , dancing and music . ","it is inspirational in characterizing how people from such diverse cultures share the same human and spiritual needs . ","it's fairly self-aware in its dumbness . ","a triumph , relentless and beautiful in its downbeat darkness . ","tailored to entertain ! ","a compelling , moving film that respects its audience and its source material . ","has a plot full of twists upon knots . . . and a nonstop parade of mock-tarantino scuzbag types that starts out clever but veers into overkill . ","a work of astonishing delicacy and force . ","the film benefits greatly from a less manic tone than its predecessor , as cho appears to have settled comfortably into her skin . ","for the first time in several years , mr . allen has surpassed himself with the magic he's spun with the hollywood empress of ms . leoni's ellie . ","isn't quite the equal of woo's best earlier work , but it's easily his finest american film . . . comes close to recapturing the brilliance of his hong kong films . ","the film hinges on its performances , and both leads are up to the task . ","an intelligent , earnest , intimate film that drops the ball only when it pauses for blunt exposition to make sure you're getting its metaphysical point . ","a modest pleasure that accomplishes its goals with ease and confidence . ","a breezy , diverting , conventional , well-acted tale of two men locked in an ongoing game of cat-and-cat . ","what jackson has accomplished here is amazing on a technical level . ","as teen movies go ,  orange county  is a refreshing change","makes s&m seem very romantic , and maggie gyllenhaal is a delight . ","a deliciously mordant , bitter black comedy . ","although life or something like it is very much in the mold of feel-good movies , the cast and director stephen herek's polished direction pour delightfully piquant wine from aged bottles . ","it is risky , intelligent , romantic and rapturous from start to finish . ","the movie sticks much closer to hornby's drop-dead confessional tone than the film version of high fidelity did . ","a pleasant ramble through the sort of idoosyncratic terrain that errol morris has often dealt with . . . it does possess a loose , lackadaisical charm . "," . . . spiced with humor ( 'i speak fluent flatula , ' advises denlopp after a rather , er , bubbly exchange with an alien deckhand ) and witty updatings ( silver's parrot has been replaced with morph , a cute alien creature who mimics everyone and everything around ) ","this is a raw and disturbing tale that took five years to make , and the trio's absorbing narrative is a heart-wrenching showcase indeed . ","a beautiful and haunting examination of the stories we tell ourselves to make sense of the mundane horrors of the world . ","aside from being the funniest movie of the year , simone , andrew niccol's brilliant anti-hollywood satire , has a wickedly eccentric enchantment to it . ","watstein handily directs and edits around his screenplay's sappier elements . . . and sustains off the hook's buildup with remarkable assuredness for a first-timer . ","just another fish-out-of-water story that barely stays afloat . ","there's an energy to y tu mamá también . much of it comes from the brave , uninhibited performances by its lead actors . ","it's the kind of pigeonhole-resisting romp that hollywood too rarely provides . ","reinforces the often forgotten fact of the world's remarkably varying human population and mindset , and its capacity to heal using creative , natural and ancient antidotes . ","you can feel the heat that ignites this gripping tale , and the humor and humanity that root it in feeling . ","it's hard not to be seduced by [witherspoon's] charisma , even in this run-of-the-mill vehicle , because this girl knows how to drive it to the max . ","a movie for 11-year-old boys with sports dreams of their own and the preteen girls who worship lil' bow wow . ","a refreshingly authentic coming-of-age tale . ","if you're not into the pokemon franchise , this fourth animated movie in four years won't convert you -- or even keep your eyes open . but fans should have fun meeting a brand-new pokemon called celebi . ","from the big giant titles of the opening credits to elmer bernstein's perfectly melodic score , haynes gets just about everything right . ","whether seen on a 10-inch television screen or at your local multiplex , the edge-of-your-seat , educational antics of steve irwin are priceless entertainment . ","has a shambling charm . . . a cheerfully inconsequential diversion . ","ferrara directs the entire film with the kind of detachment that makes any given frame look like a family's custom-made christmas card . ","the movie has lots of dancing and fabulous music . there are slow and repetitive parts , but it has just enough spice to keep it interesting . ","an incredibly clever and superbly paced caper filled with scams within scams within scams . ","there's not much more to this adaptation of the nick hornby novel than charm -- effortless , pleasurable , featherweight charm . ","as a belated nod to some neglected all-stars , standing in the shadows of motown is cultural history of the best kind : informative , revealing and richly entertaining . ","even if the ride's a little bumpy , with a final lap that's all too suspiciously smooth , you gotta give director roger michell , best known for the superfluous notting hill , credit for trying . ","not as distinctive or even as humorous as its needs to be to stand out , but it has clearly been made with affection and care . ","this is carion's debut feature but his script and direction hums with a confidence that many spend entire careers trying to reach . ","an intelligent , moving and invigorating film . ","ofrece una buena oportunidad de cultura ( aunque sea condensada ) que bien vale la pena aprovechar . "," . . . one of the most ingenious and entertaining thrillers i've seen in quite a long time . ","a clever blend of fact and fiction . ","a vivid cinematic portrait . ","hilarious , touching and wonderfully dyspeptic . ","es divertida , visualmente espectacular y muy entretenida . simple y sencillamente te sorprenderá . ","theirs is a simple and heart-warming story , full of mirth that should charm all but the most cynical . ","the film is an enjoyable family film -- pretty much aimed at any youngster who loves horses . ","a frisky and fresh romantic comedy exporing sexual politics and the challenges of friendships between women . ","it's a good film -- not a classic , but odd , entertaining and authentic . ","flavorful and romantic , you could call this how martha got her groove back -- assuming , that is , she ever had one to begin with . ","happily for mr . chin -- though unhappily for his subjects -- the invisible hand of the marketplace wrote a script that no human screenwriter could have hoped to match . ","thurman and lewis are hilarious throughout . ","the plot is so amusingly contrived and outlandish in its coincidences that no one could ever mistake it for anything resembling reality","hits one out of the park for the 'they don't make 'em like that anymore' department . ","it dares to be a little different , and that shading is what makes it worthwhile . ","[fessenden] is much more into ambiguity and creating mood than he is for on screen thrills","the comic performances are all spot on , especially lee ross's turn as ken . ","a compelling journey . . . and  his best friend remembers  is up there with the finest of specials . ","at nearly three hours , the whole of safe conduct is less than the sum of its parts . ","the hours makes you examine your own life in much the same way its characters do , and the experience is profound . the hours is what movies are supposed to be . . . ","a bold and subversive film that cuts across the grain of what is popular and powerful in this high-tech age , speaking its truths with spellbinding imagery and the entrancing music of philip glass . ","pretty darn good , despite its smarty-pants aura . ","so young , so smart , such talent , such a wise * * * . ","woo's fights have a distinct flair . his warriors collide in balletic explosion that implies an underlying order throughout the chaos . ","barney has created a tour de force that is weird , wacky and wonderful . ","the ending does leave you unfulfilled , but these are performances to enjoy in a memorable ensemble piece . "," . . . an agreeable time-wasting device -- but george pal's low-tech 1960 version still rules the epochs . ","it's a brave attempt to tap into the heartbeat of the world , a salute to the universal language of rhythm and a zippy sampling of sounds . ","offers an unusual opportunity to observe the inequities in the death penalty , not just the inherent immorality but also the haphazard administration of it and public misperception of how the whole thing works . ","i don't think i've been as entranced and appalled by an asian film since shinya tsukamoto's iron man . ","it is so refreshing to see robin williams turn 180 degrees from the string of insultingly innocuous and sappy fiascoes he's been making for the last several years . ","director benoit jacquot , making his first opera-to-film translation with tosca , conveys the heaving passion of puccini's famous love-jealousy- murder-suicide fandango with great cinematic innovation . ","lilia's transformation from strict mother to sensual siren is superficially preposterous , but abbas infuses the role with an unimpeachable core of emotional truth . ","frida's artistic brilliance is undeniable -- it's among the most breathtakingly designed films i've ever seen . ","the perfect film for those who like sick comedies that can be snide . ","'charly' will divide its audience in two separate groups , those reaching for more tissues and those begging for mercy . . . ","nervy and sensitive , it taps into genuine artistic befuddlement , and at the same time presents a scathing indictment of what drives hollywood . ","a marvellous journey from childhood idealism to adolescent self-absorption . ","the film is just a big , gorgeous , mind-blowing , breath-taking mess . ","sharp , lively , funny and ultimately sobering film . ","though the film's scenario is certainly not earthshaking , this depiction of fluctuating female sexuality has two winning lead performances and charm to spare . ","a worthy tribute to a great humanitarian and her vibrant 'co-stars . '","a recent favourite at sundance , this white-trash satire will inspire the affection of even those unlucky people who never owned a cassette of def leppard's pyromania . ","the recording session is the only part of the film that is enlightening -- and how appreciative you are of this depends on your level of fandom . ","occasionally funny and consistently odd , and it works reasonably well as a star vehicle for zhao . ","bright seems alternately amused and disgusted with this material , and he can't help throwing in a few of his own touches . ","the 3d images only enhance the film's otherworldly quality , giving it a strange combo of you-are-there closeness with the disorienting unreality of the seemingly broken-down fourth wall of the movie screen . ","andersson creates a world that's at once surreal and disturbingly familiar ; absurd , yet tremendously sad . ","it's predictable , but it jumps through the expected hoops with style and even some depth . ","often hilarious , well-shot and , importantly , entertaining , hell house is a fascinating document of an event that has to be seen to be believed . ","de oliveira creates an emotionally rich , poetically plump and visually fulsome , but never showy , film whose bittersweet themes are reinforced and brilliantly personified by michel piccoli . "," . . . an inviting piece of film . ","the film's real appeal won't be to clooney fans or adventure buffs , but to moviegoers who enjoy thinking about compelling questions with no easy answers . ","the fact that the rookie is a nearly impeccable cinematic experience -- and a wonderful all-ages triumph besides -- is a miracle akin to the story the film portrays . ","a deviant topical comedy which is funny from start to finish . ","a startling and fresh examination of how the bike still remains an ambiguous icon in chinese society . ","a highly intriguing thriller , coupled with some ingenious plot devices and some lavishly built settings . . it's a worthwhile tutorial in quantum physics and slash-dash","as hugh grant says repeatedly throughout the movie , 'lovely ! brilliant ! '","cho's fearless in picking apart human foibles , not afraid to lay her life bare in front of an audience . her delivery and timing are flawless . ","works because , for the most part , it avoids the stupid cliches and formulaic potholes that befall its brethren . ","at its best , the good girl is a refreshingly adult take on adultery . . . ","an amazing and incendiary movie that dives straight into the rough waters of contradiction . ","about nowhere kids who appropriated turfs as they found them and become self-made celebrity athletes -- a low-down version of the american dream . ","occasionally , in the course of reviewing art-house obscurities and slam-bam action flicks , a jaded critic smacks into something truly new . ","a miniscule little bleep on the film radar , but one that many more people should check out","desta vez , columbus capturou o pomo de ouro . ","  13 conversations  holds its goodwill close , but is relatively slow to come to the point . ","a slick , well-oiled machine , exquisitely polished and upholstered . ","don't plan on the perfect ending , but sweet home alabama hits the mark with critics who escaped from a small town life . ","it has a subtle way of getting under your skin and sticking with you long after it's over . ","the movie stays afloat thanks to its hallucinatory production design . ","it helps that the central performers are experienced actors , and that they know their roles so well . ","a provocative movie about loss , anger , greed , jealousy , sickness and love . ","worth the effort to watch . ","that rara avis : the intelligent romantic comedy with actual ideas on its mind . ","boisterous and daft documentary . ","hawke draws out the best from his large cast in beautifully articulated portrayals that are subtle and so expressive they can sustain the poetic flights in burdette's dialogue . ","a work of the utmost subtlety and perception , it marks the outstanding feature debut of writer-director eric byler , who understands the power of the implicit and the virtues of simplicity and economy . ","full frontal is the antidote for soderbergh fans who think he's gone too commercial since his two oscar nominated films in 2000","it turns out to be a cut above the norm , thanks to some clever writing and sprightly acting . ","you might not want to hang out with samantha , but you'll probably see a bit of yourself in her unfinished story . ","a work of intricate elegance , literary lyricism and profound common sense . ","it's as close as we'll ever come to looking through a photographer's viewfinder as he works . ","thoughtful , provocative and entertaining . ","witty , touching and well paced . ","lee jeong-hyang tells it so lovingly and films it so beautifully that i couldn't help being captivated by it . ","you have to pay attention to follow all the stories , but they're each interesting . the movie is well shot and very tragic , and one to ponder after the credits roll . ","enjoy it for what it is ; you can hate yourself later . ","a map of the inner rhythms of love and jealousy and sacrifice drawn with a master's steady stroke . ","más sarcástica , divertida y demencial que su predecesora , es un buen ejemplo de lo que es el cine de entretenimiento puro y sin complejos . ","a psychological thriller with a smart script and an obsessive-compulsive's attention to detail . ","often hilarious . ","grant gets to display his cadness to perfection , but also to show acting range that may surprise some who thought light-hearted comedy was his forte . ","at times funny and at other times candidly revealing , it's an intriguing look at two performers who put themselves out there because they love what they do . ","westfeldt and juergensen exude a chemistry and comfort level that's both saucy and endearing . ","harsh , effective documentary on life in the israeli-occupied palestinian territories . ","the film is all a little lit crit 101 , but it's extremely well played and often very funny . ","earns its laughs from stock redneck 'types' and from the many , many moments when we recognize even without the elizabethan prose , the play behind the thing . ","a real story about real people living their lives concerned about the future of an elderly , mentally handicapped family member . ","it's absolutely spooky how lillard channels the shagster right down to the original casey kasem-furnished voice . ","a dream cast of solid female talent who build a seamless ensemble . there isn't a weak or careless performance amongst them . ","smart science fiction for grown-ups , with only a few false steps along the way . ","it's a refreshing change from the self-interest and paranoia that shape most american representations of castro . ","often moving and explores the discomfort inherent in the contacts between the american 'hosts' and their 'guests . '","though the controversial korean filmmaker's latest effort is not for all tastes , it offers gorgeous imagery , effective performances , and an increasingly unsettling sense of foreboding . ","lathan and diggs have considerable personal charm , and their screen rapport makes the old story seem new . ","the story may not be new , but australian director john polson , making his american feature debut , jazzes it up adroitly . ","it's endearing to hear madame d . refer to her husband as 'jackie' -- and he does make for excellent company , not least as a self-conscious performer . ","the film often achieves a mesmerizing poetry . ","more than makes up for its mawkish posing by offering rousing spates of genuine feeling . ","it's neither as romantic nor as thrilling as it should be . but it offers plenty to ponder and chew on as its unusual relationship slowly unfolds . ","occasionally funny , always very colorful and enjoyably overblown in the traditional almodóvar style . ","merchant effectively translates naipaul's lively mix of characters from the page to screen . ","some movies are like a tasty hors-d'oeuvre ; this one is a feast . ","what could have become just another cautionary fable is allowed to play out as a clever , charming tale – as pleasantly in its own way as its self-dramatizing characters . ","davis has filled out his cast with appealing fresh faces . ","achieves a sort of filmic epiphany that revels in the true potential of the medium . ","once you get into its rhythm . . . the movie becomes a heady experience . ","  auto focus  works as an unusual biopic and document of male swingers in the playboy era","if mr . zhang's subject matter is , to some degree at least , quintessentially american , his approach to storytelling might be called iranian . ","a fast-moving and remarkable film that appears destined to become a landmark in japanese animation . "," . . . a sour little movie at its core ; an exploration of the emptiness that underlay the relentless gaiety of the 1920's . . . the film's ending has a  what was it all for ?  feeling to it , but like the 1920's , the trip there is a great deal of fun . ","a worthy entry into a very difficult genre . ","[broomfield] uncovers a story powerful enough to leave the screen sizzling with intrigue . ","eight crazy nights is a showcase for sandler's many talents . ","a sweet-natured reconsideration of one of san francisco's most vital , if least widely recognized , creative fountainheads . ","this is one of the most visually stunning and thematically moving epics in recent memory , and in spite of numerous minor flaws , scorsese's best in more than a decade . ","everywhere the camera looks there is something worth seeing . ","a richly imagined and admirably mature work from a gifted director who definitely has something on his mind . ","it's a nicely detailed world of pawns , bishops and kings , of wagers in dingy backrooms or pristine forests . ","a charming , quirky and leisurely paced scottish comedy -- except with an outrageous central gimmick that could have been a reject from monty python's meaning of life . ","it never fails to engage us . ","its direction , its script , and weaver's performance as a vaguely discontented woman of substance make for a mildly entertaining 77 minutes , if that's what you're in the mood for . ","a charming romantic comedy that is by far the lightest dogme film and among the most enjoyable . ","this is the kind of movie that used to be right at home at the saturday matinee , and it still is . ","the spark of special anime magic here is unmistakable and hard to resist . ","like its two predecessors , 1983's koyaanisqatsi and 1988's powaqqatsi , the cinematic collage naqoyqatsi could be the most navel-gazing film ever . ","baran isn't the most transporting or gripping film from iran -- or , indeed , by its director -- but it's a worthy companion to the many fine , focused films emerging from that most surprising of nations . ","the visuals alone make metropolis worth seeing . ","dark , resonant , inventively detailed and packed with fleet turns of plot and a feast of visual amazement . ","a picture that extols the virtues of comradeship and community in a spunky , spirited fashion . ","a resonant tale of racism , revenge and retribution . ","noyce's film is contemplative and mournfully reflective . ","here , adrian lyne comes as close to profundity as he is likely to get . ","evokes a little of the fear that parents have for the possible futures of their children--and the sometimes bad choices mothers and fathers make in the interests of doing them good . ","uno de los policiales más interesantes de los últimos tiempos . ","rain is a small treasure , enveloping the viewer in a literal and spiritual torpor that is anything but cathartic . ","an elegant , exquisitely modulated psychological thriller . ","this concoction , so bizarre to the adult mind , is actually a charming triumph where its intended under-12 audience is concerned . ","droll caper-comedy remake of  big deal on madonna street  that's a sly , amusing , laugh-filled little gem in which the ultimate  bellini  begins to look like a  real kaputschnik .  ","it's a beautifully accomplished lyrical meditation on a bunch of despondent and vulnerable characters living in the renown chelsea hotel . . . ","is it a total success ? no . is it something any true film addict will want to check out ? you bet . ","zany , exuberantly irreverent animated space adventure . ","dolgin and franco fashion a fascinating portrait of a vietnamese-born youngster who eagerly and easily assimilated as an all-american girl with a brand new name in southern tennessee . ","the disarming cornball atmosphere has a way of infecting the entire crowd as the film rolls on . ","a refreshingly honest and ultimately touching tale of the sort of people usually ignored in contemporary american film . search it out . ","engrossing and affecting , if ultimately not quite satisfying . ","the story , like life , refuses to be simple , and the result is a compelling slice of awkward emotions . ","a sly game of cat and mouse that's intense and thrilling at times , but occasionally stretches believability to its limits and relies on predictable plot contrivances . ","funny and , at times , poignant , the film from director george hickenlooper all takes place in pasadena ,  a city where people still read .  ","this horror-comedy doesn't go for the usual obvious laughs at the expense of cheap-looking monsters -- unless you count elvira's hooters . ","the movie's eventual success should be credited to dennis quaid , in fighting trim shape as an athlete as well as an actor","not a bad journey at all . ","sits uneasily as a horror picture . . . but finds surprising depth in its look at the binds of a small family . ","windtalkers blows this way and that , but there's no mistaking the filmmaker in the tall grass , true to himself . ","there is a refreshing absence of cynicism in stuart little 2--quite a rarity , even in the family film market . eventually , it wins you over . ","noyce films it more as a shocking history lesson than as drama . ","like a south-of-the-border melrose place . ","those with an interest in new or singular sorts of film experiences will find what time is it there ? well worth the time . ","a wildly funny prison caper . ","huppert gives erika a persona that is so intriguing that you find yourself staring hypnotically at her , trying to understand her and wondering if she'll crack . ","despite what anyone believes about the goal of its makers , the show . . . represents a spectacular piece of theater , and there's no denying the talent of the creative forces behind it . ","you'll be left with the sensation of having just witnessed a great performance and , perhaps , give in to the urge to get on your feet and shake it . ","the actors are so terrific at conveying their young angst , we do indeed feel for them . ","the reason this picture works better than its predecessors is that myers is no longer simply spoofing the mini-mod-madness of '60s spy movies . ","it is a kickass , dense sci-fi action thriller hybrid that delivers and then some . i haven't seen one in so long , no wonder i didn't recognize it at first . ","a compelling portrait of moral emptiness","in adobo , ethnicity is not just the spice , but at the heart of more universal concerns . ","it is ridiculous , of course . . . but it is also refreshing , disarming , and just outright enjoyable despite its ridiculousness . "," . . . blade ii is more enjoyable than the original . ","a film that takes you inside the rhythms of its subject : you experience it as you watch . ","the movie exists for its soccer action and its fine acting . ","the movie is saved from unbearable lightness by the simplicity of the storytelling and the authenticity of the performances . ","the film starts out as competent but unremarkable . . . and gradually grows into something of considerable power . ","nothing denis has made before , like beau travil and nenette et boni , could prepare us for this gory , perverted , sex-soaked riff on the cannibal genre . ","reinforces the talents of screenwriter charlie kaufman , creator of adaptation and being john malkovich . ","greene delivers a typically solid performance in a role that is a bit of a departure from the noble characters he has played in the past , and he is matched by schweig , who carries the film on his broad , handsome shoulders . ","finds a way to tell a simple story , perhaps the simplest story of all , in a way that seems compelling and even original . ","a stunning piece of visual poetry that will , hopefully , be remembered as one of the most important stories to be told in australia's film history . ","this is art paying homage to art . "," . . . a joke at once flaky and resonant , lightweight and bizarrely original . ","invincible is a wonderful movie . "," . . . a cute and sometimes side-splittingly funny blend of legally blonde and drop dead gorgeous , starring piper perabo in what could be her breakthrough role . ","dazzling and sugar-sweet , a blast of shallow magnificence that only sex , scandal , and a chorus line of dangerous damsels can deliver . ","occasionally amateurishly made but a winsome cast and nice dialogue keeps it going . ","japan's premier stylist of sex and blood hits audiences with what may be his most demented film to date . ","culkin , who's in virtually every scene , shines as a young man who uses sarcastic lies like a shield . ","cuts right through the b . s . giving a big middle-fingered  shut up  to those who talk up what is nothing more than two guys beating the hell outta one another . ","the am-radio soundtrack and game cast -- tierney and the inimitable walken especially -- keep this unusual comedy from choking on its own conceit . "," . . . does such a fine job of engulfing you in its world and allying you with its characters' choices , good and ill , that its shortcomings are remembered only as an afterthought . ","marvelous , merry and , yes , melancholy film . ","from spiritual rebirth to bruising defeat , vincent's odyssey resonates in a profound way , comparable to the classic films of jean renoir . ","novak manages to capture a cruelly hilarious vein of black comedy in the situation with his cast of non-actors and a gritty , no-budget approach . ","insomnia is involving . still , i thought it could have been more . ","there was time on that second round to see the subtleties of ramsay's portrait of grief . ","we can see the wheels turning , and we might resent it sometimes , but this is still a nice little picture , made by bright and friendly souls with a lot of good cheer . ","a comprehensive and provocative film -- one that pushes the boundaries of biography , and challenges its audience . ","the way coppola professes his love for movies -- both colorful pop junk and the classics that unequivocally qualify as art -- is giddily entertaining . ","a modest masterpiece . ","a worthwhile way to spend two hours . ","francophiles will snicker knowingly and you'll want to slap them . ","sensitive , insightful and beautifully rendered film . one of the best of the year . ","a love for films shines through each frame and the era is recreated with obvious affection , scored to perfection with some tasty boogaloo beats . ","throwing caution to the wind with an invitation to the hedonist in us all , nair has constructed this motion picture in such a way that even the most cynical curmudgeon with find himself or herself smiling at one time or another . ","makes an aborbing if arguable case for the man's greatness . ","an endlessly fascinating , landmark movie that is as bold as anything the cinema has seen in years . "," . . . a haunting vision , with images that seem more like disturbing hallucinations . ","they crush each other under cars , throw each other out windows , electrocute and dismember their victims in full consciousness . and we don't avert our eyes for a moment . ","it is not a mass-market entertainment but an uncompromising attempt by one artist to think about another . ","frailty isn't as gory or explicit . but in its child-centered , claustrophobic context , it can be just as frightening and disturbing -- even punishing . ","mixes likeable personalities , inventive photography and cutting , and wall-to-wall toe-tapping music to paint a picture of a subculture that is at once exhilarating , silly , perverse , hopeful and always fun . ","the long-range appeal of  minority report  should transcend any awards it bags . this is one for the ages . ","[a] superbly controlled , passionate adaptation of graham greene's 1955 novel . ","much monkeyfun for all . ","an enchanting film that presents an audacious tour of the past and takes within its warm embrace the bounties of cultural artifacts inside st . petersburg's hermitage museum . ","[hawn's character]is so bluntly written , without a trace of sentimentality , and so blisteringly defined , that every other character seems overlooked and underwritten . ","the heightened symmetry of this new/old cinema paradiso makes the film a fuller experience , like an old friend haunted by the exigencies of time . ","the powers team has fashioned a comedy with more laughs than many , no question . but this time there's some mold on the gold . ","while surprisingly sincere , this average little story is adorned with some awesome action photography and surfing . ","it is far from the worst , thanks to the topical issues it raises , the performances of stewart and hardy , and that essential feature -- a decent full-on space battle . ","a film that is a portrait of grace in an imperfect world . ","a pleasurably jacked-up piece of action moviemaking . ","nicolas philibert observes life inside a one-room schoolhouse in northern france in his documentary to be and to have , easily one of the best films of the year . ","a perverse little truffle , dainty psychological terror on the outside with a creamy filling of familial jealousy and unrepentant domestic psychopathy . ","this ecologically minded , wildlife friendly film teaches good ethics while entertaining with its unconventionally wacky but loving family","an enjoyably half-wit remake of the venerable italian comedy big deal on madonna street . ","it takes this never-ending confusion and hatred , puts a human face on it , evokes shame among all who are party to it and even promotes understanding . ","reign of fire may be little more than another platter of reheated aliens , but it's still pretty tasty . ","there are times when a rumor of angels plays like an extended episode of touched by an angel -- a little too much dancing , a few too many weeping scenes -- but i liked its heart and its spirit . ","two hours of melodramatic musical married to two hours of underdog sports intrigue , if the picture also shares the weaknesses of both genres , more's the pity . ","this cheery , down-to-earth film is warm with the cozy feeling of relaxing around old friends . ","thrilling , provocative and darkly funny , this timely sci-fi mystery works on so many different levels that it not only invites , it demands repeated viewings . ","a tale of horror and revenge that is nearly perfect in its relentless descent to the depths of one man's tortured soul . ","an epic of grandeur and scale that's been decades gone from the popcorn pushing sound stages of hollywood . ","genuinely touching because it's realistic about all kinds of love . ","lauren ambrose comes alive under the attention from two strangers in town - with honest performances and realistic interaction between the characters , this is a coming-of-age story with a twist . ","there has been much puzzlement among critics about what the election symbolizes . i believe the message is in the messenger : the agent is a woman . ","an enjoyable film for the family , amusing and cute for both adults and kids . ","  the mothman prophecies  is a difficult film to shake from your conscience when night falls . ","the second chapter of the harry potter series is even more magical than the first and simply the best family film of the year . ","more honest about alzheimer's disease , i think , than iris . ","the acting alone is worth the price of admission . ","an excellent romp that boasts both a heart and a mind . ","interacting eyeball-to-eyeball and toe-to-toe , hopkins and norton are a winning combination -- but fiennes steals 'red dragon' right from under their noses . ","this is a terrific character study , a probe into the life of a complex man . ","impresses you with its open-endedness and surprises . ","this isn't a narrative film -- i don't know if it's possible to make a narrative film about september 11th , though i'm sure some will try -- but it's as close as anyone has dared to come . ","my oh my , is this an invigorating , electric movie . ","the two leads chomp considerably more scenery with their acting than fire-breathing monsters barbecue with their breath . . . ","cedar takes a very open-minded approach to this sensitive material , showing impressive control , both visually and in the writing . ","never once predictable . ","biggie and tupac is so single-mindedly daring , it puts far more polished documentaries to shame . ","so many documentaries like this presuppose religious bigotry or zealous nuttiness of its antagonists , but family fundamentals displays a rare gift for unflinching impartiality . ","the cast is uniformly excellent and relaxed . ","after making several adaptations of other writers' work , armenian-canadian director atom egoyan broached an original treatment of a deeply personal subject . ","the film is painfully authentic , and the performances of the young players are utterly convincing . ","if it seems like a minor miracle that its septuagenarian star is young enough to be the nonagenarian filmmaker's son , more incredible still are the clear-eyed boldness and quiet irony with which actor and director take on life's urgent questions . ","a candid and often fascinating documentary about a pentecostal church in dallas that assembles an elaborate haunted house each year to scare teenagers into attending services . ","fans of the animated wildlife adventure show will be in warthog heaven ; others need not necessarily apply . ","without resorting to hyperbole , i can state that kissing jessica stein may be the best same-sex romance i have seen . ","nolan bravely treads where few american films dare to delve -- into the world of ambivalence and ambiguity . . . ","unlike the nauseating fictions peddled by such 'have-yourself-a-happy-little-holocaust' movies as life is beautiful and jakob the liar , the grey zone is honest enough to deny the possibility of hope in auschwitz . ","a potent allegorical love story . ","even those who would like to dismiss the film outright should find much to mull and debate . ","this is cool , slick stuff , ready to quench the thirst of an audience that misses the summer blockbusters . ","the movie is full of fine performances , led by josef bierbichler as brecht and monica bleibtreu as helene weigel , his wife . ","a captivating cross-cultural comedy of manners . ","andy garcia enjoys one of his richest roles in years and mick jagger gives his best movie performance since , well , performance . ","the movie isn't always easy to look at . but if it is indeed a duty of art to reflect life , than leigh has created a masterful piece of artistry right here . ","it's [ricci's] best work yet , this girl-woman who sincerely believes she can thwart the world's misery with blind good will . ","highlights are the terrific performances by christopher plummer , as the prime villain , and nathan lane as vincent crummles , the eccentric theater company manager . ","[howard] so good as leon barlow . . . that he hardly seems to be acting . ","an uplifting , near-masterpiece . ","superior genre storytelling , which gets under our skin simply by crossing the nuclear line . ","by taking entertainment tonight subject matter and giving it humor and poignancy , auto focus becomes both gut-bustingly funny and crushingly depressing . ","it's a bittersweet and lyrical mix of elements . ","subversive , meditative , clinical and poetic , the piano teacher is a daring work of genius . ","the weakest of the four harry potter books has been transformed into the stronger of the two films by the thinnest of margins . ","its gross-out gags and colorful set pieces . . . are of course stultifyingly contrived and too stylized by half . still , it gets the job done -- a sleepy afternoon rental . ","it further declares its director , zhang yang of shower , as a boldly experimental , contemporary stylist with a bright future . ","smith's approach is never to tease , except gently and in that way that makes us consider our own eccentricities and how they are expressed through our homes . ","full of profound , real-life moments that anyone can relate to , it deserves a wide audience . ","a movie that will touch the hearts of both children and adults , as well as bring audiences to the edge of their seats . ","leave it to rohmer , now 82 , to find a way to bend current technique to the service of a vision of the past that is faithful to both architectural glories and commanding open spaces of the city as it was more than two centuries ago . ","fine acting but there is no sense of connecting the dots , just dots . ","an extraordinary swedish film about the soul adventure of marriage -- the kind of intimate and character-driven film that bille august does best . ","a blessed gift to film geeks and historians . if the '70's were your idea of a good time at the movies , this will make you very happy . ","it took 19 predecessors to get this ? ","thoughtful , even stinging at times , and lots of fun . ","one of the most haunting , viciously honest coming-of-age films in recent memory . ","the wwii drama is well plotted , visually striking and filled with enjoyably complex characters who are never what they first appear . ","it's a pleasure to see seinfeld griping about the biz with buddies chris rock , garry shandling and colin quinn . ","if you love motown music , you'll love this documentary . ","this time out , [sade] is an unsettlingly familiar figure -- in turns loyal and deceitful , responsible and reckless , idealistically selfless and coldly self-interested . ","human resources was a good , straightforward tale , but time out is better . it's haunting . it's like a poem . ","to the film's credit , the acting is fresh and unselfconscious , and munch is a marvel of reality versus sappy sentiment . ","chicago is , in many ways , an admirable achievement . ","shainberg weaves a carefully balanced scenario that is controlled by neither character , is weirdly sympathetic to both and manages to be tender and darkly comic . ","even when foreign directors . . . borrow stuff from hollywood , they invariably shake up the formula and make it more interesting . ","a cockamamie tone poem pitched precipitously between swoony lyricism and violent catastrophe . . . the most aggressively nerve-wracking and screamingly neurotic romantic comedy in cinema history . ","sturdy , entertaining period drama . . . both caine and fraser have their moments . ","whether [binoche and magimel] are being charming or angst-ridden , they easily fill their scenes and , fine judges both , never overcook the hysteria . ","a spunky , original take on a theme that will resonate with singles of many ages . ","it's a glorious groove that leaves you wanting more . ","majidi gets uniformly engaging performances from his largely amateur cast . "," . . . a well-observed and disturbing little movie","fans of nijinsky will savor every minute of cox's work . ","everything you loved about it in 1982 is still there , for everybody who wants to be a kid again , or show it to their own kids . ","jagger the actor is someone you want to see again . ","warm and exotic . ","escapism in its purest form . ","there is a kind of attentive concern that hoffman brings to his characters , as if he has been giving them private lessons , and now it is time for their first public recital . ","a comic gem with some serious sparkles . ","u . s . audiences may find [attal and gainsbourg's] unfamiliar personas give the film an intimate and quaint reality that is a little closer to human nature than what hollywood typically concocts . ","  cremaster 3  should come with the warning  for serious film buffs only !  ","once again , director jackson strikes a rewarding balance between emotion on the human scale and action/effects on the spectacular scale . ","a loving little film of considerable appeal . ","although it's a bit smug and repetitive , this documentary engages your brain in a way few current films do . ","flawed but worthy look at life in u . s . relocation camps . ","it's a lovely film with lovely performances by buy and accorsi . ","no one goes unindicted here , which is probably for the best . and if you're not nearly moved to tears by a couple of scenes , you've got ice water in your veins . ","a warm , funny , engaging film . ","uses sharp humor and insight into human nature to examine class conflict , adolescent yearning , the roots of friendship and sexual identity . ","half submarine flick , half ghost story , all in one criminally neglected film","entertains by providing good , lively company . ","dazzles with its fully-written characters , its determined stylishness ( which always relates to characters and story ) and johnny dankworth's best soundtrack in years . ","visually imaginative , thematically instructive and thoroughly delightful , it takes us on a roller-coaster ride from innocence to experience without even a hint of that typical kiddie-flick sentimentality . ","nothing's at stake , just a twisty double-cross you can smell a mile away--still , the derivative nine queens is lots of fun . ","unlike the speedy wham-bam effect of most hollywood offerings , character development -- and more importantly , character empathy -- is at the heart of italian for beginners . ","you'll gasp appalled and laugh outraged and possibly , watching the spectacle of a promising young lad treading desperately in a nasty sea , shed an errant tear . ","the band's courage in the face of official repression is inspiring , especially for aging hippies ( this one included ) . ","although german cooking does not come readily to mind when considering the world's best cuisine , mostly martha could make deutchland a popular destination for hungry tourists . ","a beguiling splash of pastel colors and prankish comedy from disney . ","as surreal as a dream and as detailed as a photograph , as visually dexterous as it is at times imaginatively overwhelming . ","[lawrence bounces] all over the stage , dancing , running , sweating , mopping his face and generally displaying the wacky talent that brought him fame in the first place . ","the film serves as a valuable time capsule to remind us of the devastating horror suffered by an entire people . ","what's surprising about full frontal is that despite its overt self-awareness , parts of the movie still manage to break past the artifice and thoroughly engage you . ","whether you like rap music or loathe it , you can't deny either the tragic loss of two young men in the prime of their talent or the power of this movie . "," . . . an otherwise intense , twist-and-turn thriller that certainly shouldn't hurt talented young gaghan's resume . ","it provides the grand , intelligent entertainment of a superior cast playing smart people amid a compelling plot . ","charming and funny ( but ultimately silly ) movie . ","there's . . . tremendous energy from the cast , a sense of playfulness and excitement that seems appropriate . ","it moves quickly , adroitly , and without fuss ; it doesn't give you time to reflect on the inanity -- and the cold war datedness -- of its premise . ","a deep and meaningful film . ","the film's welcome breeziness and some unbelievably hilarious moments -- most portraying the idiocy of the film industry -- make it mostly worth the trip . ","it's a remarkably solid and subtly satirical tour de force . ","enormously entertaining for moviegoers of any age . ","a poignant , artfully crafted meditation on mortality . ","a rarity among recent iranian films : it's a comedy full of gentle humor that chides the absurdity of its protagonist's plight . ","not only is undercover brother as funny , if not more so , than both austin powers films , but it's also one of the smarter , savvier spoofs to come along in some time . ","in a way , the film feels like a breath of fresh air , but only to those that allow it in . ","woody allen's latest is an ambling , broad comedy about all there is to love -- and hate -- about the movie biz . ","it's a stunning lyrical work of considerable force and truth . ","the inhospitability of the land emphasizes the spare precision of the narratives and helps to give them an atavistic power , as if they were tales that had been handed down since the beginning of time . ","[næs] directed the stage version of elling , and gets fine performances from his two leads who originated the characters on stage . ","made me unintentionally famous — as the queasy-stomached critic who staggered from the theater and blacked out in the lobby . but believe it or not , it's one of the most beautiful , evocative works i've seen . ","a coda in every sense , the pinochet case splits time between a minute-by-minute account of the british court's extradition chess game and the regime's talking-head survivors . ","like mike is a winner for kids , and no doubt a winner for lil bow wow , who can now add movies to the list of things he does well . ","[t]his beguiling belgian fable , very much its own droll and delicate little film , has some touching things to say about what is important in life and why . ","here's yet another studio horror franchise mucking up its storyline with glitches casual fans could correct in their sleep . but taken as a stylish and energetic one-shot , the queen of the damned cannot be said to suck . ","you won't like roger , but you will quickly recognize him . and that's a big part of why we go to the movies . ","while the stoically delivered hokum of hart's war is never fun , it's still a worthy addition to the growing canon of post-saving private ryan tributes to the greatest generation . ","we know the plot's a little crazy , but it held my interest from start to finish . ","a sober and affecting chronicle of the leveling effect of loss . ","a fast , funny , highly enjoyable movie . ","a celebration of quirkiness , eccentricity , and certain individuals' tendency to let it all hang out , and damn the consequences . ","writer/director joe carnahan's grimy crime drama is a manual of precinct cliches , but it moves fast enough to cover its clunky dialogue and lapses in logic . ","a smart , witty follow-up . ","while the ideas about techno-saturation are far from novel , they're presented with a wry dark humor . ","an infectious cultural fable with a tasty balance of family drama and frenetic comedy . ","although occasionally static to the point of resembling a stage play , the film delivers a solid mixture of sweetness and laughs . ","it provides an honest look at a community striving to anchor itself in new grounds . ","add yet another hat to a talented head , clooney's a good director . ","building slowly and subtly , the film , sporting a breezy spontaneity and realistically drawn characterizations , develops into a significant character study that is both moving and wise . ","ultimately feels empty and unsatisfying , like swallowing a communion wafer without the wine . ","chilling , well-acted , and finely directed : david jacobson's dahmer . ","a swashbuckling tale of love , betrayal , revenge and above all , faith . "," . . . a true delight . ","without ever becoming didactic , director carlos carrera expertly weaves this novelistic story of entangled interrelationships and complex morality . ","it's a coming-of-age story we've all seen bits of in other films -- but it's rarely been told with such affecting grace and cultural specificity . ","a literate presentation that wonderfully weaves a murderous event in 1873 with murderous rage in 2002 . ","makes even the claustrophobic on-board quarters seem fun . ","this is as respectful a film as byatt fans could hope for , though lovers of the book may wonder why it's necessary . ","one of the best films of the year with its exploration of the obstacles to happiness faced by five contemporary individuals . . . a psychological masterpiece . ","not far beneath the surface , this reconfigured tale asks disturbing questions about those things we expect from military epics . ","for the most part stevens glides through on some solid performances and witty dialogue . ","broomfield turns his distinctive 'blundering' style into something that could really help clear up the case . ","against all odds in heaven and hell , it creeped me out just fine . ","it's refreshing to see a girl-power movie that doesn't feel it has to prove anything . ","it's worth seeing just on the basis of the wisdom , and at times , the startling optimism , of the children . ","a rigorously structured and exquisitely filmed drama about a father and son connection that is a brief shooting star of love . ","this surreal gilliam-esque film is also a troubling interpretation of ecclesiastes . a rewarding work of art for only the most patient and challenge-hungry moviegoers . ","a quiet treasure -- a film to be savored . ","may be far from the best of the series , but it's assured , wonderfully respectful of its past and thrilling enough to make it abundantly clear that this movie phenomenon has once again reinvented itself for a new generation . ","a compelling spanish film about the withering effects of jealousy in the life of a young monarch whose sexual passion for her husband becomes an obsession . ","huston nails both the glad-handing and the choking sense of hollow despair . ","may not have generated many sparks , but with his affection for astoria and its people he has given his tale a warm glow . ","a delirious celebration of the female orgasm . ","exquisitely nuanced in mood tics and dialogue , this chamber drama is superbly acted by the deeply appealing veteran bouquet and the chilling but quite human berling . ","it's fascinating to see how bettany and mcdowell play off each other . ","the film is beautifully mounted , but , more to the point , the issues are subtly presented , managing to walk a fine line with regard to the question of joan's madness . ","leigh's film is full of memorable performances from top to bottom . ","one of the most significant moviegoing pleasures of the year . ","jose campanella delivers a loosely autobiographical story brushed with sentimentality but brimming with gentle humor , bittersweet pathos , and lyric moments that linger like snapshots of memory . ","generally , clockstoppers will fulfill your wildest fantasies about being a different kind of time traveler , while happily killing 94 minutes . ","the movie is beautiful to behold and engages one in a sense of epic struggle -- inner and outer -- that's all too rare in hollywood's hastier productions . ","ao sair do cinema , eu estava feliz e com saudades de um tempo em que , para mim , a existência de papai noel era um fato inquestionável . ","neither parker nor donovan is a typical romantic lead , but they bring a fresh , quirky charm to the formula . ","it's a much more emotional journey than what shyamalan has given us in his past two movies , and gibson , stepping in for bruce willis , is the perfect actor to take us on the trip . ","not only are the special effects and narrative flow much improved , and daniel radcliffe more emotionally assertive this time around as harry , but the film conjures the magic of author j . k . rowling's books . ","jaglom . . . put[s] the audience in the privileged position of eavesdropping on his characters","beautifully observed , miraculously unsentimental comedy-drama . ","a must-see for the david mamet enthusiast and for anyone who appreciates intelligent , stylish moviemaking . ","crackerjack entertainment -- nonstop romance , music , suspense and action . ","the acting , costumes , music , cinematography and sound are all astounding given the production's austere locales . ","garcía bernal and talancón are an immensely appealing couple , and even though their story is predictable , you'll want things to work out . ","far more imaginative and ambitious than the trivial , cash-in features nickelodeon has made from its other animated tv series . ","the very definition of the 'small' movie , but it is a good stepping stone for director sprecher . ","a gripping , searing portrait of a lost soul trying to find her way through life . ","suffers from the lack of a compelling or comprehensible narrative . still , as a visual treat , the film is almost unsurpassed . ","so unassuming and pure of heart , you can't help but warmly extend your arms and yell 'safe ! '","an intriguing cinematic omnibus and round-robin that occasionally is more interesting in concept than in execution . ","so refreshingly incisive is grant that for the first time he'll probably appeal more to guys than to their girlfriends who drag them to this movie for the hugh factor . ","at a time when half the so-called real movies are little more than live-action cartoons , it's refreshing to see a cartoon that knows what it is , and knows the form's history . ","the magic of the film lies not in the mysterious spring but in the richness of its performances . ","hoffman notches in the nuances of pain , but his smart , edgy voice and waddling profile ( emphasized here ) accent the humor of wilson's plight , and that saves his pathos from drippiness . ","what better message than 'love thyself' could young women of any size receive ? ","the second coming of harry potter is a film far superior to its predecessor . a movie that successfully crushes a best selling novel into a timeframe that mandates that you avoid the godzilla sized soda . ","84 minutes of rolling musical back beat and supercharged cartoon warfare . it's also , clearly , great fun . "," . . . takes the beauty of baseball and melds it with a story that could touch anyone regardless of their familiarity with the sport","seldahl's barbara is a precise and moving portrait of someone whose world is turned upside down , first by passion and then by illness . ","a warm but realistic meditation on friendship , family and affection . ","byler reveals his characters in a way that intrigues and even fascinates us , and he never reduces the situation to simple melodrama . ","turns potentially forgettable formula into something strangely diverting . ","bogdanovich tantalizes by offering a peep show into the lives of the era's creme de la celluloid . ","people cinema at its finest . ","the performances take the movie to a higher level . ","what really makes it special is that it pulls us into its world , gives us a hero whose suffering and triumphs we can share , surrounds him with interesting characters and sends us out of the theater feeling we've shared a great adventure . "," . . . a spoof comedy that carries its share of laughs – sometimes a chuckle , sometimes a guffaw and , to my great pleasure , the occasional belly laugh . ","manages to transcend the sex , drugs and show-tunes plot into something far richer . ","dense with characters and contains some thrilling moments . ","a true pleasure . ","lapaglia's ability to convey grief and hope works with weaver's sensitive reactions to make this a two-actor master class . ","reign of fire looks as if it was made without much thought -- and is best watched that way . ","altogether , this is successful as a film , while at the same time being a most touching reconsideration of the familiar masterpiece . ","we root for [clara and paul] , even like them , though perhaps it's an emotion closer to pity . ","the best film about baseball to hit theaters since field of dreams . ","instead of a hyperbolic beat-charged urban western , it's an unpretentious , sociologically pointed slice of life . ","the film tunes into a grief that could lead a man across centuries . ","if the count of monte cristo doesn't transform caviezel into a movie star , then the game is even more rigged than it was two centuries ago . ","[d]oesn't bother being as cloying or preachy as equivalent evangelical christian movies -- maybe the filmmakers know that the likely audience will already be among the faithful . ","as a tolerable diversion , the film suffices ; a triumph , however , it is not . ","if director michael dowse only superficially understands his characters , he doesn't hold them in contempt . ","if your taste runs to 'difficult' films you absolutely can't miss it . ","[city] reminds us how realistically nuanced a robert de niro performance can be when he is not more lucratively engaged in the shameless self-caricature of 'analyze this' ( 1999 ) and 'analyze that , ' promised ( or threatened ) for later this year . "," . . . a story we haven't seen on the big screen before , and it's a story that we as americans , and human beings , should know . ","like leon , it's frustrating and still oddly likable . ","all in all , the count of monte cristo is okay , but it is surely no classic , like the novel upon which it is based . ","if you can stomach the rough content , it's worth checking out for the performances alone . ","looking aristocratic , luminous yet careworn in jane hamilton's exemplary costumes , rampling gives a performance that could not be improved upon . ","' . . . mafia , rap stars and hood rats butt their ugly heads in a regurgitation of cinematic violence that gives brutal birth to an unlikely , but likable , hero . '","on this tricky topic , tadpole is very much a step in the right direction , with its blend of frankness , civility and compassion . ","fun , flip and terribly hip bit of cinematic entertainment . ","montias . . . pumps a lot of energy into his nicely nuanced narrative and surrounds himself with a cast of quirky -- but not stereotyped -- street characters . ","falls neatly into the category of good stupid fun . ","the film's performances are thrilling . ","even in its most tedious scenes , russian ark is mesmerizing . ","the continued good chemistry between carmen and juni is what keeps this slightly disappointing sequel going , with enough amusing banter -- blessedly curse-free -- to keep both kids and parents entertained . ","reggio's continual visual barrage is absorbing as well as thought-provoking . ","unfortunately , it appears that [jackie] chan's us influence is starting to show in his hong kong films . ","it all adds up to good fun . ","a big , gorgeous , sprawling swashbuckler that delivers its diversions in grand , uncomplicated fashion . ","the wanton slipperiness of * corpus and its amiable jerking and reshaping of physical time and space would make it a great piece to watch with kids and use to introduce video as art . ","a stunning and overwhelmingly cogent case for kissinger as a calculating war criminal . ","sade is an engaging look at the controversial eponymous and fiercely atheistic hero . ","a quiet , pure , elliptical film","kinnear doesn't aim for our sympathy , but rather delivers a performance of striking skill and depth . ","the subtle strength of  elling  is that it never loses touch with the reality of the grim situation . ","a study in shades of gray , offering itself up in subtle plot maneuvers . . . ","the format gets used best . . . to capture the dizzying heights achieved by motocross and bmx riders , whose balletic hotdogging occasionally ends in bone-crushing screwups . ","has a lot of the virtues of eastwood at his best . ","chilling but uncommercial look into the mind of jeffrey dahmer , serial killer . ","though it's become almost redundant to say so , major kudos go to leigh for actually casting people who look working-class . ","it deserves to be seen by anyone with even a passing interest in the events shaping the world beyond their own horizons . ","a movie that reminds us of just how exciting and satisfying the fantasy cinema can be when it's approached with imagination and flair . ","thanks to scott's charismatic roger and eisenberg's sweet nephew , roger dodger is one of the most compelling variations on in the company of men . ","nine queens is not only than a frighteningly capable debut and genre piece , but also a snapshot of a dangerous political situation on the verge of coming to a head . ","it's the chemistry between the women and the droll scene-stealing wit and wolfish pessimism of anna chancellor that makes this  two weddings and a funeral  fun . ","will amuse and provoke adventurous adults in specialty venues . ","you don't have to know about music to appreciate the film's easygoing blend of comedy and romance . ","third time's the charm . . . yeah , baby ! ","a film about a young man finding god that is accessible and touching to the marrow . ","for the first time in years , de niro digs deep emotionally , perhaps because he's been stirred by the powerful work of his co-stars . ","the film's snags and stumblings are more than compensated for by its wryly subversive tone . ","inside the film's conflict-powered plot there is a decent moral trying to get out , but it's not that , it's the tension that keeps you in your seat . affleck and jackson are good sparring partners . ","the old-world- meets-new mesh is incarnated in the movie's soundtrack , a joyful effusion of disco bollywood that , by the end of monsoon wedding , sent my spirit soaring out of the theater . ","an effectively creepy , fear-inducing ( not fear-reducing ) film from japanese director hideo nakata , who takes the superstitious curse on chain letters and actually applies it . ","having had the good sense to cast actors who are , generally speaking , adored by the movie-going public , khouri then gets terrific performances from them all . ","a subtle and well-crafted ( for the most part ) chiller . ","warm water under a red bridge is a quirky and poignant japanese film that explores the fascinating connections between women , water , nature , and sexuality . ","although laced with humor and a few fanciful touches , the film is a refreshingly serious look at young women . ","the best revenge may just be living well because this film , unlike other dumas adaptations , is far more likened to a treasure than a lengthy jail sentence . ","a delectable and intriguing thriller filled with surprises , read my lips is an original . this is a story of two misfits who don't stand a chance alone , but together they are magnificent . ","highbrow self-appointed guardians of culture need not apply , but those who loved cool as ice have at last found a worthy follow-up . ","one of creepiest , scariest movies to come along in a long , long time , easily rivaling blair witch or the others . ","maud and roland's search for an unknowable past makes for a haunting literary detective story , but labute pulls off a neater trick in possession : he makes language sexy . ","pacino is brilliant as the sleep-deprived dormer , his increasing weariness as much existential as it is physical . ","rare birds has more than enough charm to make it memorable . ","manages to be sweet and wickedly satisfying at the same time . ","this nickleby thing might have more homosexual undertones than an eddie murphy film . and just when you think it can't get any more gay , in pops nathan lane . ","no sophomore slump for director sam mendes , who segues from oscar winner to oscar-winning potential with a smooth sleight of hand . ","the movie isn't just hilarious : it's witty and inventive , too , and in hindsight , it isn't even all that dumb . ","old-form moviemaking at its best . ","ahhhh . . . revenge is sweet ! ","yakusho and shimizu . . . create engaging characterizations in imamura's lively and enjoyable cultural mix . ","you will emerge with a clearer view of how the gears of justice grind on and the death report comes to share airtime alongside the farm report . ","ruzowitzky has taken this mothball-y stuff and made a rather sturdy , old-fashioned entertainment out of it . ","in spite of good housekeeping's unsavory characters and wwf mentality , this white trash war of the roses is a surprisingly engaging film . ","collateral damage finally delivers the goods for schwarzenegger fans . ","there has always been something likable about the marquis de sade . ","as a first-time director , paxton has tapped something in himself as an actor that provides frailty with its dark soul . ","for the most part , director anne-sophie birot's first feature is a sensitive , extraordinarily well-acted drama . ","by the time we learn that andrew's turnabout is fair play is every bit as awful as borchardt's coven , we can enjoy it anyway . ","this riveting world war ii moral suspense story deals with the shadow side of american culture : racial prejudice in its ugly and diverse forms . ","a tender , heartfelt family drama . ","a difficult , absorbing film that manages to convey more substance despite its repetitions and inconsistencies than do most films than are far more pointed and clear . ","for the most part , it's a work of incendiary genius , steering clear of knee-jerk reactions and quick solutions . ","it has the charm of the original american road movies , feasting on the gorgeous , ramshackle landscape of the filmmaker's motherland . ","[chaiken's] talent lies in an evocative , accurate observation of a distinctive milieu and in the lively , convincing dialogue she creates for her characters . ","in all , this is a watchable movie that's not quite the memorable experience it might have been . ","huppert's superbly controlled display of murderous vulnerability ensures that malice has a very human face . ","my thoughts were focused on the characters . that is a compliment to kuras and miller . if i had been thinking about the visual medium , they would have been doing something wrong . ","one of the more intelligent children's movies to hit theaters this year . ","remember the kind of movie we were hoping  ecks vs . sever  or  xxx  was going to be ? this is it . ","not for the prurient or squeamish , it's a daring if overlong examination of an idolized culture , self-loathing and sexual politics . ","a cartoon that's truly cinematic in scope , and a story that's compelling and heartfelt -- even if the heart belongs to a big , four-legged herbivore . ","the film's almost unbearable portrait of sadness and grief transcends its specific story to speak to the ways in which need , history and presumption tangle , and sometimes destroy , blood ties . ","travels a fascinating arc from hope and euphoria to reality and disillusionment . ","polished , well-structured film . ","there's something auspicious , and daring , too , about the artistic instinct that pushes a majority-oriented director like steven spielberg to follow a . i . with this challenging report so liable to unnerve the majority . ","for anyone unfamiliar with pentacostal practices in general and theatrical phenomenon of hell houses in particular , it's an eye-opener . ","it seems like i have been waiting my whole life for this movie and now i can't wait for the sequel . ","it's a bit disappointing that it only manages to be decent instead of dead brilliant . ","apesar de seus graves problemas , o filme consegue entreter . ","an operatic , sprawling picture that's entertainingly acted , magnificently shot and gripping enough to sustain most of its 170-minute length . ","the far future may be awesome to consider , but from period detail to matters of the heart , this film is most transporting when it stays put in the past . ","it inspires a continuing and deeply satisfying awareness of the best movies as monumental 'picture shows . '","awesome creatures , breathtaking scenery , and epic battle scenes add up to another 'spectacular spectacle . '","by candidly detailing the politics involved in the creation of an extraordinary piece of music , [jones] calls our attention to the inherent conflict between commerce and creativity . ","it's unnerving to see recoing's bizzarre reaction to his unemployment . good film , but very glum . ","much as we might be interested in gratuitous sexualization , haneke has a different objective in mind--namely the implications of our craving for fake stimulation . ","dazzling in its complexity , disturbing for its extraordinary themes , the piano teacher is a film that defies categorisation . it haunts , horrifies , startles and fascinates ; it is impossible to look away . ah yes , and then there's the music . . . ","it has charm to spare , and unlike many romantic comedies , it does not alienate either gender in the audience . ","although jackson is doubtless reserving the darkest hours for the return of the king , we long for a greater sense of urgency in the here and now of the two towers . ","it is great summer fun to watch arnold and his buddy gerald bounce off a quirky cast of characters . ","bleakly funny , its characters all the more touching for refusing to pity or memorialize themselves . ","it will not appeal to the impatient , but those who like long books and movies will admire the way it accumulates power and depth . ","this flick is about as cool and crowd-pleasing as a documentary can get . ","  the ring  is pretty much an english-language copy of the film that inspired it , and it carries the same strengths and flaws . ","the wild thornberrys movie is a jolly surprise . ","griffiths proves she's that rare luminary who continually raises the standard of her profession . ","prancing his way through the tailor-made part of a male hooker approaching the end of his vitality , jagger obviously relishes every self-mocking moment . ","sexy and romantic . ","offers much to enjoy . . . and a lot to mull over in terms of love , loyalty and the nature of staying friends . ","an important movie , a reminder of the power of film to move us and to make us examine our values . ","is this love or is it masochism ? binoche makes it interesting trying to find out . ","a pleasant , if forgettable , romp of a film . ","the mesmerizing performances of the leads keep the film grounded and keep the audience riveted . ","worth watching for dong jie's performance -- and for the way it documents a culture in the throes of rapid change . ","two hours fly by -- opera's a pleasure when you don't have to endure intermissions -- and even a novice to the form comes away exhilarated . ","it's one heck of a character study -- not of hearst or davies but of the unique relationship between them . ","candid camera on methamphetamines . ","a subject like this should inspire reaction in its audience ; the pianist does not . ","equilibrium is what george orwell might have imagined had today's mood-altering drug therapy been envisioned by chemists in 1949 . ","creepy , authentic and dark . this disturbing bio-pic is hard to forget . ","martin and barbara are complex characters -- sometimes tender , sometimes angry -- and the delicate performances by sven wollter and viveka seldahl make their hopes and frustrations vivid . ","a twisty , moody slice of southern gothic . . . ","it's so good that you can practically see the hollywood 'suits' trying to put together the cast and filmmaking team for the all-too -inevitable american remake . ","the weight of the piece , the unerring professionalism of the chilly production , and the fascination embedded in the lurid topic prove recommendation enough . ","an absurdist comedy about alienation , separation and loss . ","'they' begins and ends with scenes so terrifying i'm still stunned . and i've decided to leave a light on every night from now on . ","this tenth feature is a big deal , indeed -- at least the third-best , and maybe even a notch above the previous runner-up , nicholas meyer's star trek vi : the undiscovered country . "," . . . with  the bourne identity  we return to the more traditional action genre . ","beneath clouds is a succinct low-budget film whose compelling characters and intelligent script are exactly what was missing from rabbit-proof fence . ","the film is a contrivance , as artificial as the video games japanese teens play in a nightclub sequence , but it's an enjoyable one . ","holm . . . embodies the character with an effortlessly regal charisma . ","it is amusing , and that's all it needs to be . ","among the year's most intriguing explorations of alientation . ","a full world has been presented onscreen , not some series of carefully structured plot points building to a pat resolution . ","seldom has a movie so closely matched the spirit of a man and his work . ","audrey tatou has a knack for picking roles that magnify her outrageous charm , and in this literate french comedy , she's as morning-glory exuberant as she was in amélie . ","the movie has an infectious exuberance that will engage anyone with a passing interest in the skate/surf culture , the l . a . beach scene and the imaginative ( and sometimes illegal ) ways kids can make a playground out of the refuse of adults . ","even if you don't think [kissinger's] any more guilty of criminal activity than most contemporary statesmen , he'd sure make a courtroom trial great fun to watch . ","the story and structure are well-honed . fresnadillo's dark and jolting images have a way of plying into your subconscious like the nightmare you had a week ago that won't go away . ","it's made with deftly unsettling genre flair . ","it just may inspire a few younger moviegoers to read stevenson's book , which is a treasure in and of itself . ","funny but perilously slight . ","overall very good for what it's trying to do . ","forgettable horror -- more gory than psychological -- with a highly satisfying quotient of friday-night excitement and milla power . ","ramsay , as in ratcatcher , remains a filmmaker with an acid viewpoint and a real gift for teasing chilly poetry out of lives and settings that might otherwise seem drab and sordid . ","it may seem long at 110 minutes if you're not a fan , because it includes segments of 12 songs at a reunion concert . ","a lean , deftly shot , well-acted , weirdly retro thriller that recalls a raft of '60s and '70s european-set spy pictures . ","it proves quite compelling as an intense , brooding character study . ","the son's room is a triumph of gentility that earns its moments of pathos . ","morton uses her face and her body language to bring us morvern's soul , even though the character is almost completely deadpan . ","the film may appear naked in its narrative form . . . but it goes deeper than that , to fundamental choices that include the complexity of the catholic doctrine","a superbly acted and funny/gritty fable of the humanizing of one woman at the hands of the unseen forces of fate . ","one of the smartest takes on singles culture i've seen in a long time . ","there is a fabric of complex ideas here , and feelings that profoundly deepen them . ","cq's reflection of artists and the love of cinema-and-self suggests nothing less than a new voice that deserves to be considered as a possible successor to the best european directors . ","the emotions are raw and will strike a nerve with anyone who's ever had family trauma . ","holy mad maniac in a mask , splat-man ! good old-fashioned slash-and-hack is back ! ","as unseemly as its title suggests . ","by the end of the movie , you're definitely convinced that these women are spectacular . ","the french are rather good at this kind of thing , unlike the americans , who have a passion for musketeers , only to spoof them . ","the fly-on-the-wall method used to document rural french school life is a refreshing departure from the now more prevalent technique of the docu-makers being a visible part of their work . ","it's an offbeat treat that pokes fun at the democratic exercise while also examining its significance for those who take part . ","allows us to hope that nolan is poised to embark a major career as a commercial yet inventive filmmaker . ","maneuvers skillfully through the plot's hot brine -- until it's undone by the sogginess of its contemporary characters , and actors . ","it has the ability to offend and put off everyone , but it holds you with its outrageousness . ","anchored by friel and williams's exceptional performances , the film's power lies in its complexity . nothing is black and white . ","it's a charming and often affecting journey . ","psychologically savvy . ","no screen fantasy-adventure in recent memory has the showmanship of clones' last 45 minutes . ","a poignant and compelling story about relationships , food of love takes us on a bumpy but satisfying journey of the heart . ","birot creates a drama with such a well-defined sense of place and age -- as in , 15 years old -- that the torments and angst become almost as operatic to us as they are to her characters . ","the chateau cleverly probes the cross-cultural differences between gauls and yanks . ","not since tom cruise in risky business has an actor made such a strong impression in his underwear . ","aside from minor tinkering , this is the same movie you probably loved in 1994 , except that it looks even better . ","uses high comedy to evoke surprising poignance . ","it confirms fincher's status as a film maker who artfully bends technical know-how to the service of psychological insight . ","vera's three actors -- mollà , gil and bardem -- excel in insightful , empathetic performances . ","a marvel like none you've seen . ","with tightly organized efficiency , numerous flashbacks and a constant edge of tension , miller's film is one of 2002's involvingly adult surprises . ","mr . tsai is a very original artist in his medium , and what time is it there ? should be seen at the very least for its spasms of absurdist humor . ","writer/director mark romanek spotlights the underlying caste system in america . it's a scathing portrayal . ","this is a good script , good dialogue , funny even for adults . the characters are interesting and often very creatively constructed from figure to backstory . the film will play equally well on both the standard and giant screens . ","moody , heartbreaking , and filmed in a natural , unforced style that makes its characters seem entirely convincing even when its script is not . ","not a film to rival to live , but a fine little amuse-bouche to keep your appetite whetted . ","true tale of courage -- and complicity -- at auschwitz is a harrowing drama that tries to tell of the unspeakable . ","gives you the steady pulse of life in a beautiful city viewed through the eyes of a character who , in spite of tragic loss and increasing decrepitude , knows in his bones that he is one of the luckiest men alive . ","macdowell , whose wifty southern charm has anchored lighter affairs . . . brings an absolutely riveting conviction to her role . ","what time is it there ? is not easy . it haunts you , you can't forget it , you admire its conception and are able to resolve some of the confusions you had while watching it . ","if you are an actor who can relate to the search for inner peace by dramatically depicting the lives of others onstage , then esther's story is a compelling quest for truth . ","although the level of the comedy declines as the movie proceeds , there's no denying the fun of watching de niro and crystal having fun . ","claude chabrol has here a thriller without thrills , but that's okay . ","for movie lovers as well as opera lovers , tosca is a real treat . ","unflinchingly bleak and desperate","moretti's compelling anatomy of grief and the difficult process of adapting to loss . ","challenging , intermittently engrossing and unflaggingly creative . but it's too long and too convoluted and it ends in a muddle . ","the vivid lead performances sustain interest and empathy , but the journey is far more interesting than the final destination . ","a painfully funny ode to bad behavior . ","'easily my choice for one of the year's best films . '","charles' entertaining film chronicles seinfeld's return to stand-up comedy after the wrap of his legendary sitcom , alongside wannabe comic adams' attempts to get his shot at the big time . ","that dogged good will of the parents and 'vain' jia's defoliation of ego , make the film touching despite some doldrums . ","the movie is for fans who can't stop loving anime , and the fanatical excess built into it . ","the volatile dynamics of female friendship is the subject of this unhurried , low-key film that is so off-hollywood that it seems positively french in its rhythms and resonance . ","a densely constructed , highly referential film , and an audacious return to form that can comfortably sit among jean-luc godard's finest work . ","michael gerbosi's script is economically packed with telling scenes . ","a strangely compelling and brilliantly acted psychological drama . ","candid and comfortable ; a film that deftly balances action and reflection as it lets you grasp and feel the passion others have for their work . ","open-minded kids -- kids who read , kids who dream -- will be comforted by the way it deals with big issues like death and destiny . ","bennett's naturalistic performance speaks volumes more truth than any 'reality' show , and anybody contemplating their own drastic life changes should watch some body first . "," . . . a good , if not entirely fresh , look at war . "," the film is powerful , accessible and funny . you won't miss its messages , but you'll be entertained as well . ","'frailty  starts out like a typical bible killer story , but it turns out to be significantly different ( and better ) than most films with this theme . ","if you dig on david mamet's mind tricks . . . rent this movie and enjoy ! ","the primitive force of this film seems to bubble up from the vast collective memory of the combatants . it's like watching a nightmare made flesh . ","it is the sheer , selfish , wound-licking , bar-scrapping doggedness of leon's struggle to face and transmute his demons that makes the movie a spirited and touching occasion , despite its patchy construction . ","a gorgeous , high-spirited musical from india that exquisitely blends music , dance , song , and high drama . ","it's hard to imagine alan arkin being better than he is in this performance . ","for those who pride themselves on sophisticated , discerning taste , this might not seem like the proper cup of tea , however it is almost guaranteed that even the stuffiest cinema goers will laugh their * * * off for an hour-and-a-half . ","despite the 2-d animation , the wild thornberrys movie makes for a surprisingly cinematic experience . "," . . . a fun little timewaster , helped especially by the cool presence of jean reno . ","[majidi] makes us think twice about immigrants we see around us every day . ","though only 60 minutes long , the film is packed with information and impressions . ","i have no way of knowing exactly how much is exaggeration , but i've got a creepy feeling that the film is closer to the mark than i want to believe . ","immersing us in the endlessly inventive , fiercely competitive world of hip-hop djs , the project is sensational and revelatory , even if scratching makes you itch . ","further proof that the epicenter of cool , beautiful , thought-provoking foreign cinema is smack-dab in the middle of dubya's axis of evil . ","there's really only one good idea in this movie , but the director runs with it and presents it with an unforgettable visual panache . ","a simple , but gritty and well-acted ensemble drama that encompasses a potent metaphor for a country still dealing with its fascist past . ","lovely and poignant . puts a human face on a land most westerners are unfamiliar with . ","i can't say that i liked homeboy ; it'd be more accurate to say that i found it intriguing , bizarre , dogma-like in spots - and quite truthful , in its way . ","displaying about equal amounts of naiveté , passion and talent , beneath clouds establishes sen as a filmmaker of considerable potential . ","the vitality of the actors keeps the intensity of the film high , even as the strafings blend together . ","not since japanese filmmaker akira kurosawa's ran have the savagery of combat and the specter of death been visualized with such operatic grandeur . ","we learn a lot about dying coral and see a lot of life on the reef . ","if the first men in black was money , the second is small change . but it still jingles in the pocket . it's fun lite . ","passable entertainment , but it's the kind of motion picture that won't make much of a splash when it's released , and will not be remembered long afterwards . ","i just loved every minute of this film . ","this is a winning ensemble comedy that shows canadians can put gentle laughs and equally gentle sentiments on the button , just as easily as their counterparts anywhere else in the world . ","just as moving , uplifting and funny as ever . ","my wife is an actress is an utterly charming french comedy that feels so american in sensibility and style it's virtually its own hollywood remake . ","it will grip even viewers who aren't interested in rap , as it cuts to the heart of american society in an unnerving way . ","a muckraking job , the cinematic equivalent of a legal indictment , and a fairly effective one at that . ","a tender , witty , captivating film about friendship , love , memory , trust and loyalty . ","belongs to daniel day-lewis as much as it belongs to martin scorsese ; it's a memorable performance in a big , brassy , disturbing , unusual and highly successful film . ","an exhilarating futuristic thriller-noir , minority report twists the best of technology around a gripping story , delivering a riveting , pulse intensifying escapist adventure of the first order","a psychological thriller with a genuinely spooky premise and an above-average cast , actor bill paxton's directing debut is a creepy slice of gothic rural americana . ","while locals will get a kick out of spotting cleveland sites , the rest of the world will enjoy a fast-paced comedy with quirks that might make the award-winning coen brothers envious . ","pumpkin takes an admirable look at the hypocrisy of political correctness , but it does so with such an uneven tone that you never know when humor ends and tragedy begins . ","if you're hard up for raunchy college humor , this is your ticket right here . ","few films capture so perfectly the hopes and dreams of little boys on baseball fields as well as the grown men who sit in the stands . ","corny , schmaltzy and predictable , but still manages to be kind of heartwarming , nonetheless . it's the perfect kind of film to see when you don't want to use your brain . at all . ","while it regards 1967 as the key turning point of the 20th century , and returns again and again to images of dissidents in the streets , it's alarmingly current . ","feature debuter d . j . caruso directs a crack ensemble cast , bringing screenwriter tony gayton's narcotics noir to life . ","every dance becomes about seduction , where backstabbing and betrayals are celebrated , and sex is currency . ","harris commands the screen , using his frailty to suggest the ravages of a life of corruption and ruthlessness . ","stephen rea , aidan quinn , and alan bates play desmond's legal eagles , and when joined by brosnan , the sight of this grandiloquent quartet lolling in pretty irish settings is a pleasant enough thing , 'tis . ","director of photography benoit delhomme shot the movie in delicious colors , and the costumes and sets are grand . ","the movie's relatively simple plot and uncomplicated morality play well with the affable cast . ","the film is quiet , threatening and unforgettable . ","this illuminating documentary transcends our preconceived vision of the holy land and its inhabitants , revealing the human complexities beneath . ","deliriously funny , fast and loose , accessible to the uninitiated , and full of surprises","trademark american triteness and simplicity are tossed out the window with the intelligent french drama that deftly explores the difficult relationship between a father and son . ","one from the heart . ","more concerned with sade's ideas than with his actions . the movie achieves as great an impact by keeping these thoughts hidden as . . . [quills] did by showing them . ","an entertaining , colorful , action-filled crime story with an intimate heart . ","while undisputed isn't exactly a high , it is a gripping , tidy little movie that takes mr . hill higher than he's been in a while . ","the most compelling wiseman epic of recent years . ","the socio-histo-political treatise is told in earnest strides . . . [and] personal illusion is deconstructed with poignancy . ","it's great escapist fun that recreates a place and time that will never happen again . ","good car chases , great fight scenes , and a distinctive blend of european , american and asian influences . ","liotta put on 30 pounds for the role , and has completely transformed himself from his smooth , goodfellas image . ","a woman's pic directed with resonance by ilya chaiken . ","contando com uma premissa curiosa , o filme mergulha o espectador em um clima de forte suspense , culminando em um desfecho que certamente fica na memória . ","[grant's] bumbling magic takes over the film , and it turns out to be another winning star vehicle . "," . . . brian de palma is utterly mad : cinema mad , set-piece mad , style mad . it's a beautiful madness . ","generally provides its target audience of youngsters enough stimulating eye and ear candy to make its moral medicine go down . ","there are some wonderfully fresh moments that smooth the moral stiffness with human kindness and hopefulness . ","a grimly competent and stolid and earnest military courtroom drama . ","escaping the studio , piccoli is warmly affecting and so is this adroitly minimalist movie . ","very psychoanalytical -- provocatively so -- and also refreshingly literary . ","a gorgeous , witty , seductive movie . ","the special effects and many scenes of weightlessness look as good or better than in the original , while the oscar-winning sound and james horner's rousing score make good use of the hefty audio system . ","on the heels of the ring comes a similarly morose and humorless horror movie that , although flawed , is to be commended for its straight-ahead approach to creepiness . ","with rabbit-proof fence , noyce has tailored an epic tale into a lean , economical movie . ","[a]n utterly charming and hilarious film that reminded me of the best of the disney comedies from the 60s . ","preaches to two completely different choirs at the same time , which is a pretty amazing accomplishment . ","thanks to haynes' absolute control of the film's mood , and buoyed by three terrific performances , far from heaven actually pulls off this stylistic juggling act . ","birthday girl is an amusing joy ride , with some surprisingly violent moments . ","more romantic , more emotional and ultimately more satisfying than the teary-eyed original . ","an appealingly juvenile trifle that delivers its share of laughs and smiles . ","writer-director's mehta's effort has tons of charm and the whimsy is in the mixture , the intoxicating masala , of cultures and film genres . ","the draw [for  big bad love  ] is a solid performance by arliss howard . ","it gets onto the screen just about as much of the novella as one could reasonably expect , and is engrossing and moving in its own right . ","the terrific and bewilderingly underrated campbell scott gives a star performance that is nothing short of mesmerizing . ","cool ? this movie is a snow emergency . ","like mike isn't interested in recycling old cliches . it wants to tweak them with a taste of tangy new humor . ","smith is careful not to make fun of these curious owners of architectural oddities . instead , he shows them the respect they are due . ","a mess when it comes to the characters and writing . . . but works its way underneath the skin like few movies have in recent memory . ","drops you into a dizzying , volatile , pressure-cooker of a situation that quickly snowballs out of control , while focusing on the what much more than the why . ","zhang . . . has done an amazing job of getting realistic performances from his mainly nonprofessional cast . ","a solid examination of the male midlife crisis . ","if you're in the mood for a bollywood film , here's one for you . ","as the two leads , lathan and diggs are charming and have chemistry both as friends and lovers . ","a beguiling , slow-moving parable about the collision of past and present on a remote seacoast in iran . ","my big fat greek wedding uses stereotypes in a delightful blend of sweet romance and lovingly dished out humor . ","kept aloft largely by a comically adept ensemble . ","the sort of film that makes me miss hitchcock , but also feel optimistic that there's hope for popular cinema yet . ","first-time writer-director serry shows a remarkable gift for storytelling with this moving , effective little film . ","it cuts to the core of what it actually means to face your fears , to be a girl in a world of boys , to be a boy truly in love with a girl , and to ride the big metaphorical wave that is life -- wherever it takes you . ","atom egoyan has conjured up a multilayered work that tackles any number of fascinating issues","essentially an exceptionally well-written , well-edited , well-directed , well-acted , bald rip-off of aliens . ","'de niro . . . is a veritable source of sincere passion that this hollywood contrivance orbits around . '","the whole is quite entertaining , but despite its virtues , there is an unsettled feeling to the film . ","while its careful pace and seemingly opaque story may not satisfy every moviegoer's appetite , the film's final scene is soaringly , transparently moving . ","hardly a masterpiece , but it introduces viewers to a good charitable enterprise and some interesting real people . ","based on a devilishly witty script by heather mcgowan and niels mueller , the film gets great laughs , but never at the expense of its characters","it's somewhat clumsy and too lethargically paced -- but its story about a mysterious creature with psychic abilities offers a solid build-up , a terrific climax , and some nice chills along the way . ","if you've ever wondered what an ending without the input of studio executives or test audiences would look like , here it is . ","exciting and direct , with ghost imagery that shows just enough to keep us on our toes . ","whether writer-director anne fontaine's film is a ghost story , an account of a nervous breakdown , a trip down memory lane , all three or none of the above , it is as seductive as it is haunting . ","what the film lacks in general focus it makes up for in compassion , as corcuera manages to find the seeds of hope in the form of collective action . ","if you enjoy more thoughtful comedies with interesting conflicted characters ; this one is for you . ","the quality of the art combined with the humor and intelligence of the script allow the filmmakers to present the biblical message of forgiveness without it ever becoming preachy or syrupy . ","this film seems thirsty for reflection , itself taking on adolescent qualities . ","another one of those estrogen overdose movies like  divine secrets of the ya ya sisterhood ,  except that the writing , acting and character development are a lot better . ","a breezy romantic comedy that has the punch of a good sitcom , while offering exceptionally well-detailed characters . ","a romantic comedy enriched by a sharp eye for manners and mores . ","viewers of  the ring  are more likely to remember the haunting images than the plot holes . ","a delightful coming-of-age story . ","one of those energetic surprises , an original that pleases almost everyone who sees it . ","an exquisitely crafted and acted tale . ","a taut psychological thriller that doesn't waste a moment of its two-hour running time . ","jones . . . does offer a brutal form of charisma . ","despite its title , punch-drunk love is never heavy-handed . the jabs it employs are short , carefully placed and dead-center . ","there's a wickedly subversive bent to the best parts of birthday girl . ","likely to expertly drum up repressed teenage memories in any viewer . ","blanchett's performance confirms her power once again . "," . . . a magnificent drama well worth tracking down . ","a good piece of work more often than not . ","the movie understands like few others how the depth and breadth of emotional intimacy give the physical act all of its meaning and most of its pleasure . ","what distinguishes time of favor from countless other thrillers is its underlying concern with the consequences of words and with the complicated emotions fueling terrorist acts . ","smart , provocative and blisteringly funny . ","nothing is sacred in this gut-buster . ","the movie occasionally threatens to become didactic , but it's too grounded in the reality of its characters to go over the edge . a touch of humor or an unexpected plot twist always pulls it back . ","filmmakers who can deftly change moods are treasures and even marvels . so , too , is this comedy about mild culture clashing in today's new delhi . ","if steven soderbergh's 'solaris' is a failure it is a glorious failure . ","  mostly martha  is a bright , light modern day family parable that wears its heart on its sleeve for all to see . ","it's a scattershot affair , but when it hits its mark it's brilliant . ","a pleasant enough romance with intellectual underpinnings , the kind of movie that entertains even as it turns maddeningly predictable . ","featuring a dangerously seductive performance from the great daniel auteuil ,  sade  covers the same period as kaufmann's  quills  with more unsettlingly realistic results . ","a spellbinding african film about the modern condition of rootlessness , a state experienced by millions around the globe . ","it's a work by an artist so in control of both his medium and his message that he can improvise like a jazzman . ","a moody , multi-dimensional love story and sci-fi mystery , solaris is a thought-provoking , haunting film that allows the seeds of the imagination to germinate . ","a very well-made , funny and entertaining picture . ","a giggle-inducing comedy with snappy dialogue and winning performances by an unlikely team of oscar-winners : susan sarandon and goldie hawn . ","its maker , steven spielberg , hasn't had so much fun in two decades , since he was schlepping indiana jones around the globe in search of a giant misplaced ashtray . ","oscar wilde's masterpiece , the importance of being earnest , may be the best play of the 19th century . it's so good that its relentless , polished wit can withstand not only inept school productions , but even oliver parker's movie adaptation . ","the movie does a good job of laying out some of the major issues that we encounter as we journey through life . ","brilliantly explores the conflict between following one's heart and following the demands of tradition . ","this remake gets all there is to get out of a peculiar premise with promise : al pacino loathing robin williams . ","the next generation of mob movie . part low rent godfather . part three stooges . ","lan yu is at times too restrained , yet there are moments it captures the erotics of intimacy in a way that makes most american love stories look downright unfree . ","a thinly veiled look at different aspects of chinese life clashing with each other . ","light years/ several warp speeds/ levels and levels of dilithium crystals better than the pitiful insurrection . which isn't to say that it's the equal of some of its predecessors . ","delightfully rendered","if this story must be told and retold -- and indeed it must -- then the grey zone is to be lauded for finding a new and ingenious angle . ","the lion king was a roaring success when it was released eight years ago , but on imax it seems better , not just bigger . ","a gripping movie , played with performances that are all understated and touching . ","the piece plays as well as it does thanks in large measure to anspaugh's three lead actresses . ","the inspirational screenplay by mike rich covers a lot of ground , perhaps too much , but ties things together , neatly , by the end . ","not the kind of film that will appeal to a mainstream american audience , but there is a certain charm about the film that makes it a suitable entry into the fest circuit . ","director andrew niccol . . . demonstrates a wry understanding of the quirks of fame . his healthy sense of satire is light and fun . . . . ","about a manga-like heroine who fights back at her abusers , it's energetic and satisfying if not deep and psychological . ","this is human comedy at its most amusing , interesting and confirming . ","an artful , intelligent film that stays within the confines of a well-established genre . ","majidi is an unconventional storyteller , capable of finding beauty in the most depressing places . ","richard gere and diane lane put in fine performances as does french actor oliver martinez . ","the minor figures surrounding [bobby] . . . form a gritty urban mosaic . ","this is wild surreal stuff , but brilliant and the camera just kind of sits there and lets you look at this and its like you're going from one room to the next and none of them have any relation to the other . ","it's a demented kitsch mess ( although the smeary digital video does match the muddled narrative ) , but it's savvy about celebrity and has more guts and energy than much of what will open this year . ","there is nothing outstanding about this film , but it is good enough and will likely be appreciated most by sailors and folks who know their way around a submarine . ","all-in-all , the film is an enjoyable and frankly told tale of a people who live among us , but not necessarily with us . ","an interesting story with a pertinent ( cinematically unique ) message , told fairly well and scored to perfection , i found myself struggling to put my finger on that elusive  missing thing .  ","a movie with a real anarchic flair . ","a welcome relief from baseball movies that try too hard to be mythic , this one is a sweet and modest and ultimately winning story . ","a crisp psychological drama [and] a fascinating little thriller that would have been perfect for an old  twilight zone  episode . ","it has more than a few moments that are insightful enough to be fondly remembered in the endlessly challenging maze of moviegoing . ","opening with some contrived banter , cliches and some loose ends , the screenplay only comes into its own in the second half . ","an uncluttered , resonant gem that relays its universal points without lectures or confrontations . ","'[the cockettes] provides a window into a subculture hell-bent on expressing itself in every way imaginable . '","a smart , steamy mix of road movie , coming-of-age story and political satire . ","the modern-day royals have nothing on these guys when it comes to scandals . it's only in fairy tales that princesses that are married for political reason live happily ever after . ","a terrific b movie -- in fact , the best in recent memory . ","  birthday girl  is an actor's movie first and foremost . ","i walked away from this new version of e . t . just as i hoped i would -- with moist eyes . ","for devotees of french cinema , safe conduct is so rich with period minutiae it's like dying and going to celluloid heaven . ","what's really so appealing about the characters is their resemblance to everyday children . ","shamelessly resorting to pee-related sight gags that might even cause tom green a grimace ; still , myer's energy and the silliness of it all eventually prevail","an absurdist spider web . ","if you're as happy listening to movies as you are watching them , and the slow parade of human frailty fascinates you , then you're at the right film . ","this version moves beyond the original's nostalgia for the communal film experiences of yesteryear to a deeper realization of cinema's inability to stand in for true , lived experience . ","some movies blend together as they become distant memories . mention  solaris  five years from now and i'm sure those who saw it will have an opinion to share . ","allen's funniest and most likeable movie in years . ","it's a glorious spectacle like those d . w . griffith made in the early days of silent film . ","this comic gem is as delightful as it is derivative . ","more timely than its director could ever have dreamed , this quietly lyrical tale probes the ambiguous welcome extended by iran to the afghani refugees who streamed across its borders , desperate for work and food . ","the leaping story line , shaped by director peter kosminsky into sharp slivers and cutting impressions , shows all the signs of rich detail condensed into a few evocative images and striking character traits . ","with three excellent principal singers , a youthful and good-looking diva and tenor and richly handsome locations , it's enough to make you wish jacquot had left well enough alone and just filmed the opera without all these distortions of perspective . ","the production has been made with an enormous amount of affection , so we believe these characters love each other . ","certainly the performances are worthwhile . ","'no es la mejor cinta de la serie , ni la mejor con brosnan a la cabeza , pero de que entretiene ni duda cabe . '","winds up being both revelatory and narcissistic , achieving some honest insight into relationships that most high-concept films candy-coat with pat storylines , precious circumstances and beautiful stars . ","watching these eccentrics is both inspiring and pure joy . ","steven spielberg brings us another masterpiece","finally , the french-produced  read my lips  is a movie that understands characters must come first . ","ms . seigner and mr . serrault bring fresh , unforced naturalism to their characters . ","allen shows he can outgag any of those young whippersnappers making moving pictures today . ","a good film with a solid pedigree both in front of and , more specifically , behind the camera . ","by no means a slam-dunk and sure to ultimately disappoint the action fans who will be moved to the edge of their seats by the dynamic first act , it still comes off as a touching , transcendent love story . ","i encourage young and old alike to go see this unique and entertaining twist on the classic whale's tale -- you won't be sorry ! ","a literary detective story is still a detective story and aficionados of the whodunit won't be disappointed . ","high crimes steals so freely from other movies and combines enough disparate types of films that it can't help but engage an audience . ","if you're a fan of the series you'll love it and probably want to see it twice . i will be . ","it celebrates the group's playful spark of nonconformity , glancing vividly back at what hibiscus grandly called his 'angels of light . '","the story . . . is inspiring , ironic , and revelatory of just how ridiculous and money-oriented the record industry really is . it is also a testament to the integrity and vision of the band . ","laced with liberal doses of dark humor , gorgeous exterior photography , and a stable-full of solid performances , no such thing is a fascinating little tale . ","huppert's show to steal and she makes a meal of it , channeling kathy baker's creepy turn as the repressed mother on boston public just as much as 8 women's augustine . ","nair doesn't treat the issues lightly . she allows each character to confront their problems openly and honestly . ","one of the best silly horror movies of recent memory , with some real shocks in store for unwary viewers . ","the work of a filmmaker who has secrets buried at the heart of his story and knows how to take time revealing them . strange occurrences build in the mind of the viewer and take on extreme urgency . ","has a certain ghoulish fascination , and generates a fair amount of b-movie excitement . ","familiar but utterly delightful . ","a fascinating , dark thriller that keeps you hooked on the delicious pulpiness of its lurid fiction . ","the film aims to be funny , uplifting and moving , sometimes all at once . the extent to which it succeeds is impressive . ","the film brilliantly shines on all the characters , as the direction is intelligently accomplished . ","while not for every taste , this often very funny collegiate gross-out comedy goes a long way toward restoring the luster of the national lampoon film franchise , too long reduced to direct-to-video irrelevancy . ","as broad and cartoonish as the screenplay is , there is an accuracy of observation in the work of the director , frank novak , that keeps the film grounded in an undeniable social realism . ","in addition to hoffman's powerful acting clinic , this is that rare drama that offers a thoughtful and rewarding glimpse into the sort of heartache everyone has felt , or will feel someday . ","jeffrey tambor's performance as the intelligent jazz-playing exterminator is oscar-worthy . ","from the opening strains of the average white band's  pick up the pieces  , you can feel the love . ","stevens' vibrant creative instincts are the difference between this and countless other flicks about guys and dolls . ","that it'll probably be the best and most mature comedy of the 2002 summer season speaks more of the season than the picture","old people will love this movie , and i mean that in the nicest possible way : last orders will touch the heart of anyone old enough to have earned a 50-year friendship . ","meyjes' provocative film might be called an example of the haphazardness of evil . ","tian emphasizes the isolation of these characters by confining color to liyan's backyard . ","the movie is pretty funny now and then without in any way demeaning its subjects . ","imagine a scenario where bergman approaches swedish fatalism using gary larson's far side humor","too damn weird to pass up , and for the blacklight crowd , way cheaper ( and better ) than pink floyd tickets . ","it is most remarkable not because of its epic scope , but because of the startling intimacy it achieves despite that breadth . ","it's not a great monster movie . but if you've paid a matinee price and bought a big tub of popcorn , there's guilty fun to be had here . chomp chomp ! ","the grey zone gives voice to a story that needs to be heard in the sea of holocaust movies . . . but the film suffers from its own difficulties . ","fun and nimble . ","others , more attuned to the anarchist maxim that 'the urge to destroy is also a creative urge' , or more willing to see with their own eyes , will find morrison's iconoclastic uses of technology to be liberating . ","miller tells this very compelling tale with little fuss or noise , expertly plucking tension from quiet . ","time out is existential drama without any of the pretension associated with the term . ","it's a sweet , laugh-a-minute crowd pleaser that lifts your spirits as well as the corners of your mouth . ","writer/director alexander payne ( election ) and his co-writer jim taylor brilliantly employ their quirky and fearless ability to look american angst in the eye and end up laughing . ","a movie that at its best doesn't just make the most out of its characters' flaws but insists on the virtue of imperfection . ","it's tough to watch , but it's a fantastic movie . ","the best animated feature to hit theaters since beauty and the beast 11 years ago . ","what saves this deeply affecting film from being merely a collection of wrenching cases is corcuera's attention to detail . ","funny and touching . ","pacino is the best he's been in years and keener is marvelous . ","a solid , spooky entertainment worthy of the price of a ticket . ","by turns fanciful , grisly and engagingly quixotic . "," . . . very funny , very enjoyable . . . ","adaptation is intricately constructed and in a strange way nails all of orlean's themes without being a true adaptation of her book . ","so purely enjoyable that you might not even notice it's a fairly straightforward remake of hollywood comedies such as father of the bride . ","moonlight mile gives itself the freedom to feel contradictory things . it is sentimental but feels free to offend , is analytical and then surrenders to the illogic of its characters , is about grief and yet permits laughter . ","the real triumphs in igby come from philippe , who makes oliver far more interesting than the character's lines would suggest , and sarandon , who couldn't be better as a cruel but weirdly likable wasp matron . ","robin williams has thankfully ditched the saccharine sentimentality of bicentennial man in favour of an altogether darker side . ","if you're willing to have fun with it , you won't feel cheated by the high infidelity of unfaithful . ","australia : land beyond time is an enjoyable big movie primarily because australia is a weirdly beautiful place . ","hoffman's performance is authentic to the core of his being . ","told just proficiently enough to trounce its overly comfortable trappings . ","an enthralling aesthetic experience , one that's steeped in mystery and a ravishing , baroque beauty . ","the quirky drama touches the heart and the funnybone thanks to the energetic and always surprising performance by rachel griffiths . ","a captivating coming-of-age story that may also be the first narrative film to be truly informed by the wireless age . ","what could have been a daytime soap opera is actually a compelling look at a young woman's tragic odyssey . ","duvall is strong as always . ","a no-holds-barred cinematic treat . ","you'd have to be a most hard-hearted person not to be moved by this drama . ","allen's underestimated charm delivers more goodies than lumps of coal . ","measured against practically any like-themed film other than its oscar-sweeping franchise predecessor the silence of the lambs , red dragon rates as an exceptional thriller . ","an exhilarating serving of movie fluff . ","maelstrom is strange and compelling , engrossing and different , a moral tale with a twisted sense of humor . ","it makes you believe the cast and crew thoroughly enjoyed themselves and believed in their small-budget film . ","dark and disturbing , yet compelling to watch . ","too often , son of the bride becomes an exercise in trying to predict when a preordained  big moment  will occur and not  if .  ","the picture uses humor and a heartfelt conviction to tell a story about discovering your destination in life , but also acknowledging the places , and the people , from whence you came . ","a solid piece of journalistic work that draws a picture of a man for whom political expedience became a deadly foreign policy . ","a terrific insider look at the star-making machinery of tinseltown . ","it's a diverting enough hour-and-a-half for the family audience . ","a party-hearty teen flick that scalds like acid . ","as giddy and whimsical and relevant today as it was 270 years ago . ","the film offers an intriguing what-if premise . ","the pianist is the film roman polanski may have been born to make . ","this version does justice both to stevenson and to the sci-fi genre . ","poignant and delicately complex . ","enough may pander to our basest desires for payback , but unlike many revenge fantasies , it ultimately delivers . ","cho's latest comic set isn't as sharp or as fresh as i'm the one that i want . . . but it's still damn funny stuff . ","in the pianist , polanski is saying what he has long wanted to say , confronting the roots of his own preoccupations and obsessions , and he allows nothing to get in the way . ","despite the film's shortcomings , the stories are quietly moving . ","those who love cinema paradiso will find the new scenes interesting , but few will find the movie improved . ","if you come from a family that eats , meddles , argues , laughs , kibbitzes and fights together , then go see this delightful comedy . ","this bracingly truthful antidote to hollywood teenage movies that slather clearasil over the blemishes of youth captures the combustible mixture of a chafing inner loneliness and desperate grandiosity that tend to characterize puberty . ","the reason to see  sade  lay with the chemistry and complex relationship between the marquis ( auteil ) and emilie ( le besco ) . ","it's the filmmakers' post-camp comprehension of what made old-time b movies good-bad that makes eight legged freaks a perfectly entertaining summer diversion . ","serious and thoughtful . ","it strikes hardest… when it reminds you how pertinent its dynamics remain . fifty years after the fact , the world's political situation seems little different , and [director phillip] noyce brings out the allegory with remarkable skill . ","the film's strength isn't in its details , but in the larger picture it paints - of a culture in conflict with itself , with the thin veneer of nationalism that covers our deepest , media-soaked fears . "," . . . best seen as speculative history , as much an exploration of the paranoid impulse as a creative sequel to the warren report . ","it has its faults , but it is a kind , unapologetic , sweetheart of a movie , and mandy moore leaves a positive impression . ","the saigon of 1952 is an uneasy mix of sensual delights and simmering violence , and the quiet american brings us right into the center of that world . ","despite its shortcomings , girls can't swim represents an engaging and intimate first feature by a talented director to watch , and it's a worthy entry in the french coming-of-age genre . ","flawed , but worth seeing for ambrose's performance . ","with dirty deeds , david caesar has stepped into the mainstream of filmmaking with an assurance worthy of international acclaim and with every cinematic tool well under his control -- driven by a natural sense for what works on screen . ","the humor and humanity of monsoon wedding are in perfect balance . ","lookin' for sin , american-style ? try hell house , which documents the cautionary christian spook-a-rama of the same name . ","a compelling motion picture that illustrates an american tragedy . ","as comedic spotlights go , notorious c . h . o . hits all the verbal marks it should . ","it's a day at the beach -- with air conditioning and popcorn . ","frida isn't that much different from many a hollywood romance . what sets it apart is the vision that taymor , the avant garde director of broadway's the lion king and the film titus , brings . ","stevens has a flair for dialogue comedy , the film operates nicely off the element of surprise , and the large cast is solid . ","extremely well acted by the four primary actors , this is a seriously intended movie that is not easily forgotten . ","the film exudes the urbane sweetness that woody allen seems to have bitterly forsaken . ","k-19 : the widowmaker is derivative , overlong , and bombastic -- yet surprisingly entertaining . ","it's good , hard-edged stuff , violent and a bit exploitative but also nicely done , morally alert and street-smart . ","cineasts will revel in those visual in-jokes , as in the film's verbal pokes at everything from the likes of miramax chief harvey weinstein's bluff personal style to the stylistic rigors of denmark's dogma movement . ","it's a rare window on an artistic collaboration . "," . . . begins with promise , but runs aground after being snared in its own tangled plot . ","perhaps the best sports movie i've ever seen . ","cho's timing is priceless . "," . . . creates a visceral sense of its characters' lives and conflicted emotions that carries it far above . . . what could have been a melodramatic , lifetime channel-style anthology . ","a sensitive , moving , brilliantly constructed work . ","an edgy thriller that delivers a surprising punch . ","a reasonably entertaining sequel to 1994's surprise family hit that may strain adult credibility . ","[reno] delivers a monologue that manages to incorporate both the horror and the absurdity of the situation in a well-balanced fashion . ","there is truth here","a confident , richly acted , emotionally devastating piece of work and 2002's first great film","a touching , small-scale story of family responsibility and care in the community . ","arteta directs one of the best ensemble casts of the year","the casting of von sydow . . . is itself intacto's luckiest stroke . ","no , it's not as single-minded as john carpenter's original , but it's sure a lot smarter and more unnerving than the sequels . ","a gem of a romantic crime comedy that turns out to be clever , amusing and unpredictable . ","stands as one of the year's most intriguing movie experiences , letting its imagery speak for it while it forces you to ponder anew what a movie can be . "," . . . the first 2/3 of the film are incredibly captivating and insanely funny , thanks in part to interesting cinematic devices ( cool visual backmasking ) , a solid cast , and some wickedly sick and twisted humor . . . ","this movie got me grinning . there's a part of us that cannot help be entertained by the sight of someone getting away with something . ","an old-fashioned drama of substance about a teacher's slide down the slippery slope of dishonesty after an encounter with the rich and the powerful who have nothing but disdain for virtue . ","what's not to like about a movie with a 'children's' song that includes the line 'my stepdad's not mean , he's just adjusting' ? ","this english-language version . . . does full honor to miyazaki's teeming and often unsettling landscape , and to the conflicted complexity of his characters . ","the pleasures that it does afford may be enough to keep many moviegoers occupied amidst some of the more serious-minded concerns of other year-end movies . ","not everyone will welcome or accept the trials of henry kissinger as faithful portraiture , but few can argue that the debate it joins is a necessary and timely one . ","there are no special effects , and no hollywood endings . ","like the original , this version is raised a few notches above kiddie fantasy pablum by allen's astringent wit . ","despite its hawaiian setting , the science-fiction trimmings and some moments of rowdy slapstick , the basic plot of  lilo  could have been pulled from a tear-stained vintage shirley temple script . ","a brutally honest documentary about a much anticipated family reunion that goes wrong thanks to culture shock and a refusal to empathize with others . ","filled with honest performances and exceptional detail , baran is a gentle film with dramatic punch , a haunting ode to humanity . ","sparkles in its deft portrait of tinseltown's seasoned veterans of gossip , wealth , paranoia , and celebrityhood . ","in its dry and forceful way , it delivers the same message as jiri menzel's closely watched trains and danis tanovic's no man's land . ","one-of-a-kind near-masterpiece . "," . . . a triumph of emotionally and narratively complex filmmaking . ","[haynes'] homage to such films as  all that heaven allows  and  imitation of life  transcends them . simply put ,  far from heaven  is a masterpiece . ","an intense and effective film about loneliness and the chilly anonymity of the environments where so many of us spend so much of our time . ","although fairly involving as far as it goes , the film doesn't end up having much that is fresh to say about growing up catholic or , really , anything . ","proves mainly that south korean filmmakers can make undemanding action movies with all the alacrity of their hollywood counterparts . ","a very funny romantic comedy about two skittish new york middle-agers who stumble into a relationship and then struggle furiously with their fears and foibles . ","top-notch action powers this romantic drama . ","beresford nicely mixes in as much humor as pathos to take us on his sentimental journey of the heart . it really is a shame that more won't get an opportunity to embrace small , sweet 'evelyn . '","i stopped thinking about how good it all was , and started doing nothing but reacting to it - feeling a part of its grand locations , thinking urgently as the protagonists struggled , feeling at the mercy of its inventiveness , gasping at its visual delights . ","probably the best case for christianity since chesterton and lewis . ","a gently funny , sweetly adventurous film that makes you feel genuinely good , that is to say , entirely unconned by false sentiment or sharp , overmanipulative hollywood practices . ","would be an unendurable viewing experience for this ultra-provincial new yorker if 26-year-old reese witherspoon were not on hand to inject her pure fantasy character , melanie carmichael , with a massive infusion of old-fashioned hollywood magic . ","visually fascinating . . . an often intense character study about fathers and sons , loyalty and duty . ","a lyrical metaphor for cultural and personal self-discovery and a picaresque view of a little-remembered world . ","schütte's dramatic snapshot of the artist three days before his death offers an interesting bit of speculation as to the issues brecht faced as his life drew to a close . ","a slick , engrossing melodrama . ","s1m0ne's satire is not subtle , but it is effective . it's a quirky , off-beat project . . . . ","while some will object to the idea of a vietnam picture with such a rah-rah , patriotic tone , soldiers ultimately achieves its main strategic objective : dramatizing the human cost of the conflict that came to define a generation . ","even if you don't know the band or the album's songs by heart , you will enjoy seeing how both evolve , and you will also learn a good deal about the state of the music business in the 21st century . ","the solid filmmaking and convincing characters makes this a high water mark for this genre . ","films about loss , grief and recovery are pretty valuable these days . seen in that light , moonlight mile should strike a nerve in many . ","it's endlessly inventive , consistently intelligent and sickeningly savage . ","it is definitely worth seeing . ","an impeccable study in perversity . ","far from heaven is a dazzling conceptual feat , but more than that , it's a work of enthralling drama . ","a movie that both thrills the eye and , in its over-the-top way , touches the heart . ","stuffed to the brim with ideas , american instigator michael moore's film is a rambling examination of american gun culture that uses his usual modus operandi of crucifixion through juxtaposition . ","affectionately reminds us that , in any language , the huge stuff in life can usually be traced back to the little things . ","a drama of great power , yet some members of the audience will leave the theater believing they have seen a comedy . ","the large-frame imax camera lends itself beautifully to filming the teeming life on the reefs , making this gorgeous film a must for everyone from junior scientists to grown-up fish lovers . ","the result is more depressing than liberating , but it's never boring . ","a story about intelligent high school students that deals with first love sweetly but also seriously . it is also beautifully acted . ","it isn't that the picture is unfamiliar , but that it manages to find new avenues of discourse on old problems . ","same song , second verse , coulda been better , but it coulda been worse . ","it's a technically superb film , shining with all the usual spielberg flair , expertly utilizing the talents of his top-notch creative team . ","wilco fans will have a great time , and the movie should win the band a few new converts , too . ","tsai has a well-deserved reputation as one of the cinema world's great visual stylists , and in this film , every shot enhances the excellent performances . ","the date movie that franz kafka would have made . ","the fact is that the screen is most alive when it seems most likely that broomfield's interviewees , or even himself , will not be for much longer . ","leguizamo and jones are both excellent and the rest of the cast is uniformly superb . ","i liked this film a lot . . . "," . . . there is enough originality in 'life' to distance it from the pack of paint-by-number romantic comedies that so often end up on cinema screens . ","a solid and refined piece of moviemaking imbued with passion and attitude . ","nettelbeck has crafted an engaging fantasy of flavours and emotions , one part romance novel , one part recipe book . ","with or without the sex , a wonderful tale of love and destiny , told well by a master storyteller","on the surface a silly comedy , scotland , pa would be forgettable if it weren't such a clever adaptation of the bard's tragic play . ","a weird , arresting little ride . ","a fine film , but it would be a lot better if it stuck to betty fisher and left out the other stories . ","a first-class road movie that proves you can run away from home , but your ego and all your problems go with you . ","you might want to take a reality check before you pay the full ticket price to see  simone ,  and consider a dvd rental instead . ","well cast and well directed - a powerful drama with enough sardonic wit to keep it from being maudlin . ","a backstage must-see for true fans of comedy . ","there's back-stabbing , inter-racial desire and , most importantly , singing and dancing . ","the film sounds like the stuff of lurid melodrama , but what makes it interesting as a character study is the fact that the story is told from paul's perspective . ","jones . . . makes a great impression as the writer-director of this little $1 . 8 million charmer , which may not be cutting-edge indie filmmaking but has a huge heart . ","in the disturbingly involving family dysfunctional drama how i killed my father , french director anne fontaine delivers an inspired portrait of male-ridden angst and the emotional blockage that accompanies this human condition","below may not mark mr . twohy's emergence into the mainstream , but his promise remains undiminished . ","there's no reason to miss interview with the assassin","happily stays close to the ground in a spare and simple manner and doesn't pummel us with phony imagery or music . ","its sheer dynamism is infectious . ","for his first attempt at film noir , spielberg presents a fascinating but flawed look at the near future . ","lightweight but appealing . ","it somehow managed to make its way past my crappola radar and find a small place in my heart","perhaps it's cliche to call the film 'refreshing , ' but it is . 'drumline' shows a level of young , black manhood that is funny , touching , smart and complicated . ","it does give a taste of the burning man ethos , an appealing blend of counter-cultural idealism and hedonistic creativity . ","the limited sets and small confined and dark spaces also are homages to a classic low-budget film noir movie . ","the movie is well done , but slow . ","[a] wonderfully loopy tale of love , longing , and voting . ","the fascination comes in the power of the huston performance , which seems so larger than life and yet so fragile , and in the way the ivan character accepts the news of his illness so quickly but still finds himself unable to react . ","the last scenes of the film are anguished , bitter and truthful . mr . koshashvili is a director to watch . ","predictable storyline and by-the-book scripting is all but washed away by sumptuous ocean visuals and the cinematic stylings of director john stockwell . ","antwone fisher certainly does the trick of making us care about its protagonist and celebrate his victories but , with few exceptions , it rarely stoops to cheap manipulation or corny conventions to do it . ","one feels the dimming of a certain ambition , but in its place a sweetness , clarity and emotional openness that recalls the classics of early italian neorealism . ","it challenges , this nervy oddity , like modern art should . ","whenever you think you've figured out late marriage , it throws you for a loop . ","the pianist is polanski's best film . ","it is a testament of quiet endurance , of common concern , of reconciled survival . ","this orange has some juice , but it's far from fresh-squeezed . ","a sensitive , modest comic tragedy that works as both character study and symbolic examination of the huge economic changes sweeping modern china . ","highly engaging . ","high crimes knows the mistakes that bad movies make and is determined not to make them , and maybe that is nobility of a sort . ","cusack's just brilliant in this . ","knows how to make our imagination wonder . ","jae-eun jeong's take care of my cat brings a beguiling freshness to a coming-of-age story with such a buoyant , expressive flow of images that it emerges as another key contribution to the flowering of the south korean cinema . ","the overall fabric is hypnotic , and mr . mattei fosters moments of spontaneous intimacy . ","evokes a palpable sense of disconnection , made all the more poignant by the incessant use of cell phones . ","malcolm mcdowell is cool . paul bettany is cool . paul bettany playing malcolm mcdowell ? cool . ","a touching , sophisticated film that almost seems like a documentary in the way it captures an italian immigrant family on the brink of major changes . "," . . . a trashy little bit of fluff stuffed with enjoyable performances and a bewildering sense of self-importance","an inventive , absorbing movie that's as hard to classify as it is hard to resist . ","it made me want to get made-up and go see this movie with my sisters . i thought the relationships were wonderful , the comedy was funny , and the love 'real' . "," ( caine ) proves once again he hasn't lost his touch , bringing off a superb performance in an admittedly middling film . ","bogdanovich puts history in perspective and , via kirsten dunst's remarkable performance , he showcases davies as a young woman of great charm , generosity and diplomacy . ","this breezy caper movie becomes a soulful , incisive meditation on the way we were , and the way we are . ","a captivating new film . ","those who aren't put off by the film's austerity will find it more than capable of rewarding them . ","it's a clear-eyed portrait of an intensely lived time , filled with nervous energy , moral ambiguity and great uncertainties . ","reveals how important our special talents can be when put in service of of others . it also shows how deeply felt emotions can draw people together across the walls that might otherwise separate them . ","with the same sort of good-natured fun found in films like tremors , eight legged freaks is prime escapist fare . ","a sharp , amusing study of the cult of celebrity . ","the sentimental cliches mar an otherwise excellent film . a powerful performance from mel gibson and a brutal 90-minute battle sequence that does everything but issue you a dog-tag and an m-16 . ","a graceful , moving tribute to the courage of new york's finest and a nicely understated expression of the grief shared by the nation at their sacrifice . ","a coming-of-age tale from new zealand whose boozy , languid air is balanced by a rich visual clarity and deeply felt performances across the board . ","made to be jaglomized is the cannes film festival , the annual riviera spree of flesh , buzz , blab and money . the charming result is festival in cannes . ","if you're looking for something new and hoping for something entertaining , you're in luck . ","a hugely rewarding experience that's every bit as enlightening , insightful and entertaining as grant's two best films -- four weddings and a funeral and bridget jones's diary . ","a rip-roaring comedy action fest that'll put hairs on your chest . ","if there's no art here , it's still a good yarn -- which is nothing to sneeze at these days . ","simultaneously heart-breaking and very funny , the last kiss is really all about performances . ","there is a subversive element to this disney cartoon , providing unexpected fizzability . ","an unforgettable look at morality , family , and social expectation through the prism of that omnibus tradition called marriage . ","an enjoyable , if occasionally flawed , experiment . ","miyazaki is one of world cinema's most wondrously gifted artists and storytellers . ","if ayurveda can help us return to a sane regimen of eating , sleeping and stress-reducing contemplation , it is clearly a good thing . ","meeting , even exceeding expectations , it's the best sequel since the empire strikes back . . . a majestic achievement , an epic of astonishing grandeur and surprising emotional depth . ","leigh is one of the rare directors who feels acting is the heart and soul of cinema . he allows his cast members to make creative contributions to the story and dialogue . this method almost never fails him , and it works superbly here . ","poetry in motion captured on film . while it can be a bit repetitive , overall it's an entertaining and informative documentary . ","directing with a sure and measured hand , [haneke] steers clear of the sensational and offers instead an unflinching and objective look at a decidedly perverse pathology . ","the entire movie establishes a wonderfully creepy mood . ","i found the ring moderately absorbing , largely for its elegantly colorful look and sound . ","the filmmakers want nothing else than to show us a good time , and in their cheap , b movie way , they succeed . ","amari has dressed up this little parable in a fairly irresistible package full of privileged moments and memorable performances . ","rabbit-proof fence will probably make you angry . but it will just as likely make you weep , and it will do so in a way that doesn't make you feel like a sucker . ","both heartbreaking and heartwarming . . . just a simple fable done in an artless sytle , but it's tremendously moving . ","this masterfully calibrated psychological thriller thrives on its taut performances and creepy atmosphere even if the screenplay falls somewhat short . ","the film's sense of imagery gives it a terrible strength , but it's propelled by the acting . ","the pianist [is] a supremely hopeful cautionary tale of war's madness remembered that we , today , can prevent its tragic waste of life . here is a divine monument to a single man's struggle to regain his life , his dignity and his music . ","strange it is , but delightfully so . ","elegant , mannered and teasing . ","an average coming-of-age tale elevated by the wholesome twist of a pesky mother interfering during her son's discovery of his homosexuality . ","the ingenuity that parker displays in freshening the play is almost in a class with that of wilde himself . ","decasia is what has happened already to so many silent movies , newsreels and the like . the unexpected thing is that its dying , in this shower of black-and-white psychedelia , is quite beautiful . ","a droll , bitchy frolic which pokes fun at the price of popularity and small-town pretension in the lone star state . ","with each of her three protagonists , miller eloquently captures the moment when a woman's life , out of a deep-seated , emotional need , is about to turn onto a different path . ","ryan gosling . . . is at 22 a powerful young actor . ","a minor work yet there's no denying the potency of miller's strange , fleeting brew of hopeful perseverance and hopeless closure . ","as an introduction to the man's theories and influence , derrida is all but useless ; as a portrait of the artist as an endlessly inquisitive old man , however , it's invaluable . ","the film is a verbal duel between two gifted performers . ","imperfect ? yes , but also intriguing and honorable , a worthwhile addition to a distinguished film legacy . ","you'll get the enjoyable basic minimum . but not a whit more . ","what a great way to spend 4 units of your day . ","the movie is hardly a masterpiece , but it does mark ms . bullock's best work in some time . ","as simple and innocent a movie as you can imagine . this is a movie you can trust . ","passionate , irrational , long-suffering but cruel as a tarantula , helga figures prominently in this movie , and helps keep the proceedings as funny for grown-ups as for rugrats . ","  it's all about the image .  ","feral and uncomfortable . ","vividly conveys the passion , creativity , and fearlessness of one of mexico's most colorful and controversial artists -- a captivating drama that will speak to the nonconformist in us all . ","hollywood ending is not show-stoppingly hilarious , but scathingly witty nonetheless . ","maybe thomas wolfe was right : you can't go home again . ","a compelling yarn , but not quite a ripping one . ","on the granger movie gauge of 1 to 10 , the powerpuff girls is a fast , frenetic , funny , even punny 6 -- aimed specifically at a grade-school audience . ","the film has several strong performances . ","i've never bought from telemarketers , but i bought this movie . ","perfectly pitched between comedy and tragedy , hope and despair , about schmidt instead comes far closer than many movies to expressing the way many of us live -- someplace between consuming self-absorption and insistently demanding otherness . ","the funny thing is , i didn't mind all this contrived nonsense a bit . ","[shyamalan] turns the goose-pimple genre on its empty head and fills it with spirit , purpose and emotionally bruised characters who add up to more than body count . ","a sexy , peculiar and always entertaining costume drama set in renaissance spain , and the fact that it's based on true events somehow makes it all the more compelling . ","an entertaining documentary that freshly considers arguments the bard's immortal plays were written by somebody else . ","a highly spirited , imaginative kid's movie that broaches neo-augustinian theology : is god stuck in heaven because he's afraid of his best-known creation ? ","call it magic realism or surrealism , but miss wonton floats beyond reality with a certain degree of wit and dignity . ","raimi and his team couldn't have done any better in bringing the story of spider-man to the big screen . ","the director explores all three sides of his story with a sensitivity and an inquisitiveness reminiscent of truffaut . ","well-acted , well-directed and , for all its moodiness , not too pretentious . ","it's a satisfying summer blockbuster and worth a look . ","boomers and their kids will have a barrie good time . ","real women have curves wears its empowerment on its sleeve but even its worst harangues are easy to swallow thanks to remarkable performances by ferrera and ontiveros . ","ultimately ,  mib ii  succeeds due to its rapid-fire delivery and enough inspired levity that it can't be dismissed as mindless . ","stage director sam mendes showcases tom hanks as a depression era hit-man in this dark tale of revenge . ","sitting in the third row of the imax cinema at sydney's darling harbour , but i sometimes felt as though i was in the tiny two seater plane that carried the giant camera around australia , sweeping and gliding , banking and hovering over some of the most not","the real charm of this trifle is the deadpan comic face of its star , jean reno , who resembles sly stallone in a hot sake half-sleep . ","what's so fun about this silly , outrageous , ingenious thriller is the director's talent . watching a brian depalma movie is like watching an alfred hitchcock movie after drinking twelve beers . ","strip it of all its excess debris , and you'd have a 90-minute , four-star movie . as it is , it's too long and unfocused . ","an immensely entertaining look at some of the unsung heroes of 20th century pop music . ","this familiar rise-and-fall tale is long on glamour and short on larger moralistic consequences , though it's told with sharp ears and eyes for the tenor of the times . ","this beautifully animated epic is never dull . ","brian tufano's handsome widescreen photography and paul grabowsky's excellent music turn this fairly parochial melodrama into something really rather special . ","it makes compelling , provocative and prescient viewing . ","a thoroughly entertaining comedy that uses grant's own twist of acidity to prevent itself from succumbing to its own bathos . ","using a stock plot , about a boy injects just enough freshness into the proceedings to provide an enjoyable 100 minutes in a movie theater . ","what eric schaeffer has accomplished with never again may not , strictly speaking , qualify as revolutionary . but it's defiantly and delightfully against the grain . ","the hard-to-predict and absolutely essential chemistry between the down-to-earth bullock and the nonchalant grant proves to be sensational , and everything meshes in this elegant entertainment . ","a positively thrilling combination of ethnography and all the intrigue , betrayal , deceit and murder of a shakespearean tragedy or a juicy soap opera . ","mr . clooney , mr . kaufman and all their collaborators are entitled to take a deep bow for fashioning an engrossing entertainment out of an almost sure-fire prescription for a critical and commercial disaster . ","definitely funny stuff , but it's more of the 'laughing at' variety than the 'laughing with . '","easily the most thoughtful fictional examination of the root causes of anti-semitism ever seen on screen . ","a gripping drama . ","a real winner -- smart , funny , subtle , and resonant . ","family portrait of need , neurosis and nervy negativity is a rare treat that shows the promise of digital filmmaking . ","the pitch must have read like a discarded house beautiful spread . ","uplifting as only a document of the worst possibilities of mankind can be , and among the best films of the year . ","director david jacobson gives dahmer a consideration that the murderer never game his victims . ","the film has a terrific look and salma hayek has a feel for the character at all stages of her life . ","a decided lack of spontaneity in its execution and a dearth of real poignancy in its epiphanies . ","the performances are remarkable . ","it's burns' visuals , characters and his punchy dialogue , not his plot , that carry waydowntown . ","as literary desecrations go , this makes for perfectly acceptable , occasionally very enjoyable children's entertainment . you'll forget about it by monday , though , and if they're old enough to have developed some taste , so will your kids . ","while i can't say it's on par with the first one , stuart little 2 is a light , fun cheese puff of a movie . ","strange , funny , twisted , brilliant and macabre . ","a genuinely moving and wisely unsentimental drama . ","heaven is a haunting dramatization of a couple's moral ascension . ","the mothman prophecies is best when illustrating the demons bedevilling the modern masculine journey . ","'stock up on silver bullets for director neil marshall's intense freight train of a film . '","plays out with a dogged and eventually winning squareness that would make it the darling of many a kids-and-family-oriented cable channel . ","an entertaining british hybrid of comedy , caper thrills and quirky romance . ","alain choquart's camera barely stops moving , portraying both the turmoil of the time and giving conduct a perpetual sense of urgency , which , for a film that takes nearly three hours to unspool , is both funny and irritating . ","mostly martha could have used a little trimming -- 10 or 15 minutes could be cut and no one would notice -- but it's a pleasurable trifle . the only pain you'll feel as the credits roll is your stomach grumbling for some tasty grub . ","hardly an objective documentary , but it's great cinematic polemic . . . love moore or loathe him , you've got to admire . . . the intensity with which he's willing to express his convictions . ","the mark of a respectable summer blockbuster is one of two things : unadulterated thrills or genuine laughs . ","the film is visually dazzling , the depicted events dramatic , funny and poignant . ","a directorial tour de force by bernard rose , ivans xtc . is one of this year's very best pictures . ","what makes the movie work — to an admittedly limited extent — is the commitment of two genuinely engaging performers . weaver and lapaglia are both excellent , in the kind of low-key way that allows us to forget that they are actually movie folk . ","even the digressions are funny . ","mr . spielberg and his company just want you to enjoy yourselves without feeling conned . and they succeed merrily at their noble endeavor . ","melodrama with a message . ","en sí mismo el rey león es un espectáculo digno de contemplarse en cine , dvd o en su soberbio montaje teatral ; pero el hacerlo en la pantalla imax es una experiencia colosal . ","a perfectly pleasant if slightly pokey comedy . ","coppola's directorial debut is an incredibly layered and stylistic film that , despite a fairly slow paced , almost humdrum approach to character development , still manages at least a decent attempt at meaningful cinema . ","at the end , when the now computerized yoda finally reveals his martial artistry , the film ascends to a kinetic life so teeming that even cranky adults may rediscover the quivering kid inside . ","wang xiaoshuai directs this intricately structured and well-realized drama that presents a fascinating glimpse of urban life and the class warfare that embroils two young men . ","it's hard to imagine anybody ever being  in the mood  to view a movie as harrowing and painful as the grey zone , but it's equally hard to imagine anybody being able to tear their eyes away from the screen once it's started . ","bogdanovich taps deep into the hearst mystique , entertainingly reenacting a historic scandal . ","a moving tale of love and destruction in unexpected places , unexamined lives . ","clooney directs this film always keeping the balance between the fantastic and the believable . . . ","beautifully produced . ","smart and taut . ","even if you don't understand what on earth is going on , this is a movie that will stimulate hours of post viewing discussion , if only to be reminded of who did what to whom and why . "," . . . a lesson in prehistoric hilarity . ","a fantastically vital movie that manages to invest real humor , sensuality , and sympathy into a story about two adolescent boys . ","lawrence plumbs personal tragedy and also the human comedy . ","though a capable thriller , somewhere along the way k-19 jettisoned some crucial drama . ","just about the surest bet for an all-around good time at the movies this summer . ","it would be disingenuous to call reno a great film , but you can say that about most of the flicks moving in and out of the multiplex . this is a movie that is what it is : a pleasant distraction , a friday night diversion , an excuse to eat popcorn . ","os universos de chuck barris e charlie kaufman são complementares . e igualmente fascinantes . ","there is a certain sense of experimentation and improvisation to this film that may not always work , but it is nevertheless compelling . ","the four feathers has rewards , from the exoticism of its seas of sand to the fierce grandeur of its sweeping battle scenes . ","a delicious , quirky movie with a terrific screenplay and fanciful direction by michael gondry . ","this story still seems timely and important . and there's an element of heartbreak to watching it now , with older and wiser eyes , because we know what will happen after greene's story ends . ","the bodily function jokes are about what you'd expect , but there are rich veins of funny stuff in this movie . ","the performances are amiable and committed , and the comedy more often than not hits the bullseye . ","this time , the hype is quieter , and while the movie is slightly less successful than the first , it's still a rollicking good time for the most part . ","there's plenty to enjoy -- in no small part thanks to lau . ","with a romantic comedy plotline straight from the ages , this cinderella story doesn't have a single surprise up its sleeve . but it does somehow manage to get you under its spell . ","though few will argue that it ranks with the best of herzog's works , invincible shows he's back in form , with an astoundingly rich film . ","  catch me  feels capable of charming the masses with star power , a pop-induced score and sentimental moments that have become a spielberg trademark . ","by no means a great movie , but it is a refreshingly forthright one . ","the casting of raymond j . barry as the 'assassin' greatly enhances the quality of neil burger's impressive fake documentary . ","despite besson's high-profile name being wasabi's big selling point , there is no doubt that krawczyk deserves a huge amount of the credit for the film's thoroughly winning tone . ","this documentary is a dazzling , remarkably unpretentious reminder of what [evans] had , lost , and got back . ","a thoughtful movie , a movie that is concerned with souls and risk and schemes and the consequences of one's actions . ","as satisfyingly odd and intriguing a tale as it was a century and a half ago . . . has a delightfully dour , deadpan tone and stylistic consistency . ","methodical , measured , and gently tedious in its comedy , secret ballot is a purposefully reductive movie -- which may be why it's so successful at lodging itself in the brain . ","a witty , trenchant , wildly unsentimental but flawed look at the ins and outs of modern moviemaking . ","for most of the distance the picture provides a satisfyingly unsettling ride into the dark places of our national psyche . ","by the standards of knucklehead swill , the hot chick is pretty damned funny . ","one of the most gloriously unsubtle and adrenalized extreme shockers since the evil dead . ","[reaches] wholly believable and heart-wrenching depths of despair . ","an absorbing and unsettling psychological drama . ","this movie may not have the highest production values you've ever seen , but it's the work of an artist , one whose view of america , history and the awkwardness of human life is generous and deep . ","though it's not very well shot or composed or edited , the score is too insistent and the dialogue is frequently overwrought and crudely literal , the film shatters you in waves . ","the entire cast is extraordinarily good . ","yakusho , as always , is wonderful as the long-faced sad sack . . . and his chemistry with shimizu is very believable . ","the film delivers what it promises : a look at the  wild ride  that ensues when brash young men set out to conquer the online world with laptops , cell phones and sketchy business plans . ","young hanks and fisk , who vaguely resemble their celebrity parents , bring fresh good looks and an ease in front of the camera to the work . ","a captivatingly quirky hybrid of character portrait , romantic comedy and beat-the-clock thriller . ","the film sparkles with the the wisdom and humor of its subjects . ","if [jaglom's] latest effort is not the director at his most sparkling , some of its repartee is still worth hearing . ","like the english patient and the unbearable lightness of being , the hours is one of those reputedly  unfilmable  novels that has bucked the odds to emerge as an exquisite motion picture in its own right . ","just about the best straight-up , old-school horror film of the last 15 years . ","a chilling tale of one of the great crimes of 20th century france : the murder of two rich women by their servants in 1933 . ","an oddity , to be sure , but one that you might wind up remembering with a degree of affection rather than revulsion . ","while the film is not entirely successful , it still manages to string together enough charming moments to work . ","a winning piece of work filled with love for the movies of the 1960s . ","e . t . works because its flabbergasting principals , 14-year-old robert macnaughton , 6-year-old drew barrymore and 10-year-old henry thomas , convince us of the existence of the wise , wizened visitor from a faraway planet . ","helps to remind the first world that hiv/aids is far from being yesterday's news . ","a heartening tale of small victories and enduring hope . ","the vistas are sweeping and the acting is far from painful . ","jackson and co have brought back the value and respect for the term epic cinema . ","it may be a somewhat backhanded compliment to say that the film makes the viewer feel like the movie's various victimized audience members after a while , but it also happens to be the movie's most admirable quality","charlotte sometimes is a brilliant movie . it is about irrational , unexplainable life and it seems so real because it does not attempt to filter out the complexity . ","a delightful stimulus for the optic nerves , so much that it's forgivable that the plot feels like every other tale of a totalitarian tomorrow . ","defies logic , the laws of physics and almost anyone's willingness to believe in it . but darned if it doesn't also keep us riveted to our seats . ","a complex psychological drama about a father who returns to his son's home after decades away . ","writer and director otar iosseliani's pleasant tale about a factory worker who escapes for a holiday in venice reveals how we all need a playful respite from the grind to refresh our souls . ","this is not a retread of  dead poets' society .  ","sweet and memorable film . ","a smart , arch and rather cold-blooded comedy . ","keenly observed and refreshingly natural , swimming gets the details right , from its promenade of barely clad bodies in myrtle beach , s . c . , to the adrenaline jolt of a sudden lunch rush at the diner . ","highly watchable stuff . "," . . . begins on a high note and sustains it beautifully . ","davis . . . gets vivid performances from her cast and pulls off some deft ally mcbeal-style fantasy sequences . ","'it's better to go in knowing full well what's going to happen , but willing to let the earnestness of its execution and skill of its cast take you down a familiar road with a few twists . cynics need not apply . '","funny , somber , absurd , and , finally , achingly sad , bartleby is a fine , understated piece of filmmaking . ","  red dragon  is entertaining . an obvious copy of one of the best films ever made , how could it not be ? but it is entertaining on an inferior level . it is a popcorn film , not a must-own , or even a must-see . ","succeeds only because bullock and grant were made to share the silver screen . ","both flawed and delayed , martin scorcese's gangs of new york still emerges as his most vital work since goodfellas . ","as any creature-feature fan knows , when you cross toxic chemicals with a bunch of exotic creatures , you get a lot of running around , screaming and death . on that score , the film certainly doesn't disappoint . ","as the movie traces mr . brown's athletic exploits , it is impossible not to be awed by the power and grace of one of the greatest natural sportsmen of modern times . ","a moving and solidly entertaining comedy/drama that should bolster director and co-writer juan josé campanella's reputation in the united states . ","thanks to confident filmmaking and a pair of fascinating performances , the way to that destination is a really special walk in the woods . ","beautifully shot , delicately scored and powered by a set of heartfelt performances , it's a lyrical endeavour . ","a macabre and very stylized swedish fillm about a modern city where all the religious and civic virtues that hold society in place are in tatters . ","a stylistic romp that's always fun to watch . ","informative , intriguing , observant , often touching . . . gives a human face to what's often discussed in purely abstract terms . "," . . . once the true impact of the day unfolds , the power of this movie is undeniable . ","an honest , sensitive story from a vietnamese point of view . "," a buoyant romantic comedy about friendship , love , and the truth that we're all in this together . ","the film's intimate camera work and searing performances pull us deep into the girls' confusion and pain as they struggle tragically to comprehend the chasm of knowledge that's opened between them . ","it's the perfect star vehicle for grant , allowing him to finally move away from his usual bumbling , tongue-tied screen persona . ","gaunt , silver-haired and leonine , [harris] brings a tragic dimension and savage full-bodied wit and cunning to the aging sandeman . ","a disturbing examination of what appears to be the definition of a 'bad' police shooting . ","it's been made with an innocent yet fervid conviction that our hollywood has all but lost . ","not only a reminder of how they used to make movies , but also how they sometimes still can be made . ","a three-hour cinema master class . ","eyre is on his way to becoming the american indian spike lee . ","psychologically revealing . ","a witty , whimsical feature debut . ","warm in its loving yet unforgivingly inconsistent depiction of everyday people , relaxed in its perfect quiet pace and proud in its message . i loved this film . ","it provides a grim , upsetting glimpse at the lives of some of the 1 . 2 million palestinians who live in the crowded cities and refugee camps of gaza . ","clint eastwood's blood work is a lot like a well-made pb& j sandwich : familiar , fairly uneventful and boasting no real surprises – but still quite tasty and inviting all the same . ","a movie that will surely be profane , politically charged music to the ears of cho's fans . ","much of this slick and sprightly cgi feature is sufficiently funny to amuse even the most resolutely unreligious parents who escort their little ones to megaplex screenings . ","rarely , a movie is more than a movie . go . ","jacquot's strategy allows his cast the benefit of being able to give full performances . . . while demonstrating vividly that the beauty and power of the opera reside primarily in the music itself . ","quitting delivers a sucker-punch , and its impact is all the greater beause director zhang's last film , the cuddly shower , was a non-threatening multi-character piece centered around a public bath house . ","by not averting his eyes , solondz forces us to consider the unthinkable , the unacceptable , the unmentionable . ","one hour photo may seem disappointing in its generalities , but it's the little nuances that perhaps had to escape from director mark romanek's self-conscious scrutiny to happen , that finally get under your skin . ","while general audiences might not come away with a greater knowledge of the facts of cuban music , they'll be treated to an impressive and highly entertaining celebration of its sounds . ","a fascinating documentary that provides a rounded and revealing overview of this ancient holistic healing system","birthday girl lucks out with chaplin and kidman , who are capable of anteing up some movie star charisma when they need it to sell us on this twisted love story , but who can also negotiate the movie's darker turns . ","an interesting look behind the scenes of chicago-based rock group wilco . . . ","sharp edges and a deep vein of sadness run through its otherwise comic narrative . ","there's lots of cool stuff packed into espn's ultimate x . ","rock solid family fun out of the gates , extremely imaginative through out , but wanes in the middle","as a film director , labute continues to improve . ","the ya-ya's have many secrets and one is - the books are better . translating complex characters from novels to the big screen is an impossible task but they are true to the essence of what it is to be ya-ya . ","the touch is generally light enough and the performances , for the most part , credible . ","i liked about schmidt a lot , but i have a feeling that i would have liked it much more if harry & tonto never existed . ","steers has an unexpectedly adamant streak of warm-blooded empathy for all his disparate manhattan denizens--especially the a * * holes . ","that storytelling has value cannot be denied . not even solondz's thirst for controversy , sketchy characters and immature provocations can fully succeed at cheapening it . ","once the downward spiral comes to pass , auto focus bears out as your typical junkie opera . . . ","a knowing sense of humor and a lot of warmth ignite son of the bride . ","a rich tale of our times , very well told with an appropriate minimum of means . ","the characters are complex and quirky , but entirely believable as the remarkable ensemble cast brings them to life . ","in all fairness , i must report that the children of varying ages in my audience never coughed , fidgeted or romped up and down the aisles for bathroom breaks . ","as gory as the scenes of torture and self-mutilation may be , they are pitted against shimmering cinematography that lends the setting the ethereal beauty of an asian landscape painting . ","efficient , suitably anonymous chiller . ","gorgeous scenes , masterful performances , but the sickly sweet gender normative narrative left an acrid test in this gourmet's mouth . ","the hot topics of the plot are relegated to the background -- a welcome step forward from the sally jesse raphael atmosphere of films like philadelphia and american beauty . ","it's usually a bad sign when directors abandon their scripts and go where the moment takes them , but olympia , wash . , based filmmakers anne de marcken and marilyn freeman did just that and it's what makes their project so interesting . ","a memorable experience that , like many of his works , presents weighty issues colorfully wrapped up in his own idiosyncratic strain of kitschy goodwill . ","executed with such gentle but insistent sincerity , with such good humor and appreciation of the daily grind that only the most hardhearted scrooge could fail to respond . ","the gentle comic treatment of adolescent sturm und drang should please fans of chris fuhrman's posthumously published cult novel . ","director claude chabrol has become the master of innuendo . it is not what you see , it is what you think you see . ","a deftly entertaining film , smartly played and smartly directed . ","a documentary to make the stones weep -- as shameful as it is scary . ","i hope the movie is widely seen and debated with appropriate ferocity and thoughtfulness . "," a thought-provoking look at how western foreign policy - however well intentioned - can wreak havoc in other cultures . ","asks what truth can be discerned from non-firsthand experience , and specifically questions cinema's capability for recording truth . ","the journey to the secret's eventual discovery is a separate adventure , and thrill enough . ","a quiet , disquieting triumph . ","darkly funny and frequently insightful . "," . . . the tale of her passionate , tumultuous affair with musset unfolds as sand's masculine persona , with its love of life and beauty , takes form . ","if you want to see a train wreck that you can't look away from , then look no further , because here it is . ","there's so much to look at in metropolis you hate to tear your eyes away from the images long enough to read the subtitles . ","the search for redemption makes for a touching love story , mainly because blanchett and ribisi compellingly tap into a spiritual aspect of their characters' suffering . ","a fast paced and suspenseful argentinian thriller about the shadow side of play . ","a film of ideas and wry comic mayhem . ","at its worst the screenplay is callow , but at its best it is a young artist's thoughtful consideration of fatherhood . ","a worthwhile documentary , whether you're into rap or not , even if it may still leave you wanting more answers as the credits roll . ","fessenden's narrative is just as much about the ownership and redefinition of myth as it is about a domestic unit finding their way to joy . ","that the film opens with maggots crawling on a dead dog is not an out of place metaphor . ","stanley kwan has directed not only one of the best gay love stories ever made , but one of the best love stories of any stripe . ","the concert footage is stirring , the recording sessions are intriguing , and -- on the way to striking a blow for artistic integrity -- this quality band may pick up new admirers . ","norton holds the film together . ","[there's] quite a bit of heart , as you would expect from the directors of the little mermaid and aladdin . ","you won't have any trouble getting kids to eat up these veggies . ","a creaky staircase gothic . ","enjoyably dumb , sweet , and intermittently hilarious -- if you've a taste for the quirky , steal a glimpse . ","a movie that sends you out of the theater feeling like you've actually spent time living in another community . ","light-years ahead of paint-by-number american blockbusters like pearl harbor , at least artistically . ","a fascinating documentary about the long and eventful spiritual journey of the guru who helped launch the new age . ","isabelle huppert excels as the enigmatic mika and anna mouglalis is a stunning new young talent in one of chabrol's most intense psychological mysteries . ","perhaps not since nelson eddy crooned his indian love call to jeanette macdonald has there been a movie so unabashedly canadian , not afraid to risk american scorn or disinterest . ","wedding feels a bit anachronistic . still , not every low-budget movie must be quirky or bleak , and a happy ending is no cinematic sin . ","it's still a comic book , but maguire makes it a comic book with soul . ","brings to a spectacular completion one of the most complex , generous and subversive artworks of the last decade . ","an amusing and unexpectedly insightful examination of sexual jealousy , resentment and the fine line between passion and pretence . ","a fascinating , bombshell documentary that should shame americans , regardless of whether or not ultimate blame finally lies with kissinger . should be required viewing for civics classes and would-be public servants alike . ","adaptation's success in engaging the audience in the travails of creating a screenplay is extraordinary . ","a polished and vastly entertaining caper film that puts the sting back into the con . ","it's no surprise that as a director washington demands and receives excellent performances , from himself and from newcomer derek luke . "," . . . while each moment of this broken character study is rich in emotional texture , the journey doesn't really go anywhere . ","the film gets close to the chimps the same way goodall did , with a serious minded patience , respect and affection . ","it's an often-cute film but either needs more substance to fill the time or some judicious editing . ","this may be burns's strongest film since the brothers mcmullen . ","what makes this film special is serry's ability to take what is essentially a contained family conflict and put it into a much larger historical context . ","it's quaid who anchors the film with his effortless performance and that trademark grin of his -- so perfect for a ballplayer . ","it is ok for a movie to be something of a sitcom apparatus , if the lines work , the humor has point and the actors are humanly engaged . ","though not for everyone , the guys is a somber trip worth taking . ","will warm your heart without making you feel guilty about it . ","a sly female empowerment movie , although not in a way anyone would expect . ","you really have to salute writer-director haneke ( he adapted elfriede jelinek's novel ) for making a film that isn't nearly as graphic but much more powerful , brutally shocking and difficult to watch . ","it's a wonderful , sobering , heart-felt drama . ","runs on the pure adrenalin of pacino's performance . ","the paradiso's rusted-out ruin and ultimate collapse during the film's final ( restored ) third…emotionally belittle a cinema classic . sometimes shorter is better . ","phillip noyce and all of his actors -- as well as his cinematographer , christopher doyle -- understand the delicate forcefulness of greene's prose , and it's there on the screen in their version of the quiet american . ","the film just might turn on many people to opera , in general , an art form at once visceral and spiritual , wonderfully vulgar and sublimely lofty -- and as emotionally grand as life . ","as a vehicle to savour binoche's skill , the film is well worthwhile . "," . . . wise and elegiac . . . ","the huskies are beautiful , the border collie is funny and the overall feeling is genial and decent . ","whatever complaints i might have , i'd take [its] earnest errors and hard-won rewards over the bombastic self-glorification of other feel-good fiascos like antwone fisher or the emperor's club any time . ","mastering its formidable arithmetic of cameras and souls , group articulates a flood of emotion . ","a pretty decent kid-pleasing , tolerable-to-adults lark of a movie . ","even during the climactic hourlong cricket match , boredom never takes hold . ","combine the paranoid claustrophobia of a submarine movie with the unsettling spookiness of the supernatural -- why didn't hollywood think of this sooner ? ","like kubrick , soderbergh isn't afraid to try any genre and to do it his own way . ","nothing can detract from the affection of that moral favorite : friends will be friends through thick and thin . ","if the film has a problem , its shortness disappoints : you want the story to go on and on . ","unlike most anime , whose most ardent fans outside japan seem to be introverted young men with fantasy fetishes , metropolis never seems hopelessly juvenile . ","the plot twists give i am trying to break your heart an attraction it desperately needed . ","the most brilliant and brutal uk crime film since jack carter went back to newcastle , the first half of gangster no . 1 drips with style and , at times , blood . ","like its new england characters , most of whom wander about in thick clouds of denial , the movie eventually gets around to its real emotional business , striking deep chords of sadness . ","the bai brothers have taken an small slice of history and opened it up for all of us to understand , and they've told a nice little story in the process . ","flamboyant in some movies and artfully restrained in others , 65-year-old jack nicholson could be looking at his 12th oscar nomination by proving that he's now , more than ever , choosing his roles with the precision of the insurance actuary . "," . . . is there a deeper , more direct connection between these women , one that spans time and reveals meaning ? you bet there is and it's what makes this rather convoluted journey worth taking . ","the most amazing super-sized dosage of goofball stunts any  jackass  fan could want . ","real women may have many agendas , but it also will win you over , in a big way . ","young everlyn sampi , as the courageous molly craig , simply radiates star-power potential in this remarkable and memorable film . ","surprisingly powerful and universal . ","apart from its own considerable achievement , metropolis confirms tezuka's status as both the primary visual influence on the animé tradition and its defining philosophical conscience . ","i'll put it this way : if you're in the mood for a melodrama narrated by talking fish , this is the movie for you . ","morvern callar confirms lynne ramsay as an important , original talent in international cinema . ","well-done supernatural thriller with keen insights into parapsychological phenomena and the soulful nuances of the grieving process . ","a plethora of engaging diatribes on the meaning of 'home , ' delivered in grand passion by the members of the various households . ","it's technically sumptuous but also almost wildly alive . ","this film puts wang at the forefront of china's sixth generation of film makers . ","it's refreshing to see a movie that embraces its old-fashioned themes and in the process comes out looking like something wholly original . ","wiseman is patient and uncompromising , letting his camera observe and record the lives of women torn apart by a legacy of abuse . ","there's none of the happily-ever -after spangle of monsoon wedding in late marriage -- and that's part of what makes dover kosashvili's outstanding feature debut so potent . ","an ingenious and often harrowing look at damaged people and how families can offer either despair or consolation . ","arguably the best script that besson has written in years . ","it's no lie -- big fat liar is a real charmer . ","invigorating , surreal , and resonant with a rainbow of emotion . ","director alfonso cuaron gets vivid , convincing performances from a fine cast , and generally keeps things going at a rapid pace , occasionally using an omniscient voice-over narrator in the manner of french new wave films . ","pray has really done his subject justice . ","an unexpectedly sweet story of sisterhood . ","maintains your sympathy for this otherwise challenging soul by letting you share her one-room world for a while . ","a subtle , humorous , illuminating study of politics , power and social mobility . ","even if you have no interest in the gang-infested , east-vs . -west coast rap wars , this modern mob music drama never fails to fascinate . ","nair's attention to detail creates an impeccable sense of place , while thurman and lewis give what can easily be considered career-best performances . ","berry's saucy , full-bodied performance gives this aging series a much needed kick , making  die another day  one of the most entertaining bonds in years","red dragon is less baroque and showy than hannibal , and less emotionally affecting than silence . but , like silence , it's a movie that gets under your skin . ","caviezel embodies the transformation of his character completely . ","a creepy , intermittently powerful study of a self-destructive man . . . about as unsettling to watch as an exploratory medical procedure or an autopsy . ","pacino and williams seem to keep upping the ante on each other , just as their characters do in the film . what results is the best performance from either in years . ","the cast is top-notch and i predict there will be plenty of female audience members drooling over michael idemoto as michael . ","béart and berling are both superb , while huppert . . . is magnificent . ","all the actors are good in pauline & paulette but van der groen , described as 'belgium's national treasure , ' is especially terrific as pauline . ","miyazaki has created such a vibrant , colorful world , it's almost impossible not to be swept away by the sheer beauty of his images . ","muccino seems to be exploring the idea of why human beings long for what they don't have , and how this gets us in trouble . but even while his characters are acting horribly , he is always sympathetic . ","whether or not you buy mr . broomfield's findings , the film acquires an undeniable entertainment value as the slight , pale mr . broomfield continues to force himself on people and into situations that would make lesser men run for cover . ","ozpetek joins the ranks of those gay filmmakers who have used the emigre experience to explore same-sex culture in ways that elude the more nationally settled . ","…an eerily suspenseful , deeply absorbing piece that works as a treatise on spirituality as well as a solid sci-fi thriller . ","i've never seen or heard anything quite like this film , and i recommend it for its originality alone . ","nicole kidman makes it a party worth attending . ","catch it . . . if you can ! ","the direction has a fluid , no-nonsense authority , and the performances by harris , phifer and cam'ron seal the deal . ","the komediant is a tale worth catching . ","the writing is clever and the cast is appealing . ","the simplicity of the way home has few equals this side of aesop","life on the rez is no picnic : this picture shows you why . ","spielberg has managed to marry science fiction with film noir and action flicks with philosophical inquiry . ","it's the type of film about growing up that we don't see often enough these days : realistic , urgent , and not sugarcoated in the least . ","a taut , sobering film . ","exudes the fizz of a busby berkeley musical and the visceral excitement of a sports extravaganza . ","it's full of cheesy dialogue , but great trashy fun that finally returns de palma to his pulpy thrillers of the early '80s . ","the results , if not memorable , are at least interesting . ","a quietly moving look back at what it was to be iranian-american in 1979 . ","like a veteran head cutter , barbershop is tuned in to its community . ","i'm sure mainstream audiences will be baffled , but , for those with at least a minimal appreciation of woolf and clarissa dalloway , the hours represents two of those well spent . ","you live the mood rather than savour the story . ","angela gheorghiu as famous prima donna floria tosca , roberto alagna as her lover mario cavaradossi , and ruggero as the villainous , lecherous police chief scarpia , all sing beautifully and act adequately . ","while there are times when the film's reach exceeds its grasp , the production works more often than it doesn't . ","while scorsese's bold images and generally smart casting ensure that  gangs  is never lethargic , the movie is hindered by a central plot that's peppered with false starts and populated by characters who are nearly impossible to care about . ","watching this gentle , mesmerizing portrait of a man coming to terms with time , you barely realize your mind is being blown . ","the beautifully choreographed kitchen ballet is simple but absorbing . ","there's . . . an underlying old world sexism to monday morning that undercuts its charm . ","  the best disney movie since the lion king  ","transcends its agenda to deliver awe-inspiring , at times sublime , visuals and offer a fascinating glimpse into the subculture of extreme athletes whose derring-do puts the x into the games . ","spare yet audacious . . . ","think of it as gidget , only with muscles and a lot more smarts , but just as endearing and easy to watch . ","there is no solace here , no entertainment value , merely a fierce lesson in where filmmaking can take us . ","giggling at the absurdities and inconsistencies is part of the fun . but the talented cast alone will keep you watching , as will the fight scenes . ","arteta paints a picture of lives lived in a state of quiet desperation . ","drug abuse , infidelity and death aren't usually comedy fare , but turpin's film allows us to chuckle through the angst . ","while insomnia is in many ways a conventional , even predictable remake , nolan's penetrating undercurrent of cerebral and cinemantic flair lends ( it ) stimulating depth . ","efteriades gives the neighborhood -- scenery , vibe and all -- the cinematic equivalent of a big , tender hug . ","this is a nicely handled affair , a film about human darkness but etched with a light ( yet unsentimental ) touch . ","amazing ! a college story that works even without vulgarity , sex scenes , and cussing ! ","the amazing film work is so convincing that by movies' end you'll swear you are wet in some places and feel sand creeping in others . ","a raunchy and frequently hilarious follow-up to the gifted korean american stand-up's i'm the one that i want . ","if you ever wanted to be an astronaut , this is the ultimate movie experience - it's informative and breathtakingly spectacular . ","while parker and co-writer catherine di napoli are faithful to melville's plotline , they and a fully engaged supporting cast . . . have made the old boy's characters more quick-witted than any english lit major would have thought possible . ","a smart , sassy and exceptionally charming romantic comedy . ","surprisingly insightful","there are flaws , but also stretches of impact and moments of awe ; we're wrapped up in the characters , how they make their choices , and why . ","a gift to anyone who loves both dance and cinema","it seems grant doesn't need the floppy hair and the self-deprecating stammers after all . ","a reminder that beyond all the hype and recent digital glitz , spielberg knows how to tell us about people . ","one of the finest , most humane and important holocaust movies ever made . ","an engrossing and infectiously enthusiastic documentary . ","a beautiful , timeless and universal tale of heated passions -- jealousy , betrayal , forgiveness and murder . ","a culture-clash comedy that , in addition to being very funny , captures some of the discomfort and embarrassment of being a bumbling american in europe . ","shattering , devastating documentary on two maladjusted teens in a downward narcotized spiral . extraordinary debut from josh koury . ","the most compelling performance of the year adds substantial depth to this shocking testament to anti-semitism and neo-fascism . ","for those who are intrigued by politics of the '70s , the film is every bit as fascinating as it is flawed . ","all right , so it's not a brilliant piece of filmmaking , but it is a funny ( sometimes hilarious ) comedy with a deft sense of humor about itself , a playful spirit and a game cast . ","douglas mcgrath's nicholas nickleby does dickens as it should be done cinematically . ","it's a lovely , eerie film that casts an odd , rapt spell . ","the quirky and recessive charms of co-stars martin donovan and mary-louise parker help overcome the problematic script . ","it's good to see michael caine whipping out the dirty words and punching people in the stomach again . ","you just know something terrible is going to happen . but when it does , you're entirely unprepared . ","it's fun , wispy , wise and surprisingly inoffensive for a film about a teen in love with his stepmom . ","able to provide insight into a fascinating part of theater history . ","an unflinching , complex portrait of a modern israel that is rarely seen on-screen . ","a jewish ww ii doc that isn't trying simply to out-shock , out-outrage or out-depress its potential audience ! who knew . . . ","it's a familiar story , but one that is presented with great sympathy and intelligence . ","gently humorous and touching . ","it won't hold up over the long haul , but in the moment , finch's tale provides the forgettable pleasures of a saturday matinee . ","kinnear's performance is a career-defining revelation . ","the film is predictable in the reassuring manner of a beautifully sung holiday carol . "," . . . hits every cliche we've come to expect , including the assumption that  crazy  people are innocent , childlike and inherently funny . ","the strong subject matter continues to shock throughout the film . not everyone will play the dark , challenging tune taught by the piano teacher . ","a certain sexiness underlines even the dullest tangents . ","you may be captivated , as i was , by its moods , and by its subtly transformed star , and still wonder why paul thomas anderson ever had the inclination to make the most sincere and artful movie in which adam sandler will probably ever appear . ","there is no substitute for on-screen chemistry , and when friel pulls the strings that make williams sink into melancholia , the reaction in williams is as visceral as a gut punch . ","that old adage about women being unknowable gets an exhilarating new interpretation in morvern callar . ","a mix of gritty realism , crisp storytelling and radiant compassion that effortlessly draws you in . ","after watching it , you can only love the players it brings to the fore for the gifted but no-nonsense human beings they are and for the still-inestimable contribution they have made to our shared history . ","in his u . s . debut , mr . schnitzler proves himself a deft pace master and stylist . ","ultimate x is a ride , basically the kind of greatest-hits reel that might come with a subscription to espn the magazine . ","rich in shadowy metaphor and as sharp as a samurai sword , jiang wen's devils on the doorstep is a wartime farce in the alternately comic and gut-wrenching style of joseph heller or kurt vonnegut . ","offers a clear-eyed chronicle of a female friendship that is more complex and honest than anything represented in a hollywood film . ","a winning comedy with its wry observations about long-lived friendships and the ways in which we all lose track of ourselves by trying to please others . ","its cast full of caffeinated comedy performances more than make up for its logical loopholes , which fly by so fast there's no time to think about them anyway . ","lohman adapts to the changes required of her , but the actress and director peter kosminsky never get the audience to break through the wall her character erects","although it includes a fair share of dumb drug jokes and predictable slapstick ,  orange county  is far funnier than it would seem to have any right to be . ","for a movie audience , the hours doesn't connect in a neat way , but introduces characters who illuminate mysteries of sex , duty and love . ","a bright , inventive , thoroughly winning flight of revisionist fancy . ","ozpetek's effort has the scope and shape of an especially well-executed television movie . ","graças às interações entre seus personagens , o filme torna-se não apenas uma história divertida sobre uma curiosa perseguição , mas também um belo estudo de personagens . ","affirms the gifts of all involved , starting with spielberg and going right through the ranks of the players -- on-camera and off -- that he brings together . ","a delightful little film that revels in its own simplicity , mostly martha will leave you with a smile on your face and a grumble in your stomach . ","makes one thing abundantly clear . american musical comedy as we know it wouldn't exist without the precedent of yiddish theater , whose jolly , fun-for-fun's-sake communal spirit goes to the essence of broadway . ","deepa mehta provides an accessible introduction as well as some intelligent observations on the success of bollywood in the western world . ","if anything , the film is doing something of a public service -- shedding light on a group of extremely talented musicians who might otherwise go unnoticed and underappreciated by music fans . ","in addition to gluing you to the edge of your seat , changing lanes is also a film of freshness , imagination and insight . ","pan nalin's exposition is beautiful and mysterious , and the interviews that follow , with the practitioners of this ancient indian practice , are as subtle and as enigmatic . ","the mood , look and tone of the film fit the incredible storyline to a t . ","it's crafty , energetic and smart -- the kid is sort of like a fourteen-year old ferris bueller . ","a work of extraordinary journalism , but it is also a work of deft and subtle poetry . ","it's funny and human and really pretty damned wonderful , all at once . ","at 78 minutes it just zings along with vibrance and warmth . ","a strangely stirring experience that finds warmth in the coldest environment and makes each crumb of emotional comfort feel like a 10-course banquet . ","sometimes this 'blood' seems as tired as its protagonist . . . still , the pulse never disappears entirely , and the picture crosses the finish line winded but still game . ","the stripped-down dramatic constructs , austere imagery and abstract characters are equal parts poetry and politics , obvious at times but evocative and heartfelt . ","dogtown and z-boys more than exposes the roots of the skateboarding boom that would become  the punk kids' revolution .  "," . . . plenty of warmth to go around , with music and laughter and the love of family . ","it'll keep you wide awake and . . . very tense . ","could use a little more humanity , but it never lacks in eye-popping visuals . "," ( danny huston gives ) an astounding performance that deftly , gradually reveals a real human soul buried beneath a spellbinding serpent's smirk . ","these three films form a remarkably cohesive whole , both visually and thematically , through their consistently sensitive and often exciting treatment of an ignored people . ","a funny and well-contructed black comedy where the old adage  be careful what you wish for  is given a full workout . ","it reaffirms life as it looks in the face of death . ","the film is reasonably entertaining , though it begins to drag two-thirds through , when the melodramatic aspects start to overtake the comedy . ","this is more fascinating -- being real -- than anything seen on jerry springer . ","a different movie -- sometimes tedious -- by a director many viewers would like to skip but film buffs should get to know . ","williams plays sy , another of his open-faced , smiling madmen , like the killer in insomnia . he does this so well you don't have the slightest difficulty accepting him in the role . ","twist open the ouzo ! it's time to let your hair down – greek style . a vibrant whirlwind of love , family and all that goes with it , my big fat greek wedding is a non-stop funny feast of warmth , colour and cringe . ","thought-provoking and stylish , if also somewhat hermetic . ","broomfield is energized by volletta wallace's maternal fury , her fearlessness , and because of that , his film crackles . ","while it has definite weaknesses -- like a rather unbelievable love interest and a meandering ending -- this '60s caper film is a riveting , brisk delight . ","funny in a sick , twisted sort of way . ","if cinema had been around to capture the chaos of france in the 1790's , one imagines the result would look like something like this . ","it's a talking head documentary , but a great one . ","the fast runner' transports the viewer into an unusual space","ultimately engages less for its story of actorly existential despair than for its boundary-hopping formal innovations and glimpse into another kind of chinese 'cultural revolution . '"," . . . a solid , well-formed satire . ","as part of mr . dong's continuing exploration of homosexuality in america , family fundamentals is an earnest study in despair . ","most consumers of lo mein and general tso's chicken barely give a thought to the folks who prepare and deliver it , so , hopefully , this film will attach a human face to all those little steaming cartons . ","hatosy . . . portrays young brendan with his usual intelligence and subtlety , not to mention a convincing brogue . ","the filmmakers' eye for detail and the high standards of performance convey a strong sense of the girls' environment . ","uneven , self-conscious but often hilarious spoof . ","even bigger and more ambitious than the first installment , spy kids 2 looks as if it were made by a highly gifted 12-year-old instead of a grown man . ","thanks to the château's balance of whimsicality , narrative discipline and serious improvisation , almost every relationship and personality in the film yields surprises . ","alan and his fellow survivors are idiosyncratic enough to lift the movie above its playwriting 101 premise . ","fresh and raw like a blown-out vein , narc takes a walking-dead , cop-flick subgenre and beats new life into it . ","the premise of jason x is silly but strangely believable . ","it's a wise and powerful tale of race and culture forcefully told , with superb performances throughout . ","an awfully good , achingly human picture . ","the cast comes through even when the movie doesn't . ","you'll laugh at either the obviousness of it all or its stupidity or maybe even its inventiveness , but the point is , you'll laugh . ","definitely worth 95 minutes of your time . ","the film jolts the laughs from the audience--as if by cattle prod . ","a sexy , surprising romance . . . idemoto and kim make a gorgeous pair . . . their scenes brim with sexual possibility and emotional danger . ","toes the fine line between cheese and earnestness remarkably well ; everything is delivered with such conviction that it's hard not to be carried away . ","whereas oliver stone's conspiracy thriller jfk was long , intricate , star-studded and visually flashy , interview with the assassin draws its considerable power from simplicity . ","funny , sexy , devastating and incurably romantic . ","triple x is a double agent , and he's one bad dude . when you've got the wildly popular vin diesel in the equation , it adds up to big box office bucks all but guaranteed . ","very well-written and very well-acted . ","a powerful and telling story that examines forbidden love , racial tension , and other issues that are as valid today as they were in the 1950s . ","you emerge dazed , confused as to whether you've seen pornography or documentary . ","it ain't art , by a long shot , but unlike last year's lame musketeer , this dumas adaptation entertains . ","likeable thanks to its cast , its cuisine and its quirky tunes . ","chilling in its objective portrait of dreary , lost twenty-first century america . ","highly recommended as an engrossing story about a horrifying historical event and the elements which contributed to it . "," . . . there's enough cool fun here to warm the hearts of animation enthusiasts of all ages . ","it manages to squeeze by on angelina jolie's surprising flair for self-deprecating comedy . ","secretary manages a neat trick , bundling the flowers of perversity , comedy and romance into a strangely tempting bouquet of a movie . ","judith and zaza's extended bedroom sequence . . . is so intimate and sensual and funny and psychologically self-revealing that it makes most of what passes for sex in the movies look like cheap hysterics . ","photographed with melancholy richness and eloquently performed yet also decidedly uncinematic . ","a knowing look at female friendship , spiked with raw urban humor . ","as i settled into my world war ii memories , i found myself strangely moved by even the corniest and most hackneyed contrivances . ","the overall effect is awe and affection -- and a strange urge to get on a board and , uh , shred , dude . ","it's that rare family movie -- genuine and sweet without relying on animation or dumb humor . ","the trinity assembly approaches the endeavor with a shocking lack of irony , and george ratliff's documentary , hell house , reflects their earnestness — which makes for a terrifying film . ","confessions may not be a straightforward bio , nor does it offer much in the way of barris' motivations , but the film is an oddly fascinating depiction of an architect of pop culture . ","an intoxicating experience . ","a special kind of movie , this melancholic film noir reminded me a lot of memento . . . ","simple , poignant and leavened with humor , it's a film that affirms the nourishing aspects of love and companionship . ","together , miller , kuras and the actresses make personal velocity into an intricate , intimate and intelligent journey . ","the wonder of mostly martha is the performance of gedeck , who makes martha enormously endearing . ","with notorious c . h . o . cho proves she has the stuff to stand tall with pryor , carlin and murphy . ","less front-loaded and more shapely than the two-hour version released here in 1990 . ","watching war photographer , you come to believe that nachtwey hates the wars he shows and empathizes with the victims he reveals . ","[a] real pleasure in its laid-back way . ","some may choose to interpret the film's end as hopeful or optimistic but i think payne is after something darker . ","though it runs 163 minutes , safe conduct is anything but languorous . it's packed to bursting with incident , and with scores of characters , some fictional , some from history . ","a much better documentary -- more revealing , more emotional and more surprising -- than its pedestrian english title would have you believe . ","notwithstanding my problem with the movie's final half hour , i'm going to recommend secretary , based on the wonderful acting clinic put on by spader and gyllenhaal , and also the unique way shainberg goes about telling what at heart is a sweet little girl-","a well-crafted film that is all the more remarkable because it achieves its emotional power and moments of revelation with restraint and a delicate ambiguity . ","the film has the uncanny ability to right itself precisely when you think it's in danger of going wrong . ","my big fat greek wedding is that rare animal known as 'a perfect family film , ' because it's about family . ","would make an excellent companion piece to the similarly themed 'the french lieutenant's woman . '"," . . . with the gifted pearce on hand to keep things on semi-stable ground dramatically , this retooled machine is ultimately effective enough at achieving the modest , crowd-pleasing goals it sets for itself . ","a movie that's just plain awful but still manages to entertain on a guilty-pleasure , so-bad-it's-funny level . ","a disoriented but occasionally disarming saga packed with moments out of an alice in wonderland adventure , a stalker thriller , and a condensed season of tv's big brother . ","functions as both a revealing look at the collaborative process and a timely , tongue-in-cheek profile of the corporate circus that is the recording industry in the current climate of mergers and downsizing . ","with a confrontational stance , todd solondz takes aim on political correctness and suburban families . ","a mess , but it's a sincere mess . ","this odd , distant portuguese import more or less borrows from bad lieutenant and les vampires , and comes up with a kind of art-house gay porn film . ","for a debut film , skin of man , heart of beast feels unusually assured . ","a photographic marvel of sorts , and it's certainly an invaluable record of that special fishy community . ","it's soulful and unslick , and that's apparently just what [aniston] has always needed to grow into a movie career . ","although olivier assayas' elegantly appointed period drama seems , at times , padded with incident in the way of a too-conscientious adaptation . . . its three-hour running time plays closer to two . ","a jaw-droppingly beautiful work that upends nearly every cliché of japanese animation while delivering a more than satisfactory amount of carnage . ","terry is a sort of geriatric dirty harry , which will please eastwood's loyal fans -- and suits the story , wherein our hero must ride roughshod over incompetent cops to get his man . ","parts seem like they were lifted from terry gilliam's subconscious , pressed through kafka's meat grinder and into buñuel's casings","'like a child with an important message to tell . . . [skins'] faults are easy to forgive because the intentions are lofty . '","a delightful entree in the tradition of food movies . ","an escapist confection that's pure entertainment . ","the ring is worth a look , if you don't demand much more than a few cheap thrills from your halloween entertainment . ","the movie ultimately relies a bit too heavily on grandstanding , emotional , rocky-like moments . . . but it's such a warm and charming package that you'll feel too happy to argue much . ","reassuring , retro uplifter . ","throwing it all away for the fleeting joys of love's brief moment . ","armed with a game supporting cast , from the pitch-perfect forster to the always hilarious meara and levy , like mike shoots and scores , doing its namesake proud . ","a decent-enough nail-biter that stands a good chance of being the big hit franklin needs to stay afloat in hollywood . ","begins like a docu-drama but builds its multi-character story with a flourish . ","one of the most genuinely sweet films to come along in quite some time . ","after an uncertain start , murder hits and generally sustains a higher plateau with bullock's memorable first interrogation of gosling . ","the story ultimately takes hold and grips hard . ","a bit of a downer and a little over-dramatic at times , but this is a beautiful film for people who like their romances to have that french realism . ","an emotionally strong and politically potent piece of cinema . ","enticing and often funny documentary . ","going to this movie is a little like chewing whale blubber - it's an acquired taste that takes time to enjoy , but it's worth it , even if it does take 3 hours to get through . ","a portrait of hell so shattering it's impossible to shake . ","almodovar is an imaginative teacher of emotional intelligence in this engaging film about two men who discover what william james once called 'the gift of tears . '","better than the tepid star trek : insurrection ; falls short of first contact because the villain couldn't pick the lint off borg queen alice krige's cape ; and finishes half a parsec ( a nose ) ahead of generations . ","at times a bit melodramatic and even a little dated ( depending upon where you live ) , ignorant fairies is still quite good-natured and not a bad way to spend an hour or two . ","tense , terrific , sweaty-palmed fun . ","majidi's direction has never been smoother or more confident . ","visually captivating . ","what a bewilderingly brilliant and entertaining movie this is . ","hard , endearing , caring , warm . bring tissues . ","a thriller with an edge -- which is to say that it doesn't follow the stale , standard , connect-the-dots storyline which has become commonplace in movies that explore the seamy underbelly of the criminal world . ","  me without you  is a probing examination of a female friendship set against a few dynamic decades . ","inherently caustic and oddly whimsical , the film chimes in on the grieving process and strangely draws the audience into the unexplainable pain and eccentricities that are attached to the concept of loss . ","though frodo's quest remains unfulfilled , a hardy group of determined new zealanders has proved its creative mettle . ","it's a square , sentimental drama that satisfies , as comfort food often can . ","pure cinematic intoxication , a wildly inventive mixture of comedy and melodrama , tastelessness and swooning elegance . ","ramsay is clearly extraordinarily talented , and based on three short films and two features , here's betting her third feature will be something to behold . ","i was impressed by how many tit-for-tat retaliatory responses the filmmakers allow before pulling the plug on the conspirators and averting an american-russian armageddon . ","a classy , sprightly spin on film . ","fast , frantic and fun , but also soon forgotten","a spiffy animated feature about an unruly adolescent boy who is yearning for adventure and a chance to prove his worth . ","devos and cassel have tremendous chemistry -- their sexual and romantic tension , while never really vocalized , is palpable . ","fulfills the minimum requirement of disney animation . ","a moving , if uneven , success . "," with one exception , every blighter in this particular south london housing project digs into dysfunction like it's a big , comforting jar of marmite , to be slathered on crackers and served as a feast of bleakness . ","wickedly funny , visually engrossing , never boring , this movie challenges us to think about the ways we consume pop culture . ","there's plenty to impress about e . t . ","a chronicle not only of one man's quest to be president , but of how that man single-handedly turned a plane full of hard-bitten , cynical journalists into what was essentially , by campaign's end , an extended publicity department . ","until it goes off the rails in its final 10 or 15 minutes , wendigo , larry fessenden's spooky new thriller , is a refreshingly smart and newfangled variation on several themes derived from far less sophisticated and knowing horror films . ","[woo's] most resonant film since the killer . ","collateral damage is trash , but it earns extra points by acting as if it weren't . ","a whole lot of fun and funny in the middle , though somewhat less hard-hitting at the start and finish . ","maybe it is formula filmmaking , but there's nothing wrong with that if the film is well-crafted and this one is . ","[fincher's] camera sense and assured pacing make it an above-average thriller . ","the film is insightful about kissinger's background and history . ","an engrossing portrait of a man whose engaging manner and flamboyant style made him a truly larger-than-life character . ","a lot of the credit for the film's winning tone must go to grant , who hasn't lost a bit of the dry humor that first made audiences on both sides of the atlantic love him . ","exploits [headbanger] stereotypes in good fun , while adding a bit of heart and unsettling subject matter . ","a journey that is as difficult for the audience to take as it is for the protagonist -- yet it's potentially just as rewarding . ","ratliff's two previous titles , plutonium circus and purgatory county show his penchant for wry , contentious configurations , and this film is part of that delicate canon . ","from its invitingly upbeat overture to its pathos-filled but ultimately life-affirming finale , martin is a masterfully conducted work . ","passions , obsessions , and loneliest dark spots are pushed to their most virtuous limits , lending the narrative an unusually surreal tone . ","a comedy that swings and jostles to the rhythms of life . ","at times auto focus feels so distant you might as well be watching it through a telescope . yet in its own aloof , unreachable way it's so fascinating you won't be able to look away for a second . ","if you're part of her targeted audience , you'll cheer . otherwise , maybe . ","as animation increasingly emphasizes the computer and the cool , this is a film that takes a stand in favor of tradition and warmth . ","blade ii merges bits and pieces from fighting games , wire fu , horror movies , mystery , james bond , wrestling , sci-fi and anime into one big bloody stew . ","instead of hitting the audience over the head with a moral , schrader relies on subtle ironies and visual devices to convey point of view . ","k-19 will not go down in the annals of cinema as one of the great submarine stories , but it is an engaging and exciting narrative of man confronting the demons of his own fear and paranoia . ","contrived as this may sound , mr . rose's updating works surprisingly well . ","a glib but bouncy bit of sixties-style slickness in which the hero might wind up caught but the audience gets pure escapism . ","lavishly , exhilaratingly tasteless . ","you don't need to be a hip-hop fan to appreciate scratch , and that's the mark of a documentary that works . ","between bursts of automatic gunfire , the story offers a trenchant critique of capitalism . ","combines improbable melodrama ( gored bullfighters , comatose ballerinas ) with subtly kinky bedside vigils and sensational denouements , and yet at the end , we are undeniably touched . ","while the story's undeniably hard to follow , iwai's gorgeous visuals seduce . ","if you can get past the taboo subject matter , it will be well worth your time . ","a lovely film . . . elegant , witty and beneath a prim exterior unabashedly romantic . . . hugely enjoyable in its own right though not really faithful to its source's complexity . ","scooby doo is surely everything its fans are hoping it will be , and in that sense is a movie that deserves recommendation . ","[a] devastatingly powerful and astonishingly vivid holocaust drama . ","a solid cast , assured direction and complete lack of modern day irony . ","these characters are so well established that the gang feels comfortable with taking insane liberties and doing the goofiest stuff out of left field , and i'm all for that . ","a sun-drenched masterpiece , part parlor game , part psychological case study , part droll social satire . ","worth a look as a curiosity . ","you watch for that sense of openness , the little surprises . ","director peter kosminsky gives these women a forum to demonstrate their acting 'chops' and they take full advantage . ","auto focus is not your standard hollywood bio-pic . schrader aims to present an unflinching look at one man's downfall , brought about by his lack of self-awareness . ","the bourne identity shouldn't be half as entertaining as it is , but director doug liman and his colleagues have managed to pack it with enough action to satisfy the boom-bam crowd without a huge sacrifice of character and mood . ","for veggietales fans , this is more appetizing than a side dish of asparagus . if you're not a fan , it might be like trying to eat brussels sprouts . ","remove spider-man the movie from its red herring surroundings and it's apparent that this is one summer film that satisfies . ","the whole mildly pleasant outing -- the r rating is for brief nudity and a grisly corpse -- remains aloft not on its own self-referential hot air , but on the inspired performance of tim allen . ","a gorgeously strange movie , heaven is deeply concerned with morality , but it refuses to spell things out for viewers . ","the emperor's club , ruthless in its own placid way , finds one of our most conservative and hidebound movie-making traditions and gives it new texture , new relevance , new reality . ","it's truly awful and heartbreaking subject matter , but one whose lessons are well worth revisiting as many times as possible . ","though intrepid in exploring an attraction that crosses sexual identity , ozpetek falls short in showing us antonia's true emotions . . . but at the very least , his secret life will leave you thinking . ","there is little question that this is a serious work by an important director who has something new to say about how , in the flip-flop of courtship , we often reel in when we should be playing out . ","the message of such reflections--intentional or not--is that while no art grows from a vacuum , many artists exist in one . ","gooding is the energetic frontman , and it's hard to resist his enthusiasm , even if the filmmakers come up with nothing original in the way of slapstick sequences . ","the otherwise good-naturedness of mr . deeds , with its embrace of sheer goofiness and cameos of less- than-likely new york celebrities . . . certainly raises the film above anything sandler's been attached to before . ","the movie is brilliant , really . it is philosophy , illustrated through everyday events . ","it's stylishly directed with verve . . . ","gives an intriguing twist to the french coming-of-age genre . ","offers an interesting look at the rapidly changing face of beijing . ","a solid , psychological action film from hong kong . ","see it now , before the inevitable hollywood remake flattens out all its odd , intriguing wrinkles . ","holm does his sly , intricate magic , and iben hjelje is entirely appealing as pumpkin . ","an enjoyable feel-good family comedy regardless of race . ","features what is surely the funniest and most accurate depiction of writer's block ever . ","it would take a complete moron to foul up a screen adaptation of oscar wilde's classic satire . ","it's bright , pristine style and bold colors make it as much fun as reading an oversized picture book before bedtime . ","in the long , dishonorable history of quickie teen-pop exploitation , like mike stands out for its only partly synthetic decency . ","bravo for history rewritten , and for the uncompromising knowledge that the highest power of all is the power of love . ","lead actress gaï , she of the impossibly long limbs and sweetly conspiratorial smile , is a towering siren . ","even if you've seen  stomp  ( the stage show ) , you still have to see this ! "," . . . a light , yet engrossing piece . lux , now in her eighties , does a great combination act as narrator , jewish grandmother and subject – taking us through a film that is part biography , part entertainment and part history . ","it's a setup so easy it borders on facile , but keeping the film from cheap-shot mediocrity is its crack cast . ","rife with the rueful , wry humor springing out of yiddish culture and language . ","a time machine , a journey back to your childhood , when cares melted away in the dark theater , and films had the ability to mesmerize , astonish and entertain . ","rubbo's humorously tendentious intervention into the who-wrote-shakespeare controversy . ","cantet beautifully illuminates what it means sometimes to be inside looking out , and at other times outside looking in . ","k-19 : the widowmaker is a great yarn . ","it's as raw and action-packed an experience as a ringside seat at a tough-man contest . ","evokes the frustration , the awkwardness and the euphoria of growing up , without relying on the usual tropes . ","a brilliant gag at the expense of those who paid for it and those who pay to see it . ","visually striking and viscerally repellent . ","overcomes its visual hideousness with a sharp script and strong performances . ","touché ! ","astonishingly skillful and moving . . . it could become a historically significant work as well as a masterfully made one . ","beautifully crafted and cooly unsettling . . . recreates the atmosphere of the crime expertly . ","the year 2002 has conjured up more coming-of-age stories than seem possible , but take care of my cat emerges as the very best of them . ","although it doesn't always hang together -- violence and whimsy don't combine easily --  cherish  certainly isn't dull . ","the sight of the spaceship on the launching pad is duly impressive in imax dimensions , as are shots of the astronauts floating in their cabins . ","time is a beautiful film to watch , an interesting and at times captivating take on loss and loneliness . ","an intriguing look at the french film industry during the german occupation ; its most delightful moments come when various characters express their quirky inner selves . ","a fine documentary can be distinguished from a mediocre one by the better film's ability to make its subject interesting to those who aren't part of its supposed target audience . judging by those standards , 'scratch' is a pretty decent little documentary . ","fubar is very funny , but not always in a laugh-out-loud way . ","a diverse and astonishingly articulate cast of palestinian and israeli children . ","slight but enjoyable documentary . ","'the film is stark , straightforward and deadly . . . an unnatural calm that's occasionally shaken by . . . blasts of rage , and later , violent jealousy . '","an impressive hybrid . ","call this the full monty on ice , the underdog sports team formula redux . ","unfolds in a low-key , organic way that encourages you to accept it as life and go with its flow . ","a beguiling evocation of the quality that keeps dickens evergreen : the exuberant openness with which he expresses our most basic emotions . ","the heat of the moment prevails . it cooks conduct in a low , smoky and inviting sizzle . ","a riveting story well told . ","denis forges out of the theories of class- based rage and sisterly obsession a razor-sided tuning fork that rings with cultural , sexual and social discord . ","a compelling pre-wwii drama with vivid characters and a warm , moving message . ","the stars may be college kids , but the subject matter is as adult as you can get : the temptations of the flesh are unleashed by a slightly crazed , overtly determined young woman and a one-night swim turns into an ocean of trouble . ","pretty good little movie . ","by turns touching , raucously amusing , uncomfortable , and , yes , even sexy , never again is a welcome and heartwarming addition to the romantic comedy genre . ","worse than 'silence of the lambs' better than 'hannibal'","if you haven't seen the film lately , you may be surprised at the variety of tones in spielberg's work . much of it is funny , but there are also some startling , surrealistic moments . . . ","[the digital effects] reminded me of terry gilliam's rudimentary old monty python cartoons , in which he would cut out figures from drawings and photographs and paste them together . ","an entertaining mix of period drama and flat-out farce that should please history fans . ","canada's arctic light shines bright on this frozen tundra soap opera that breathes extraordinary life into the private existence of the inuit people . ","the fluid motion is astounding on any number of levels -- including the physical demands made on büttner -- and it implies in its wake the intractable , irreversible flow of history . ","alternately hilarious and sad , aggravating and soulful , scathing and joyous . it's a masterpeice . ","the film's messages of tolerance and diversity aren't particularly original , but one can't help but be drawn in by the sympathetic characters . ","though it lacks the utter authority of a genre gem , there's a certain robustness to this engaging mix of love and bloodletting . ","a conventional , but well-crafted film about a historic legal battle in ireland over a man's right to raise his own children . ","yes , it's as good as you remember . in fact , even better . ","hartley adds enough quirky and satirical touches in the screenplay to keep the film entertaining . ","an uncomfortable movie , suffocating and sometimes almost senseless , the grey zone does have a center , though a morbid one . ","this is a harrowing movie about how parents know where all the buttons are , and how to push them . ","a stirring road movie . ","one of the best films i have ever seen , constantly pulling the rug from underneath us , seeing things from new sides , plunging deeper , getting more intense . ","insanely hilarious ! i haven't laughed that hard in years ! ","anyone who's ever suffered under a martinet music instructor has no doubt fantasized about what an unhappy , repressed and twisted personal life their tormentor deserved . these people are really going to love the piano teacher . ","it's a tour de force , written and directed so quietly that it's implosion rather than explosion you fear . ","it may not be history – but then again , what if it is ? – but it makes for one of the most purely enjoyable and satisfying evenings at the movies i've had in a while . ","if  lilo & stitch  isn't the most edgy piece of disney animation to hit the silver screen , then this first film to use a watercolor background since  dumbo  certainly ranks as the most original in years . ","this may be dover kosashvili's feature directing debut , but it looks an awful lot like life -- gritty , awkward and ironic . ","this ready-made midnight movie probably won't stand the cold light of day , but under the right conditions , it's goofy ( if not entirely wholesome ) fun . ","see scratch for the history , see scratch for the music , see scratch for a lesson in scratching , but , most of all , see it for the passion . "," . . .  bowling for columbine  remains a disquieting and thought-provoking film . . . ","even though it is infused with the sensibility of a video director , it doesn't make for completely empty entertainment","but even with the two-wrongs-make-a-right chemistry between jolie and burns . . . this otherwise appealing picture loses its soul to screenwriting for dummies conformity . ","talk to her is so darned assured , we have absolutely no idea who the main characters are until the film is well under way -- and yet it's hard to stop watching . ","star/producer salma hayek and director julie taymor have infused frida with a visual style unique and inherent to the titular character's paintings and in the process created a masterful work of art of their own . ","a tasty masala . ","a truly wonderful tale combined with stunning animation . ","a low-key labor of love that strikes a very resonant chord . ","an average kid-empowerment fantasy with slightly above-average brains . ","confessions isn't always coherent , but it's sharply comic and surprisingly touching , so hold the gong . ","while guzmán frustratingly refuses to give pinochet's crimes a political context , his distance from the material is mostly admirable . "," . . . a story , an old and scary one , about the monsters we make , and the vengeance they take . ","a sentimental but entirely irresistible portrait of three aging sisters . ","white oleander may leave you rolling your eyes in the dark , but that doesn't mean you won't like looking at it . ","in painting an unabashedly romantic picture of a nation whose songs spring directly from the lives of the people , the movie exalts the marxian dream of honest working folk , with little to show for their labor , living harmoniously , joined in song . ","the most brilliant work in this genre since the 1984 uncut version of sergio leone's flawed but staggering once upon a time in america . ","it looks closely , insightfully at fragile , complex relationships . ","not a bad choice here , assuming that . . . the air-conditioning in the theater is working properly . ","a fine effort , an interesting topic , some intriguing characters and a sad ending . certainly the big finish wasn't something galinsky and hawley could have planned for . . . but part of being a good documentarian is being there when the rope snaps . ","it must be the end of the world : the best film so far this year is a franchise sequel starring wesley snipes . ","there are moments of hilarity to be had . ","refreshing . ","a hypnotic portrait of this sad , compulsive life . ","[while the last metro] was more melodramatic , confined to a single theater company and its strategies and deceptions , while tavernier is more concerned with the entire period of history . ","one of the best films of the year with its exquisite acting , inventive screenplay , mesmerizing music , and many inimitable scenes of tenderness , loss , discontent , and yearning . ","return to never land is reliable , standard disney animated fare , with enough creative energy and wit to entertain all ages . ","michael moore's latest documentary about america's thirst for violence is his best film yet . . . ","suffice to say that after seeing this movie in imax form , you'll be more acquainted with the tiniest details of tom hanks' face than his wife is . ","like a tarantino movie with heart , alias betty is richly detailed , deftly executed and utterly absorbing . ","marvelously entertaining and deliriously joyous documentary . ","a brisk , reverent , and subtly different sequel . ","a movie i loved on first sight and , even more important , love in remembrance . ","'divertida , enternecedora , universal y profundamente sincera , es una de las mejores comedias románticas en mucho tiempo . una verdadera delicia . '","deserves a place of honor next to nanook as a landmark in film history . ","murderous maids pulls no punches in its depiction of the lives of the papin sister and the events that led to their notorious rise to infamy . . . ","this is an undeniably intriguing film from an adventurous young talent who finds his inspiration on the fringes of the american underground . ","the sweetest thing , a romantic comedy with outrageous tendencies , may be a mess in a lot of ways . but it does have one saving grace . a lot of its gags and observations reflect a woman's point-of-view . ","this is lightweight filmmaking , to be sure , but it's pleasant enough -- and oozing with attractive men . ","at its most basic , this cartoon adventure is that wind-in-the-hair exhilarating . ","fans of critics' darling band wilco will marvel at the sometimes murky , always brooding look of i am trying to break your heart . ","the film presents visceral and dangerously honest revelations about the men and machines behind the curtains of our planet . ","[gosling's] combination of explosive physical energy and convincing intelligence helps create a complex , unpredictable character . ","confounding because it solemnly advances a daringly preposterous thesis . acting cannot be acted . ","fulford-wierzbicki . . . deftly captures the wise-beyond-her-years teen . ","a wild ride juiced with enough energy and excitement for at least three films . ","it's a cool event for the whole family . maybe not a classic , but a movie the kids will want to see over and over again . ","featherweight romantic comedy has a few nice twists in a standard plot and the charisma of hugh grant and sandra bullock . ","the movie is not as terrible as the synergistic impulse that created it . ","a typically observant , carefully nuanced and intimate french coming-of-age film that is an encouraging debut feature but has a needlessly downbeat ending that is too heavy for all that has preceded it . ","less an examination of neo-nazism than a probe into the nature of faith itself . ","a moving and weighty depiction of one family's attempts to heal after the death of a child . ","i don't think most of the people who loved the 1989 paradiso will prefer this new version . but i do . ","a zinger-filled crowd-pleaser that open-minded elvis fans ( but by no means all ) will have fun with . ","diggs and lathan are among the chief reasons brown sugar is such a sweet and sexy film . ","entirely suspenseful , extremely well-paced and ultimately . . . dare i say , entertaining ! ","the riveting performances by the incredibly flexible cast make love a joy to behold . ","terrific as nadia , a russian mail-order bride who comes to america speaking not a word of english , it's kidman who holds the film together with a supremely kittenish performance that gradually accumulates more layers . ","with an unflappable air of decadent urbanity , everett remains a perfect wildean actor , and a relaxed firth displays impeccable comic skill . ","the re-release of ron howard's apollo 13 in the imax format proves absolutely that really , really , really good things can come in enormous packages . ","very well written and directed with brutal honesty and respect for its audience . ","wonderful fencing scenes and an exciting plot make this an eminently engrossing film . ","it's pretty linear and only makeup-deep , but bogdanovich ties it together with efficiency and an affection for the period . ","a surprisingly charming and even witty match for the best of hollywood's comic-book adaptations . ","this is a superior horror flick . ","adaptation is simply brilliant . ","smart and alert , thirteen conversations about one thing is a small gem . ","the pleasure of read my lips is like seeing a series of perfect black pearls clicking together to form a string . we're drawn in by the dark luster . ","a haunting tale of murder and mayhem . ","i love the opening scenes of a wintry new york city in 1899 . cinematic poetry showcases the city's old-world charm before machines change nearly everything . ","it's hard to imagine anyone managing to steal a movie not only from charismatic rising star jake gyllenhaal but also from accomplished oscar winners susan sarandon , dustin hoffman and holly hunter , yet newcomer ellen pompeo pulls off the feat with aplomb . ","one of the best rock documentaries ever . wilco is a phenomenal band with such an engrossing story that will capture the minds and hearts of many . ","ian holm conquers france as an earthy napoleon","offers big , fat , dumb laughs that may make you hate yourself for giving in . ah , what the hell . ","[sports] admirable energy , full-bodied characterizations and narrative urgency . ","a portrait of an artist . ","directors brett morgen and nanette burstein have put together a bold biographical fantasia . ","the subtitled costume drama is set in a remote african empire before cell phones , guns , and the internal combustion engine , but the politics that thump through it are as timely as tomorrow . ","a tremendous piece of work . ","a delightful , if minor , pastry of a movie . ","while obviously aimed at kids , the country bears . . . should keep parents amused with its low groan-to-guffaw ratio . ","labute masterfully balances both traditional or modern stories together in a manner that one never overwhelms the other . something for everyone . ","irwin is so earnest that it's hard to resist his pleas to spare wildlife and respect their environs . there are far worse messages to teach a young audience , which will probably be perfectly happy with the sloppy slapstick comedy . ","leigh succeeds in delivering a dramatic slap in the face that's simultaneously painful and refreshing . ","not about scares but a mood in which an ominous , pervasive , and unknown threat lurks just below the proceedings and adds an almost constant mindset of suspense . ","'film aficionados cannot help but love cinema paradiso , whether the original version or new director's cut . '","a fascinating glimpse into an insular world that gives the lie to many clichés and showcases a group of dedicated artists . ","it's one thing to read about or rail against the ongoing - and unprecedented - construction project going on over our heads . it's quite another to feel physically caught up in the process . ","contradicts everything we've come to expect from movies nowadays . instead of simply handling conventional material in a conventional way , secretary takes the most unexpected material and handles it in the most unexpected way . ","could i have been more geeked when i heard that apollo 13 was going to be released in imax format ? in a word : no . ","murderous maids has a lot going for it , not least the brilliant performances by testud . . . and parmentier . ","filmmaker stacy peralta has a flashy editing style that doesn't always jell with sean penn's monotone narration , but he respects the material without sentimentalizing it . ","there are a couple of things that elevate  glory  above most of its ilk , most notably the mere presence of duvall . ","it's light on the chills and heavy on the atmospheric weirdness , and there are moments of jaw-droppingly odd behavior -- yet i found it weirdly appealing . "," ( rises ) above its oh-so-hollywood rejiggering and its conventional direction to give the film a soul and an unabashed sense of good old-fashioned escapism . ","a breezy blend of art , history , esoteric musings and philosophy . ","kids will love its fantasy and adventure , and grownups should appreciate its whimsical humor . ","tsai ming-liang's ghosts are painfully aware of their not-being . ","leaping from one arresting image to another , songs from the second floor has all the enjoyable randomness of a very lively dream and so manages to be compelling , amusing and unsettling at the same time . ","sean penn , you owe nicolas cage an apology . ","the performances are uniformly good . ","she's all-powerful , a voice for a pop-cyber culture that feeds on her bjorkness . ","it's a perfect show of respect to just one of those underrated professionals who deserve but rarely receive it . ","for all its plot twists , and some of them verge on the bizarre as the film winds down , blood work is a strong , character-oriented piece . ","the story line may be 127 years old , but el crimen del padre amaro . . . couldn't be more timely in its despairing vision of corruption within the catholic establishment . ","this in-depth study of important developments of the computer industry should make it required viewing in university computer science departments for years to come . ","it shows us a slice of life that's very different from our own and yet instantly recognizable . ","a wonderfully speculative character study that made up for its rather slow beginning by drawing me into the picture . ","has its share of arresting images . ","leave it to john sayles to take on developers , the chamber of commerce , tourism , historical pageants , and commercialism all in the same movie . . . without neglecting character development for even one minute . ","reign of fire just might go down as one of the all-time great apocalypse movies . ","poignant and funny . ","a smart little indie . ","payne has created a beautiful canvas , and nicholson proves once again that he's the best brush in the business . ","see it . debate it . remember it . ","try as you might to resist , if you've got a place in your heart for smokey robinson , this movie will worm its way there . ","a riveting profile of law enforcement , and a visceral , nasty journey into an urban hades . ","director douglas mcgrath takes on nickleby with all the halfhearted zeal of an 8th grade boy delving into required reading . ","stands as a document of what it felt like to be a new yorker -- or , really , to be a human being -- in the weeks after 9/11 . ","i am not generally a huge fan of cartoons derived from tv shows , but hey arnold ! the movie is clever , offbeat and even gritty enough to overcome my resistance . ","with not a lot of help from the screenplay ( proficient , but singularly cursory ) , [testud] acts with the feral intensity of the young bette davis . ","it's a film that's destined to win a wide summer audience through word-of-mouth reviews and , not far down the line , to find a place among the studio's animated classics . ","slow and ponderous , but rohmer's drama builds to an intense indoor drama about compassion , sacrifice , and christian love in the face of political corruption . ","if you're not totally weirded- out by the notion of cinema as community-therapy spectacle , quitting hits home with disorienting force . ","austin powers for the most part is extremely funny , the first part making up for any flaws that come later . ","while tattoo borrows heavily from both seven and the silence of the lambs , it manages to maintain both a level of sophisticated intrigue and human-scale characters that suck the audience in . ","cho continues her exploration of the outer limits of raunch with considerable brio . ","elvira fans could hardly ask for more . ","a canny , derivative , wildly gruesome portrait of a london sociopath who's the scariest of sadists . ","the movie should be credited with remembering his victims . ","fast-paced and wonderfully edited , the film is extremely thorough . ","a bracing , unblinking work that serves as a painful elegy and sobering cautionary tale . ","hashiguchi uses the situation to evoke a japan bustling atop an undercurrent of loneliness and isolation . ","as if trying to grab a lump of play-doh , the harder that liman tries to squeeze his story , the more details slip out between his fingers . ","my big fat greek wedding is not only the best date movie of the year , it's also a -- dare i say it twice -- delightfully charming -- and totally american , i might add -- slice of comedic bliss . ","few films have captured the chaos of an urban conflagration with such fury , and audience members will leave feeling as shaken as nesbitt's cooper looks when the bullets stop flying . ","another love story in 2002's remarkable procession of sweeping pictures that have reinvigorated the romance genre . ","it's another retelling of alexandre dumas' classic . why ? who knows , but it works under the direction of kevin reynolds . ","[f]rom the performances and the cinematography to the outstanding soundtrack and unconventional narrative , the film is blazingly alive and admirable on many levels . ","shiri is an action film that delivers on the promise of excitement , but it also has a strong dramatic and emotional pull that gradually sneaks up on the audience . ","provides the kind of 'laugh therapy' i need from movie comedies -- offbeat humor , amusing characters , and a happy ending . after seeing 'analyze that , ' i feel better already . ","a penetrating , potent exploration of sanctimony , self-awareness , self-hatred and self-determination . ","this isn't a retooled genre piece , the tale of a guy and his gun , but an amiably idiosyncratic work . ","overall , it's a very entertaining , thought-provoking film with a simple message : god is love . ","it may not be a great piece of filmmaking , but its power comes from its soul's-eye view of how well-meaning patronizing masked a social injustice , at least as represented by this case . ","although mainstream american movies tend to exploit the familiar , every once in a while a film arrives from the margin that gives viewers a chance to learn , to grow , to travel . ","jeong-hyang lee's film is deceptively simple , deeply satisfying . ","the film is a hoot , and is just as good , if not better than much of what's on saturday morning tv especially the pseudo-educational stuff we all can't stand . ","george clooney , in his first directorial effort , presents this utterly ridiculous shaggy dog story as one of the most creative , energetic and original comedies to hit the screen in years . ","even when it drags , we are forced to reflect that its visual imagination is breathtaking","although commentary on nachtwey is provided . . . it's the image that really tells the tale . ","a life-size reenactment of those jack chick cartoon tracts that always ended with some hippie getting tossed into the lake of fire . ","grainy photography mars an otherwise delightful comedy of errors . ","this film is not a love letter for the slain rappers , it's a taunt -a call for justice for two crimes from which many of us have not yet recovered . ","the film is impressive for the sights and sounds of the wondrous beats the world has to offer . ","daily struggles and simple pleasures usurp the preaching message so that , by the time the credits roll across the pat ending , a warm , fuzzy feeling prevails . "," . . . in no way original , or even all that memorable , but as downtown saturday matinee brain candy , it doesn't disappoint . ","clever and unflinching in its comic barbs , slap her is a small but rewarding comedy that takes aim at contemporary southern adolescence and never lets up . ","cremaster 3 is at once a tough pill to swallow and a minor miracle of self-expression . ","sex is one of those films that aims to confuse . ","compared to his series of spectacular belly flops both on and off the screen , runteldat is something of a triumph . ","[moore's] better at fingering problems than finding solutions . but though he only scratches the surface , at least he provides a strong itch to explore more . ","the powerful success of read my lips with such provocative material shows why , after only three films , director/co-writer jacques audiard , though little known in this country , belongs in the very top rank of french filmmakers . ","in his debut as a director , washington has a sure hand . his work with actors is particularly impressive . ","a generous , inspiring film that unfolds with grace and humor and gradually becomes a testament to faith . ","delivers the sexy razzle-dazzle that everyone , especially movie musical fans , has been hoping for . ","morvern rocks . ","vincent gallo is right at home in this french shocker playing his usual bad boy weirdo role . ","fierce , glaring and unforgettable . ","cletis is playful but highly studied and dependent for its success on a patient viewer . ","like its predecessor , it's no classic , but it provides a reasonably attractive holiday contraption , one that families looking for a clean , kid-friendly outing should investigate . ","campanella gets the tone just right -- funny in the middle of sad in the middle of hopeful . ","either a fascinating study of the relationship between mothers and their children or a disturbing story about sociopaths and their marks . "," . . . gripping and handsome execution , ( but ) there isn't much about k-19 that's unique or memorable . ","effective in all its aspects , margarita happy hour represents an auspicious feature debut for chaiken . ","the delicious trimmings…arrive early and stay late , filling nearly every minute…with a lighthearted glow , some impudent snickers , and a glorious dose of humankind's liberating ability to triumph over a scrooge or two . ","standing by yourself is haunting . . . [it's] what punk rock music used to be , and what the video medium could use more of : spirit , perception , conviction . ","not the best herzog perhaps , but unmistakably herzog . ","enjoyably fast-moving , hard-hitting documentary . ","rehearsals are frequently more fascinating than the results . last dance , whatever its flaws , fulfills one facet of its mission in making me want to find out whether , in this case , that's true . ","the film's constant mood of melancholy and its unhurried narrative are masterfully controlled . but … in trying to capture the novel's deeper intimate resonances , the film has – ironically - distanced us from the characters . ","this is a stunning film , a one-of-a-kind tour de force . ","[cho's face is] an amazing slapstick instrument , creating a scrapbook of living mug shots . ","it's about as convincing as any other arnie musclefest , but has a little too much resonance with real world events and ultimately comes off as insultingly simplistic . ","while not quite a comedy , the film tackles its relatively serious subject with an open mind and considerable good cheer , and is never less than engaging . ","an extremely funny , ultimately heartbreaking look at life in contemporary china . ","your response to its new sequel , analyze that , may hinge on what you thought of the first film . ","davis is funny , charming and quirky in her feature film acting debut as amy . ","bloody sunday has the grace to call for prevention rather than to place blame , making it one of the best war movies ever made . it's a movie that accomplishes so much that one viewing can't possibly be enough . ","a lively and engaging examination of how similar obsessions can dominate a family . ","in the new release of cinema paradiso , the tale has turned from sweet to bittersweet , and when the tears come during that final , beautiful scene , they finally feel absolutely earned . ","faithful without being forceful , sad without being shrill ,  a walk to remember  succeeds through sincerity . ","the film is a masterpiece of nuance and characterization , marred only by an inexplicable , utterly distracting blunder at the very end . ","the film is full of charm . ","the movie is well crafted , and well executed . if you're paying attention , the  big twists  are pretty easy to guess - but that doesn't make the movie any less entertaining . ","one of those unassuming films that sneaks up on you and stays with you long after you have left the theatre . "," . . . pray doesn't have a passion for the material . he nonetheless appreciates the art and reveals a music scene that transcends culture and race . ","the one-liners are snappy , the situations volatile and the comic opportunities richly rewarded . ","it's anchored by splendid performances from an honored screen veteran and a sparkling newcomer who instantly transform themselves into a believable mother/daughter pair . ","intelligent and moving . ","fathers and sons , and the uneasy bonds between them , rarely have received such a sophisticated and unsentimental treatment on the big screen as they do in this marvelous film . ","this sci-fi techno-sex thriller starts out bizarre and just keeps getting weirder . ","last orders nurtures the multi-layers of its characters , allowing us to remember that life's ultimately a gamble and last orders are to be embraced . it's affecting , amusing , sad and reflective . ","a slight but sweet film . ","el peso de un líquido incoloro , el peso del líquido vital , del amor como elemento de vida , y de muerte . . . ","writer/director walter hill is in his hypermasculine element here , once again able to inject some real vitality and even art into a pulpy concept that , in many other hands would be completely forgettable . ","it is a happy , heady jumble of thought and storytelling , an insane comic undertaking that ultimately coheres into a sane and breathtakingly creative film . ","this new time machine is hardly perfect… yet it proves surprisingly serviceable . even at its worst , it's not half-bad . ","almost everyone growing up believes their family must look like  the addams family  to everyone looking in . . .  my big fat greek wedding  comes from the heart . . . ","once folks started hanging out at the barbershop , they never wanted to leave . chances are you won't , either . ","george lucas returns as a visionary with a tale full of nuance and character dimension . ","can be viewed as pure composition and form -- film as music","an extraordinary dramatic experience . ","every individual will see the movie through the prism of his or her own beliefs and prejudices , but the one thing most will take away is the sense that peace is possible . that , in itself , is extraordinary . ","if you can tolerate the redneck-versus-blueblood cliches that the film trades in , sweet home alabama is diverting in the manner of jeff foxworthy's stand-up act . ","it's a treat watching shaw , a british stage icon , melting under the heat of phocion's attentions . ","all in all , an interesting look at the life of the campaign-trail press , especially ones that don't really care for the candidate they're forced to follow . ","narc is a no-bull throwback to 1970s action films . it zips along with b-movie verve while adding the rich details and go-for-broke acting that heralds something special . ","me without you has a bracing truth that's refreshing after the phoniness of female-bonding pictures like divine secrets of the ya-ya sisterhood . ","it's a strange film , one that was hard for me to warm up to . ","goes a long way on hedonistic gusto . ","the result puts a human face on derrida , and makes one of the great minds of our times interesting and accessible to people who normally couldn't care less . ","the scorpion king is more fun than conan the barbarian . ","if there's one big point to promises , it's that nothing can change while physical and psychological barriers keep the sides from speaking even one word to each other . ","unexpected moments of authentically impulsive humor are the hallmark of this bittersweet , uncommonly sincere movie that portrays the frank humanity of…emotional recovery . ","jacquot has filmed the opera exactly as the libretto directs , ideally capturing the opera's drama and lyricism . ","this is a sincerely crafted picture that deserves to emerge from the traffic jam of holiday movies . ","i liked it because it was so endlessly , grotesquely , inventive . ","audiard successfully maintains suspense on different levels throughout a film that is both gripping and compelling . ","credit director ramsay for taking the sometimes improbable story and making it feel realistic . ","this is dicaprio's best performance in anything ever , and easily the most watchable film of the year . ","witherspoon puts to rest her valley-girl image , but it's dench who really steals the show . ","even when there are lulls , the emotions seem authentic , and the picture is so lovely toward the end . . . you almost don't notice the 129-minute running time . ","while dutifully pulling on heartstrings , directors dean deblois and chris sanders valiantly keep punching up the mix . ","ambitious , unsettling psychodrama that takes full , chilling advantage of its rough-around-the-edges , low-budget constraints . ","eric byler's nuanced pic avoids easy sentiments and explanations . . . ","manages to be wholesome and subversive at the same time . ","when it's not wallowing in hormonal melodrama ,  real women have curves  is a sweet , honest , and enjoyable comedy-drama about a young woman who wants many things in life , but fears she'll become her mother before she gets to fulfill her dreams . ","the film runs on a little longer than it needs to -- muccino either doesn't notice when his story ends or just can't tear himself away from the characters -- but it's smooth and professional . ","blithely anachronistic and slyly achronological . ","this starts off with a 1950's doris day feel and it gets very ugly , very fast . the first five minutes will have you talking 'til the end of the year ! ","triumph of love is a very silly movie , but the silliness has a pedigree . ","discursive but oddly riveting documentary . ","the movie has no respect for laws , political correctness or common decency , but it displays something more important : respect for its flawed , crazy people . ","on its own , big trouble could be considered a funny little film . ","an undeniably gorgeous , terminally smitten document of a troubadour , his acolytes , and the triumph of his band . ","this cinema verite speculation on the assassination of john f . kennedy may have been inspired by blair witch , but it takes its techniques into such fresh territory that the film never feels derivative . ","a beautifully observed character piece . ","a coming-of-age movie that hollywood wouldn't have the guts to make . ","it is quite a vision . ","there are laughs aplenty , and , as a bonus , viewers don't have to worry about being subjected to farts , urine , feces , semen , or any of the other foul substances that have overrun modern-day comedies . ","a bittersweet drama about the limbo of grief and how truth-telling can open the door to liberation . ","a strong and confident work which works so well for the first 89 minutes , but ends so horrendously confusing in the final two","salma goes native and she's never been better in this colorful bio-pic of a mexican icon . ","filled with alexandre desplat's haunting and sublime music , the movie completely transfixes the audience . ","as chilling and fascinating as philippe mora's modern hitler-study , snide and prejudice . ","an hour and a half of joyful solo performance . ","strange and beautiful film . ","no worse a film than breaking out , and breaking out was utterly charming . ","parker cannot sustain the buoyant energy level of the film's city beginnings into its country conclusion","' . . . despite lagging near the finish line , the movie runs a good race , one that will have you at the edge of your seat for long stretches . '"," . . . a guiltless film for nice evening out . ","deflated ending aside , there's much to recommend the film . ","it's a treat – a delightful , witty , improbable romantic comedy with a zippy jazzy score… grant and bullock make it look as though they are having so much fun . ","performances all around are tops , with the two leads delivering oscar-caliber performances . ","everything about the quiet american is good , except its timing . ","a savage john waters-like humor that dances on the edge of tastelessness without ever quite falling over . ","at once a testament to the divine calling of education and a demonstration of the painstaking process of imparting knowledge . ","may seriously impair your ability to ever again maintain a straight face while speaking to a highway patrolman . ","it's an interesting effort ( particularly for jfk conspiracy nuts ) , and barry's cold-fish act makes the experience worthwhile . ","they're just a couple of cops in copmovieland , these two , but in narc , they find new routes through a familiar neighborhood . ","brings awareness to an issue often overlooked -- women's depression . ","it's a shame the marvelous first 101 minutes have to be combined with the misconceived final 5 . ","it has a caffeinated , sloppy brilliance , sparkling with ideas you wish had been developed with more care , but animated by an energy that puts the dutiful efforts of more disciplined grade-grubbers to shame . ","you can almost see mendes and company getting together before a single frame had been shot and collectively vowing , 'this is going to be something really good . ' and it is . ","foster and whitaker are especially fine . she is a lioness , protecting her cub , and he a reluctant villain , incapable of controlling his crew . ","undoubtedly the scariest movie ever made about tattoos . ","a movie that will wear you out and make you misty even when you don't want to be . ","not only better than its predecessor , it may rate as the most magical and most fun family fare of this or any recent holiday season . ","though the story . . . is hackneyed , the characters have a freshness and modesty that transcends their predicament . ","although frailty fits into a classic genre , in its script and execution it is a remarkably original work . ","if this movie leaves you cool , it also leaves you intriguingly contemplative . ","the climactic events are so well realized that you may forget all about the original conflict , just like the movie does","a rude black comedy about the catalytic effect a holy fool has upon those around him in the cutthroat world of children's television . ","all comedy is subversive , but this unrelenting bleak insistence on opting out of any opportunity for finding meaning in relationships or work just becomes sad . ","if a horror movie's primary goal is to frighten and disturb , then they works spectacularly well . . . a shiver-inducing , nerve-rattling ride . ","a playful iranian parable about openness , particularly the need for people of diverse political perspectives to get along despite their ideological differences . ","brilliantly written and well-acted , yellow asphalt is an uncompromising film . ","that 'alabama' manages to be pleasant in spite of its predictability and occasional slowness is due primarily to the perkiness of witherspoon ( who is always a joy to watch , even when her material is not first-rate ) . . . ","personal velocity has a no-frills docu-dogma plainness , yet miller lingers on invisible , nearly psychic nuances , leaping into digressions of memory and desire . she boxes these women's souls right open for us . ","a fascinating literary mystery story with multiple strands about the controversy of who really wrote shakespeare's plays . ","throughout , mr . audiard's direction is fluid and quick . ","a dashing and absorbing outing with one of france's most inventive directors . ","it's a fine , old-fashioned-movie movie , which is to say it's unburdened by pretensions to great artistic significance . "," . . . flat-out amusing , sometimes endearing and often fabulous , with a solid cast , noteworthy characters , delicious dialogue and a wide supply of effective sight gags . ","the trials of henry kissinger is a remarkable piece of filmmaking … because you get it . ","nachtwey clears the cynicism right out of you . he makes you realize that deep inside righteousness can be found a tough beauty . ","what it lacks in substance it makes up for in heart . ","robert harmon's less-is-more approach delivers real bump-in -the-night chills -- his greatest triumph is keeping the creepy crawlies hidden in the film's thick shadows . ","genuinely unnerving . ","american and european cinema has amassed a vast holocaust literature , but it is impossible to think of any film more challenging or depressing than the grey zone . ","a compelling film . ","with its hint of an awkward hitchcockian theme in tact , harmon's daunting narrative promotes a reasonable landscape of conflict and pathos to support the scattershot terrorizing tone","in auteil's less dramatic but equally incisive performance , he's a charismatic charmer likely to seduce and conquer . ","the heart of the film is a touching reflection on aging , suffering and the prospect of death . ","will you go ape over this movie ? well , it probably won't have you swinging from the trees hooting it's praises , but it's definitely worth taking a look . ","its director's most substantial feature for some time . ","fontaine's direction , especially her agreeably startling use of close-ups and her grace with a moving camera , creates sheerly cinematic appeal . ","the son of the bride's humour is born out of an engaging storyline , which also isn't embarrassed to make you reach for the tissues . this movie is to be cherished . "," . . . a visually seductive , unrepentantly trashy take on rice's second installment of her vampire chronicles . ","the story's scope and pageantry are mesmerizing , and mr . day-lewis roars with leonine power . ","p . t . anderson understands the grandness of romance and how love is the great equalizer that can calm us of our daily ills and bring out joys in our lives that we never knew were possible . ","twenty years later , e . t . is still a cinematic touchstone . ","this fascinating experiment plays as more of a poetic than a strict reality , creating an intriguing species of artifice that gives the lady and the duke something of a theatrical air . ","it's virtually impossible to like any of these despicable characters . ","this is mostly well-constructed fluff , which is all it seems intended to be . ","even through its flaws , revolution #9 proves to be a compelling , interestingly told film . ","the best way to describe it is as a cross between paul thomas anderson's magnolia and david lynch's mulholland dr . ","schepisi , aided by a cast that seems to include every top-notch british actor who did not appear in gosford park ( as well as one , ms . mirren , who did ) , has succeeded beyond all expectation . ","lejos del paraíso es al mismo tiempo una fiesta para los ojos y oídos y un movilizador cuadro de personajes enfrentados a sus propios deseos , miedos y prejuicios . ","watching this film , one is left with the inescapable conclusion that hitchens' obsession with kissinger is , at bottom , a sophisticated flower child's desire to purge the world of the tooth and claw of human power . ","there is no denying the power of polanski's film . . . ","the movie is amateurish , but it's a minor treat . ","this charming but slight tale has warmth , wit and interesting characters compassionately portrayed . ","el título no engaña : la película narra una historia donde una mujer enfrentará cierta realidad , y donde el sexo es . . . ","offers a persuasive look at a defeated but defiant nation in flux . ","'interesante y disfrutable trabajo gracias a que prescinde del clásico elemento estadounidense patriotero y manipulador . '","a return to pure disney magic and is enjoyable family fare . ","takes a fresh and absorbing look at a figure whose legacy had begun to bronze . ","a triumph of pure craft and passionate heart . ","gosling creates a staggeringly compelling character , a young man whose sharp intellect is at the very root of his contradictory , self-hating , self-destructive ways . ","witty and often surprising , a dark little morality tale disguised as a romantic comedy . ","even as it pays earnest homage to turntablists and beat jugglers , old schoolers and current innovators , scratch is great fun , full of the kind of energy it's documenting . ","got a david lynch jones ? then you'd do well to check this one out because it's straight up twin peaks action . . . ","astonishing . . . [frames] profound ethical and philosophical questions in the form of dazzling pop entertainment . ","take care is nicely performed by a quintet of actresses , but nonetheless it drags during its 112-minute length . ","it's hard to fairly judge a film like ringu when you've seen the remake first . many of the effective horror elements are dampened through familiarity , [yet] are worthwhile . ","one of the very best movies ever made about the life of moviemaking . ","rarely does such high-profile talent serve such literate material . ","an elegant and sly deadpan comedy . ","the way the roundelay of partners functions , and the interplay within partnerships and among partnerships and the general air of gator-bashing are consistently delightful . ","land , people and narrative flow together in a stark portrait of motherhood deferred and desire explored . ","'blue crush' swims away with the sleeper movie of the summer award . ","you're not merely watching history , you're engulfed by it . ","a chick flick for guys . ","it's mildly entertaining , especially if you find comfort in familiarity . but it's hardly a necessary enterprise . ","the quiet american isn't a bad film , it's just one that could easily wait for your pay per view dollar . ","as home movie gone haywire , it's pretty enjoyable , but as sexual manifesto , i'd rather listen to old tori amos records . ","in its treatment of the dehumanizing and ego-destroying process of unemployment , time out offers an exploration that is more accurate than anything i have seen in an american film . ","like an episode of mtv's undressed , with 20 times the creativity but without any more substance . . . indulgently entertaining but could have and should have been deeper . ","deliciously slow . ","a sensitive , cultivated treatment of greene's work as well as a remarkably faithful one . ","it's not just a feel-good movie , it's a feel movie . you feel good , you feel sad , you feel pissed off , but in the end , you feel alive - which is what they did . ","it's a piece of handiwork that shows its indie tatters and self-conscious seams in places , but has some quietly moving moments and an intelligent subtlety . ","what makes barbershop so likable , with all its flaws , is that it has none of the pushiness and decibel volume of most contemporary comedies . ","watching these two actors play against each other so intensely , but with restraint , is a treat . ","an example of quiet , confident craftsmanship that tells a sweet , charming tale of intergalactic friendship . ","a meditation on faith and madness , frailty is blood-curdling stuff . ","the production design , score and choreography are simply intoxicating . ","a comedy that is warm , inviting , and surprising . ","so vivid a portrait of a woman consumed by lust and love and crushed by betrayal that it conjures up the intoxicating fumes and emotional ghosts of a freshly painted rembrandt . ","suspend your disbelief here and now , or you'll be shaking your head all the way to the credits . ","trades run-of-the-mill revulsion for extreme unease . "," . . . one of the more influential works of the 'korean new wave' . ","implicitly acknowledges and celebrates the glorious chicanery and self-delusion of this most american of businesses , and for that reason it may be the most oddly honest hollywood document of all . ","a beautifully tooled action thriller about love and terrorism in korea . ","director-writer bille august . . . depicts this relationship with economical grace , letting his superb actors convey martin's deterioration and barbara's sadness -- and , occasionally , anger . ","victor rosa is leguizamo's best movie work so far , a subtle and richly internalized performance . ","birthday girl doesn't try to surprise us with plot twists , but rather seems to enjoy its own transparency . ","smart , funny and just honest enough to provide the pleasures of a slightly naughty , just-above-average off- broadway play . ","topics that could make a sailor blush - but lots of laughs . ","michael moore has perfected the art of highly entertaining , self-aggrandizing , politically motivated documentary-making , and he's got as potent a topic as ever here . ","a fine production with splendid singing by angela gheorghiu , ruggero raimondi , and roberto alagna . ","about a boy vividly recalls the cary grant of room for one more , houseboat and father goose in its affectionate depiction of the gentle war between a reluctant , irresponsible man and the kid who latches onto him . ","none of this is meaningful or memorable , but frosting isn't , either , and you wouldn't turn down a big bowl of that , would you ? ","the film is a fierce dance of destruction . its flame-like , roiling black-and-white inspires trembling and gratitude . ","a riveting documentary . ","may lack the pungent bite of its title , but it's an enjoyable trifle nonetheless . "," . . . manages to fall closer in quality to silence than to the abysmal hannibal . ","you may think you have figured out the con and the players in this debut film by argentine director fabian bielinsky , but while you were thinking someone made off with your wallet . ","diane lane works nothing short of a minor miracle in unfaithful . ","takashi miike keeps pushing the envelope : ichi the killer","a fantastic premise anchors this movie , but what it needs is either a more rigid , blair witch-style commitment to its mockumentary format , or a more straightforward , dramatic treatment , with all the grandiosity that that implies . ","exhilarating but blatantly biased . ","much of what we see is horrible but it's also undeniably exceedingly clever . ","it understands , in a way that speaks forcefully enough about the mechanisms of poverty to transcend the rather simplistic filmmaking . ","ramsay succeeds primarily with her typical blend of unsettling atmospherics , delivering a series of abrasive , stylized sequences that burn themselves upon the viewer's memory . "," . . . a thoughtful what-if for the heart as well as the mind . ","like its bizarre heroine , it irrigates our souls . ","hawn and sarandon form an acting bond that makes the banger sisters a fascinating character study with laughs to spare . ","it's a fun adventure movie for kids ( of all ages ) that like adventure . ","a very capable nailbiter . ","because the genre is well established , what makes the movie fresh is smart writing , skewed characters , and the title performance by kieran culkin . ","  white oleander ,  the movie , is akin to a reader's digest condensed version of the source material . ","it's like going to a house party and watching the host defend himself against a frothing ex-girlfriend . you don't want to call the cops . you want to call domino's . ","what's most refreshing about real women have curves is its unforced comedy-drama and its relaxed , natural-seeming actors . ","the low-key direction is pleasingly emphatic in this properly intense , claustrophobic tale of obsessive love . ","secretary is just too original to be ignored . ","that rare film whose real-life basis is , in fact , so interesting that no embellishment is needed . ","smart and fun , but far more witty than it is wise . ","this isn't a stand up and cheer flick ; it's a sit down and ponder affair . and thanks to kline's superbly nuanced performance , that pondering is highly pleasurable . ","originality ain't on the menu , but there's never a dull moment in the giant spider invasion comic chiller . ","walter hill's undisputed is like a 1940s warner bros . b picture , and i mean that as a compliment . ","this one is not nearly as dreadful as expected . in fact , it's quite fun in places . ","with elements cribbed from lang's metropolis , welles' kane , and eisenstein's potemkin , the true wonder of rintarô's metropolis is the number of lasting images all its own . ","a biopic about crane's life in the classic tradition but evolves into what has become of us all in the era of video . ","the best of the pierce brosnan james bond films to date . ","thanks to a small star with big heart , this family film sequel is plenty of fun for all . ","while the now 72-year-old robert evans been slowed down by a stroke , he has at least one more story to tell : his own . ","it's about individual moments of mood , and an aimlessness that's actually sort of amazing . ","the people in jessica are so recognizable and true that , as in real life , we're never sure how things will work out . ","a tone poem of transgression . ","creeps you out in high style , even if nakata did it better . ","rubbo runs through a remarkable amount of material in the film's short 90 minutes . ","visually engrossing , seldom hammy , honorably mexican and burns its kahlories with conviction . ","this is christmas future for a lot of baby boomers . ","despite a quieter middle section , involving aragorn's dreams of arwen , this is even better than the fellowship . there are scenes of cinematic perfection that steal your heart away . ","spider-man is in the same category as x-men - occasionally brilliant but mostly average , showing signs of potential for the sequels , but not giving us much this time around . ","the obnoxious title character provides the drama that gives added clout to this doc . ","an enjoyable experience . ","anyone who welcomes a dash of the avant-garde fused with their humor should take pleasure in this crazed , joyous romp of a film . ","the fun of the movie is the chance it affords to watch jackson , who also served as executive producer , take his smooth , shrewd , powerful act abroad . ","'si bien no logra desarrollarse como un gran drama , tampoco es tan superficial como muchas cintas que pecan de pretenciosas y que resultan totalmente banales . '","saddled with an unwieldy cast of characters and angles , but the payoff is powerful and revelatory . ","it's something of the ultimate scorsese film , with all the stomach-turning violence , colorful new york gang lore and other hallmarks of his personal cinema painted on their largest-ever historical canvas . ","mr . caine and mr . fraser are the whole show here , with their memorable and resourceful performances . ","a frustrating yet deeply watchable melodrama that makes you think it's a tougher picture than it is . ","a giddy and provocative sexual romp that has something to say . ","[russell] makes good b movies ( the mask , the blob ) , and the scorpion king more than ably meets those standards . ","otto-sallies has a real filmmaker's eye . ","this is a smart movie that knows its classical music , knows its freud and knows its sade . ","the film has an infectious enthusiasm and we're touched by the film's conviction that all life centered on that place , that time and that sport . ","beautifully reclaiming the story of carmen and recreating it an in an african idiom . ","the camera soars above the globe in dazzling panoramic shots that make the most of the large-screen format , before swooping down on a string of exotic locales , scooping the whole world up in a joyous communal festival of rhythm . ","a flawed but engrossing thriller . ","demonstrates the unusual power of thoughtful , subjective filmmaking . ","expect no major discoveries , nor any stylish sizzle , but the film sits with square conviction and touching good sense on the experience of its women . ","the success of undercover brother is found in its ability to spoof both black and white stereotypes equally . ","this is the kind of subject matter that could so easily have been fumbled by a lesser filmmaker , but ayres makes the right choices at every turn . ","cox creates a fluid and mesmerizing sequence of images to match the words of nijinsky's diaries . ","what bloody sunday lacks in clarity , it makes up for with a great , fiery passion . ","its adult themes of familial separation and societal betrayal are head and shoulders above much of the director's previous popcorn work . ","director nancy savoca's no-frills record of a show forged in still-raw emotions captures the unsettled tenor of that post 9-11 period far better than a more measured or polished production ever could . ","the film grows on you . and how . ","one thing you have to give them credit for : the message of the movie is consistent with the messages espoused in the company's previous video work . ","halloween : resurrection isn't exactly quality cinema , but it isn't nearly as terrible as it cold have been . ","as banal as the telling may be -- and at times , all my loved ones more than flirts with kitsch -- the tale commands attention . ","romantic comedy and dogme 95 filmmaking may seem odd bedfellows , but they turn out to be delightfully compatible here . ","the most wondrous love story in years , it is a great film . ","some movies suck you in despite their flaws , and heaven is one such beast . ","my wife is an actress works as well as it does because [the leads] are such a companionable couple . ","with spy kids 2 : the island of lost dreams , however , robert rodriguez adorns his family-film plot with an elegance and maturity that even most contemporary adult movies are lacking . ","based on dave barry's popular book of the same name , the movie benefits from having a real writer plot out all of the characters' moves and overlapping story . ","bouquet gives a performance that is masterly . ","a poignant comedy that offers food for thought . "," . . . a series of tales told with the intricate preciseness of the best short story writing . ","if you're content with a clever pseudo-bio that manages to have a good time as it doles out pieces of the famous director's life , eisenstein delivers . ","this filmed tosca -- not the first , by the way -- is a pretty good job , if it's filmed tosca that you want . i'll stay with the stage versions , however , which bite cleaner , and deeper . ","while the path may be familiar , first-time director denzel washington and a top-notch cast manage to keep things interesting . ","an engaging criminal romp that will have viewers guessing just who's being conned right up to the finale . ","the picture runs a mere 84 minutes , but it's no glance . it's a head-turner -- thoughtfully written , beautifully read and , finally , deeply humanizing . ","it asks nothing of the audience other than to sit back and enjoy a couple of great actors hamming it up . ","it is as uncompromising as it is nonjudgmental , and makes clear that a prostitute can be as lonely and needy as any of the clients . ","'barbershop  is a good-hearted ensemble comedy with a variety of quirky characters and an engaging story . ","a good thriller . ","tully is in many ways the perfect festival film : a calm , self-assured portrait of small town regret , love , duty and friendship that appeals to the storytelling instincts of a slightly more literate filmgoing audience . ","i like this movie a lot . i like that smith , he's not making fun of these people , he's not laughing at them . ","a glorious mess . "," . . . the implication is kissinger may have decided that — when it comes to truncheoning — it's better to give than to receive . ","'what's the russian word for wow ! ? '","kiarostami has crafted a deceptively casual ode to children and managed to convey a tiny sense of hope . ","i had more fun watching spy than i had with most of the big summer movies . ","what lee does so marvelously compelling is present brown as a catalyst for the struggle of black manhood in restrictive and chaotic america . . . sketchy but nevertheless gripping portrait of jim brown , a celebrated wonder in the spotlight","murder by numbers' isn't a great movie , but it's a perfectly acceptable widget . ","for those of an indulgent , slightly sunbaked and summery mind , sex and lucia may well prove diverting enough . ","what [denis] accomplishes in his chilling , unnerving film is a double portrait of two young women whose lives were as claustrophic , suffocating and chilly as the attics to which they were inevitably consigned . ","a well-done film of a self-reflexive , philosophical nature . ","texan director george ratliff had unlimited access to families and church meetings , and he delivers fascinating psychological fare . ","the rich performances by friel -- and especially williams , an american actress who becomes fully english -- round out the square edges . ","the new insomnia is a surprisingly faithful remake of its chilly predecessor , and when it does elect to head off in its own direction , it employs changes that fit it well rather than ones that were imposed for the sake of commercial sensibilities . ","a film in a class with spike lee's masterful do the right thing . ","jagger , stoppard and director michael apted . . . deliver a riveting and surprisingly romantic ride . ","greengrass ( working from don mullan's script ) forgoes the larger socio-political picture of the situation in northern ireland in favour of an approach that throws one in the pulsating thick of a truly frightening situation . ","a thought-provoking and often-funny drama about isolation . ","whatever one makes of its political edge , this is beautiful filmmaking from one of french cinema's master craftsmen . ","mama africa pretty much delivers on that promise . it does give you a peek . the main problem being that it's only a peek . ","roman polanski's autobiographical gesture at redemption is better than 'shindler's list' - it is more than merely a holocaust movie . ","a perfectly respectable , perfectly inoffensive , easily forgettable film . ","romanek's themes are every bit as distinctive as his visuals . beyond the cleverness , the weirdness and the pristine camerawork , one hour photo is a sobering meditation on why we take pictures . ","seeing seinfeld at home as he watches his own appearance on letterman with a clinical eye reminds you that the key to stand-up is to always make it look easy , even though the reality is anything but . ","speaks eloquently about the symbiotic relationship between art and life . ","the work of an artist tormented by his heritage , using his storytelling ability to honor the many faceless victims . ","the audacity to view one of shakespeare's better known tragedies as a dark comedy is , by itself , deserving of discussion . ","this is an exercise in chilling style , and twohy films the sub , inside and out , with an eye on preserving a sense of mystery . ","an uncomfortable experience , but one as brave and challenging as you could possibly expect these days from american cinema . ","hailed as a clever exercise in neo-hitchcockianism , this clever and very satisfying picture is more accurately chabrolian . ","funny and also heartwarming without stooping to gooeyness . ","at the film's centre is a precisely layered performance by an actor in his mid-seventies , michel piccoli . ","the viewer takes great pleasure in watching the resourceful molly stay a step ahead of her pursuers . ","with amazing finesse , the film shadows heidi's trip back to vietnam and the city where her mother , mai thi kim , still lives . ","director charles stone iii applies more detail to the film's music than to the story line ; what's best about drumline is its energy . ","a heroic tale of persistence that is sure to win viewers' hearts . ","it's all a rather shapeless good time . . . ","has far more energy , wit and warmth than should be expected from any movie with a  2  at the end of its title . ","a little better than sorcerer's stone . ","a chilling movie without oppressive gore . ","a uniquely sensual metaphorical dramatization of sexual obsession that spends a bit too much time on its fairly ludicrous plot . ","if you like peace , you'll like promises . ","be prepared to cling to the edge of your seat , tense with suspense . the ring never lets you off the hook . ","thumbs up to paxton for not falling into the hollywood trap and making a vanity project with nothing new to offer . ","at once disarmingly straightforward and strikingly devious . ","if you like quirky , odd movies and/or the ironic , here's a fun one . ","sensitive ensemble performances and good period reconstruction add up to a moving tragedy with some buoyant human moments . ","it's not the least of afghan tragedies that this noble warlord would be consigned to the dustbin of history . ","it's a lovely , sad dance highlighted by kwan's unique directing style . ","the script by david koepp is perfectly serviceable and because he gives the story some soul . . . he elevates the experience to a more mythic level . ","this is a visually stunning rumination on love , memory , history and the war between art and commerce . ","short-story quaint , touchingly mending a child's pain for his dead mother via communication with an old woman straight out of eudora welty . ","it's always fascinating to watch marker the essayist at work . ","a quiet family drama with a little bit of romance and a dose of darkness . ","the tasteful little revision works wonders , enhancing the cultural and economic subtext , bringing richer meaning to the story's morals . ","kosminsky . . . puts enough salt into the wounds of the tortured and self-conscious material to make it sting . ","one of the greatest films i've ever seen . ","its gentle , touching story creeps into your heart . ","about as big a crowdpleaser as they possibly come . ","bound to appeal to women looking for a howlingly trashy time . ","even these tales of just seven children seem at times too many , although in reality they are not enough . every child's story is what matters . this film can only point the way -- but thank goodness for this signpost . ","a poignant and gently humorous parable that loves its characters and communicates something rather beautiful about human nature . ","real women have curves doesn't offer any easy answers . ","vampire epic succeeds as spooky action-packed trash of the highest order . ","one of the funniest motion pictures of the year , but . . . also one of the most curiously depressing . ","while somewhat less than it might have been , the film is a good one , and you've got to hand it to director george clooney for biting off such a big job the first time out . ","like the chilled breath of oral storytelling frozen onto film . ","a charmer from belgium . ","a wild , endearing , masterful documentary . ","jackie chan movies are a guilty pleasure - he's easy to like and always leaves us laughing . ","brown sugar signals director rick famuyiwa's emergence as an articulate , grown-up voice in african-american cinema . ","with exquisite craftsmanship . . . olivier assayas has fashioned an absorbing look at provincial bourgeois french society . ","it's rare for any movie to be as subtle and touching as the son's room . ","it has a way of seeping into your consciousness , with lingering questions about what the film is really getting at . ","maelstrom is a deliberately unsteady mixture of stylistic elements . ","[leigh] has a true talent for drawing wrenching performances from his actors ( improvised over many months ) and for conveying the way tiny acts of kindness make ordinary life survivable . ","[d]espite its familiar subject matter , ice age is consistently amusing and engrossing . . . ","the ingenious construction ( adapted by david hare from michael cunningham's novel ) constantly flows forwards and back , weaving themes among three strands which allow us to view events as if through a prism","assured , glossy and shot through with brittle desperation . ","the bottom line is the piece works brilliantly . ","it was only a matter of time before some savvy producer saw the potential success inherent in the mixture of bullock bubble and hugh goo . ","it is scott's convincing portrayal of roger the sad cad that really gives the film its oomph . ","while this movie , by necessity , lacks fellowship's heart , two towers outdoes its spectacle . ","meyjes . . . has done his homework and soaked up some jazzy new revisionist theories about the origins of nazi politics and aesthetics . ","para hitler , o mundo era sua tela ; e o horror , seu pincel . e max retrata este fato com elegante abandono , numa triste constatação da realidade histórica . ","aside from rohmer's bold choices regarding point of view , the lady and the duke represents the filmmaker's lifelong concern with formalist experimentation in cinematic art . ","what 'dumb and dumber' would have been without the vulgarity and with an intelligent , life-affirming script . "," . . . a vivid , thoughtful , unapologetically raw coming-of-age tale full of sex , drugs and rock 'n' roll . ","you wouldn't want to live waydowntown , but it is a hilarious place to visit . ","films are made of little moments . changing lanes tries for more . it doesn't reach them , but the effort is gratefully received . ","when the movie mixes the cornpone and the cosa nostra , it finds a nice rhythm . ","the story is a rather simplistic one : grief drives her , love drives him , and a second chance to find love in the most unlikely place - it struck a chord in me . ","terrific casting and solid execution give all three stories life . ","a hard look at one man's occupational angst and its subsequent reinvention , a terrifying study of bourgeois desperation worthy of claude chabrol . ","neatly constructed thriller . ","[ramsay] visually transforms the dreary expanse of dead-end distaste the characters inhabit into a poem of art , music and metaphor . ","frequent flurries of creative belly laughs and genuinely enthusiastic performances . . . keep the movie slaloming through its hackneyed elements with enjoyable ease . ","at its best , this is grand-scale moviemaking for a larger-than-life figure , an artist who has been awarded mythic status in contemporary culture . ","'possession , ' based on the book by a . s . byatt , demands that labute deal with the subject of love head-on ; trading in his cynicism for reverence and a little wit","the plot of the comeback curlers isn't very interesting actually , but what i like about men with brooms and what is kind of special is how the film knows what's unique and quirky about canadians . ","10 minutes into the film you'll be white-knuckled and unable to look away . ","it's a beautiful film , full of elaborate and twisted characters - and it's also pretty funny . ","could this be the first major studio production shot on video tape instead of film ? ","not since ghostbusters has a film used manhattan's architecture in such a gloriously goofy way . ","as tricky and satisfying as any of david mamet's airless cinematic shell games . ","the universal theme of becoming a better person through love has never been filmed more irresistibly than in 'baran . '","cube's charisma and chemistry compensate for corniness and cliche . ","with lesser talents , high crimes would be entertaining , but forgettable . with freeman and judd , i'll at least remember their characters . ","as a director , paxton is surprisingly brilliant , deftly sewing together what could have been a confusing and horrifying vision into an intense and engrossing head-trip . ","the film is filled with humorous observations about the general absurdity of modern life as seen through the eyes outsiders , but deftly manages to avoid many of the condescending stereotypes that so often plague films dealing with the mentally ill . ","daughter from danang sticks with its subjects a little longer and tells a deeper story","a coming-of-age film that avoids the cartoonish clichés and sneering humor of the genre as it provides a fresh view of an old type -- the uncertain girl on the brink of womanhood . ","the faithful will enjoy this sometimes wry adaptation of v . s . naipaul's novel , but newcomers may find themselves stifling a yawn or two during the first hour . ","a distinguished and thoughtful film , marked by acute writing and a host of splendid performances . ","barry convinces us he's a dangerous , secretly unhinged guy who could easily have killed a president because it made him feel powerful . ","takes you by the face , strokes your cheeks and coos beseechingly at you : slow down , shake off your tensions and take this picture at its own breezy , distracted rhythms . ","i don't feel the least bit ashamed in admitting that my enjoyment came at the expense of seeing justice served , even if it's a dish that's best served cold . ","it's a smart , solid , kinetically-charged spy flick worthy of a couple hours of summertime and a bucket of popcorn . nothing overly original , mind you , but solidly entertaining . ","changing lanes is an anomaly for a hollywood movie ; it's a well-written and occasionally challenging social drama that actually has something interesting to say . ","borrows a bit from the classics  wait until dark  and  extremities  . . . but in terms of its style , the movie is in a class by itself . ","because eight legged freaks is partly an homage to them , tarantula and other low- budget b-movie thrillers of the 1950s and '60s , the movie is a silly ( but not sophomoric ) romp through horror and hellish conditions . ","puts a refreshing and comical spin on the all-too-familiar saga of the contemporary single woman . ","if you grew up on scooby -- you'll love this movie . matthew lillard is born to play shaggy ! ","intimate and panoramic . ","though filmed partly in canada , paid in full has clever ways of capturing inner-city life during the reagan years . ","  spider-man is better than any summer blockbuster we had to endure last summer , and hopefully , sets the tone for a summer of good stuff . if you're a comic fan , you can't miss it . if you're not , you'll still have a good time .  ","exciting documentary . ","this movie has a strong message about never giving up on a loved one , but it's not an easy movie to watch and will probably disturb many who see it . ","the movie is a trove of delights . ","excellent performances from jacqueline bisset and martha plimpton grace this deeply touching melodrama . ","in a summer of clones , harvard man is something rare and riveting : a wild ride that relies on more than special effects . ","while the humor is recognizably plympton , he has actually bothered to construct a real story this time . ","jolting into charleston rhythms , the story has the sizzle of old news that has finally found the right vent ( accurate ? who cares ? ) . ","an overly melodramatic but somewhat insightful french coming-of-age film . . . ","most thrillers send audiences out talking about specific scary scenes or startling moments ;  frailty  leaves us with the terrifying message that the real horror may be waiting for us at home . ","close enough in spirit to its freewheeling trash-cinema roots to be a breath of fresh air . ","skillfully weaves both the elements of the plot and a powerfully evocative mood combining heated sexuality with a haunting sense of malaise . ","damon brings the proper conviction to his role as [jason bourne] . ","for the most part , it works beautifully as a movie without sacrificing the integrity of the opera . ","as played by ryan gosling , danny is a frighteningly fascinating contradiction . ","this is not chabrol's best , but even his lesser works outshine the best some directors can offer . ","despite its flaws , crazy as hell marks an encouraging new direction for la salle . ","you'll end up moved . ","if you ever wondered what it would be like to be smack in the middle of a war zone armed with nothing but a camera , this oscar-nominated documentary takes you there . ","the woodman seems to have directly influenced this girl-meets-girl love story , but even more reassuring is how its makers actually seem to understand what made allen's romantic comedies so pertinent and enduring . ","i loved the look of this film . ","it's the kind of movie that , aside from robert altman , spike lee , the coen brothers and a few others , our moviemakers don't make often enough . ","those with a modicum of patience will find in these characters' foibles a timeless and unique perspective . ","beautiful to watch and holds a certain charm . ","13 conversations may be a bit too enigmatic and overly ambitious to be fully successful , but sprecher and her screenwriting partner and sister , karen sprecher , don't seem ever to run out of ideas . ","the movie is our story as much as it is schmidt's , no matter if it's viewed as a self-reflection or cautionary tale . ","foster breathes life into a roll that could have otherwise been bland and run of the mill . ","quitting offers piercing domestic drama with spikes of sly humor . ","some people want the ol' ball-and-chain and then there are those who just want the ball and chain . ","[barry] gives assassin a disquieting authority . ","it's refreshing to see a romance this smart . ","at its best ( and it does have some very funny sequences ) looking for leonard reminds you just how comically subversive silence can be . ","as improbable as this premise may seem , abbass's understated , shining performance offers us the sense that on some elemental level , lilia deeply wants to break free of her old life . ","anyone who ever fantasized about space travel but can't afford the $20 million ticket to ride a russian rocket should catch this imax offering . ","  the turntable is now outselling the electric guitar . . .  ","transforms one of [shakespeare's] deepest tragedies into a smart new comedy . ","an intelligent and deeply felt work about impossible , irrevocable choices and the price of making them . ","it may sound like a mere disease-of- the-week tv movie , but a song for martin is made infinitely more wrenching by the performances of real-life spouses seldahl and wollter . ","sayles is making a statement about the inability of dreams and aspirations to carry forward into the next generation . ","as antonia is assimilated into this newfangled community , the film settles in and becomes compulsively watchable in a guilty-pleasure , daytime-drama sort of fashion . ","every once in a while , a movie will come along that turns me into that annoying specimen of humanity that i usually dread encountering the most - the fanboy","on its own staggeringly unoriginal terms , this gender-bending comedy is generally quite funny . ","it's never dull and always looks good . ","the tonal shifts are jolting , and though wen's messages are profound and thoughtfully delivered , more thorough transitions would have made the film more cohesive . ","chicago pode até ser um filme divertido e cativante ( como é ) , mas acaba representando um passo que vai na direção contrária à evolução dos musicais . ","as commander-in-chief of this film , bigelow demonstrates a breadth of vision and an attention to detail that propels her into the upper echelons of the directing world . ","with wit and empathy to spare , waydowntown acknowledges the silent screams of workaday inertia but stops short of indulging its characters' striving solipsism . ","all of it works smoothly under the direction of spielberg , who does a convincing impersonation here of a director enjoying himself immensely . ","the kind of sweet-and-sour insider movie that film buffs will eat up like so much gelati . ","with 'bowling for columbine , ' michael moore gives us the perfect starting point for a national conversation about guns , violence , and fear . ","one of the year's most weirdly engaging and unpredictable character pieces . ","one of the best inside-show-biz yarns ever . ","none of his actors stand out , but that's less of a problem here than it would be in another film : characterization matters less than atmosphere . ","a terrifically entertaining specimen of spielbergian sci-fi . ","a rare and lightly entertaining look behind the curtain that separates comics from the people laughing in the crowd . ","solondz is so intent on hammering home his message that he forgets to make it entertaining . ","whatever heartwarming scene the impressively discreet filmmakers may have expected to record with their mini dv , they show a remarkable ability to document both sides of this emotional car-wreck . ","it establishes its ominous mood and tension swiftly , and if the suspense never rises to a higher level , it is nevertheless maintained throughout . ","although what time offers tsai's usual style and themes , it has a more colorful , more playful tone than his other films . ","a moving and stark reminder that the casualties of war reach much further than we imagine . ","a thoroughly engaging , surprisingly touching british comedy . ","a sloppy , amusing comedy that proceeds from a stunningly unoriginal premise . "," . . . a rich and intelligent film that uses its pulpy core conceit to probe questions of attraction and interdependence and how the heart accomodates practical needs . it is an unstinting look at a collaboration between damaged people that may or may not qual","captures that perverse element of the kafkaesque where identity , overnight , is robbed and replaced with a persecuted  other .  ","the actors are simply too good , and the story too intriguing , for technical flaws to get in the way . ","an estrogen opera so intensely feminine that it serves as the antidote ( and cannier doppelganger ) to diesel's xxx flex-a-thon . ","imamura has said that warm water under a red bridge is a poem to the enduring strengths of women . it may also be the best sex comedy about environmental pollution ever made . ","it's a ripper of a yarn and i for one enjoyed the thrill of the chill . naomi watts is terrific as rachel ; her petite frame and vulnerable persona emphasising her plight and isolation . ","a family film that contains some hefty thematic material on time , death , eternity , and what is needed to live a rich and full life . ","with dickens' words and writer-director douglas mcgrath's even-toned direction , a ripping good yarn is told . ","exactly what its title implies : lusty , boisterous and utterly charming . ","the film is darkly funny in its observation of just how much more grueling and time-consuming the illusion of work is than actual work . ","a smart , compelling drama . ","a must-see for fans of thoughtful war films and those interested in the sights and sounds of battle . ","i found myself liking the film , though in this case one man's treasure could prove to be another man's garbage . "," . . . rogers's mouth never stops shut about the war between the sexes and how to win the battle . ","deliberately and skillfully uses ambiguity to suggest possibilities which imbue the theme with added depth and resonance . ","it's all entertaining enough , but don't look for any hefty anti-establishment message in what is essentially a whip-crack of a buddy movie that ends with a whimper . ","nicholson's understated performance is wonderful . as warren he stumbles in search of all the emotions and life experiences he's neglected over the years . ","despite its old-hat set-up and predictable plot , empire still has enough moments to keep it entertaining . ","another entertaining romp from robert rodriguez . ","it's not a classic spy-action or buddy movie , but it's entertaining enough and worth a look . ","i am more offended by his lack of faith in his audience than by anything on display here . ","a sharp satire of desperation and cinematic deception . ","tsai convincingly paints a specifically urban sense of disassociation here . ","if you can swallow its absurdities and crudities lagaan really is enormously good fun . ","an unorthodox little film noir organized crime story that includes one of the strangest love stories you will ever see . ","a pleasing , often-funny comedy . ","[a] rare movie that makes us re-assess the basis for our lives and evaluate what is truly ours in a world of meaningless activity . ","all three actresses are simply dazzling , particularly balk , who's finally been given a part worthy of her considerable talents . ","an asian neo-realist treasure . ","plummer steals the show without resorting to camp as nicholas' wounded and wounding uncle ralph . it's a great performance and a reminder of dickens' grandeur . "," . . . less a story than an inexplicable nightmare , right down to the population's shrugging acceptance to each new horror . ","i am highly amused by the idea that we have come to a point in society where it has been deemed important enough to make a film in which someone has to be hired to portray richard dawson . ","a compassionate , moving portrait of an american ( and an america ) always reaching for something just outside his grasp . ","'estupendamente actuada , sumamente emotiva y profundamente humana , es una experiencia fílmica imposible de olvidar'","an original little film about one young woman's education . ","the film is about the relationships rather than about the outcome . and it sees those relationships , including that between the son and his wife , and the wife and the father , and between the two brothers , with incredible subtlety and acumen . ","one of those terrific documentaries that collect a bunch of people who are enthusiastic about something and then figures out how to make us share their enthusiasm . ","an instance of an old dog not only learning but inventing a remarkable new trick . ","rodriguez has the chops of a smart-aleck film school brat and the imagination of a big kid . . . ","amy and matthew have a bit of a phony relationship , but the film works in spite of it . ","garcia and the other actors help make the wobbly premise work . ","it's surprisingly decent , particularly for a tenth installment in a series . ","a fascinating , unnerving examination of the delusions of one unstable man . ","good , solid storytelling . ","it's no accident that the accidental spy is a solid action pic that returns the martial arts master to top form . ","leave it to the french to truly capture the terrifying angst of the modern working man without turning the film into a cheap thriller , a dumb comedy or a sappy melodrama . ","the director , mark pellington , does a terrific job conjuring up a sinister , menacing atmosphere though unfortunately all the story gives us is flashing red lights , a rattling noise , and a bump on the head . ","heartwarming here relies less on forced air than on petter næss' delicate , clever direction . . . and a wonderful , imaginative script by axel hellstenius . ","makes the case for a strong education and good teachers being more valuable in the way they help increase an average student's self-esteem , and not strictly in the knowledge imparted . ","steers refreshingly clear of the usual cliches . ","  home movie  is a sweet treasure and something well worth your time . ","highly recommended viewing for its courage , ideas , technical proficiency and great acting . ","the movie's thesis -- elegant technology for the masses -- is surprisingly refreshing . ","scott delivers a terrific performance in this fascinating portrait of a modern lothario . "," . . . wallace is smart to vary the pitch of his movie , balancing deafening battle scenes with quieter domestic scenes of women back home receiving war department telegrams . ","combines sharp comedy , old-fashioned monster movie atmospherics , and genuine heart to create a film that's not merely about kicking undead * * * , but also about dealing with regret and , ultimately , finding redemption . ","while most films these days are about nothing , this film seems to be about everything that's plaguing the human spirit in a relentlessly globalizing world . ","marshall puts a suspenseful spin on standard horror flick formula . ","as lively an account as seinfeld is deadpan . ","though lan yu lacks a sense of dramatic urgency , the film makes up for it with a pleasing verisimilitude . ","you may leave the theater with more questions than answers , but darned if your toes won't still be tapping . ","take any 12-year-old boy to see this picture , and he'll be your slave for a year . ","but this is not a movie about an inhuman monster ; it's about a very human one . ","at times the guys taps into some powerful emotions , but this kind of material is more effective on stage . it's not a motion picture ; it's an utterly static picture . ","what makes it worth watching is quaid's performance . ","soderbergh skims the fat from the 1972 film . what's left is a rich stew of longing . ","it's the brilliant surfing photography bringing you right inside the massive waves that lifts blue crush into one of the summer's most pleasurable movies . ","more of the same from taiwanese auteur tsai ming-liang , which is good news to anyone who's fallen under the sweet , melancholy spell of this unique director's previous films . ","hatfield and hicks make the oddest of couples , and in this sense the movie becomes a study of the gambles of the publishing world , offering a case study that exists apart from all the movie's political ramifications . ","infidelity drama is nicely shot , well-edited and features a standout performance by diane lane . ","best of all is garcia , who perfectly portrays the desperation of a very insecure man . ","the filmmakers try to balance pointed , often incisive satire and unabashed sweetness , with results that are sometimes bracing , sometimes baffling and quite often , and in unexpected ways , touching . ","a sobering and powerful documentary about the most severe kind of personal loss : rejection by one's mother . ","audacious-impossible yet compelling . . . ","often overwrought and at times positively irritating , the film turns into an engrossing thriller almost in spite of itself . ","humorous and heartfelt , douglas mcgrath's version of 'nicholas nickleby' left me feeling refreshed and hopeful . not many movies have that kind of impact on me these days . ","a poignant lyricism runs through balzac and the little chinese seamstress that transforms this story about love and culture into a cinematic poem . ","this is so de palma . if you love him , you'll like it . if you don't . . . well , skip to another review . ","rouge is less about a superficial midlife crisis than it is about the need to stay in touch with your own skin , at 18 or 80 . ","the moral shrapnel and mental shellshock will linger long after this film has ended . ","o Último suspeito ganha força ao também funcionar em uma esfera adicional : a do drama familiar . ","unfolds in a series of achronological vignettes whose cumulative effect is chilling . ","the movie enters a realm where few non-porn films venture , and comes across as darkly funny , energetic , and surprisingly gentle . ","although the subject matter may still be too close to recent national events , the film works - mostly due to its superior cast of characters . ","it's not going to be everyone's bag of popcorn , but it definitely gives you something to chew on . ","huppert and girardot give performances of exceptional honesty . ","it has that rare quality of being able to creep the living hell out of you . . . ","a cautionary tale about the grandiosity of a college student who sees himself as impervious to a fall . ","an infinitely wittier version of the home alone formula . ","feardotcom's thrills are all cheap , but they mostly work . ","[hayek] throws herself into this dream hispanic role with a teeth-clenching gusto , she strikes a potent chemistry with molina and she gradually makes us believe she is kahlo . ","mr . deeds is , as comedy goes , very silly -- and in the best way . ","you could love safe conduct ( laissez passer ) for being a subtitled french movie that is 170 minutes long . you could hate it for the same reason . ","with we were soldiers , hollywood makes a valiant attempt to tell a story about the vietnam war before the pathology set in . ","'moore is like a progressive bull in a china shop , a provocateur crashing into ideas and special-interest groups as he slaps together his own brand of liberalism . '","broomfield reveals an ironic manifestation of institutionalized slavery that ties a black-owned record label with a white-empowered police force . ","at just over an hour , home movie will leave you wanting more , not to mention leaving you with some laughs and a smile on your face . ","stuart's poor-me persona needs a whole bunch of snowball's cynicism to cut through the sugar coating . but once the falcon arrives in the skies above manhattan , the adventure is on red alert . ","there is greatness here . ","boasts enough funny dialogue and sharp characterizations to be mildly amusing . ","director juan jose campanella could have turned this into an argentine retread of  iris  or  american beauty ,  but instead pulls a little from each film and creates something more beautiful than either of those films . ","if you love the music , and i do , its hard to imagine having more fun watching a documentary . . . ","nakata's technique is to imply terror by suggestion , rather than the overuse of special effects . ","  13 conversations about one thing  is an intelligent flick that examines many different ideas from happiness to guilt in an intriguing bit of storytelling . ","satin rouge is not a new , or inventive , journey , but it's encouraging to see a three-dimensional , average , middle-aged woman's experience of self-discovery handled with such sensitivity . ","though an important political documentary , this does not really make the case the kissinger should be tried as a war criminal . ","cannon's confidence and laid-back good spirits are , with the drumming routines , among the film's saving graces . ","in its understanding , often funny way , it tells a story whose restatement is validated by the changing composition of the nation . ","she may not be real , but the laughs are . ","a fiercely clever and subtle film , capturing the precarious balance between the extravagant confidence of the exiled aristocracy and the cruel earnestness of the victorious revolutionaries . ","ok arthouse . the power of this script , and the performances that come with it , is that the whole damned thing didn't get our moral hackles up . ","the movie itself is far from disappointing , offering an original take on courtroom movies , a few nifty twists that are so crucial to the genre and another first-rate performance by top-billed star bruce willis . ","about schmidt is undoubtedly one of the finest films of the year . if you're not deeply touched by this movie , check your pulse . ","the charm of revolution os is rather the way it introduces you to new , fervently held ideas and fanciful thinkers . ","until its final minutes this is a perceptive study of two families in crisis -- and of two girls whose friendship is severely tested by bad luck and their own immaturity . ","offers the flash of rock videos fused with solid performances and eerie atmosphere . ","filmmakers dana janklowicz-mann and amir mann area headed east , far east , in retelling a historically significant , and personal , episode detailing how one international city welcomed tens of thousands of german jewish refugees while the world's democracie","for all its problems . . . the lady and the duke surprisingly manages never to grow boring . . . which proves that rohmer still has a sense of his audience . ","an edifying glimpse into the wit and revolutionary spirit of these performers and their era . ","craig bartlett and director tuck tucker should be commended for illustrating the merits of fighting hard for something that really matters . ","the film is saved from aren't-kids-cute sentimentality by a warmth that isn't faked and a stately sense of composition . ","this is one of the year's best films . ","a fleet-footed and pleasingly upbeat family diversion . ","sorvino is delightful in the central role . she nearly glows with enthusiasm , sensuality and a conniving wit . ","it's immensely ambitious , different than anything that's been done before and amazingly successful in terms of what it's trying to do . ","the story , once it gets rolling , is nothing short of a great one . ","great performances , stylish cinematography and a gritty feel help make gangster no . 1 a worthwhile moviegoing experience . ","  mr . deeds  is suitable summer entertainment that offers escapism without requiring a great deal of thought . ","it's an ambitious film , and as with all ambitious films , it has some problems . but on the whole , you're gonna like this movie . ","chaiken ably balances real-time rhythms with propulsive incident . ","this is an extraordinary film , not least because it is japanese and yet feels universal . ","in a summer overrun with movies dominated by cgi aliens and super heroes , it revigorates the mind to see a feature that concentrates on people , a project in which the script and characters hold sway . ","there's just something about watching a squad of psychopathic underdogs whale the tar out of unsuspecting lawmen that reaches across time and distance . ","a funny and touching film that is gorgeously acted by a british cast to rival gosford park's . ","there's nothing more satisfying during a summer of event movies than a spy thriller like the bourne identity that's packed with just as much intelligence as action . ","i'm not generally a fan of vegetables but this batch is pretty cute . ","qutting may be a flawed film , but it is nothing if not sincere . ","beautifully crafted , engaging filmmaking that should attract upscale audiences hungry for quality and a nostalgic , twisty yarn that will keep them guessing . ","a thoughtful and surprisingly affecting portrait of a screwed-up man who dared to mess with some powerful people , seen through the eyes of the idealistic kid who chooses to champion his ultimately losing cause . ","a cultural wildcard experience : wacky , different , unusual , even nutty . ","daughter from danang reveals that efforts toward closure only open new wounds . it doesn't flinch from its unsettling prognosis , namely , that the legacy of war is a kind of perpetual pain . ","for most of its footage , the new thriller proves that director m . night shyamalan can weave an eerie spell and that mel gibson can gasp , shudder and even tremble without losing his machismo . ","this is not an easy film . but it could be , by its art and heart , a necessary one . ","a very good film sits in the place where a masterpiece should be . "," . . . spellbinding fun and deliciously exploitative . ","it's jagger's bone-dry , mournfully brittle delivery that gives the film its bittersweet bite . ","impossible as it may sound , this film's heart is even more embracing than monty , if only because it accepts nasty behavior and severe flaws as part of the human condition . ","despite the predictable parent vs . child coming-of-age theme , first-class , natural acting and a look at  the real americans  make this a charmer . ","one of the smarter offerings the horror genre has produced in recent memory , even if it's far tamer than advertised . ","one of recent memory's most thoughtful films about art , ethics , and the cost of moral compromise . ","the film doesn't sustain its initial promise with a jarring , new-agey tone creeping into the second half","blade ii is as estrogen-free as movies get , so you might want to leave your date behind for this one , or she's gonna make you feel like you owe her big-time . ","the message is that even the most unlikely can link together to conquer all kinds of obstacles , whether they be of nature , of man or of one another . ","many a parent and their teen ( or preteen ) kid could bond while watching a walk to remember . so could young romantics out on a date . ","all leather pants & augmented boobs , hawn is hilarious as she tries to resuscitate the fun-loving libertine lost somewhere inside the conservative , handbag-clutching sarandon . ","the members manage to pronounce kok exactly as you think they might , thus giving the cast ample opportunity to use that term as often as possible . it's very beavis and butthead , yet always seems to elicit a chuckle . ","while this gentle and affecting melodrama will have luvvies in raptures , it's far too slight and introspective to appeal to anything wider than a niche audience . ","chicago offers much colorful eye candy , including the spectacle of gere in his dancing shoes , hoofing and crooning with the best of them . ","a difficult but worthy film that bites off more than it can chew by linking the massacre of armenians in 1915 with some difficult relationships in the present . ","by and large this is mr . kilmer's movie , and it's his strongest performance since the doors . ","some of the most ravaging , gut-wrenching , frightening war scenes since  saving private ryan  have been recreated by john woo in this little-known story of native americans and their role in the second great war . ","a charming but slight comedy . ","henry bean's thoughtful screenplay provides no easy answers , but offers a compelling investigation of faith versus intellect","a great cast and a wonderful but sometimes confusing flashback movie about growing up in a dysfunctional family . ","playing a role of almost bergmanesque intensity . . . bisset is both convincing and radiant . ","a smart , provocative drama that does the nearly impossible : it gets under the skin of a man we only know as an evil , monstrous lunatic . ","an alternately fascinating and frustrating documentary . ","griffin & co . manage to be spectacularly outrageous . ","nair's cast is so large it's altman-esque , but she deftly spins the multiple stories in a vibrant and intoxicating fashion . ","the movie plays up the cartoon's more obvious strength of snazziness while neglecting its less conspicuous writing strength . ","poignant japanese epic about adolescent anomie and heartbreak . ","we've seen it all before in one form or another , but director hoffman , with great help from kevin kline , makes us care about this latest reincarnation of the world's greatest teacher . ","secretary is not a movie about fetishism . it is a movie about passion . ","even though it's common knowledge that park and his founding partner , yong kang , lost kozmo in the end , you can't help but get caught up in the thrill of the company's astonishing growth . ","although some viewers will not be able to stomach so much tongue-in-cheek weirdness , those who do will have found a cult favorite to enjoy for a lifetime . ","what could have easily become a cold , calculated exercise in postmodern pastiche winds up a powerful and deeply moving example of melodramatic moviemaking . ","a delightful surprise because despite all the backstage drama , this is a movie that tells stories that work -- is charming , is moving , is funny and looks professional . ","the imax screen enhances the personal touch of manual animation . ","does an impressive job of relating the complicated history of the war and of filling in the background . ","it's all about anakin . . . and the lustrous polished visuals rich in color and creativity and , of course , special effect . ","lacks the inspiration of the original and has a bloated plot that stretches the running time about 10 minutes past a child's interest and an adult's patience . but it also has many of the things that made the first one charming . ","it's funny , touching , dramatically forceful , and beautifully shot . ","its rawness and vitality give it considerable punch . ","a live-wire film that never loses its ability to shock and amaze . ","the year's greatest adventure , and jackson's limited but enthusiastic adaptation has made literature literal without killing its soul -- a feat any thinking person is bound to appreciate . ","it's fairly solid--not to mention well edited so that it certainly doesn't feel like a film that strays past the two and a half mark . ","brims with passion : for words , for its eccentric , accident-prone characters , and for the crazy things that keep people going in this crazy life . ","it's secondary to american psycho but still has claws enough to get inside you and stay there for a couple of hours . ","the hours , a delicately crafted film , is an impressive achievement in spite of a river of sadness that pours into every frame . ","fudges fact and fancy with such confidence that we feel as if we're seeing something purer than the real thing . ","this is unusual , food-for-thought cinema that's as entertaining as it is instructive . ","with an expressive face reminiscent of gong li and a vivid personality like zhang ziyi's , dong stakes out the emotional heart of happy . ","nohe's documentary about the event is sympathetic without being gullible : he isn't blind to the silliness , but also captures moments of spontaneous creativity and authentic co-operative interaction . ","it may not be as cutting , as witty or as true as back in the glory days of weekend and two or three things i know about her , but who else engaged in filmmaking today is so cognizant of the cultural and moral issues involved in the process ? ","secret ballot is a funny , puzzling movie ambiguous enough to be engaging and oddly moving . ","although devoid of objectivity and full of nostalgic comments from the now middle-aged participants , dogtown and z-boys has a compelling story to tell . ","it's got some pretentious eye-rolling moments and it didn't entirely grab me , but there's stuff here to like . ","birthday girl walks a tricky tightrope between being wickedly funny and just plain wicked . ","a muted freak-out","the enjoyable undercover brother , a zany mix of saturday night live-style parody , '70s blaxploitation films and goofball action comedy gone wild , dishes out a ton of laughs that everyone can enjoy . ","brings an irresistible blend of warmth and humor and a consistent embracing humanity in the face of life's harshness . ","jackson is always watchable . ","to the degree that ivans xtc . works , it's thanks to huston's revelatory performance . ","a wild ride of a movie that keeps throwing fastballs . ","confessions is without a doubt a memorable directorial debut from king hunk . ","weird , vulgar comedy that's definitely an acquired taste . ","a . . . cynical and serious look at teenage boys doing what they do best - being teenagers . ","the film is a very good viewing alternative for young women . ","australian filmmaker david flatman uses the huge-screen format to make an old-fashioned nature film that educates viewers with words and pictures while entertaining them . ","a dazzling dream of a documentary . ","a keep-'em-guessing plot and an affectionate take on its screwed-up characters . ","moving and vibrant . ","brave and sweetly rendered love story . ","the film proves unrelentingly grim -- and equally engrossing . ","a hallmark film in an increasingly important film industry and worth the look . ","the last kiss will probably never achieve the popularity of my big fat greek wedding , but its provocative central wedding sequence has far more impact . ","if you like blood , guts and crazy beasts stalking men with guns though . . . you will likely enjoy this monster . ","the difference between cho and most comics is that her confidence in her material is merited . ","sad to say -- it accurately reflects the rage and alienation that fuels the self-destructiveness of many young people . ","there is a strong directorial stamp on every frame of this stylish film that is able to visualize schizophrenia but is still confident enough to step back and look at the sick character with a sane eye . ","'anyone with a passion for cinema , and indeed sex , should see it as soon as possible . '","seeks to transcend its genre with a curiously stylized , quasi-shakespearean portrait of pure misogynist evil . ","mordantly funny and intimately knowing . . . ","what makes the movie special is its utter sincerity . ","fast and funny , an action cartoon that's suspenseful enough for older kids but not too scary for the school-age crowd . ","one of those rare films that come by once in a while with flawless amounts of acting , direction , story and pace . ","the aaa of action , xxx is a blast of adrenalin , rated eee for excitement . and vin diesel is the man . ","earnest , unsubtle and hollywood-predictable , green dragon is still a deeply moving effort to put a human face on the travail of thousands of vietnamese . ","an ambitious movie that , like shiner's organizing of the big fight , pulls off enough of its effects to make up for the ones that don't come off . ","nair and writer laura cahill dare to build a movie around some flawed but rather unexceptional women , emerging with a fine character study that's short on plot but rich in the tiny revelations of real life . ","the film's unhurried pace is actually one of its strengths . entirely appropriately , the tale unfolds like a lazy summer afternoon and concludes with the crisp clarity of a fall dawn . ","despite its floating narrative , this is a remarkably accessible and haunting film . ","vibrantly colored and beautifully designed , metropolis is a feast for the eyes . ","sweetly sexy , funny and touching . "," . . . while dark water isn't a complete wash ( no pun intended ) , watched side-by-side with ringu , it ultimately comes off as a pale successor . ","is truth stranger than fiction ? in [screenwriter] charlie kaufman's world , truth and fiction are equally strange , and his for the taking . ","for decades we've marveled at disney's rendering of water , snow , flames and shadows in a hand-drawn animated world . prepare to marvel again . ","a witty , low-key romantic comedy . ","more good than great but freeman and judd make it work . ","if you're looking for a smart , nuanced look at de sade and what might have happened at picpus , sade is your film . ","could have been crisper and punchier , but it's likely to please audiences who like movies that demand four hankies . ","together writer-director danny verete's three tales comprise a powerful and reasonably fulfilling gestalt . ","bursting through the constraints of its source , this is one adapted- from-television movie that actually looks as if it belongs on the big screen . "," . . . quite endearing . ","its almost too-spectacular coastal setting distracts slightly from an eccentric and good-naturedly aimless story . ","in other words , it's just another sports drama/character study . yet this one makes up for in heart what it lacks in outright newness . plus , like i already mentioned . . . it's robert duvall ! c'mon ! ","this story of a determined woman's courage to find her husband in a war zone offers winning performances and some effecting moments . ","like shrek , spirit's visual imagination reminds you of why animation is such a perfect medium for children , because of the way it allows the mind to enter and accept another world . ","a modestly made but profoundly moving documentary . ","it irritates and saddens me that martin lawrence's latest vehicle can explode obnoxiously into 2 , 500 screens while something of bubba ho-tep's clearly evident quality may end up languishing on a shelf somewhere . ","not everything in this ambitious comic escapade works , but coppola , along with his sister , sofia , is a real filmmaker . it must be in the genes . ","the performers are so spot on , it is hard to conceive anyone else in their roles . ","this slight premise . . . works because of the ideal casting of the masterful british actor ian holm as the aged napoleon . ","hashiguchi covers this territory with wit and originality , suggesting that with his fourth feature -- the first to be released in the u . s . -- a major director is emerging in world cinema . ","although the film boils down to a lightweight story about matchmaking , the characters make italian for beginners worth the journey","the dragons are the real stars of reign of fire and you won't be disappointed . ","kudos to the most enchanting film of the year . ","it works well enough , since the thrills pop up frequently , and the dispatching of the cast is as often imaginative as it is gory . ","colorful and deceptively buoyant until it suddenly pulls the rug out from under you , burkinabe filmmaker dani kouyate's reworking of a folk story whose roots go back to 7th-century oral traditions is also a pointed political allegory . ","it's a powerful though flawed movie , guaranteed to put a lump in your throat while reaffirming washington as possibly the best actor working in movies today . ","director paul cox's unorthodox , abstract approach to visualizing nijinsky's diaries is both stimulating and demanding . ","for 95 often hilarious minutes , [cho] riffs on the diciness of colonics , on straight versus gay personal ads , on how men would act if they had periods , and on the perils of a certain outré sexual practice . ","most of the things that made the original men in black such a pleasure are still there . ","mostly honest , this somber picture reveals itself slowly , intelligently , artfully . ","best enjoyed as a work of fiction inspired by real-life events . those seeking a definitive account of eisenstein's life would do better elsewhere . ","[westbrook] makes a wonderful subject for the camera . ","a film that's flawed and brilliant in equal measure . ","even if invincible is not quite the career peak that the pianist is for roman polanski , it demonstrates that werner herzog can still leave us with a sense of wonder at the diverse , marvelously twisted shapes history has taken . ","ultimately too repellent to fully endear itself to american art house audiences , but it is notable for its stylistic austerity and forcefulness . ","hardly a film that comes along every day . ","harmless fun . ","a wild ride with eight boarders from venice beach that was a deserved co-winner of the audience award for documentaries at the sundance film festival . ","the film's only missteps come from the script's insistence on providing deep emotional motivation for each and every one of abagnale's antics . ","a sweet , tender sermon about a 12-year-old welsh boy more curious about god than girls , who learns that believing in something does matter . ","the film belongs to the marvelous verdu , a sexy slip of an earth mother who mourns her tragedies in private and embraces life in public","more intimate than spectacular , e . t . is carried less by wow factors than by its funny , moving yarn that holds up well after two decades . ","for once , a movie does not proclaim the truth about two love-struck somebodies , but permits them time and space to convince us of that all on their own . ","if you're burnt out on it's a wonderful life marathons and bored with a christmas carol , it might just be the movie you're looking for . it depends on how well flatulence gags fit into your holiday concept . ","moonlight mile doesn't quite go the distance but the cast is impressive and they all give life to these broken characters who are trying to make their way through this tragedy . ","it is an indelible epic american story about two families , one black and one white , facing change in both their inner and outer lives . ","not as well-written as sexy beast , not as gloriously flippant as lock , stock and two smoking barrels , but stylish and moody and exceptionally well-acted . ","quite simply , a joy to watch and--especially--to listen to . ","a flawed film but an admirable one that tries to immerse us in a world of artistic abandon and political madness and very nearly succeeds . ","the filmmakers wisely decided to let crocodile hunter steve irwin do what he does best , and fashion a story around him . ","a winning and wildly fascinating work . ","we do get the distinct impression that this franchise is drawing to a close . ","worth catching for griffiths' warm and winning central performance . ","the tone errs on the shrill side , tempered by a soft southern gentility that speaks of beauty , grace and a closet full of skeletons . ","an interesting psychological game of cat-and-mouse , three-dimensional characters and believable performances all add up to a satisfying crime drama . ","a meatier deeper beginning and/or ending would have easily tipped this film into the  a  range , as is , it's a very very strong  b+ .  i love the robust middle of this picture . ","the power of shanghai ghetto , a documentary by dana janklowicz-mann and amir mann , rests in the voices of men and women , now in their 70s , who lived there in the 1940s . ","maintains your interest until the end and even leaves you with a few lingering animated thoughts . ","there is a beautiful , aching sadness to it all . paul cox needed to show it . it is up to you to decide if you need to see it . ","if divine secrets of the ya-ya sisterhood suffers from a ploddingly melodramatic structure , it comes to life in the performances . ","if you ignore the cliches and concentrate on city by the sea's interpersonal drama , it ain't half-bad . ","alternates between deadpan comedy and heartbreaking loneliness and isn't afraid to provoke introspection in both its characters and its audience . ","there aren't too many films that can be as simultaneously funny , offbeat and heartwarming ( without a thick shmear of the goo , at least ) , but  elling  manages to do all three quite well , making it one of the year's most enjoyable releases . ","reign of fire is hardly the most original fantasy film ever made -- beyond road warrior , it owes enormous debts to aliens and every previous dragon drama -- but that barely makes it any less entertaining . ","an earnest , roughshod document , it serves as a workable primer for the region's recent history , and would make a terrific 10th-grade learning tool . ","samuel beckett applied to the iranian voting process . ","the bard as black comedy -- willie would have loved it . ","another trumpet blast that there may be a new mexican cinema a-bornin' . ","' . . . the film's considered approach to its subject matter is too calm and thoughtful for agitprop , and the thinness of its characterizations makes it a failure as straight drama . '","tadpole may be one of the most appealing movies ever made about an otherwise appalling , and downright creepy , subject -- a teenage boy in love with his stepmother . ","this is a story that zings all the way through with originality , humour and pathos . ","as underwater ghost stories go , below casts its spooky net out into the atlantic ocean and spits it back , grizzled and charred , somewhere northwest of the bermuda triangle . ","it is a challenging film , if not always a narratively cohesive one . ","trapped won't score points for political correctness , but it may cause parents a few sleepless hours -- a sign of its effectiveness . ","a rock-solid gangster movie with a fair amount of suspense , intriguing characters and bizarre bank robberies , plus a heavy dose of father-and-son dynamics . ","it's incredible the number of stories the holocaust has generated . just when you think that every possible angle has been exhausted by documentarians , another new film emerges with yet another remarkable yet shockingly little-known perspective . ","as they used to say in the 1950s sci-fi movies , signs is a tribute to shyamalan's gifts , which are such that we'll keep watching the skies for his next project . ","there's no conversion effort , much of the writing is genuinely witty and both stars are appealing enough to probably have a good shot at a hollywood career , if they want one . ","like a skillful fisher , the director uses the last act to reel in the audience since its poignancy hooks us completely . ","a film with contemporary political resonance illustrated by a winning family story . ","kids five and up will be delighted with the fast , funny , and even touching story . parents may even find that it goes by quickly , because it has some of the funniest jokes of any movie this year , including those intended for adults . ","an unsettling , memorable cinematic experience that does its predecessors proud . ","maid in manhattan might not look so appealing on third or fourth viewing down the road . . . but as a high concept vehicle for two bright stars of the moment who can rise to fans' lofty expectations , the movie passes inspection . ","much of all about lily chou-chou is mesmerizing : some of its plaintiveness could make you weep . ","ferrara's strongest and most touching movie of recent years . ","spielberg's first real masterpiece , it deserved all the hearts it won -- and wins still , 20 years later . ","the screenwriters dig themselves in deeper every time they toss logic and science into what is essentially a  dungeons and dragons  fantasy with modern military weaponry . . . ","more than simply a portrait of early extreme sports , this peek into the 1970s skateboard revolution is a skateboard film as social anthropology . . . ","what i saw , i enjoyed . ","good-naturedly cornball sequel . ","the level of acting elevates the material above pat inspirational status and gives it a sturdiness and solidity that we've long associated with washington the actor . ","a deft , delightful mix of sulky teen drama and overcoming-obstacles sports-movie triumph . ","daringly perceptive , taut , piercing and feisty , biggie and tupac is undeniably subversive and involving in its bold presentation . ","delivers more than its fair share of saucy hilarity . ","a fairly enjoyable mixture of longest yard . . . and the 1999 guy ritchie caper lock stock and two smoking barrels . ","happily , some things are immune to the folly of changing taste and attitude . for proof of that on the cinematic front , look no further than this 20th anniversary edition of the film that spielberg calls , retrospectively , his most personal work yet . ","hugely entertaining from start to finish , featuring a fall from grace that still leaves shockwaves , it will gratify anyone who has ever suspected hollywood of being overrun by corrupt and hedonistic weasels . ","it's not like having a real film of nijinsky , but at least it's better than that eponymous 1980 biopic that used soap in the places where the mysteries lingered . ","it's probably worth catching solely on its visual merits . if only it had the story to match . ","like other great documentaries . . . this goes after one truth ( the ford administration's complicity in tearing 'orphans' from their mothers ) and stumbles upon others even more compelling . "," . . . only bond can save us from the latest eccentric , super-wealthy megalomaniac bent on world domination and destruction . ","the first half bursts with a goofy energy previous disney films only used for a few minutes here and there . ","it's quite diverting nonsense . ","an old-fashioned scary movie , one that relies on lingering terror punctuated by sudden shocks and not constant bloodshed punctuated by flying guts . ","for all the wit and hoopla , festival in cannes offers rare insight into the structure of relationships . ","what makes how i killed my father compelling , besides its terrific performances , is fontaine's willingness to wander into the dark areas of parent-child relationships without flinching . ","renner ? s face is chillingly unemotive , yet he communicates a great deal in his performance . see it for his performance if nothing else . "," . . . the kind of entertainment that parents love to have their kids see . ","it's a fine , focused piece of work that reopens an interesting controversy and never succumbs to sensationalism . ","its engaging simplicity is driven by appealing leads . ","swimming is above all about a young woman's face , and by casting an actress whose face projects that woman's doubts and yearnings , it succeeds . ","a respectable venture on its own terms , lacking the broader vision that has seen certain trek films . . . cross over to a more mainstream audience . ","it's weird , wonderful , and not necessarily for kids . ","an elegant film with often surprising twists and an intermingling of naiveté and sophistication . ","blessed with two fine , nuanced lead performances . ","while this has the making of melodrama , the filmmaker cuts against this natural grain , producing a work that's more interested in asking questions than in answering them . ","as a girl-meets-girl romantic comedy , kissing jessica steinis quirky , charming and often hilarious . yet it's not quite the genre-busting film it's been hyped to be because it plays everything too safe . ","you don't need to know your ice-t's from your cool-j's to realize that as far as these shootings are concerned , something is rotten in the state of california . ","turturro is fabulously funny and over the top as a 'very sneaky' butler who excels in the art of impossible disappearing/reappearing acts","meant for star wars fans . it is there to give them a good time . ","from a deceptively simple premise , this deeply moving french drama develops a startling story that works both as a detailed personal portrait and as a rather frightening examination of modern times . ","simply and eloquently articulates the tangled feelings of particular new yorkers deeply touched by an unprecedented tragedy . ","provides a very moving and revelatory footnote to the holocaust . ","terrific performances , great to look at , and funny . a little uneven to be the cat's meow , but it's good enough to be the purr . ","it's a compelling and horrifying story , and the laramie project is worthwhile for reminding us that this sort of thing does , in fact , still happen in america . ","i like it . there is a freedom to watching stunts that are this crude , this fast-paced and this insane . ","that rare documentary that incorporates so much of human experience -- drama , conflict , tears and surprise -- that it transcends the normal divisions between fiction and nonfiction film . ","that rare movie that works on any number of levels -- as a film of magic and whimsy for children , a heartfelt romance for teenagers and a compelling argument about death , both pro and con , for adults . ","it's both degrading and strangely liberating to see people working so hard at leading lives of sexy intrigue , only to be revealed by the dispassionate gantz brothers as ordinary , pasty lumpen . ","a sharp and quick documentary that is funny and pithy , while illuminating an era of theatrical comedy that , while past , really isn't . ","the script is smart , not cloying . ","the film does a solid job of slowly , steadily building up to the climactic burst of violence . ","fred schepisi's tale of four englishmen facing the prospect of their own mortality views youthful affluence not as a lost ideal but a starting point . ","the directive to protect the code at all costs also begins to blur as the importance of the man and the code merge","overall , cletis tout is a winning comedy that excites the imagination and tickles the funny bone . ","easily one of the best and most exciting movies of the year . ","the script manages the rare trick of seeming at once both refreshingly different and reassuringly familiar . ","an engaging , formulaic sports drama that carries a charge of genuine excitement . ","insomnia is one of the year's best films and pacino gives one of his most daring , and complicated , performances . ","like vardalos and corbett , who play their roles with vibrant charm , the film , directed by joel zwick , is heartfelt and hilarious in ways you can't fake . ","i don't know if frailty will turn bill paxton into an a-list director , but he can rest contentedly with the knowledge that he's made at least one damn fine horror movie . ","despite its flaws . . . belinsky is still able to create an engaging story that keeps you guessing at almost every turn . ","each punch seen through prison bars , the fights become not so much a struggle of man vs . man as brother-man vs . the man . ","the evocative imagery and gentle , lapping rhythms of this film are infectious -- it gets under our skin and draws us in long before the plot kicks into gear . ","like the best of godard's movies . . . it is visually ravishing , penetrating , impenetrable . ","horns and halos benefits from serendipity but also reminds us of our own responsibility to question what is told as the truth . ","oddly compelling . ","[has] an immediacy and an intimacy that sucks you in and dares you not to believe it's all true . ","it treats ana's journey with honesty that is tragically rare in the depiction of young women in film . ","captivates as it shows excess in business and pleasure , allowing us to find the small , human moments , and leaving off with a grand whimper . ","a refreshingly realistic , affectation-free coming-of-age tale . ","how good this film might be , depends if you believe that the shocking conclusion is too much of a plunge or not . ","great fun both for sports aficionados and for ordinary louts whose idea of exercise is climbing the steps of a stadium-seat megaplex . ","features one of the most affecting depictions of a love affair ever committed to film . ","to honestly address the flaws inherent in how medical aid is made available to american workers , a more balanced or fair portrayal of both sides will be needed . ","one of the best movies of the year . ","the usual movie rah-rah , pleasantly and predictably delivered in low-key style by director michael apted and writer tom stoppard . ","a superlative b movie -- funny , sexy , and rousing . ","those prone to indignation need not apply ; those susceptible to blue hilarity , step right up . ","witless but watchable . ","like mike isn't going to make box office money that makes michael jordan jealous , but it has some cute moments , funny scenes , and hits the target audience ( young bow wow fans ) - with nothing but net . ","[dong] makes a valiant effort to understand everyone's point of view , and he does such a good job of it that family fundamentals gets you riled up . ","the trick when watching godard is to catch the pitch of his poetics , savor the pleasure of his sounds and images , and ponder the historical , philosophical , and ethical issues that intersect with them . ","at its best , which occurs often , michael moore's bowling for columbine rekindles the muckraking , soul-searching spirit of the 'are we a sick society ? ' journalism of the 1960s . ","a modestly surprising movie . ","a headline-fresh thriller set among orthodox jews on the west bank , joseph cedar's time of favor manages not only to find a compelling dramatic means of addressing a complex situation , it does so without compromising that complexity . ","there's a spontaneity to the chateau , a sense of light-heartedness , that makes it attractive throughout . ","the first tunisian film i have ever seen , and it's also probably the most good-hearted yet sensual entertainment i'm likely to see all year . ","like any good romance , son of the bride , proves it's never too late to learn . ","[kline's] utterly convincing -- and deeply appealing -- as a noble teacher who embraces a strict moral code , and as a flawed human being who can't quite live up to it . ","the film , while not exactly assured in its execution , is notable for its sheer audacity and openness . ","a thoroughly enjoyable , heartfelt coming-of-age comedy . ","feeling like a dope has rarely been more fun than it is in nine queens . ","leigh makes these lives count . and he allows a gawky actor like spall -- who could too easily become comic relief in any other film -- to reveal his impressively delicate range . ","a lot of fun , with an undeniable energy sparked by two actresses in their 50s working at the peak of their powers . ","promises is one film that's truly deserving of its oscar nomination . ","what bubbles up out of john c . walsh's pipe dream is the distinct and very welcome sense of watching intelligent people making a movie they might actually want to watch . ","if reno is to the left of liberal on the political spectrum , her tough , funny , rather chaotic show isn't subversive so much as it is nit-picky about the hypocrisies of our time . ","beautiful , angry and sad , with a curious sick poetry , as if the marquis de sade had gone in for pastel landscapes . ","ms . hutchins is talented enough and charismatic enough to make us care about zelda's ultimate fate . ","monte cristo smartly emphasizes the well-wrought story and omits needless chase scenes and swordfights as the revenge unfolds . ","a mesmerizing cinematic poem from the first frame to the last . ","[it's] a clever thriller with enough unexpected twists to keep our interest . ","an undeniably moving film to experience , and ultimately that's what makes it worth a recommendation . ","nicole kidman evolved from star to superstar some time over the past year , which means that birthday girl is the kind of quirkily appealing minor movie she might not make for a while . ","vividly conveys the shadow side of the 30-year friendship between two english women . ","the story has some nice twists but the ending and some of the back-story is a little tired . the performances are all solid ; it merely lacks originality to make it a great movie . ","manages to please its intended audience -- children -- without placing their parents in a coma-like state . ","mr . deeds is sure to give you a lot of laughs in this simple , sweet and romantic comedy . ","when you think you've figured out bielinsky's great game , that's when you're in the most trouble : he's the con , and you're just the mark . ","a strong first act and absolutely , inescapably gorgeous , skyscraper-trapeze motion of the amazing spider-man . ","driven by a fantastic dual performance from ian holm . . . the film is funny , insightfully human and a delightful lark for history buffs . ","a well-put-together piece of urban satire . ","it's the sweet cinderella story that  pretty woman  wanted to be . ","it will make you think twice about what might be going on inside each trailer park you drive past -- even if it chiefly inspires you to drive a little faster . ","what doesn't this film have that an impressionable kid couldn't stand to hear ? ","what saves it . . . and makes it one of the better video-game-based flicks , is that the film acknowledges upfront that the plot makes no sense , such that the lack of linearity is the point of emotional and moral departure for protagonist alice . ","a deeply felt and vividly detailed story about newcomers in a strange new world . ","it's a visual delight and a decent popcorn adventure , as long as you don't try to look too deep into the story","it's a feel-good movie about which you can actually feel good . ","a full experience , a love story and a murder mystery that expands into a meditation on the deep deceptions of innocence . ","visually , 'santa clause 2' is wondrously creative . ","the powerpuff girls arrive on the big screen with their super-powers , their super-simple animation and their super-dooper-adorability intact . ","[raimi's] matured quite a bit with spider-man , even though it's one of the most plain white toast comic book films you'll ever see . ","a new film from bill plympton , the animation master , is always welcome . ","a devastating indictment of unbridled greed and materalism . ","what makes the film special is the refreshingly unhibited enthusiasm that the people , in spite of clearly evident poverty and hardship , bring to their music . ","the film has a kind of hard , cold effect . ","the gags are often a stitch . ","the asylum material is gripping , as are the scenes of jia with his family . ","a bonanza of wacky sight gags , outlandish color schemes , and corny visual puns that can be appreciated equally as an abstract frank tashlin comedy and as a playful recapitulation of the artist's career . ","one can't deny its seriousness and quality . ","good performances and a realistic , non-exploitive approach make paid in full worth seeing . ","this engrossing , characteristically complex tom clancy thriller is shifty in the manner in which it addresses current terrorism anxieties and sidesteps them at the same time . ","ryan gosling is , in a word , brilliant as the conflicted daniel . "," . . . somehow manages to escape the shackles of its own clichés to be the best espionage picture to come out in weeks . ","much of the lady and the duke is about quiet , decisive moments between members of the cultural elite as they determine how to proceed as the world implodes . ","takes a simple premise and carries it to unexpected heights . ","with few respites , marshall keeps the energy humming , and his edits , unlike those in moulin rouge , are crisp and purposeful without overdoing it . ","its metaphors are opaque enough to avoid didacticism , and the film succeeds as an emotionally accessible , almost mystical work . ","provides a satisfactory overview of the bizarre world of extreme athletes as several daredevils express their own views . ","inventive , fun , intoxicatingly sexy , violent , self-indulgent and maddening . ","hard to resist . ","comedian , like its subjects , delivers the goods and audiences will have a fun , no-frills ride . ","a naturally funny film , home movie makes you crave chris smith's next movie . ","pipe dream does have its charms . the leads are natural and lovely , the pace is serene , the humor wry and sprightly . ","those who want to be jolted out of their gourd should drop everything and run to ichi . ","a bittersweet contemporary comedy about benevolent deception , which , while it may not rival the filmmaker's period pieces , is still very much worth seeing . "," . . . enthusiastically invokes the percussion rhythm , the brass soul and the sense of fierce competition that helps make great marching bands half the fun of college football games . ","sheds light on a subject few are familiar with , and makes you care about music you may not have heard before . ","despite the film's bizarre developments , hoffman keeps us riveted with every painful nuance , unexpected flashes of dark comedy and the character's gripping humanity . ","to get at the root psychology of this film would require many sessions on the couch of dr . freud . ","great over-the-top moviemaking if you're in a slap-happy mood . ","viveka seldahl and sven wollter will touch you to the core in a film you will never forget -- that you should never forget . ","the magic ( and original running time ) of ace japanimator hayao miyazaki's spirited away survives intact in bv's re-voiced version . ","from the dull , surreal ache of mortal awareness emerges a radiant character portrait . ","captures the raw comic energy of one of our most flamboyant female comics . ","it's not particularly subtle . . . however , it still manages to build to a terrifying , if obvious , conclusion . ","the auteur's ear for the way fears and slights are telegraphed in the most blithe exchanges gives the film its lingering tug . ","bolstered by exceptional performances and a clear-eyed take on the economics of dealing and the pathology of ghetto fabulousness . ","this enthralling documentary . . . is at once playful and haunting , an in-depth portrait of an iconoclastic artist who was fundamentally unknowable even to his closest friends . ","some remarkable achival film about how shanghai ( of all places ) served jews who escaped the holocaust . ","in a movie full of surprises , the biggest is that secret ballot is a comedy , both gentle and biting . ","the urban landscapes are detailed down to the signs on the kiosks , and the color palette , with lots of somber blues and pinks , is dreamy and evocative . ","a manically generous christmas vaudeville . ","tony gayton's script doesn't give us anything we haven't seen before , but director d . j . caruso's grimy visual veneer and kilmer's absorbing performance increase the gravitational pull considerably . ","a psychic journey deep into the very fabric of iranian . . . life . ","it's a smartly directed , grown-up film of ideas . ","a true-blue delight . ","while puerile men dominate the story , the women shine . ","unlike lots of hollywood fluff , this has layered , well-developed characters and some surprises . ","for a film that's being advertised as a comedy , sweet home alabama isn't as funny as you'd hoped . for a film that's being advertised as a comedy , sweet home alabama isn't as funny as you'd hoped . ","vera has created a provocative , absorbing drama that reveals the curse of a self-hatred instilled by rigid social mores . ","a french film with a more down-home flavor . ","a fun ride . ","depending upon your reaction to this movie , you may never again be able to look at a red felt sharpie pen without disgust , a thrill , or the giggles . ","while bollywood/hollywood will undoubtedly provide its keenest pleasures to those familiar with bombay musicals , it also has plenty for those ( like me ) who aren't . ","there are times when you wish that the movie had worked a little harder to conceal its contrivances , but brown sugar turns out to be a sweet and enjoyable fantasy . ","fontaine masterfully creates a portrait of two strong men in conflict , inextricably entwined through family history , each seeing himself in the other , neither liking what he sees . ","one fantastic ( and educational ) documentary . ","as janice , eileen walsh , an engaging , wide-eyed actress whose teeth are a little too big for her mouth , infuses the movie with much of its slender , glinting charm . ","sure , it's contrived and predictable , but its performances are so well tuned that the film comes off winningly , even though it's never as solid as you want it to be . ","dong shows how intolerance has the power to deform families , then tear them apart . ","the chateau belongs to rudd , whose portrait of a therapy-dependent flakeball spouting french malapropisms . . . is a nonstop hoot . ","the cast , collectively a successful example of the lovable-loser protagonist , shows deft comic timing . ","it trusts the story it sets out to tell . ","i couldn't recommend this film more . ","as a good old-fashioned adventure for kids , spirit : stallion of the cimarron is a winner . ","an effective portrait of a life in stasis -- of the power of inertia to arrest development in a dead-end existence . ","succeeds as a well-made evocation of a subculture . "," . . . an interesting slice of history . ","me no lika da accents so good , but i thoroughly enjoyed the love story . scott baio is turning in some delightful work on indie projects . ","it's an experience in understanding a unique culture that is presented with universal appeal . ","what's surprising is how well it holds up in an era in which computer-generated images are the norm . ","brings together some of the biggest names in japanese anime , with impressive results . ","wonder , hope and magic can never escape the heart of the boy when the right movie comes along , especially if it begins with the name of star wars","a flick about our infantilized culture that isn't entirely infantile . ","an exceptionally acted , quietly affecting cop drama . ","sensual , funny and , in the end , very touching . ","angel presents events partly from the perspective of aurelie and christelle , and infuses the film with the sensibility of a particularly nightmarish fairytale . ","who needs mind-bending drugs when they can see this , the final part of the 'qatsi' trilogy , directed by godfrey reggio , with music by philip glass ? ","[a] smarter and much funnier version of the old police academy flicks . ","proof once again that if the filmmakers just follow the books , they can't go wrong . better effects , better acting and a hilarious kenneth branagh . an excellent sequel . ","both a grand tour through 300 hundred years of russian cultural identity and a stunning technical achievement . ","just how these families interact may surprise you . ","allen se atreve a atacar , a atacarse y nos ofrece gags que van de la sonrisa a la risa de larga duración","proves that some movie formulas don't need messing with -- like the big-bug movie . ","a surprisingly funny movie . ","this new movie version of the alexandre dumas classic is the stuff of high romance , brought off with considerable wit . ","like all of egoyan's work , ararat is fiercely intelligent and uncommonly ambitious . ","if a big musical number like 'praise the lord , he's the god of second chances' doesn't put you off , this will be an enjoyable choice for younger kids . "," . . . fuses the events of her life with the imagery in her paintings so vividly that the artist's work may take on a striking new significance for anyone who sees the film . ","[clooney's] debut can be accused of being a bit undisciplined , but it has a tremendous , offbeat sense of style and humor that suggests he was influenced by some of the filmmakers who have directed him , especially the coen brothers and steven soderbergh . ","although made on a shoestring and unevenly acted , conjures a lynch-like vision of the rotting underbelly of middle america . ","a piquant meditation on the things that prevent people from reaching happiness . ","a timely look back at civil disobedience , anti-war movements and the power of strong voices . ","rifkin's references are . . . impeccable throughout . ","i'd be lying if i said my ribcage didn't ache by the end of kung pow . ","more than their unique residences , home movie is about the people who live in them , who have carved their own comfortable niche in the world and have been kind enough to share it . ","the movie is ingenious fun . see it . ","the combination of lightness and strictness in this instance gives italian for beginners an amiable aimlessness that keeps it from seeming predictably formulaic . ","una película oscura , precisa , por momentos grandiosa y casi siempre conmovedora . ","the script is smart and dark - hallelujah for small favors . ","an intelligent , multi-layered and profoundly humanist ( not to mention gently political ) meditation on the values of knowledge , education , and the affects of cultural and geographical displacement . ","mr . polanski is in his element here : alone , abandoned , but still consoled by his art , which is more than he has ever revealed before about the source of his spiritual survival . ","spectacular in every sense of the word , even if you don' t know an orc from a uruk-hai . ","this isn't exactly profound cinema , but it's good-natured and sometimes quite funny . ","this is a finely written , superbly acted offbeat thriller . ","tres greek writer and star nia vardalos has crafted here a worldly-wise and very funny script . ","os problemas têm início a partir do momento em que saímos do cinema e começamos a pensar sobre o que acabamos de ver . É então que sinais realmente desaponta . ","a tasty appetizer that leaves you wanting more . ","it gives devastating testimony to both people's capacity for evil and their heroic capacity for good . ","the film reminds me of a vastly improved germanic version of my big fat greek wedding -- with better characters , some genuine quirkiness and at least a measure of style . the difference is that i truly enjoyed most of mostly martha while i ne","morton deserves an oscar nomination . ","a colorful , vibrant introduction to a universal human impulse , lushly photographed and beautifully recorded . ","the screenplay never lets us forget that bourne was once an amoral assassin just like the ones who are pursuing him . . . there is never really a true  us  versus  them  . ","the history is fascinating ; the action is dazzling . they just don't work in concert . ","for those in search of something different , wendigo is a genuinely bone-chilling tale . ","a lovely film for the holiday season . ","it remains to be seen whether statham can move beyond the crime-land action genre , but then again , who says he has to ? ","a hypnotic cyber hymn and a cruel story of youth culture . ","it's a fairy tale that comes from a renowned indian film culture that allows americans to finally revel in its splendor . ","at once subtle and visceral , the film never succumbs to the trap of the maudlin or tearful , offering instead with its unflinching gaze a measure of faith in the future . ","the performances of the children , untrained in acting , have an honesty and dignity that breaks your heart . ","despite its lavish formalism and intellectual austerity , the film manages to keep you at the edge of your seat with its shape-shifting perils , political intrigue and brushes with calamity . ","this rush to profits has created a predictably efficient piece of business notable largely for its overwhelming creepiness , for an eagerness to create images you wish you hadn't seen , which , in this day and age , is of course the point . ","adams , with four scriptwriters , takes care with the characters , who are so believable that you feel what they feel . ","a completely spooky piece of business that gets under your skin and , some plot blips aside , stays there for the duration . ","superbly photographed and staged by mendes with a series of riveting set pieces the likes of which mainstream audiences have rarely seen . ","the ensemble cast turns in a collectively stellar performance , and the writing is tight and truthful , full of funny situations and honest observations . ","not quite as miraculous as its dreamworks makers would have you believe , but it more than adequately fills the eyes and stirs the emotions . ","a properly spooky film about the power of spirits to influence us whether we believe in them or not . ","the lightest , most breezy movie steven spielberg has made in more than a decade . and the positive change in tone here seems to have recharged him . ","like edward norton in american history x , ryan gosling ( murder by numbers ) delivers a magnetic performance . ","this is a very funny , heartwarming film . it has fun with the quirks of family life , but it also treats the subject with fondness and respect . ","rarely , indeed almost never , is such high-wattage brainpower coupled with pitch-perfect acting and an exquisite , unfakable sense of cinema . ","the leanest and meanest of solondz's misanthropic comedies . ","a dark , quirky road movie that constantly defies expectation . ","there are some movies that hit you from the first scene and you know it's going to be a trip . igby goes down is one of those movies . ","often messy and frustrating , but very pleasing at its best moments , it's very much like life itself . ","a burst of color , music , and dance that only the most practiced curmudgeon could fail to crack a smile at . ","an energetic , violent movie with a momentum that never lets up . ","lasker's canny , meditative script distances sex and love , as byron and luther . . . realize they can't get no satisfaction without the latter . ","it turns out to be smarter and more diabolical than you could have guessed at the beginning . ","cage makes an unusual but pleasantly haunting debut behind the camera . ","noyce has worked wonders with the material . ","it's mostly a pleasure to watch . and the reason for that is a self-aware , often self-mocking , intelligence . ","the chateau is a risky venture that never quite goes where you expect and often surprises you with unexpected comedy . ","a very well-meaning movie , and it will stand in future years as an eloquent memorial to the world trade center tragedy . ","there aren't many conclusive answers in the film , but there is an interesting story of pointed personalities , courage , tragedy and the little guys vs . the big guys . ","vividly demonstrates that the director of such hollywood blockbusters as patriot games can still turn out a small , personal film with an emotional wallop . ","a four star performance from kevin kline who unfortunately works with a two star script . ","dogtown & z-boys evokes the blithe rebel fantasy with the kind of insouciance embedded in the sexy demise of james dean . ","if you don't flee , you might be seduced . if you don't laugh , flee . ","payne constructs a hilarious ode to middle america and middle age with this unlikely odyssey , featuring a pathetic , endearing hero who is all too human . ","koury frighteningly and honestly exposes one teenager's uncomfortable class resentment and , in turn , his self-inflicted retaliation . ","the santa clause 2 proves itself a more streamlined and thought out encounter than the original could ever have hoped to be . ","now as a former gong show addict , i'll admit it , my only complaint is that we didn't get more re-creations of all those famous moments from the show . ","succeeds where its recent predecessor miserably fails because it demands that you suffer the dreadfulness of war from both sides . ","the first bond movie in ages that isn't fake fun . ","this odd , poetic road movie , spiked by jolts of pop music , pretty much takes place in morton's ever-watchful gaze -- and it's a tribute to the actress , and to her inventive director , that the journey is such a mesmerizing one . ","a film centering on a traditional indian wedding in contemporary new delhi may not sound like specialized fare , but mira nair's film is an absolute delight for all audiences . ","a weird and wonderful comedy . ","the movie should jolt you out of your seat a couple of times , give you a few laughs , and leave you feeling like it was worth your seven bucks , even though it does turn out to be a bit of a cheat in the end . ","has the capability of effecting change and inspiring hope . ","a first-class , thoroughly involving b movie that effectively combines two surefire , beloved genres -- the prison flick and the fight film . ","labute's careful handling makes the material seem genuine rather than pandering . ","in between all the emotional seesawing , it's hard to figure the depth of these two literary figures , and even the times in which they lived . but they fascinate in their recklessness . ","death to smoochy is often very funny , but what's even more remarkable is the integrity of devito's misanthropic vision . ","a beautiful , entertaining two hours . you get the idea , though , that kapur intended the film to be more than that . ","a wonderful , ghastly film . ","amid the new populist comedies that underscore the importance of family tradition and familial community , one would be hard-pressed to find a movie with a bigger , fatter heart than barbershop . ","parris' performance is credible and remarkably mature . ","'enigma' is the kind of engaging historical drama that hollywood appears to have given up on in favor of sentimental war movies in the vein of 'we were soldiers . '","munch's screenplay is tenderly observant of his characters . he watches them as they float within the seas of their personalities . his scenes are short and often unexpected . ","it grabs you in the dark and shakes you vigorously for its duration . ","leigh's daring here is that without once denying the hardscrabble lives of people on the economic fringes of margaret thatcher's ruinous legacy , he insists on the importance of those moments when people can connect and express their love for each other . ","hashiguchi vividly captures the way young japanese live now , chafing against their culture's manic mix of millennial brusqueness and undying , traditional politesse . ","uneven but a lot of fun . ","i know that i'll never listen to marvin gaye or the supremes the same way again","the two leads , nearly perfect in their roles , bring a heart and reality that buoy the film , and at times , elevate it to a superior crime movie . ","not as good as the full monty , but a really strong second effort . ","whenever it threatens to get bogged down in earnest dramaturgy , a stirring visual sequence like a surge through swirling rapids or a leap from pinnacle to pinnacle rouses us . if horses could fly , this is surely what they'd look like . ","unfolds as one of the most politically audacious films of recent decades from any country , but especially from france . ","this real-life hollywood fairy-tale is more engaging than the usual fantasies hollywood produces . ","the graphic carnage and re-creation of war-torn croatia is uncomfortably timely , relevant , and sickeningly real . ","left me with the visceral sensation of longing , lasting traces of charlotte's web of desire and desperation . ","the characters are more deeply thought through than in most 'right-thinking' films . ","crammed with incident , and bristles with passion and energy . ","it's fun , splashy and entertainingly nasty . ","a simple tale of an unlikely friendship , but thanks to the gorgeous locales and exceptional lead performances , it has considerable charm . ","it might be 'easier' to watch on video at home , but that shouldn't stop die-hard french film connoisseurs from going out and enjoying the big-screen experience . ","there's very little sense to what's going on here , but the makers serve up the cliches with considerable dash . ","witty , contemplative , and sublimely beautiful . ","a surprisingly 'solid' achievement by director malcolm d . lee and writer john ridley . ","woven together handsomely , recalling sixties' rockumentary milestones from lonely boy to don't look back . ","this is pure , exciting moviemaking . you won't exactly know what's happening but you'll be blissfully exhausted . ","the 1960s rebellion was misdirected : you can't fight your culture . ","works because reno doesn't become smug or sanctimonious towards the audience . ","nettelbeck . . . has a pleasing way with a metaphor . ","a pure participatory event that malnourished intellectuals will gulp down in a frenzy . ","the cast delivers without sham the raw-nerved story . ","steven soderbergh's digital video experiment is a clever and cutting , quick and dirty look at modern living and movie life . ","the film's highlight is definitely its screenplay , both for the rhapsodic dialogue that jumps off the page , and for the memorable character creations . ","it lets you brush up against the humanity of a psycho , without making him any less psycho . ","sillier , cuter , and shorter than the first ( as best i remember ) , but still a very good time at the cinema . ","the film is bright and flashy in all the right ways . ","elegant and eloquent [meditation] on death and that most elusive of passions , love . ","cut through the layers of soap-opera emotion and you find a scathing portrayal of a powerful entity strangling the life out of the people who want to believe in it the most . ","filmmaker tian zhuangzhuang triumphantly returns to narrative filmmaking with a visually masterful work of quiet power . ","it excels because , unlike so many other hollywood movies of its ilk , it offers hope . ","shot in rich , shadowy black-and-white , devils chronicles , with increasingly amused irony , the relationship between reluctant captors and befuddled captives . ","there's no clear picture of who killed bob crane . but here's a glimpse at his life . ","spectacularly beautiful , not to mention mysterious , sensual , emotionally intense , and replete with virtuoso throat-singing . ","weird . rewarding . ","a summer entertainment adults can see without feeling embarrassed , but it could have been more . ","sparse but oddly compelling . ","a stirring , funny and finally transporting re-imagining of beauty and the beast and 1930s horror films","the pinochet case is a searing album of remembrance from those who , having survived , suffered most . ","a sweet-tempered comedy that forgoes the knee-jerk misogyny that passes for humor in so many teenage comedies . ","argento , at only 26 , brings a youthful , out-to-change-the-world aggressiveness to the project , as if she's cut open a vein and bled the raw film stock . ","sleek and arty . ","with so many bad romances out there , this is the kind of movie that deserves a chance to shine . ","brash , intelligent and erotically perplexing , haneke's portrait of an upper class austrian society and the suppression of its tucked away demons is uniquely felt with a sardonic jolt . ","though jackson doesn't always succeed in integrating the characters in the foreground into the extraordinarily rich landscape , it must be said that he is an imaginative filmmaker who can see the forest for the trees . ","  the quiet american  begins in saigon in 1952 . that's its first sign of trouble . ","a dazzling thing to behold -- as long as you're wearing the somewhat cumbersome 3d goggles the theater provides . ","be patient with the lovely hush ! and your reward will be a thoughtful , emotional movie experience . ","the large-format film is well suited to capture these musicians in full regalia and the incredible imax sound system lets you feel the beat down to your toes . ","godard has never made a more sheerly beautiful film than this unexpectedly moving meditation on love , history , memory , resistance and artistic transcendence . ","the kind of movie that comes along only occasionally , one so unconventional , gutsy and perfectly executed it takes your breath away . ","unlike most surf movies , blue crush thrillingly uses modern technology to take the viewer inside the wave . by the end you can't help but feel 'stoked . '","the off-center humor is a constant , and the ensemble gives it a buoyant delivery . ","a tasty slice of droll whimsy . ","mike leigh populates his movie with a wonderful ensemble cast of characters that bring the routine day to day struggles of the working class to life","awesome work : ineffable , elusive , yet inexplicably powerful","sparkling , often hilarious romantic jealousy comedy . . . attal looks so much like a young robert deniro that it seems the film should instead be called 'my husband is travis bickle' . ","even if you're an agnostic carnivore , you can enjoy much of jonah simply , and gratefully , as laugh-out-loud lunacy with a pronounced monty pythonesque flavor . ","where bowling for columbine is at its most valuable is in its examination of america's culture of fear as a root cause of gun violence . ","the result is somewhat satisfying -- it still comes from spielberg , who has never made anything that wasn't at least watchable . but it's also disappointing to a certain degree . ","the all-french cast is marveilleux . ","there's a lot to recommend read my lips . ","a minor film with major pleasures from portuguese master manoel de oliviera . . . ","brosnan gives a portrayal as solid and as perfect as his outstanding performance as bond in die another day . ","audiences are advised to sit near the back and squint to avoid noticing some truly egregious lip-non-synching , but otherwise the production is suitably elegant . ","the movie is . . . very funny as you peek at it through the fingers in front of your eyes . ","nicks sustains the level of exaggerated , stylized humor throughout by taking your expectations and twisting them just a bit . ","a refreshing change from the usual whoopee-cushion effort aimed at the youth market . ","it finds its moviegoing pleasures in the tiny events that could make a person who has lived her life half-asleep suddenly wake up and take notice . "," . . . an enjoyably frothy 'date movie' . . . ","the genius of the work speaks volumes , offering up a hallucinatory dreamscape that frustrates and captivates . ","two weeks notice has appeal beyond being a sandra bullock vehicle or a standard romantic comedy . ","the movie's seams may show . . . but pellington gives  mothman  an irresistibly uncanny ambience that goes a long way toward keeping the picture compelling . ","if mostly martha is mostly unsurprising , it's still a sweet , even delectable diversion . ","a wild comedy that could only spring from the demented mind of the writer of being john malkovich . ","schnitzler does a fine job contrasting the sleekness of the film's present with the playful paranoia of the film's past . ","'a fresh-faced , big-hearted and frequently funny thrill ride for the kiddies , with enough eye candy and cheeky wit to keep parents away from the concession stand . '","mana gives us compelling , damaged characters who we want to help -- or hurt . ","the sentimental script has problems , but the actors pick up the slack . ","a good documentary can make interesting a subject you thought would leave you cold . a case in point : doug pray's scratch . ","abderrahmane sissako's heremakono ( waiting for happiness ) is an elegiac portrait of a transit city on the west african coast struggling against foreign influences . ","in xxx , diesel is that rare creature -- an action hero with table manners , and one who proves that elegance is more than tattoo deep . ","an engrossing and grim portrait of hookers : what they think of themselves and their clients . ","it all plays out . . . like a high-end john hughes comedy , a kind of elder bueller's time out . ","the film is enriched by an imaginatively mixed cast of antic spirits , headed by christopher plummer as the subtlest and most complexly evil uncle ralph i've ever seen in the many film and stage adaptations of the work . ","this is one of the rarest kinds of films : a family-oriented non-disney film that is actually funny without hitting below the belt . ","it is refreshingly undogmatic about its characters . ","a moving and important film . ","deep intelligence and a warm , enveloping affection breathe out of every frame . ","famuyiwa's feature deals with its subject matter in a tasteful , intelligent manner , rather than forcing us to endure every plot contrivance that the cliché-riddled genre can offer . ","showtime is a fine-looking film with a bouncy score and a clutch of lively songs for deft punctuation . ","sweet home alabama isn't going to win any academy awards , but this date-night diversion will definitely win some hearts . ","a cruelly funny twist on teen comedy packed with inventive cinematic tricks and an ironically killer soundtrack","a gracious , eloquent film that by its end offers a ray of hope to the refugees able to look ahead and resist living in a past forever lost . ","even though many of these guys are less than adorable ( their lamentations are pretty much self-centered ) , there's something vital about the movie . ","a tour de force drama about the astonishingly pivotal role of imagination in the soulful development of two rowdy teenagers . ","it is a strength of a documentary to disregard available bias , especially as temptingly easy as it would have been with this premise . ","when twentysomething hotsies make movies about their lives , hard-driving narcissism is a given , but what a world we'd live in if argento's hollywood counterparts . . . had this much imagination and nerve . ","maryam is more timely now than ever . ","an eloquent , reflective and beautifully acted meditation on both the profoundly devastating events of one year ago and the slow , painful healing process that has followed in their wake . ","piccoli gives a superb performance full of deep feeling . ","what a concept , what an idea , what a thrill ride . this is a more fascinating look at the future than  bladerunner  and one of the most high-concept sci fi adventures attempted for the screen . ","the rare movie that's as crisp and to the point as the novel on which it's based . ","a film of epic scale with an intimate feeling , a saga of the ups and downs of friendships . ","sayles has an eye for the ways people of different ethnicities talk to and about others outside the group . ","  nicholas nickleby  is a perfect family film to take everyone to since there's no new  a christmas carol  out in the theaters this year . charlie hunnam has the twinkling eyes , repressed smile and determined face needed to carry out a dickensian hero . ","niccol the filmmaker merges his collaborators' symbolic images with his words , insinuating , for example , that in hollywood , only god speaks to the press","khouri manages , with terrific flair , to keep the extremes of screwball farce and blood-curdling family intensity on one continuum . ","impresses as a skillfully assembled , highly polished and professional adaptation . . . just about as chilling and unsettling as 'manhunter' was . ","it's a solid movie about people whose lives are anything but . ","though a touch too arthouse 101 in its poetic symbolism , heaven proves to be a good match of the sensibilities of two directors . ","i simply can't recommend it enough . ","wiseman reveals the victims of domestic abuse in all of their pity and terror . ","muccino , who directed from his own screenplay , is a canny crowd pleaser , and the last kiss . . . provides more than enough sentimental catharsis for a satisfying evening at the multiplex . ","we want the funk - and this movie's got it . ","wow , so who knew charles dickens could be so light-hearted ? ","many went to see the attraction for the sole reason that it was hot outside and there was air conditioning inside , and i don't think that a . c . will help this movie one bit . ","sem se preocupar em criar momentos melodramáticos para arrancar lágrimas do espectador , o pianista é um filme triste sem que , para isso , precise ser emocionante . ","the storylines are woven together skilfully , the magnificent swooping aerial shots are breathtaking , and the overall experience is awesome . ","a miraculous movie , i'm going home is so slight , yet overflows with wisdom and emotion . ","baran is shockingly devoid of your typical majid majidi shoe-loving , crippled children . ","an ambitious 'what if ? ' that works . ","every moment crackles with tension , and by the end of the flick , you're on the edge of your seat . ","a fine , rousing , g-rated family film , aimed mainly at little kids but with plenty of entertainment value to keep grown-ups from squirming in their seats . ","the series' message about making the right choice in the face of tempting alternatives remains prominent , as do the girls' amusing personalities . ","richly entertaining and suggestive of any number of metaphorical readings . ","a compelling allegory about the last days of germany's democratic weimar republic . ","offers a guilt-free trip into feel-good territory . ","a b-movie you can sit through , enjoy on a certain level and then forget . ","devos delivers a perfect performance that captures the innocence and budding demons within a wallflower . ","disappointingly , the characters are too strange and dysfunctional , tom included , to ever get under the skin , but this is compensated in large part by the off-the-wall dialogue , visual playfulness and the outlandishness of the idea itself . ","director todd solondz has made a movie about critical reaction to his two previous movies , and about his responsibility to the characters that he creates . ","the word that comes to mind , while watching eric rohmer's tribute to a courageous scottish lady , is painterly . ","a fascinating case study of flower-power liberation -- and the price that was paid for it . ","bluer than the atlantic and more biologically detailed than an autopsy , the movie . . . is , also , frequently hilarious . ","really is a pan-american movie , with moments of genuine insight into the urban heart . ","obligada para impotentes , daneses , camareras italianas , profesores de idiomas , y todo aquel que desee una lengua para expresar su amor . ","an overly familiar scenario is made fresh by an intelligent screenplay and gripping performances in this low-budget , video-shot , debut indie effort . ","peppering this urban study with references to norwegian folktales , villeneuve creates in maelstrom a world where the bizarre is credible and the real turns magical . ","ong's promising debut is a warm and well-told tale of one recent chinese immigrant's experiences in new york city . ","fantastic ! ","that the real antwone fisher was able to overcome his personal obstacles and become a good man is a wonderful thing ; that he has been able to share his story so compellingly with us is a minor miracle . ","there's not much to fatale , outside of its stylish surprises . . . but that's ok . ","what redeems the film is the cast , particularly the ya-yas themselves . ","beautiful , cold , oddly colorful and just plain otherworldly , a freaky bit of art that's there to scare while we delight in the images . ","it's up to [watts] to lend credibility to this strange scenario , and her presence succeeds in making us believe . ","the film is darkly atmospheric , with herrmann quietly suggesting the sadness and obsession beneath hearst's forced avuncular chortles . ","shyamalan takes a potentially trite and overused concept ( aliens come to earth ) and infuses it into a rustic , realistic , and altogether creepy tale of hidden invasion . "," . . . the story , like ravel's bolero , builds to a crescendo that encompasses many more paths than we started with . ","it's plotless , shapeless -- and yet , it must be admitted , not entirely humorless . indeed , the more outrageous bits achieve a shock-you-into-laughter intensity of almost dadaist proportions . ","gondry's direction is adequate . . . but what gives human nature its unique feel is kaufman's script . ","the film's plot may be shallow , but you've never seen the deep like you see it in these harrowing surf shots . ","with a large cast representing a broad cross-section , tavernier's film bounds along with the rat-a-tat energy of  his girl friday ,  maintaining a light touch while tackling serious themes . ","the observations of this social/economic/urban environment are canny and spiced with irony . ","renner carries much of the film with a creepy and dead-on performance . ","jarecki and gibney do find enough material to bring kissinger's record into question and explain how the diplomat's tweaked version of statecraft may have cost thousands and possibly millions of lives . ","the spaniel-eyed jean reno infuses hubert with a mixture of deadpan cool , wry humor and just the measure of tenderness required to give this comic slugfest some heart . ","aniston has at last decisively broken with her friends image in an independent film of satiric fire and emotional turmoil . ","a mildly enjoyable if toothless adaptation of a much better book . ","  the dangerous lives of altar boys  has flaws , but it also has humor and heart and very talented young actors","unexpected , and often contradictory , truths emerge . ","300 years of russian history and culture compressed into an evanescent , seamless and sumptuous stream of consciousness . ","intelligent , caustic take on a great writer and dubious human being . ","may take its sweet time to get wherever it's going , but if you have the patience for it , you won't feel like it's wasted yours . ","less the sensational true-crime hell-jaunt purists might like and more experimental in its storytelling ( though no less horrifying for it ) . ","the film is one of the year's best . ","eerily accurate depiction of depression . "," . . . a delicious crime drama on par with the slickest of mamet . ","charming and witty , it's also somewhat clumsy . ","directed with purpose and finesse by england's roger mitchell , who handily makes the move from pleasing , relatively lightweight commercial fare such as notting hill to commercial fare with real thematic heft . ","escapes the precious trappings of most romantic comedies , infusing into the story very real , complicated emotions . ","this big screen caper has a good bark , far from being a bow-wow . ","[allen] manages to breathe life into this somewhat tired premise . ","i have two words to say about reign of fire . great dragons ! ","by surrounding us with hyper-artificiality , haynes makes us see familiar issues , like racism and homophobia , in a fresh way . ","a deliberative account of a lifestyle characterized by its surface-obsession – one that typifies the delirium of post , pre , and extant stardom . ","superb production values & christian bale's charisma make up for a derivative plot . ","the film has the courage of its convictions and excellent performances on its side . ","i know i shouldn't have laughed , but hey , those farts got to my inner nine-year-old . ","a movie that will thrill you , touch you and make you laugh as well . ","it's a smart , funny look at an arcane area of popular culture , and if it isn't entirely persuasive , it does give exposure to some talented performers . ","more vaudeville show than well-constructed narrative , but on those terms it's inoffensive and actually rather sweet . ","the case is a convincing one , and should give anyone with a conscience reason to pause . ","the actresses find their own rhythm and protect each other from the script's bad ideas and awkwardness . ","diverting french comedy in which a husband has to cope with the pesky moods of jealousy . ","captivates and shows how a skillful filmmaker can impart a message without bludgeoning the audience over the head . ","there is a welcome lack of pretension about the film , which very simply sets out to entertain and ends up delivering in good measure . ","coy but exhilarating , with really solid performances by ving rhames and wesley snipes . ","it is a likable story , told with competence . ","not only does spider-man deliver , but i suspect it might deliver again and again . ","tackles the difficult subject of grief and loss with such life-embracing spirit that the theme doesn't drag an audience down . ","a small movie with a big impact . ","the movie , despite its rough edges and a tendency to sag in certain places , is wry and engrossing . "," i admire the closing scenes of the film , which seem to ask whether our civilization offers a cure for vincent's complaint . ","like rudy yellow lodge , eyre needs to take a good sweat to clarify his cinematic vision before his next creation and remember the lessons of the trickster spider . ","a delightful romantic comedy with plenty of bite . it's far from a frothy piece , and the characters are complex , laden with plenty of baggage and tinged with tragic undertones . ","using an endearing cast , writer/director dover kosashvili takes a slightly dark look at relationships , both sexual and kindred . ","when a movie has stuck around for this long , you know there's something there . it's that good . ","smart , sassy interpretation of the oscar wilde play . ","forget about one oscar nomination for julianne moore this year - she should get all five . ","japanese director shohei imamura's latest film is an odd but ultimately satisfying blend of the sophomoric and the sublime . ","kwan is a master of shadow , quietude , and room noise , and lan yu is a disarmingly lived-in movie . ","while the plot follows a predictable connect-the-dots course . . . director john schultz colors the picture in some evocative shades . ","nice piece of work . ","katz's documentary doesn't have much panache , but with material this rich it doesn't need it . ","we get an image of big papa spanning history , rather than suspending it . ","evelyn's strong cast and surehanded direction make for a winning , heartwarming yarn . ","'aunque recurre a ciertos clichés del género , la poderosa actuación de robin williams perdona las fallas del guión . '","a conventional but heartwarming tale . ","a thought-provoking picture . ","this is one of the outstanding thrillers of recent years . ","skins has a desolate air , but eyre , a native american raised by white parents , manages to infuse the rocky path to sibling reconciliation with flashes of warmth and gentle humor . ","a film of quiet power . ","more concerned with overall feelings , broader ideas , and open-ended questions than concrete story and definitive answers , soderbergh's solaris is a gorgeous and deceptively minimalist cinematic tone poem . ","an intelligent romantic thriller of a very old-school kind of quality . ","the sword fighting is well done and auteuil is a goofy pleasure . ","yes , mibii is rote work and predictable , but with a philosophical visual coming right at the end that extravagantly redeems it . ","film can't quite maintain its initial momentum , but remains sporadically funny throughout . ","o fantasma is boldly , confidently orchestrated , aesthetically and sexually , and its impact is deeply and rightly disturbing . ","it's still adam sandler , and it's not little nicky . and for many of us , that's good enough . ","here's yet another cool crime movie that actually manages to bring something new into the mix . ","lee's achievement extends to his supple understanding of the role that brown played in american culture as an athlete , a movie star , and an image of black indomitability . ","kaufman and jonze take huge risks to ponder the whole notion of passion -- our desire as human beings for passion in our lives and the emptiness one feels when it is missing . ","it tends to remind one of a really solid woody allen film , with its excellent use of new york locales and sharp writing","while centered on the life experiences of a particular theatrical family , this marvelous documentary touches -- ever so gracefully -- on the entire history of the yiddish theater , both in america and israel . ","the film , despite the gratuitous cinematic distractions impressed upon it , is still good fun . ","the immersive powers of the giant screen and its hyper-realistic images are put to perfect use in the breathtakingly beautiful outer-space documentary space station 3d . ","has an unmistakable , easy joie de vivre . ","more than anything else , kissing jessica stein injects freshness and spirit into the romantic comedy genre , which has been held hostage by generic scripts that seek to remake sleepless in seattle again and again . ","this movie has the usual impossible stunts . . . but it has just as many scenes that are lean and tough enough to fit in any modern action movie . ","mostly works because of the universal themes , earnest performances . . . and excellent use of music by india's popular gulzar and jagjit singh . "," . . . the one thing this wild film has that other imax films don't : chimps , lots of chimps , all blown up to the size of a house . that's fun for kids of any age . ","writer/director david caesar ladles on the local flavour with a hugely enjoyable film about changing times , clashing cultures and the pleasures of a well-made pizza . ","rarely have i seen a film so willing to champion the fallibility of the human heart . ","holofcener rejects patent solutions to dramatize life's messiness from inside out , in all its strange quirks . ","like the full monty , this is sure to raise audience's spirits and leave them singing long after the credits roll . "," . . . a gleefully grungy , hilariously wicked black comedy . . . ","kinnear and dafoe give what may be the performances of their careers . ","all in all , a great party . ","a moving story of determination and the human spirit . ","  brown sugar  admirably aspires to be more than another  best man  clone by weaving a theme throughout this funny film . ","[gulpilil] is a commanding screen presence , and his character's abundant humanism makes him the film's moral compass . ","a stylish thriller . ","an effortlessly accomplished and richly resonant work . ","in some ways , lagaan is quintessential bollywood . except it's much , much better . ","though it never rises to its full potential as a film , still offers a great deal of insight into the female condition and the timeless danger of emotions repressed . ","scotland looks wonderful , the fans are often funny fanatics , the showdown sure beats a bad day of golf . ","what enlivens this film , beyond the astute direction of cardoso and beautifully detailed performances by all of the actors , is a note of defiance over social dictates . ","the emotion is impressively true for being so hot-blooded , and both leads are up to the task . ","although it lacks the detail of the book , the film does pack some serious suspense . ","i'd watch these two together again in a new york minute . ","there's nothing like love to give a movie a b-12 shot , and cq shimmers with it . ","a moving essay about the specter of death , especially suicide . ","this film is so different from the apple and so striking that it can only encourage us to see samira makhmalbaf as a very distinctive sensibility , working to develop her own film language with conspicuous success . ","like a less dizzily gorgeous companion to mr . wong's in the mood for love -- very much a hong kong movie despite its mainland setting . "," . . . a somber film , almost completely unrelieved by any comedy beyond the wistful everyday ironies of the working poor . ","coral reef adventure is a heavyweight film that fights a good fight on behalf of the world's endangered reefs -- and it lets the pictures do the punching . ","the overall result is an intelligent , realistic portrayal of testing boundaries . ","poignant and moving , a walk to remember is an inspirational love story , capturing the innocence and idealism of that first encounter . ","worth a salute just for trying to be more complex than your average film . ","handsome and sophisticated approach to the workplace romantic comedy . ","a shimmeringly lovely coming-of-age portrait , shot in artful , watery tones of blue , green and brown . ","while cherish doesn't completely survive its tonal transformation from dark comedy to suspense thriller , it's got just enough charm and appealing character quirks to forgive that still serious problem . ","in many ways , reminiscent of 1992's unforgiven which also utilized the scintillating force of its actors to draw out the menace of its sparse dialogue . ","we admire this film for its harsh objectivity and refusal to seek our tears , our sympathies . ","an often watchable , though goofy and lurid , blast of a costume drama set in the late 15th century . ","the entire cast is first-rate , especially sorvino . ","the cat's meow marks a return to form for director peter bogdanovich . . . ","this one is strictly a lightweight escapist film . ","this sensitive , smart , savvy , compelling coming-of-age drama delves into the passive-aggressive psychology of co-dependence and the struggle for self-esteem . ","the culmination of everyone's efforts is given life when a selection appears in its final form [in  last dance  ] . ","in questioning the election process , payami graphically illustrates the problems of fledgling democracies , but also the strength and sense of freedom the iranian people already possess , with or without access to the ballot box . ","a very charming and funny movie . ","this is a film that manages to find greatness in the hue of its drastic iconography . ","streamlined to a tight , brisk 85-minute screwball thriller ,  big trouble  is funny , harmless and as substantial as a tub of popcorn with extra butter . ","consummate actor barry has done excellent work here . ","the biggest problem with this movie is that it's not nearly long enough . ","while not all that bad of a movie , it's nowhere near as good as the original . ","ali's graduation from little screen to big is far less painful than his opening scene encounter with an over-amorous terrier . ","i have always appreciated a smartly written motion picture , and , whatever flaws igby goes down may possess , it is undeniably that . ","you can sip your vintage wines and watch your merchant ivory productions ; i'll settle for a nice cool glass of iced tea and a jerry bruckheimer flick any day of the week . ","may be the most undeserving victim of critical overkill since town and country . ","a chilly , brooding but quietly resonant psychological study of domestic tension and unhappiness . ","the movie does its best to work us over , with second helpings of love , romance , tragedy , false dawns , real dawns , comic relief , two separate crises during marriage ceremonies , and the lush scenery of the cotswolds . ","cold , nervy and memorable . ","becomes a fascinating study of isolation and frustration that successfully recreates both the physical setting and emotional tensions of the papin sisters . ","spend your benjamins on a matinee . ","all in all , it's a pretty good execution of a story that's a lot richer than the ones hollywood action screenwriters usually come up with on their own . ","worth seeing just for weaver and lapaglia . ","a pleasant piece of escapist entertainment . ","among the many pleasures are the lively intelligence of the artists and their perceptiveness about their own situations . ","it's consistently funny , in an irresistible junior-high way , and consistently free of any gag that would force you to give it a millisecond of thought . ","it's the cute frissons of discovery and humor between chaplin and kidman that keep this nicely wound clock not just ticking , but humming . ","the storytelling may be ordinary , but the cast is one of those all-star reunions that fans of gosford park have come to assume is just another day of brit cinema . ","there's something about a marching band that gets me where i live . ","cuaron repeatedly , perversely undercuts the joie de vivre even as he creates it , giving the movie a mournful undercurrent that places the good-time shenanigans in welcome perspective . ","it's definitely an improvement on the first blade , since it doesn't take itself so deadly seriously . ","a slam-bang extravaganza that is all about a wild-and-woolly , wall-to-wall good time . ","what's infuriating about full frontal is that it's too close to real life to make sense . what's invigorating about it is that it doesn't give a damn . ","is red dragon worthy of a place alongside the other hannibal movies ? as hannibal would say , yes , 'it's like having an old friend for dinner' . ","writer-director juan carlos fresnadillo makes a feature debut that is fully formed and remarkably assured . ","insightfully written , delicately performed","perhaps the grossest movie ever made . funny , though . ","this 90-minute postmodern voyage was more diverting and thought-provoking than i'd expected it to be . ","one of those exceedingly rare films in which the talk alone is enough to keep us involved . ","a heartbreakingly thoughtful minor classic , the work of a genuine and singular artist . ","an affectionately goofy satire that's unafraid to throw elbows when necessary . . . ","between them , de niro and murphy make showtime the most savory and hilarious guilty pleasure of many a recent movie season . ","jackson tries to keep the plates spinning as best he can , but all the bouncing back and forth can't help but become a bit tedious -- even with the breathtaking landscapes and villainous varmints there to distract you from the ricocheting . ","filmmakers david weissman and bill weber benefit enormously from the cockettes' camera craziness -- not only did they film performances , but they did the same at home . ","interesting both as a historical study and as a tragic love story . ","a stylish but steady , and ultimately very satisfying , piece of character-driven storytelling . ","it picked me up , swung me around , and dropped me back in my seat with more emotional force than any other recent film . ","graham greene's novel of colonialism and empire is elevated by michael caine's performance as a weary journalist in a changing world . ","though it's equally solipsistic in tone , the movie has enough vitality to justify the notion of creating a screen adaptation of evans' saga of hollywood excess . ","compulsively watchable , no matter how degraded things get . ","delivers roughly equal amounts of beautiful movement and inside information . ","bon appétit ! just like a splendid meal , red dragon satisfies – from its ripe recipe , inspiring ingredients , certified cuisine and palatable presentation . ","the structure is simple , but in its own way , rabbit-proof fence is a quest story as grand as the lord of the rings . ","this charming , thought-provoking new york fest of life and love has its rewards . ","some people march to the beat of a different drum , and if you ever wondered what kind of houses those people live in , this documentary takes a look at 5 alternative housing options . ","playfully profound . . . and crazier than michael jackson on the top floor of a skyscraper nursery surrounded by open windows . ","a film that will enthrall the whole family . ","the charm of the first movie is still there , and the story feels like the logical , unforced continuation of the careers of a pair of spy kids . ","k 19 stays afloat as decent drama/action flick","it sends you away a believer again and quite cheered at just that . ","like the best 60 minutes exposé , the film ( at 80 minutes ) is actually quite entertaining . ","an 83 minute document of a project which started in a muddle , seesawed back and forth between controlling interests multiple times , then found its sweet spot","an emotionally and spiritually compelling journey seen through the right eyes , with the right actors and with the kind of visual flair that shows what great cinema can really do . ","nair doesn't use [monsoon wedding] to lament the loss of culture . instead , she sees it as a chance to revitalize what is and always has been remarkable about clung-to traditions . ","both grant and hoult carry the movie because they are believable as people -- flawed , assured of the wrong things , and scared to admit how much they may really need the company of others . ","leading a double life in an american film only comes to no good , but not here . matters play out realistically if not always fairly . ","in the affable maid in manhattan , jennifer lopez's most aggressive and most sincere attempt to take movies by storm , the diva shrewdly surrounds herself with a company of strictly a-list players . ","like mike is a harmlessly naïve slice of b-ball fantasy , fit for filling in during the real nba's off-season . ","though writer/director bart freundlich's film ultimately becomes a simplistic story about a dysfunctional parent-child relationship , it has some special qualities and the soulful gravity of crudup's anchoring performance . ","y tu mamá también es un buen filme gracias a lo poco convencional de su narrativa , y es quizá el proyecto más arriesgado en la carrera de alfonso cuarón","what the movie lacks in action it more than makes up for in drama , suspense , revenge , and romance . ","just offbeat enough to keep you interested without coming close to bowling you over . ","probes in a light-hearted way the romantic problems of individuals for whom the yearning for passion spells discontent . ","what elevates the movie above the run-of-the-mill singles blender is its surreal sense of humor and technological finish . ","a film about female friendship that men can embrace and women will talk about for hours . ","the directing and story are disjointed , flaws that have to be laid squarely on taylor's doorstep . but the actors make this worth a peek . ","É uma pena que , mais tarde , o próprio filme abandone o tom de paródia e passe a utilizar os mesmos clichês que havia satirizado . ","light the candles , bring out the cake and don't fret about the calories because there's precious little substance in birthday girl -- it's simply , and surprisingly , a nice , light treat . ","it may be about drug dealers , kidnapping , and unsavory folks , but the tone and pacing are shockingly intimate . ","massoud's story is an epic , but also a tragedy , the record of a tenacious , humane fighter who was also the prisoner ( and ultimately the victim ) of history . ","if villainous vampires are your cup of blood , blade 2 is definitely a cut above the rest . ","drumline ably captures the complicated relationships in a marching band . ","because the film deliberately lacks irony , it has a genuine dramatic impact ; it plays like a powerful 1957 drama we've somehow never seen before . ","does point the way for adventurous indian filmmakers toward a crossover into nonethnic markets . ","seems based on ugly ideas instead of ugly behavior , as happiness was . . . hence , storytelling is far more appealing . ","sum  is jack ryan's  do-over .  give credit to everyone from robinson down to the key grip that this bold move works . especially give credit to affleck . ","an intelligently made ( and beautifully edited ) picture that at the very least has a spark of life to it -- more than you can say for plenty of movies that flow through the hollywood pipeline without a hitch . ","a terrific date movie , whatever your orientation . ","not all of the stories work and the ones that do are thin and scattered , but the film works well enough to make it worth watching . ","what it lacks in originality it makes up for in effective if cheap moments of fright and dread . ","the pain , loneliness and insecurity of the screenwriting process are vividly and painfully brought to slovenly life in this self-deprecating , biting and witty feature written by charlie kaufman and his twin brother , donald , and directed by spike jonze . ","a gem of a movie . ","witty , vibrant , and intelligent . ","it's all stitched together with energy , intelligence and verve , enhanced by a surplus of vintage archive footage . ","miller comes at film with bracing intelligence and a vision both painterly and literary . ","the film is moody , oozing , chilling and heart-warming all at once . . . a twisting , unpredictable , cat-and-mouse thriller . ","eight legged freaks is clever and funny , is amused by its special effects , and leaves you feeling like you've seen a movie instead of an endless trailer . ","this is historical filmmaking without the balm of right-thinking ideology , either liberal or conservative . mr . scorsese's bravery and integrity in advancing this vision can hardly be underestimated . ","a thriller whose style , structure and rhythms are so integrated with the story , you cannot separate them . ","it's a hoot watching the rock chomp on jumbo ants , pull an arrow out of his back , and leap unscathed through raging fire ! ","returning director rob minkoff . . . and screenwriter bruce joel rubin . . . have done a fine job of updating white's dry wit to a new age . ","unfolds with such a wallop of you-are-there immediacy that when the bullets start to fly , your first instinct is to duck . ","a strong script , powerful direction and splendid production design allows us to be transported into the life of wladyslaw szpilman , who is not only a pianist , but a good human being . ","an unflinching look at the world's dispossessed . ","if the film fails to fulfill its own ambitious goals , it nonetheless sustains interest during the long build-up of expository material . ","polanski has found the perfect material with which to address his own world war ii experience in his signature style . ","it is life affirming and heartbreaking , sweet without the decay factor , funny and sad . ","an off-beat and fanciful film about the human need for monsters to blame for all that is amiss in the world . ","a colorful , joyous celebration of life ; a tapestry woven of romance , dancing , singing , and unforgettable characters . ","frei assembles a fascinating profile of a deeply humanistic artist who , in spite of all that he's witnessed , remains surprisingly idealistic , and retains an extraordinary faith in the ability of images to communicate the truth of the world around him . ","nicely combines the enigmatic features of 'memento' with the hallucinatory drug culture of 'requiem for a dream . '","a well paced and satisfying little drama that deserved better than a ‘direct-to-video' release . ","the best part about  gangs  was daniel day-lewis . ","a treat for its depiction on not giving up on dreams when you're a struggling nobody . ","one of those rare films that seems as though it was written for no one , but somehow manages to convince almost everyone that it was put on the screen , just for them . ","a gripping documentary that reveals how deep the antagonism lies in war-torn jerusalem . ","director chris wedge and screenwriters michael berg , michael j . wilson and peter ackerman create some episodes that rival vintage looney tunes for the most creative mayhem in a brief amount of time . ","one of the film's most effective aspects is its tchaikovsky soundtrack of neurasthenic regret . ","solondz creates some effective moments of discomfort for character and viewer alike . ","the film's appeal has a lot to do with the casting of juliette binoche as sand , who brings to the role her pale , dark beauty and characteristic warmth . ","i was amused and entertained by the unfolding of bielinsky's cleverly constructed scenario , and greatly impressed by the skill of the actors involved in the enterprise . ","somehow ms . griffiths and mr . pryce bring off this wild welsh whimsy . ","more mature than fatal attraction , more complete than indecent proposal and more relevant than 9 ½ weeks , unfaithful is at once intimate and universal cinema . ","for all the dolorous trim , secretary is a genial romance that maintains a surprisingly buoyant tone throughout , notwithstanding some of the writers' sporadic dips into pop freudianism . ","a fanciful drama about napoleon's last years and his surprising discovery of love and humility . ","a highly personal look at the effects of living a dysfunctionally privileged lifestyle , and by the end , we only wish we could have spent more time in its world . ","eric schweig and graham greene both exude an air of dignity that's perfect for the proud warrior that still lingers in the souls of these characters . ","lovely and amazing is holofcener's deep , uncompromising curtsy to women she knows , and very likely is . when all is said and done , she loves them to pieces -- and so , i trust , will you . ","campbell scott finds the ideal outlet for his flick-knife diction in the role of roger swanson . ","[fiji diver rusi vulakoro and the married couple howard and michelle hall] show us the world they love and make us love it , too . ","russian ark is a new treasure of the hermitage . ","the animated sequences are well done and perfectly constructed to convey a sense of childhood imagination and creating adventure out of angst . ","it's definitely a step in the right direction . ","as the princess , sorvino glides gracefully from male persona to female without missing a beat . ben kingsley is truly funny , playing a kind of ghandi gone bad . ","ourside the theatre roger might be intolerable company , but inside it he's well worth spending some time with . ","a gem , captured in the unhurried , low-key style favored by many directors of the iranian new wave . ","in an era where big stars and high production values are standard procedure , narc strikes a defiantly retro chord , and outpaces its contemporaries with daring and verve . ","almost peerlessly unsettling . ","ranges from laugh-out-loud hilarious to wonder-what- time-it-is tedious . ","the film's gamble to occasionally break up the live-action scenes with animated sequences pays off , as does its sensitive handling of some delicate subject matter . ","talk to her is not the perfect movie many have made it out to be , but it's still quite worth seeing . ","beating the austin powers films at their own game , this blaxploitation spoof downplays the raunch in favor of gags that rely on the strength of their own cleverness as opposed to the extent of their outrageousness . ","this is a dark , gritty , sometimes funny little gem . ","for all its visual panache and compelling supporting characters , the heart of the film rests in the relationship between sullivan and his son . ","what makes salton sea surprisingly engrossing is that caruso takes an atypically hypnotic approach to a world that's often handled in fast-edit , hopped-up fashion . ","a hidden-agenda drama that shouts classic french nuance . ","with spy kids 2 : the island of lost dreams , the spy kids franchise establishes itself as a durable part of the movie landscape : a james bond series for kids . ","an invaluable historical document thanks to the filmmaker's extraordinary access to massoud , whose charm , cultivation and devotion to his people are readily apparent . ","the performances of the four main actresses bring their characters to life . a little melodramatic , but with enough hope to keep you engaged . ","lan yu seems altogether too slight to be called any kind of masterpiece . it is , however , a completely honest , open-hearted film that should appeal to anyone willing to succumb to it . ","everyone should be able to appreciate the wonderful cinematography and naturalistic acting . ","this often-hilarious farce manages to generate the belly laughs of lowbrow comedy without sacrificing its high-minded appeal . ","stock up on silver bullets for director neil marshall's intense freight train of a film . ","expands the limits of what a film can be , taking us into the lives of women to whom we might not give a second look if we passed them on the street . ","the farcical elements seemed too pat and familiar to hold my interest , yet its diverting grim message is a good one . ","shanghai ghetto may not be as dramatic as roman polanski's the pianist , but its compassionate spirit soars every bit as high . ","despite these annoyances , the capable clayburgh and tambor really do a great job of anchoring the characters in the emotional realities of middle age . ","the underworld urban angst is derivative of martin scorsese's taxi driver and goodfellas , but this film speaks for itself . ","the film's heady yet far from impenetrable theory suggests that russians take comfort in their closed-off nationalist reality . ","despite modest aspirations its occasional charms are not to be dismissed . ","constantly touching , surprisingly funny , semi-surrealist exploration of the creative act . ","the journey is worth your time , especially if you have ellen pompeo sitting next to you for the ride . ","merci pour le movie . ","for every cheesy scene , though , there is a really cool bit -- the movie's conception of a future-world holographic librarian ( orlando jones ) who knows everything and answers all questions , is visually smart , cleverly written , and nicely realized . ","what sets ms . birot's film apart from others in the genre is a greater attention to the parents -- and particularly the fateful fathers -- in the emotional evolution of the two bewitched adolescents . ","all three women deliver remarkable performances . ","claire is a terrific role for someone like judd , who really ought to be playing villains . ","it's clear that mehta simply wanted to update her beloved genre for the thousands of indians who fancy themselves too sophisticated for the cheese-laced spectacles that pack 'em in on the subcontinent . ","compassionately explores the seemingly irreconcilable situation between conservative christian parents and their estranged gay and lesbian children . ","the soundtrack alone is worth the price of admission . ","rodriguez does a splendid job of racial profiling hollywood style--casting excellent latin actors of all ages--a trend long overdue . ","beneath the film's obvious determination to shock at any cost lies considerable skill and determination , backed by sheer nerve . ","bielinsky is a filmmaker of impressive talent . ","so beautifully acted and directed , it's clear that washington most certainly has a new career ahead of him if he so chooses . ","a visual spectacle full of stunning images and effects . ","a gentle and engrossing character study . ","it's enough to watch huppert scheming , with her small , intelligent eyes as steady as any noir villain , and to enjoy the perfectly pitched web of tension that chabrol spins . ","an engrossing portrait of uncompromising artists trying to create something original against the backdrop of a corporate music industry that only seems to care about the bottom line . ","a mischievous visual style and oodles of charm make 'cherish' a very good ( but not great ) movie . ","just as the recent argentine film son of the bride reminded us that a feel-good movie can still show real heart , time of favor presents us with an action movie that actually has a brain . ","[a] strong piece of work . ","a stirring tribute to the bravery and dedication of the world's reporters who willingly walk into the nightmare of war not only to record the events for posterity , but to help us clearly see the world of our making . ","the importance of being earnest , so thick with wit it plays like a reading from bartlett's familiar quotations","daring and beautifully made . ","made for teens and reviewed as such , this is recommended only for those under 20 years of age . . . and then only as a very mild rental . ","imagine o . henry's <b>the gift of the magi</b> relocated to the scuzzy underbelly of nyc's drug scene . merry friggin' christmas ! ","the film does give a pretty good overall picture of the situation in laramie following the murder of matthew shepard . ","both lead performances are oscar-size . quaid is utterly fearless as the tortured husband living a painful lie , and moore wonderfully underplays the long-suffering heroine with an unflappable '50s dignity somewhere between jane wyman and june cleaver . ","ferrara's best film in years . ","a remarkably insightful look at the backstage angst of the stand-up comic . ","nothing short of wonderful with its ten-year-old female protagonist and its steadfast refusal to set up a dualistic battle between good and evil . ","davis' candid , archly funny and deeply authentic take on intimate relationships comes to fruition in her sophomore effort . ","it's more enjoyable than i expected , though , and that's because the laughs come from fairly basic comedic constructs . cinematic pratfalls given a working over . the cast is spot on and the mood is laid back . ","matches neorealism's impact by showing the humanity of a war-torn land filled with people who just want to live their lives . ","those moviegoers who would automatically bypass a hip-hop documentary should give  scratch  a second look . ","baby-faced renner is eerily convincing as this bland blank of a man with unimaginable demons within . ","romantic , riveting and handsomely animated . ","a competent , unpretentious entertainment destined to fill the after-school slot at shopping mall theaters across the country . ","shot largely in small rooms , the film has a gentle , unforced intimacy that never becomes claustrophobic . ","where janice beard falters in its recycled aspects , implausibility , and sags in pace , it rises in its courageousness , and comedic employment . ","byler is too savvy a filmmaker to let this morph into a typical romantic triangle . instead , he focuses on the anguish that can develop when one mulls leaving the familiar to traverse uncharted ground . ","mcgrath has deftly trimmed dickens' wonderfully sprawling soap opera , the better to focus on the hero's odyssey from cowering poverty to courage and happiness . ","a chance to see three splendid actors turn a larky chase movie into an emotionally satisfying exploration of the very human need to be somebody , and to belong to somebody . ","metaphors abound , but it is easy to take this film at face value and enjoy its slightly humorous and tender story . ","as directed by dani kouyate of burkina faso , sia lacks visual flair . but kouyate elicits strong performances from his cast , and he delivers a powerful commentary on how governments lie , no matter who runs them . ","the best comedy concert movie i've seen since cho's previous concert comedy film , i'm the one that i want , in 2000 . ","broomfield reminds us that beneath the hype , the celebrity , the high life , the conspiracies and the mystery there were once a couple of bright young men -- promising , talented , charismatic and tragically doomed . ","offers laughs and insight into one of the toughest ages a kid can go through . ","a perceptive , good-natured movie . ","an amused indictment of jaglom's own profession . ","a small movie with a big heart . ","hugely accomplished slice of hitchcockian suspense . ","the formula is familiar but enjoyable . ","tells a fascinating , compelling story . ","a triumph , a film that hews out a world and carries us effortlessly from darkness to light . ","what begins as a conventional thriller evolves into a gorgeously atmospheric meditation on life-changing chance encounters . ","the lady and the duke is a smart , romantic drama that dares to depict the french revolution from the aristocrats' perspective . ","most haunting about  fence  is its conclusion , when we hear the ultimate fate of these girls and realize , much to our dismay , that this really did happen . noyce's greatest mistake is thinking that we needed sweeping , dramatic , hollywood moments to keep us","world traveler might not go anywhere new , or arrive anyplace special , but it's certainly an honest attempt to get at something . ","there's much tongue in cheek in the film and there's no doubt the filmmaker is having fun with it all . ","there's absolutely no reason why blue crush , a late-summer surfer girl entry , should be as entertaining as it is","an action/thriller of the finest kind , evoking memories of day of the jackal , the french connection , and heat . ","the best movie in many a moon about the passions that sometimes fuel our best achievements and other times leave us stranded with nothing more than our lesser appetites . ","in capturing the understated comedic agony of an ever-ruminating , genteel yet decadent aristocracy that can no longer pay its bills , the film could just as well be addressing the turn of the 20th century into the 21st . ","insomnia does not become one of those rare remakes to eclipse the original , but it doesn't disgrace it , either . ","classic cinema served up with heart and humor","[stephen] earnhart's film is more about the optimism of a group of people who are struggling to give themselves a better lot in life than the ones they currently have . ","the events of the film are just so weird that i honestly never knew what the hell was coming next . ","nicole holofcener's lovely and amazing , from her own screenplay , jumps to the head of the class of women's films that manage to avoid the ghetto of sentimental chick-flicks by treating female follies with a satirical style . ","that jack nicholson makes this man so watchable is a tribute not only to his craft , but to his legend . ","has a solid emotional impact . ","successfully blended satire , high camp and yet another sexual taboo into a really funny movie . ","mark pellington's latest pop thriller is as kooky and overeager as it is spooky and subtly in love with myth . ","while maintaining the appearance of clinical objectivity , this sad , occasionally horrifying but often inspiring film is among wiseman's warmest . ","raimi crafted a complicated hero who is a welcome relief from the usual two-dimensional offerings . ","an enjoyable above average summer diversion . ","there is simply no doubt that this film asks the right questions at the right time in the history of our country . ","if you've the patience , there are great rewards here . ","as a science fiction movie ,  minority report  astounds . ","watching e . t now , in an era dominated by cold , loud special-effects-laden extravaganzas , one is struck less by its lavish grandeur than by its intimacy and precision . ","visually breathtaking , viscerally exciting , and dramatically moving , it's the very definition of epic adventure . ","chris columbus' sequel is faster , livelier and a good deal funnier than his original . ","watching this film , what we feel isn't mainly suspense or excitement . the dominant feeling is something like nostalgia . ","' . . . a great , participatory spectator sport . '","a rather brilliant little cult item : a pastiche of children's entertainment , superhero comics , and japanese animation . ","believes so fervently in humanity that it feels almost anachronistic , and it is too cute by half . but arriving at a particularly dark moment in history , it offers flickering reminders of the ties that bind us . ","adam sandler ! in an art film ! ","as averse as i usually am to feel-good , follow-your-dream hollywood fantasies , this one got to me . ","stone seems to have a knack for wrapping the theater in a cold blanket of urban desperation . "," . . . a funny yet dark and seedy clash of cultures and generations . ","the hook is the drama within the drama , as an unsolved murder and an unresolved moral conflict jockey for the spotlight . ","over the years , hollywood has crafted a solid formula for successful animated movies , and ice age only improves on it , with terrific computer graphics , inventive action sequences and a droll sense of humor . ","like smoke signals , the film is also imbued with strong themes of familial ties and spirituality that are powerful and moving without stooping to base melodrama","one of those movies that make us pause and think of what we have given up to acquire the fast-paced contemporary society . ","one of the most original american productions this year , you'll find yourself remembering this refreshing visit to a sunshine state . ","melds derivative elements into something that is often quite rich and exciting , and always a beauty to behold . ","gives everyone something to shout about . ","the entire movie has a truncated feeling , but what's available is lovely and lovable . ","[a] thoughtful , visually graceful work . ","admirers of director abel ferrara may be relieved that his latest feature , r xmas , marks a modest if encouraging return to form . ","the slam-bang superheroics are kinetic enough to engross even the most antsy youngsters . ","a worthy addition to the cinematic canon , which , at last count , numbered 52 different versions . ","deliciously mean-spirited and wryly observant . ","the kind of primal storytelling that george lucas can only dream of . ","even if the ring has a familiar ring , it's still unusually crafty and intelligent for hollywood horror . ","the sheer joy and pride they took in their work -- and in each other -- shines through every frame . ","a solidly constructed , entertaining thriller that stops short of true inspiration . ","the cast . . . keeps this pretty watchable , and casting mick jagger as director of the escort service was inspired . ","an entertaining , if somewhat standardized , action movie . ","it has a dashing and resourceful hero ; a lisping , reptilian villain ; big fights ; big hair ; lavish period scenery ; and a story just complicated enough to let you bask in your own cleverness as you figure it out . ","an enjoyable comedy of lingual and cultural differences… the château is a film -- full of life and small delights -- that has all the wiggling energy of young kitten . ","intriguing and downright intoxicating . ","an incredibly thoughtful , deeply meditative picture that neatly and effectively captures the debilitating grief felt in the immediate aftermath of the terrorist attacks . ","with an obvious rapport with her actors and a striking style behind the camera , hélène angel is definitely a director to watch . "," . . . could easily be called the best korean film of 2002 . ","full of detail about the man and his country , and is well worth seeing . ","the banter between calvin and his fellow barbers feels like a streetwise mclaughlin group . . . and never fails to entertain . ","thoroughly engrossing and ultimately tragic . ","peter jackson and company once again dazzle and delight us , fulfilling practically every expectation either a longtime tolkien fan or a movie-going neophyte could want . ","bill morrison's decasia is uncompromising , difficult and unbearably beautiful . ","full of bland hotels , highways , parking lots , with some glimpses of nature and family warmth , time out is a discreet moan of despair about entrapment in the maze of modern life . ","even with all its botches , enigma offers all the pleasure of a handsome and well-made entertainment . ","his work transcends the boy-meets-girl posturing of typical love stories . ","if the real-life story is genuinely inspirational , the movie stirs us as well . ","an ebullient tunisian film about the startling transformation of a tradition-bound widow who is drawn into the exotic world of belly dancing . ","the dramatic crisis doesn't always succeed in its quest to be taken seriously , but huppert's volatile performance makes for a riveting movie experience . ","highly irritating at first , mr . koury's passive technique eventually begins to yield some interesting results . ","about schmidt belongs to nicholson . gone are the flamboyant mannerisms that are the trademark of several of his performances . as schmidt , nicholson walks with a slow , deliberate gait , chooses his words carefully and subdues his natural exuberance . ","the powder blues and sun-splashed whites of tunis make an alluring backdrop for this sensuous and spirited tale of a prim widow who finds an unlikely release in belly-dancing clubs . ","it doesn't make for great cinema , but it is interesting to see where one's imagination will lead when given the opportunity . ","it's sobering , particularly if anyone still thinks this conflict can be resolved easily , or soon . ","if it's not entirely memorable , the movie is certainly easy to watch . "," . . . by the time it's done with us , mira nair's new movie has its audience giddy with the delight of discovery , of having been immersed in a foreign culture only to find that human nature is pretty much the same all over . ","best indie of the year , so far . ","[ferrera] has the charisma of a young woman who knows how to hold the screen . "," . . . the plot weaves us into a complex web . ","don't judge this one too soon - it's a dark , gritty story but it takes off in totally unexpected directions and keeps on going . ","it's funny , as the old saying goes , because it's true . ","in death to smoochy , we don't get williams' usual tear and a smile , just sneers and bile , and the spectacle is nothing short of refreshing . ","a serviceable euro-trash action extravaganza , with a decent sense of humor and plenty of things that go boom — handguns , bmws and seaside chateaus . ","fortunately , elling never gets too cloying thanks to the actors' perfect comic timing and sweet , genuine chemistry . ","if you've grown tired of going where no man has gone before , but several movies have - take heart . this is the best star trek movie in a long time . ","greg kinnear gives a mesmerizing performance as a full-fledged sex addict who is in complete denial about his obsessive behavior . ","not only a coming-of-age story and cautionary parable , but also a perfectly rendered period piece . ","ou've got to love a disney pic with as little cleavage as this one has , and a heroine as feisty and principled as jane . ","a funny , triumphant , and moving documentary . ","delirious fun . ","lathan and diggs carry the film with their charisma , and both exhibit sharp comic timing that makes the more hackneyed elements of the film easier to digest . ","about schmidt is nicholson's goofy , heartfelt , mesmerizing king lear . ","a confluence of kiddie entertainment , sophisticated wit and symbolic graphic design . ","gay or straight , kissing jessica stein is one of the greatest date movies in years . ","this is a movie full of grace and , ultimately , hope . ","exciting and well-paced . ","even better than the first one ! ","its compelling mix of trial movie , escape movie and unexpected fable ensures the film never feels draggy . ","a must see for all sides of the political spectrum","[reynolds] takes a classic story , casts attractive and talented actors and uses a magnificent landscape to create a feature film that is wickedly fun to watch . ","there are problems with this film that even 3 oscar winners can't overcome , but it's a nice girl-buddy movie once it gets rock-n-rolling . ","rich in atmosphere of the post-war art world , it manages to instruct without reeking of research library dust . ","has the rare capability to soothe and break your heart with a single stroke . ","it rapidly develops into a gut-wrenching examination of the way cultural differences and emotional expectations collide . ","though it flirts with bathos and pathos and the further oprahfication of the world as we know it , it still cuts all the way down to broken bone . ","this humbling little film , fueled by the light comedic work of zhao benshan and the delicate ways of dong jie , is just the sort for those moviegoers who complain that 'they don't make movies like they used to anymore . '","es una de esas películas de las que uno sale reconfortado , agradecido , genuinamente sorprendido . ","it will break your heart many times over . ","a straight-shooting family film which awards animals the respect they've rarely been given . ","overall , interesting as a documentary -- but not very imaxy . ","this is one of those war movies that focuses on human interaction rather than battle and action sequences . . . and it's all the stronger because of it . ","secretary  is owned by its costars , spader and gyllenhaal . maggie g . makes an amazing breakthrough in her first starring role and eats up the screen . ","the film fits into a genre that has been overexposed , redolent of a thousand cliches , and yet remains uniquely itself , vibrant with originality . ","not only is it a charming , funny and beautifully crafted import , it uses very little dialogue , making it relatively effortless to read and follow the action at the same time . ","'almodóvar logra un filme entrañable , lleno de compasión , comprensión , amor , amistad , esperanza y humanidad que es sencillamente inolvidable . '","the kind of sense of humor that derives from a workman's grasp of pun and entendre and its attendant need to constantly draw attention to itself . ","too much of storytelling moves away from solondz's social critique , casting its audience as that of intellectual lector in contemplation of the auteur's professional injuries . ","the story is virtually impossible to follow here , but there's a certain style and wit to the dialogue . ","the music makes a nice album , the food is enticing and italy beckons us all . ","the film is an earnest try at beachcombing verismo , but it would be even more indistinct than it is were it not for the striking , quietly vulnerable personality of ms . ambrose . ","the film is small in scope , yet perfectly formed . ","jones has delivered a solidly entertaining and moving family drama . ","happy times maintains an appealing veneer without becoming too cute about it . ","oliveira seems to pursue silent film representation with every mournful composition . ","one of the pleasures in walter's documentary . . . is the parade of veteran painters , confounded dealers , and miscellaneous bohos who expound upon the subject's mysterious personality without ever explaining him . ","captures all the longing , anguish and ache , the confusing sexual messages and the wish to be a part of that elusive adult world . ","he's the scariest guy you'll see all summer . ","  frailty  offers chills much like those that you get when sitting around a campfire around midnight , telling creepy stories to give each other the willies . and , there's no way you won't be talking about the film once you exit the theater . ","really quite funny . ","if i have to choose between gorgeous animation and a lame story ( like , say , treasure planet ) or so-so animation and an exciting , clever story with a batch of appealing characters , i'll take the latter every time . ","quiet , adult and just about more stately than any contemporary movie this year . . . a true study , a film with a questioning heart and mind that isn't afraid to admit it doesn't have all the answers . ","in the end , the film is less the cheap thriller you'd expect than it is a fairly revealing study of its two main characters — damaged-goods people whose orbits will inevitably and dangerously collide . ","some of the visual flourishes are a little too obvious , but restrained and subtle storytelling , and fine performances make this delicate coming-of-age tale a treat . ","it is hard not to be especially grateful for freedom after a film like this . ","the dirty jokes provide the funniest moments in this oddly sweet comedy about jokester highway patrolmen . ","y tu mamá también is hilariously , gloriously alive , and quite often hotter than georgia asphalt . "," . . . works on some levels and is certainly worth seeing at least once . ","you come away from his film overwhelmed , hopeful and , perhaps paradoxically , illuminated . ","if the material is slight and admittedly manipulative , jacquot preserves tosca's intoxicating ardor through his use of the camera . ","thirteen conversations about one thing lays out a narrative puzzle that interweaves individual stories , and , like a mobius strip , elliptically loops back to where it began . ","overall , it's a wacky and inspired little film that works effortlessly at delivering genuine , acerbic laughs . ","mais um momento inspirado de david fincher . ","a must for fans of british cinema , if only because so many titans of the industry are along for the ride . ","tsai has managed to create an underplayed melodrama about family dynamics and dysfunction that harks back to the spare , unchecked heartache of yasujiro ozu . ","until ( the ) superfluous . . . epilogue that leaks suspension of disbelief like a sieve , die another day is as stimulating & heart-rate-raising as any james bond thriller . ","it's a good film , but it falls short of its aspiration to be a true 'epic' . ","all the pieces fall together without much surprise , but little moments give it a boost . ","the beauty of alexander payne's ode to the everyman is in the details . ","a touching drama about old age and grief with a tour de force performance by michel piccoli . ","the ending feels at odds with the rest of the film . ","a tone of rueful compassion . . . reverberates throughout this film , whose meaning and impact is sadly heightened by current world events . ","a beautiful paean to a time long past . ","dense and thoughtful and brimming with ideas that are too complex to be rapidly absorbed . ","if you thought tom hanks was just an ordinary big-screen star , wait until you've seen him eight stories tall . ","with this masterful , flawless film , [wang] emerges in the front ranks of china's now numerous , world-renowned filmmakers . ","shyamalan offers copious hints along the way -- myriad signs , if you will -- that beneath the familiar , funny surface is a far bigger , far more meaningful story than one in which little green men come to earth for harvesting purposes . ","this film is an act of spiritual faith -- an eloquent , deeply felt meditation on the nature of compassion . ","a different kind of love story - one that is dark , disturbing , painful to watch , yet compelling . ","splendidly illustrates the ability of the human spirit to overcome adversity . ","a compelling , gut-clutching piece of advocacy cinema that carries you along in a torrent of emotion as it explores the awful complications of one terrifying day . ","she's as rude and profane as ever , always hilarious and , most of the time , absolutely right in her stinging social observations . ","to those who have not read the book , the film is a much better mother-daughter tale than last summer's 'divine secrets of the ya-ya sisterhood , ' but that's not saying much . ","even before it builds up to its insanely staged ballroom scene , in which 3000 actors appear in full regalia , it's waltzed itself into the art film pantheon . ","a thoughtful , reverent portrait of what is essentially a subculture , with its own rules regarding love and family , governance and hierarchy . ","it seems impossible that an epic four-hour indian musical about a cricket game could be this good , but it is . ","will certainly appeal to asian cult cinema fans and asiaphiles interested to see what all the fuss is about . ","touches smartly and wistfully on a number of themes , not least the notion that the marginal members of society . . . might benefit from a helping hand and a friendly kick in the pants . ","a wildly entertaining scan of evans' career . ","a mature , deeply felt fantasy of a director's travel through 300 years of russian history . ","boldly engineering a collision between tawdry b-movie flamboyance and grandiose spiritual anomie , rose's film , true to its source material , provides a tenacious demonstration of death as the great equalizer . ","a finely tuned mood piece , a model of menacing atmosphere . ","the salton sea has moments of inspired humour , though every scrap is of the darkest variety . ","both a beautifully made nature film and a tribute to a woman whose passion for this region and its inhabitants still shines in her quiet blue eyes . ","although shot with little style , skins is heartfelt and achingly real . ","harks back to a time when movies had more to do with imagination than market research . ","upsetting and thought-provoking , the film has an odd purity that doesn't bring you into the characters so much as it has you study them . ","a well-executed spy-thriller . ","a very pretty after-school special . it's an effort to watch this movie , but it eventually pays off and is effective if you stick with it . ","a harrowing account of a psychological breakdown . ","continually challenges perceptions of guilt and innocence , of good guys and bad , and asks us whether a noble end can justify evil means . ","it certainly won't win any awards in the plot department but it sets out with no pretensions and delivers big time . ","dog soldiers doesn't transcend genre -- it embraces it , energizes it and takes big bloody chomps out of it . ","at once emotional and richly analytical , the cosby-seinfeld encounter alone confirms the serious weight behind this superficially loose , larky documentary . ","it may scream low budget , but this charmer has a spirit that cannot be denied . ","'alice's adventure through the looking glass and into zombie-land' is filled with strange and wonderful creatures . ","without [de niro] , city by the sea would slip under the waves . he drags it back , single-handed . ","a good music documentary , probably one of the best since the last waltz . ","if the plot seems a bit on the skinny side , that's because panic room is interested in nothing more than sucking you in…and making you sweat . "," . . . [the film] works , due mostly to the tongue-in-cheek attitude of the screenplay . ","the film becomes an overwhelming pleasure , and you find yourself rooting for gai's character to avoid the fate that has befallen every other carmen before her . ","broomfield has a rather unique approach to documentary . he thinks the film is just as much a document about him as it is about the subject . ","at its best when the guarded , resentful betty and the manipulative yet needy margot are front and center . ","gloriously straight from the vagina . ","it's excessively quirky and a little underconfident in its delivery , but otherwise this is the best 'old neighborhood' project since christopher walken kinda romanced cyndi lauper in the opportunists . ","the film oozes craft . ","robinson's web of suspense matches the page-turning frenzy that clancy creates . ","manages to be both hugely entertaining and uplifting . ","a classic fairy tale that perfectly captures the wonders and worries of childhood in a way that few movies have ever approached . ","it's the unsettling images of a war-ravaged land that prove more potent and riveting than the unlikely story of sarah and harrison . ","a wonderfully warm human drama that remains vividly in memory long after viewing","jaunty fun , with its celeb-strewn backdrop well used . ","recoing's fantastic performance doesn't exactly reveal what makes vincent tick , but perhaps any definitive explanation for it would have felt like a cheat . ","washington overcomes the script's flaws and envelops the audience in his character's anguish , anger and frustration . ","the film fearlessly gets under the skin of the people involved . . . this makes it not only a detailed historical document , but an engaging and moving portrait of a subculture . ","a searing , epic treatment of a nationwide blight that seems to be , horrifyingly , ever on the rise . ","not a film for the faint of heart or conservative of spirit , but for the rest of us -- especially san francisco lovers -- it's a spirited film and a must-see . ","read my lips is to be viewed and treasured for its extraordinary intelligence and originality as well as its lyrical variations on the game of love . ","the color sense of stuart little 2 is its most immediate and most obvious pleasure , but it would count for very little if the movie weren't as beautifully shaped and as delicately calibrated in tone as it is . ","while [roman coppola] scores points for style , he staggers in terms of story . ","idiotic and ugly . ","any movie that makes hard work seem heroic deserves a look . ","it may not be a huge cut of above the rest , but i enjoyed barbershop . it's a funny little movie with clever dialogue and likeable characters . ","a different and emotionally reserved type of survival story -- a film less about refracting all of world war ii through the specific conditions of one man , and more about that man lost in its midst . ","it's sweet , funny , charming , and completely delightful . ","a perfectly competent and often imaginative film that lacks what little lilo & stitch had in spades -- charisma . ","beautifully shot against the frozen winter landscapes of grenoble and geneva , the film unfolds with all the mounting tension of an expert thriller , until the tragedy beneath it all gradually reveals itself . ","medem may have disrobed most of the cast , leaving their bodies exposed , but the plot remains as guarded as a virgin with a chastity belt . that's why sex and lucia is so alluring . ","an elegant work , food of love is as consistently engaging as it is revealing . ","although largely a heavy-handed indictment of parental failings and the indifference of spanish social workers and legal system towards child abuse , the film retains ambiguities that make it well worth watching . ","a behind the scenes look at the training and dedication that goes into becoming a world-class fencer and the champion that's made a difference to nyc inner-city youth . ","a brain twister , less a movie-movie than a funny and weird meditation on hollywood , success , artistic integrity and intellectual bankruptcy . ","a powerful , inflammatory film about religion that dares to question an ancient faith , and about hatred that offers no easy , comfortable resolution . ","in its own floundering way , it gets to you . just like igby . ","return to never land may be another shameless attempt by disney to rake in dough from baby boomer families , but it's not half-bad . ","wise and deadpan humorous . ","god bless crudup and his aversion to taking the easy hollywood road and cashing in on his movie-star gorgeousness . ","if signs is a good film , and it is , the essence of a great one is in there somewhere . ","veterans of the dating wars will smirk uneasily at the film's nightmare versions of everyday sex-in-the-city misadventures . ","schrader examines crane's decline with unblinking candor . ","you can watch , giggle and get an adrenaline boost without feeling like you've completely lowered your entertainment standards . ","it thankfully goes easy on the reel/real world dichotomy that [jaglom] pursued with such enervating determination in venice/venice . ","this rich , bittersweet israeli documentary , about the life of song-and-dance-man pasach'ke burstein and his family , transcends ethnic lines . ","sensitively examines general issues of race and justice among the poor , and specifically raises serious questions about the death penalty and asks what good the execution of a mentally challenged woman could possibly do . ","cool gadgets and creatures keep this fresh . not as good as the original , but what is . . . ","presents a side of contemporary chinese life that many outsiders will be surprised to know exists , and does so with an artistry that also smacks of revelation . ","[jeff's] gorgeous , fluid compositions , underlined by neil finn and edmund mcwilliams's melancholy music , are charged with metaphor , but rarely easy , obvious or self-indulgent . ","engages us in constant fits of laughter , until we find ourselves surprised at how much we care about the story , and end up walking out not only satisfied but also somewhat touched . ","a bilingual charmer , just like the woman who inspired it","blisteringly rude , scarily funny , sorrowfully sympathetic to the damage it surveys , the film has in kieran culkin a pitch-perfect holden . ","apuestas fuertes para el futuro del director , y apuestas bien fundadas , pues la suerte ya la tiene , y la cinta lo comprueba . . . . ","the fourth  pokemon  is a diverting--if predictable--adventure suitable for a matinee , with a message that cautions children about disturbing the world's delicate ecological balance . ","what one is left with , even after the most awful acts are committed , is an overwhelming sadness that feels as if it has made its way into your very bloodstream . ","[it] has the feel of a summer popcorn movie . nothing too deep or substantial . explosions , jokes , and sexual innuendoes abound . ","miyazaki's nonstop images are so stunning , and his imagination so vivid , that the only possible complaint you could have about spirited away is that there is no rest period , no timeout . "," . . . a delightfully unpredictable , hilarious comedy with wonderful performances that tug at your heart in ways that utterly transcend gender labels . ","assured , vital and well wrought , the film is , arguably , the most accomplished work to date from hong kong's versatile stanley kwan . ","delia , greta , and paula rank as three of the most multilayered and sympathetic female characters of the year . as each of them searches for their place in the world , miller digs into their very minds to find an unblinking , flawed humanity . ","a surprisingly sweet and gentle comedy . ","shanghai ghetto , much stranger than any fiction , brings this unknown slice of history affectingly to life . ","it's not particularly well made , but since i found myself howling more than cringing , i'd say the film works . ","but this is lohman's film . her performance moves between heartbreak and rebellion as she continually tries to accommodate to fit in and gain the unconditional love she seeks . ","though its story is only surface deep , the visuals and enveloping sounds of blue crush make this surprisingly decent flick worth a summertime look-see . ","ryosuke has created a wry , winning , if languidly paced , meditation on the meaning and value of family . ","sometimes charming , sometimes infuriating , this argentinean 'dramedy' succeeds mainly on the shoulders of its actors . ","you may feel compelled to watch the film twice or pick up a book on the subject . ","often shocking but ultimately worthwhile exploration of motherhood and desperate mothers . ","a venturesome , beautifully realized psychological mood piece that reveals its first-time feature director's understanding of the expressive power of the camera . ","like the rugrats movies , the wild thornberrys movie doesn't offer much more than the series , but its emphasis on caring for animals and respecting other cultures is particularly welcome . ","taken outside the context of the current political climate ( see : terrorists are more evil than ever ! ) , the sum of all fears is simply a well-made and satisfying thriller . ","the setting is so cool that it chills the characters , reducing our emotional stake in the outcome of  intacto's  dangerous and seductively stylish game . ","a lovely and beautifully photographed romance . ","one of the most splendid entertainments to emerge from the french film industry in years . ","its vision of that awkward age when sex threatens to overwhelm everything else is acute enough to make everyone who has been there squirm with recognition . ","for almost the first two-thirds of martin scorsese's 168-minute gangs of new york , i was entranced . ","open-ended and composed of layer upon layer , talk to her is a cinephile's feast , an invitation to countless interpretations . ","one of the most slyly exquisite anti-adult movies ever made . ","what makes esther kahn so demanding is that it progresses in such a low-key manner that it risks monotony . but it's worth the concentration . ","neither the funniest film that eddie murphy nor robert de niro has ever made , showtime is nevertheless efficiently amusing for a good while . before it collapses into exactly the kind of buddy cop comedy it set out to lampoon , anyway . ","a clever script and skilled actors bring new energy to the familiar topic of office politics . ","the determination of pinochet's victims to seek justice , and their often heartbreaking testimony , spoken directly into director patricio guzman's camera , pack a powerful emotional wallop . ","disney aficionados will notice distinct parallels between this story and the 1971 musical  bedknobs and broomsticks ,  which also dealt with british children rediscovering the power of fantasy during wartime . ","it's . . . worth the extra effort to see an artist , still committed to growth in his ninth decade , change while remaining true to his principles with a film whose very subject is , quite pointedly , about the peril of such efforts . ","dark and unrepentant , this excursion into the epicenter of percolating mental instability is not easily dismissed or forgotten . ","it's a rollicking adventure for you and all your mateys , regardless of their ages . ","boasts a handful of virtuosic set pieces and offers a fair amount of trashy , kinky fun . "," . . . myers has turned his franchise into the movie version of an adolescent dirty-joke book done up in post-tarantino pop-culture riffs . . . ","if you're down for a silly hack-and-slash flick , you can do no wrong with jason x . ","this is a very ambitious project for a fairly inexperienced filmmaker , but good actors , good poetry and good music help sustain it . ","the modern master of the chase sequence returns with a chase to end all chases","the messy emotions raging throughout this three-hour effort are instantly recognizable , allowing the film to paradoxically feel familiar and foreign at the same time . "," . . . either you're willing to go with this claustrophobic concept or you're not . ","just watch bettany strut his stuff . you'll know a star when you see one . ","austin powers in goldmember is a cinematic car wreck , a catastrophic collision of tastelessness and gall that nevertheless will leave fans clamoring for another ride . ","you can fire a torpedo through some of clancy's holes , and the scripters don't deserve any oscars . but the nerve-raked acting , the crackle of lines , the impressive stagings of hardware , make for some robust and scary entertainment . ","contrasting the original ringu with the current americanized adaptation is akin to comparing the evil dead with evil dead ii","a small gem of a movie that defies classification and is as thought-provoking as it is funny , scary and sad . ","for a long time the film succeeds with its dark , delicate treatment of these characters and its unerring respect for them . ","it's the kind of effectively creepy-scary thriller that has you fixating on a far corner of the screen at times because your nerves just can't take it any more . ","late marriage is an in-your-face family drama and black comedy that is filled with raw emotions conveying despair and love . ","an ambitious and moving but bleak film . ","it's too harsh to work as a piece of storytelling , but as an intellectual exercise -- an unpleasant debate that's been given the drive of a narrative and that's been acted out -- the believer is nothing less than a provocative piece of work . ","it's sweet . it's funny . it wears its heart on the sleeve of its gaudy hawaiian shirt . and , thanks to the presence of 'the king , ' it also rocks . ","it's never laugh-out-loud funny , but it is frequently amusing . ","a bittersweet film , simple in form but rich with human events . ","the unexplored story opportunities of  punch-drunk love  may have worked against the maker's minimalist intent but it is an interesting exercise by talented writer/director anderson . ","  punch-drunk love  is a little like a chocolate milk moustache . . . "," . . . digs beyond the usual portrayals of good kids and bad seeds to reveal a more ambivalent set of characters and motivations . ","the beauty of the piece is that it counts heart as important as humor . ","piercingly affecting . . . while clearly a manipulative film , emerges as powerful rather than cloying . ","very amusing , not the usual route in a thriller , and the performances are odd and pixilated and sometimes both . ","while the frequent allusions to gurus and doshas will strike some westerners as verging on mumbo-jumbo . . . broad streaks of common sense emerge with unimpeachable clarity . ","the cast is phenomenal , especially the women . ","a marvel of production design . ","the byplay and bickering between the now spy-savvy siblings , carmen ( vega ) and juni ( sabara ) cortez , anchor the film in a very real and amusing give-and-take . ","good actors have a radar for juicy roles -- there's a plethora of characters in this picture , and not one of them is flat . ","though in some ways similar to catherine breillat's fat girl , rain is the far superior film . ","is not so much a work of entertainment as it is a unique , well-crafted psychological study of grief . ","remarkable for its excellent storytelling , its economical , compressed characterisations and for its profound humanity , it's an adventure story and history lesson all in one . ","colorful , energetic and sweetly whimsical . . . the rare sequel that's better than its predecessor . ","reno himself can take credit for most of the movie's success . he's one of the few 'cool' actors who never seems aware of his own coolness . ","significantly better than its 2002 children's-movie competition . ","ub equally spoofs and celebrates the more outre aspects of 'black culture' and the dorkier aspects of 'white culture , ' even as it points out how inseparable the two are . ","a lot smarter than your average bond . "," . . . bright , intelligent , and humanly funny film . ","painful , horrifying and oppressively tragic , this film should not be missed . ","part of the film's cheeky charm comes from its vintage schmaltz . ","so unique and stubborn and charismatic that you want it to be better and more successful than it is . ","i won't argue with anyone who calls 'slackers' dumb , insulting , or childish . . . but i laughed so much that i didn't mind . ","it arrives with an impeccable pedigree , mongrel pep , and almost indecipherable plot complications . ","so fiendishly cunning that even the most jaded cinema audiences will leave the auditorium feeling dizzy , confused , and totally disorientated . not to mention absolutely refreshed . ","a vibrant , colorful , semimusical rendition . ","the film sometimes flags . . . but there is enough secondary action to keep things moving along at a brisk , amusing pace . ","it's a drawling , slobbering , lovable run-on sentence of a film , a southern gothic with the emotional arc of its raw blues soundtrack . ","nós gosta muito de as duas torres . ","nolan proves that he can cross swords with the best of them and helm a more traditionally plotted popcorn thriller while surrendering little of his intellectual rigor or creative composure . ","it is different from others in its genre in that it is does not rely on dumb gags , anatomical humor , or character cliches ; it primarily relies on character to tell its story . ","both a successful adaptation and an enjoyable film in its own right . ","all the filmmakers are asking of us , is to believe in something that is improbable . ","if the very concept makes you nervous . . . you'll have an idea of the film's creepy , scary effectiveness . ","worth a look by those on both sides of the issues , if only for the perspective it offers , one the public rarely sees . ","a mostly believable , refreshingly low-key and quietly inspirational little sports drama . ","may be more genial than ingenious , but it gets the job done . ","a stylish cast and some clever scripting solutions help chicago make the transition from stage to screen with considerable appeal intact . ","exhilarating , funny and fun . ","while not quite  shrek  or monsters , inc .  , it's not too bad . it's worth taking the kids to . ","in the end there is one word that best describes this film : honest . ","writer-director david jacobson and his star , jeremy renner , have made a remarkable film that explores the monster's psychology not in order to excuse him but rather to demonstrate that his pathology evolved from human impulses that grew hideously twisted . ","the action sequences are fun and reminiscent of combat scenes from the star wars series . ","norton is magnetic as graham . ","savvy director robert j . siegel and his co-writers keep the story subtle and us in suspense . ","it pulls the rug out from under you , just when you're ready to hate one character , or really sympathize with another character , something happens to send you off in different direction . ","twenty years after its first release , e . t . remains the most wondrous of all hollywood fantasies -- and the apex of steven spielberg's misunderstood career . ","it says a lot about a filmmaker when he can be wacky without clobbering the audience over the head and still maintain a sense of urgency and suspense . ","gives us a lot to chew on , but not all of it has been properly digested . ","it's an exhilarating place to visit , this laboratory of laughter . ","  simone  is a fun and funky look into an artificial creation in a world that thrives on artificiality . ","a great companion piece to other napoleon films . ","to some eyes this will seem like a recycling of clichés , an assassin's greatest hits . to others , it will remind them that hong kong action cinema is still alive and kicking . ","gran historia sobre el amor , la familia , la lealtad y la traición que seguramente se convertirá en un nuevo clásico del género . ","at the end of the movie , my 6-year-old nephew said ,  i guess i come from a broken family , and my uncles are all aliens , too .  congrats disney on a job well done , i enjoyed it just as much ! ","a remarkably alluring film set in the constrictive eisenhower era about one suburban woman's yearning in the face of a loss that shatters her cheery and tranquil suburban life . ","berling and béart . . . continue to impress , and isabelle huppert . . . again shows uncanny skill in getting under the skin of her characters . ","uplifting , funny and wise . ","remarkable for its intelligence and intensity . ","the hypnotic imagery and fragmentary tale explore the connections between place and personal identity . ","brosnan is more feral in this film than i've seen him before and halle berry does her best to keep up with him . ","a film that begins with the everyday lives of naval personnel in san diego and ends with scenes so true and heartbreaking that tears welled up in my eyes both times i saw the film . ","a funny film . ","  on guard !  won't be placed in the pantheon of the best of the swashbucklers but it is a whole lot of fun and you get to see the one of the world's best actors , daniel auteuil , have a whale of a good time . ","the movie starts with a legend and ends with a story that is so far-fetched it would be impossible to believe if it weren't true . this is the stuff that disney movies are made of . ","like all great films about a life you never knew existed , it offers much to absorb and even more to think about after the final frame . ","that the e-graveyard holds as many good ideas as bad is the cold comfort that chin's film serves up with style and empathy . ","while we no longer possess the lack-of-attention span that we did at seventeen , we had no trouble sitting for blade ii . ","like a poor man's you can count on me"," . . . a solid , unassuming drama . ","a seriocomic debut of extravagant promise by georgian-israeli director dover kosashvili . ","thanks to ice cube , benjamins feels an awful lot like friday in miami . ","though the film is static , its writer-director's heart is in the right place , his plea for democracy and civic action laudable . ","the real star of this movie is the score , as in the songs translate well to film , and it's really well directed . ","it's rare to find a film to which the adjective 'gentle' applies , but the word perfectly describes pauline & paulette . ","my wife is an actress has its moments in looking at the comic effects of jealousy . in the end , though , it is only mildly amusing when it could have been so much more . ","both garcia and jagger turn in perfectly executed and wonderfully sympathetic characters , who are alternately touching and funny . ","humorous , artsy , and even cute , in an off-kilter , dark , vaguely disturbing way . ","the more you think about the movie , the more you will probably like it . "," . . . a powerful sequel and one of the best films of the year . ","for the most part , the film does hold up pretty well . ","together [time out and human resources] establish mr . cantet as france's foremost cinematic poet of the workplace . ","the filmmaker's heart is in the right place . . . ","you can take the grandkids or the grandparents and never worry about anyone being bored . . . audience is a sea of constant smiles and frequent laughter . ","like these russo guys lookin' for their mamet instead found their sturges . ","[a] satisfying niblet . ","there has been a string of ensemble cast romances recently . . . but peter mattei's love in the time of money sets itself apart by forming a chain of relationships that come full circle to end on a positive ( if tragic ) note . ","by applying definition to both sides of the man , the picture realizes a fullness that does not negate the subject . ","who is the audience for cletis tout ? anybody who enjoys quirky , fun , popcorn movies with a touch of silliness and a little bloodshed . ","[cuarón has] created a substantive movie out of several cliched movie structures : the road movie , the coming-of-age movie , and the teenage sex comedy . ","puts to rest any thought that the german film industry cannot make a delightful comedy centering on food . ","poetic , heartbreaking . ","witty dialog between realistic characters showing honest emotions . it's touching and tender and proves that even in sorrow you can find humor . like blended shades of lipstick , these components combine into one terrific story with lots of laughs . ","<em>ash wednesday</em> is not edward burns' best film , but it is a good and ambitious film . and it marks him as one of the most interesting writer/directors working today . ","after one gets the feeling that the typical hollywood disregard for historical truth and realism is at work here , it's a matter of finding entertainment in the experiences of zishe and the fiery presence of hanussen . ","the footage of the rappers at play and the prison interview with suge knight are just two of the elements that will grab you . "," . . . it's as comprehensible as any dummies guide , something even non-techies can enjoy . ","don't wait to see this terrific film with your kids -- if you don't have kids borrow some . ","moretti . . . is the rare common-man artist who's wise enough to recognize that there are few things in this world more complex -- and , as it turns out , more fragile -- than happiness . ","the movie's captivating details are all in the performances , from foreman's barking-mad taylor to thewlis's smoothly sinister freddie and bettany/mcdowell's hard-eyed gangster . ","features fincher's characteristically startling visual style and an almost palpable sense of intensity . ","precocious smarter-than-thou wayward teen struggles to rebel against his oppressive , right-wing , propriety-obsessed family . anyone else seen this before ? ","moore provides an invaluable service by sparking debate and encouraging thought . better still , he does all of this , and more , while remaining one of the most savagely hilarious social critics this side of jonathan swift . ","alternating between facetious comic parody and pulp melodrama , this smart-aleck movie . . . tosses around some intriguing questions about the difference between human and android life . ","a cutesy romantic tale with a twist . ","this is a gorgeous film - vivid with color , music and life . delight your senses and crash this wedding ! ","a brutally dry satire of middle american numbness . ","more sophisticated and literate than such pictures usually are . . . an amusing little catch . ","smith examines the intimate , unguarded moments of folks who live in unusual homes -- which pop up in nearly every corner of the country . ","with an admirably dark first script by brent hanley , paxton , making his directorial feature debut , does strong , measured work . ","a compelling french psychological drama examining the encounter of an aloof father and his chilly son after 20 years apart . "," . . . even if you've never heard of chaplin , you'll still be glued to the screen . ","you have enough finely tuned acting to compensate for the movie's failings . ","as the dominant christine , sylvie testud is icily brilliant . ","although tender and touching , the movie would have benefited from a little more dramatic tension and some more editing . ","the story that emerges has elements of romance , tragedy and even silent-movie comedy . ","[  safe conduct  ] is a long movie at 163 minutes but it fills the time with drama , romance , tragedy , bravery , political intrigue , partisans and sabotage . viva le resistance ! ","it offers a glimpse of the solomonic decision facing jewish parents in those turbulent times : to save their children and yet to lose them . ","the film is delicately narrated by martin landau and directed with sensitivity and skill by dana janklowicz-mann . ","martyr gets royally screwed and comes back for more . ","a virtual roller-coaster ride of glamour and sleaze . ","an admirable , sometimes exceptional film","if you like an extreme action-packed film with a hint of humor , then triple x marks the spot . ","from blushing to gushing---imamura squirts the screen in ‘warm water under a red bridge'","if you're the kind of parent who enjoys intentionally introducing your kids to films which will cause loads of irreparable damage that years and years of costly analysis could never fix , i have just one word for you -– decasia","may not be a breakthrough in filmmaking , but it is unwavering and arresting . ","the film's images give a backbone to the company and provide an emotional edge to its ultimate demise . ","a bodice-ripper for intellectuals . ","the locations go from stark desert to gorgeous beaches . the story plays out slowly , but the characters are intriguing and realistic . ","count on his movie to work at the back of your neck long after you leave the theater . ","neil burger here succeeded in . . . making the mystery of four decades back the springboard for a more immediate mystery in the present . ","the complex , politically charged tapestry of contemporary chinese life this exciting new filmmaker has brought to the screen is like nothing we westerners have seen before . ","a thriller made from a completist's checklist rather than with a cultist's passion . ","try as you might to scrutinize the ethics of kaufman's approach , somehow it all comes together to create a very compelling , sensitive , intelligent and almost cohesive piece of film entertainment . ","as quiet , patient and tenacious as mr . lopez himself , who approaches his difficult , endless work with remarkable serenity and discipline . ","though the film never veers from its comic course , its unintentional parallels might inadvertently evoke memories and emotions which are anything but humorous . ","evokes the style and flash of the double-cross that made mamet's  house of games  and last fall's  heist  so much fun . ","so original in its base concept that you cannot help but get caught up . ","it may be a no-brainer , but at least it's a funny no-brainer . ","a lot more dimensional and complex than its sunny disposition would lead you to believe . ","jeffs has created a breathtakingly assured and stylish work of spare dialogue and acute expressiveness . ","underachieves only in not taking the shakespeare parallels quite far enough . ","the most audacious , outrageous , sexually explicit , psychologically probing , pure libido film of the year has arrived from portugal . ","the creative animation work may not look as fully 'rendered' as pixar's industry standard , but it uses lighting effects and innovative backgrounds to an equally impressive degree . ","art-house to the core , read my lips is a genre-curling crime story that revives the free-wheeling noir spirit of old french cinema . ","grant is certainly amusing , but the very hollowness of the character he plays keeps him at arms length","conceptually brilliant . . . plays like a living-room war of the worlds , gaining most of its unsettling force from the suggested and the unknown . "," . . . manages to deliver a fair bit of vampire fun . ","drama of temptation , salvation and good intentions is a thoughtful examination of faith , love and power . ","the strength of the film comes not from any cinematic razzle-dazzle but from its recovery of an historical episode that , in the simple telling , proves simultaneously harrowing and uplifting . ","the performances are strong , though the subject matter demands acting that borders on hammy at times . ","a damn fine and a truly distinctive and a deeply pertinent film . ","still rapturous after all these years , cinema paradiso stands as one of the great films about movie love . ","reggio and glass put on an intoxicating show . ","macdowell . . . gives give a solid , anguished performance that eclipses nearly everything else she's ever done . ","the thing about guys like evans is this : you're never quite sure where self-promotion ends and the truth begins . but as you watch the movie , you're too interested to care . ","i liked a lot of the smaller scenes . ","the film will appeal to discovery channel fans and will surely widen the perspective of those of us who see the continent through rose-colored glasses . ","an eye-boggling blend of psychedelic devices , special effects and backgrounds , 'spy kids 2' is a visual treat for all audiences . ","formuliac , but fun . ","straightforward and old-fashioned in the best possible senses of both those words , possession is a movie that puts itself squarely in the service of the lovers who inhabit it . ","it may . . . work as a jaunt down memory lane for teens and young adults who grew up on televised scooby-doo shows or reruns . ","one of those movies that catches you up in something bigger than yourself , namely , an archetypal desire to enjoy good trash every now and then . ","this harrowing journey into combat hell vividly captures the chaotic insanity and personal tragedies that are all too abundant when human hatred spews forth unchecked . ","far more successful , if considerably less ambitious , than last year's kubrick-meets-spielberg exercise . ","apart from anything else , this is one of the best-sustained ideas i have ever seen on the screen . ","'pocas veces es posible ver un elenco tan compenetrado con la historia , donde todos y cada uno de los actores ofrecen actuaciones verdaderamente memorables . '","elling builds gradually until you feel fully embraced by this gentle comedy . ","a fascinating examination of the joyous , turbulent self-discovery made by a proper , middle-aged woman . ","here is a vh1 behind the music special that has something a little more special behind it : music that didn't sell many records but helped change a nation . ","buy popcorn . take nothing seriously and enjoy the ride . ","carrying off a spot-on scottish burr , duvall ( also a producer ) peels layers from this character that may well not have existed on paper . ","the acting , for the most part , is terrific , although the actors must struggle with the fact that they're playing characters who sometimes feel more like literary conceits than flesh-and-blood humans . ","some body will take you places you haven't been , and also places you have . ","vereté has a whip-smart sense of narrative bluffs . ","parts of the film feel a bit too much like an infomercial for ram dass's latest book aimed at the boomer demographic . but mostly it's a work that , with humor , warmth , and intelligence , captures a life interestingly lived . ","were it not for a sentimental resolution that explains way more about cal than does the movie or the character any good , freundlich's world traveler might have been one of the more daring and surprising american movies of the year . ","  home movie  is the film equivalent of a lovingly rendered coffee table book . ","graphic sex may be what's attracting audiences to unfaithful , but gripping performances by lane and gere are what will keep them awake . ","when compared to the usual , more somber festival entries , davis' highly personal brand of romantic comedy is a tart , smart breath of fresh air that stands out from the pack even if the picture itself is somewhat problematic . ","feels untidily honest . ","both damning and damned compelling . ","much has been written about those years when the psychedelic '60s grooved over into the gay '70s , but words don't really do the era justice . you have to see it . ","even if it pushes its agenda too forcefully , this remains a film about something , one that attempts and often achieves a level of connection and concern . ","what lifts the film high above run-of-the-filth gangster flicks is its refusal to recognise any of the signposts , as if discovering a way through to the bitter end without a map . ","we've seen the hippie-turned-yuppie plot before , but there's an enthusiastic charm in <i ? fire that makes the formula fresh again . ","both an admirable reconstruction of terrible events , and a fitting memorial to the dead of that day , and of the thousands thereafter . ","a sly dissection of the inanities of the contemporary music business and a rather sad story of the difficulties of artistic collaboration . ","the unique niche of self-critical , behind-the-scenes navel-gazing kaufman has carved from orleans' story and his own infinite insecurity is a work of outstanding originality . ","lovingly photographed in the manner of a golden book sprung to life , stuart little 2 manages sweetness largely without stickiness . ","consistently clever and suspenseful . ","it's like a  big chill  reunion of the baader-meinhof gang , only these guys are more harmless pranksters than political activists . ","the story gives ample opportunity for large-scale action and suspense , which director shekhar kapur supplies with tremendous skill . ","red dragon  never cuts corners . ","fresnadillo has something serious to say about the ways in which extravagant chance can distort our perspective and throw us off the path of good sense . ","throws in enough clever and unexpected twists to make the formula feel fresh . ","weighty and ponderous but every bit as filling as the treat of the title . ","a real audience-pleaser that will strike a chord with anyone who's ever waited in a doctor's office , emergency room , hospital bed or insurance company office . ","generates an enormous feeling of empathy for its characters . ","exposing the ways we fool ourselves is one hour photo's real strength . ","it's up to you to decide whether to admire these people's dedication to their cause or be repelled by their dogmatism , manipulativeness and narrow , fearful view of american life . ","mostly , [goldbacher] just lets her complicated characters be unruly , confusing and , through it all , human . "," . . . quite good at providing some good old fashioned spooks . ","at its worst , the movie is pretty diverting ; the pity is that it rarely achieves its best . ","scherfig's light-hearted profile of emotional desperation is achingly honest and delightfully cheeky . ","a journey spanning nearly three decades of bittersweet camaraderie and history , in which we feel that we truly know what makes holly and marina tick , and our hearts go out to them as both continue to negotiate their imperfect , love-hate relationship . ","the wonderfully lush morvern callar is pure punk existentialism , and ms . ramsay and her co-writer , liana dognini , have dramatized the alan warner novel , which itself felt like an answer to irvine welsh's book trainspotting . ","as it turns out , you can go home again . ","you've already seen city by the sea under a variety of titles , but it's worth yet another visit . ","this kind of hands-on storytelling is ultimately what makes shanghai ghetto move beyond a good , dry , reliable textbook and what allows it to rank with its worthy predecessors . ","making such a tragedy the backdrop to a love story risks trivializing it , though chouraqui no doubt intended the film to affirm love's power to help people endure almost unimaginable horror . ","grown-up quibbles are beside the point here . the little girls understand , and mccracken knows that's all that matters . ","a powerful , chilling , and affecting study of one man's dying fall . ","this is a fascinating film because there is no clear-cut hero and no all-out villain . ","a dreadful day in irish history is given passionate , if somewhat flawed , treatment . "," . . . a good film that must have baffled the folks in the marketing department . "," . . . is funny in the way that makes you ache with sadness ( the way chekhov is funny ) , profound without ever being self-important , warm without ever succumbing to sentimentality . ","devotees of star trek ii : the wrath of khan will feel a nagging sense of deja vu , and the grandeur of the best next generation episodes is lacking . ","a soul-stirring documentary about the israeli/palestinian conflict as revealed through the eyes of some children who remain curious about each other against all odds . ","what's so striking about jolie's performance is that she never lets her character become a caricature -- not even with that radioactive hair . ","the main story . . . is compelling enough , but it's difficult to shrug off the annoyance of that chatty fish . ","the performances are immaculate , with roussillon providing comic relief . ","kinnear . . . gives his best screen performance with an oddly winning portrayal of one of life's ultimate losers . ","hugh grant , who has a good line in charm , has never been more charming than in about a boy . ","there's a lot of tooth in roger dodger . but what's nice is that there's a casual intelligence that permeates the script . ","reminiscent of alfred hitchcock's thrillers , most of the scary parts in 'signs' occur while waiting for things to happen . ","one of the best looking and stylish animated movies in quite a while . . . ","its use of the thriller form to examine the labyrinthine ways in which people's lives cross and change , buffeted by events seemingly out of their control , is intriguing , provocative stuff . ","denver should not get the first and last look at one of the most triumphant performances of vanessa redgrave's career . it deserves to be seen everywhere . ","you needn't be steeped in '50s sociology , pop culture or movie lore to appreciate the emotional depth of haynes' work . though haynes' style apes films from the period . . . its message is not rooted in that decade . ","waiting for godard can be fruitful : 'in praise of love' is the director's epitaph for himself . ","a gangster movie with the capacity to surprise . ","the film has a laundry list of minor shortcomings , but the numerous scenes of gory mayhem are worth the price of admission . . . if  gory mayhem  is your idea of a good time . ","if not a home run , then at least a solid base hit . ","goldmember is funny enough to justify the embarrassment of bringing a barf bag to the moviehouse . "," . . . a fairly disposable yet still entertaining b picture . ","it may not be particularly innovative , but the film's crisp , unaffected style and air of gentle longing make it unexpectedly rewarding . ","the film truly does rescue [the funk brothers] from motown's shadows . it's about time . ","drawing on an irresistible , languid romanticism , byler reveals the ways in which a sultry evening or a beer-fueled afternoon in the sun can inspire even the most retiring heart to venture forth . ","works because we're never sure if ohlinger's on the level or merely a dying , delusional man trying to get into the history books before he croaks . ","[scherfig] has made a movie that will leave you wondering about the characters' lives after the clever credits roll . ","a heady , biting , be-bop ride through nighttime manhattan , a loquacious videologue of the modern male and the lengths to which he'll go to weave a protective cocoon around his own ego . ","skin of man gets a few cheap shocks from its kids-in-peril theatrics , but it also taps into the primal fears of young people trying to cope with the mysterious and brutal nature of adults . ","the piano teacher is not an easy film . it forces you to watch people doing unpleasant things to each other and themselves , and it maintains a cool distance from its material that is deliberately unsettling . ","as refreshing as a drink from a woodland stream . ","williams absolutely nails sy's queasy infatuation and overall strangeness . ","can i admit xxx is as deep as a petri dish and as well-characterized as a telephone book but still say it was a guilty pleasure ? ","while it's nothing we haven't seen before from murphy , i spy is still fun and enjoyable and so aggressively silly that it's more than a worthwhile effort . ","by the time it ends in a rush of sequins , flashbulbs , blaring brass and back-stabbing babes , it has said plenty about how show business has infiltrated every corner of society -- and not always for the better . ","an intimate contemplation of two marvelously messy lives . ","rarely has skin looked as beautiful , desirable , even delectable , as it does in trouble every day . ","this is one of those rare docs that paints a grand picture of an era and makes the journey feel like a party . ","poignant if familiar story of a young person suspended between two cultures . ","a metaphor for a modern-day urban china searching for its identity . ","for all its brooding quality , ash wednesday is suspenseful and ultimately unpredictable , with a sterling ensemble cast . ","an odd drama set in the world of lingerie models and bar dancers in the midwest that held my interest precisely because it didn't try to . ","the film feels uncomfortably real , its language and locations bearing the unmistakable stamp of authority . ","despite its faults , gangs excels in spectacle and pacing . ","entertaining despite its one-joke premise with the thesis that women from venus and men from mars can indeed get together . ","a tightly directed , highly professional film that's old-fashioned in all the best possible ways . ","it's dark but has wonderfully funny moments ; you care about the characters ; and the action and special effects are first-rate . ","in visual fertility treasure planet rivals the top japanese animations of recent vintage . ","enormously enjoyable , high-adrenaline documentary . ","buy is an accomplished actress , and this is a big , juicy role . ","it works its magic with such exuberance and passion that the film's length becomes a part of its fun . ","beautifully crafted and brutally honest , promises offers an unexpected window into the complexities of the middle east struggle and into the humanity of its people . ","an old-fashioned but emotionally stirring adventure tale of the kind they rarely make anymore . ","charlotte sometimes is a gem . it's always enthralling . ","in my opinion , analyze that is not as funny or entertaining as analyze this , but it is a respectable sequel . ","a remarkable film by bernard rose . ","zhuangzhuang creates delicate balance of style , text , and subtext that's so simple and precise that anything discordant would topple the balance , but against all odds , nothing does . ","a much more successful translation than its most famous previous film adaptation , writer-director anthony friedman's similarly updated 1970 british production . ","an original and highly cerebral examination of the psychopathic mind","michel piccoli's moving performance is this films reason for being . ","a captivating and intimate study about dying and loving . . . ","this is an elegantly balanced movie -- every member of the ensemble has something fascinating to do -- that doesn't reveal even a hint of artifice . ","[grant] goes beyond his usual fluttering and stammering and captures the soul of a man in pain who gradually comes to recognize it and deal with it . ","a high-spirited buddy movie about the reunion of berlin anarchists who face arrest 15 years after their crime . ","about the best thing you could say about narc is that it's a rock-solid little genre picture . whether you like it or not is basically a matter of taste . ","an involving , inspirational drama that sometimes falls prey to its sob-story trappings . ","some of the most inventive silliness you are likely to witness in a movie theatre for some time . ","canadian filmmaker gary burns' inventive and mordantly humorous take on the soullessness of work in the city . ","a rollicking ride , with jaw-dropping action sequences , striking villains , a gorgeous color palette , astounding technology , stirring music and a boffo last hour that leads up to a strangely sinister happy ending . ","everyone's insecure in lovely and amazing , a poignant and wryly amusing film about mothers , daughters and their relationships . ","the closest thing to the experience of space travel","full of surprises . ","connoisseurs of chinese film will be pleased to discover that tian's meticulous talent has not withered during his enforced hiatus . ","if you can push on through the slow spots , you'll be rewarded with some fine acting . ","an unusually dry-eyed , even analytical approach to material that is generally played for maximum moisture . ","symbolically , warm water under a red bridge is a celebration of feminine energy , a tribute to the power of women to heal . ","spy kids 2 also happens to be that rarity among sequels : it actually improves upon the original hit movie . ","exceptionally well acted by diane lane and richard gere . ","like a precious and finely cut diamond , magnificent to behold in its sparkling beauty yet in reality it's one tough rock . ","in addition to scoring high for originality of plot -- putting together familiar themes of family , forgiveness and love in a new way -- lilo & stitch has a number of other assets to commend it to movie audiences both innocent and jaded . ","miller has crafted an intriguing story of maternal instincts and misguided acts of affection . ","one of the most exciting action films to come out of china in recent years . ","this is a nervy , risky film , and villeneuve has inspired croze to give herself over completely to the tormented persona of bibi . ","my little eye is the best little  horror  movie i've seen in years . ","tunney , brimming with coltish , neurotic energy , holds the screen like a true star . ","even if the naipaul original remains the real masterpiece , the movie possesses its own languorous charm . ","[the film] tackles the topic of relationships in such a straightforward , emotionally honest manner that by the end , it's impossible to ascertain whether the film is , at its core , deeply pessimistic or quietly hopeful . ","sometimes we feel as if the film careens from one colorful event to another without respite , but sometimes it must have seemed to frida kahlo as if her life did , too . ","the strength of the film lies in its two central performances by sven wollter as the stricken composer and viveka seldahl as his desperate violinist wife . ","like the series , the movie is funny , smart , visually inventive , and most of all , alive . ","it was filled with shootings , beatings , and more cussing than you could shake a stick at . ","you don't know whether to admire the film's stately nature and call it classicism or be exasperated by a noticeable lack of pace . or both . ","sure , i hated myself in the morning . but then again , i hate myself most mornings . i still like moonlight mile , better judgment be damned . ","time out is as serious as a pink slip . and more than that , it's an observant , unfussily poetic meditation about identity and alienation . ","will assuredly rank as one of the cleverest , most deceptively amusing comedies of the year . ","maryam is a small film , but it offers large rewards . ","a highly watchable , giggly little story with a sweet edge to it . ","the most consistently funny of the austin powers films . ","ana's journey is not a stereotypical one of self-discovery , as she's already comfortable enough in her own skin to be proud of her rubenesque physique . . . ","cockettes has the glorious , gaudy benefit of much stock footage of those days , featuring all manner of drag queen , bearded lady and lactating hippie . ","there's something poignant about an artist of 90-plus years taking the effort to share his impressions of life and loss and time and art with us . ","the comedy makes social commentary more palatable . ","an ideal love story for those intolerant of the more common saccharine genre . ","one funny popcorn flick . ","this new zealand coming-of-age movie isn't really about anything . when it's this rich and luscious , who cares ? ","tully is worth a look for its true-to-life characters , its sensitive acting , its unadorned view of rural life and the subtle direction of first-timer hilary birmingham . ","this gorgeous epic is guaranteed to lift the spirits of the whole family . ","the wild thornberrys movie is pleasant enough and the message of our close ties with animals can certainly not be emphasized enough . ","williams creates a stunning , taxi driver-esque portrayal of a man teetering on the edge of sanity . ","if you're in the right b-movie frame of mind , it may just scare the pants off you . ","a movie of riveting power and sadness . ","both a detective story and a romance spiced with the intrigue of academic skullduggery and politics . ","quietly engaging . ","ludicrous , but director carl franklin adds enough flourishes and freak-outs to make it entertaining . ","director roger kumble offers just enough sweet and traditional romantic comedy to counter the crudity . and there's the inimitable diaz , holding it all together . ","spielberg's picture is smarter and subtler than [total recall and blade runner] , although its plot may prove too convoluted for fun-seeking summer audiences . ","it's got all the familiar bruckheimer elements , and schumacher does probably as good a job as anyone at bringing off the hopkins/rock collision of acting styles and onscreen personas . ","a grittily beautiful film that looks , sounds , and feels more like an extended , open-ended poem than a traditionally structured story . ","dense , exhilarating documentary . ","the production values are of the highest and the performances attractive without being memorable . ","a well-rounded tribute to a man whose achievements -- and complexities -- reached far beyond the end zone . ","finely crafted , finely written , exquisitely performed","ramsay and morton fill this character study with poetic force and buoyant feeling . ","this submarine drama earns the right to be favorably compared to das boot . ","claude chabrol's camera has a way of gently swaying back and forth as it cradles its characters , veiling tension beneath otherwise tender movements . ","there's a great deal of corny dialogue and preposterous moments . and yet , it still works . ","the film was immensely enjoyable thanks to great performances by both steve buscemi and rosario dawson . . . ","like many western action films , this thriller is too loud and thoroughly overbearing , but its heartfelt concern about north korea's recent past and south korea's future adds a much needed moral weight . ","special p . o . v . camera mounts on bikes , skateboards , and motorcycles provide an intense experience when splashed across the immense imax screen . ","a joyous occasion","mike white's deft combination of serious subject matter and dark , funny humor make   the good girl  a film worth watching . ","this is a shrewd and effective film from a director who understands how to create and sustain a mood . ","meant to reduce blake's philosophy into a tragic coming-of-age saga punctuated by bursts of animator todd mcfarlane's superhero dystopia . ","assayas' ambitious , sometimes beautiful adaptation of jacques chardonne's novel . ","as ex-marine walter , who may or may not have shot kennedy , actor raymond j . barry is perfectly creepy and believable . ","those who don't entirely 'get' godard's distinctive discourse will still come away with a sense of his reserved but existential poignancy . ","pete's screenplay manages to find that real natural , even-flowing tone that few movies are able to accomplish . ","like brosnan's performance , evelyn comes from the heart . ","it uses some of the figures from the real-life story to portray themselves in the film . the result is a powerful , naturally dramatic piece of low-budget filmmaking . ","its spirit of iconoclastic abandon -- however canned -- makes for unexpectedly giddy viewing . ","the early and middle passages are surprising in how much they engage and even touch us . this is not a classical dramatic animated feature , nor a hip , contemporary , in-jokey one . it's sort of in-between , and it works . ","this quiet , introspective and entertaining independent is worth seeking . ","whether our action-and-popcorn obsessed culture will embrace this engaging and literate psychodrama isn't much of a mystery , unfortunately . ","whether or not ram dass proves as clear and reliable an authority on that as he was about inner consciousness , fierce grace reassures us that he will once again be an honest and loving one . ","sly , sophisticated and surprising . ","spare but quietly effective retelling . ","demonstrates a vivid imagination and an impressive style that result in some terrific setpieces . ","by its modest , straight-ahead standards , undisputed scores a direct hit . ","its story about a young chinese woman , ah na , who has come to new york city to replace past tragedy with the american dream is one that any art-house moviegoer is likely to find compelling . ","for those who like quirky , slightly strange french films , this is a must ! ","there are so few films about the plight of american indians in modern america that skins comes as a welcome , if downbeat , missive from a forgotten front . ","[shyamalan] continues to cut a swathe through mainstream hollywood , while retaining an integrity and refusing to compromise his vision . ","a whale of a good time for both children and parents seeking christian-themed fun . ","what begins as a film in the tradition of the graduate quickly switches into something more recyclable than significant . ","much smarter and more attentive than it first sets out to be . ","the story is smart and entirely charming in intent and execution . ","a movie of technical skill and rare depth of intellect and feeling . ","represents a worthy departure from the culture clash comedies that have marked an emerging indian american cinema . ","doesn't do more than expand a tv show to movie length . however , it's pleasant enough and its ecological , pro-wildlife sentiments are certainly welcome . ","if you're looking for an intelligent movie in which you can release your pent up anger , enough is just the ticket you need . ","a pointed , often tender , examination of the pros and cons of unconditional love and familial duties . ","as well-acted and well-intentioned as all or nothing is , however , the film comes perilously close to being too bleak , too pessimistic and too unflinching for its own good . ","a comedy-drama of nearly epic proportions rooted in a sincere performance by the title character undergoing midlife crisis . ","it's about issues most adults have to face in marriage and i think that's what i liked about it -- the real issues tucked between the silly and crude storyline . ","elegantly produced and expressively performed , the six musical numbers crystallize key plot moments into minutely detailed wonders of dreamlike ecstasy . ","enriched by a strong and unforced supporting cast . ","writer/ director m . night shyamalan's ability to pull together easily accessible stories that resonate with profundity is undeniable . ","if you can keep your eyes open amid all the blood and gore , you'll see del toro has brought unexpected gravity to blade ii . ","not a strike against yang's similarly themed yi yi , but i found what time ? to be more engaging on an emotional level , funnier , and on the whole less detached . ","a breathtaking adventure for all ages , spirit tells its poignant and uplifting story in a stunning fusion of music and images . ","a charming and funny story of clashing cultures and a clashing mother/daughter relationship . ","never lets go your emotions , taking them to surprising highs , sorrowful lows and hidden impulsive niches . . . gorgeous , passionate , and at times uncommonly moving . ","  . . . something appears to have been lost in the translation this time . the importance of being earnest movie seems to be missing a great deal of the acerbic repartee of the play .  ","[washington's] strong hand , keen eye , sweet spirit and good taste are reflected in almost every scene . ","shiner can certainly go the distance , but isn't world championship material","the film's desire to be liked sometimes undermines the possibility for an exploration of the thornier aspects of the nature/nurture argument in regards to homosexuality . "," . . . a quietly introspective portrait of the self-esteem of employment and the shame of losing a job . . . ","affable if not timeless , like mike raises some worthwhile themes while delivering a wholesome fantasy for kids . ","a film of delicate interpersonal dances . caine makes us watch as his character awakens to the notion that to be human is eventually to have to choose . it's a sight to behold . ","it's an unusual , thoughtful bio-drama with a rich subject and some fantastic moments and scenes . ","saved from being merely way-cool by a basic , credible compassion . ","the increasingly diverse french director has created a film that one can honestly describe as looking , sounding and simply feeling like no other film in recent history . ","gangs , despite the gravity of its subject matter , is often as fun to watch as a good spaghetti western . ","peter jackson has done the nearly impossible . he has improved upon the first and taken it a step further , richer and deeper . what jackson has done is proven that no amount of imagination , no creature , no fantasy story and no incredibly outlandish scenery","there has to be a few advantages to never growing old . like being able to hit on a 15-year old when you're over 100 . ","ice age won't drop your jaw , but it will warm your heart , and i'm giving it a strong thumbs up . ","like kissing jessica stein , amy's orgasm has a key strength in its willingness to explore its principal characters with honesty , insight and humor . ","the lady and the duke is eric rohmer's economical antidote to the bloated costume drama","one of the year's best films , featuring an oscar-worthy performance by julianne moore . ","a small gem from belgium . ","combines a comically dismal social realism with a farcically bawdy fantasy of redemption and regeneration . ","a soap-opera quality twist in the last 20 minutes . . . almost puts the kibosh on what is otherwise a sumptuous work of b-movie imagination . ","the most ingenious film comedy since being john malkovich . ","there's something to be said for a studio-produced film that never bothers to hand viewers a suitcase full of easy answers . ","a movie where story is almost an afterthought amidst a swirl of colors and inexplicable events . ","manages to accomplish what few sequels can -- it equals the original and in some ways even betters it . ","to call this one an eventual cult classic would be an understatement , and woe is the horror fan who opts to overlook this goofily endearing and well-lensed gorefest . ","jolie gives it that extra little something that makes it worth checking out at theaters , especially if you're in the mood for something more comfortable than challenging . ","although melodramatic and predictable , this romantic comedy explores the friendship between five filipino-americans and their frantic efforts to find love . ","i have a new favorite musical -- and i'm not even a fan of the genre","it's unlikely we'll see a better thriller this year . ","there is a real subject here , and it is handled with intelligence and care . ","jason patric and ray liotta make for one splendidly cast pair . ","noyce creates a film of near-hypnotic physical beauty even as he tells a story as horrifying as any in the heart-breakingly extensive annals of white-on-black racism . ","starts slowly , but adrien brody – in the title role – helps make the film's conclusion powerful and satisfying . ","very predictable but still entertaining","nothing short of a masterpiece -- and a challenging one . ","pratfalls aside , barbershop gets its greatest play from the timeless spectacle of people really talking to each other . ","this amiable picture talks tough , but it's all bluster -- in the end it's as sweet as greenfingers . . . ","this is one of mr . chabrol's subtlest works , but also one of his most uncanny . ","an engrossing iranian film about two itinerant teachers and some lost and desolate people they encounter in a place where war has savaged the lives and liberties of the poor and the dispossessed . ","even though we know the outcome , the seesawing of the general's fate in the arguments of competing lawyers has the stomach-knotting suspense of a legal thriller , while the testimony of witnesses lends the film a resonant undertone of tragedy . ","watching spirited away is like watching an eastern imagination explode . ","as relationships shift , director robert j . siegel allows the characters to inhabit their world without cleaving to a narrative arc . ","twohy knows how to inflate the mundane into the scarifying , and gets full mileage out of the rolling of a stray barrel or the unexpected blast of a phonograph record . ","while the story does seem pretty unbelievable at times , it's awfully entertaining to watch . ","a smart and funny , albeit sometimes superficial , cautionary tale of a technology in search of an artist . ","examines its explosive subject matter as nonjudgmentally as wiseman's previous studies of inner-city high schools , hospitals , courts and welfare centers . ","i prefer soderbergh's concentration on his two lovers over tarkovsky's mostly male , mostly patriarchal debating societies . ","'if you are in the mood for an intelligent weepy , it can easily worm its way into your heart . '","in imax in short , it's just as wonderful on the big screen . ","does a good job of establishing a time and place , and of telling a fascinating character's story . ","i'm going to give it a marginal thumbs up . i liked it just enough . ","those of you who don't believe in santa claus probably also think that sequels can never capture the magic of the original . well , this movie proves you wrong on both counts . ","a deliciously nonsensical comedy about a city coming apart at its seams . ","the rare imax movie that you'll wish was longer than an hour . ","my wife's plotting is nothing special ; it's the delivery that matters here . ","i've yet to find an actual vietnam war combat movie actually produced by either the north or south vietnamese , but at least now we've got something pretty damn close . ","a moving and not infrequently breathtaking film . ","it's a sharp movie about otherwise dull subjects . ","[an] absorbing documentary . ","it's like rocky and bullwinkle on speed , but that's neither completely enlightening , nor does it catch the intensity of the movie's strangeness . ","as action-adventure , this space-based homage to robert louis stevenson's treasure island fires on all plasma conduits . ","a melancholy , emotional film . ","while the filmmaking may be a bit disjointed , the subject matter is so fascinating that you won't care . ","intensely romantic , thought-provoking and even an engaging mystery . ","goofy , nutty , consistently funny . and educational ! ","not a schlocky creature feature but something far more stylish and cerebral--and , hence , more chillingly effective . ","another in a long line of ultra-violent war movies , this one is not quite what it could have been as a film , but the story and theme make up for it . ","it leaves little doubt that kidman has become one of our best actors . ","the film boasts dry humor and jarring shocks , plus moments of breathtaking mystery . ","beautifully directed and convincingly acted . ","gambling and throwing a basketball game for money isn't a new plot -- in fact toback himself used it in black and white . but toback's deranged immediacy makes it seem fresh again . ","in the director's cut , the film is not only a love song to the movies but it also is more fully an example of the kind of lush , all-enveloping movie experience it rhapsodizes . ","bring on the sequel . ","graced with the kind of social texture and realism that would be foreign in american teen comedies . ","if we sometimes need comforting fantasies about mental illness , we also need movies like tim mccann's revolution no . 9 . ","the film occasionally tries the viewer's patience with slow pacing and a main character who sometimes defies sympathy , but it ultimately satisfies with its moving story . ","a big-budget/all-star movie as unblinkingly pure as the hours is a distinct rarity , and an event . "," . . . certainly an entertaining ride , despite many talky , slow scenes . but something seems to be missing . a sense of real magic , perhaps . ","that haynes can both maintain and dismantle the facades that his genre and his character construct is a wonderous accomplishment of veracity and narrative grace . ","the movie worked for me right up to the final scene , and then it caved in . "," . . . one of the most entertaining monster movies in ages . . . ","plunges you into a reality that is , more often then not , difficult and sad , and then , without sentimentalizing it or denying its brutality , transforms that reality into a lyrical and celebratory vision . ","would you laugh if a tuba-playing dwarf rolled down a hill in a trash can ? do you chuckle at the thought of an ancient librarian whacking a certain part of a man's body ? if you answered yes , by all means enjoy the new guy . ","the film is . . . determined to treat its characters , weak and strong , as fallible human beings , not caricatures , and to carefully delineate the cost of the inevitable conflicts between human urges and an institution concerned with self-preservation . ","missteps take what was otherwise a fascinating , riveting story and send it down the path of the mundane . ","an indispensable peek at the art and the agony of making people laugh . ","steadfastly uncinematic but powerfully dramatic . ","the engagingly primitive animated special effects contribute to a mood that's sustained through the surprisingly somber conclusion . ","made-up lampoons the moviemaking process itself , while shining a not particularly flattering spotlight on america's skin-deep notions of pulchritude . ","evokes the 19th century with a subtlety that is an object lesson in period filmmaking . ","ya-yas everywhere will forgive the flaws and love the film . ","the film's best trick is the way that it treats conspiracy as a kind of political blair witch , a monstrous murk that haunts us precisely because it can never be seen . ","the artwork is spectacular and unlike most animaton from japan , the characters move with grace and panache . ","the picture's fascinating byways are littered with trenchant satirical jabs at the peculiar egocentricities of the acting breed . ","the modern remake of dumas's story is long on narrative and ( too ) short on action . ","fred schepisi's film is paced at a speed that is slow to those of us in middle age and deathly slow to any teen . with a cast of a-list brit actors , it is worth searching out . ","suffers from its timid parsing of the barn-side target of sons trying to breach gaps in their relationships with their fathers . ","nonchalantly freaky and uncommonly pleasurable , warm water may well be the year's best and most unpredictable comedy . ","it's like an old warner bros . costumer jived with sex -- this could be the movie errol flynn always wanted to make , though bette davis , cast as joan , would have killed him . ","it's a great american adventure and a wonderful film to bring to imax . ","satisfyingly scarifying , fresh and old-fashioned at the same time . ","oh , james ! your 20th outing shows off a lot of stamina and vitality , and get this , madonna's cameo doesn't suck ! ","a genuine mind-bender . ","that death is merely a transition is a common tenet in the world's religions . this deeply spiritual film taps into the meaning and consolation in afterlife communications . ","there is something that is so meditative and lyrical about babak payami's boldly quirky iranian drama secret ballot . . . a charming and evoking little ditty that manages to show the gentle and humane side of middle eastern world politics","a huge box-office hit in korea , shiri is a must for genre fans . "," . . . planos fijos , tomas largas , un ritmo pausado y una sutil observación de sus personajes , sin estridencias ni grandes revelaciones . ","i'm not a fan of the phrase 'life affirming' because it usually means 'schmaltzy , ' but real women have curves truly is life affirming . ","the symbols float like butterflies and the spinning styx sting like bees . i wanted more . ","if it's unnerving suspense you're after -- you'll find it with ring , an indisputably spooky film ; with a screenplay to die for . ","the art direction and costumes are gorgeous and finely detailed , and kurys' direction is clever and insightful . ","red dragon makes one appreciate silence of the lambs . ","proves a servicable world war ii drama that can't totally hide its contrivances , but it at least calls attention to a problem hollywood too long has ignored . ","leigh isn't breaking new ground , but he knows how a daily grind can kill love . ","while broomfield's film doesn't capture the effect of these tragic deaths on hip-hop culture , it succeeds as a powerful look at a failure of our justice system . "," . . . strips bible stores of the potential for sanctimoniousness , making them meaningful for both kids and church-wary adults . ","laugh-out-loud lines , adorably ditsy but heartfelt performances , and sparkling , bittersweet dialogue that cuts to the chase of the modern girl's dilemma . ","tends to pile too many  serious issues  on its plate at times , yet remains fairly light , always entertaining , and smartly written . ","a solidly entertaining little film . ","it's an entertaining movie , and the effects , boosted to the size of a downtown hotel , will all but take you to outer space . ","sayles has a knack for casting , often resurrecting performers who rarely work in movies now . . . and drawing flavorful performances from bland actors . ","despite an overwrought ending , the film works as well as it does because of the performances . ","a passionately inquisitive film determined to uncover the truth and hopefully inspire action . ","though nijinsky's words grow increasingly disturbed , the film maintains a beguiling serenity and poise that make it accessible for a non-narrative feature . ","a muddle splashed with bloody beauty as vivid as any scorsese has ever given us . ","from both a great and a terrible story , mr . nelson has made a film that is an undeniably worthy and devastating experience . ","spider-man is about growing strange hairs , getting a more mature body , and finding it necessary to hide new secretions from the parental units . ","the first shocking thing about sorority boys is that it's actually watchable . even more baffling is that it's funny . ","highlighted by a gritty style and an excellent cast , it's better than one might expect when you look at the list of movies starring ice-t in a major role . ","neither quite a comedy nor a romance , more of an impish divertissement of themes that interest attal and gainsbourg -- they live together -- the film has a lot of charm . ","first and foremost . . . the reason to go see  blue crush  is the phenomenal , water-born cinematography by david hennings . ","a visionary marvel , but it's lacking a depth in storytelling usually found in anime like this . ","the problems and characters it reveals are universal and involving , and the film itself -- as well its delightful cast -- is so breezy , pretty and gifted , it really won my heart . ","in his latest effort , storytelling , solondz has finally made a movie that isn't just offensive -- it also happens to be good . ","how i killed my father would be a rarity in hollywood . it's an actor's showcase that accomplishes its primary goal without the use of special effects , but rather by emphasizing the characters -- including the supporting ones . ","i just saw this movie . . . well , it's probably not accurate to call it a movie . ","what's most memorable about circuit is that it's shot on digital video , whose tiny camera enables shafer to navigate spaces both large . . . and small . . . with considerable aplomb . ","scherfig , the writer-director , has made a film so unabashedly hopeful that it actually makes the heart soar . yes , soar . ","a delicious and delicately funny look at the residents of a copenhagen neighborhood coping with the befuddling complications life tosses at them . ","  what really happened ?  is a question for philosophers , not filmmakers ; all the filmmakers need to do is engage an audience . ","soderbergh , like kubrick before him , may not touch the planet's skin , but understands the workings of its spirit . ","much credit must be given to the water-camera operating team of don king , sonny miller , and michael stewart . their work is fantastic . ","crush is so warm and fuzzy you might be able to forgive its mean-spirited second half . ","franco is an excellent choice for the walled-off but combustible hustler , but he does not give the transcendent performance sonny needs to overcome gaps in character development and story logic . ","tsai ming-liang's witty , wistful new film , what time is it there ? , is a temporal inquiry that shoulders its philosophical burden lightly . ","the pianist lacks the quick emotional connections of steven spielberg's schindler's list . but mr . polanski creates images even more haunting than those in mr . spielberg's 1993 classic . ","steers , in his feature film debut , has created a brilliant motion picture . ","a brilliant , absurd collection of vignettes that , in their own idiosyncratic way , sum up the strange horror of life in the new millennium . ","as warm as it is wise , deftly setting off uproarious humor with an underlying seriousness that sneaks up on the viewer , providing an experience that is richer than anticipated . ","the film may not hit as hard as some of the better drug-related pictures , but it still manages to get a few punches in . ","old-fashioned but thoroughly satisfying entertainment . ","an energizing , intoxicating documentary charting the rise of hip-hop culture in general and the art of scratching ( or turntablism ) in particular . ","a fun family movie that's suitable for all ages -- a movie that will make you laugh , cry and realize , 'it's never too late to believe in your dreams . '","if you open yourself up to mr . reggio's theory of this imagery as the movie's set . . . it can impart an almost visceral sense of dislocation and change . ","i had a dream that a smart comedy would come along to rescue me from a summer of teen-driven , toilet-humor codswallop , and its name was earnest . ","even though the film doesn't manage to hit all of its marks , it's still entertaining to watch the target practice . ","where this was lazy but enjoyable , a formula comedy redeemed by its stars , that is even lazier and far less enjoyable . ","the 3-d vistas from orbit , with the space station suspended like a huge set of wind chimes over the great blue globe , are stanzas of breathtaking , awe-inspiring visual poetry . ","the attraction between these two marginal characters is complex from the start -- and , refreshingly , stays that way . ","fans of the modern day hong kong action film finally have the worthy successor to a better tomorrow and the killer which they have been patiently waiting for . ","even when he's not at his most critically insightful , godard can still be smarter than any 50 other filmmakers still at work . ","what sets this romantic comedy apart from most hollywood romantic comedies is its low-key way of tackling what seems like done-to-death material . ","has enough wit , energy and geniality to please not only the fanatical adherents on either side , but also people who know nothing about the subject and think they're not interested . ","this seductive tease of a thriller gets the job done . it's a scorcher . ","bittersweet comedy/drama full of life , hand gestures , and some really adorable italian guys . ","works as pretty contagious fun . ","the best didacticism is one carried by a strong sense of humanism , and bertrand tavernier's oft-brilliant safe conduct (  laissez-passer  ) wears its heart on its sleeve . ","a realistically terrifying movie that puts another notch in the belt of the long list of renegade-cop tales . ","a charming , banter-filled comedy . . . one of those airy cinematic bon bons whose aims -- and by extension , accomplishments -- seem deceptively slight on the surface . ","a film with almost as many delights for adults as there are for children and dog lovers . ","serious movie-goers embarking upon this journey will find that the road to perdition leads to a satisfying destination . ","heartwarming and gently comic even as the film breaks your heart . ","caruso sometimes descends into sub-tarantino cuteness . . . but for the most part he makes sure the salton sea works the way a good noir should , keeping it tight and nasty . ","a  black austin powers ?  i prefer to think of it as  pootie tang with a budget .  sa da tay ! ","oddly , the film isn't nearly as downbeat as it sounds , but strikes a tone that's alternately melancholic , hopeful and strangely funny . ","i would be shocked if there was actually one correct interpretation , but that shouldn't make the movie or the discussion any less enjoyable . ","chouraqui brings documentary-like credibility to the horrors of the killing field and the barbarism of 'ethnic cleansing . '","the best thing i can say about this film is that i can't wait to see what the director does next . ","smarter than its commercials make it seem . ","great character interaction . ","one of the funnier movies in town . ","campanella's competent direction and his excellent cast overcome the obstacles of a predictable outcome and a screenplay that glosses over rafael's evolution . ","by turns very dark and very funny . ","steven soderbergh doesn't remake andrei tarkovsky's solaris so much as distill it . ","for more than two decades mr . nachtwey has traveled to places in the world devastated by war , famine and poverty and documented the cruelty and suffering he has found with an devastating , eloquent clarity . ","simultaneously heartbreakingly beautiful and exquisitely sad . ","though overall an overwhelmingly positive portrayal , the film doesn't ignore the more problematic aspects of brown's life . ","the philosophical musings of the dialogue jar against the tawdry soap opera antics of the film's action in a way that is surprisingly enjoyable . ","not too fancy , not too filling , not too fluffy , but definitely tasty and sweet . ","quando tiros em columbine acerta o alvo ( com o perdão do trocadilho ) , não há como negar o brilhantismo da argumentação de seu diretor . ","director lee has a true cinematic knack , but it's also nice to see a movie with its heart so thoroughly , unabashedly on its sleeve . ","as allen's execution date closes in , the documentary gives an especially poignant portrait of her friendship with the never flagging legal investigator david presson . ","jones has tackled a meaty subject and drawn engaging characters while peppering the pages with memorable zingers . ","a vivid , spicy footnote to history , and a movie that grips and holds you in rapt attention from start to finish . ","if s&m seems like a strange route to true love , maybe it is , but it's to this film's ( and its makers' ) credit that we believe that that's exactly what these two people need to find each other -- and themselves . ","if the film's vision of sport as a secular religion is a bit cloying , its through-line of family and community is heartening in the same way that each season marks a new start . ","one of the best of a growing strain of daring films . . . that argue that any sexual relationship that doesn't hurt anyone and works for its participants is a relationship that is worthy of our respect . ","…an adorably whimsical comedy that deserves more than a passing twinkle . ","an engrossing story that combines psychological drama , sociological reflection , and high-octane thriller . ","it's easy to be cynical about documentaries in which underdogs beat the odds and the human spirit triumphs , but westbrook's foundation and dalrymple's film earn their uplift . ","mel gibson fights the good fight in vietnam in director randall wallace's flag-waving war flick with a core of decency . ","there's real visual charge to the filmmaking , and a strong erotic spark to the most crucial lip-reading sequence . ","a brutal and funny work . nicole holofcenter , the insightful writer/director responsible for this illuminating comedy doesn't wrap the proceedings up neatly but the ideas tie together beautifully . ","the film is a blunt indictment , part of a perhaps surreal campaign to bring kissinger to trial for crimes against humanity . ","one of the most important and exhilarating forms of animated filmmaking since old walt doodled steamboat willie . ","move over bond ; this girl deserves a sequel . ","the kind of trifle that date nights were invented for . "," . it's a testament to the film's considerable charm that it succeeds in entertaining , despite playing out like a feature-length sitcom replete with stereotypical familial quandaries . there's a sheer unbridled delight in the way the story unfurls . . . ","tells ( the story ) with such atmospheric ballast that shrugging off the plot's persnickety problems is simply a matter of ( being ) in a shrugging mood . ","the film is hard to dismiss -- moody , thoughtful , and lit by flashes of mordant humor . ","if the man from elysian fields is doomed by its smallness , it is also elevated by it--the kind of movie that you enjoy more because you're one of the lucky few who sought it out . ","what emerges is an unsettling picture of childhood innocence combined with indoctrinated prejudice . promises is a compelling piece that demonstrates just how well children can be trained to live out and carry on their parents' anguish . ","meticulously uncovers a trail of outrageous force and craven concealment . ","hey , happy ! is many things -- stoner midnight flick , sci-fi deconstruction , gay fantasia -- but above all it's a love story as sanguine as its title . ","you won't look at religious fanatics -- or backyard sheds -- the same way again . ","at its best . . . festival in cannes bubbles with the excitement of the festival in cannes . ","there is a general air of exuberance in all about the benjamins that's hard to resist . ","a lovably old-school hollywood confection . ","i'm happy to have seen it -- not as an alternate version , but as the ultimate exercise in viewing deleted scenes . ","by turns gripping , amusing , tender and heart-wrenching , laissez-passer has all the earmarks of french cinema at its best . ","the warnings to resist temptation in this film . . . are blunt and challenging and offer no easy rewards for staying clean . ","wonder of wonders -- a teen movie with a humanistic message . ","a quirky comedy set in newfoundland that cleverly captures the dry wit that's so prevalent on the rock . ","peppered with witty dialogue and inventive moments . ","i'd rather watch a rerun of the powerpuff girls","with the prospect of films like kangaroo jack about to burst across america's winter movie screens it's a pleasure to have a film like the hours as an alternative . ","the wonderful combination of the sweetness and the extraordinary technical accomplishments of the first film are maintained , but its overall impact falls a little flat with a storyline that never quite delivers the original magic . ","like its title character , this nicholas nickleby finds itself in reduced circumstances -- and , also like its hero , it remains brightly optimistic , coming through in the end . ","as a thoughtful and unflinching examination of an alternative lifestyle , sex with strangers is a success . ","unpretentious , charming , quirky , original","spinning a web of dazzling entertainment may be overstating it , but  spider-man  certainly delivers the goods . ","other than the slightly flawed ( and fairly unbelievable ) finale , everything else is top shelf . ","this fascinating look at israel in ferment feels as immediate as the latest news footage from gaza and , because of its heightened , well-shaped dramas , twice as powerful . ","manages to delight without much of a story . ","there's no denying that burns is a filmmaker with a bright future ahead of him . ","i have a confession to make : i didn't particularly like e . t . the first time i saw it as a young boy . that is because - damn it ! - i also wanted a little alien as a friend ! ","fairy-tale formula , serves as a paper skeleton for some very good acting , dialogue , comedy , direction and especially charm . ","a genuinely funny ensemble comedy that also asks its audience -- in a heartwarming , nonjudgmental kind of way -- to consider what we value in our daily lives . ","though the aboriginal aspect lends the ending an extraordinary poignancy , and the story itself could be played out in any working class community in the nation . ","an energetic and engaging film that never pretends to be something it isn't . ","a violent initiation rite for the audience , as much as it is for angelique , the [opening] dance guarantees karmen's enthronement among the cinema's memorable women . ","an animation landmark as monumental as disney's 1937 breakthrough snow white and the seven dwarfs . ","an entertaining , if ultimately minor , thriller . ","sex with strangers is fascinating . . . ","a subtle , poignant picture of goodness that is flawed , compromised and sad . ","a wry , affectionate delight . ","the acting in pauline and paulette is good all round , but what really sets the film apart is debrauwer's refusal to push the easy emotional buttons . ","one of those joyous films that leaps over national boundaries and celebrates universal human nature . ","a penetrating glimpse into the tissue-thin ego of the stand-up comic . ","kids should have a stirring time at this beautifully drawn movie . and adults will at least have a dream image of the west to savor whenever the film's lamer instincts are in the saddle . ","paid in full is remarkably engaging despite being noticeably derivative of goodfellas and at least a half dozen other trouble-in-the-ghetto flicks . ","less cinematically powerful than quietly and deeply moving , which is powerful in itself . ","waydowntown manages to nail the spirit-crushing ennui of denuded urban living without giving in to it . ","each of these stories has the potential for touched by an angel simplicity and sappiness , but thirteen conversations about one thing , for all its generosity and optimism , never resorts to easy feel-good sentiments . ","if borstal boy isn't especially realistic , it is an engaging nostalgia piece . ","often demented in a good way , but it is an uneven film for the most part . ","the script's snazzy dialogue establishes a realistic atmosphere that involves us in the unfolding crisis , but the lazy plotting ensures that little of our emotional investment pays off . ","maggie smith as the ya-ya member with the o2-tank will absolutely crack you up with her crass , then gasp for gas , verbal deportment . ","this is a movie that refreshes the mind and spirit along with the body , so original is its content , look , and style . ","although i didn't hate this one , it's not very good either . it can be safely recommended as a video/dvd babysitter . ","another best of the year selection . ","the film has the high-buffed gloss and high-octane jolts you expect of de palma , but what makes it transporting is that it's also one of the smartest , most pleasurable expressions of pure movie love to come from an american director in years . ","it's a very valuable film . . . ","max pokes , provokes , takes expressionistic license and hits a nerve . . . as far as art is concerned , it's mission accomplished . ","literary purists may not be pleased , but as far as mainstream matinee-style entertainment goes , it does a bang-up job of pleasing the crowds . ","here polanski looks back on those places he saw at childhood , and captures them by freeing them from artefact , and by showing them heartbreakingly drably . ","intriguing and stylish . ","the story itself it mostly told through on-camera interviews with several survivors , whose riveting memories are rendered with such clarity that it's as if it all happened only yesterday . ","a compelling story of musical passion against governmental odds . ","with  ichi the killer  , takashi miike , japan's wildest filmmaker gives us a crime fighter carrying more emotional baggage than batman . . . ","you never know where changing lanes is going to take you but it's a heck of a ride . samuel l . jackson is one of the best actors there is . ","[breheny's] lensing of the new zealand and cook island locations captures both the beauty of the land and the people . ","an almost unbearably morbid love story . ","the wild thornberrys movie has all the sibling rivalry and general family chaos to which anyone can relate . ","a forceful drama of an alienated executive who re-invents himself . ","spielberg's realization of a near-future america is masterful . this makes minority report necessary viewing for sci-fi fans , as the film has some of the best special effects ever . ","the gags that fly at such a furiously funny pace that the only rip off that we were aware of was the one we felt when the movie ended so damned soon . ","the best film of the year 2002 . ","an enthralling , entertaining feature . ","stripped almost entirely of such tools as nudity , profanity and violence , labute does manage to make a few points about modern man and his problematic quest for human connection . ","a remarkable movie with an unsatisfying ending , which is just the point . ","all in all , brown sugar is a satisfying well-made romantic comedy that's both charming and well acted . it will guarantee to have you leaving the theater with a smile on your face . ","smith finds amusing juxtapositions that justify his exercise . ","working from a surprisingly sensitive script co-written by gianni romoli . . . ozpetek avoids most of the pitfalls you'd expect in such a potentially sudsy set-up . ","an older cad instructs a younger lad in zen and the art of getting laid in this prickly indie comedy of manners and misanthropy . ","  austin powers in goldmember  has the right stuff for silly summer entertainment and has enough laughs to sustain interest to the end . ","one of [jaglom's] better efforts -- a wry and sometime bitter movie about love . ","schaeffer isn't in this film , which may be why it works as well as it does . ","a fresh , entertaining comedy that looks at relationships minus traditional gender roles . ","although estela bravo's documentary is cloyingly hagiographic in its portrait of cuban leader fidel castro , it's still a guilty pleasure to watch . ","surprisingly , the film is a hilarious adventure and i shamelessly enjoyed it . ","the way home is an ode to unconditional love and compassion garnered from years of seeing it all , a condition only the old are privy to , and . . . often misconstrued as weakness . ","brutally honest and told with humor and poignancy , which makes its message resonate . ","if you can read the subtitles ( the opera is sung in italian ) and you like 'masterpiece theatre' type costumes , you'll enjoy this movie . ","a pretty funny movie , with most of the humor coming , as before , from the incongruous but chemically perfect teaming of crystal and de niro . ","gangster no . 1 is solid , satisfying fare for adults . ","this chicago has hugely imaginative and successful casting to its great credit , as well as one terrific score and attitude to spare . ","has enough gun battles and throwaway humor to cover up the yawning chasm where the plot should be . ","with its jerky hand-held camera and documentary feel , bloody sunday is a sobering recount of a very bleak day in derry . ","you will likely prefer to keep on watching . ","insomnia loses points when it surrenders to a formulaic bang-bang , shoot-em-up scene at the conclusion . but the performances of pacino , williams , and swank keep the viewer wide-awake all the way through . ","what might have been readily dismissed as the tiresome rant of an aging filmmaker still thumbing his nose at convention takes a surprising , subtle turn at the midway point . ","at a time when commercialism has squeezed the life out of whatever idealism american moviemaking ever had , godfrey reggio's career shines like a lonely beacon . ","an inuit masterpiece that will give you goosebumps as its uncanny tale of love , communal discord , and justice unfolds . ","this is popcorn movie fun with equal doses of action , cheese , ham and cheek ( as well as a serious debt to the road warrior ) , but it feels like unrealized potential","it's a testament to de niro and director michael caton-jones that by movie's end , we accept the characters and the film , flaws and all . ","performances are potent , and the women's stories are ably intercut and involving . ","an enormously entertaining movie , like nothing we've ever seen before , and yet completely familiar . ","lan yu is a genuine love story , full of traditional layers of awakening and ripening and separation and recovery . ","your children will be occupied for 72 minutes . ","pull[s] off the rare trick of recreating not only the look of a certain era , but also the feel . ","twohy's a good yarn-spinner , and ultimately the story compels . ","'tobey maguire is a poster boy for the geek generation . '"," . . . a sweetly affecting story about four sisters who are coping , in one way or another , with life's endgame . ","passion , melodrama , sorrow , laugther , and tears cascade over the screen effortlessly . . . ","road to perdition does display greatness , and it's worth seeing . but it also comes with the laziness and arrogance of a thing that already knows it's won . ","a marvelous performance by allison lohman as an identity-seeking foster child . ","arliss howard's ambitious , moving , and adventurous directorial debut , big bad love , meets so many of the challenges it poses for itself that one can forgive the film its flaws . ","critics need a good laugh , too , and this too-extreme-for-tv rendition of the notorious mtv show delivers the outrageous , sickening , sidesplitting goods in steaming , visceral heaps . ","what a dumb , fun , curiously adolescent movie this is . ","many insightful moments . ","the charms of the lead performances allow us to forget most of the film's problems . ","a vivid , sometimes surreal , glimpse into the mysteries of human behavior . ","a tour de force of modern cinema . ","peralta captures , in luminous interviews and amazingly evocative film from three decades ago , the essence of the dogtown experience . ","the lively appeal of the last kiss lies in the ease with which it integrates thoughtfulness and pasta-fagioli comedy . ","without resorting to camp or parody , haynes ( like sirk , but differently ) has transformed the rhetoric of hollywood melodrama into something provocative , rich , and strange . ","the performances are an absolute joy . ","a quasi-documentary by french filmmaker karim dridi that celebrates the hardy spirit of cuban music . ","grant carries the day with impeccable comic timing , raffish charm and piercing intellect . ","a sensitive and astute first feature by anne-sophie birot . ","both exuberantly romantic and serenely melancholy , what time is it there ? may prove to be [tsai's] masterpiece . ","mazel tov to a film about a family's joyous life acting on the yiddish stage . ","standing in the shadows of motown is the best kind of documentary , one that makes a depleted yesterday feel very much like a brand-new tomorrow . ","it's nice to see piscopo again after all these years , and chaykin and headly are priceless . ","provides a porthole into that noble , trembling incoherence that defines us all . ","I wouldn't be surprised if some observers say Pitt made huge miscalculations in his acting choices with the result being the worst performance of his career - but I found it to be a brazenly effective piece of work, well-suited to the material. "];

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _negatives = __webpack_require__(112);
	
	var _positives = __webpack_require__(113);
	
	var _stemmer = __webpack_require__(115);
	
	var _bayes = __webpack_require__(111);
	
	var _d = __webpack_require__(23);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _bad = __webpack_require__(240);
	
	var _bad2 = _interopRequireDefault(_bad);
	
	var _good = __webpack_require__(241);
	
	var _good2 = _interopRequireDefault(_good);
	
	__webpack_require__(123);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	This code was heavily influenced by Burak Kanber's article https://www.burakkanber.com/blog/machine-learning-in-other-languages-introduction/
	
	The following is not free software. You may use it for educational purposes, but you may not redistribute or use it commercially.
	(C) All Rights Reserved, Burak Kanber 2013
	*/
	
	function setupClassifier() {
	    var Bayes = (0, _bayes.getBayes)();
	
	    // A list of negation terms that we'll use to flag nearby tokens
	    var negations = new RegExp("^(never|no|nothing|nowhere|noone|none|not|havent|hasnt|hadnt|cant|couldnt|shouldnt|wont|wouldnt|dont|doesnt|didnt|isnt|arent|aint)$");
	
	    // // Use 85% of our data set for training, the remaining 15% will be used for testing.
	
	    // Don't spit out console.log stuff during training and guessing.
	    Bayes.debug = false;
	
	    // Close-proximity negation-marked unigram ("eMSU")
	    Bayes.tokenizer = function (text) {
	        // Standard unigram tokenizer; lowercase, strip special characters, split by whitespace
	        text = Bayes.unigramTokenizer(text);
	        // Step through our array of tokens
	        for (var i = 0, len = text.length; i < len; i++) {
	            // If we find a negation word, add an exclamation point to the word preceding and following it.
	            if (text[i].match(negations)) {
	                if (typeof text[i + 1] !== "undefined") text[i + 1] = "!" + text[i + 1];
	                if (typeof text[i - 1] !== "undefined") text[i - 1] = "!" + text[i - 1];
	            }
	        }
	        // Porter Stemmer; this reduces entropy a bit
	        text = text.map(function (t) {
	            return (0, _stemmer.stemmer)(t);
	        });
	
	        return text;
	    };
	
	    // Set the storage engine to in-memory; this example has too much data for localStorage.
	    Bayes.storage = (0, _bayes.getStorage)();
	    return Bayes;
	}
	
	// Runs a single training and testing experiment.
	function trainAndTest(Bayes, onProgressFn) {
	    // Define a couple of global variables so we can easily inspect data points we guessed incorrectly on.
	    var incorrectNegs = [];
	    var incorrectPos = [];
	
	    // Use 85% of our data set for training, the remaining 15% will be used for testing.
	    var length = _negatives.negatives.length;
	    var split = Math.floor(0.85 * length);
	
	    // Start from scratch.
	    var correct = 0;
	    var incorrect = 0;
	    var trainingPct = 0;
	    var resultsPct = 0.0;
	
	    Bayes.storage._data = {};
	
	    // Shuffle our arrays. I'm sure some really astute CS genius will find a flaw with this ;)
	    _negatives.negatives.sort(function () {
	        return Math.random() - 0.5;
	    });
	    _positives.positives.sort(function () {
	        return Math.random() - 0.5;
	    });
	
	    // First we train. Walk through the data until we hit our split/pivot point.
	    // Unfortunately our progress bar doesn't work because of the browser's JS event loop,
	    // And retooling to use animation frames is more annoying than it's worth.
	
	    for (var i = 0; i < split; i++) {
	        Bayes.train(_negatives.negatives[i], "negative");
	        Bayes.train(_positives.positives[i], "positive");
	        if (i % 500 === 0) {
	            // Next three lines are largely useless.
	            trainingPct = Math.round(i * 100 / split);
	            // If you want live updates, look at the console.
	            console.log("Training progress: " + trainingPct + "%");
	            onProgressFn(trainingPct);
	        }
	    }
	
	    // Clean up the progress bar for the final state.
	    trainingPct = 100;
	    onProgressFn(trainingPct);
	
	    // Now we guess. Look at the remainder of the data set and test each of those.
	    for (var _i = split; _i < length; _i++) {
	        var netGuess = Bayes.guess(_negatives.negatives[_i]);
	        var negResult = Bayes.extractWinner(netGuess.scores);
	
	        var posGuess = Bayes.guess(_positives.positives[_i]);
	        var posResult = Bayes.extractWinner(posGuess.scores);
	
	        // Probability less than 75%? Skip it. No sense in making guesses that we know are uncertain.
	        if (negResult.score < 0.75) {} else if (negResult.label === "negative") correct++;else {
	            incorrect++;
	            incorrectNegs.push(_negatives.negatives[_i]);
	        }
	
	        // Repeat for the corresponding positive data point.
	        if (posResult.score < 0.75) {} else if (posResult.label === "positive") correct++;else {
	            incorrect++;
	            incorrectPos.push(_positives.positives[_i]);
	        }
	    }
	
	    // Show the accuracy for this training/testing run.
	    resultsPct = Math.round(10000 * correct / (correct + incorrect)) / 100;
	    return resultsPct;
	}
	
	var Sentiment = function (_Component) {
	    _inherits(Sentiment, _Component);
	
	    function Sentiment() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Sentiment);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sentiment.__proto__ || Object.getPrototypeOf(Sentiment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            testText: "",
	            resultLabel: "",
	            resultScore: "",
	            Bayes: setupClassifier(),
	            trainingProgress: 0,
	            wordicities: []
	        }, _this.onTestTextChange = function (e) {
	            _this.setState({ testText: e.target.value });
	        }, _this.onClick = function () {
	            var _this$state = _this.state,
	                testText = _this$state.testText,
	                Bayes = _this$state.Bayes;
	
	            var _Bayes$guess = Bayes.guess(testText),
	                scores = _Bayes$guess.scores,
	                wordicities = _Bayes$guess.wordicities;
	
	            var result = Bayes.extractWinner(scores);
	
	            var resultLabel = result.label;
	            var resultScore = Math.round(100 * result.score);
	
	            _this.setState({ resultLabel: resultLabel, resultScore: resultScore, wordicities: wordicities });
	        }, _this.onTrain = function () {
	            var Bayes = _this.state.Bayes;
	
	
	            var accuracy = trainAndTest(Bayes, function (pct) {
	                _this.setState({ trainingProgress: pct });
	                _this.forceUpdate();
	            });
	
	            _this.setState({ resultScore: accuracy });
	        }, _this.onPasteReview = function () {
	            _this.setState({ testText: "Jenkins tries not only to include men on Wonder Woman's side but also to make male viewers feel better about a woman saving them" });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Sentiment, [{
	        key: "render",
	        value: function render() {
	            var _state = this.state,
	                testText = _state.testText,
	                resultLabel = _state.resultLabel,
	                resultScore = _state.resultScore,
	                trainingProgress = _state.trainingProgress,
	                wordicities = _state.wordicities;
	
	
	            var colorScale = d3.scaleLinear().domain([-1, -0.5, 0, 1]).range(["#f00", "#f00", "#ff0", "#0f0"]);
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: "sentiment dark-panel",
	                    style: { paddingBottom: 200 }
	                },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Sentiment Analysis (classifier, Naive Bayes)"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "centered-panel" },
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Uses Bayes Theorem combined with \"negation\" and \"stemming\" to determine the sentiment of movie reviews. Negation allows us to treat negations (\"not good\") as monograms instead of bigrams."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Preprocessing:",
	                        _react2.default.createElement(
	                            "ul",
	                            null,
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                "Remove all punctuation"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                "Lower case"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                "Stem all words  (\"exciting\" ---> \"excit\")"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                "Apply negation (\"not good\" ---> \"!good\")"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        _react2.default.createElement(
	                            "span",
	                            { id: "trainingProgressValue" },
	                            "Training progress: ",
	                            trainingProgress
	                        ),
	                        "% (over 10,000 sample reviews)"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "progress-wrapper" },
	                        _react2.default.createElement("div", { className: "progress", id: "trainingProgressBar" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "progress-wrapper" },
	                        _react2.default.createElement("div", { className: "progress", id: "testResultsBar" })
	                    ),
	                    _react2.default.createElement("textarea", {
	                        id: "testBox",
	                        value: testText,
	                        onChange: this.onTestTextChange,
	                        placeholder: "Train first, then put your text here. Try reviews from Rotten Tomatoes.",
	                        style: {
	                            color: "#000",
	                            width: 655,
	                            height: 256,
	                            marginLeft: 0
	                        }
	                    }),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: "ui blue button",
	                            id: "testButton",
	                            onClick: this.onTrain
	                        },
	                        "1. Train"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: "ui grey button",
	                            id: "testButton",
	                            onClick: this.onPasteReview
	                        },
	                        "2. Paste a movie review"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: "ui orange button",
	                            id: "testButton",
	                            onClick: this.onClick
	                        },
	                        "3. Guess Sentiment"
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    resultLabel === 'negative' && _react2.default.createElement("img", { src: _bad2.default, alt: "" }),
	                    resultLabel === 'positive' && _react2.default.createElement("img", { src: _good2.default, alt: "" }),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "result" },
	                        resultLabel
	                    ),
	                    _react2.default.createElement(
	                        "h2",
	                        null,
	                        resultScore,
	                        "% accuracy"
	                    ),
	                    wordicities && wordicities.length > 0 && _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "h2",
	                            null,
	                            "Result Details"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Words are colored green to red. Green is the word's probablity of being in a positive review, red in a negative review. The winning score determines whether the review is positive or negative. Partial words and \"!\" prefixes show the stemming and negation pre-processing."
	                        ),
	                        wordicities.map(function (d) {
	                            var colorMag = 0 - d.neg + d.pos;
	                            var color = colorScale(colorMag);
	
	                            return _react2.default.createElement(
	                                "span",
	                                { style: { color: color, fontSize: 24 } },
	                                d.word,
	                                " "
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Sentiment;
	}(_react.Component);
	
	exports.default = Sentiment;

/***/ },
/* 115 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* Source: https://github.com/kristopolous/Porter-Stemmer */
	var stemmer = exports.stemmer = function () {
	  function h() {}function i() {
	    console.log(Array.prototype.slice.call(arguments).join(" "));
	  }var j = { ational: "ate", tional: "tion", enci: "ence", anci: "ance", izer: "ize", bli: "ble", alli: "al", entli: "ent", eli: "e", ousli: "ous", ization: "ize", ation: "ate", ator: "ate", alism: "al", iveness: "ive", fulness: "ful", ousness: "ous", aliti: "al", iviti: "ive", biliti: "ble", logi: "log" },
	      k = { icate: "ic", ative: "", alize: "al", iciti: "ic", ical: "ic", ful: "", ness: "" };return function (a, l) {
	    var d, b, g, c, f, e;e = l ? i : h;if (3 > a.length) return a;
	    g = a.substr(0, 1);"y" == g && (a = g.toUpperCase() + a.substr(1));c = /^(.+?)(ss|i)es$/;b = /^(.+?)([^s])s$/;c.test(a) ? (a = a.replace(c, "$1$2"), e("1a", c, a)) : b.test(a) && (a = a.replace(b, "$1$2"), e("1a", b, a));c = /^(.+?)eed$/;b = /^(.+?)(ed|ing)$/;c.test(a) ? (b = c.exec(a), c = /^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*/, c.test(b[1]) && (c = /.$/, a = a.replace(c, ""), e("1b", c, a))) : b.test(a) && (b = b.exec(a), d = b[1], b = /^([^aeiou][^aeiouy]*)?[aeiouy]/, b.test(d) && (a = d, e("1b", b, a), b = /(at|bl|iz)$/, f = /([^aeiouylsz])\1$/, d = /^[^aeiou][^aeiouy]*[aeiouy][^aeiouwxy]$/, b.test(a) ? (a += "e", e("1b", b, a)) : f.test(a) ? (c = /.$/, a = a.replace(c, ""), e("1b", f, a)) : d.test(a) && (a += "e", e("1b", d, a))));c = /^(.*[aeiouy].*)y$/;c.test(a) && (b = c.exec(a), d = b[1], a = d + "i", e("1c", c, a));c = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;c.test(a) && (b = c.exec(a), d = b[1], b = b[2], c = /^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*/, c.test(d) && (a = d + j[b], e("2", c, a)));c = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;
	    c.test(a) && (b = c.exec(a), d = b[1], b = b[2], c = /^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*/, c.test(d) && (a = d + k[b], e("3", c, a)));c = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;b = /^(.+?)(s|t)(ion)$/;c.test(a) ? (b = c.exec(a), d = b[1], c = /^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*[aeiouy][aeiou]*[^aeiou][^aeiouy]*/, c.test(d) && (a = d, e("4", c, a))) : b.test(a) && (b = b.exec(a), d = b[1] + b[2], b = /^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*[aeiouy][aeiou]*[^aeiou][^aeiouy]*/, b.test(d) && (a = d, e("4", b, a)));c = /^(.+?)e$/;if (c.test(a) && (b = c.exec(a), d = b[1], c = /^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*[aeiouy][aeiou]*[^aeiou][^aeiouy]*/, b = /^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*([aeiouy][aeiou]*)?$/, f = /^[^aeiou][^aeiouy]*[aeiouy][^aeiouwxy]$/, c.test(d) || b.test(d) && !f.test(d))) a = d, e("5", c, b, f, a);c = /ll$/;b = /^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*[aeiouy][aeiou]*[^aeiou][^aeiouy]*/;c.test(a) && b.test(a) && (c = /.$/, a = a.replace(c, ""), e("5", c, b, a));"y" == g && (a = g.toLowerCase() + a.substr(1));return a;
	  };
	}();

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(29);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 117 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 118 */
117,
/* 119 */
117,
/* 120 */
117,
/* 121 */
117,
/* 122 */
117,
/* 123 */
117,
/* 124 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(124);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(134);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var createArrayFromMixed = __webpack_require__(127);
	var getMarkupWrap = __webpack_require__(129);
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 130 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(131);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 133 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(133);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 135 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(30);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(17);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(62);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(63);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(64);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 137 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 138 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(138)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(66);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(66);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(10);
	var invariant = __webpack_require__(1);
	var ReactPropTypesSecret = __webpack_require__(68);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(10);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var ReactPropTypesSecret = __webpack_require__(68);
	var checkPropTypes = __webpack_require__(142);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(159);


/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(5);
	
	var focusNode = __webpack_require__(59);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(25);
	var ExecutionEnvironment = __webpack_require__(8);
	var FallbackCompositionState = __webpack_require__(154);
	var SyntheticCompositionEvent = __webpack_require__(191);
	var SyntheticInputEvent = __webpack_require__(194);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(69);
	var ExecutionEnvironment = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(11);
	
	var camelizeStyleName = __webpack_require__(125);
	var dangerousStyleValue = __webpack_require__(200);
	var hyphenateStyleName = __webpack_require__(132);
	var memoizeStringOnly = __webpack_require__(135);
	var warning = __webpack_require__(2);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(24);
	var EventPropagators = __webpack_require__(25);
	var ExecutionEnvironment = __webpack_require__(8);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(12);
	var SyntheticEvent = __webpack_require__(13);
	
	var inputValueTracking = __webpack_require__(85);
	var getEventTarget = __webpack_require__(52);
	var isEventSupported = __webpack_require__(53);
	var isTextInputElement = __webpack_require__(87);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(18);
	var ExecutionEnvironment = __webpack_require__(8);
	
	var createNodesFromMarkup = __webpack_require__(128);
	var emptyFunction = __webpack_require__(10);
	var invariant = __webpack_require__(1);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(25);
	var ReactDOMComponentTree = __webpack_require__(5);
	var SyntheticMouseEvent = __webpack_require__(33);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(15);
	
	var getTextContentAccessor = __webpack_require__(84);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(19);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(20);
	
	var instantiateReactComponent = __webpack_require__(86);
	var KeyEscapeUtils = __webpack_require__(44);
	var shouldUpdateReactComponent = __webpack_require__(54);
	var traverseAllChildren = __webpack_require__(89);
	var warning = __webpack_require__(2);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/mlearning"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(94);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(40);
	var ReactDOMIDOperations = __webpack_require__(164);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var React = __webpack_require__(21);
	var ReactComponentEnvironment = __webpack_require__(46);
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactErrorUtils = __webpack_require__(47);
	var ReactInstanceMap = __webpack_require__(26);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactNodeTypes = __webpack_require__(79);
	var ReactReconciler = __webpack_require__(20);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(29);
	var invariant = __webpack_require__(1);
	var shallowEqual = __webpack_require__(38);
	var shouldUpdateReactComponent = __webpack_require__(54);
	var warning = __webpack_require__(2);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDefaultInjection = __webpack_require__(172);
	var ReactMount = __webpack_require__(78);
	var ReactReconciler = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(12);
	var ReactVersion = __webpack_require__(185);
	
	var findDOMNode = __webpack_require__(201);
	var getHostComponentFromComposite = __webpack_require__(83);
	var renderSubtreeIntoContainer = __webpack_require__(208);
	var warning = __webpack_require__(2);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var AutoFocusUtils = __webpack_require__(147);
	var CSSPropertyOperations = __webpack_require__(149);
	var DOMLazyTree = __webpack_require__(18);
	var DOMNamespaces = __webpack_require__(41);
	var DOMProperty = __webpack_require__(19);
	var DOMPropertyOperations = __webpack_require__(71);
	var EventPluginHub = __webpack_require__(24);
	var EventPluginRegistry = __webpack_require__(42);
	var ReactBrowserEventEmitter = __webpack_require__(32);
	var ReactDOMComponentFlags = __webpack_require__(72);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMInput = __webpack_require__(165);
	var ReactDOMOption = __webpack_require__(166);
	var ReactDOMSelect = __webpack_require__(73);
	var ReactDOMTextarea = __webpack_require__(169);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactMultiChild = __webpack_require__(178);
	var ReactServerRenderingTransaction = __webpack_require__(183);
	
	var emptyFunction = __webpack_require__(10);
	var escapeTextContentForBrowser = __webpack_require__(35);
	var invariant = __webpack_require__(1);
	var isEventSupported = __webpack_require__(53);
	var shallowEqual = __webpack_require__(38);
	var inputValueTracking = __webpack_require__(85);
	var validateDOMNesting = __webpack_require__(55);
	var warning = __webpack_require__(2);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(55);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(18);
	var ReactDOMComponentTree = __webpack_require__(5);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(5);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var DOMPropertyOperations = __webpack_require__(71);
	var LinkedValueUtils = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(12);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var React = __webpack_require__(21);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMSelect = __webpack_require__(73);
	
	var warning = __webpack_require__(2);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var getNodeForCharacterOffset = __webpack_require__(205);
	var getTextContentAccessor = __webpack_require__(84);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var DOMChildrenOperations = __webpack_require__(40);
	var DOMLazyTree = __webpack_require__(18);
	var ReactDOMComponentTree = __webpack_require__(5);
	
	var escapeTextContentForBrowser = __webpack_require__(35);
	var invariant = __webpack_require__(1);
	var validateDOMNesting = __webpack_require__(55);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(12);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactUpdates = __webpack_require__(12);
	var Transaction = __webpack_require__(34);
	
	var emptyFunction = __webpack_require__(10);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(146);
	var BeforeInputEventPlugin = __webpack_require__(148);
	var ChangeEventPlugin = __webpack_require__(150);
	var DefaultEventPluginOrder = __webpack_require__(152);
	var EnterLeaveEventPlugin = __webpack_require__(153);
	var HTMLDOMPropertyConfig = __webpack_require__(155);
	var ReactComponentBrowserEnvironment = __webpack_require__(157);
	var ReactDOMComponent = __webpack_require__(160);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMEmptyComponent = __webpack_require__(162);
	var ReactDOMTreeTraversal = __webpack_require__(170);
	var ReactDOMTextComponent = __webpack_require__(168);
	var ReactDefaultBatchingStrategy = __webpack_require__(171);
	var ReactEventListener = __webpack_require__(175);
	var ReactInjection = __webpack_require__(176);
	var ReactReconcileTransaction = __webpack_require__(181);
	var SVGDOMPropertyConfig = __webpack_require__(186);
	var SelectEventPlugin = __webpack_require__(187);
	var SimpleEventPlugin = __webpack_require__(188);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 173 */
95,
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(24);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventListener = __webpack_require__(58);
	var ExecutionEnvironment = __webpack_require__(8);
	var PooledClass = __webpack_require__(15);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(12);
	
	var getEventTarget = __webpack_require__(52);
	var getUnboundedScrollPosition = __webpack_require__(130);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(19);
	var EventPluginHub = __webpack_require__(24);
	var EventPluginUtils = __webpack_require__(43);
	var ReactComponentEnvironment = __webpack_require__(46);
	var ReactEmptyComponent = __webpack_require__(74);
	var ReactBrowserEventEmitter = __webpack_require__(32);
	var ReactHostComponent = __webpack_require__(76);
	var ReactUpdates = __webpack_require__(12);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(199);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactComponentEnvironment = __webpack_require__(46);
	var ReactInstanceMap = __webpack_require__(26);
	var ReactInstrumentation = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactReconciler = __webpack_require__(20);
	var ReactChildReconciler = __webpack_require__(156);
	
	var emptyFunction = __webpack_require__(10);
	var flattenChildren = __webpack_require__(202);
	var invariant = __webpack_require__(1);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 180 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(70);
	var PooledClass = __webpack_require__(15);
	var ReactBrowserEventEmitter = __webpack_require__(32);
	var ReactInputSelection = __webpack_require__(77);
	var ReactInstrumentation = __webpack_require__(11);
	var Transaction = __webpack_require__(34);
	var ReactUpdateQueue = __webpack_require__(48);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(179);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(15);
	var Transaction = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactServerUpdateQueue = __webpack_require__(184);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(48);
	
	var warning = __webpack_require__(2);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 185 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.1';

/***/ },
/* 186 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(25);
	var ExecutionEnvironment = __webpack_require__(8);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInputSelection = __webpack_require__(77);
	var SyntheticEvent = __webpack_require__(13);
	
	var getActiveElement = __webpack_require__(60);
	var isTextInputElement = __webpack_require__(87);
	var shallowEqual = __webpack_require__(38);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventListener = __webpack_require__(58);
	var EventPropagators = __webpack_require__(25);
	var ReactDOMComponentTree = __webpack_require__(5);
	var SyntheticAnimationEvent = __webpack_require__(189);
	var SyntheticClipboardEvent = __webpack_require__(190);
	var SyntheticEvent = __webpack_require__(13);
	var SyntheticFocusEvent = __webpack_require__(193);
	var SyntheticKeyboardEvent = __webpack_require__(195);
	var SyntheticMouseEvent = __webpack_require__(33);
	var SyntheticDragEvent = __webpack_require__(192);
	var SyntheticTouchEvent = __webpack_require__(196);
	var SyntheticTransitionEvent = __webpack_require__(197);
	var SyntheticUIEvent = __webpack_require__(27);
	var SyntheticWheelEvent = __webpack_require__(198);
	
	var emptyFunction = __webpack_require__(10);
	var getEventCharCode = __webpack_require__(50);
	var invariant = __webpack_require__(1);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(13);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(13);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(13);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(33);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(27);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(13);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(27);
	
	var getEventCharCode = __webpack_require__(50);
	var getEventKey = __webpack_require__(203);
	var getEventModifierState = __webpack_require__(51);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(27);
	
	var getEventModifierState = __webpack_require__(51);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(13);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(33);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(69);
	var warning = __webpack_require__(2);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInstanceMap = __webpack_require__(26);
	
	var getHostComponentFromComposite = __webpack_require__(83);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(44);
	var traverseAllChildren = __webpack_require__(89);
	var warning = __webpack_require__(2);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/mlearning"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(94);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(50);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 204 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 205 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(35);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(78);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(62);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _reactRouter = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(63);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _reactRouter = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(9);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.MemoryRouter;
	  }
	});

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(9);
	
	var _Link = __webpack_require__(90);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);
	
	  return _react2.default.createElement(_reactRouter.Route, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [activeClassName, className].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active'
	};
	
	exports.default = NavLink;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(9);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Prompt;
	  }
	});

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(9);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Redirect;
	  }
	});

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(9);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Route;
	  }
	});

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(9);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Router;
	  }
	});

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(9);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.StaticRouter;
	  }
	});

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(9);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Switch;
	  }
	});

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(9);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.matchPath;
	  }
	});

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(9);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.withRouter;
	  }
	});

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(64);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(56);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(17);
	
	var _Router = __webpack_require__(56);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _matchPath = __webpack_require__(57);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(137);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(92);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 227 */
44,
/* 228 */
[244, 28],
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(228);
	var ReactElement = __webpack_require__(22);
	
	var emptyFunction = __webpack_require__(10);
	var traverseAllChildren = __webpack_require__(238);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(22);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(22),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(67);
	
	module.exports = factory(isValidElement);

/***/ },
/* 232 */
185,
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(93),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(22),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(96);
	var factory = __webpack_require__(116);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 234 */
204,
/* 235 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(28);
	
	var ReactElement = __webpack_require__(22);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(28);
	
	var ReactCurrentOwner = __webpack_require__(14);
	var REACT_ELEMENT_TYPE = __webpack_require__(95);
	
	var getIteratorFn = __webpack_require__(234);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(227);
	var warning = __webpack_require__(2);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 239 */
/***/ function(module, exports) {

	'use strict';
	
	var isAbsolute = function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	};
	
	// About 1.5x faster than the two-arg version of Array#splice()
	var spliceOne = function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }list.pop();
	};
	
	// This implementation is based heavily on node's url.parse
	var resolvePathname = function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	};
	
	module.exports = resolvePathname;

/***/ },
/* 240 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 241 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 242 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var valueEqual = function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	    return valueEqual(item, b[index]);
	  });
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	};
	
	exports.default = valueEqual;

/***/ },
/* 243 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.9d5bd403.js